// components/Modal.tsx
import React, { useState, useMemo, useRef,useEffect } from 'react';
import {  PaperAirplaneIcon } from '@heroicons/react/outline';

const data = [
  {
    "grupo": "A00 - COLERA",
    "detalle": [
      {
        "codigo": "A000",
        "valor": "COLERA DEBIDO A VIBRIO CHOLERAE 01, BIOTIPO CHOLERAE"
      },
      {
        "codigo": "A001",
        "valor": "COLERA DEBIDO A VIBRIO CHOLERAE 01, BIOTIPO EL TOR"
      },
      {
        "codigo": "A009",
        "valor": "COLERA, NO ESPECIFICADO"
      },
      {
        "codigo": "A0090",
        "valor": "SOSPECHOSO DE COLERA"
      },
      {
        "codigo": "A0091",
        "valor": "SOSPECHOSO DE COLERA NO ESPECIFICADO SIN DESHIDRATACION"
      },
      {
        "codigo": "A0092",
        "valor": "SOSPECHOSOS DE COLERA NO ESPECIFICADO CON DESHIDRATACION"
      },
      {
        "codigo": "A0093",
        "valor": "SOSPECHOSOS DE COLERA NO ESPECIFICADO CON DESHIDRATACION CON SHOCK"
      }
    ]
  },
  {
    "grupo": "A01 - FIEBRES TIFOIDEA Y PARATIFOIDEA",
    "detalle": [
      {
        "codigo": "A010",
        "valor": "FIEBRE TIFOIDEA"
      },
      {
        "codigo": "A0109",
        "valor": "FIEBRE TIFOIDEA CON DIARREA"
      },
      {
        "codigo": "A011",
        "valor": "FIEBRE PARATIFOIDEA A"
      },
      {
        "codigo": "A012",
        "valor": "FIEBRE PARATIFOIDEA B"
      },
      {
        "codigo": "A013",
        "valor": "FIEBRE PARATIFOIDEA C"
      },
      {
        "codigo": "A014",
        "valor": "FIEBRE PARATIFOIDEA, NO ESPECIFICADA"
      },
      {
        "codigo": "A0141",
        "valor": "FIEBRE PARATIFOIDEA NO ESPECIFICADA CON DIARREA"
      }
    ]
  },
  {
    "grupo": "A02 - OTRAS INFECCIONES DEBIDAS A SALMONELLA",
    "detalle": [
      {
        "codigo": "A020",
        "valor": "ENTERITIS DEBIDA A SALMONELLA"
      },
      {
        "codigo": "A021",
        "valor": "SEPSIS DEBIDA A SALMONELLA"
      },
      {
        "codigo": "A022",
        "valor": "INFECCIONES LOCALIZADAS DEBIDAS A SALMONELLA"
      },
      {
        "codigo": "A028",
        "valor": "OTRAS INFECCIONES ESPECIFICADAS COMO DEBIDAS A SALMONELLA"
      },
      {
        "codigo": "A029",
        "valor": "INFECCION DEBIDA A SALMONELLA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A03 - SHIGELOSIS",
    "detalle": [
      {
        "codigo": "A030",
        "valor": "SHIGELOSIS DEBIDA A SHIGELLA DYSENTERIAE"
      },
      {
        "codigo": "A031",
        "valor": "SHIGELOSIS DEBIDA A SHIGELLA FLEXNERI"
      },
      {
        "codigo": "A032",
        "valor": "SHIGELOSIS DEBIDA A SHIGELLA BOYDII"
      },
      {
        "codigo": "A033",
        "valor": "SHIGELOSIS DEBIDA A SHIGELLA SONNEI"
      },
      {
        "codigo": "A038",
        "valor": "OTRAS SHIGELOSIS"
      },
      {
        "codigo": "A039",
        "valor": "SHIGELOSIS DE TIPO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "A04 - OTRAS INFECCIONES INTESTINALES BACTERIANAS",
    "detalle": [
      {
        "codigo": "A040",
        "valor": "INFECCION DEBIDA A ESCHERICHIA COLI ENTEROPATOGENA"
      },
      {
        "codigo": "A041",
        "valor": "INFECCION DEBIDA A ESCHERICHIA COLI ENTEROTOXIGENA"
      },
      {
        "codigo": "A042",
        "valor": "INFECCION DEBIDA A ESCHERICHIA COLI ENTEROINVASIVA"
      },
      {
        "codigo": "A043",
        "valor": "INFECCION DEBIDA A ESCHERICHIA COLI ENTEROHEMORRAGICA"
      },
      {
        "codigo": "A044",
        "valor": "OTRAS INFECCIONES INTESTINALES DEBIDAS A ESCHERICHIA COLI"
      },
      {
        "codigo": "A045",
        "valor": "ENTERITIS DEBIDA A CAMPYLOBACTER"
      },
      {
        "codigo": "A046",
        "valor": "ENTERITIS DEBIDA A YERSINIA ENTEROCOLITICA"
      },
      {
        "codigo": "A047",
        "valor": "ENTEROCOLITIS DEBIDA A CLOSTRIDIUM DIFFICILE"
      },
      {
        "codigo": "A048",
        "valor": "OTRAS INFECCIONES INTESTINALES BACTERIANAS ESPECIFICADAS"
      },
      {
        "codigo": "A049",
        "valor": "INFECCION INTESTINAL BACTERIANA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A05 - OTRAS INTOXICACIONES ALIMENTARIAS BACTERIANAS",
    "detalle": [
      {
        "codigo": "A050",
        "valor": "INTOXICACION ALIMENTARIA ESTAFILOCOCICA"
      },
      {
        "codigo": "A051",
        "valor": "BOTULISMO"
      },
      {
        "codigo": "A052",
        "valor": "INTOXICACION ALIMENTARIA DEBIDA A CLOSTRIDIUM PERFRINGENS [CLOSTRIDIUM WELCHII]"
      },
      {
        "codigo": "A053",
        "valor": "INTOXICACION ALIMENTARIA DEBIDA A VIBRIO PARAHAEMOLYTICUS"
      },
      {
        "codigo": "A054",
        "valor": "INTOXICACION ALIMENTARIA DEBIDA A BACILLUS CEREUS"
      },
      {
        "codigo": "A058",
        "valor": "OTRAS INTOXICACIONES ALIMENTARIAS DEBIDAS A BACTERIAS ESPECIFICADAS"
      },
      {
        "codigo": "A059",
        "valor": "INTOXICACION ALIMENTARIA BACTERIANA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A06 - AMEBIASIS",
    "detalle": [
      {
        "codigo": "A060",
        "valor": "DISENTERIA AMEBIANA AGUDA"
      },
      {
        "codigo": "A061",
        "valor": "AMEBIASIS INTESTINAL CRONICA"
      },
      {
        "codigo": "A062",
        "valor": "COLITIS AMEBIANA NO DISENTERICA"
      },
      {
        "codigo": "A063",
        "valor": "AMEBOMA INTESTINAL"
      },
      {
        "codigo": "A064",
        "valor": "ABSCESO AMEBIANO DEL HIGADO"
      },
      {
        "codigo": "A065",
        "valor": "ABSCESO AMEBIANO DEL PULMON"
      },
      {
        "codigo": "A066",
        "valor": "ABSCESO AMEBIANO DEL CEREBRO"
      },
      {
        "codigo": "A067",
        "valor": "AMEBIASIS CUTANEA"
      },
      {
        "codigo": "A068",
        "valor": "INFECCION AMEBIANA DE OTRAS LOCALIZACIONES"
      },
      {
        "codigo": "A069",
        "valor": "AMEBIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A07 - OTRAS ENFERMEDADES INTESTINALES DEBIDAS A PROTOZOARIOS",
    "detalle": [
      {
        "codigo": "A070",
        "valor": "BALANTIDIASIS"
      },
      {
        "codigo": "A071",
        "valor": "GIARDIASIS [LAMBLIASIS]"
      },
      {
        "codigo": "A072",
        "valor": "CRIPTOSPORIDIOSIS"
      },
      {
        "codigo": "A073",
        "valor": "ISOSPORIASIS"
      },
      {
        "codigo": "A078",
        "valor": "OTRAS ENFERMEDADES INTESTINALES ESPECIFICADAS DEBIDAS A PROTOZOARIOS"
      },
      {
        "codigo": "A079",
        "valor": "ENFERMEDAD INTESTINAL DEBIDA A PROTOZOARIOS, NO ESPECIFICADA"
      },
      {
        "codigo": "A0793",
        "valor": "COLITIS"
      }
    ]
  },
  {
    "grupo": "A08 - INFECCIONES INTESTINALES DEBIDAS A VIRUS Y OTROS ORGANISMOS ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "A080",
        "valor": "ENTERITIS DEBIDA A ROTAVIRUS"
      },
      {
        "codigo": "A081",
        "valor": "GASTROENTEROPATIA AGUDA DEBIDA AL AGENTE DE NORWALK"
      },
      {
        "codigo": "A082",
        "valor": "ENTERITIS DEBIDA A ADENOVIRUS"
      },
      {
        "codigo": "A083",
        "valor": "OTRAS ENTERITIS VIRALES"
      },
      {
        "codigo": "A084",
        "valor": "INFECCION INTESTINAL VIRAL, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "A085",
        "valor": "OTRAS INFECCIONES INTESTINALES ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "A09 - OTRAS GASTROENTERITIS Y COLITIS DE ORIGEN INFECCIOSO Y NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "A090",
        "valor": "OTRAS GASTROENTERITIS Y COLITIS DE ORIGEN INFECCIOSO"
      },
      {
        "codigo": "A099",
        "valor": "GASTROENTERITIS Y COLITIS DE ORIGEN NO ESPECIFICADO"
      },
      {
        "codigo": "A09X",
        "valor": "INFECCIONES INTESTINALES DEBIDAS A OTROS ORGANISMOS SIN ESPECIFICAR"
      }
    ]
  },
  {
    "grupo": "A15 - TUBERCULOSIS RESPIRATORIA, CONFIRMADA BACTERIOLOGICA E HISTOLOGICAMENTE",
    "detalle": [
      {
        "codigo": "A150",
        "valor": "TUBERCULOSIS DEL PULMON, CONFIRMADA POR HALLAZGO MICROSCOPICO DEL BACILO TUBERCULOSO EN ESPUTO, CON O SIN CULTIVO"
      },
      {
        "codigo": "A151",
        "valor": "TUBERCULOSIS DEL PULMON, CONFIRMADA UNICAMENTE POR CULTIVO"
      },
      {
        "codigo": "A152",
        "valor": "TUBERCULOSIS DEL PULMON, CONFIRMADA HISTOLOGICAMENTE"
      },
      {
        "codigo": "A153",
        "valor": "TUBERCULOSIS DEL PULMON, CONFIRMADA POR MEDIOS NO ESPECIFICADOS"
      },
      {
        "codigo": "A154",
        "valor": "TUBERCULOSIS DE GANGLIOS LINFATICOS INTRATORACICOS, CONFIRMADA BACTERIOLOGICA E HISTOLOGICAMENTE"
      },
      {
        "codigo": "A155",
        "valor": "TUBERCULOSIS DE LARINGE, TRAQUEA Y BRONQUIOS, CONFIRMADA BACTERIOLOGICA E HISTOLOGICAMENTE"
      },
      {
        "codigo": "A156",
        "valor": "PLEURESIA TUBERCULOSA, CONFIRMADA BACTERIOLOGICA E HISTOLOGICAMENTE"
      },
      {
        "codigo": "A157",
        "valor": "TUBERCULOSIS RESPIRATORIA PRIMARIA, CONFIRMADA BACTERIOLOGICA E HISTOLOGICAMENTE"
      },
      {
        "codigo": "A158",
        "valor": "OTRAS TUBERCULOSIS RESPIRATORIAS, CONFIRMADAS BACTERIOLOGICA E HISTOLOGICAMENTE"
      },
      {
        "codigo": "A159",
        "valor": "TUBERCULOSIS RESPIRATORIA NO ESPECIFICADA, CONFIRMADA BACTERIOLOGICA E HISTOLOGICAMENTE"
      }
    ]
  },
  {
    "grupo": "A16 - TUBERCULOSIS RESPIRATORIA, NO CONFIRMADA BACTERIOLOGICA O HISTOLOGICAMENTE",
    "detalle": [
      {
        "codigo": "A160",
        "valor": "TUBERCULOSIS DEL PULMON, CON EXAMEN BACTERIOLOGICO E HISTOLOGICO NEGATIVOS"
      },
      {
        "codigo": "A161",
        "valor": "TUBERCULOSIS DE PULMON, SIN EXAMEN BACTERIOLOGICO E HISTOLOGICO"
      },
      {
        "codigo": "A162",
        "valor": "TUBERCULOSIS DE PULMON, SIN MENCION DE CONFIRMACION BACTERIOLOGICA O HISTOLOGICA"
      },
      {
        "codigo": "A163",
        "valor": "TUBERCULOSIS DE GANGLIOS LINFATICOS INTRATORACICOS, SIN MENCION DE CONFIRMACION BACTERIOLOGICA O HISTOLOGICA"
      },
      {
        "codigo": "A164",
        "valor": "TUBERCULOSIS DE LARINGE, TRAQUEA Y BRONQUIOS, SIN MENCION DE CONFIRMACION BACTERIOLOGICA O HISTOLOGICA"
      },
      {
        "codigo": "A165",
        "valor": "PLEURESIA TUBERCULOSA, SIN MENCION DE CONFIRMACION BACTERIOLOGICA O HISTOLOGICA"
      },
      {
        "codigo": "A167",
        "valor": "TUBERCULOSIS RESPIRATORIA PRIMARIA, SIN MENCION DE CONFIRMACION BACTERIOLOGICA O HISTOLOGICA"
      },
      {
        "codigo": "A168",
        "valor": "OTRAS TUBERCULOSIS RESPIRATORIAS, SIN MENCION DE CONFIRMACION"
      },
      {
        "codigo": "A169",
        "valor": "TUBERCULOSIS RESPIRATORIA NO ESPECIFICADA, SIN MENCION DE CONFIRMACION BACTERIOLOGICA O HISTOLOGICA"
      }
    ]
  },
  {
    "grupo": "A17 - TUBERCULOSIS DEL SISTEMA NERVIOSO",
    "detalle": [
      {
        "codigo": "A170",
        "valor": "MENINGITIS TUBERCULOSA"
      },
      {
        "codigo": "A171",
        "valor": "TUBERCULOMA MENINGEO"
      },
      {
        "codigo": "A178",
        "valor": "OTRAS TUBERCULOSIS DEL SISTEMA NERVIOSO"
      },
      {
        "codigo": "A179",
        "valor": "TUBERCULOSIS DEL SISTEMA NERVIOSO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A18 - TUBERCULOSIS DE OTROS ORGANOS",
    "detalle": [
      {
        "codigo": "A180",
        "valor": "TUBERCULOSIS DE HUESOS Y ARTICULACIONES"
      },
      {
        "codigo": "A1801",
        "valor": "TUBERCULOSIS DE HUESOS Y ARTICULACIONES, SIN CONFIRMACION BACTERIOLOGICA E HISTOPATOLOGICA"
      },
      {
        "codigo": "A1802",
        "valor": "TUBERCULOSIS DE HUESOS Y ARTICULACIONES, CONFIRMADO CON HISTOPATOLOGIA"
      },
      {
        "codigo": "A1803",
        "valor": "TUBERCULOSIS DE HUESOS Y ARTICULACIONES, CONFIRMADO CON BACTERIOLOGIA"
      },
      {
        "codigo": "A181",
        "valor": "TUBERCULOSIS DEL APARATO GENITOURINARIO"
      },
      {
        "codigo": "A1811",
        "valor": "TUBERCULOSIS DEL APARATO GENITOURINARIO, SIN CONFIRMACION BACTERIOLOGICA E HISTOPATOLOGICA"
      },
      {
        "codigo": "A1812",
        "valor": "TUBERCULOSIS DEL APARATO GENITOURINAIRO, CONFIRMADO CON HISTOPATOLOGIA"
      },
      {
        "codigo": "A1813",
        "valor": "TUBERCULOSIS DEL APARATO GENITOURINARIO, CONFIRMADO CON BACTERIOLOGIA"
      },
      {
        "codigo": "A182",
        "valor": "LINFADENOPATIA PERIFERICA TUBERCULOSA"
      },
      {
        "codigo": "A1821",
        "valor": "LINFADENOPATIA PERIFERICA TUBERCULOSA, SIN CONFIRMACION BACTERIOLOGICA E HISTOPATOLOGICA"
      },
      {
        "codigo": "A1822",
        "valor": "LINFADENOPATIA PERIFERICA TUBERCULOSA, CONFIRMADO CON HISTOPATOLOGIA"
      },
      {
        "codigo": "A1823",
        "valor": "LINFADENOPATIA PERIFERICA TUBERCULOSA, CONFIRMADO CON BACTERIOLOGIA"
      },
      {
        "codigo": "A183",
        "valor": "TUBERCULOSIS DE LOS INTESTINOS, EL PERITONEO Y LOS GANGLIOS MESENTERICOS"
      },
      {
        "codigo": "A1831",
        "valor": "TUBERCULOSIS DE LOS INTESTINOS, EL PERITONEO Y GANGLIOS MESENTERICOS, SIN COFIRMIMACION BACTERIOLOGICA"
      },
      {
        "codigo": "A1832",
        "valor": "TUBERCULOSIS DE LOS INTESTINOS, EL PERITONEO Y GANGLIOS MESENTERICOS CONFIRMADO CON HISTOPATOLOGIA"
      },
      {
        "codigo": "A1833",
        "valor": "TUBERCULOSIS DE LOS INTESTINOS, EL PERITONEO Y GANGLIOS MESENTERICOS, CONFIRMADO CON BACTERIOLOGIA"
      },
      {
        "codigo": "A184",
        "valor": "TUBERCULOSIS DE LA PIEL Y EL TEJIDO SUBCUTANEO"
      },
      {
        "codigo": "A1841",
        "valor": "TUBERCULOSIS DE LA PIEL Y EL TEJIDO SUBCUTANEO, SIN CONFIRMACION BACTERIOLOGICA E HISTOPATOLOGICA"
      },
      {
        "codigo": "A1842",
        "valor": "TUBERCULOSIS DE LA PIEL Y EL TEJIDO SUBCUTANEO, CONFIRMADO CON HISTOPATOLOGIA"
      },
      {
        "codigo": "A1843",
        "valor": "TUBERCULOSIS DE LA PIEL Y EL TEJIDO SUBCUTANEO, CONFIRMADO CON BACTERIOLOGIA"
      },
      {
        "codigo": "A185",
        "valor": "TUBERCULOSIS DEL OJO"
      },
      {
        "codigo": "A1851",
        "valor": "TUBERCULOSIS DEL OJO, SIN CONFIRMACION BACTERIOLOGICA E HISTOPATOLOGICA"
      },
      {
        "codigo": "A1852",
        "valor": "TUBERCULOSIS DEL OJO, CONFIRMADO CON HISTOPATOLOGIA"
      },
      {
        "codigo": "A1853",
        "valor": "TUBERCULOSIS DEL OJO, CONFIRMACO CON BACTERIOLOGIA"
      },
      {
        "codigo": "A186",
        "valor": "TUBERCULOSIS DEL OIDO"
      },
      {
        "codigo": "A1861",
        "valor": "TUBERCULOSIS DEL OIDO, SIN CONFIRMACION BACTERIOLOGICA E HISTOPATOLOGICA"
      },
      {
        "codigo": "A1862",
        "valor": "TUBERCULOSIS DEL OIDO, CONFIRMADO CON HISTOPATOLOGIA"
      },
      {
        "codigo": "A1863",
        "valor": "TUBERCULOSIS DEL OIDO, CONFIRMADO CON BACTERIOLOGIA"
      },
      {
        "codigo": "A187",
        "valor": "TUBERCULOSIS DE GLANDULAS SUPRARRENALES"
      },
      {
        "codigo": "A1871",
        "valor": "TUBERCULOSIS DE GLANDULAS SUPRARRENALES, SIN CONFIRMACION BACTERIOLOGICA E HISTOPATOLOGICO"
      },
      {
        "codigo": "A1872",
        "valor": "TUBERCULOSIS DE GLANDULAS SUPRARRENALES, CONFIRMADO CON BACTERIOLOGIA"
      },
      {
        "codigo": "A188",
        "valor": "TUBERCULOSIS DE OTROS ORGANOS ESPECIFICADOS"
      },
      {
        "codigo": "A1881",
        "valor": "TUBERCULOSIS DE OTROS ORGANOS ESPECIFICADOS, SIN CONFIRMACION BACTERIOLOGICA E HISTOPATOLOGICA"
      },
      {
        "codigo": "A1882",
        "valor": "TUBERCULOSIS DE OTROS ORGANOS ESPECIFICADOS, CONFIRMADO CON HISTOPATOLOGIA"
      },
      {
        "codigo": "A1883",
        "valor": "TUBERCULOSIS DE OTROS ORGANOS ESPECIFICADOS, CONFIRMADO CON BACTERIOLOGIA"
      },
      {
        "codigo": "A1891",
        "valor": "TUBERCULOSIS EXTRAPULMONAR SIN CONFIRMACION"
      },
      {
        "codigo": "A1892",
        "valor": "TUBERCULOSIS EXTRAPULMONAR CON CONFIRMACION HISTOPATOLOGICA"
      },
      {
        "codigo": "A1893",
        "valor": "TUBERCULOSIS EXTRAPULMONAR CON CONFIRMACION BACTERIOLOGICA"
      }
    ]
  },
  {
    "grupo": "A19 - TUBERCULOSIS MILIAR",
    "detalle": [
      {
        "codigo": "A190",
        "valor": "TUBERCULOSIS MILIAR AGUDA DE UN SOLO SITIO ESPECIFICADO"
      },
      {
        "codigo": "A191",
        "valor": "TUBERCULOSIS MILIAR AGUDA DE SITIOS MULTIPLES"
      },
      {
        "codigo": "A192",
        "valor": "TUBERCULOSIS MILIAR AGUDA, NO ESPECIFICADA"
      },
      {
        "codigo": "A198",
        "valor": "OTRAS TUBERCULOSIS MILIARES"
      },
      {
        "codigo": "A199",
        "valor": "TUBERCULOSIS MILIAR, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A20 - PESTE",
    "detalle": [
      {
        "codigo": "A200",
        "valor": "PESTE BUBONICA"
      },
      {
        "codigo": "A201",
        "valor": "PESTE CELULOCUTANEA"
      },
      {
        "codigo": "A202",
        "valor": "PESTE NEUMONICA"
      },
      {
        "codigo": "A203",
        "valor": "MENINGITIS POR PESTE"
      },
      {
        "codigo": "A207",
        "valor": "PESTE SEPTICEMICA"
      },
      {
        "codigo": "A208",
        "valor": "OTRAS FORMAS DE PESTE"
      },
      {
        "codigo": "A209",
        "valor": "PESTE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A21 - TULAREMIA",
    "detalle": [
      {
        "codigo": "A210",
        "valor": "TULAREMIA ULCEROGLANDULAR"
      },
      {
        "codigo": "A211",
        "valor": "TULAREMIA OCULOGLANDULAR"
      },
      {
        "codigo": "A212",
        "valor": "TULAREMIA PULMONAR"
      },
      {
        "codigo": "A213",
        "valor": "TULAREMIA GASTROINTESTINAL"
      },
      {
        "codigo": "A217",
        "valor": "TULAREMIA GENERALIZADA"
      },
      {
        "codigo": "A218",
        "valor": "OTRAS FORMAS DE TULAREMIA"
      },
      {
        "codigo": "A219",
        "valor": "TULAREMIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A22 - CARBUNCO [ANTRAX]",
    "detalle": [
      {
        "codigo": "A220",
        "valor": "CARBUNCO CUTANEO"
      },
      {
        "codigo": "A221",
        "valor": "CARBUNCO PULMONAR"
      },
      {
        "codigo": "A222",
        "valor": "CARBUNCO GASTROINTESTINAL"
      },
      {
        "codigo": "A227",
        "valor": "CARBUNCO SEPTICO"
      },
      {
        "codigo": "A228",
        "valor": "OTRAS FORMAS DE CARBUNCO"
      },
      {
        "codigo": "A229",
        "valor": "CARBUNCO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "A23 - BRUCELOSIS",
    "detalle": [
      {
        "codigo": "A230",
        "valor": "BRUCELOSIS DEBIDA A BRUCELLA MELITENSIS"
      },
      {
        "codigo": "A231",
        "valor": "BRUCELOSIS DEBIDA A BRUCELLA ABORTUS"
      },
      {
        "codigo": "A232",
        "valor": "BRUCELOSIS DEBIDA A BRUCELLA SUIS"
      },
      {
        "codigo": "A233",
        "valor": "BRUCELOSIS DEBIDA A BRUCELLA CANIS"
      },
      {
        "codigo": "A238",
        "valor": "OTRAS BRUCELOSIS"
      },
      {
        "codigo": "A239",
        "valor": "BRUCELOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A24 - MUERMO Y MELIOIDOSIS",
    "detalle": [
      {
        "codigo": "A240",
        "valor": "MUERMO"
      },
      {
        "codigo": "A241",
        "valor": "MELIOIDOSIS AGUDA Y FULMINANTE"
      },
      {
        "codigo": "A242",
        "valor": "MELIOIDOSIS SUBAGUDA Y CRONICA"
      },
      {
        "codigo": "A243",
        "valor": "OTRAS MELIOIDOSIS"
      },
      {
        "codigo": "A244",
        "valor": "MELIOIDOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A25 - FIEBRES POR MORDEDURA DE RATA",
    "detalle": [
      {
        "codigo": "A250",
        "valor": "ESPIRILOSIS"
      },
      {
        "codigo": "A251",
        "valor": "ESTREPTOBACILOSIS"
      },
      {
        "codigo": "A259",
        "valor": "FIEBRE POR MORDEDURA DE RATA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A26 - ERISIPELOIDE",
    "detalle": [
      {
        "codigo": "A260",
        "valor": "ERISIPELOIDE CUTANEO"
      },
      {
        "codigo": "A267",
        "valor": "SEPSIS POR ERYSIPELOTHRIX"
      },
      {
        "codigo": "A268",
        "valor": "OTRAS FORMAS DE ERISIPELOIDE"
      },
      {
        "codigo": "A269",
        "valor": "ERISIPELOIDE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A27 - LEPTOSPIROSIS",
    "detalle": [
      {
        "codigo": "A270",
        "valor": "LEPTOSPIROSIS ICTEROHEMORRAGICA"
      },
      {
        "codigo": "A278",
        "valor": "OTRAS FORMAS DE LEPTOSPIROSIS"
      },
      {
        "codigo": "A279",
        "valor": "LEPTOSPIROSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A28 - OTRAS ENFERMEDADES ZOONOTICAS BACTERIANAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "A280",
        "valor": "PASTEURELOSIS"
      },
      {
        "codigo": "A281",
        "valor": "ENFERMEDAD POR RASGUÑO DE GATO"
      },
      {
        "codigo": "A282",
        "valor": "YERSINIOSIS EXTRAINTESTINAL"
      },
      {
        "codigo": "A288",
        "valor": "OTRAS ENFERMEDADES ZOONOTICAS BACTERIANAS ESPECIFICADAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "A289",
        "valor": "ENFERMEDAD ZOONOTICA BACTERIANA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A30 - LEPRA [ENFERMEDAD DE HANSEN]",
    "detalle": [
      {
        "codigo": "A300",
        "valor": "LEPRA INDETERMINADA"
      },
      {
        "codigo": "A301",
        "valor": "LEPRA TUBERCULOIDE"
      },
      {
        "codigo": "A302",
        "valor": "LEPRA TUBERCULOIDE LIMITROFE"
      },
      {
        "codigo": "A303",
        "valor": "LEPRA LIMITROFE"
      },
      {
        "codigo": "A304",
        "valor": "LEPRA LEPROMATOSA LIMITROFE"
      },
      {
        "codigo": "A305",
        "valor": "LEPRA LEPROMATOSA"
      },
      {
        "codigo": "A308",
        "valor": "OTRAS FORMAS DE LEPRA"
      },
      {
        "codigo": "A309",
        "valor": "LEPRA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A31 - INFECCIONES DEBIDAS A OTRAS MICOBACTERIAS",
    "detalle": [
      {
        "codigo": "A310",
        "valor": "INFECCIONES POR MICOBACTERIAS PULMONARES"
      },
      {
        "codigo": "A311",
        "valor": "INFECCION CUTANEA POR MICOBACTERIAS"
      },
      {
        "codigo": "A318",
        "valor": "OTRAS INFECCIONES POR MICOBACTERIAS"
      },
      {
        "codigo": "A319",
        "valor": "INFECCION POR MICOBACTERIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A32 - LISTERIOSIS",
    "detalle": [
      {
        "codigo": "A320",
        "valor": "LISTERIOSIS CUTANEA"
      },
      {
        "codigo": "A321",
        "valor": "MENINGITIS Y MENINGOENCEFALITIS LISTERIANA"
      },
      {
        "codigo": "A327",
        "valor": "SEPSIS LISTERIANA"
      },
      {
        "codigo": "A328",
        "valor": "OTRAS FORMAS DE LISTERIOSIS"
      },
      {
        "codigo": "A329",
        "valor": "LISTERIOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A33 - TETANOS NEONATAL",
    "detalle": [
      {
        "codigo": "A33X",
        "valor": "TETANOS NEONATAL"
      }
    ]
  },
  {
    "grupo": "A34 - TETANOS OBSTETRICO",
    "detalle": [
      {
        "codigo": "A34X",
        "valor": "TETANOS OBSTETRICO"
      }
    ]
  },
  {
    "grupo": "A35 - OTROS TETANOS",
    "detalle": [
      {
        "codigo": "A35X",
        "valor": "OTROS TETANOS"
      }
    ]
  },
  {
    "grupo": "A36 - DIFTERIA",
    "detalle": [
      {
        "codigo": "A360",
        "valor": "DIFTERIA FARINGEA"
      },
      {
        "codigo": "A361",
        "valor": "DIFTERIA NASOFARINGEA"
      },
      {
        "codigo": "A362",
        "valor": "DIFTERIA LARINGEA"
      },
      {
        "codigo": "A363",
        "valor": "DIFTERIA CUTANEA"
      },
      {
        "codigo": "A368",
        "valor": "OTRAS DIFTERIAS"
      },
      {
        "codigo": "A369",
        "valor": "DIFTERIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A37 - TOS FERINA [TOS CONVULSIVA]",
    "detalle": [
      {
        "codigo": "A370",
        "valor": "TOS FERINA DEBIDA A BORDETELLA PERTUSSIS"
      },
      {
        "codigo": "A371",
        "valor": "TOS FERINA DEBIDA A BORDETELLA PARAPERTUSSIS"
      },
      {
        "codigo": "A378",
        "valor": "TOS FERINA DEBIDA A OTRAS ESPECIES DE BORDETELLA"
      },
      {
        "codigo": "A379",
        "valor": "TOS FERINA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A38 - ESCARLATINA",
    "detalle": [
      {
        "codigo": "A38X",
        "valor": "ESCARLATINA"
      }
    ]
  },
  {
    "grupo": "A39 - ENFERMEDAD MENINGOCOCICA",
    "detalle": [
      {
        "codigo": "A390",
        "valor": "MENINGITIS MENINGOCOCICA"
      },
      {
        "codigo": "A391",
        "valor": "SINDROME DE WATERHOUSE-FRIDERICHSEN"
      },
      {
        "codigo": "A392",
        "valor": "MENINGOCOCEMIA AGUDA"
      },
      {
        "codigo": "A393",
        "valor": "MENINGOCOCEMIA CRONICA"
      },
      {
        "codigo": "A394",
        "valor": "MENINGOCOCEMIA, NO ESPECIFICADA"
      },
      {
        "codigo": "A395",
        "valor": "ENFERMEDAD CARDIACA DEBIDA A MENINGOCOCO"
      },
      {
        "codigo": "A398",
        "valor": "OTRAS FORMAS DE ENFERMEDAD MENINGOCOCICA"
      },
      {
        "codigo": "A399",
        "valor": "ENFERMEDAD MENINGOCOCICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A40 - SEPTICEMIA ESTREPTOCOCICA",
    "detalle": [
      {
        "codigo": "A400",
        "valor": "SEPSIS DEBIDA A ESTREPTOCOCO, GRUPO A"
      },
      {
        "codigo": "A401",
        "valor": "SEPSIS DEBIDA A ESTREPTOCOCO, GRUPO B"
      },
      {
        "codigo": "A402",
        "valor": "SEPSIS DEBIDA A ESTREPTOCOCO, GRUPO D Y ENTEROCOCO"
      },
      {
        "codigo": "A403",
        "valor": "SEPSIS DEBIDA A STREPTOCOCCUS PNEUMONIAE"
      },
      {
        "codigo": "A408",
        "valor": "OTRAS SEPSIS ESTREPTOCOCICAS"
      },
      {
        "codigo": "A409",
        "valor": "SEPSIS ESTREPTOCOCICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A41 - OTRAS SEPTICEMIAS",
    "detalle": [
      {
        "codigo": "A410",
        "valor": "SEPSIS DEBIDA A STAPHYLOCOCCUS AUREUS"
      },
      {
        "codigo": "A411",
        "valor": "SEPSIS DEBIDA A OTRO ESTAFILOCOCO ESPECIFICADO"
      },
      {
        "codigo": "A412",
        "valor": "SEPSIS DEBIDA A ESTAFILOCOCO NO ESPECIFICADO"
      },
      {
        "codigo": "A413",
        "valor": "SEPSIS DEBIDA A HAEMOPHILUS INFLUENZAE"
      },
      {
        "codigo": "A414",
        "valor": "SEPSIS DEBIDA A ANAEROBIOS"
      },
      {
        "codigo": "A415",
        "valor": "SEPSIS DEBIDA A OTROS ORGANISMOS GRAMNEGATIVOS"
      },
      {
        "codigo": "A418",
        "valor": "OTRAS SEPSIS ESPECIFICADAS"
      },
      {
        "codigo": "A419",
        "valor": "SEPSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A42 - ACTINOMICOSIS",
    "detalle": [
      {
        "codigo": "A420",
        "valor": "ACTINOMICOSIS PULMONAR"
      },
      {
        "codigo": "A421",
        "valor": "ACTINOMICOSIS ABDOMINAL"
      },
      {
        "codigo": "A422",
        "valor": "ACTINOMICOSIS CERVICOFACIAL"
      },
      {
        "codigo": "A427",
        "valor": "SEPSIS ACTINOMICOTICA"
      },
      {
        "codigo": "A428",
        "valor": "OTRAS FORMAS DE ACTINOMICOSIS"
      },
      {
        "codigo": "A429",
        "valor": "ACTINOMICOSIS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A43 - NOCARDIOSIS",
    "detalle": [
      {
        "codigo": "A430",
        "valor": "NOCARDIOSIS PULMONAR"
      },
      {
        "codigo": "A431",
        "valor": "NOCARDIOSIS CUTANEA"
      },
      {
        "codigo": "A438",
        "valor": "OTRAS FORMAS DE NOCARDIOSIS"
      },
      {
        "codigo": "A439",
        "valor": "NOCARDIOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A44 - BARTONELOSIS",
    "detalle": [
      {
        "codigo": "A440",
        "valor": "BARTONELOSIS SISTEMICA"
      },
      {
        "codigo": "A441",
        "valor": "BARTONELOSIS CUTANEA Y MUCOCUTANEA"
      },
      {
        "codigo": "A448",
        "valor": "OTRAS FORMAS DE BARTONELOSIS"
      },
      {
        "codigo": "A4481",
        "valor": "BARTONELOSIS AGUDA"
      },
      {
        "codigo": "A4482",
        "valor": "BARTONELOSIS AGUDA COMPLICADA"
      },
      {
        "codigo": "A4483",
        "valor": "BARTONELOSIS RESISTENTE"
      },
      {
        "codigo": "A449",
        "valor": "BARTONELOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A46 - ERISIPELA",
    "detalle": [
      {
        "codigo": "A46X",
        "valor": "ERISIPELA"
      }
    ]
  },
  {
    "grupo": "A48 - OTRAS ENFERMEDADES BACTERIANAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "A480",
        "valor": "GANGRENA GASEOSA"
      },
      {
        "codigo": "A481",
        "valor": "ENFERMEDAD DE LOS LEGIONARIOS"
      },
      {
        "codigo": "A482",
        "valor": "ENFERMEDAD DE LOS LEGIONARIOS NO NEUMONICA (FIEBRE DE PONTIAC)"
      },
      {
        "codigo": "A483",
        "valor": "SINDROME DEL CHOQUE TOXICO"
      },
      {
        "codigo": "A484",
        "valor": "FIEBRE PURPURICA BRASILEÑA"
      },
      {
        "codigo": "A488",
        "valor": "OTRAS ENFERMEDADES BACTERIANAS ESPECIFICADAS"
      },
      {
        "codigo": "A4851",
        "valor": "BOTULISMO INFANTIL"
      }
    ]
  },
  {
    "grupo": "A49 - INFECCION BACTERIANA DE SITIO NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "A490",
        "valor": "INFECCION ESTAFILOCOCICA, SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "A491",
        "valor": "INFECCION ESTREPTOCOCICA Y ENTEROCOCICA DE SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "A492",
        "valor": "INFECCION POR HAEMOPHILUS INFLUENZAE, SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "A493",
        "valor": "INFECCION POR MICOPLASMA, SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "A498",
        "valor": "OTRAS INFECCIONES BACTERIANAS DE SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "A499",
        "valor": "INFECCION BACTERIANA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A50 - SIFILIS CONGENITA",
    "detalle": [
      {
        "codigo": "A500",
        "valor": "SIFILIS CONGENITA PRECOZ, SINTOMATICA"
      },
      {
        "codigo": "A501",
        "valor": "SIFILIS CONGENITA PRECOZ, LATENTE"
      },
      {
        "codigo": "A502",
        "valor": "SIFILIS CONGENITA PRECOZ, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "A503",
        "valor": "OCULOPATIA SIFILITICA CONGENITA TARDIA"
      },
      {
        "codigo": "A504",
        "valor": "NEUROSIFILIS CONGENITA TARDIA [NEUROSIFILIS JUVENIL]"
      },
      {
        "codigo": "A505",
        "valor": "OTRAS FORMAS DE SIFILIS CONGENITA TARDIA, SINTOMATICA"
      },
      {
        "codigo": "A506",
        "valor": "SIFILIS CONGENITA TARDIA, LATENTE"
      },
      {
        "codigo": "A507",
        "valor": "SIFILIS CONGENITA TARDIA, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "A509",
        "valor": "SIFILIS CONGENITA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A51 - SIFILIS PRECOZ",
    "detalle": [
      {
        "codigo": "A510",
        "valor": "SIFILIS GENITAL PRIMARIA"
      },
      {
        "codigo": "A511",
        "valor": "SIFILIS PRIMARIA ANAL"
      },
      {
        "codigo": "A512",
        "valor": "SIFILIS PRIMARIA EN OTROS SITIOS"
      },
      {
        "codigo": "A513",
        "valor": "SIFILIS SECUNDARIA DE PIEL Y MEMBRANAS MUCOSAS"
      },
      {
        "codigo": "A514",
        "valor": "OTRAS SIFILIS SECUNDARIAS"
      },
      {
        "codigo": "A515",
        "valor": "SIFILIS PRECOZ, LATENTE"
      },
      {
        "codigo": "A519",
        "valor": "SIFILIS PRECOZ, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A52 - SIFILIS TARDIA",
    "detalle": [
      {
        "codigo": "A520",
        "valor": "SIFILIS CARDIOVASCULAR"
      },
      {
        "codigo": "A521",
        "valor": "NEUROSIFILIS SINTOMATICA"
      },
      {
        "codigo": "A522",
        "valor": "NEUROSIFILIS ASINTOMATICA"
      },
      {
        "codigo": "A523",
        "valor": "NEUROSIFILIS NO ESPECIFICADA"
      },
      {
        "codigo": "A527",
        "valor": "OTRAS SIFILIS TARDIAS SINTOMATICAS"
      },
      {
        "codigo": "A528",
        "valor": "SIFILIS TARDIA, LATENTE"
      },
      {
        "codigo": "A529",
        "valor": "SIFILIS TARDIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A53 - OTRAS SIFILIS Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "A530",
        "valor": "SIFILIS LATENTE, NO ESPECIFICADA COMO PRECOZ O TARDIA"
      },
      {
        "codigo": "A539",
        "valor": "SIFILIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A54 - INFECCION GONOCOCICA",
    "detalle": [
      {
        "codigo": "A540",
        "valor": "INFECCION GONOCOCICA DEL TRACTO GENITOURINARIO INFERIOR SIN ABSCESO PERIURETRAL Y DE GLANDULA ACCESORIA"
      },
      {
        "codigo": "A541",
        "valor": "INFECCION GONOCOCICA DEL TRACTO GENITOURINARIO INFERIOR CON ABSCESO PERIURETRAL Y DE GLANDULAS ACCESORIAS"
      },
      {
        "codigo": "A542",
        "valor": "PELVIPERITONITIS GONOCOCICA Y OTRAS INFECCIONES GONOCOCICAS GENITOURINARIAS"
      },
      {
        "codigo": "A543",
        "valor": "INFECCION GONOCOCICA DEL OJO"
      },
      {
        "codigo": "A544",
        "valor": "INFECCION GONOCOCICA DEL SISTEMA OSTEOMUSCULAR"
      },
      {
        "codigo": "A545",
        "valor": "FARINGITIS GONOCOCICA"
      },
      {
        "codigo": "A546",
        "valor": "INFECCION GONOCOCICA DEL ANO Y DEL RECTO"
      },
      {
        "codigo": "A548",
        "valor": "OTRAS INFECCIONES GONOCOCICAS"
      },
      {
        "codigo": "A549",
        "valor": "INFECCION GONOCOCICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A55 - LINFOGRANULOMA (VENEREO) POR CLAMIDIAS",
    "detalle": [
      {
        "codigo": "A55X",
        "valor": "LINFOGRANULOMA VENEREO"
      }
    ]
  },
  {
    "grupo": "A56 - OTRAS ENFERMEDADES DE TRANSMISION SEXUAL DEBIDAS A CLAMIDIAS",
    "detalle": [
      {
        "codigo": "A560",
        "valor": "INFECCION DEL TRACTO GENITOURINARIO INFERIOR DEBIDA A CLAMIDIAS"
      },
      {
        "codigo": "A561",
        "valor": "INFECCION DEL PELVIPERITONEO Y OTROS ORGANOS GENITOURINARIOS DEBIDA A CLAMIDIAS"
      },
      {
        "codigo": "A562",
        "valor": "INFECCIONES DEL TRACTO GENITOURINARIO DEBIDAS A CLAMIDIAS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "A563",
        "valor": "INFECCION DEL ANO Y DEL RECTO DEBIDA A CLAMIDIAS"
      },
      {
        "codigo": "A564",
        "valor": "INFECCION DE FARINGE DEBIDA A CLAMIDIAS"
      },
      {
        "codigo": "A568",
        "valor": "INFECCION DE TRANSMISION SEXUAL DE OTROS SITIOS DEBIDA A CLAMIDIAS"
      }
    ]
  },
  {
    "grupo": "A57 - CHANCRO BLANDO",
    "detalle": [
      {
        "codigo": "A57X",
        "valor": "CHANCRO BLANDO"
      }
    ]
  },
  {
    "grupo": "A58 - GRANULOMA INGUINAL",
    "detalle": [
      {
        "codigo": "A58X",
        "valor": "GRANULOMA INGUINAL"
      }
    ]
  },
  {
    "grupo": "A59 - TRICOMONIASIS",
    "detalle": [
      {
        "codigo": "A590",
        "valor": "TRICOMONIASIS UROGENITAL"
      },
      {
        "codigo": "A598",
        "valor": "TRICOMONIASIS DE OTROS SITOS"
      },
      {
        "codigo": "A599",
        "valor": "TRICOMONIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A60 - INFECCION ANOGENITAL DEBIDA A VIRUS DEL HERPES [HERPES SIMPLE]",
    "detalle": [
      {
        "codigo": "A600",
        "valor": "INFECCION DE GENITALES Y TRAYECTO UROGENITAL DEBIDA A VIRUS DEL HERPES [HERPES SIMPLE]"
      },
      {
        "codigo": "A601",
        "valor": "INFECCION DE LA PIEL PERIANAL Y RECTO POR VIRUS DEL HERPES SIMPLE"
      },
      {
        "codigo": "A609",
        "valor": "INFECCION ANOGENITAL POR VIRUS DEL HERPES SIMPLE, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A63 - OTRAS ENFERMEDADES DE TRANSMISION PREDOMINANTEMENTE SEXUAL, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "A630",
        "valor": "VERRUGAS (VENEREAS) ANOGENITALES"
      },
      {
        "codigo": "A638",
        "valor": "OTRAS ENFERMEDADES DE TRANSMISION PREDOMINANTEMENTE SEXUAL, ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "A64 - ENFERMEDAD DE TRANSMISION SEXUAL NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "A64X",
        "valor": "ENFERMEDAD DE TRANSMISION SEXUAL NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A65 - SIFILIS NO VENEREA",
    "detalle": [
      {
        "codigo": "A65X",
        "valor": "SIFILIS NO VENEREA"
      }
    ]
  },
  {
    "grupo": "A66 - FRAMBESIA",
    "detalle": [
      {
        "codigo": "A660",
        "valor": "LESIONES INICIALES DE FRAMBESIA"
      },
      {
        "codigo": "A661",
        "valor": "LESIONES PAPILOMATOSAS MULTIPLES Y FRAMBESIA CON PASO DE CANGREJO"
      },
      {
        "codigo": "A662",
        "valor": "OTRAS LESIONES PRECOCES DE LA PIEL EN LA FRAMBESIA"
      },
      {
        "codigo": "A663",
        "valor": "HIPERQUERATOSIS DE FRAMBESIA"
      },
      {
        "codigo": "A664",
        "valor": "GOMA Y ULCERAS DE FRAMBESIA"
      },
      {
        "codigo": "A665",
        "valor": "GANGOSA"
      },
      {
        "codigo": "A666",
        "valor": "LESIONES FRAMBESICAS DE LOS HUESOS Y DE LAS ARTICULACIONES"
      },
      {
        "codigo": "A667",
        "valor": "OTRAS MANIFESTACIONES DE FRAMBESIA"
      },
      {
        "codigo": "A668",
        "valor": "FRAMBESIA LATENTE"
      },
      {
        "codigo": "A669",
        "valor": "FRAMBESIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A67 - PINTA [CARATE]",
    "detalle": [
      {
        "codigo": "A670",
        "valor": "LESIONES PRIMARIAS DE LA PINTA"
      },
      {
        "codigo": "A671",
        "valor": "LESIONES INTERMEDIAS DE LA PINTA"
      },
      {
        "codigo": "A672",
        "valor": "LESIONES TARDIAS DE LA PINTA"
      },
      {
        "codigo": "A673",
        "valor": "LESIONES MIXTAS DE LA PINTA"
      },
      {
        "codigo": "A679",
        "valor": "PINTA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A68 - FIEBRES RECURRENTES",
    "detalle": [
      {
        "codigo": "A680",
        "valor": "FIEBRE RECURRENTE TRANSMITIDA POR PIOJOS"
      },
      {
        "codigo": "A681",
        "valor": "FIEBRE RECURRENTE TRANSMITIDA POR GARRAPATAS"
      },
      {
        "codigo": "A689",
        "valor": "FIEBRE RECURRENTE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A69 - OTRAS INFECCIONES CAUSADAS POR ESPIROQUETAS",
    "detalle": [
      {
        "codigo": "A690",
        "valor": "ESTOMATITIS ULCERATIVA NECROTIZANTE"
      },
      {
        "codigo": "A691",
        "valor": "OTRAS INFECCIONES DE VINCENT"
      },
      {
        "codigo": "A6910",
        "valor": "GINGIVITIS ULCERATIVA NECROTIZANTE AGUDA [GINGIVITIS FUSOESPIROQUETICA][GINGIVITIS DE VINCENT]"
      },
      {
        "codigo": "A6911",
        "valor": "ANGINA DE VINCENT"
      },
      {
        "codigo": "A692",
        "valor": "ENFERMEDAD DE LYME"
      },
      {
        "codigo": "A698",
        "valor": "OTRAS INFECCIONES ESPECIFICADAS POR ESPIROQUETAS"
      },
      {
        "codigo": "A699",
        "valor": "INFECCION POR ESPIROQUETA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A70 - INFECCION DEBIDA A CHLAMYDIA PSITTACI",
    "detalle": [
      {
        "codigo": "A70X",
        "valor": "INFECCION DEBIDA A CHLAMYDIA PSITTACI"
      }
    ]
  },
  {
    "grupo": "A71 - TRACOMA",
    "detalle": [
      {
        "codigo": "A710",
        "valor": "ESTADO INICIAL DE TRACOMA"
      },
      {
        "codigo": "A711",
        "valor": "ESTADO ACTIVO DE TRACOMA"
      },
      {
        "codigo": "A719",
        "valor": "TRACOMA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "A74 - OTRAS ENFERMEDADES CAUSADAS POR CLAMIDIAS",
    "detalle": [
      {
        "codigo": "A740",
        "valor": "CONJUNTIVITIS POR CLAMIDIAS"
      },
      {
        "codigo": "A748",
        "valor": "OTRAS ENFERMEDADES POR CLAMIDIAS"
      },
      {
        "codigo": "A749",
        "valor": "INFECCION POR CLAMIDIAS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A75 - TIFUS",
    "detalle": [
      {
        "codigo": "A750",
        "valor": "TIFUS EPIDEMICO DEBIDO A RICKETTSIA PROWAZEKII TRANSMITIDO POR PIOJOS"
      },
      {
        "codigo": "A751",
        "valor": "TIFUS RECRUDESCENTE [ENFERMEDAD DE BRILL]"
      },
      {
        "codigo": "A752",
        "valor": "TIFUS DEBIDO A RICKETTSIA TYPHI"
      },
      {
        "codigo": "A753",
        "valor": "TIFUS DEBIDO A RICKETTSIA TSUTSUGAMUSHI"
      },
      {
        "codigo": "A759",
        "valor": "TIFUS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "A77 - FIEBRE MACULOSA [RICKETTSIOSIS TRANSMITIDA POR GARRAPATAS]",
    "detalle": [
      {
        "codigo": "A770",
        "valor": "FIEBRE MACULOSA DEBIDA A RICKETTSIA RICKETTSII"
      },
      {
        "codigo": "A771",
        "valor": "FIEBRE MACULOSA DEBIDA A RICKETTSIA CONORII"
      },
      {
        "codigo": "A772",
        "valor": "FIEBRE MACULOSA DEBIDA A RICKETTSIA SIBERICA"
      },
      {
        "codigo": "A773",
        "valor": "FIEBRE MACULOSA DEBIDA A RICKETTSIA AUSTRALIS"
      },
      {
        "codigo": "A778",
        "valor": "OTRAS FIEBRES MACULOSAS"
      },
      {
        "codigo": "A779",
        "valor": "FIEBRE MACULOSA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A78 - FIEBRE Q",
    "detalle": [
      {
        "codigo": "A78X",
        "valor": "FIEBRE Q"
      }
    ]
  },
  {
    "grupo": "A79 - OTRAS RICKETTSIOSIS",
    "detalle": [
      {
        "codigo": "A790",
        "valor": "FIEBRE DE LAS TRINCHERAS"
      },
      {
        "codigo": "A791",
        "valor": "RICKETTSIOSIS PUSTULOSA DEBIDA A RICKETTSIA AKARI"
      },
      {
        "codigo": "A798",
        "valor": "OTRAS RICKETTSIOSIS ESPECIFICADAS"
      },
      {
        "codigo": "A799",
        "valor": "RICKETTSIOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A80 - POLIOMIELITIS AGUDA",
    "detalle": [
      {
        "codigo": "A800",
        "valor": "POLIOMIELITIS AGUDA PARALITICA, ASOCIADA A VACUNA"
      },
      {
        "codigo": "A801",
        "valor": "POLIOMIELITIS AGUDA PARALITICA DEBIDA A VIRUS SALVAJE IMPORTADO"
      },
      {
        "codigo": "A802",
        "valor": "POLIOMIELITIS AGUDA PARALITICA DEBIDA A VIRUS SALVAJE AUTOCTONO"
      },
      {
        "codigo": "A803",
        "valor": "OTRAS POLIOMIELITIS AGUDAS PARALITICAS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "A804",
        "valor": "POLIOMIELITIS AGUDA NO PARALITICA"
      },
      {
        "codigo": "A809",
        "valor": "POLIOMIELITIS AGUDA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A81 - INFECCIONES DEL SISTEMA NERVIOSO CENTRAL POR VIRUS LENTO",
    "detalle": [
      {
        "codigo": "A810",
        "valor": "ENFERMEDAD DE CREUTZFELDT-JAKOB"
      },
      {
        "codigo": "A811",
        "valor": "PANENCEFALITIS ESCLEROSANTE SUBAGUDA"
      },
      {
        "codigo": "A812",
        "valor": "LEUCOENCEFALOPATIA MULTIFOCAL PROGRESIVA"
      },
      {
        "codigo": "A818",
        "valor": "OTRAS INFECCIONES DEL SISTEMA NERVIOSO CENTRAL POR VIRUS ATIPICO"
      },
      {
        "codigo": "A819",
        "valor": "INFECCIONES DEL SISTEMA NERVIOSO CENTRAL POR VIRUS ATIPICO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A82 - RABIA",
    "detalle": [
      {
        "codigo": "A820",
        "valor": "RABIA SELVATICA"
      },
      {
        "codigo": "A821",
        "valor": "RABIA URBANA"
      },
      {
        "codigo": "A829",
        "valor": "RABIA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A83 - ENCEFALITIS VIRAL TRANSMITIDA POR MOSQUITOS",
    "detalle": [
      {
        "codigo": "A830",
        "valor": "ENCEFALITIS JAPONESA"
      },
      {
        "codigo": "A831",
        "valor": "ENCEFALITIS EQUINA DEL OESTE"
      },
      {
        "codigo": "A832",
        "valor": "ENCEFALITIS EQUINA DEL ESTE"
      },
      {
        "codigo": "A833",
        "valor": "ENCEFALITIS DE SAN LUIS"
      },
      {
        "codigo": "A834",
        "valor": "ENCEFALITIS AUSTRALIANA"
      },
      {
        "codigo": "A835",
        "valor": "ENCEFALITIS DE CALIFORNIA"
      },
      {
        "codigo": "A836",
        "valor": "ENFERMEDAD POR VIRUS ROCIO"
      },
      {
        "codigo": "A838",
        "valor": "OTRAS ENCEFALITIS VIRALES TRANSMITIDAS POR MOSQUITOS"
      },
      {
        "codigo": "A839",
        "valor": "ENCEFALITIS VIRAL TRANSMITIDA POR MOSQUITOS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A84 - ENCEFALITIS VIRAL TRANSMITIDA POR GARRAPATAS",
    "detalle": [
      {
        "codigo": "A840",
        "valor": "ENCEFALITIS DEL LEJANO ORIENTE TRANSMITIDA POR GARRAPATAS [ENCEFALITIS PRIMAVEROESTIVAL RUSA]"
      },
      {
        "codigo": "A841",
        "valor": "ENCEFALITIS CENTROEUROPEA TRANSMITIDA POR GARRAPATAS"
      },
      {
        "codigo": "A848",
        "valor": "OTRAS ENCEFALITIS VIRALES TRANSMITIDA POR GARRAPATAS"
      },
      {
        "codigo": "A849",
        "valor": "ENCEFALITIS VIRAL TRANSMITIDA POR GARRAPATAS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A85 - OTRAS ENCEFALITIS VIRALES, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "A850",
        "valor": "ENCEFALITIS ENTEROVIRAL"
      },
      {
        "codigo": "A851",
        "valor": "ENCEFALITIS POR ADENOVIRUS"
      },
      {
        "codigo": "A852",
        "valor": "ENCEFALITIS VIRAL TRANSMITIDA POR ARTROPODOS, SIN OTRA ESPECIFCACION"
      },
      {
        "codigo": "A858",
        "valor": "OTRAS ENCEFALITIS VIRALES ESPECIFCADAS"
      }
    ]
  },
  {
    "grupo": "A86 - ENCEFALITIS VIRAL, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "A86X",
        "valor": "MENINGOENCEFALITIS VIRAL"
      }
    ]
  },
  {
    "grupo": "A87 - MENINGITIS VIRAL",
    "detalle": [
      {
        "codigo": "A870",
        "valor": "MENINGITIS ENTEROVIRAL"
      },
      {
        "codigo": "A871",
        "valor": "MENINGITIS DEBIDA A ADENOVIRUS"
      },
      {
        "codigo": "A872",
        "valor": "CORIOMENINGITIS LINFOCITICA"
      },
      {
        "codigo": "A878",
        "valor": "OTRAS MENINGITIS VIRALES"
      },
      {
        "codigo": "A879",
        "valor": "MENINGITIS VIRAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A88 - OTRAS INFECCIONES VIRALES DEL SISTEMA NERVIOSO CENTRAL, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "A880",
        "valor": "FIEBRE EXANTEMATICA ENTEROVIRAL [EXANTEMA DE BOSTON]"
      },
      {
        "codigo": "A881",
        "valor": "VERTIGO EPIDEMICO"
      },
      {
        "codigo": "A888",
        "valor": "OTRAS INFECCIONES VIRALES ESPECIFICADAS DEL SISTEMA NERVIOSO CENTRAL"
      }
    ]
  },
  {
    "grupo": "A89 - INFECCION VIRAL DEL SISTEMA NERVIOSO CENTRAL, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "A89X",
        "valor": "INFECCION VIRAL DEL SISTEMA NERVIOSO CENTRAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A92 - OTRAS FIEBRES VIRALES TRANSMITIDAS POR MOSQUITOS",
    "detalle": [
      {
        "codigo": "A920",
        "valor": "ENFERMEDAD POR VIRUS CHIKUNGUNYA"
      },
      {
        "codigo": "A921",
        "valor": "FIEBRE DE ONYONG-NYONG"
      },
      {
        "codigo": "A922",
        "valor": "FIEBRE EQUINA VENEZOLANA"
      },
      {
        "codigo": "A923",
        "valor": "INFECCION POR VIRUS DEL OESTE DEL NILO"
      },
      {
        "codigo": "A924",
        "valor": "FIEBRE DEL VALLE DEL RIFT"
      },
      {
        "codigo": "A925",
        "valor": "ENFERMEDAD POR VIRUS DEL ZIKA"
      },
      {
        "codigo": "A928",
        "valor": "OTRAS FIEBRES VIRALES ESPECIFICADAS TRANSMITIDAS POR MOSQUITOS"
      },
      {
        "codigo": "A929",
        "valor": "FIEBRE VIRAL TRANSMITIDA POR MOSQUITO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A93 - OTRAS FIEBRES VIRALES TRANSMITIDAS POR ARTROPODOS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "A930",
        "valor": "ENFERMEDAD POR VIRUS DE OROPOUCHE"
      },
      {
        "codigo": "A931",
        "valor": "FIEBRE TRANSMITIDA POR FLEBOTOMOS"
      },
      {
        "codigo": "A932",
        "valor": "FIEBRE DE COLORADO TRANSMITIDA POR GARRAPATAS"
      },
      {
        "codigo": "A938",
        "valor": "OTRAS FIEBRES VIRALES ESPECIFICADAS TRANSMITIDAS POR ARTROPODOS"
      }
    ]
  },
  {
    "grupo": "A94 - FIEBRE VIRAL TRANSMITIDA POR ARTROPODOS, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "A94X",
        "valor": "FIEBRE VIRAL TRANSMITIDA POR ARTROPODOS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A95 - FIEBRE AMARILLA",
    "detalle": [
      {
        "codigo": "A950",
        "valor": "FIEBRE AMARILLA SELVATICA"
      },
      {
        "codigo": "A9501",
        "valor": "FIEBRE AMARILLA SELVATICA FASE MODERADA"
      },
      {
        "codigo": "A9502",
        "valor": "FIEBRE AMARILLA SELVATICA FASE TOXICA"
      },
      {
        "codigo": "A951",
        "valor": "FIEBRE AMARILLA URBANA"
      },
      {
        "codigo": "A959",
        "valor": "FIEBRE AMARILLA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "A96 - FIEBRE HEMORRAGICA POR ARENAVIRUS",
    "detalle": [
      {
        "codigo": "A960",
        "valor": "FIEBRE HEMORRAGICA DE JUNIN"
      },
      {
        "codigo": "A961",
        "valor": "FIEBRE HEMORRAGICA DE MACHUPO"
      },
      {
        "codigo": "A962",
        "valor": "FIEBRE DE LASSA"
      },
      {
        "codigo": "A968",
        "valor": "OTRAS FIEBRES HEMORRAGICAS POR ARENAVIRUS"
      },
      {
        "codigo": "A969",
        "valor": "FIEBRE HEMORRAGICA POR ARENAVIRUS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "A97 - DENGUE",
    "detalle": [
      {
        "codigo": "A970",
        "valor": "DENGUE SIN SEÑALES DE ALARMA"
      },
      {
        "codigo": "A971",
        "valor": "DENGUE CON SEÑALES DE ALARMA"
      },
      {
        "codigo": "A972",
        "valor": "DENGUE GRAVE"
      }
    ]
  },
  {
    "grupo": "A98 - OTRAS FIEBRES VIRALES HEMORRAGICAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "A980",
        "valor": "FIEBRE HEMORRAGICA DE CRIMEA-CONGO"
      },
      {
        "codigo": "A981",
        "valor": "FIEBRE HEMORRAGICA DE OMSK"
      },
      {
        "codigo": "A982",
        "valor": "ENFERMEDAD DE LA SELVA KYASANUR"
      },
      {
        "codigo": "A983",
        "valor": "ENFERMEDAD POR EL VIRUS DE MARBURG"
      },
      {
        "codigo": "A984",
        "valor": "ENFERMEDAD POR EL VIRUS DE EBOLA"
      },
      {
        "codigo": "A985",
        "valor": "FIEBRES HEMORRAGICAS CON SINDROME RENAL"
      },
      {
        "codigo": "A988",
        "valor": "OTRAS FIEBRES HEMORRAGICAS VIRALES ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "A99 - FIEBRE VIRAL HEMORRAGICA, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "A99X",
        "valor": "FIEBRE VIRAL HEMORRAGICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B00 - INFECCIONES HERPETICAS [HERPES SIMPLE]",
    "detalle": [
      {
        "codigo": "B000",
        "valor": "ECZEMA HERPETICO"
      },
      {
        "codigo": "B000X",
        "valor": "ERUPCION VARICELOFORME DE KAPOSI, MANIFESTACIONES BUCALES"
      },
      {
        "codigo": "B001",
        "valor": "DERMATITIS VESICULAR HERPETICA"
      },
      {
        "codigo": "B0010",
        "valor": "HERPES SIMPLE FACIAL"
      },
      {
        "codigo": "B0011",
        "valor": "HERPES SIMPLE LABIAL"
      },
      {
        "codigo": "B002",
        "valor": "GINGIVOESTOMATITIS Y FARINGOAMIGDALITIS HERPETICA"
      },
      {
        "codigo": "B002X",
        "valor": "GINGIVOESTOMATITIS HERPETICA"
      },
      {
        "codigo": "B003",
        "valor": "MENINGITIS HERPETICA"
      },
      {
        "codigo": "B004",
        "valor": "ENCEFALITIS HERPETICA"
      },
      {
        "codigo": "B005",
        "valor": "OCULOPATIA HERPETICA"
      },
      {
        "codigo": "B007",
        "valor": "ENFERMEDAD HERPETICA DISEMINADA"
      },
      {
        "codigo": "B008",
        "valor": "OTRAS FORMAS DE INFECCIONES HERPETICAS"
      },
      {
        "codigo": "B008X",
        "valor": "PANADIZO HERPETICO"
      },
      {
        "codigo": "B009",
        "valor": "INFECCION DEBIDA AL VIRUS DEL HERPES, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B01 - VARICELA",
    "detalle": [
      {
        "codigo": "B010",
        "valor": "MENINGITIS DEBIDA A VARICELA"
      },
      {
        "codigo": "B011",
        "valor": "ENCEFALITIS DEBIDA A VARICELA"
      },
      {
        "codigo": "B012",
        "valor": "NEUMONIA DEBIDA A VARICELA"
      },
      {
        "codigo": "B018",
        "valor": "VARICELA CON OTRAS COMPLICACIONES"
      },
      {
        "codigo": "B018X",
        "valor": "MANIFESTACIONES BUCALES"
      },
      {
        "codigo": "B019",
        "valor": "VARICELA SIN COMPLICACIONES"
      }
    ]
  },
  {
    "grupo": "B02 - HERPES ZOSTER",
    "detalle": [
      {
        "codigo": "B020",
        "valor": "ENCEFALITIS DEBIDA A HERPES ZOSTER"
      },
      {
        "codigo": "B021",
        "valor": "MENINGITIS DEBIDA A HERPES ZOSTER"
      },
      {
        "codigo": "B022",
        "valor": "HERPES ZOSTER CON OTROS COMPROMISOS DEL SISTEMA NERVIOSO"
      },
      {
        "codigo": "B0220",
        "valor": "NEURALGIA POSTHERPETICA DEL TRIGEMINO"
      },
      {
        "codigo": "B023",
        "valor": "HERPES ZOSTER OCULAR"
      },
      {
        "codigo": "B027",
        "valor": "HERPES ZOSTER DISEMINADO"
      },
      {
        "codigo": "B028",
        "valor": "HERPES ZOSTER CON OTRAS COMPLICACIONES"
      },
      {
        "codigo": "B028X",
        "valor": "MANIFESTACIONES BUCALES"
      },
      {
        "codigo": "B029",
        "valor": "HERPES ZOSTER SIN COMPLICACIONES"
      }
    ]
  },
  {
    "grupo": "B03 - VIRUELA",
    "detalle": [
      {
        "codigo": "B03X",
        "valor": "VIRUELA"
      }
    ]
  },
  {
    "grupo": "B04 - VIRUELA DE LOS MONOS",
    "detalle": [
      {
        "codigo": "B04X",
        "valor": "VIRUELA DE LOS MONOS"
      }
    ]
  },
  {
    "grupo": "B05 - SARAMPION",
    "detalle": [
      {
        "codigo": "B050",
        "valor": "SARAMPION COMPLICADO CON ENCEFALITIS"
      },
      {
        "codigo": "B051",
        "valor": "SARAMPION COMPLICADO CON MENINGITIS"
      },
      {
        "codigo": "B052",
        "valor": "SARAMPION COMPLICADO CON NEUMONIA"
      },
      {
        "codigo": "B053",
        "valor": "SARAMPION COMPLICADO CON OTITIS MEDIA"
      },
      {
        "codigo": "B054",
        "valor": "SARAMPION CON COMPLICACIONES INTESTINALES"
      },
      {
        "codigo": "B058",
        "valor": "SARAMPION CON OTRAS COMPLICACIONES"
      },
      {
        "codigo": "B059",
        "valor": "SARAMPION SIN COMPLICACIONES"
      }
    ]
  },
  {
    "grupo": "B06 - RUBEOLA [SARAMPION ALEMAN]",
    "detalle": [
      {
        "codigo": "B060",
        "valor": "RUBEOLA CON COMPLICACIONES NEUROLOGICAS"
      },
      {
        "codigo": "B068",
        "valor": "RUBEOLA CON OTRAS COMPLICACIONES"
      },
      {
        "codigo": "B069",
        "valor": "RUBEOLA SIN COMPLICACIONES"
      }
    ]
  },
  {
    "grupo": "B07 - VERRUGAS VIRICAS",
    "detalle": [
      {
        "codigo": "B07X",
        "valor": "VERRUGAS VIRICAS"
      }
    ]
  },
  {
    "grupo": "B08 - OTRAS INFECCIONES VIRICAS CARACTERIZADAS POR LESIONES DE LA PIEL Y DE LAS MEMBRANAS MUCOSAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "B080",
        "valor": "OTRAS INFECCIONES DEBIDAS A ORTOPOXVIRUS"
      },
      {
        "codigo": "B081",
        "valor": "MOLUSCO CONTAGIOSO"
      },
      {
        "codigo": "B082",
        "valor": "EXANTEMA SUBITO [SEXTA ENFERMEDAD]"
      },
      {
        "codigo": "B083",
        "valor": "ERITEMA INFECCIOSO [QUINTA ENFERMEDAD]"
      },
      {
        "codigo": "B084",
        "valor": "ESTOMATITIS VESICULAR ENTEROVIRAL CON EXANTEMA"
      },
      {
        "codigo": "B085",
        "valor": "FARINGITIS VESICULAR ENTEROVIRICA"
      },
      {
        "codigo": "B088",
        "valor": "OTRAS INFECCIONES VIRALES ESPECIFICADAS, CARACTERIZADAS POR LESIONES DE LA PIEL Y DE LAS MEMBRANAS MUCOSAS"
      }
    ]
  },
  {
    "grupo": "B09 - INFECCION VIRAL NO ESPECIFICADA, CARACTERIZADA POR LESIONES DE LA PIEL Y DE LAS MEMBRANAS MUCOSAS",
    "detalle": [
      {
        "codigo": "B09X",
        "valor": "INFECCION VIRAL NO ESPECIFICADA, CARACTERIZADA POR LESIONES DE LA PIEL Y DE LAS"
      }
    ]
  },
  {
    "grupo": "B15 - HEPATITIS AGUDA TIPO A",
    "detalle": [
      {
        "codigo": "B150",
        "valor": "HEPATITIS AGUDA TIPO A, CON COMA HEPATICO"
      },
      {
        "codigo": "B159",
        "valor": "HEPATITIS AGUDA TIPO A, SIN COMA HEPATICO"
      }
    ]
  },
  {
    "grupo": "B16 - HEPATITIS AGUDA TIPO B",
    "detalle": [
      {
        "codigo": "B160",
        "valor": "HEPATITIS AGUDA TIPO B, CON AGENTE DELTA (COINFECCION), CON COMA HEPATICO"
      },
      {
        "codigo": "B161",
        "valor": "HEPATITIS AGUDA TIPO B, CON AGENTE DELTA (COINFECCION), SIN COMA HEPATICO"
      },
      {
        "codigo": "B162",
        "valor": "HEPATITIS AGUDA TIPO B, SIN AGENTE DELTA, CON COMA HEPATICO"
      },
      {
        "codigo": "B169",
        "valor": "HEPATITIS AGUDA TIPO B, SIN AGENTE DELTA Y SIN COMA HEPATICO"
      }
    ]
  },
  {
    "grupo": "B17 - OTRAS HEPATITIS VIRALES AGUDAS",
    "detalle": [
      {
        "codigo": "B170",
        "valor": "INFECCION (SUPERINFECCION) AGUDA POR AGENTE DELTA EN LA HEPATITIS B CRONICA"
      },
      {
        "codigo": "B171",
        "valor": "HEPATITIS AGUDA TIPO C"
      },
      {
        "codigo": "B172",
        "valor": "HEPATITIS AGUDA TIPO E"
      },
      {
        "codigo": "B178",
        "valor": "OTRAS HEPATITIS VIRALES AGUDAS ESPECIFICADAS"
      },
      {
        "codigo": "B179",
        "valor": "HEPATITIS VIRAL AGUDA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B18 - HEPATITIS VIRAL CRONICA",
    "detalle": [
      {
        "codigo": "B180",
        "valor": "HEPATITIS VIRAL TIPO B CRONICA, CON AGENTE DELTA"
      },
      {
        "codigo": "B181",
        "valor": "HEPATITIS VIRAL TIPO B CRONICA, SIN AGENTE DELTA"
      },
      {
        "codigo": "B182",
        "valor": "HEPATITIS VIRAL TIPO C CRONICA"
      },
      {
        "codigo": "B188",
        "valor": "OTRAS HEPATITIS VIRALES CRONICAS"
      },
      {
        "codigo": "B189",
        "valor": "HEPATITIS VIRAL CRONICA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "B19 - HEPATITIS VIRAL, SIN OTRA ESPECIFICACION",
    "detalle": [
      {
        "codigo": "B190",
        "valor": "HEPATITIS VIRAL NO ESPECIFICADA CON COMA HEPATICO"
      },
      {
        "codigo": "B199",
        "valor": "HEPATITIS VIRAL NO ESPECIFICADA SIN COMA HEPATICO"
      }
    ]
  },
  {
    "grupo": "B20 - ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH], RESULTANTE EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS",
    "detalle": [
      {
        "codigo": "B200",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN INFECCION POR MICOBACTERIAS"
      },
      {
        "codigo": "B201",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN OTRAS INFECCIONES BACTERIANAS"
      },
      {
        "codigo": "B202",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN ENFERMEDAD POR CITOMEGALOVIRUS"
      },
      {
        "codigo": "B203",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN OTRAS INFECCIONES VIRALES"
      },
      {
        "codigo": "B204",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN CANDIDIASIS"
      },
      {
        "codigo": "B205",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN OTRAS MICOSIS"
      },
      {
        "codigo": "B206",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN NEUMONIA POR PNEUMOCYSTIS CARINII"
      },
      {
        "codigo": "B207",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN INFECCIONES MULTIPLES"
      },
      {
        "codigo": "B208",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN OTRAS ENFERMEDADES INFECCIOSAS O PARASITARIAS"
      },
      {
        "codigo": "B209",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN ENFERMEDAD INFECCIOSA O PARASITARIA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B21 - ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH], RESULTANTE EN TUMORES MALIGNOS",
    "detalle": [
      {
        "codigo": "B210",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN SARCOMA DE KAPOSI"
      },
      {
        "codigo": "B211",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN LINFOMA DE BURKITT"
      },
      {
        "codigo": "B212",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN OTROS TIPOS DE LINFOMA NO HODGKIN"
      },
      {
        "codigo": "B213",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN OTROS TUMORES MALIGNOS DEL TEJIDO LINFOIDE, HEMATOPOYETICO Y TEJIDOS RELACIONADOS"
      },
      {
        "codigo": "B217",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN TUMORES MALIGNOS MULTIPLES"
      },
      {
        "codigo": "B218",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN OTROS TUMORES MALIGNOS"
      },
      {
        "codigo": "B219",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN TUMORES MALIGNOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "B22 - ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH], RESULTANTE EN OTRAS ENFERMEDADES ESPECIFICAS",
    "detalle": [
      {
        "codigo": "B220",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN ENCEFALOPATIA"
      },
      {
        "codigo": "B221",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN NEUMONITIS LINFOIDE INTERSTICIAL"
      },
      {
        "codigo": "B222",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN SINDROME CAQUECTICO"
      },
      {
        "codigo": "B227",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN ENFERMEDADES MULTIPLES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "B23 - ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH], RESULTANTE EN OTRAS AFECCIONES",
    "detalle": [
      {
        "codigo": "B230",
        "valor": "SINDROME DE INFECCION AGUDA DEBIDA A VIH"
      },
      {
        "codigo": "B231",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN LINFADENOPATIA GENERALIZADA (PERSISTENTE)"
      },
      {
        "codigo": "B232",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN ANORMALIDADES INMUNOLOGICAS Y HEMATOLOGICAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "B238",
        "valor": "ENFERMEDAD POR VIH, RESULTANTE EN OTRAS AFECCIONES ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "B24 - ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH], SIN OTRA ESPECIFICACION",
    "detalle": [
      {
        "codigo": "B24X",
        "valor": "SIDA"
      }
    ]
  },
  {
    "grupo": "B25 - ENFERMEDAD DEBIDA A VIRUS CITOMEGALICO",
    "detalle": [
      {
        "codigo": "B250",
        "valor": "NEUMONITIS DEBIDA A VIRUS CITOMEGALICO"
      },
      {
        "codigo": "B251",
        "valor": "HEPATITIS DEBIDA A VIRUS CITOMEGALICO"
      },
      {
        "codigo": "B252",
        "valor": "PANCREATITIS DEBIDA A VIRUS CITOMEGALICO"
      },
      {
        "codigo": "B258",
        "valor": "OTRAS ENFERMEDADES DEBIDAS A VIRUS CITOMEGALICO"
      },
      {
        "codigo": "B259",
        "valor": "ENFERMEDAD POR VIRUS CITOMEGALICO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B26 - PAROTIDITIS INFECCIOSA",
    "detalle": [
      {
        "codigo": "B260",
        "valor": "ORQUITIS POR PAROTIDITIS"
      },
      {
        "codigo": "B261",
        "valor": "MENINGITIS POR PAROTIDITIS"
      },
      {
        "codigo": "B262",
        "valor": "ENCEFALITIS POR PAROTIDITIS"
      },
      {
        "codigo": "B263",
        "valor": "PANCREATITIS POR PAROTIDITIS"
      },
      {
        "codigo": "B268",
        "valor": "PAROTIDITIS INFECCIOSA CON OTRAS COMPLICACIONES"
      },
      {
        "codigo": "B269",
        "valor": "PAROTIDITIS, SIN COMPLICACIONES"
      }
    ]
  },
  {
    "grupo": "B27 - MONONUCLEOSIS INFECCIOSA",
    "detalle": [
      {
        "codigo": "B270",
        "valor": "MONONUCLEOSIS DEBIDA A HERPES VIRUS GAMMA"
      },
      {
        "codigo": "B271",
        "valor": "MONONUCLEOSIS POR CITOMEGALOVIRUS"
      },
      {
        "codigo": "B278",
        "valor": "OTRAS MONONUCLEOSIS INFECCIOSAS"
      },
      {
        "codigo": "B279",
        "valor": "MONONUCLEOSIS INFECCIOSA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B30 - CONJUNTIVITIS VIRAL",
    "detalle": [
      {
        "codigo": "B300",
        "valor": "QUERATOCONJUNTIVITIS DEBIDA A ADENOVIRUS"
      },
      {
        "codigo": "B301",
        "valor": "CONJUNTIVITIS DEBIDA A ADENOVIRUS"
      },
      {
        "codigo": "B302",
        "valor": "FARINGOCONJUNTIVITIS VIRAL"
      },
      {
        "codigo": "B303",
        "valor": "CONJUNTIVITIS EPIDEMICA AGUDA HEMORRAGICA (ENTEROVIRICA)"
      },
      {
        "codigo": "B308",
        "valor": "OTRAS CONJUNTIVITIS VIRALES"
      },
      {
        "codigo": "B309",
        "valor": "CONJUNTIVITIS VIRAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "B33 - OTRAS ENFERMEDADES VIRALES, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "B330",
        "valor": "MIALGIA EPIDEMICA"
      },
      {
        "codigo": "B331",
        "valor": "ENFERMEDAD DEL RIO ROSS"
      },
      {
        "codigo": "B332",
        "valor": "CARDITIS VIRAL"
      },
      {
        "codigo": "B333",
        "valor": "INFECCIONES DEBIDAS A RETROVIRUS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "B334",
        "valor": "SINDROME (CARDIO) PULMONAR POR HANTAVIRUS [SPH] [SCPH] (J17.1*)"
      },
      {
        "codigo": "B338",
        "valor": "OTRAS ENFERMEDADES VIRALES ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "B34 - INFECCION VIRAL DE SITIO NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "B340",
        "valor": "INFECCION DEBIDA A ADENOVIRUS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B341",
        "valor": "INFECCION DEBIDA A ENTEROVIRUS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B342",
        "valor": "INFECCION DEBIDA A CORONAVIRUS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B343",
        "valor": "INFECCION DEBIDA A PARVOVIRUS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B344",
        "valor": "INFECCION DEBIDA A PAPOVAVIRUS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B348",
        "valor": "OTRAS INFECCIONES VIRALES DE SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "B349",
        "valor": "INFECCION VIRAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B35 - DERMATOFITOSIS",
    "detalle": [
      {
        "codigo": "B350",
        "valor": "TIÑA DE LA BARBA Y DEL CUERO CABELLUDO"
      },
      {
        "codigo": "B351",
        "valor": "TIÑA DE LAS UÑAS"
      },
      {
        "codigo": "B352",
        "valor": "TIÑA DE LA MANO"
      },
      {
        "codigo": "B353",
        "valor": "TIÑA DEL PIE [TINEA PEDIS]"
      },
      {
        "codigo": "B354",
        "valor": "TIÑA DEL CUERPO [TINEA CORPORIS]"
      },
      {
        "codigo": "B355",
        "valor": "TIÑA IMBRICADA [TINEA IMBRICATA]"
      },
      {
        "codigo": "B356",
        "valor": "TIÑA INGUINAL [TINEA CRURIS]"
      },
      {
        "codigo": "B358",
        "valor": "OTRAS DERMATOFITOSIS"
      },
      {
        "codigo": "B359",
        "valor": "DERMATOFITOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B36 - OTRAS MICOSIS SUPERFICIALES",
    "detalle": [
      {
        "codigo": "B360",
        "valor": "PITIRIASIS VERSICOLOR"
      },
      {
        "codigo": "B361",
        "valor": "TIÑA NEGRA"
      },
      {
        "codigo": "B362",
        "valor": "PIEDRA BLANCA"
      },
      {
        "codigo": "B363",
        "valor": "PIEDRA NEGRA"
      },
      {
        "codigo": "B368",
        "valor": "OTRAS MICOSIS SUPERFICIALES ESPECIFICADAS"
      },
      {
        "codigo": "B369",
        "valor": "MICOSIS SUPERFICIAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "B37 - CANDIDIASIS",
    "detalle": [
      {
        "codigo": "B370",
        "valor": "ESTOMATITIS CANDIDIASICA"
      },
      {
        "codigo": "B3700",
        "valor": "ESTOMATITIS CANDIDIASICA PSEUDOMEMBRANOSA AGUDA"
      },
      {
        "codigo": "B3701",
        "valor": "ESTOMATITIS CANDIDIASICA ERITEMATOSA (ATROFICA) AGUDA"
      },
      {
        "codigo": "B3702",
        "valor": "ESTOMATITIS CANDIDIASICA HIPERPLASICA CRONICA"
      },
      {
        "codigo": "B3703",
        "valor": "ESTOMATITIS CANDIDIASICA ERITEMATOSA (ATROFICA) CRONICA"
      },
      {
        "codigo": "B3704",
        "valor": "CANDIDIASIS MUCOCUTANEA"
      },
      {
        "codigo": "B3705",
        "valor": "GRANULOMA CANDIDIASICO BUCAL"
      },
      {
        "codigo": "B3706",
        "valor": "QUEILITIS ANGULAR"
      },
      {
        "codigo": "B3708",
        "valor": "OTRAS MANIFESTACIONES BUCALES ESPECIFICADAS"
      },
      {
        "codigo": "B3709",
        "valor": "MANIFESTACIONES BUCALES, NO ESPECIFICADAS"
      },
      {
        "codigo": "B371",
        "valor": "CANDIDIASIS PULMONAR"
      },
      {
        "codigo": "B372",
        "valor": "CANDIDIASIS DE LA PIEL Y LAS UÑAS"
      },
      {
        "codigo": "B373",
        "valor": "CANDIDIASIS DE LA VULVA Y DE LA VAGINA"
      },
      {
        "codigo": "B374",
        "valor": "CANDIDIASIS DE OTRAS LOCALIZACIONES UROGENITALES"
      },
      {
        "codigo": "B375",
        "valor": "MENINGITIS DEBIDA A CANDIDA"
      },
      {
        "codigo": "B376",
        "valor": "ENDOCARDITIS DEBIDA A CANDIDA"
      },
      {
        "codigo": "B377",
        "valor": "SEPSIS DEBIDA A CANDIDA"
      },
      {
        "codigo": "B378",
        "valor": "CANDIDIASIS DE OTROS SITIOS"
      },
      {
        "codigo": "B379",
        "valor": "CANDIDIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B38 - COCCIDIOIDOMICOSIS",
    "detalle": [
      {
        "codigo": "B380",
        "valor": "COCCIDIOIDOMICOSIS PULMONAR AGUDA"
      },
      {
        "codigo": "B381",
        "valor": "COCCIDIOIDOMICOSIS PULMONAR CRONICA"
      },
      {
        "codigo": "B382",
        "valor": "COCCIDIOIDOMICOSIS PULMONAR, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B383",
        "valor": "COCCIDIOIDOMICOSIS CUTANEA"
      },
      {
        "codigo": "B384",
        "valor": "MENINGITIS DEBIDA A COCCIDIOIDOMICOSIS"
      },
      {
        "codigo": "B387",
        "valor": "COCCIDIOIDOMICOSIS DISEMINADA"
      },
      {
        "codigo": "B388",
        "valor": "OTRAS FORMAS DE COCCIDIOIDOMICOSIS"
      },
      {
        "codigo": "B389",
        "valor": "COCCIDIOIDOMICOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B39 - HISTOPLASMOSIS",
    "detalle": [
      {
        "codigo": "B390",
        "valor": "INFECCION PULMONAR AGUDA DEBIDA A HISTOPLASMA CAPSULATUM"
      },
      {
        "codigo": "B391",
        "valor": "INFECCION PULMONAR CRONICA DEBIDA A HISTOPLASMA CAPSULATUM"
      },
      {
        "codigo": "B392",
        "valor": "INFECCION PULMONAR DEBIDA A HISTOPLASMA CAPSULATUM, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B393",
        "valor": "INFECCION DISEMINADA DEBIDA A HISTOPLASMA CAPSULATUM"
      },
      {
        "codigo": "B394",
        "valor": "HISTOPLASMOSIS DEBIDA A HISTOPLASMA CAPSULATUM, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B395",
        "valor": "INFECCION DEBIDA A HISTOPLASMA DUBOISII"
      },
      {
        "codigo": "B399",
        "valor": "HISTOPLASMOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B40 - BLASTOMICOSIS",
    "detalle": [
      {
        "codigo": "B400",
        "valor": "BLASTOMICOSIS PULMONAR AGUDA"
      },
      {
        "codigo": "B401",
        "valor": "BLASTOMICOSIS PULMONAR CRONICA"
      },
      {
        "codigo": "B402",
        "valor": "BLASTOMICOSIS PULMONAR, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B403",
        "valor": "BLASTOMICOSIS CUTANEA"
      },
      {
        "codigo": "B407",
        "valor": "BLASTOMICOSIS DISEMINADA"
      },
      {
        "codigo": "B408",
        "valor": "OTRAS FORMAS DE BLASTOMICOSIS"
      },
      {
        "codigo": "B409",
        "valor": "BLASTOMICOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B41 - PARACOCCIDIOIDOMICOSIS",
    "detalle": [
      {
        "codigo": "B410",
        "valor": "PARACOCCIDIOIDOMICOSIS PULMONAR"
      },
      {
        "codigo": "B417",
        "valor": "PARACOCCIDIOIDOMICOSIS DISEMINADA"
      },
      {
        "codigo": "B418",
        "valor": "OTRAS FORMAS DE PARACOCCIDIOIDOMICOSIS"
      },
      {
        "codigo": "B419",
        "valor": "PARACOCCIDIOIDOMICOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B42 - ESPOROTRICOSIS",
    "detalle": [
      {
        "codigo": "B420",
        "valor": "ESPOROTRICOSIS PULMONAR"
      },
      {
        "codigo": "B421",
        "valor": "ESPOROTRICOSIS LINFOCUTANEA"
      },
      {
        "codigo": "B427",
        "valor": "ESPOROTRICOSIS DISEMINADA"
      },
      {
        "codigo": "B428",
        "valor": "OTRAS FORMAS DE ESPOROTRICOSIS"
      },
      {
        "codigo": "B429",
        "valor": "ESPOROTRICOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B43 - CROMOMICOSIS Y ABSCESO FEOMICOTICO",
    "detalle": [
      {
        "codigo": "B430",
        "valor": "CROMOMICOSIS CUTANEA"
      },
      {
        "codigo": "B431",
        "valor": "ABSCESO CEREBRAL FEOMICOTICO"
      },
      {
        "codigo": "B432",
        "valor": "ABSCESO Y QUISTE SUBCUTANEO FEOMICOTICO"
      },
      {
        "codigo": "B438",
        "valor": "OTRAS FORMAS DE CROMOMICOSIS"
      },
      {
        "codigo": "B439",
        "valor": "CROMOMICOSIS,NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B44 - ASPERGILOSIS",
    "detalle": [
      {
        "codigo": "B440",
        "valor": "ASPERGILOSIS PULMONAR INVASIVA"
      },
      {
        "codigo": "B441",
        "valor": "OTRAS ASPERGILOSIS PULMONARES"
      },
      {
        "codigo": "B442",
        "valor": "ASPERGILOSIS AMIGDALINA"
      },
      {
        "codigo": "B447",
        "valor": "ASPERGILOSIS DISEMINADA"
      },
      {
        "codigo": "B448",
        "valor": "OTRAS FORMAS DE ASPERGILOSIS"
      },
      {
        "codigo": "B449",
        "valor": "ASPERGILOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B45 - CRIPTOCOCOSIS",
    "detalle": [
      {
        "codigo": "B450",
        "valor": "CRIPTOCOCOSIS PULMONAR"
      },
      {
        "codigo": "B451",
        "valor": "CRIPTOCOCOSIS CEREBRAL"
      },
      {
        "codigo": "B452",
        "valor": "CRIPTOCOCOSIS CUTANEA"
      },
      {
        "codigo": "B453",
        "valor": "CRIPTOCOCOSIS OSEA"
      },
      {
        "codigo": "B457",
        "valor": "CRIPTOCOCOSIS DISEMINADA"
      },
      {
        "codigo": "B458",
        "valor": "OTRAS FORMAS DE CRIPTOCOCOSIS"
      },
      {
        "codigo": "B459",
        "valor": "CRIPTOCOCOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B46 - CIGOMICOSIS",
    "detalle": [
      {
        "codigo": "B460",
        "valor": "MUCORMICOSIS PULMONAR"
      },
      {
        "codigo": "B461",
        "valor": "MUCORMICOSIS RINOCEREBRAL"
      },
      {
        "codigo": "B462",
        "valor": "MUCORMICOSIS GASTROINTESTINAL"
      },
      {
        "codigo": "B463",
        "valor": "MUCORMICOSIS CUTANEA"
      },
      {
        "codigo": "B464",
        "valor": "MUCORMICOSIS DISEMINADA"
      },
      {
        "codigo": "B465",
        "valor": "MUCORMICOSIS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B468",
        "valor": "OTRAS CIGOMICOSIS"
      },
      {
        "codigo": "B469",
        "valor": "CIGOMICOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B47 - MICETOMA",
    "detalle": [
      {
        "codigo": "B470",
        "valor": "EUMICETOMA"
      },
      {
        "codigo": "B471",
        "valor": "ACTINOMICETOMA"
      },
      {
        "codigo": "B479",
        "valor": "MICETOMA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "B48 - OTRAS MICOSIS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "B480",
        "valor": "LOBOMICOSIS"
      },
      {
        "codigo": "B481",
        "valor": "RINOSPORIDIOSIS"
      },
      {
        "codigo": "B482",
        "valor": "ALESQUERIASIS"
      },
      {
        "codigo": "B483",
        "valor": "GEOTRICOSIS"
      },
      {
        "codigo": "B484",
        "valor": "PENICILOSIS"
      },
      {
        "codigo": "B487",
        "valor": "MICOSIS OPORTUNISTAS"
      },
      {
        "codigo": "B488",
        "valor": "OTRAS MICOSIS ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "B49 - MICOSIS, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "B49X",
        "valor": "MICOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B50 - PALUDISMO [MALARIA] DEBIDO A PLASMODIUM FALCIPARUM",
    "detalle": [
      {
        "codigo": "B500",
        "valor": "PALUDISMO DEBIDO A PLASMODIUM FALCIPARUM CON COMPLICACIONES CEREBRALES"
      },
      {
        "codigo": "B508",
        "valor": "OTRO PALUDISMO GRAVE Y COMPLICADO DEBIDO A PLASMODIUM FALCIPARUM"
      },
      {
        "codigo": "B509",
        "valor": "PALUDISMO DEBIDO A PLASMODIUM FALCIPARUM, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "B51 - PALUDISMO [MALARIA] DEBIDO A PLASMODIUM VIVAX",
    "detalle": [
      {
        "codigo": "B510",
        "valor": "PALUDISMO DEBIDO A PLASMODIUM VIVAX CON RUPTURA ESPLENICA"
      },
      {
        "codigo": "B518",
        "valor": "PALUDISMO DEBIDO A PLASMODIUM VIVAX CON OTRAS COMPLICACIONES"
      },
      {
        "codigo": "B519",
        "valor": "PALUDISMO DEBIDO A PLASMODIUM VIVAX, SIN COMPLICACIONES"
      }
    ]
  },
  {
    "grupo": "B52 - PALUDISMO [MALARIA] DEBIDO A PLASMODIUM MALARIAE",
    "detalle": [
      {
        "codigo": "B520",
        "valor": "PALUDISMO DEBIDO A PLASMODIUM MALARIAE CON NEFROPATIA"
      },
      {
        "codigo": "B528",
        "valor": "PALUDISMO DEBIDO A PLASMODIUM MALARIAE CON OTRAS COMPLICACIONES"
      },
      {
        "codigo": "B529",
        "valor": "PALUDISMO DEBIDO A PLASMODIUM MALARIAE, SIN COMPLICACIONES"
      }
    ]
  },
  {
    "grupo": "B53 - OTRO PALUDISMO [MALARIA] CONFIRMADO PARASITOLOGICAMENTE",
    "detalle": [
      {
        "codigo": "B530",
        "valor": "PALUDISMO DEBIDO A PLASMODIUM OVALE"
      },
      {
        "codigo": "B531",
        "valor": "PALUDISMO DEBIDO A PLASMODIOS DE LOS SIMIOS"
      },
      {
        "codigo": "B538",
        "valor": "OTRO PALUDISMO CONFIRMADO PARASITOLOGICAMENTE, NO CLASIFICADO EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "B54 - PALUDISMO [MALARIA] NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "B54X",
        "valor": "PALUDISMO [MALARIA] NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "B55 - LEISHMANIASIS",
    "detalle": [
      {
        "codigo": "B550",
        "valor": "LEISHMANIASIS VISCERAL"
      },
      {
        "codigo": "B551",
        "valor": "LEISHMANIASIS CUTANEA"
      },
      {
        "codigo": "B552",
        "valor": "LEISHMANIASIS MUCOCUTANEA"
      },
      {
        "codigo": "B559",
        "valor": "LEISHMANIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B56 - TRIPANOSOMIASIS AFRICANA",
    "detalle": [
      {
        "codigo": "B560",
        "valor": "TRIPANOSOMIASIS GAMBIENSE"
      },
      {
        "codigo": "B561",
        "valor": "TRIPANOSOMIASIS RHODESIENSE"
      },
      {
        "codigo": "B569",
        "valor": "TRIPANOSOMIASIS AFRICANA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "B57 - ENFERMEDAD DE CHAGAS",
    "detalle": [
      {
        "codigo": "B570",
        "valor": "ENFERMEDAD DE CHAGAS AGUDA QUE AFECTA AL CORAZON"
      },
      {
        "codigo": "B571",
        "valor": "ENFERMEDAD DE CHAGAS AGUDA QUE NO AFECTA AL CORAZON"
      },
      {
        "codigo": "B572",
        "valor": "ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA AL CORAZON"
      },
      {
        "codigo": "B5721",
        "valor": "ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA AL CORAZON INCIPIENTE"
      },
      {
        "codigo": "B5722",
        "valor": "ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA AL CORAZON SINTOMATICO"
      },
      {
        "codigo": "B573",
        "valor": "ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA AL SISTEMA DIGESTIVO"
      },
      {
        "codigo": "B5731",
        "valor": "ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA AL SISTEMA DIGESTIVO INCIPIENTE"
      },
      {
        "codigo": "B5732",
        "valor": "ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA AL SISTEMA DIGESTIVO SINTOMATICO"
      },
      {
        "codigo": "B574",
        "valor": "ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA AL SISTEMA NERVIOSO"
      },
      {
        "codigo": "B575",
        "valor": "ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA OTROS ORGANOS"
      },
      {
        "codigo": "B576",
        "valor": "ENFERMEDAD DE CHAGAS CONGENITO"
      },
      {
        "codigo": "B579",
        "valor": "ENFERMEDAD DE CHAGAS (CRONICA) INDETERMINADO"
      }
    ]
  },
  {
    "grupo": "B58 - TOXOPLASMOSIS",
    "detalle": [
      {
        "codigo": "B580",
        "valor": "OCULOPATIA DEBIDA A TOXOPLASMA"
      },
      {
        "codigo": "B581",
        "valor": "HEPATITIS DEBIDA A TOXOPLASMA"
      },
      {
        "codigo": "B582",
        "valor": "MENINGOENCEFALITIS DEBIDA A TOXOPLASMA"
      },
      {
        "codigo": "B583",
        "valor": "TOXOPLASMOSIS PULMONAR"
      },
      {
        "codigo": "B588",
        "valor": "TOXOPLASMOSIS CON OTRO ORGANO AFECTADO"
      },
      {
        "codigo": "B589",
        "valor": "TOXOPLASMOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B59 - NEUMOCISTOSIS",
    "detalle": [
      {
        "codigo": "B59X",
        "valor": "NEUMONIA POR NEUMOCYSTIS CARINI"
      }
    ]
  },
  {
    "grupo": "B60 - OTRAS ENFERMEDADES DEBIDAS A PROTOZOARIOS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "B600",
        "valor": "BABESIOSIS"
      },
      {
        "codigo": "B601",
        "valor": "ACANTAMEBIASIS"
      },
      {
        "codigo": "B602",
        "valor": "NAEGLERIASIS"
      },
      {
        "codigo": "B608",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DEBIDAS A PROTOZOARIOS"
      }
    ]
  },
  {
    "grupo": "B64 - ENFERMEDAD DEBIDA A PROTOZOARIOS, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "B64X",
        "valor": "ENFERMEDAD DEBIDA A PROTOZOARIOS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B65 - ESQUISTOSOMIASIS [BILHARZIASIS]",
    "detalle": [
      {
        "codigo": "B650",
        "valor": "ESQUISTOSOMIASIS DEBIDA A SCHISTOSOMA HAEMATOBIUM (ESQUISTOSOMIASIS URINARIA)"
      },
      {
        "codigo": "B651",
        "valor": "ESQUISTOSOMIASIS DEBIDA A SCHISTOSOMA MANSONI [ESQUISTOSOMIASIS INTESTINAL]"
      },
      {
        "codigo": "B652",
        "valor": "ESQUISTOSOMIASIS DEBIDA A SCHISTOSOMA JAPONICUM"
      },
      {
        "codigo": "B653",
        "valor": "DERMATITIS POR CERCARIAS"
      },
      {
        "codigo": "B658",
        "valor": "OTRAS ESQUISTOSOMIASIS"
      },
      {
        "codigo": "B659",
        "valor": "ESQUISTOSOMIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B66 - OTRAS INFECCIONES DEBIDAS A TREMATODOS",
    "detalle": [
      {
        "codigo": "B660",
        "valor": "OPISTORQUIASIS"
      },
      {
        "codigo": "B661",
        "valor": "CLONORQUIASIS"
      },
      {
        "codigo": "B662",
        "valor": "DICROCOELIASIS"
      },
      {
        "codigo": "B663",
        "valor": "FASCIOLIASIS"
      },
      {
        "codigo": "B664",
        "valor": "PARAGONIMIASIS"
      },
      {
        "codigo": "B665",
        "valor": "FASCIOLOPSIASIS"
      },
      {
        "codigo": "B668",
        "valor": "OTRAS INFECCIONES ESPECIFICADAS DEBIDAS A TREMATODOS"
      },
      {
        "codigo": "B669",
        "valor": "INFECCION DEBIDA A TREMATODOS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B67 - EQUINOCOCOSIS",
    "detalle": [
      {
        "codigo": "B670",
        "valor": "INFECCION DEL HIGADO DEBIDA A ECHINOCOCCUS GRANULOSUS"
      },
      {
        "codigo": "B671",
        "valor": "INFECCION DEL PULMON DEBIDA A ECHINOCOCCUS GRANULOSUS"
      },
      {
        "codigo": "B672",
        "valor": "INFECCION DE HUESO DEBIDA A ECHINOCOCCUS GRANULOSUS"
      },
      {
        "codigo": "B673",
        "valor": "INFECCION DE OTRO ORGANO Y DE SITIOS MULTIPLES DEBIDA A ECHINOCOCCUS GRANULOSUS"
      },
      {
        "codigo": "B674",
        "valor": "INFECCION DEBIDA A ECHINOCOCCUS GRANULOSUS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B675",
        "valor": "INFECCION DEL HIGADO DEBIDA A ECHINOCOCCUS MULTILOCULARIS"
      },
      {
        "codigo": "B676",
        "valor": "INFECCION DE OTRO ORGANO Y DE SITIOS MULTIPLES DEBIDA A ECHINOCOCCUS MULTILOCULARIS"
      },
      {
        "codigo": "B677",
        "valor": "INFECCION DEBIDA A ECHINOCOCCUS MULTILOCULARIS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B678",
        "valor": "EQUINOCOCOSIS DEL HIGADO, NO ESPECIFICADA"
      },
      {
        "codigo": "B679",
        "valor": "EQUINOCOCOSIS, OTRA Y LA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B68 - TENIASIS",
    "detalle": [
      {
        "codigo": "B680",
        "valor": "TENIASIS DEBIDA A TAENIA SOLIUM"
      },
      {
        "codigo": "B681",
        "valor": "INFECCION DEBIDA A TAENIA SAGINATA"
      },
      {
        "codigo": "B689",
        "valor": "TENIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B69 - CISTICERCOSIS",
    "detalle": [
      {
        "codigo": "B690",
        "valor": "CISTICERCOSIS DEL SISTEMA NERVIOSO CENTRAL"
      },
      {
        "codigo": "B691",
        "valor": "CISTICERCOSIS DEL OJO"
      },
      {
        "codigo": "B698",
        "valor": "CISTICERCOSIS DE OTROS SITIOS"
      },
      {
        "codigo": "B699",
        "valor": "CISTICERCOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B70 - DIFILOBOTRIASIS Y ESPARGANOSIS",
    "detalle": [
      {
        "codigo": "B700",
        "valor": "DIFILOBOTRIASIS INTESTINAL"
      },
      {
        "codigo": "B701",
        "valor": "ESPARGANOSIS"
      }
    ]
  },
  {
    "grupo": "B71 - OTRAS INFECCIONES DEBIDAS A CESTODOS",
    "detalle": [
      {
        "codigo": "B710",
        "valor": "HIMENOLEPIASIS"
      },
      {
        "codigo": "B711",
        "valor": "DIPILIDIASIS"
      },
      {
        "codigo": "B718",
        "valor": "OTRAS INFECCIONES DEBIDAS A CESTODOS ESPECIFICADAS"
      },
      {
        "codigo": "B719",
        "valor": "INFECCIONES DEBIDAS A CESTODOS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B72 - DRACONTIASIS",
    "detalle": [
      {
        "codigo": "B72X",
        "valor": "DRACONTIASIS"
      }
    ]
  },
  {
    "grupo": "B73 - ONCOCERCOSIS",
    "detalle": [
      {
        "codigo": "B73X",
        "valor": "ONCOCERCOSIS"
      }
    ]
  },
  {
    "grupo": "B74 - FILARIASIS",
    "detalle": [
      {
        "codigo": "B740",
        "valor": "FILARIASIS DEBIDA A WUCHERERIA BANCROFTI"
      },
      {
        "codigo": "B741",
        "valor": "FILARIASIS DEBIDA A BRUGIA MALAYI"
      },
      {
        "codigo": "B742",
        "valor": "FILARIASIS DEBIDA A BRUGIA TIMORI"
      },
      {
        "codigo": "B743",
        "valor": "LOAIASIS"
      },
      {
        "codigo": "B744",
        "valor": "MANSONELIASIS"
      },
      {
        "codigo": "B748",
        "valor": "OTRAS FILARIASIS"
      },
      {
        "codigo": "B749",
        "valor": "FILARIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B75 - TRIQUINOSIS",
    "detalle": [
      {
        "codigo": "B75X",
        "valor": "TRIQUINOSIS"
      }
    ]
  },
  {
    "grupo": "B76 - ANQUILOSTOMIASIS Y NECATORIASIS",
    "detalle": [
      {
        "codigo": "B760",
        "valor": "ANQUILOSTOMIASIS"
      },
      {
        "codigo": "B761",
        "valor": "NECATORIASIS"
      },
      {
        "codigo": "B768",
        "valor": "OTRAS ENFERMEDADES DEBIDAS A ANQUILOSTOMAS"
      },
      {
        "codigo": "B769",
        "valor": "ENFERMEDAD DEBIDA A ANQUILOSTOMAS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B77 - ASCARIASIS",
    "detalle": [
      {
        "codigo": "B770",
        "valor": "ASCARIASIS CON COMPLICACIONES INTESTINALES"
      },
      {
        "codigo": "B778",
        "valor": "ASCARIASIS CON OTRAS COMPLICACIONES"
      },
      {
        "codigo": "B779",
        "valor": "ASCARIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B78 - ESTRONGILOIDIASIS",
    "detalle": [
      {
        "codigo": "B780",
        "valor": "ESTRONGILOIDIASIS INTESTINAL"
      },
      {
        "codigo": "B781",
        "valor": "ESTRONGILOIDIASIS CUTANEA"
      },
      {
        "codigo": "B787",
        "valor": "ESTRONGILOIDIASIS DISEMINADA"
      },
      {
        "codigo": "B789",
        "valor": "ESTRONGILOIDIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B79 - TRICURIASIS",
    "detalle": [
      {
        "codigo": "B79X",
        "valor": "TRICURIASIS"
      }
    ]
  },
  {
    "grupo": "B80 - ENTEROBIASIS",
    "detalle": [
      {
        "codigo": "B80X",
        "valor": "ENTEROBIASIS"
      }
    ]
  },
  {
    "grupo": "B81 - OTRAS HELMINTIASIS INTESTINALES, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "B810",
        "valor": "ANISAQUIASIS"
      },
      {
        "codigo": "B811",
        "valor": "CAPILARIASIS INTESTINAL"
      },
      {
        "codigo": "B812",
        "valor": "TRICOESTRONGILIASIS"
      },
      {
        "codigo": "B813",
        "valor": "ANGIOESTRONGILIASIS INTESTINAL"
      },
      {
        "codigo": "B814",
        "valor": "HELMINTIASIS INTESTINAL MIXTA"
      },
      {
        "codigo": "B818",
        "valor": "OTRAS HELMINTIASIS INTESTINALES ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "B82 - PARASITOSIS INTESTINALES, SIN OTRA ESPECIFICACION",
    "detalle": [
      {
        "codigo": "B820",
        "valor": "HELMINTIASIS INTESTINAL, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B829",
        "valor": "PARASITOSIS INTESTINAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "B83 - OTRAS HELMINTIASIS",
    "detalle": [
      {
        "codigo": "B830",
        "valor": "LARVA MIGRANS VISCERAL"
      },
      {
        "codigo": "B831",
        "valor": "GNATOSTOMIASIS"
      },
      {
        "codigo": "B832",
        "valor": "ANGIOESTRONGILIASIS DEBIDA A PARASTRONGYLUS CANTONENSIS"
      },
      {
        "codigo": "B833",
        "valor": "SINGAMIASIS"
      },
      {
        "codigo": "B834",
        "valor": "HIRUDINIASIS INTERNA"
      },
      {
        "codigo": "B838",
        "valor": "OTRAS HELMINTIASIS ESPECIFICADAS"
      },
      {
        "codigo": "B839",
        "valor": "HELMINTIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B85 - PEDICULOSIS Y PHTHIRIASIS",
    "detalle": [
      {
        "codigo": "B850",
        "valor": "PEDICULOSIS DEBIDA A PEDICULUS HUMANUS CAPITIS"
      },
      {
        "codigo": "B851",
        "valor": "PEDICULOSIS DEBIDA A PEDICULUS HUMANUS CORPORIS"
      },
      {
        "codigo": "B852",
        "valor": "PEDICULOSIS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "B853",
        "valor": "PHTHIRIASIS"
      },
      {
        "codigo": "B854",
        "valor": "PEDICULOSIS Y PHTHIRIASIS MIXTAS"
      }
    ]
  },
  {
    "grupo": "B86 - ESCABIOSIS",
    "detalle": [
      {
        "codigo": "B86X",
        "valor": "ESCABIOSIS"
      }
    ]
  },
  {
    "grupo": "B87 - MIASIS",
    "detalle": [
      {
        "codigo": "B870",
        "valor": "MIASIS CUTANEA"
      },
      {
        "codigo": "B871",
        "valor": "MIASIS EN HERIDAS"
      },
      {
        "codigo": "B872",
        "valor": "MIASIS OCULAR"
      },
      {
        "codigo": "B873",
        "valor": "MIASIS NASOFARINGEA"
      },
      {
        "codigo": "B874",
        "valor": "MIASIS AURAL"
      },
      {
        "codigo": "B878",
        "valor": "MIASIS DE OTROS SITIOS"
      },
      {
        "codigo": "B879",
        "valor": "MIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B88 - OTRAS INFESTACIONES",
    "detalle": [
      {
        "codigo": "B880",
        "valor": "OTRAS ACARIASIS"
      },
      {
        "codigo": "B881",
        "valor": "TUNGIASIS [INFECCION DEBIDA A PULGA DE ARENA]"
      },
      {
        "codigo": "B882",
        "valor": "OTRAS INFESTACIONES DEBIDAS A ARTROPODOS"
      },
      {
        "codigo": "B883",
        "valor": "HIRUDINIASIS EXTERNA"
      },
      {
        "codigo": "B888",
        "valor": "OTRAS INFESTACIONES ESPECIFICADAS"
      },
      {
        "codigo": "B889",
        "valor": "INFESTACION, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B89 - ENFERMEDAD PARASITARIA, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "B89X",
        "valor": "ENFERMEDAD PARASITARIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B90 - SECUELAS DE TUBERCULOSIS",
    "detalle": [
      {
        "codigo": "B900",
        "valor": "SECUELAS DE TUBERCULOSIS DEL SISTEMA NERVIOSO CENTRAL"
      },
      {
        "codigo": "B901",
        "valor": "SECUELAS DE TUBERCULOSIS GENITOURINARIA"
      },
      {
        "codigo": "B902",
        "valor": "SECUELAS DE TUBERCULOSIS DE HUESOS Y ARTICULACIONES"
      },
      {
        "codigo": "B908",
        "valor": "SECUELAS DE TUBERCULOSIS DE OTROS ORGANOS ESPECIFICADOS"
      },
      {
        "codigo": "B909",
        "valor": "SECUELAS DE TUBERCULOSIS RESPIRATORIA Y DE TUBERCULOSIS NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "B91 - SECUELAS DE POLIOMIELITIS",
    "detalle": [
      {
        "codigo": "B91X",
        "valor": "SECUELAS DE POLIOMIELITIS"
      }
    ]
  },
  {
    "grupo": "B92 - SECUELAS DE LEPRA",
    "detalle": [
      {
        "codigo": "B92X",
        "valor": "SECUELAS DE LEPRA"
      }
    ]
  },
  {
    "grupo": "B94 - SECUELAS DE OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS Y DE LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "B940",
        "valor": "SECUELAS DE TRACOMA"
      },
      {
        "codigo": "B941",
        "valor": "SECUELAS DE ENCEFALITIS VIRAL"
      },
      {
        "codigo": "B942",
        "valor": "SECUELAS DE HEPATITIS VIRAL"
      },
      {
        "codigo": "B948",
        "valor": "SECUELAS DE OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS ESPECIFICADAS"
      },
      {
        "codigo": "B949",
        "valor": "SECUELAS DE ENFERMEDADES INFECCIOSAS Y PARASITARIAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "B95 - ESTREPTOCOCOS Y ESTAFILOCOCOS COMO CAUSA DE ENFERMEDADES CLASIFICADAS",
    "detalle": [
      {
        "codigo": "B950",
        "valor": "ESTREPTOCOCO, GRUPO A, COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B951",
        "valor": "ESTREPTOCOCO, GRUPO B, COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B952",
        "valor": "ESTREPTOCOCO, GRUPO D Y ENTEROCOCOS, COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B953",
        "valor": "STREPTOCOCCUS PNEUMONIAE COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B954",
        "valor": "OTROS ESTREPTOCOCOS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B955",
        "valor": "ESTREPTOCOCO NO ESPECIFICADO COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B956",
        "valor": "STAPHYLOCOCCUS AUREUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B957",
        "valor": "OTROS ESTAFILOCOCOS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B958",
        "valor": "ESTAFILOCOCO NO ESPECIFICADO, COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      }
    ]
  },
  {
    "grupo": "B96 - OTROS AGENTES BACTERIANOS ESPECIFICADOS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "detalle": [
      {
        "codigo": "B960",
        "valor": "MYCOPLASMA PNEUMONIAE [M. PNEUMONIAE] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B961",
        "valor": "KLEBSIELLA PNEUMONIAE [K. PNEUMONIAE] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B962",
        "valor": "ESCHERICHIA COLI [E. COLI] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B963",
        "valor": "HAEMOPHILUS INFLUENZAE [H. INFLUENZAE] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B964",
        "valor": "PROTEUS (MIRABILIS) (MORGANII) COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B965",
        "valor": "PSEUDOMONAS (AERUGINOSA) COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B966",
        "valor": "BACILLUS FRAGILIS [B. FRAGILIS] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B967",
        "valor": "CLOSTRIDIUM PERFRINGENS [C. PERFRINGENS] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B968",
        "valor": "OTROS AGENTES BACTERIANOS ESPECIFICADOS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      }
    ]
  },
  {
    "grupo": "B97 - AGENTES VIRALES COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITTULOS",
    "detalle": [
      {
        "codigo": "B970",
        "valor": "ADENOVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B971",
        "valor": "ENTEROVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B972",
        "valor": "CORONAVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B973",
        "valor": "RETROVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B974",
        "valor": "VIRUS SINCICIAL RESPIRATORIO COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B975",
        "valor": "REOVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B976",
        "valor": "PARVOVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B977",
        "valor": "PAPILOMAVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B978",
        "valor": "OTROS AGENTES VIRALES COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      }
    ]
  },
  {
    "grupo": "B98 - OTROS AGENTES INFECCIOSOS ESPECIFICADOS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "detalle": [
      {
        "codigo": "B980",
        "valor": "HELICOBACTER PYLORI [H.PYLORI] COMO LA CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      },
      {
        "codigo": "B981",
        "valor": "VIBRIO VULNIFICUS COMO LA CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS"
      }
    ]
  },
  {
    "grupo": "B99 - OTRAS ENFERMEDADES INFECCIOSAS Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "B99X",
        "valor": "OTRAS ENFERMEDADES INFECCIOSAS Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "C00 - TUMOR MALIGNO DEL LABIO",
    "detalle": [
      {
        "codigo": "C000",
        "valor": "TUMOR MALIGNO DEL LABIO SUPERIOR, CARA EXTERNA"
      },
      {
        "codigo": "C001",
        "valor": "TUMOR MALIGNO DEL LABIO INFERIOR, CARA EXTERNA"
      },
      {
        "codigo": "C002",
        "valor": "TUMOR MALIGNO DEL LABIO, CARA EXTERNA, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "C003",
        "valor": "TUMOR MALIGNO DEL LABIO SUPERIOR, CARA INTERNA"
      },
      {
        "codigo": "C004",
        "valor": "TUMOR MALIGNO DEL LABIO INFERIOR, CARA INTERNA"
      },
      {
        "codigo": "C005",
        "valor": "TUMOR MALIGNO DEL LABIO, CARA INTERNA, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "C006",
        "valor": "TUMOR MALIGNO DE LA COMISURA LABIAL"
      },
      {
        "codigo": "C008",
        "valor": "LESION DE SITIOS CONTIGUOS DEL LABIO"
      },
      {
        "codigo": "C009",
        "valor": "TUMOR MALIGNO DEL LABIO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C01 - TUMOR MALIGNO DE LA BASE DE LA LENGUA",
    "detalle": [
      {
        "codigo": "C01X",
        "valor": "TUMOR MALIGNO DE LA BASE DE LA LENGUA"
      }
    ]
  },
  {
    "grupo": "C02 - TUMOR MALIGNO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA LENGUA",
    "detalle": [
      {
        "codigo": "C020",
        "valor": "TUMOR MALIGNO DE LA CARA DORSAL DE LA LENGUA"
      },
      {
        "codigo": "C021",
        "valor": "TUMOR MALIGNO DEL BORDE DE LA LENGUA"
      },
      {
        "codigo": "C022",
        "valor": "TUMOR MALIGNO DE LA CARA VENTRAL DE LA LENGUA"
      },
      {
        "codigo": "C023",
        "valor": "TUMOR MALIGNO DE LOS DOS TERCIOS ANTERIORES DE LA LENGUA, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "C024",
        "valor": "TUMOR MALIGNO DE LA AMIGDALA LINGUAL"
      },
      {
        "codigo": "C028",
        "valor": "LESION DE SITIOS CONTIGUOS DE LA LENGUA"
      },
      {
        "codigo": "C029",
        "valor": "TUMOR MALIGNO DE LA LENGUA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C03 - TUMOR MALIGNO DE LA ENCIA",
    "detalle": [
      {
        "codigo": "C030",
        "valor": "TUMOR MALIGNO DE LA ENCIA SUPERIOR"
      },
      {
        "codigo": "C031",
        "valor": "TUMOR MALIGNO DE LA ENCIA INFERIOR"
      },
      {
        "codigo": "C039",
        "valor": "TUMOR MALIGNO DE LA ENCIA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C04 - TUMOR MALIGNO DEL PISO DE LA BOCA",
    "detalle": [
      {
        "codigo": "C040",
        "valor": "TUMOR MALIGNO DE LA PARTE ANTERIOR DEL PISO DE LA BOCA"
      },
      {
        "codigo": "C041",
        "valor": "TUMOR MALIGNO DE LA PARTE LATERAL DEL PISO DE LA BOCA"
      },
      {
        "codigo": "C048",
        "valor": "LESION DE SITIOS CONTIGUOS DEL PISO DE LA BOCA"
      },
      {
        "codigo": "C049",
        "valor": "TUMOR MALIGNO DEL PISO DE LA BOCA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C05 - TUMOR MALIGNO DEL PALADAR",
    "detalle": [
      {
        "codigo": "C050",
        "valor": "TUMOR MALIGNO DEL PALADAR DURO"
      },
      {
        "codigo": "C051",
        "valor": "TUMOR MALIGNO DEL PALADAR BLANDO"
      },
      {
        "codigo": "C052",
        "valor": "TUMOR MALIGNO DE LA UVULA"
      },
      {
        "codigo": "C058",
        "valor": "LESION DE SITIOS CONTIGUOS DEL PALADAR"
      },
      {
        "codigo": "C059",
        "valor": "TUMOR MALIGNO DEL PALADAR, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C06 - TUMOR MALIGNO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA BOCA",
    "detalle": [
      {
        "codigo": "C060",
        "valor": "TUMOR MALIGNO DE LA MUCOSA DE LA MEJILLA"
      },
      {
        "codigo": "C061",
        "valor": "TUMOR MALIGNO DEL VESTIBULO DE LA BOCA"
      },
      {
        "codigo": "C062",
        "valor": "TUMOR MALIGNO DEL AREA RETROMOLAR"
      },
      {
        "codigo": "C068",
        "valor": "LESION DE SITIOS CONTIGUOS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA BOCA"
      },
      {
        "codigo": "C069",
        "valor": "TUMOR MALIGNO DE LA BOCA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C07 - TUMOR MALIGNO DE LA GLANDULA PAROTIDA",
    "detalle": [
      {
        "codigo": "C07X",
        "valor": "TUMOR MALIGNO DE LA GLANDULA PAROTIDA"
      }
    ]
  },
  {
    "grupo": "C08 - TUMOR MALIGNO DE OTRAS GLANDULAS SALIVALES MAYORES Y DE LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "C080",
        "valor": "TUMOR MALIGNO DE LA GLANDULA SUBMAXILAR"
      },
      {
        "codigo": "C081",
        "valor": "TUMOR MALIGNO DE LA GLANDULA SUBLINGUAL"
      },
      {
        "codigo": "C088",
        "valor": "LESION DE SITIOS CONTIGUOS DE LAS GLANDULAS SALIVALES MAYORES"
      },
      {
        "codigo": "C089",
        "valor": "TUMOR MALIGNO DE GLANDULA SALIVAL MAYOR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C09 - TUMOR MALIGNO DE LA AMIGDALA",
    "detalle": [
      {
        "codigo": "C090",
        "valor": "TUMOR MALIGNO DE LA FOSA AMIGDALINA"
      },
      {
        "codigo": "C091",
        "valor": "TUMOR MALIGNO DEL PILAR AMIGDALINO (ANTERIOR) (POSTERIOR)"
      },
      {
        "codigo": "C098",
        "valor": "LESION DE SITIOS CONTIGUOS DE LA AMIGDALA"
      },
      {
        "codigo": "C099",
        "valor": "TUMOR MALIGNO DE LA AMIGDALA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C10 - TUMOR MALIGNO DE LA OROFARINGE",
    "detalle": [
      {
        "codigo": "C100",
        "valor": "TUMOR MALIGNO DE LA VALECULA"
      },
      {
        "codigo": "C101",
        "valor": "TUMOR MALIGNO DE LA CARA ANTERIOR DE LA EPIGLOTIS"
      },
      {
        "codigo": "C102",
        "valor": "TUMOR MALIGNO DE LA PARED LATERAL DE LA OROFARINGE"
      },
      {
        "codigo": "C103",
        "valor": "TUMOR MALIGNO DE LA PARED POSTERIOR DE LA OROFARINGE"
      },
      {
        "codigo": "C104",
        "valor": "TUMOR MALIGNO DE LA HENDIDURA BRANQUIAL"
      },
      {
        "codigo": "C108",
        "valor": "LESION DE SITIOS CONTIGUOS DE LA OROFARINGE"
      },
      {
        "codigo": "C109",
        "valor": "TUMOR MALIGNO DE LA OROFARINGE, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C11 - TUMOR MALIGNO DE LA NASOFARINGE",
    "detalle": [
      {
        "codigo": "C110",
        "valor": "TUMOR MALIGNO DE LA PARED SUPERIOR DE LA NASOFARINGE"
      },
      {
        "codigo": "C111",
        "valor": "TUMOR MALIGNO DE LA PARED POSTERIOR DE LA NASOFARINGE"
      },
      {
        "codigo": "C112",
        "valor": "TUMOR MALIGNO DE LA PARED LATERAL DE LA NASOFARINGE"
      },
      {
        "codigo": "C113",
        "valor": "TUMOR MALIGNO DE LA PARED ANTERIOR DE LA NASOFARINGE"
      },
      {
        "codigo": "C118",
        "valor": "LESION DE SITIOS CONTIGUOS DE LA NASOFARINGE"
      },
      {
        "codigo": "C119",
        "valor": "TUMOR MALIGNO DE LA NASOFARINGE, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C12 - TUMOR MALIGNO DEL SENO PIRIFORME",
    "detalle": [
      {
        "codigo": "C12X",
        "valor": "TUMOR MALIGNO DEL SENO PIRIFORME"
      }
    ]
  },
  {
    "grupo": "C13 - TUMOR MALIGNO DE LA HIPOFARINGE",
    "detalle": [
      {
        "codigo": "C130",
        "valor": "TUMOR MALIGNO DE LA REGION POSTCRICOIDEA"
      },
      {
        "codigo": "C131",
        "valor": "TUMOR MALIGNO DEL PLIEGUE ARITENOEPIGLOTICO, CARA HIPOFARINGEA"
      },
      {
        "codigo": "C132",
        "valor": "TUMOR MALIGNO DE LA PARED POSTERIOR DE LA HIPOFARINGE"
      },
      {
        "codigo": "C138",
        "valor": "LESION DE SITIOS CONTIGUOS DE LA HIPOFARINGE"
      },
      {
        "codigo": "C139",
        "valor": "TUMOR MALIGNO DE LA HIPOFARINGE, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C14 - TUMOR MALIGNO DE OTROS SITIOS Y DE LOS MAL DEFINIDOS DEL LABIO, DE LA CAVIDAD BUCAL Y DE LA FARINGE",
    "detalle": [
      {
        "codigo": "C140",
        "valor": "TUMOR MALIGNO DE LA FARINGE, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "C142",
        "valor": "TUMOR MALIGNO DEL ANILLO DE WALDEYER"
      },
      {
        "codigo": "C148",
        "valor": "LESION DE SITIOS CONTIGUOS DEL LABIO, DE LA CAVIDAD BUCAL Y DE LA FARINGE"
      }
    ]
  },
  {
    "grupo": "C15 - TUMOR MALIGNO DEL ESOFAGO",
    "detalle": [
      {
        "codigo": "C150",
        "valor": "TUMOR MALIGNO DEL ESOFAGO, PORCION CERVICAL"
      },
      {
        "codigo": "C151",
        "valor": "TUMOR MALIGNO DEL ESOFAGO, PORCION TORACICA"
      },
      {
        "codigo": "C152",
        "valor": "TUMOR MALIGNO DEL ESOFAGO, PORCION ABDOMINAL"
      },
      {
        "codigo": "C153",
        "valor": "TUMOR MALIGNO DEL TERCIO SUPERIOR DEL ESOFAGO"
      },
      {
        "codigo": "C154",
        "valor": "TUMOR MALIGNO DEL TERCIO MEDIO DEL ESOFAGO"
      },
      {
        "codigo": "C155",
        "valor": "TUMOR MALIGNO DEL TERCIO INFERIOR DEL ESOFAGO"
      },
      {
        "codigo": "C158",
        "valor": "LESION DE SITIOS CONTIGUOS DEL ESOFAGO"
      },
      {
        "codigo": "C159",
        "valor": "TUMOR MALIGNO DEL ESOFAGO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C16 - TUMOR MALIGNO DEL ESTOMAGO",
    "detalle": [
      {
        "codigo": "C160",
        "valor": "TUMOR MALIGNO DEL CARDIAS"
      },
      {
        "codigo": "C161",
        "valor": "TUMOR MALIGNO DEL FUNDUS GASTRICO"
      },
      {
        "codigo": "C162",
        "valor": "TUMOR MALIGNO DEL CUERPO DEL ESTOMAGO"
      },
      {
        "codigo": "C163",
        "valor": "TUMOR MALIGNO DEL ANTRO PILORICO"
      },
      {
        "codigo": "C164",
        "valor": "TUMOR MALIGNO DEL PILORO"
      },
      {
        "codigo": "C165",
        "valor": "TUMOR MALIGNO DE LA CURVATURA MENOR DEL ESTOMAGO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "C166",
        "valor": "TUMOR MALIGNO DE LA CURVATURA MAYOR DEL ESTOMAGO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "C168",
        "valor": "LESION DE SITIOS CONTIGUOS DEL ESTOMAGO"
      },
      {
        "codigo": "C169",
        "valor": "TUMOR MALIGNO DEL ESTOMAGO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C17 - TUMOR MALIGNO DEL INTESTINO DELGADO",
    "detalle": [
      {
        "codigo": "C170",
        "valor": "TUMOR MALIGNO DEL DUODENO"
      },
      {
        "codigo": "C171",
        "valor": "TUMOR MALIGNO DEL YEYUNO"
      },
      {
        "codigo": "C172",
        "valor": "TUMOR MALIGNO DEL ILEON"
      },
      {
        "codigo": "C173",
        "valor": "TUMOR MALIGNO DEL DIVERTICULO DE MECKEL"
      },
      {
        "codigo": "C178",
        "valor": "LESION DE SITIOS CONTIGUOS DEL INTESTINO DELGADO"
      },
      {
        "codigo": "C179",
        "valor": "TUMOR MALIGNO DEL INTESTINO DELGADO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C18 - TUMOR MALIGNO DEL COLON",
    "detalle": [
      {
        "codigo": "C180",
        "valor": "TUMOR MALIGNO DEL CIEGO"
      },
      {
        "codigo": "C181",
        "valor": "TUMOR MALIGNO DEL APENDICE"
      },
      {
        "codigo": "C182",
        "valor": "TUMOR MALIGNO DEL COLON ASCENDENTE"
      },
      {
        "codigo": "C183",
        "valor": "TUMOR MALIGNO DEL ANGULO HEPATICO"
      },
      {
        "codigo": "C184",
        "valor": "TUMOR MALIGNO DEL COLON TRANSVERSO"
      },
      {
        "codigo": "C185",
        "valor": "TUMOR MALIGNO DEL ANGULO ESPLENICO"
      },
      {
        "codigo": "C186",
        "valor": "TUMOR MALIGNO DEL COLON DESCENDENTE"
      },
      {
        "codigo": "C187",
        "valor": "TUMOR MALIGNO DEL COLON SIGMOIDE"
      },
      {
        "codigo": "C188",
        "valor": "LESION DE SITIOS CONTIGUOS DEL COLON"
      },
      {
        "codigo": "C189",
        "valor": "TUMOR MALIGNO DEL COLON, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C19 - TUMOR MALIGNO DE LA UNION RECTOSIGMOIDEA",
    "detalle": [
      {
        "codigo": "C19X",
        "valor": "TUMOR MALIGNO DE LA UNION RECTOSIGMOIDEA"
      }
    ]
  },
  {
    "grupo": "C20 - TUMOR MALIGNO DEL RECTO",
    "detalle": [
      {
        "codigo": "C20X",
        "valor": "TUMOR MALIGNO DEL RECTO"
      }
    ]
  },
  {
    "grupo": "C21 - TUMOR MALIGNO DEL ANO Y DEL CONDUCTO ANAL",
    "detalle": [
      {
        "codigo": "C210",
        "valor": "TUMOR MALIGNO DEL ANO, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "C211",
        "valor": "TUMOR MALIGNO DEL CONDUCTO ANAL"
      },
      {
        "codigo": "C212",
        "valor": "TUMOR MALIGNO DE LA ZONA CLOACOGENICA"
      },
      {
        "codigo": "C218",
        "valor": "LESION DE SITIOS CONTIGUOS DEL ANO, DEL CONDUCTO ANAL Y DEL RECTO"
      }
    ]
  },
  {
    "grupo": "C22 - TUMOR MALIGNO DEL HIGADO Y DE LAS VIAS BILIARES INTRAHEPATICAS",
    "detalle": [
      {
        "codigo": "C220",
        "valor": "CARCINOMA DE CELULAS HEPATICAS"
      },
      {
        "codigo": "C221",
        "valor": "CARCINOMA DE VIAS BILIARES INTRAHEPATICAS"
      },
      {
        "codigo": "C222",
        "valor": "HEPATOBLASTOMA"
      },
      {
        "codigo": "C223",
        "valor": "ANGIOSARCOMA DEL HIGADO"
      },
      {
        "codigo": "C224",
        "valor": "OTROS SARCOMAS DEL HIGADO"
      },
      {
        "codigo": "C227",
        "valor": "OTROS CARCINOMAS ESPECIFICADOS DEL HIGADO"
      },
      {
        "codigo": "C229",
        "valor": "TUMOR MALIGNO DEL HIGADO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C23 - TUMOR MALIGNO DE LA VESICULA BILIAR",
    "detalle": [
      {
        "codigo": "C23X",
        "valor": "TUMOR MALIGNO DE LA VESICULA BILIAR"
      }
    ]
  },
  {
    "grupo": "C24 - TUMOR MALIGNO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LAS VIAS BILIARES",
    "detalle": [
      {
        "codigo": "C240",
        "valor": "TUMOR MALIGNO DE LAS VIAS BILIARES EXTRAHEPATICAS"
      },
      {
        "codigo": "C241",
        "valor": "TUMOR MALIGNO DE LA AMPOLLA DE VATER"
      },
      {
        "codigo": "C248",
        "valor": "LESION DE SITIOS CONTIGUOS DE LAS VIAS BILIARES"
      },
      {
        "codigo": "C249",
        "valor": "TUMOR MALIGNO DE LAS VIAS BILIARES, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C25 - TUMOR MALIGNO DEL PANCREAS",
    "detalle": [
      {
        "codigo": "C250",
        "valor": "TUMOR MALIGNO DE LA CABEZA DEL PANCREAS"
      },
      {
        "codigo": "C251",
        "valor": "TUMOR MALIGNO DEL CUERPO DEL PANCREAS"
      },
      {
        "codigo": "C252",
        "valor": "TUMOR MALIGNO DE LA COLA DEL PANCREAS"
      },
      {
        "codigo": "C253",
        "valor": "TUMOR MALIGNO DEL CONDUCTO PANCREATICO"
      },
      {
        "codigo": "C254",
        "valor": "TUMOR MALIGNO DEL PANCREAS ENDOCRINO"
      },
      {
        "codigo": "C257",
        "valor": "TUMOR MALIGNO DE OTRAS PARTES ESPECIFICADAS DEL PANCREAS"
      },
      {
        "codigo": "C258",
        "valor": "LESION DE SITIOS CONTIGUOS DEL PANCREAS"
      },
      {
        "codigo": "C259",
        "valor": "TUMOR MALIGNO DEL PANCREAS, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C26 - TUMOR MALIGNO DE OTROS SITIOS Y DE LOS MAL DEFINIDOS DE LOS ORGANOS DIGESTIVOS",
    "detalle": [
      {
        "codigo": "C260",
        "valor": "TUMOR MALIGNO DEL INTESTINO, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "C261",
        "valor": "TUMOR MALIGNO DEL BAZO"
      },
      {
        "codigo": "C268",
        "valor": "LESION DE SITIOS CONTIGUOS DE LOS ORGANOS DIGESTIVOS"
      },
      {
        "codigo": "C269",
        "valor": "TUMOR MALIGNO DE SITIOS MAL DEFINIDOS DE LOS ORGANOS DIGESTIVOS"
      }
    ]
  },
  {
    "grupo": "C30 - TUMOR MALIGNO DE LAS FOSAS NASALES Y DEL OIDO MEDIO",
    "detalle": [
      {
        "codigo": "C300",
        "valor": "TUMOR MALIGNO DE LA FOSA NASAL"
      },
      {
        "codigo": "C301",
        "valor": "TUMOR MALIGNO DEL OIDO MEDIO"
      }
    ]
  },
  {
    "grupo": "C31 - TUMOR MALIGNO DE LOS SENOS PARANASALES",
    "detalle": [
      {
        "codigo": "C310",
        "valor": "TUMOR MALIGNO DEL SENO MAXILAR"
      },
      {
        "codigo": "C311",
        "valor": "TUMOR MALIGNO DEL SENO ETMOIDAL"
      },
      {
        "codigo": "C312",
        "valor": "TUMOR MALIGNO DEL SENO FRONTAL"
      },
      {
        "codigo": "C313",
        "valor": "TUMOR MALIGNO DEL SENO ESFENOIDAL"
      },
      {
        "codigo": "C318",
        "valor": "LESION DE SITIOS CONTIGUOS DE LOS SENOS PARANASALES"
      },
      {
        "codigo": "C319",
        "valor": "TUMOR MALIGNO DE SENO PARANASAL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C32 - TUMOR MALIGNO DE LA LARINGE",
    "detalle": [
      {
        "codigo": "C320",
        "valor": "TUMOR MALIGNO DE LA GLOTIS"
      },
      {
        "codigo": "C321",
        "valor": "TUMOR MALIGNO DE LA REGION SUPRAGLOTICA"
      },
      {
        "codigo": "C322",
        "valor": "TUMOR MALIGNO DE LA REGION SUBGLOTICA"
      },
      {
        "codigo": "C323",
        "valor": "TUMOR MALIGNO DEL CARTILAGO LARINGEO"
      },
      {
        "codigo": "C328",
        "valor": "LESION DE SITIOS CONTIGUOS DE LA LARINGE"
      },
      {
        "codigo": "C329",
        "valor": "TUMOR MALIGNO DE LA LARINGE, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C33 - TUMOR MALIGNO DE LA TRAQUEA",
    "detalle": [
      {
        "codigo": "C33X",
        "valor": "TUMOR MALIGNO DE LA TRAQUEA"
      }
    ]
  },
  {
    "grupo": "C34 - TUMOR MALIGNO DE LOS BRONQUIOS Y DEL PULMON",
    "detalle": [
      {
        "codigo": "C340",
        "valor": "TUMOR MALIGNO DEL BRONQUIO PRINCIPAL"
      },
      {
        "codigo": "C341",
        "valor": "TUMOR MALIGNO DEL LOBULO SUPERIOR, BRONQUIO O PULMON"
      },
      {
        "codigo": "C342",
        "valor": "TUMOR MALIGNO DEL LOBULO MEDIO, BRONQUIO O PULMON"
      },
      {
        "codigo": "C343",
        "valor": "TUMOR MALIGNO DEL LOBULO INFERIOR, BRONQUIO O PULMON"
      },
      {
        "codigo": "C348",
        "valor": "LESION DE SITIOS CONTIGUOS DE LOS BRONQUIOS Y DEL PULMON"
      },
      {
        "codigo": "C349",
        "valor": "TUMOR MALIGNO DE LOS BRONQUIOS O DEL PULMON, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C37 - TUMOR MALIGNO DEL TIMO",
    "detalle": [
      {
        "codigo": "C37X",
        "valor": "TUMOR MALIGNO DEL TIMO"
      }
    ]
  },
  {
    "grupo": "C38 - TUMOR MALIGNO DEL CORAZON, DEL MEDIASTINO Y DE LA PLEURA",
    "detalle": [
      {
        "codigo": "C380",
        "valor": "TUMOR MALIGNO DEL CORAZON"
      },
      {
        "codigo": "C381",
        "valor": "TUMOR MALIGNO DEL MEDIASTINO ANTERIOR"
      },
      {
        "codigo": "C382",
        "valor": "TUMOR MALIGNO DEL MEDIASTINO POSTERIOR"
      },
      {
        "codigo": "C383",
        "valor": "TUMOR MALIGNO DEL MEDIASTINO, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "C384",
        "valor": "TUMOR MALIGNO DE LA PLEURA"
      },
      {
        "codigo": "C388",
        "valor": "LESION DE SITOS CONTIGUOS DEL CORAZON, DEL MEDIASTINO Y DE LA PLEURA"
      }
    ]
  },
  {
    "grupo": "C39 - TUMOR MALIGNO DE OTROS SITIOS Y DE LOS MAL DEFINIDOS DEL SISTEMA RESPIRATORIO Y DE LOS ORGANOS INTRATORACICOS",
    "detalle": [
      {
        "codigo": "C390",
        "valor": "TUMOR MALIGNO DE LA VIAS RESPIRATORIA SUPERIORES, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "C398",
        "valor": "LESION DE SITIOS CONTIGUOS DE LOS ORGANOS RESPIRATORIOS E INTRATORACICOS"
      },
      {
        "codigo": "C399",
        "valor": "TUMOR MALIGNO DE SITIOS MAL DEFINIDOS DEL SISTEMA RESPIRATORIO"
      }
    ]
  },
  {
    "grupo": "C40 - TUMOR MALIGNO DE LOS HUESOS Y DE LOS CARTILAGOS ARTICULARES DE LOS MIEMBROS",
    "detalle": [
      {
        "codigo": "C400",
        "valor": "TUMOR MALIGNO DEL OMOPLATO Y DE LOS HUESOS LARGOS DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "C401",
        "valor": "TUMOR MALIGNO DE LOS HUESOS CORTOS DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "C402",
        "valor": "TUMOR MALIGNO DE LOS HUESOS LARGOS DEL MIEMBRO INFERIOR"
      },
      {
        "codigo": "C403",
        "valor": "TUMOR MALIGNO DE LOS HUESOS CORTOS DEL MIEMBRO INFERIOR"
      },
      {
        "codigo": "C408",
        "valor": "LESION DE SITIOS CONTIGUOS DE LOS HUESOS Y DE LOS CARTILAGOS ARTICULARES DE LOS MIEMBROS"
      },
      {
        "codigo": "C409",
        "valor": "TUMOR MALIGNO DE LOS HUESOS Y DE LOS CARTILAGOS ARTICULARES DE LOS MIEMBROS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "C41 - TUMOR MALIGNO DE LOS HUESOS Y DE LOS CARTILAGOS ARTICULARES, DE OTROS SITIOS Y DE ITIOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "C410",
        "valor": "TUMOR MALIGNO DE LOS HUESOS DEL CRANEO Y DE LA CARA"
      },
      {
        "codigo": "C411",
        "valor": "TUMOR MALIGNO DEL HUESO DEL MAXILAR INFERIOR"
      },
      {
        "codigo": "C412",
        "valor": "TUMOR MALIGNO DE LA COLUMNA VERTEBRAL"
      },
      {
        "codigo": "C413",
        "valor": "TUMOR MALIGNO DE LA COSTILLA, ESTERNON Y CLAVICULA"
      },
      {
        "codigo": "C414",
        "valor": "TUMOR MALIGNO DE LOS HUESOS DE LA PELVIS, SACRO Y COCCIX"
      },
      {
        "codigo": "C418",
        "valor": "LESION DE SITIOS CONTIGUOS DEL HUESO Y DEL CARTILAGO ARTICULAR"
      },
      {
        "codigo": "C419",
        "valor": "TUMOR MALIGNO DEL HUESO Y DEL CARTILAGO ARTICULAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C43 - MELANOMA MALIGNO DE LA PIEL",
    "detalle": [
      {
        "codigo": "C430",
        "valor": "MELANOMA MALIGNO DEL LABIO"
      },
      {
        "codigo": "C431",
        "valor": "MELANOMA MALIGNO DEL PARPADO, INCLUIDA LA COMISURA PALPEBRAL"
      },
      {
        "codigo": "C432",
        "valor": "MELANOMA MALIGNO DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO"
      },
      {
        "codigo": "C433",
        "valor": "MELANOMA MALIGNO DE LAS OTRAS PARTES Y LAS NO ESPECIFICADAS DE LA CARA"
      },
      {
        "codigo": "C434",
        "valor": "MELANOMA MALIGNO DEL CUERO CABELLUDO Y DEL CUELLO"
      },
      {
        "codigo": "C435",
        "valor": "MELANOMA MALIGNO DEL TRONCO"
      },
      {
        "codigo": "C436",
        "valor": "MELANOMA MALIGNO DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO"
      },
      {
        "codigo": "C437",
        "valor": "MELANOMA MALIGNO DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA"
      },
      {
        "codigo": "C438",
        "valor": "MELANOMA MALIGNO DE SITIOS CONTIGUOS DE LA PIEL"
      },
      {
        "codigo": "C439",
        "valor": "MELANOMA MALIGNO DE PIEL, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C44 - OTROS TUMORES MALIGNOS DE LA PIEL",
    "detalle": [
      {
        "codigo": "C440",
        "valor": "TUMOR MALIGNO DE LA PIEL DEL LABIO"
      },
      {
        "codigo": "C441",
        "valor": "TUMOR MALIGNO DE LA PIEL DEL PARPADO, INCLUIDA LA COMISURA PALPEBRAL"
      },
      {
        "codigo": "C442",
        "valor": "TUMOR MALIGNO DE LA PIEL DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO"
      },
      {
        "codigo": "C443",
        "valor": "TUMOR MALIGNO DE LA PIEL DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CARA"
      },
      {
        "codigo": "C444",
        "valor": "TUMOR MALIGNO DE LA PIEL DEL CUERO CABELLUDO Y DEL CUELLO"
      },
      {
        "codigo": "C445",
        "valor": "TUMOR MALIGNO DE LA PIEL DEL TRONCO"
      },
      {
        "codigo": "C446",
        "valor": "TUMOR MALIGNO DE LA PIEL DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO"
      },
      {
        "codigo": "C447",
        "valor": "TUMOR MALIGNO DE LA PIEL MIEMBRO INFERIOR, INCLUIDA LA CADERA"
      },
      {
        "codigo": "C448",
        "valor": "LESION DE SITIOS CONTIGUOS DE LA PIEL"
      },
      {
        "codigo": "C449",
        "valor": "TUMOR MALIGNO DE LA PIEL, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C45 - MESOTELIOMA",
    "detalle": [
      {
        "codigo": "C450",
        "valor": "MESOTELIOMA DE LA PLEURA"
      },
      {
        "codigo": "C451",
        "valor": "MESOTELIOMA DEL PERITONEO"
      },
      {
        "codigo": "C452",
        "valor": "MESOTELIOMA DEL PERICARDIO"
      },
      {
        "codigo": "C457",
        "valor": "MESOTELIOMA DE OTROS SITIOS ESPECIFICADOS"
      },
      {
        "codigo": "C459",
        "valor": "MESOTELIOMA, DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C46 - SARCOMA DE KAPOSI",
    "detalle": [
      {
        "codigo": "C460",
        "valor": "SARCOMA DE KAPOSI DE LA PIEL"
      },
      {
        "codigo": "C461",
        "valor": "SARCOMA DE KAPOSI DEL TEJIDO BLANDO"
      },
      {
        "codigo": "C462",
        "valor": "SARCOMA DE KAPOSI DEL PALADAR"
      },
      {
        "codigo": "C463",
        "valor": "SARCOMA DE KAPOSI DE LOS GANGLIOS LINFATICOS"
      },
      {
        "codigo": "C467",
        "valor": "SARCOMA DE KAPOSI DE OTROS SITIOS ESPECIFICADOS"
      },
      {
        "codigo": "C468",
        "valor": "SARCOMA DE KAPOSI DE MULTIPLES ORGANOS"
      },
      {
        "codigo": "C469",
        "valor": "SARCOMA DE KAPOSI DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C47 - TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS Y DEL SISTEMA NERVIOSO AUTONOMO",
    "detalle": [
      {
        "codigo": "C470",
        "valor": "TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DE LA CABEZA, CARA Y CUELLO"
      },
      {
        "codigo": "C471",
        "valor": "TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO"
      },
      {
        "codigo": "C472",
        "valor": "TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA"
      },
      {
        "codigo": "C473",
        "valor": "TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DEL TORAX"
      },
      {
        "codigo": "C474",
        "valor": "TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DEL ABDOMEN"
      },
      {
        "codigo": "C475",
        "valor": "TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DE LA PELVIS"
      },
      {
        "codigo": "C476",
        "valor": "TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DEL TRONCO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "C478",
        "valor": "LESION DE SITIOS CONTIGUOS DE LOS NERVIOS PERIFERICOS Y DEL SISTEMA NERVIOSO AUTONOMO"
      },
      {
        "codigo": "C479",
        "valor": "TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS Y DEL SISTEMA NERVIOSO AUTONOMO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C48 - TUMOR MALIGNO DEL PERITONEO Y DEL RETROPERITONEO",
    "detalle": [
      {
        "codigo": "C480",
        "valor": "TUMOR MALIGNO DEL RETROPERITONEO"
      },
      {
        "codigo": "C481",
        "valor": "TUMOR MALIGNO DE PARTE ESPECIFICADA DEL PERITONEO"
      },
      {
        "codigo": "C482",
        "valor": "TUMOR MALIGNO DEL PERITONEO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "C488",
        "valor": "LESION DE SITIOS CONTIGUOS DEL PERITONEO Y DEL RETROPERITONEO"
      }
    ]
  },
  {
    "grupo": "C49 - TUMOR MALIGNO DE OTROS TEJIDOS CONJUNTIVOS Y DE TEJIDOS BLANDOS",
    "detalle": [
      {
        "codigo": "C490",
        "valor": "TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DE LA CABEZA, CARA Y CUELLO"
      },
      {
        "codigo": "C491",
        "valor": "TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO"
      },
      {
        "codigo": "C492",
        "valor": "TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA"
      },
      {
        "codigo": "C493",
        "valor": "TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DEL TORAX"
      },
      {
        "codigo": "C494",
        "valor": "TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DEL ABDOMEN"
      },
      {
        "codigo": "C495",
        "valor": "TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DE LA PELVIS"
      },
      {
        "codigo": "C496",
        "valor": "TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DEL TRONCO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "C498",
        "valor": "LESION DE SITIOS CONTIGUOS DEL TEJIDO CONJUNTIVO Y DEL TEJIDO BLANDO"
      },
      {
        "codigo": "C499",
        "valor": "TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO, DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C50 - TUMOR MALIGNO DE LA MAMA",
    "detalle": [
      {
        "codigo": "C500",
        "valor": "TUMOR MALIGNO DEL PEZON Y AREOLA MAMARIA"
      },
      {
        "codigo": "C501",
        "valor": "TUMOR MALIGNO DE LA PORCION CENTRAL DE LA MAMA"
      },
      {
        "codigo": "C502",
        "valor": "TUMOR MALIGNO DEL CUADRANTE SUPERIOR INTERNO DE LA MAMA"
      },
      {
        "codigo": "C503",
        "valor": "TUMOR MALIGNO DEL CUADRANTE INFERIOR INTERNO DE LA MAMA"
      },
      {
        "codigo": "C504",
        "valor": "TUMOR MALIGNO DEL CUADRANTE SUPERIOR EXTERNO DE LA MAMA"
      },
      {
        "codigo": "C505",
        "valor": "TUMOR MALIGNO DEL CUADRANTE INFERIOR EXTERNO DE LA MAMA"
      },
      {
        "codigo": "C506",
        "valor": "TUMOR MALIGNO DE LA PROLONGACION AXILAR DE LA MAMA"
      },
      {
        "codigo": "C508",
        "valor": "LESION DE SITIOS CONTIGUOS DE LA MAMA"
      },
      {
        "codigo": "C509",
        "valor": "TUMOR MALIGNO DE LA MAMA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C51 - TUMOR MALIGNO DE LA VULVA",
    "detalle": [
      {
        "codigo": "C510",
        "valor": "TUMOR MALIGNO DEL LABIO MAYOR"
      },
      {
        "codigo": "C511",
        "valor": "TUMOR MALIGNO DEL LABIO MENOR"
      },
      {
        "codigo": "C512",
        "valor": "TUMOR MALIGNO DEL CLITORIS"
      },
      {
        "codigo": "C518",
        "valor": "LESION DE SITIOS CONTIGUOS DE LA VULVA"
      },
      {
        "codigo": "C519",
        "valor": "TUMOR MALIGNO DE LA VULVA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C52 - TUMOR MALIGNO DE LA VAGINA",
    "detalle": [
      {
        "codigo": "C52X",
        "valor": "TUMOR MALIGNO DE LA VAGINA"
      }
    ]
  },
  {
    "grupo": "C53 - TUMOR MALIGNO DEL CUELLO DEL UTERO",
    "detalle": [
      {
        "codigo": "C530",
        "valor": "TUMOR MALIGNO DEL ENDOCERVIX"
      },
      {
        "codigo": "C531",
        "valor": "TUMOR MALIGNO DEL EXOCERVIX"
      },
      {
        "codigo": "C538",
        "valor": "LESION DE SITIOS CONTIGUOS DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "C539",
        "valor": "TUMOR MALIGNO DEL CUELLO DEL UTERO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "C54 - TUMOR MALIGNO DEL CUERPO DEL UTERO",
    "detalle": [
      {
        "codigo": "C540",
        "valor": "TUMOR MALIGNO DEL ISTMO UTERINO"
      },
      {
        "codigo": "C541",
        "valor": "TUMOR MALIGNO DEL ENDOMETRIO"
      },
      {
        "codigo": "C542",
        "valor": "TUMOR MALIGNO DEL MIOMETRIO"
      },
      {
        "codigo": "C543",
        "valor": "TUMOR MALIGNO DEL FONDO DEL UTERO"
      },
      {
        "codigo": "C548",
        "valor": "LESION DE SITIOS CONTIGUOS DEL CUERPO DEL UTERO"
      },
      {
        "codigo": "C549",
        "valor": "TUMOR MALIGNO DEL CUERPO DEL UTERO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C55 - TUMOR MALIGNO DEL UTERO, PARTE NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "C55X",
        "valor": "TUMOR MALIGNO DEL UTERO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C56 - TUMOR MALIGNO DEL OVARIO",
    "detalle": [
      {
        "codigo": "C56X",
        "valor": "TUMOR MALIGNO DEL OVARIO"
      }
    ]
  },
  {
    "grupo": "C57 - TUMOR MALIGNO DE OTROS ORGANOS GENITALES FEMENINOS Y DE LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "C570",
        "valor": "TUMOR MALIGNO DE LA TROMPA DE FALOPIO"
      },
      {
        "codigo": "C571",
        "valor": "TUMOR MALIGNO DEL LIGAMENTO ANCHO"
      },
      {
        "codigo": "C572",
        "valor": "TUMOR MALIGNO DEL LIGAMENTO REDONDO"
      },
      {
        "codigo": "C573",
        "valor": "TUMOR MALIGNO DEL PARAMETRIO"
      },
      {
        "codigo": "C574",
        "valor": "TUMOR MALIGNO DE LOS ANEXOS UTERINOS, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "C577",
        "valor": "TUMOR MALIGNO DE OTRAS PARTES ESPECIFICADAS DE LOS ORGANOS GENITALES FEMENINOS"
      },
      {
        "codigo": "C578",
        "valor": "LESION DE SITIOS CONTIGUOS DE LOS ORGANOS GENITALES FEMENINOS"
      },
      {
        "codigo": "C579",
        "valor": "TUMOR MALIGNO DE ORGANO GENITAL FEMENINO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C58 - TUMOR MALIGNO DE LA PLACENTA",
    "detalle": [
      {
        "codigo": "C58X",
        "valor": "TUMOR MALIGNO DE LA PLACENTA"
      }
    ]
  },
  {
    "grupo": "C60 - TUMOR MALIGNO DEL PENE",
    "detalle": [
      {
        "codigo": "C600",
        "valor": "TUMOR MALIGNO DEL PREPUCIO"
      },
      {
        "codigo": "C601",
        "valor": "TUMOR MALIGNO DEL GLANDE"
      },
      {
        "codigo": "C602",
        "valor": "TUMOR MALIGNO DEL CUERPO DEL PENE"
      },
      {
        "codigo": "C608",
        "valor": "LESION DE SITIOS CONTIGUOS DEL PENE"
      },
      {
        "codigo": "C609",
        "valor": "TUMOR MALIGNO DEL PENE, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C61 - TUMOR MALIGNO DE LA PROSTATA",
    "detalle": [
      {
        "codigo": "C61X",
        "valor": "TUMOR MALIGNO DE LA PROSTATA"
      }
    ]
  },
  {
    "grupo": "C62 - TUMOR MALIGNO DEL TESTICULO",
    "detalle": [
      {
        "codigo": "C620",
        "valor": "TUMOR MALIGNO DEL TESTICULO NO DESCENDIDO"
      },
      {
        "codigo": "C621",
        "valor": "TUMOR MALIGNO DEL TESTICULO DESCENDIDO"
      },
      {
        "codigo": "C629",
        "valor": "TUMOR MALIGNO DEL TESTICULO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C63 - TUMOR MALIGNO DE OTROS ORGANOS GENITALES MASCULINOS Y DE LOS NO ESPECICADOS",
    "detalle": [
      {
        "codigo": "C630",
        "valor": "TUMOR MALIGNO DEL EPIDIDIMO"
      },
      {
        "codigo": "C631",
        "valor": "TUMOR MALIGNO DEL CORDON ESPERMATICO"
      },
      {
        "codigo": "C632",
        "valor": "TUMOR MALIGNO DEL ESCROTO"
      },
      {
        "codigo": "C637",
        "valor": "TUMOR MALIGNO DE OTRAS PARTES ESPECIFICADAS DE LOS ORGANOS GENITALES MASCULINOS"
      },
      {
        "codigo": "C638",
        "valor": "LESION DE SITIOS CONTIGUOS DE LOS ORGANOS GENITALES MASCULINOS"
      },
      {
        "codigo": "C639",
        "valor": "TUMOR MALIGNO DE ORGANO GENITAL MASCULINO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C64 - TUMOR MALIGNO DEL RIÑON, EXCEPTO DE LA PELVIS RENAL",
    "detalle": [
      {
        "codigo": "C64X",
        "valor": "TUMOR MALIGNO DEL RINON, EXCEPTO DE LA PELVIS RENAL"
      }
    ]
  },
  {
    "grupo": "C65 - TUMOR MALIGNO DE LA PELVIS RENAL",
    "detalle": [
      {
        "codigo": "C65X",
        "valor": "TUMOR MALIGNO DE LA PELVIS RENAL"
      }
    ]
  },
  {
    "grupo": "C66 - TUMOR MALIGNO DEL URETER",
    "detalle": [
      {
        "codigo": "C66X",
        "valor": "TUMOR MALIGNO DEL URETER"
      }
    ]
  },
  {
    "grupo": "C67 - TUMOR MALIGNO DE LA VEJIGA URINARIA",
    "detalle": [
      {
        "codigo": "C670",
        "valor": "TUMOR MALIGNO DEL TRIGONO VESICAL"
      },
      {
        "codigo": "C671",
        "valor": "TUMOR MALIGNO DE LA CUPULA VESICAL"
      },
      {
        "codigo": "C672",
        "valor": "TUMOR MALIGNO DE LA PARED LATERAL DE LA VEJIGA"
      },
      {
        "codigo": "C673",
        "valor": "TUMOR MALIGNO DE LA PARED ANTERIOR DE LA VEJIGA"
      },
      {
        "codigo": "C674",
        "valor": "TUMOR MALIGNO DE LA PARED POSTERIOR DE LA VEJIGA"
      },
      {
        "codigo": "C675",
        "valor": "TUMOR MALIGNO DEL CUELLO DE LA VEJIGA"
      },
      {
        "codigo": "C676",
        "valor": "TUMOR MALIGNO DEL ORIFICIO URETERAL"
      },
      {
        "codigo": "C677",
        "valor": "TUMOR MALIGNO DEL URACO"
      },
      {
        "codigo": "C678",
        "valor": "LESION DE SITIOS CONTIGUOS DE LA VEJIGA"
      },
      {
        "codigo": "C679",
        "valor": "TUMOR MALIGNO DE LA VEJIGA URINARIA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C68 - TUMOR MALIGNO DE OTROS ORGANOS URINARIOS Y DE LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "C680",
        "valor": "TUMOR MALIGNO DE LA URETRA"
      },
      {
        "codigo": "C681",
        "valor": "TUMOR MALIGNO DE LAS GLANDULAS PARAURETRALES"
      },
      {
        "codigo": "C688",
        "valor": "LESION DE SITIOS CONTIGUOS DE LOS ORGANOS URINARIOS"
      },
      {
        "codigo": "C689",
        "valor": "TUMOR MALIGNO DE ORGANO URINARIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C69 - TUMOR MALIGNO DEL OJO Y SUS ANEXOS",
    "detalle": [
      {
        "codigo": "C690",
        "valor": "TUMOR MALIGNO DE LA CONJUNTIVA"
      },
      {
        "codigo": "C691",
        "valor": "TUMOR MALIGNO DE LA CORNEA"
      },
      {
        "codigo": "C692",
        "valor": "TUMOR MALIGNO DE LA RETINA"
      },
      {
        "codigo": "C693",
        "valor": "TUMOR MALIGNO DE LA COROIDES"
      },
      {
        "codigo": "C694",
        "valor": "TUMOR MALIGNO DEL CUERPO CILIAR"
      },
      {
        "codigo": "C695",
        "valor": "TUMOR MALIGNO DE LA GLANDULA Y CONDUCTO LAGRIMALES"
      },
      {
        "codigo": "C696",
        "valor": "TUMOR MALIGNO DE LA ORBITA"
      },
      {
        "codigo": "C698",
        "valor": "LESION DE SITIOS CONTIGUOS DEL OJO Y SUS ANEXOS"
      },
      {
        "codigo": "C699",
        "valor": "TUMOR MALIGNO DEL OJO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C70 - TUMOR MALIGNO DE LAS MENINGES",
    "detalle": [
      {
        "codigo": "C700",
        "valor": "TUMOR MALIGNO DE LAS MENINGES CEREBRALES"
      },
      {
        "codigo": "C701",
        "valor": "TUMOR MALIGNO DE LAS MENINGES RAQUIDEAS"
      },
      {
        "codigo": "C709",
        "valor": "TUMOR MALIGNO DE LAS MENINGES, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C71 - TUMOR MALIGNO DEL ENCEFALO",
    "detalle": [
      {
        "codigo": "C710",
        "valor": "TUMOR MALIGNO DEL CEREBRO, EXCEPTO LOBULOS Y VENTRICULOS"
      },
      {
        "codigo": "C711",
        "valor": "TUMOR MALIGNO DEL LOBULO FRONTAL"
      },
      {
        "codigo": "C712",
        "valor": "TUMOR MALIGNO DEL LOBULO TEMPORAL"
      },
      {
        "codigo": "C713",
        "valor": "TUMOR MALIGNO DEL LOBULO PARIETAL"
      },
      {
        "codigo": "C714",
        "valor": "TUMOR MALIGNO DEL LOBULO OCCIPITAL"
      },
      {
        "codigo": "C715",
        "valor": "TUMOR MALIGNO DEL VENTRICULO CEREBRAL"
      },
      {
        "codigo": "C716",
        "valor": "TUMOR MALIGNO DEL CEREBELO"
      },
      {
        "codigo": "C717",
        "valor": "TUMOR MALIGNO DEL PEDUNCULO CEREBRAL"
      },
      {
        "codigo": "C718",
        "valor": "LESION DE SITIOS CONTIGUOS DEL ENCEFALO"
      },
      {
        "codigo": "C719",
        "valor": "TUMOR MALIGNO DEL ENCEFALO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C72 - TUMOR MALIGNO DE LA MEDULA ESPINAL, DE LOS NERVIOS CRANEALES Y DE OTRAS PARTES DEL SISTEMA NERVIOSO CENTRAL",
    "detalle": [
      {
        "codigo": "C720",
        "valor": "TUMOR MALIGNO DE LA MEDULA ESPINAL"
      },
      {
        "codigo": "C721",
        "valor": "TUMOR MALIGNO DE LA COLA DE CABALLO"
      },
      {
        "codigo": "C722",
        "valor": "TUMOR MALIGNO DEL NERVIO OLFATORIO"
      },
      {
        "codigo": "C723",
        "valor": "TUMOR MALIGNO DEL NERVIO OPTICO"
      },
      {
        "codigo": "C724",
        "valor": "TUMOR MALIGNO DEL NERVIO ACUSTICO"
      },
      {
        "codigo": "C725",
        "valor": "TUMOR MALIGNO DE OTROS NERVIOS CRANEALES Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "C728",
        "valor": "LESION DE SITIOS CONTIGUOS DEL ENCEFALO Y OTRAS PARTES DEL SISTEMA NERVIOSO CENTRAL"
      },
      {
        "codigo": "C729",
        "valor": "TUMOR MALIGNO DEL SISTEMA NERVIOSO CENTRAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "C73 - TUMOR MALIGNO DE LA GLANDULA TIROIDES",
    "detalle": [
      {
        "codigo": "C73X",
        "valor": "TUMOR MALIGNO DE LA GLANDULA TIROIDES"
      }
    ]
  },
  {
    "grupo": "C74 - TUMOR MALIGNO DE LA GLANDULA SUPRARRENAL",
    "detalle": [
      {
        "codigo": "C740",
        "valor": "TUMOR MALIGNO DE LA CORTEZA DE LA GLANDULA SUPRARRENAL"
      },
      {
        "codigo": "C741",
        "valor": "TUMOR MALIGNO DE LA MEDULA DE LA GLANDULA SUPRARRENAL"
      },
      {
        "codigo": "C749",
        "valor": "TUMOR MALIGNO DE LA GLANDULA SUPRARRENAL, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C75 - TUMOR MALIGNO DE OTRAS GLANDULAS ENDOCRINAS Y DE ESTRUCTURAS AFINES",
    "detalle": [
      {
        "codigo": "C750",
        "valor": "TUMOR MALIGNO DE LA GLANDULA PARATIROIDES"
      },
      {
        "codigo": "C751",
        "valor": "TUMOR MALIGNO DE LA HIPOFISIS"
      },
      {
        "codigo": "C752",
        "valor": "TUMOR MALIGNO DEL CONDUCTO CRANEOFARINGEO"
      },
      {
        "codigo": "C753",
        "valor": "TUMOR MALIGNO DE LA GLANDULA PINEAL"
      },
      {
        "codigo": "C754",
        "valor": "TUMOR MALIGNO DEL CUERPO CAROTIDEO"
      },
      {
        "codigo": "C755",
        "valor": "TUMOR MALIGNO DEL CUERPO AORTICO Y OTROS CUERPOS CROMAFINES"
      },
      {
        "codigo": "C758",
        "valor": "TUMOR MALIGNO PLURIGLANDULAR, NO ESPECIFICADO"
      },
      {
        "codigo": "C759",
        "valor": "TUMOR MALIGNO DE GLANDULA ENDOCRINA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C76 - TUMOR MALIGNO DE OTROS SITIOS Y DE SITIOS MAL DEFINIDOS",
    "detalle": [
      {
        "codigo": "C760",
        "valor": "TUMOR MALIGNO DE LA CABEZA, CARA Y CUELLO"
      },
      {
        "codigo": "C761",
        "valor": "TUMOR MALIGNO DEL TORAX"
      },
      {
        "codigo": "C762",
        "valor": "TUMOR MALIGNO DEL ABDOMEN"
      },
      {
        "codigo": "C763",
        "valor": "TUMOR MALIGNO DE LA PELVIS"
      },
      {
        "codigo": "C764",
        "valor": "TUMOR MALIGNO DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "C765",
        "valor": "TUMOR MALIGNO DEL MIEMBRO INFERIOR"
      },
      {
        "codigo": "C767",
        "valor": "TUMOR MALIGNO DE OTROS SITIOS MAL DEFINIDOS"
      },
      {
        "codigo": "C768",
        "valor": "LESION DE SITIOS CONTIGUOS MAL DEFINIDOS"
      }
    ]
  },
  {
    "grupo": "C77 - TUMOR MALIGNO SECUNDARIO Y EL NO ESPECIFICADO DE LOS GANGLIOS LINFATICOS, ESPECIFICADOS COMO PRIMARIO",
    "detalle": [
      {
        "codigo": "C770",
        "valor": "TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS DE LA CABEZA, CARA Y CUELLO"
      },
      {
        "codigo": "C771",
        "valor": "TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS INTRATORACICOS"
      },
      {
        "codigo": "C772",
        "valor": "TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS INTRAABDOMINALES"
      },
      {
        "codigo": "C773",
        "valor": "TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS DE LA AXILA Y DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "C774",
        "valor": "TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS DE LA REGION INGUINAL Y DEL MIEMBRO INFERIOR"
      },
      {
        "codigo": "C775",
        "valor": "TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS DE LA PELVIS"
      },
      {
        "codigo": "C778",
        "valor": "TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS DE REGIONES MULTIPLES"
      },
      {
        "codigo": "C779",
        "valor": "TUMOR MALIGNO DEL GANGLIO LINFATICO, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C78 - TUMOR MALIGNO SECUNDARIO DE LOS ORGANOS RESPIRATORIOS Y DIGESTIVOS",
    "detalle": [
      {
        "codigo": "C780",
        "valor": "TUMOR MALIGNO SECUNDARIO DEL PULMON"
      },
      {
        "codigo": "C781",
        "valor": "TUMOR MALIGNO SECUNDARIO DEL MEDIASTINO"
      },
      {
        "codigo": "C782",
        "valor": "TUMOR MALIGNO SECUNDARIO DE LA PLEURA"
      },
      {
        "codigo": "C783",
        "valor": "TUMOR MALIGNO SECUNDARIO DE OTROS ORGANOS RESPIRATORIOS Y DE LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "C784",
        "valor": "TUMOR MALIGNO SECUNDARIO DEL INTESTINO DELGADO"
      },
      {
        "codigo": "C785",
        "valor": "TUMOR MALIGNO SECUNDARIO DEL INTESTINO GRUESO Y DEL RECTO"
      },
      {
        "codigo": "C786",
        "valor": "TUMOR MALIGNO SECUNDARIO DEL PERITONEO Y DEL RETROPERITONEO"
      },
      {
        "codigo": "C787",
        "valor": "TUMOR MALIGNO SECUNDARIO DEL HIGADO Y DE LOS CONDUCTOS BILIARES INTRAHEPATICOS"
      },
      {
        "codigo": "C788",
        "valor": "TUMOR MALIGNO SECUNDARIO DE OTROS ORGANOS DIGESTIVOS Y DE LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "C79 - TUMOR MALIGNO SECUNDARIO DE OTROS SITIOS Y LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "C790",
        "valor": "TUMOR MALIGNO SECUNDARIO DEL RIÑON Y DE LA PELVIS RENAL"
      },
      {
        "codigo": "C791",
        "valor": "TUMOR MALIGNO SECUNDARIO DE LA VEJIGA, Y DE OTROS ORGANOS Y LOS NO ESPECIFICADOS DE LAS VIAS URINARIAS"
      },
      {
        "codigo": "C792",
        "valor": "TUMOR MALIGNO SECUNDARIO DE LA PIEL"
      },
      {
        "codigo": "C793",
        "valor": "TUMOR MALIGNO SECUNDARIO DEL ENCEFALO Y DE LAS MENINGES CEREBRALES"
      },
      {
        "codigo": "C794",
        "valor": "TUMOR MALIGNO SECUNDARIO DE OTRAS PARTES DEL SISTEMA NERVIOSO Y DE LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "C795",
        "valor": "TUMOR MALIGNO SECUNDARIO DE LOS HUESOS Y DE LA MEDULA OSEA"
      },
      {
        "codigo": "C796",
        "valor": "TUMOR MALIGNO SECUNDARIO DEL OVARIO"
      },
      {
        "codigo": "C797",
        "valor": "TUMOR MALIGNO SECUNDARIO DE LA GLANDULA SUPRARRENAL"
      },
      {
        "codigo": "C798",
        "valor": "TUMOR MALIGNO SECUNDARIO DE OTROS SITIOS ESPECIFICADOS"
      },
      {
        "codigo": "C799",
        "valor": "TUMOR MALIGNO SECUNDARIO, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C80 - TUMOR MALIGNO DE SITIOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "C800",
        "valor": "TUMOR MALIGNO, DE SITIO PRIMARIO DESCONOCIDO, ASI DESCRITO"
      },
      {
        "codigo": "C809",
        "valor": "TUMOR MALIGNO, SITIO PRIMARIO NO ESPECIFICADO"
      },
      {
        "codigo": "C80X",
        "valor": "TUMOR MALIGNO DE SITIOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "C81 - LINFOMA DE HODGKIN",
    "detalle": [
      {
        "codigo": "C810",
        "valor": "LINFOMA DE HODGKIN CON PREDOMINIO LINFOCITICO NODULAR"
      },
      {
        "codigo": "C811",
        "valor": "LINFOMA DE HODGKIN CLASICO CON ESCLEROSIS NODULAR"
      },
      {
        "codigo": "C812",
        "valor": "LINFOMA DE HODGKIN CLASICO CON CELULARIDAD MIXTA"
      },
      {
        "codigo": "C813",
        "valor": "LINFOMA DE HODGKIN CLASICO CON DEPLECION LINFOCITICA"
      },
      {
        "codigo": "C814",
        "valor": "LINFOMA DE HODGKIN CLASICO RICO EN LINFOCITOS"
      },
      {
        "codigo": "C817",
        "valor": "OTROS LINFOMAS DE HODGKIN CLASICOS"
      },
      {
        "codigo": "C819",
        "valor": "LINFOMA DE HODGKIN, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C82 - LINFOMA FOLICULAR",
    "detalle": [
      {
        "codigo": "C820",
        "valor": "LINFOMA FOLICULAR GRADO I"
      },
      {
        "codigo": "C821",
        "valor": "LINFOMA FOLICULAR GRADO II"
      },
      {
        "codigo": "C822",
        "valor": "LINFOMA FOLICULAR GRADO III NO ESPECIFICADO"
      },
      {
        "codigo": "C823",
        "valor": "LINFOMA FOLICULAR GRADO IIIA"
      },
      {
        "codigo": "C824",
        "valor": "LINFOMA FOLICULAR GRADO IIIB"
      },
      {
        "codigo": "C825",
        "valor": "LINFOMA CENTRO FOLICULAR DIFUSO"
      },
      {
        "codigo": "C826",
        "valor": "LINFOMA CENTRO FOLICULAR CUTANEO"
      },
      {
        "codigo": "C827",
        "valor": "OTROS TIPOS ESPECIFICADOS DE LINFOMA FOLICULAR"
      },
      {
        "codigo": "C829",
        "valor": "LINFOMA FOLICULAR, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "C83 - LINFOMA NO FOLICULAR",
    "detalle": [
      {
        "codigo": "C830",
        "valor": "LINFOMA DE CELULAS B PEQUEÑAS"
      },
      {
        "codigo": "C831",
        "valor": "LINFOMA DE CELULAS DEL MANTO"
      },
      {
        "codigo": "C832",
        "valor": "LINFOMA NO HODGKIN MIXTO, DE CELULAS PEQUEÑAS Y GRANDES (DIFUSO)"
      },
      {
        "codigo": "C833",
        "valor": "LINFOMA DE CELULAS GRANDES B DIFUSO"
      },
      {
        "codigo": "C834",
        "valor": "LINFOMA NO HODGKIN INMUNOBLASTICO (DIFUSO)"
      },
      {
        "codigo": "C835",
        "valor": "LINFOMA LINFOBLASTICO (DIFUSO)"
      },
      {
        "codigo": "C836",
        "valor": "LINFOMA NO HODGKIN INDIFERENCIADO (DIFUSO)"
      },
      {
        "codigo": "C837",
        "valor": "LINFOMA DE BURKITT"
      },
      {
        "codigo": "C838",
        "valor": "OTROS TIPOS ESPECIFICADOS DE LINFOMA NO FOLICULAR"
      },
      {
        "codigo": "C839",
        "valor": "LINFOMA NO FOLICULAR (DIFUSO), SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "C84 - LINFOMA DE CELULAS T / NK MADURAS",
    "detalle": [
      {
        "codigo": "C840",
        "valor": "MICOSIS FUNGOIDE"
      },
      {
        "codigo": "C841",
        "valor": "ENFERMEDAD DE SEZARY"
      },
      {
        "codigo": "C842",
        "valor": "LINFOMA DE ZONA T"
      },
      {
        "codigo": "C843",
        "valor": "LINFOMA LINFOEPITELIOIDE"
      },
      {
        "codigo": "C844",
        "valor": "LINFOMA PERIFERICO DE CELULAS T, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "C845",
        "valor": "OTROS LINFOMAS DE CELULAS T/NK MADURAS"
      },
      {
        "codigo": "C846",
        "valor": "LINFOMA ANAPLASICO DE CELULAS GRANDES ALK-POSITIVO"
      },
      {
        "codigo": "C847",
        "valor": "LINFOMA ANAPLASICO DE CELULAS GRANDES ALK-NEGATIVO"
      },
      {
        "codigo": "C848",
        "valor": "LINFOMA CUTANEO DE CELULAS T, NO ESPECIFICADO"
      },
      {
        "codigo": "C849",
        "valor": "LINFOMA DE CELULAS T/NK MADURAS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C85 - LINFOMA NO HODGKIN DE OTRO TIPO Y EL NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "C850",
        "valor": "LINFOSARCOMA"
      },
      {
        "codigo": "C851",
        "valor": "LINFOMA DE CELULAS B, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "C852",
        "valor": "LINFOMA MEDIASTINAL DE CELULAS B GRANDES (DEL TIMO)"
      },
      {
        "codigo": "C857",
        "valor": "OTROS TIPOS ESPECIFICADOS DE LINFOMA NO HODGKIN"
      },
      {
        "codigo": "C859",
        "valor": "LINFOMA NO HODGKIN, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "C86 - OTROS TIPOS ESPECIFICADOS DE LINFOMAS DE CELULAS T/NK",
    "detalle": [
      {
        "codigo": "C860",
        "valor": "LINFOMA EXTRAÑODAL DE CELULAS T/NK, TIPO NASAL"
      },
      {
        "codigo": "C861",
        "valor": "LINFOMA HEPATOESPLENICO DE CELULAS T"
      },
      {
        "codigo": "C862",
        "valor": "LINFOMA DE CELULAS T TIPO ENTEROPATIA (INTESTINAL)"
      },
      {
        "codigo": "C863",
        "valor": "LINFOMA DE CELULAS T TIPO PANICULITIS SUBCUTANEA"
      },
      {
        "codigo": "C864",
        "valor": "LINFOMA BLASTICO DE CELULAS NK"
      },
      {
        "codigo": "C865",
        "valor": "LINFOMA ANGIOINMUNOBLASTICO DE CELULAS T"
      },
      {
        "codigo": "C866",
        "valor": "TRASTORNOS LINFOPROLIFERATIVOS PRIMARIO CUTANEOS DE CELULAS T CD30-POSITIVO"
      }
    ]
  },
  {
    "grupo": "C88 - OTROS LINFOMAS DE CELULA B [ENFERMEDAES INMUNO PROLIFERATIVAS MALIGNAS]",
    "detalle": [
      {
        "codigo": "C880",
        "valor": "MACROGLOBULINEMIA DE WALDENSTRÖM"
      },
      {
        "codigo": "C881",
        "valor": "ENFERMEDAD DE CADENA PESADA ALFA"
      },
      {
        "codigo": "C882",
        "valor": "OTRAS ENFERMEDADES DE CADENA PESADA"
      },
      {
        "codigo": "C883",
        "valor": "ENFERMEDAD INMUNOPROLIFERATIVA DEL INTESTINO DELGADO"
      },
      {
        "codigo": "C884",
        "valor": "LINFOMA DE CELULAS B EXTRAÑODAL DE ZONA MARGINAL DE TEJIDO LINFOIDE ASOCIADO A MUCOSAS [LINFOMA TLAM]"
      },
      {
        "codigo": "C887",
        "valor": "OTRAS ENFERMEDADES INMUNOPROLIFERATIVAS MALIGNAS"
      },
      {
        "codigo": "C889",
        "valor": "ENFERMEDAD INMUNOPROLIFERATIVA MALIGNA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "C90 - MIELOMA MULTIPLE Y TUMORES MALIGNOS DE CELULAS PLASMATICAS",
    "detalle": [
      {
        "codigo": "C900",
        "valor": "MIELOMA MULTIPLE"
      },
      {
        "codigo": "C901",
        "valor": "LEUCEMIA DE CELULAS PLASMATICAS"
      },
      {
        "codigo": "C902",
        "valor": "PLASMOCITOMA EXTRAMEDULAR"
      },
      {
        "codigo": "C903",
        "valor": "PLASMOCITOMA SOLITARIO"
      }
    ]
  },
  {
    "grupo": "C91 - LEUCEMIA LINFOIDE",
    "detalle": [
      {
        "codigo": "C910",
        "valor": "LEUCEMIA LINFOBLASTICA AGUDA [LLA]"
      },
      {
        "codigo": "C911",
        "valor": "LEUCEMIA LINFOCITICA CRONICA DE CELULA TIPO B"
      },
      {
        "codigo": "C912",
        "valor": "LEUCEMIA LINFOCITICA SUBAGUDA"
      },
      {
        "codigo": "C913",
        "valor": "LEUCEMIA PROLINFOCITICA DE CELULA TIPO B"
      },
      {
        "codigo": "C914",
        "valor": "LEUCEMIA DE CELULAS VELLOSAS"
      },
      {
        "codigo": "C915",
        "valor": "LEUCEMIA/LINFOMA DE CELULAS T ADULTAS [HTLV-1-ASOCIADO]"
      },
      {
        "codigo": "C916",
        "valor": "LEUCEMIA PROLINFOCITICA DE CELULAS TIPO T"
      },
      {
        "codigo": "C917",
        "valor": "OTRAS LEUCEMIAS LINFOIDES"
      },
      {
        "codigo": "C918",
        "valor": "LEUCEMIA TIPO BURKITT DE CELULAS B MADURAS"
      },
      {
        "codigo": "C919",
        "valor": "LEUCEMIA LINFOIDE, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "C92 - LEUCEMIA MIELOIDE",
    "detalle": [
      {
        "codigo": "C920",
        "valor": "LEUCEMIA MIELOBLASTICA AGUDA [LMA]"
      },
      {
        "codigo": "C921",
        "valor": "LEUCEMIA MIELOIDE CRONICA [LMC], BCR/ABL-POSITIVO"
      },
      {
        "codigo": "C922",
        "valor": "LEUCEMIA MIELOIDE CRONICA ATIPICA, BCR/ABL-NEGATIVO"
      },
      {
        "codigo": "C923",
        "valor": "SARCOMA MIELOIDE"
      },
      {
        "codigo": "C924",
        "valor": "LEUCEMIA PROMIELOCITICA AGUDA [LPA]"
      },
      {
        "codigo": "C925",
        "valor": "LEUCEMIA MIELOMONOCITICA AGUDA"
      },
      {
        "codigo": "C926",
        "valor": "LEUCEMIA MIELOIDE AGUDA CON ANORMALIDAD 11Q23"
      },
      {
        "codigo": "C927",
        "valor": "OTRAS LEUCEMIAS MIELOIDES"
      },
      {
        "codigo": "C928",
        "valor": "LEUCEMIA MIELOIDE AGUDA CON DISPLASIA MULTILINAJE"
      },
      {
        "codigo": "C929",
        "valor": "LEUCEMIA MIELOIDE, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "C93 - LEUCEMIA MONOCITICA",
    "detalle": [
      {
        "codigo": "C930",
        "valor": "LEUCEMIA MONOCITICA/MONOBLASTICA AGUDA"
      },
      {
        "codigo": "C931",
        "valor": "LEUCEMIA MIELOMONOCITICA CRONICA"
      },
      {
        "codigo": "C932",
        "valor": "LEUCEMIA MONOCITICA SUBAGUDA"
      },
      {
        "codigo": "C933",
        "valor": "LEUCEMIA MIELOMONOCITICA JUVENIL"
      },
      {
        "codigo": "C937",
        "valor": "OTRAS LEUCEMIAS MONOCITICAS"
      },
      {
        "codigo": "C939",
        "valor": "LEUCEMIA MONOCITICA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "C94 - OTRAS LEUCEMIAS DE TIPO CELULAR ESPECIFICADO",
    "detalle": [
      {
        "codigo": "C940",
        "valor": "LEUCEMIA ERITROIDE AGUDA"
      },
      {
        "codigo": "C941",
        "valor": "ERITREMIA CRONICA"
      },
      {
        "codigo": "C942",
        "valor": "LEUCEMIA MEGACARIOBLASTICA AGUDA"
      },
      {
        "codigo": "C943",
        "valor": "LEUCEMIA DE MASTOCITOS"
      },
      {
        "codigo": "C944",
        "valor": "PANMIELOSIS AGUDA CON MIELOFIBROSIS"
      },
      {
        "codigo": "C945",
        "valor": "MIELOFIBROSIS AGUDA"
      },
      {
        "codigo": "C946",
        "valor": "ENFERMEDAD MIELODISPLASICA Y MIELOPROLIFERATIVA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "C947",
        "valor": "OTRAS LEUCEMIAS ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "C95 - LEUCEMIA DE CELULAS DE TIPO NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "C950",
        "valor": "LEUCEMIA AGUDA, CELULAS DE TIPO NO ESPECIFICADO"
      },
      {
        "codigo": "C951",
        "valor": "LEUCEMIA CRONICA, CELULAS DE TIPO NO ESPECIFICADO"
      },
      {
        "codigo": "C952",
        "valor": "LEUCEMIA SUBAGUDA, CELULAS DE TIPO NO ESPECIFICADO"
      },
      {
        "codigo": "C957",
        "valor": "OTRAS LEUCEMIAS DE CELULAS DE TIPO NO ESPECIFICADO"
      },
      {
        "codigo": "C959",
        "valor": "LEUCEMIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "C96 - OTROS TUMORES MALIGNOS Y LOS NO ESPECIFICADOS DEL TEJIDO LINFATICO, DE LOS ORGANOS HEMATOPOYETICOS Y DE TEJIDOS AFINES",
    "detalle": [
      {
        "codigo": "C960",
        "valor": "HISTIOCITOSIS DE CELULAS DE LANGERHANS MULTIFOCAL Y MULTISISTEMICA (DISEMINADA) [ENFERMEDAD DE LETTERER-SIWE]"
      },
      {
        "codigo": "C961",
        "valor": "HISTIOCITOSIS MALIGNA"
      },
      {
        "codigo": "C962",
        "valor": "TUMOR MALIGNO DE MASTOCITOS"
      },
      {
        "codigo": "C963",
        "valor": "LINFOMA HISTIOCITICO VERDADERO"
      },
      {
        "codigo": "C964",
        "valor": "SARCOMA DE CELULAS DENDRITICAS (CELULAS ACCESORIAS)"
      },
      {
        "codigo": "C965",
        "valor": "HISTIOCITOSIS DE CELULAS DE LANGERHANS MULTIFOCAL Y UNISISTEMICA"
      },
      {
        "codigo": "C966",
        "valor": "HISTIOCITOSIS DE CELULAS DE LANGERHANS UNIFOCAL"
      },
      {
        "codigo": "C967",
        "valor": "OTROS TUMORES MALIGNOS ESPECIFICADOS DEL TEJIDO LINFATICO, HEMATOPOYETICO Y TEJIDOS AFINES"
      },
      {
        "codigo": "C968",
        "valor": "SARCOMA HISTIOCITICO"
      },
      {
        "codigo": "C969",
        "valor": "TUMOR MALIGNO DEL TEJIDO LINFATICO, HEMATOPOYETICO Y TEJIDOS AFINES, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "C97 - TUMORES MALIGNOS (PRIMARIOS) DE SITIOS MULTIPLES INDEPENDIENTES",
    "detalle": [
      {
        "codigo": "C97X",
        "valor": "TUMOR MALIGNO(PRIMARIO) DE SITIOS MULTIPLES INDEPENDIENTES"
      }
    ]
  },
  {
    "grupo": "D00 - CARCINOMA IN SITU DE LA CAVIDAD BUCAL, DEL ESOFAGO Y DEL ESTOMAGO",
    "detalle": [
      {
        "codigo": "D000",
        "valor": "CARCINOMA IN SITU DEL LABIO, DE LA CAVIDAD BUCAL Y DE LA FARINGE"
      },
      {
        "codigo": "D001",
        "valor": "CARCINOMA IN SITU DEL ESOFAGO"
      },
      {
        "codigo": "D002",
        "valor": "CARCINOMA IN SITU DEL ESTOMAGO"
      }
    ]
  },
  {
    "grupo": "D01 - CARCINOMA IN SITU DE OTROS ORGANOS DIGESTIVOS Y DE LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "D010",
        "valor": "CARCINOMA IN SITU DEL COLON"
      },
      {
        "codigo": "D011",
        "valor": "CARCINOMA IN SITU DE LA UNION RECTOSIGMOIDEA"
      },
      {
        "codigo": "D012",
        "valor": "CARCINOMA IN SITU DEL RECTO"
      },
      {
        "codigo": "D013",
        "valor": "CARCINOMA IN SITU DEL ANO Y DEL CONDUCTO ANAL"
      },
      {
        "codigo": "D014",
        "valor": "CARCINOMA IN SITU DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL INTESTINO"
      },
      {
        "codigo": "D015",
        "valor": "CARCINOMA IN SITU DEL HIGADO, DE LA VESICULA BILIAR Y DEL CONDUCTO BILIAR"
      },
      {
        "codigo": "D017",
        "valor": "CARCINOMA IN SITU DE OTRAS PARTES ESPECIFICADAS DE ORGANOS DIGESTIVOS"
      },
      {
        "codigo": "D019",
        "valor": "CARCINOMA IN SITU DE ORGANOS DIGESTIVOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "D02 - CARCINOMA IN SITU DEL SISTEMA RESPIRATORIO Y DEL OIDO MEDIO",
    "detalle": [
      {
        "codigo": "D020",
        "valor": "CARCINOMA IN SITU DE LA LARINGE"
      },
      {
        "codigo": "D021",
        "valor": "CARCINOMA IN SITU DE LA TRAQUEA"
      },
      {
        "codigo": "D022",
        "valor": "CARCINOMA IN SITU DEL BRONQUIO Y DEL PULMON"
      },
      {
        "codigo": "D023",
        "valor": "CARCINOMA IN SITU DE OTRAS PARTES DEL SISTEMA RESPIRATORIO"
      },
      {
        "codigo": "D024",
        "valor": "CARCINOMA IN SITU DE ORGANOS RESPIRATORIOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "D03 - MELANOMA IN SITU",
    "detalle": [
      {
        "codigo": "D030",
        "valor": "MELANOMA IN SITU DEL LABIO"
      },
      {
        "codigo": "D031",
        "valor": "MELANOMA IN SITU DEL PARPADO Y DE LA COMISURA PALPEBRAL"
      },
      {
        "codigo": "D032",
        "valor": "MELANOMA IN SITU DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO"
      },
      {
        "codigo": "D033",
        "valor": "MELANOMA IN SITU DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CARA"
      },
      {
        "codigo": "D034",
        "valor": "MELANOMA IN SITU DEL CUERO CABELLUDO Y DEL CUELLO"
      },
      {
        "codigo": "D035",
        "valor": "MELANOMA IN SITU DEL TRONCO"
      },
      {
        "codigo": "D036",
        "valor": "MELANOMA IN SITU DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO"
      },
      {
        "codigo": "D037",
        "valor": "MELANOMA IN SITU DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA"
      },
      {
        "codigo": "D038",
        "valor": "MELANOMA IN SITU DE OTROS SITIOS"
      },
      {
        "codigo": "D039",
        "valor": "MELANOMA IN SITU, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D04 - CARCINOMA IN SITU DE LA PIEL",
    "detalle": [
      {
        "codigo": "D040",
        "valor": "CARCINOMA IN SITU DE LA PIEL DEL LABIO"
      },
      {
        "codigo": "D041",
        "valor": "CARCINOMA IN SITU DE LA PIEL DEL PARPADO Y DE LA COMISURA PALPEBRAL"
      },
      {
        "codigo": "D042",
        "valor": "CARCINOMA IN SITU DE LA PIEL DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO"
      },
      {
        "codigo": "D043",
        "valor": "CARCINOMA IN SITU DE LA PIEL DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CARA"
      },
      {
        "codigo": "D044",
        "valor": "CARCINOMA IN SITU DE LA PIEL DEL CUERO CABELLUDO Y CUELLO"
      },
      {
        "codigo": "D045",
        "valor": "CARCINOMA IN SITU DE LA PIEL DEL TRONCO"
      },
      {
        "codigo": "D046",
        "valor": "CARCINOMA IN SITU DE LA PIEL DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO"
      },
      {
        "codigo": "D047",
        "valor": "CARCINOMA IN SITU DE LA PIEL DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA"
      },
      {
        "codigo": "D048",
        "valor": "CARCINOMA IN SITU DE LA PIEL DE OTROS SITIOS ESPECIFICADOS"
      },
      {
        "codigo": "D049",
        "valor": "CARCINOMA IN SITU DE LA PIEL, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D05 - CARCINOMA IN SITU DE LA MAMA",
    "detalle": [
      {
        "codigo": "D050",
        "valor": "CARCINOMA IN SITU LOBULAR"
      },
      {
        "codigo": "D051",
        "valor": "CARCINOMA IN SITU INTRACANALICULAR"
      },
      {
        "codigo": "D057",
        "valor": "OTROS CARCINOMAS IN SITU DE LA MAMA"
      },
      {
        "codigo": "D059",
        "valor": "CARCINOMA IN SITU DE LA MAMA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D06 - CARCINOMA IN SITU DEL CUELLO DEL UTERO",
    "detalle": [
      {
        "codigo": "D060",
        "valor": "CARCINOMA IN SITU DEL ENDOCERVIX"
      },
      {
        "codigo": "D061",
        "valor": "CARCINOMA IN SITU DEL EXOCERVIX"
      },
      {
        "codigo": "D067",
        "valor": "CARCINOMA IN SITU DE OTRAS PARTES ESPECIFICADAS DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "D069",
        "valor": "CARCINOMA IN SITU DEL CUELLO DEL UTERO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D07 - CARCINOMA IN SITU DE OTROS ORGANOS GENITALES Y DE LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "D070",
        "valor": "CARCINOMA IN SITU DEL ENDOMETRIO"
      },
      {
        "codigo": "D071",
        "valor": "CARCINOMA IN SITU DE LA VULVA"
      },
      {
        "codigo": "D072",
        "valor": "CARCINOMA IN SITU DE LA VAGINA"
      },
      {
        "codigo": "D073",
        "valor": "CARCINOMA IN SITU DE OTROS SITIOS DE ORGANOS GENITALES FEMENINOS Y DE LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "D074",
        "valor": "CARCINOMA IN SITU DEL PENE"
      },
      {
        "codigo": "D075",
        "valor": "CARCINOMA IN SITU DE LA PROSTATA"
      },
      {
        "codigo": "D076",
        "valor": "CARCINOMA IN SITU DE OTROS ORGANOS GENITALES MASCULINOS Y DE LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "D09 - CARCINOMA IN SITU DE OTROS SITIOS Y DE LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "D090",
        "valor": "CARCINOMA IN SITU DE LA VEJIGA"
      },
      {
        "codigo": "D091",
        "valor": "CARCINOMA IN SITU DE OTROS ORGANOS URINARIOS Y DE LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "D092",
        "valor": "CARCINOMA IN SITU DEL OJO"
      },
      {
        "codigo": "D093",
        "valor": "CARCINOMA IN SITU DE LA GLANDULA TIROIDES Y DE OTRAS GLANDULAS ENDOCRINAS"
      },
      {
        "codigo": "D097",
        "valor": "CARCINOMA IN SITU DE OTROS SITIOS ESPECIFICADOS"
      },
      {
        "codigo": "D099",
        "valor": "CARCINOMA IN SITU, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D10 - TUMOR BENIGNO DE LA BOCA Y DE LA FARINGE",
    "detalle": [
      {
        "codigo": "D100",
        "valor": "TUMOR BENIGNO DEL LABIO"
      },
      {
        "codigo": "D101",
        "valor": "TUMOR BENIGNO DE LA LENGUA"
      },
      {
        "codigo": "D102",
        "valor": "TUMOR BENIGNO DEL PISO DE LA BOCA"
      },
      {
        "codigo": "D103",
        "valor": "TUMOR BENIGNO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA BOCA"
      },
      {
        "codigo": "D104",
        "valor": "TUMOR BENIGNO DE LA AMIGDALA"
      },
      {
        "codigo": "D105",
        "valor": "TUMOR BENIGNO DE OTRAS PARTES DE LA OROFARINGE"
      },
      {
        "codigo": "D106",
        "valor": "TUMOR BENIGNO DE LA NASOFARINGE"
      },
      {
        "codigo": "D107",
        "valor": "TUMOR BENIGNO DE LA HIPOFARINGE"
      },
      {
        "codigo": "D109",
        "valor": "TUMOR BENIGNO DE LA FARINGE, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D11 - TUMOR BENIGNO DE LAS GLANDULAS SALIVALES MAYORES",
    "detalle": [
      {
        "codigo": "D110",
        "valor": "TUMOR BENIGNO DE LA GLANDULA PAROTIDA"
      },
      {
        "codigo": "D117",
        "valor": "TUMOR BENIGNO DE OTRAS GLANDULAS SALIVALES MAYORES ESPECIFICADAS"
      },
      {
        "codigo": "D119",
        "valor": "TUMOR BENIGNO DE LA GLANDULA SALIVAL MAYOR, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "D12 - TUMOR BENIGNO DEL COLON, DEL RECTO, DEL CONDUCTO ANAL Y DEL ANO",
    "detalle": [
      {
        "codigo": "D120",
        "valor": "TUMOR BENIGNO DEL CIEGO"
      },
      {
        "codigo": "D121",
        "valor": "TUMOR BENIGNO DEL APENDICE"
      },
      {
        "codigo": "D122",
        "valor": "TUMOR BENIGNO DEL COLON ASCENDENTE"
      },
      {
        "codigo": "D123",
        "valor": "TUMOR BENIGNO DEL COLON TRANSVERSO"
      },
      {
        "codigo": "D124",
        "valor": "TUMOR BENIGNO DEL COLON DESCENDENTE"
      },
      {
        "codigo": "D125",
        "valor": "TUMOR BENIGNO DEL COLON SIGMOIDE"
      },
      {
        "codigo": "D126",
        "valor": "TUMOR BENIGNO DEL COLON, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "D127",
        "valor": "TUMOR BENIGNO DE LA UNION RECTOSIGMOIDEA"
      },
      {
        "codigo": "D128",
        "valor": "TUMOR BENIGNO DEL RECTO"
      },
      {
        "codigo": "D129",
        "valor": "TUMOR BENIGNO DEL CONDUCTO ANAL Y DEL ANO"
      }
    ]
  },
  {
    "grupo": "D13 - TUMOR BENIGNO DE OTRAS PARTES Y DE LAS MAL DEFINIDAS DEL SISTEMA DIGESTIVO",
    "detalle": [
      {
        "codigo": "D130",
        "valor": "TUMOR BENIGNO DEL ESOFAGO"
      },
      {
        "codigo": "D131",
        "valor": "TUMOR BENIGNO DEL ESTOMAGO"
      },
      {
        "codigo": "D132",
        "valor": "TUMOR BENIGNO DEL DUODENO"
      },
      {
        "codigo": "D133",
        "valor": "TUMOR BENIGNO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL INTESTINO DELGADO"
      },
      {
        "codigo": "D134",
        "valor": "TUMOR BENIGNO DEL HIGADO"
      },
      {
        "codigo": "D135",
        "valor": "TUMOR BENIGNO DE LAS VIAS BILIARES EXTRAHEPATICAS"
      },
      {
        "codigo": "D136",
        "valor": "TUMOR BENIGNO DEL PANCREAS"
      },
      {
        "codigo": "D137",
        "valor": "TUMOR BENIGNO DEL PANCREAS ENDOCRINO"
      },
      {
        "codigo": "D139",
        "valor": "TUMOR BENIGNO DE SITIOS MAL DEFINIDOS DEL SISTEMA DIGESTIVO"
      }
    ]
  },
  {
    "grupo": "D14 - TUMOR BENIGNO DEL OIDO MEDIO Y DEL SISTEMA RESPIRATORIO",
    "detalle": [
      {
        "codigo": "D140",
        "valor": "TUMOR BENIGNO DEL OIDO MEDIO, DE LA CAVIDAD NASAL Y DE LOS SENOS PARANASALES"
      },
      {
        "codigo": "D141",
        "valor": "TUMOR BENIGNO DE LA LARINGE"
      },
      {
        "codigo": "D142",
        "valor": "TUMOR BENIGNO DE LA TRAQUEA"
      },
      {
        "codigo": "D143",
        "valor": "TUMOR BENIGNO DE LOS BRONQUIOS Y DEL PULMON"
      },
      {
        "codigo": "D144",
        "valor": "TUMOR BENIGNO DEL SISTEMA RESPIRATORIO, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D15 - TUMOR BENIGNO DE OTROS ORGANOS INTRATORACICOS Y DE LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "D150",
        "valor": "TUMOR BENIGNO DEL TIMO"
      },
      {
        "codigo": "D151",
        "valor": "TUMOR BENIGNO DEL CORAZON"
      },
      {
        "codigo": "D152",
        "valor": "TUMOR BENIGNO DEL MEDIASTINO"
      },
      {
        "codigo": "D157",
        "valor": "TUMOR BENIGNO DE OTROS ORGANOS INTRATORACICOS ESPECIFICADOS"
      },
      {
        "codigo": "D159",
        "valor": "TUMOR BENIGNO DE ORGANO INTRATORACICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D16 - TUMOR BENIGNO DEL HUESO Y DEL CARTILAGO ARTICULAR",
    "detalle": [
      {
        "codigo": "D160",
        "valor": "TUMOR BENIGNO DEL OMOPLATO Y HUESOS LARGOS DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "D161",
        "valor": "TUMOR BENIGNO DE LOS HUESOS CORTOS DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "D162",
        "valor": "TUMOR BENIGNO DE LOS HUESOS LARGOS DEL MIEMBRO INFERIOR"
      },
      {
        "codigo": "D163",
        "valor": "TUMOR BENIGNO DE LOS HUESOS CORTOS DEL MIEMBRO INFERIOR"
      },
      {
        "codigo": "D164",
        "valor": "TUMOR BENIGNO DE LOS HUESOS DEL CRANEO Y DE LA CARA"
      },
      {
        "codigo": "D165",
        "valor": "TUMOR BENIGNO DEL MAXILAR INFERIOR"
      },
      {
        "codigo": "D166",
        "valor": "TUMOR BENIGNO DE LA COLUMNA VERTEBRAL"
      },
      {
        "codigo": "D167",
        "valor": "TUMOR BENIGNO DE LAS COSTILLAS, ESTERNON Y CLAVICULA"
      },
      {
        "codigo": "D168",
        "valor": "TUMOR BENIGNO DE LOS HUESOS PELVICOS, SACRO Y COCCIX"
      },
      {
        "codigo": "D169",
        "valor": "TUMOR BENIGNO DEL HUESO Y DEL CARTILAGO ARTICULAR, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D17 - TUMORES BENIGNOS LIPOMATOSOS",
    "detalle": [
      {
        "codigo": "D170",
        "valor": "TUMOR BENIGNO LIPOMATOSO DE PIEL Y DE TEJIDO SUBCUTANEO DE CABEZA, CARA Y CUELLO"
      },
      {
        "codigo": "D171",
        "valor": "TUMOR BENIGNO LIPOMATOSO DE PIEL Y DE TEJIDO SUBCUTANEO DEL TRONCO"
      },
      {
        "codigo": "D172",
        "valor": "TUMOR BENIGNO LIPOMATOSO DE PIEL Y DE TEJIDO SUBCUTANEO DE MIEMBROS"
      },
      {
        "codigo": "D173",
        "valor": "TUMOR BENIGNO LIPOMATOSO DE PIEL Y DE TEJIDO SUBCUTANEO DE OTROS SITIOS Y DE LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "D174",
        "valor": "TUMOR BENIGNO LIPOMATOSO DE LOS ORGANOS INTRATORACICOS"
      },
      {
        "codigo": "D175",
        "valor": "TUMOR BENIGNO LIPOMATOSO DE LOS ORGANOS INTRAABDOMINALES"
      },
      {
        "codigo": "D176",
        "valor": "TUMOR BENIGNO LIPOMATOSO DEL CORDON ESPERMATICO"
      },
      {
        "codigo": "D177",
        "valor": "TUMOR BENIGNO LIPOMATOSO DE OTROS SITIOS ESPECIFICADOS"
      },
      {
        "codigo": "D179",
        "valor": "TUMOR BENIGNO LIPOMATOSO, DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D18 - HEMANGIOMA Y LINFANGIOMA DE CUALQUIER SITIO",
    "detalle": [
      {
        "codigo": "D180",
        "valor": "HEMANGIOMA, DE CUALQUIER SITIO"
      },
      {
        "codigo": "D181",
        "valor": "LINFANGIOMA, DE CUALQUIER SITIO"
      }
    ]
  },
  {
    "grupo": "D19 - TUMORES BENIGNOS DEL TEJIDO MESOTELIAL",
    "detalle": [
      {
        "codigo": "D190",
        "valor": "TUMOR BENIGNO DEL TEJIDO MESOTELIAL DE LA PLEURA"
      },
      {
        "codigo": "D191",
        "valor": "TUMOR BENIGNO DEL TEJIDO MESOTELIAL DEL PERITONEO"
      },
      {
        "codigo": "D197",
        "valor": "TUMOR BENIGNO DEL TEJIDO MESOTELIAL DE OTROS SITIOS ESPECIFICADOS"
      },
      {
        "codigo": "D199",
        "valor": "TUMOR BENIGNO DEL TEJIDO MESOTELIAL, DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D20 - TUMOR BENIGNO DEL TEJIDO BLANDO DEL PERITONEO Y DEL RETROPERITONEO",
    "detalle": [
      {
        "codigo": "D200",
        "valor": "TUMOR BENIGNO DEL RETROPERITONEO"
      },
      {
        "codigo": "D201",
        "valor": "TUMOR BENIGNO DEL PERITONEO"
      }
    ]
  },
  {
    "grupo": "D21 - OTROS TUMORES BENIGNOS DEL TEJIDO CONJUNTIVO Y DE LOS TEJIDOS BLANDOS",
    "detalle": [
      {
        "codigo": "D210",
        "valor": "TUMOR BENIGNO DEL TEJIDO CONJUNTIVO Y DE OTROS TEJIDOS BLANDOS DE CABEZA, CARA Y CUELLO"
      },
      {
        "codigo": "D211",
        "valor": "TUMOR BENIGNO DEL TEJIDO CONJUNTIVO Y DE OTROS TEJIDOS BLANDOS DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO"
      },
      {
        "codigo": "D212",
        "valor": "TUMOR BENIGNO DEL TEJIDO CONJUNTIVO Y DE OTROS TEJIDOS BLANDOS DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA"
      },
      {
        "codigo": "D213",
        "valor": "TUMOR BENIGNO DEL TEJIDO CONJUNTIVO Y DE OTROS TEJIDOS BLANDOS DEL TORAX"
      },
      {
        "codigo": "D214",
        "valor": "TUMOR BENIGNO DEL TEJIDO CONJUNTIVO Y OTROS TEJIDOS BLANDOS DEL ABDOMEN"
      },
      {
        "codigo": "D215",
        "valor": "TUMOR BENIGNO DEL TEJIDO CONJUNTIVO Y OTROS TEJIDOS BLANDOS DE LA PELVIS"
      },
      {
        "codigo": "D216",
        "valor": "TUMOR BENIGNO DEL TEJIDO CONJUNTIVO Y OTROS TEJIDOS BLANDOS DEL TRONCO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "D219",
        "valor": "TUMOR BENIGNO DEL TEJIDO CONJUNTIVO Y OTROS TEJIDOS BLANDOS, DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D22 - NEVO MELANOCITICO",
    "detalle": [
      {
        "codigo": "D220",
        "valor": "NEVO MELANOCITICO DEL LABIO"
      },
      {
        "codigo": "D221",
        "valor": "NEVO MELANOCITICO DEL PARPADO, INCLUIDA LA COMISURA PALPEBRAL"
      },
      {
        "codigo": "D222",
        "valor": "NEVO MELANOCITICO DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO"
      },
      {
        "codigo": "D223",
        "valor": "NEVO MELANOCITICO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CARA"
      },
      {
        "codigo": "D224",
        "valor": "NEVO MELANOCITICO DEL CUERO CABELLUDO Y DEL CUELLO"
      },
      {
        "codigo": "D225",
        "valor": "NEVO MELANOCITICO DEL TRONCO"
      },
      {
        "codigo": "D226",
        "valor": "NEVO MELANOCITICO DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO"
      },
      {
        "codigo": "D227",
        "valor": "NEVO MELANOCITICO DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA"
      },
      {
        "codigo": "D229",
        "valor": "NEVO MELANOCITICO, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D23 - OTROS TUMORES BENIGNOS DE LA PIEL",
    "detalle": [
      {
        "codigo": "D230",
        "valor": "TUMOR BENIGNO DE LA PIEL DEL LABIO"
      },
      {
        "codigo": "D231",
        "valor": "TUMOR BENIGNO DE LA PIEL DEL PARPADO, INCLUIDA LA COMISURA PALPEBRAL"
      },
      {
        "codigo": "D232",
        "valor": "TUMOR BENIGNO DE LA PIEL DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO"
      },
      {
        "codigo": "D233",
        "valor": "TUMOR BENIGNO DE LA PIEL DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CARA"
      },
      {
        "codigo": "D234",
        "valor": "TUMOR BENIGNO DE LA PIEL DEL CUERO CABELLUDO Y DEL CUELLO"
      },
      {
        "codigo": "D235",
        "valor": "TUMOR BENIGNO DE LA PIEL DEL TRONCO"
      },
      {
        "codigo": "D236",
        "valor": "TUMOR BENIGNO DE LA PIEL DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO"
      },
      {
        "codigo": "D237",
        "valor": "TUMOR BENIGNO DE LA PIEL DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA"
      },
      {
        "codigo": "D239",
        "valor": "TUMOR BENIGNO DE LA PIEL, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D24 - TUMOR BENIGNO DE LA MAMA",
    "detalle": [
      {
        "codigo": "D24X",
        "valor": "TUMOR BENIGNO DE LA MAMA"
      }
    ]
  },
  {
    "grupo": "D25 - LEIOMIOMA DEL UTERO",
    "detalle": [
      {
        "codigo": "D250",
        "valor": "LEIOMIOMA SUBMUCOSO DEL UTERO"
      },
      {
        "codigo": "D251",
        "valor": "LEIOMIOMA INTRAMURAL DEL UTERO"
      },
      {
        "codigo": "D252",
        "valor": "LEIOMIOMA SUBSEROSO DEL UTERO"
      },
      {
        "codigo": "D259",
        "valor": "LEIOMIOMA DEL UTERO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "D26 - OTROS TUMORES BENIGNOS DEL UTERO",
    "detalle": [
      {
        "codigo": "D260",
        "valor": "TUMOR BENIGNO DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "D261",
        "valor": "TUMOR BENIGNO DEL CUERPO DEL UTERO"
      },
      {
        "codigo": "D267",
        "valor": "TUMOR BENIGNO DE OTRAS PARTES ESPECIFICADAS DEL UTERO"
      },
      {
        "codigo": "D269",
        "valor": "TUMOR BENIGNO DEL UTERO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D27 - TUMOR BENIGNO DEL OVARIO",
    "detalle": [
      {
        "codigo": "D27X",
        "valor": "TUMOR BENIGNO DEL OVARIO"
      }
    ]
  },
  {
    "grupo": "D28 - TUMOR BENIGNO DE OTROS ORGANOS GENITALES FEMENINOS Y DE LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "D280",
        "valor": "TUMOR BENIGNO DE LA VULVA"
      },
      {
        "codigo": "D281",
        "valor": "TUMOR BENIGNO DE LA VAGINA"
      },
      {
        "codigo": "D282",
        "valor": "TUMOR BENIGNO DE LA TROMPA DE FALOPIO Y DE LOS LIGAMENTOS UTERINOS"
      },
      {
        "codigo": "D287",
        "valor": "TUMOR BENIGNO DE OTROS SITIOS ESPECIFICADOS DE LOS ORGANOS GENITALES FEMENINOS"
      },
      {
        "codigo": "D289",
        "valor": "TUMOR BENIGNO DE ORGANO GENITAL FEMENINO, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D29 - TUMOR BENIGNO DE LOS ORGANOS GENITALES MASCULINOS",
    "detalle": [
      {
        "codigo": "D290",
        "valor": "TUMOR BENIGNO DEL PENE"
      },
      {
        "codigo": "D291",
        "valor": "TUMOR BENIGNO DE LA PROSTATA"
      },
      {
        "codigo": "D292",
        "valor": "TUMOR BENIGNO DE LOS TESTICULOS"
      },
      {
        "codigo": "D293",
        "valor": "TUMOR BENIGNO DEL EPIDIDIMO"
      },
      {
        "codigo": "D294",
        "valor": "TUMOR BENIGNO DEL ESCROTO"
      },
      {
        "codigo": "D297",
        "valor": "TUMOR BENIGNO DE OTROS ORGANOS GENITALES MASCULINOS"
      },
      {
        "codigo": "D299",
        "valor": "TUMOR BENIGNO DE ORGANO GENITAL MASCULINO, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D30 - TUMOR BENIGNO DE LOS ORGANOS URINARIOS",
    "detalle": [
      {
        "codigo": "D300",
        "valor": "TUMOR BENIGNO DEL RIÑON"
      },
      {
        "codigo": "D301",
        "valor": "TUMOR BENIGNO DE LA PELVIS RENAL"
      },
      {
        "codigo": "D302",
        "valor": "TUMOR BENIGNO DEL URETER"
      },
      {
        "codigo": "D303",
        "valor": "TUMOR BENIGNO DE LA VEJIGA"
      },
      {
        "codigo": "D304",
        "valor": "TUMOR BENIGNO DE LA URETRA"
      },
      {
        "codigo": "D307",
        "valor": "TUMOR BENIGNO DE OTROS ORGANOS URINARIOS"
      },
      {
        "codigo": "D309",
        "valor": "TUMOR BENIGNO DE ORGANO URINARIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D31 - TUMOR BENIGNO DEL OJO Y SUS ANEXOS",
    "detalle": [
      {
        "codigo": "D310",
        "valor": "TUMOR BENIGNO DE LA CONJUNTIVA"
      },
      {
        "codigo": "D311",
        "valor": "TUMOR BENIGNO DE LA CORNEA"
      },
      {
        "codigo": "D312",
        "valor": "TUMOR BENIGNO DE LA RETINA"
      },
      {
        "codigo": "D313",
        "valor": "TUMOR BENIGNO DE LA COROIDES"
      },
      {
        "codigo": "D314",
        "valor": "TUMOR BENIGNO DEL CUERPO CILIAR"
      },
      {
        "codigo": "D315",
        "valor": "TUMOR BENIGNO DE LAS GLANDULAS Y DE LOS CONDUCTOS LAGRIMALES"
      },
      {
        "codigo": "D316",
        "valor": "TUMOR BENIGNO DE LA ORBITA, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "D319",
        "valor": "TUMOR BENIGNO DEL OJO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D32 - TUMORES BENIGNOS DE LAS MENINGES",
    "detalle": [
      {
        "codigo": "D320",
        "valor": "TUMOR BENIGNO DE LAS MENINGES CEREBRALES"
      },
      {
        "codigo": "D321",
        "valor": "TUMOR BENIGNO DE LAS MENINGES RAQUIDEAS"
      },
      {
        "codigo": "D329",
        "valor": "TUMOR BENIGNO DE LAS MENINGES, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D33 - TUMOR BENIGNO DEL ENCEFALO Y DE OTRAS PARTES DEL SISTEMA NERVIOSO CENTRAL",
    "detalle": [
      {
        "codigo": "D330",
        "valor": "TUMOR BENIGNO DEL ENCEFALO, SUPRATENTORIAL"
      },
      {
        "codigo": "D331",
        "valor": "TUMOR BENIGNO DEL ENCEFALO, INFRATENTORIAL"
      },
      {
        "codigo": "D332",
        "valor": "TUMOR BENIGNO DEL ENCEFALO, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "D333",
        "valor": "TUMOR BENIGNO DE LOS NERVIOS CRANEALES"
      },
      {
        "codigo": "D334",
        "valor": "TUMOR BENIGNO DE LA MEDULA ESPINAL"
      },
      {
        "codigo": "D337",
        "valor": "TUMOR BENIGNO DE OTRAS PARTES ESPECIFICADAS DEL SISTEMA NERVIOSO CENTRAL"
      },
      {
        "codigo": "D339",
        "valor": "TUMOR BENIGNO DEL SISTEMA NERVIOSO CENTRAL, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D34 - TUMOR BENIGNO DE LA GLANDULA TIROIDES",
    "detalle": [
      {
        "codigo": "D34X",
        "valor": "TUMOR BENIGNO DE LA GLANDULA TIROIDES"
      }
    ]
  },
  {
    "grupo": "D35 - TUMOR BENIGNO DE OTRAS GLANDULAS ENDOCRINAS Y DE LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "D350",
        "valor": "TUMOR BENIGNO DE LA GLANDULA SUPRARRENAL"
      },
      {
        "codigo": "D351",
        "valor": "TUMOR BENIGNO DE LA GLANDULA PARATIROIDES"
      },
      {
        "codigo": "D352",
        "valor": "TUMOR BENIGNO DE LA HIPOFISIS"
      },
      {
        "codigo": "D353",
        "valor": "TUMOR BENIGNO DEL CONDUCTO CRANEOFARINGEO"
      },
      {
        "codigo": "D354",
        "valor": "TUMOR BENIGNO DE LA GLANDULA PINEAL"
      },
      {
        "codigo": "D355",
        "valor": "TUMOR BENIGNO DEL CUERPO CAROTIDEO"
      },
      {
        "codigo": "D356",
        "valor": "TUMOR BENIGNO DEL CUERPO AORTICO Y DE OTROS CUERPOS CROMAFINES"
      },
      {
        "codigo": "D357",
        "valor": "TUMOR BENIGNO DE OTRAS GLANDULAS ENDOCRINAS ESPECIFICADAS"
      },
      {
        "codigo": "D358",
        "valor": "TUMOR BENIGNO PLURIGLANDULAR"
      },
      {
        "codigo": "D359",
        "valor": "TUMOR BENIGNO DE GLANDULA ENDOCRINA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D36 - TUMOR BENIGNO DE OTROS SITIOS Y DE LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "D360",
        "valor": "TUMOR BENIGNO DE LOS GANGLIOS LINFATICOS"
      },
      {
        "codigo": "D361",
        "valor": "TUMOR BENIGNO DE LOS NERVIOS PERIFERICOS Y DEL SISTEMA NERVIOSO AUTONOMO"
      },
      {
        "codigo": "D367",
        "valor": "TUMOR BENIGNO DE OTROS SITIOS ESPECIFICADOS"
      },
      {
        "codigo": "D369",
        "valor": "TUMOR BENIGNO DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D37 - TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA CAVIDAD BUCAL Y DE LOS ORGANOS DIGESTIVOS",
    "detalle": [
      {
        "codigo": "D370",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL LABIO, DE LA CAVIDAD BUCAL Y DE LA FARINGE"
      },
      {
        "codigo": "D371",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL ESTOMAGO"
      },
      {
        "codigo": "D372",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL INTESTINO DELGADO"
      },
      {
        "codigo": "D373",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL APENDICE"
      },
      {
        "codigo": "D374",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL COLON"
      },
      {
        "codigo": "D375",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL RECTO"
      },
      {
        "codigo": "D376",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL HIGADO, DE LA VESICULA BILIAR Y DEL CONDUCTO BILIAR"
      },
      {
        "codigo": "D377",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS ORGANOS DIGESTIVOS ESPECIFICADOS"
      },
      {
        "codigo": "D379",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE ORGANOS DIGESTIVOS, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D38 - TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL OIDO MEDIO Y DE LOS",
    "detalle": [
      {
        "codigo": "D380",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LARINGE"
      },
      {
        "codigo": "D381",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA TRAQUEA, DE LOS BRONQUIOS Y DEL PULMON"
      },
      {
        "codigo": "D382",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA PLEURA"
      },
      {
        "codigo": "D383",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL MEDIASTINO"
      },
      {
        "codigo": "D384",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TIMO"
      },
      {
        "codigo": "D385",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS ORGANOS RESPIRATORIOS Y DEL OIDO MEDIO"
      },
      {
        "codigo": "D386",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE ORGANOS RESPIRATORIOS, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D39 - TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LOS ORGANOS GENITALES FEMENINOS",
    "detalle": [
      {
        "codigo": "D390",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL UTERO"
      },
      {
        "codigo": "D391",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL OVARIO"
      },
      {
        "codigo": "D392",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA PLACENTA"
      },
      {
        "codigo": "D397",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS ORGANOS GENITALES FEMENINOS"
      },
      {
        "codigo": "D399",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE ORGANO GENITAL FEMENINO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D40 - TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LOS ORGANOS GENITALES MASCULINOS",
    "detalle": [
      {
        "codigo": "D400",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA PROSTATA"
      },
      {
        "codigo": "D401",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TESTICULO"
      },
      {
        "codigo": "D407",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS ORGANOS GENITALES MASCULINOS"
      },
      {
        "codigo": "D409",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE ORGANO GENITAL MASCULINO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D41 - TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LOS ORGANOS URINARIO",
    "detalle": [
      {
        "codigo": "D410",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL RIÑON"
      },
      {
        "codigo": "D411",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA PELVIS RENAL"
      },
      {
        "codigo": "D412",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL URETER"
      },
      {
        "codigo": "D413",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA URETRA"
      },
      {
        "codigo": "D414",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA VEJIGA"
      },
      {
        "codigo": "D417",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS ORGANOS URINARIOS"
      },
      {
        "codigo": "D419",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE ORGANO URINARIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D42 - TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LAS MENINGES",
    "detalle": [
      {
        "codigo": "D420",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LAS MENINGES CEREBRALES"
      },
      {
        "codigo": "D421",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LAS MENINGES RAQUIDEAS"
      },
      {
        "codigo": "D429",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LAS MENINGES, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D43 - TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL ENCEFALO Y DEL SISTEMA NERVIOSO CENTRAL",
    "detalle": [
      {
        "codigo": "D430",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL ENCEFALO, SUPRATENTORIAL"
      },
      {
        "codigo": "D431",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL ENCEFALO, INFRATENTORIAL"
      },
      {
        "codigo": "D432",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL ENCEFALO, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "D433",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LOS NERVIOS CRANEALES"
      },
      {
        "codigo": "D434",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA MEDULA ESPINAL"
      },
      {
        "codigo": "D437",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTRAS PARTES ESPECIFICADAS DEL SISTEMA NERVIOSO CENTRAL"
      },
      {
        "codigo": "D439",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL SISTEMA NERVIOSO CENTRAL, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D44 - TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LAS GLANDULAS ENDOCRINAS",
    "detalle": [
      {
        "codigo": "D440",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA GLANDULA TIROIDES"
      },
      {
        "codigo": "D441",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA GLANDULA SUPRARRENAL"
      },
      {
        "codigo": "D442",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA GLANDULA PARATIROIDES"
      },
      {
        "codigo": "D443",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA GLANDULA HIPOFISIS"
      },
      {
        "codigo": "D444",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL CONDUCTO CRANEOFARINGEO"
      },
      {
        "codigo": "D445",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA GLANDULA PINEAL"
      },
      {
        "codigo": "D446",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL CUERPO CAROTIDEO"
      },
      {
        "codigo": "D447",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL CUERPO AORTICO Y OTROS CUERPOS CROMAFINES"
      },
      {
        "codigo": "D448",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO CON AFECTACION PLURIGLANDULAR"
      },
      {
        "codigo": "D449",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE GLANDULA ENDOCRINA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D45 - POLICITEMIA VERA",
    "detalle": [
      {
        "codigo": "D45X",
        "valor": "POLICITEMIA VERA"
      }
    ]
  },
  {
    "grupo": "D46 - SINDROMES MIELODISPLASICOS",
    "detalle": [
      {
        "codigo": "D460",
        "valor": "ANEMIA REFRACTARIA SIN SIDEROBLASTOS EN FORMA DE ANILLO, ASI DESCRITA"
      },
      {
        "codigo": "D461",
        "valor": "ANEMIA REFRACTARIA CON SIDEROBLASTOS EN FORMA DE ANILLO"
      },
      {
        "codigo": "D462",
        "valor": "ANEMIA REFRACTARIA CON EXCESO DE BLASTOS [AREB]"
      },
      {
        "codigo": "D463",
        "valor": "ANEMIA REFRACTARIA CON EXCESO DE BLASTOS CON TRANSFORMACION"
      },
      {
        "codigo": "D464",
        "valor": "ANEMIA REFRACTARIA, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "D465",
        "valor": "ANEMIA REFRACTARIA CON DISPLASIA MULTILINAJE"
      },
      {
        "codigo": "D466",
        "valor": "SINDROME MIELODISPLASICO CON ANORMALIDAD CROMOSOMICA AISLADA DEL (5Q)"
      },
      {
        "codigo": "D467",
        "valor": "OTROS SINDROMES MIELODISPLASICOS"
      },
      {
        "codigo": "D469",
        "valor": "SINDROME MIELODISPLASICO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "D47 - OTROS TUMORES DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TEJIDO LINFATICO",
    "detalle": [
      {
        "codigo": "D470",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LOS MASTOCITOS E HISTIOCITOS"
      },
      {
        "codigo": "D471",
        "valor": "ENFERMEDAD MIELOPROLIFERATIVA CRONICA"
      },
      {
        "codigo": "D472",
        "valor": "GAMMOPATIA MONOCLONAL DE SIGNIFICADO INCIERTO [GMSI]"
      },
      {
        "codigo": "D473",
        "valor": "TROMBOCITOPENIA (HEMORRAGICA) ESENCIAL"
      },
      {
        "codigo": "D474",
        "valor": "OSTEOMIELOFIBROSIS"
      },
      {
        "codigo": "D475",
        "valor": "LEUCEMIA EOSINOFILICA CRONICA [SINDROME HIPEREOSINOFILICO]"
      },
      {
        "codigo": "D477",
        "valor": "OTROS TUMORES ESPECIFICADOS DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TEJIDO LINFATICO, DE LOS ORGANOS HEMATOPOYETICOS Y DE TEJIDOS AFINES"
      },
      {
        "codigo": "D479",
        "valor": "TUMORES DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TEJIDO LINFATICO, DE LOS ORGANOS HEMATOPOYETICOS Y DE TEJIDOS AFINES, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "D48 - TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS SITIOS Y DE LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "D480",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL HUESO Y CARTILAGO ARTICULAR"
      },
      {
        "codigo": "D481",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TEJIDO CONJUNTIVO Y OTRO TEJIDO BLANDO"
      },
      {
        "codigo": "D482",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LOS NERVIOS PERIFERICOS Y DEL SISTEMA NERVIOSO AUTONOMO"
      },
      {
        "codigo": "D483",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL RETROPERITONEO"
      },
      {
        "codigo": "D484",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL PERITONEO"
      },
      {
        "codigo": "D485",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA PIEL"
      },
      {
        "codigo": "D486",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA MAMA"
      },
      {
        "codigo": "D487",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS SITIOS ESPECIFICADOS"
      },
      {
        "codigo": "D489",
        "valor": "TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO, DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D50 - ANEMIAS POR DEFICIENCIA DE HIERRO",
    "detalle": [
      {
        "codigo": "D500",
        "valor": "ANEMIA POR DEFICIENCIA DE HIERRO SECUNDARIA A PERDIDA DE SANGRE (CRONICA)"
      },
      {
        "codigo": "D501",
        "valor": "DISFAGIA SIDEROPENICA"
      },
      {
        "codigo": "D508",
        "valor": "OTRAS ANEMIAS POR DEFICIENCIA DE HIERRO"
      },
      {
        "codigo": "D509",
        "valor": "ANEMIA POR DEFICIENCIA DE HIERRO SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "D51 - ANEMIA POR DEFICIENCIA DE VITAMINA B12",
    "detalle": [
      {
        "codigo": "D510",
        "valor": "ANEMIA POR DEFICIENCIA DE VITAMINA B12 DEBIDA A DEFICIENCIA DEL FACTOR INTRINSECO"
      },
      {
        "codigo": "D511",
        "valor": "ANEMIA POR DEFICIENCIA DE VITAMINA B12 DEBIDA A MALA ABSORCION SELECTIVA DE VITAMINA B12 CON PROTEINURIA"
      },
      {
        "codigo": "D512",
        "valor": "DEFICIENCIA DE TRASCOBALAMINA II"
      },
      {
        "codigo": "D513",
        "valor": "OTRAS ANEMIAS POR DEFICIENCIA DIETETICA DE VITAMINA B12"
      },
      {
        "codigo": "D518",
        "valor": "OTRAS ANEMIAS POR DEFICIENCIA DE VITAMINA B12"
      },
      {
        "codigo": "D519",
        "valor": "ANEMIA POR DEFICIENCIA DE VITAMINA B12, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "D52 - ANEMIA POR DEFICIENCIA DE FOLATOS",
    "detalle": [
      {
        "codigo": "D520",
        "valor": "ANEMIA POR DEFICIENCIA DIETETICA DE FOLATOS"
      },
      {
        "codigo": "D521",
        "valor": "ANEMIA POR DEFICIENCIA DE FOLATOS INDUCIDA POR DROGAS"
      },
      {
        "codigo": "D528",
        "valor": "OTRAS ANEMIAS POR DEFICIENCIA DE FOLATOS"
      },
      {
        "codigo": "D529",
        "valor": "ANEMIA POR DEFICIENCIA DE FOLATOS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "D53 - OTRAS ANEMIAS NUTRICIONALES",
    "detalle": [
      {
        "codigo": "D530",
        "valor": "ANEMIA POR DEFICIENCIA DE PROTEINAS"
      },
      {
        "codigo": "D531",
        "valor": "OTRAS ANEMIAS MEGALOBLASTICAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "D532",
        "valor": "ANEMIA ESCORBUTICA"
      },
      {
        "codigo": "D538",
        "valor": "OTRAS ANEMIAS NUTRICIONALES ESPECIFICADAS"
      },
      {
        "codigo": "D539",
        "valor": "ANEMIA NUTRICIONAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D55 - ANEMIA DEBIDA A TRASTORNOS ENZIMATICOS",
    "detalle": [
      {
        "codigo": "D550",
        "valor": "ANEMIA DEBIDA A DEFICIENCIA DE GLUCOSA-6-FOSFATO DESHIDROGENASA [G6FD]"
      },
      {
        "codigo": "D551",
        "valor": "ANEMIA DEBIDA A OTROS TRASTORNOS DEL METABOLISMO DEL GLUTATION"
      },
      {
        "codigo": "D552",
        "valor": "ANEMIA DEBIDA A TRASTORNOS DE LAS ENZIMAS GLUCOLITICAS"
      },
      {
        "codigo": "D553",
        "valor": "ANEMIA DEBIDA A TRASTORNOS DEL METABOLISMO DE LOS NUCLEOTIDOS"
      },
      {
        "codigo": "D558",
        "valor": "OTRAS ANEMIAS DEBIDAS A TRASTORNOS ENZIMATICOS"
      },
      {
        "codigo": "D559",
        "valor": "ANEMIA DEBIDA A TRASTORNOS ENZIMATICOS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "D56 - TALASEMIA",
    "detalle": [
      {
        "codigo": "D560",
        "valor": "ALFA TALASEMIA"
      },
      {
        "codigo": "D561",
        "valor": "BETA TALASEMIA"
      },
      {
        "codigo": "D562",
        "valor": "DELTA-BETA TALASEMIA"
      },
      {
        "codigo": "D563",
        "valor": "RASGO TALASEMICO"
      },
      {
        "codigo": "D564",
        "valor": "PERSISTENCIA HEREDITARIA DE LA HEMOGLOBINA FETAL [PHHF]"
      },
      {
        "codigo": "D568",
        "valor": "OTRAS TALASEMIAS"
      },
      {
        "codigo": "D569",
        "valor": "TALASEMIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D57 - TRASTORNOS FALCIFORMES",
    "detalle": [
      {
        "codigo": "D570",
        "valor": "ANEMIA FALCIFORME CON CRISIS"
      },
      {
        "codigo": "D571",
        "valor": "ANEMIA FALCIFORME SIN CRISIS"
      },
      {
        "codigo": "D572",
        "valor": "TRASTORNOS FALCIFORMES HETEROCIGOTOS DOBLES"
      },
      {
        "codigo": "D573",
        "valor": "RASGO DREPANOCITICO"
      },
      {
        "codigo": "D578",
        "valor": "OTROS TRASTORNOS FALCIFORMES"
      }
    ]
  },
  {
    "grupo": "D58 - OTRAS ANEMIAS HEMOLITICAS HEREDITARIAS",
    "detalle": [
      {
        "codigo": "D580",
        "valor": "ESFEROCITOSIS HEREDITARIA"
      },
      {
        "codigo": "D581",
        "valor": "ELIPTOCITOSIS HEREDITARIA"
      },
      {
        "codigo": "D582",
        "valor": "OTRAS HEMOGLOBINOPATIAS"
      },
      {
        "codigo": "D588",
        "valor": "OTRAS ANEMIAS HEMOLITICAS HEREDITARIAS ESPECIFICADAS"
      },
      {
        "codigo": "D589",
        "valor": "ANEMIA HEMOLITICA HEREDITARIA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "D59 - ANEMIA HEMOLITICA ADQUIRIDA",
    "detalle": [
      {
        "codigo": "D590",
        "valor": "ANEMIA HEMOLITICA AUTOINMUNE INDUCIDA POR DROGAS"
      },
      {
        "codigo": "D591",
        "valor": "OTRAS ANEMIAS HEMOLITICAS AUTOINMUNES"
      },
      {
        "codigo": "D592",
        "valor": "ANEMIA HEMOLITICA NO AUTOINMUNE INDUCIDA POR DROGAS"
      },
      {
        "codigo": "D593",
        "valor": "SINDROME HEMOLITICO-UREMICO"
      },
      {
        "codigo": "D594",
        "valor": "OTRAS ANEMIAS HEMOLITICAS NO AUTOINMUNES"
      },
      {
        "codigo": "D595",
        "valor": "HEMOGLOBINURIA PAROXISTICA NOCTURNA [MARCHIAFAVA- MICHELI]"
      },
      {
        "codigo": "D596",
        "valor": "HEMOGLOBINURIA DEBIDA A HEMOLISIS POR OTRAS CAUSAS EXTERNAS"
      },
      {
        "codigo": "D598",
        "valor": "OTRAS ANEMIAS HEMOLITICAS ADQUIRIDAS"
      },
      {
        "codigo": "D599",
        "valor": "ANEMIA HEMOLITICA ADQUIRIDA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "D60 - APLASIA ADQUIRIDA, EXCLUSIVA DE LA SERIE ROJA [ERITROBLASTOPENIA]",
    "detalle": [
      {
        "codigo": "D600",
        "valor": "APLASIA CRONICA ADQUIRIDA, EXCLUSIVA DE LA SERIE ROJA"
      },
      {
        "codigo": "D601",
        "valor": "APLASIA TRANSITORIA ADQUIRIDA, EXCLUSIVA DE LA SERIE ROJA"
      },
      {
        "codigo": "D608",
        "valor": "OTRAS APLASIAS ADQUIRIDAS, EXCLUSIVAS DE LA SERIE ROJA"
      },
      {
        "codigo": "D609",
        "valor": "APLASIA ADQUIRIDA, EXCLUSIVA DE LA SERIE ROJA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D61 - OTRAS ANEMIAS APLASTICAS",
    "detalle": [
      {
        "codigo": "D610",
        "valor": "ANEMIA APLASTICA CONSTITUCIONAL"
      },
      {
        "codigo": "D611",
        "valor": "ANEMIA APLASTICA INDUCIDA POR DROGAS"
      },
      {
        "codigo": "D612",
        "valor": "ANEMIA APLASTICA DEBIDA A OTROS AGENTES EXTERNOS"
      },
      {
        "codigo": "D613",
        "valor": "ANEMIA APLASTICA IDIOPATICA"
      },
      {
        "codigo": "D618",
        "valor": "OTRAS ANEMIAS APLASTICAS ESPECIFICADAS"
      },
      {
        "codigo": "D619",
        "valor": "ANEMIA APLASTICA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "D62 - ANEMIA POSTHEMORRAGICA AGUDA",
    "detalle": [
      {
        "codigo": "D62X",
        "valor": "ANEMIA POSTHEMORRAGICA AGUDA"
      }
    ]
  },
  {
    "grupo": "D63 - ANEMIA EN ENFERMEDADES CRONICAS CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "D630",
        "valor": "ANEMIA EN ENFERMEDAD NEOPLASICA"
      },
      {
        "codigo": "D638",
        "valor": "ANEMIA EN OTRAS ENFERMEDADES CRONICAS CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "D64 - OTRAS ANEMIAS",
    "detalle": [
      {
        "codigo": "D640",
        "valor": "ANEMIA SIDEROBLASTICA HEREDITARIA"
      },
      {
        "codigo": "D641",
        "valor": "ANEMIA SIDEROBLASTICA SECUNDARIA A OTRA ENFERMEDAD"
      },
      {
        "codigo": "D642",
        "valor": "ANEMIA SIDEROBLASTICA SECUNDARIA, DEBIDA A DROGAS Y TOXINAS"
      },
      {
        "codigo": "D643",
        "valor": "OTRAS ANEMIAS SIDEROBLASTICAS"
      },
      {
        "codigo": "D644",
        "valor": "ANEMIA DISERITROPOYETICA CONGENITA"
      },
      {
        "codigo": "D648",
        "valor": "OTRAS ANEMIAS ESPECIFICADAS"
      },
      {
        "codigo": "D649",
        "valor": "ANEMIA DE TIPO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D65 - COAGULACION INTRAVASCULAR DISEMINADA [SINDROME DE DESFIBRINACION]",
    "detalle": [
      {
        "codigo": "D65X",
        "valor": "COAGULACION INTRAVASCULAR DISEMINADA [SINDROME DE DESFIBRINACION]"
      }
    ]
  },
  {
    "grupo": "D66 - DEFICIENCIA HEREDITARIA DEL FACTOR VIII",
    "detalle": [
      {
        "codigo": "D66X",
        "valor": "DEFICIENCIA HEREDITARIA DEL FACTOR VIII"
      }
    ]
  },
  {
    "grupo": "D67 - DEFICIENCIA HEREDITARIA DEL FACTOR IX",
    "detalle": [
      {
        "codigo": "D67X",
        "valor": "DEFICIENCIA HEREDITARIA DEL FACTOR IX"
      }
    ]
  },
  {
    "grupo": "D68 - OTROS DEFECTOS DE LA COAGULACION",
    "detalle": [
      {
        "codigo": "D680",
        "valor": "ENFERMEDAD DE VON WILLEBRAND"
      },
      {
        "codigo": "D681",
        "valor": "DEFICIENCIA HEREDITARIA DEL FACTOR XI"
      },
      {
        "codigo": "D682",
        "valor": "DEFICIENCIA HEREDITARIA DE OTROS FACTORES DE LA COAGULACION"
      },
      {
        "codigo": "D683",
        "valor": "TRASTORNO HEMORRAGICO DEBIDO A ANTICOAGULANTES CIRCULANTES"
      },
      {
        "codigo": "D684",
        "valor": "DEFICIENCIA ADQUIRIDA DE FACTORES DE LA COAGULACION"
      },
      {
        "codigo": "D685",
        "valor": "TROMBOFILIA PRIMARIA"
      },
      {
        "codigo": "D686",
        "valor": "OTRA TROMBOFILIA"
      },
      {
        "codigo": "D688",
        "valor": "OTROS DEFECTOS ESPECIFICADOS DE LA COAGULACION"
      },
      {
        "codigo": "D689",
        "valor": "DEFECTO DE LA COAGULACION, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D69 - PURPURA Y OTRAS AFECCIONES HEMORRAGICAS",
    "detalle": [
      {
        "codigo": "D690",
        "valor": "PURPURA ALERGICA"
      },
      {
        "codigo": "D691",
        "valor": "DEFECTO CUALITATIVOS DE LAS PLAQUETAS"
      },
      {
        "codigo": "D692",
        "valor": "OTRAS PURPURAS NO TROMBOCITOPENICAS"
      },
      {
        "codigo": "D693",
        "valor": "PURPURA TROMBOCITOPENICA IDIOPATICA"
      },
      {
        "codigo": "D694",
        "valor": "OTRAS TROMBOCITOPENIAS PRIMARIAS"
      },
      {
        "codigo": "D695",
        "valor": "TROMBOCITOPENIA SECUNDARIA"
      },
      {
        "codigo": "D696",
        "valor": "TROMBOCITOPENIA NO ESPECIFICADA"
      },
      {
        "codigo": "D698",
        "valor": "OTRAS AFECCIONES HEMORRAGICAS ESPECIFICADAS"
      },
      {
        "codigo": "D699",
        "valor": "AFECCION HEMORRAGICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D70 - AGRANULOCITOSIS",
    "detalle": [
      {
        "codigo": "D70X",
        "valor": "AGRANULOCITOSIS"
      }
    ]
  },
  {
    "grupo": "D71 - TRASTORNOS FUNCIONALES DE LOS POLIMORFONUCLEARES NEUTROFILOS",
    "detalle": [
      {
        "codigo": "D71X",
        "valor": "TRASTORNOS FUNCIONALES DE LOS POLIMORFONUCLEARES NEUTROFILOS"
      }
    ]
  },
  {
    "grupo": "D72 - OTROS TRASTORNOS DE LOS LEUCOCITOS",
    "detalle": [
      {
        "codigo": "D720",
        "valor": "ANOMALIAS GENETICAS DE LOS LEUCOCITOS"
      },
      {
        "codigo": "D721",
        "valor": "EOSINOFILIA"
      },
      {
        "codigo": "D728",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LOS LEUCOCITOS"
      },
      {
        "codigo": "D729",
        "valor": "TRASTORNO DE LOS LEUCOCITOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D73 - ENFERMEDADES DEL BAZO",
    "detalle": [
      {
        "codigo": "D730",
        "valor": "HIPOESPLENISMO"
      },
      {
        "codigo": "D731",
        "valor": "HIPERESPLENISMO"
      },
      {
        "codigo": "D732",
        "valor": "ESPLENOMEGALIA CONGESTIVA CRONICA"
      },
      {
        "codigo": "D733",
        "valor": "ABSCESO DEL BAZO"
      },
      {
        "codigo": "D734",
        "valor": "QUISTE DEL BAZO"
      },
      {
        "codigo": "D735",
        "valor": "INFARTO DEL BAZO"
      },
      {
        "codigo": "D738",
        "valor": "OTRAS ENFERMEDADES DEL BAZO"
      },
      {
        "codigo": "D739",
        "valor": "ENFERMEDAD DEL BAZO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D74 - METAHEMOGLOBINEMIA",
    "detalle": [
      {
        "codigo": "D740",
        "valor": "METAHEMOGLOBINEMIA CONGENITA"
      },
      {
        "codigo": "D748",
        "valor": "OTRAS METAHEMOGLOBINEMIAS"
      },
      {
        "codigo": "D749",
        "valor": "METAHEMOGLOBINEMIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D75 - OTRAS ENFERMEDADES DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS",
    "detalle": [
      {
        "codigo": "D750",
        "valor": "ERITROCITOSIS FAMILIAR"
      },
      {
        "codigo": "D751",
        "valor": "POLICITEMIA SECUNDARIA"
      },
      {
        "codigo": "D752",
        "valor": "TROMBOCITOSIS ESENCIAL"
      },
      {
        "codigo": "D758",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS"
      },
      {
        "codigo": "D759",
        "valor": "ENFERMEDAD DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D76 - OTRAS ENFERMEDADES ESPECIFICADAS CON PARTICIPACION DEL TEJIDO LINFORRETICULAR Y RETICULO ENDOTELIAL",
    "detalle": [
      {
        "codigo": "D760",
        "valor": "HISTIOCITOSIS DE LAS CELULAS DE LANGERHANS, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "D761",
        "valor": "LINFOHISTIOCITOSIS HEMOFAGOCITICA"
      },
      {
        "codigo": "D762",
        "valor": "SINDROME HEMOFAGOCITICO ASOCIADO A INFECCION"
      },
      {
        "codigo": "D763",
        "valor": "OTROS SINDROMES HISTIOCITICOS"
      }
    ]
  },
  {
    "grupo": "D77 - OTROS TRASTORNOS DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS EN ENFE",
    "detalle": [
      {
        "codigo": "D77X",
        "valor": "OTROS TRASTORNOS DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS EN ENFERMEDADES C"
      }
    ]
  },
  {
    "grupo": "D80 - INMUNODEFICIENCIA CON PREDOMINIO DE DEFECTOS DE LOS ANTICUERPOS",
    "detalle": [
      {
        "codigo": "D800",
        "valor": "HIPOGAMMAGLOBULINEMIA HEREDITARIA"
      },
      {
        "codigo": "D801",
        "valor": "HIPOGAMMAGLOBULINEMIA NO FAMILIAR"
      },
      {
        "codigo": "D802",
        "valor": "DEFICIENCIA SELECTIVA DE INMUNOGLOBULINA A [IGA]"
      },
      {
        "codigo": "D803",
        "valor": "DEFICIENCIA SELECTIVA DE SUBCLASES DE LA INMUNOGLOBULINA G [IGG]"
      },
      {
        "codigo": "D804",
        "valor": "DEFICIENCIA SELECTIVA DE INMUNOGLOBULINA M [IGM]"
      },
      {
        "codigo": "D805",
        "valor": "INMUNODEFICIENCIA CON INCREMENTO DE INMUNOGLOBULINA M [IGM]"
      },
      {
        "codigo": "D806",
        "valor": "DEFICIENCIA DE ANTICUERPOS CON INMUNOGLOBULINAS CASI NORMALES O CON HIPERINMUNOGLOBULINEMIA"
      },
      {
        "codigo": "D807",
        "valor": "HIPOGAMMAGLOBULINEMIA TRANSITORIA DE LA INFANCIA"
      },
      {
        "codigo": "D808",
        "valor": "OTRAS INMUNODEFICIENCIAS CON PREDOMINIO DE DEFECTOS DE LOS ANTICUERPOS"
      },
      {
        "codigo": "D809",
        "valor": "INMUNODEFICIENCIA CON PREDOMINIO DE DEFECTOS DE LOS ANTICUERPOS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D81 - INMUNODEFICIENCIAS COMBINADAS",
    "detalle": [
      {
        "codigo": "D810",
        "valor": "INMUNODEFICIENCIA COMBINADA SEVERA [IDCS] CON DISGENESIA RETICULAR"
      },
      {
        "codigo": "D811",
        "valor": "INMUNODEFICIENCIA COMBINADA SEVERA [IDCS] CON LINFOCITOPENIA T Y B"
      },
      {
        "codigo": "D812",
        "valor": "INMUNODEFICIENCIA COMBINADA SEVERA [IDCS] CON CIFRA BAJA O NORMAL DE LINFOCITOS B"
      },
      {
        "codigo": "D813",
        "valor": "DEFICIENCIA DE LA ADENOSINA DEAMINASA [ADA]"
      },
      {
        "codigo": "D814",
        "valor": "SINDROME DE NEZELOF"
      },
      {
        "codigo": "D815",
        "valor": "DEFICIENCIA DE LA FOSFORILASA PURINONUCLEOSIDA [FPN]"
      },
      {
        "codigo": "D816",
        "valor": "DEFICIENCIA DE LA CLASE I DEL COMPLEJO DE HISTOCOMPATIBILIDAD MAYOR"
      },
      {
        "codigo": "D817",
        "valor": "DEFICIENCIA DE LA CLASE II DEL COMPLEJO DE HISTOCOMPATIBILIDAD MAYOR"
      },
      {
        "codigo": "D818",
        "valor": "OTRAS INMUNODEFICIENCIAS COMBINADAS"
      },
      {
        "codigo": "D819",
        "valor": "INMUNODEFICIENCIA COMBINADA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D82 - INMUNODEFICIENCIA ASOCIADA CON OTROS DEFECTOS MAYORES",
    "detalle": [
      {
        "codigo": "D820",
        "valor": "SINDROME DE WISKOTT-ALDRICH"
      },
      {
        "codigo": "D821",
        "valor": "SINDROME DE DI GEORGE"
      },
      {
        "codigo": "D822",
        "valor": "INMUNODEFICIENCIA CON ENANISMO MICROMELICO [MIEMBROS CORTOS]"
      },
      {
        "codigo": "D823",
        "valor": "INMUNODEFICIENCIA CONSECUTIVA A RESPUESTA DEFECTUOSA HEREDITARIA CONTRA EL VIRUS DE EPSTEIN-BARR"
      },
      {
        "codigo": "D824",
        "valor": "SINDROME DE HIPERINMUNOGLOBULINA E [IGE]"
      },
      {
        "codigo": "D828",
        "valor": "INMUNODEFICIENCIA ASOCIADA CON OTROS DEFECTOS MAYORES ESPECIFICADOS"
      },
      {
        "codigo": "D829",
        "valor": "INMUNODEFICIENCIA ASOCIADA CON DEFECTOS MAYORES NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "D83 - INMUNODEFICIENCIA VARIABLE COMUN",
    "detalle": [
      {
        "codigo": "D830",
        "valor": "INMUNODEFICIENCIA VARIABLE COMUN CON PREDOMINIO DE ANORMALIDADES EN EL NUMERO Y LA FUNCION DE LOS LINFOCITOS B"
      },
      {
        "codigo": "D831",
        "valor": "INMUNODEFICIENCIA VARIABLE COMUN CON PREDOMINIO DE TRASTORNOS INMUNORREGULADORES DE LOS LINFOCITOS T"
      },
      {
        "codigo": "D832",
        "valor": "INMUNODEFICIENCIA VARIABLE COMUN CON AUTOANTICUERPOS ANTI-B O ANTI-T"
      },
      {
        "codigo": "D838",
        "valor": "OTRAS INMUNODEFICIENCIAS VARIABLES COMUNES"
      },
      {
        "codigo": "D839",
        "valor": "INMUNODEFICIENCIA VARIABLE COMUN, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D84 - OTRAS INMUNODEFICIENCIAS",
    "detalle": [
      {
        "codigo": "D840",
        "valor": "DEFECTO DE LA FUNCION DEL ANTIGENO-1 DEL LINFOCITO [LFA-1]"
      },
      {
        "codigo": "D841",
        "valor": "DEFECTO DEL SISTEMA DEL COMPLEMENTO"
      },
      {
        "codigo": "D848",
        "valor": "OTRAS INMUNODEFICIENCIAS ESPECIFICADAS"
      },
      {
        "codigo": "D849",
        "valor": "INMUNODEFICIENCIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "D86 - SARCOIDOSIS",
    "detalle": [
      {
        "codigo": "D860",
        "valor": "SARCOIDOSIS DEL PULMON"
      },
      {
        "codigo": "D861",
        "valor": "SARCOIDOSIS DE LOS GANGLIOS LINFATICOS"
      },
      {
        "codigo": "D862",
        "valor": "SARCOIDOSIS DEL PULMON Y DE LOS GANGLIOS LINFATICOS"
      },
      {
        "codigo": "D863",
        "valor": "SARCOIDOSIS DE LA PIEL"
      },
      {
        "codigo": "D868",
        "valor": "SARCOIDOSIS DE OTROS SITIOS ESPECIFICADOS O DE SITIOS COMBINADOS"
      },
      {
        "codigo": "D869",
        "valor": "SARCOIDOSIS DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "D89 - OTROS TRASTORNOS QUE AFECTAN EL MECANISMO DE LA INMUNIDAD, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "D890",
        "valor": "HIPERGAMMAGLOBULINEMIA POLICLONAL"
      },
      {
        "codigo": "D891",
        "valor": "CRIOGLOBULINEMIA"
      },
      {
        "codigo": "D892",
        "valor": "HIPERGAMMAGLOBULINEMIA, NO ESPECIFICADA"
      },
      {
        "codigo": "D893",
        "valor": "SINDROME DE RECONSTITUCION INMUNE"
      },
      {
        "codigo": "D898",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS QUE AFECTAN EL MECANISMO DE LA INMUNIDAD, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "D899",
        "valor": "TRASTORNO QUE AFECTA AL MECANISMO DE LA INMUNIDAD, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E00 - SINDROME CONGENITO DE DEFICIENCIA DE YODO",
    "detalle": [
      {
        "codigo": "E000",
        "valor": "SINDROME CONGENITO DE DEFICIENCIA DE YODO, TIPO NEUROLOGICO"
      },
      {
        "codigo": "E001",
        "valor": "SINDROME DE DEFICIENCIA CONGENITA DE YODO, TIPO MIXEDEMATOSO"
      },
      {
        "codigo": "E002",
        "valor": "SINDROME CONGENITO DE DEFICIENCIA DE YODO, TIPO MIXTO"
      },
      {
        "codigo": "E009",
        "valor": "SINDROME CONGENITO DE DEFICIENCIA DE YODO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E01 - TRASTORNOS TIROIDEOS VINCULADOS A DEFICIENCIA DE YODO Y AFECCIONES RELACIONADAS",
    "detalle": [
      {
        "codigo": "E010",
        "valor": "BOCIO DIFUSO (ENDEMICO) RELACIONADO CON DEFICIENCIA DE YODO"
      },
      {
        "codigo": "E011",
        "valor": "BOCIO MULTINODULAR (ENDEMICO) RELACIONADO CON DEFICIENCIA DE YODO"
      },
      {
        "codigo": "E012",
        "valor": "BOCIO (ENDEMICO) RELACIONADO CON DEFICIENCIA DE YODO, NO ESPECIFICADO"
      },
      {
        "codigo": "E018",
        "valor": "OTROS TRASTORNOS DE LA TIROIDES RELACIONADOS CON DEFICIENCIA DE YODO Y AFECCIONES SIMILARES"
      }
    ]
  },
  {
    "grupo": "E02 - HIPOTIROIDISMO SUBCLINICO POR DEFICIENCIA DE YODO",
    "detalle": [
      {
        "codigo": "E02X",
        "valor": "HIPOTIROIDISMO SUBCLINICO POR DEFICIENCIA DE YODO"
      }
    ]
  },
  {
    "grupo": "E03 - OTROS HIPOTIROIDISMOS",
    "detalle": [
      {
        "codigo": "E030",
        "valor": "HIPOTIROIDISMO CONGENITO CON BOCIO DIFUSO"
      },
      {
        "codigo": "E031",
        "valor": "HIPOTIROIDISMO CONGENITO SIN BOCIO"
      },
      {
        "codigo": "E032",
        "valor": "HIPOTIROIDISMO DEBIDO A MEDICAMENTOS Y A OTRAS SUSTANCIAS EXOGENAS"
      },
      {
        "codigo": "E033",
        "valor": "HIPOTIROIDISMO POSTINFECCIOSO"
      },
      {
        "codigo": "E034",
        "valor": "ATROFIA DE TIROIDES (ADQUIRIDA)"
      },
      {
        "codigo": "E035",
        "valor": "COMA MIXEDEMATOSO"
      },
      {
        "codigo": "E038",
        "valor": "OTROS HIPOTIROIDISMOS ESPECIFICADOS"
      },
      {
        "codigo": "E039",
        "valor": "HIPOTIROIDISMO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E04 - OTROS BOCIOS NO TOXICOS",
    "detalle": [
      {
        "codigo": "E040",
        "valor": "BOCIO DIFUSO NO TOXICO"
      },
      {
        "codigo": "E041",
        "valor": "NODULO TIROIDEO SOLITARIO NO TOXICO"
      },
      {
        "codigo": "E042",
        "valor": "BOCIO MULTINODULAR NO TOXICO"
      },
      {
        "codigo": "E048",
        "valor": "OTROS BOCIOS NO TOXICOS ESPECIFICADOS"
      },
      {
        "codigo": "E049",
        "valor": "BOCIO NO TOXICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E05 - TIROTOXICOSIS [HIPERTIROIDISMO]",
    "detalle": [
      {
        "codigo": "E050",
        "valor": "TIROTOXICOSIS CON BOCIO DIFUSO"
      },
      {
        "codigo": "E051",
        "valor": "TIROTOXICOSIS CON NODULO SOLITARIO TIROIDEO TOXICO"
      },
      {
        "codigo": "E052",
        "valor": "TIROTOXICOSIS CON BOCIO MULTINODULAR TOXICO"
      },
      {
        "codigo": "E053",
        "valor": "TIROTOXICOSIS POR TEJIDO TIROIDEO ECTOPICO"
      },
      {
        "codigo": "E054",
        "valor": "TIROTOXICOSIS FACTICIA"
      },
      {
        "codigo": "E055",
        "valor": "CRISIS O TORMENTA TIROTOXICA"
      },
      {
        "codigo": "E058",
        "valor": "OTRAS TIROTOXICOSIS"
      },
      {
        "codigo": "E059",
        "valor": "TIROTOXICOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E06 - TIROIDITIS",
    "detalle": [
      {
        "codigo": "E060",
        "valor": "TIROIDITIS AGUDA"
      },
      {
        "codigo": "E061",
        "valor": "TIROIDITIS SUBAGUDA"
      },
      {
        "codigo": "E062",
        "valor": "TIROIDITIS CRONICA CON TIROTOXICOSIS TRANSITORIA"
      },
      {
        "codigo": "E063",
        "valor": "TIROIDITIS AUTOINMUNE"
      },
      {
        "codigo": "E064",
        "valor": "TIROIDITIS INDUCIDA POR DROGAS"
      },
      {
        "codigo": "E065",
        "valor": "OTRAS TIROIDITIS CRONICAS"
      },
      {
        "codigo": "E069",
        "valor": "TIROIDITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E07 - OTROS TRASTORNOS TIROIDEOS",
    "detalle": [
      {
        "codigo": "E070",
        "valor": "HIPERSECRECION DE CALCITONINA"
      },
      {
        "codigo": "E071",
        "valor": "BOCIO DISHORMOGENETICO"
      },
      {
        "codigo": "E078",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA GLANDULA TIROIDES"
      },
      {
        "codigo": "E079",
        "valor": "TRASTORNO DE LA GLANDULA TIROIDES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E10 - DIABETES MELLITUS INSULINODEPENDIENTE",
    "detalle": [
      {
        "codigo": "E100",
        "valor": "DIABETES MELLITUS TIPO 1, CON COMA"
      },
      {
        "codigo": "E101",
        "valor": "DIABETES MELLITUS TIPO 1, CON CETOACIDOSIS"
      },
      {
        "codigo": "E102",
        "valor": "DIABETES MELLITUS TIPO 1, CON COMPLICACIONES RENALES"
      },
      {
        "codigo": "E103",
        "valor": "DIABETES MELLITUS TIPO 1, CON COMPLICACIONES OFTALMICAS"
      },
      {
        "codigo": "E104",
        "valor": "DIABETES MELLITUS TIPO 1, CON COMPLICACIONES NEUROLOGICAS"
      },
      {
        "codigo": "E105",
        "valor": "DIABETES MELLITUS TIPO 1, CON COMPLICACIONES CIRCULATORIAS PERIFERICAS"
      },
      {
        "codigo": "E106",
        "valor": "DIABETES MELLITUS TIPO 1, CON OTRAS COMPLICACIONES ESPECIFICADAS"
      },
      {
        "codigo": "E107",
        "valor": "DIABETES MELLITUS TIPO 1, CON COMPLICACIONES MULTIPLES"
      },
      {
        "codigo": "E108",
        "valor": "DIABETES MELLITUS TIPO 1, CON COMPLICACIONES NO ESPECIFICADAS"
      },
      {
        "codigo": "E109",
        "valor": "DIABETES MELLITUS TIPO 1, SIN MENCION DE COMPLICACION"
      }
    ]
  },
  {
    "grupo": "E11 - DIABETES MELLITUS NO INSULINODEPENDIENTE",
    "detalle": [
      {
        "codigo": "E110",
        "valor": "DIABETES MELLITUS TIPO 2, CON COMA"
      },
      {
        "codigo": "E111",
        "valor": "DIABETES MELLITUS TIPO 2, CON CETOACIDOSIS"
      },
      {
        "codigo": "E112",
        "valor": "DIABETES MELLITUS TIPO 2, CON COMPLICACIONES RENALES"
      },
      {
        "codigo": "E113",
        "valor": "DIABETES MELLITUS TIPO 2, CON COMPLICACIONES OFTALMICAS"
      },
      {
        "codigo": "E114",
        "valor": "DIABETES MELLITUS TIPO 2, CON COMPLICACIONES NEUROLOGICAS"
      },
      {
        "codigo": "E115",
        "valor": "DIABETES MELLITUS TIPO 2, CON COMPLICACIONES CIRCULATORIAS PERIFERICAS"
      },
      {
        "codigo": "E116",
        "valor": "DIABETES MELLITUS TIPO 2, CON OTRAS COMPLICACIONES ESPECIFICADAS"
      },
      {
        "codigo": "E117",
        "valor": "DIABETES MELLITUS TIPO 2, CON COMPLICACIONES MULTIPLES"
      },
      {
        "codigo": "E118",
        "valor": "DIABETES MELLITUS TIPO 2, CON COMPLICACIONES NO ESPECIFICADAS"
      },
      {
        "codigo": "E119",
        "valor": "DIABETES MELLITUS TIPO 2, SIN MENCION DE COMPLICACION"
      },
      {
        "codigo": "E1191",
        "valor": "DIABETES TIPO MODY"
      }
    ]
  },
  {
    "grupo": "E12 - DIABETES MELLITUS ASOCIADA CON DESNUTRICION",
    "detalle": [
      {
        "codigo": "E120",
        "valor": "DIABETES MELLITUS ASOCIADA CON DESNUTRICION, CON COMA"
      },
      {
        "codigo": "E121",
        "valor": "DIABETES MELLITUS ASOCIADA CON DESNUTRICION, CON CETOACIDOSIS"
      },
      {
        "codigo": "E122",
        "valor": "DIABETES MELLITUS ASOCIADA CON DESNUTRICION, CON COMPLICACIONES RENALES"
      },
      {
        "codigo": "E123",
        "valor": "DIABETES MELLITUS ASOCIADA CON DESNUTRICION, CON COMPLICACIONES OFTALMICAS"
      },
      {
        "codigo": "E124",
        "valor": "DIABETES MELLITUS ASOCIADA CON DESNUTRICION, CON COMPLICACIONES NEUROLOGICAS"
      },
      {
        "codigo": "E125",
        "valor": "DIABETES MELLITUS ASOCIADA CON DESNUTRICION, CON COMPLICACIONES CIRCULATORIAS PERIFERICAS"
      },
      {
        "codigo": "E126",
        "valor": "DIABETES MELLITUS ASOCIADA CON DESNUTRICION, CON OTRAS COMPLICACIONES ESPECIFICADAS"
      },
      {
        "codigo": "E127",
        "valor": "DIABETES MELLITUS ASOCIADA CON DESNUTRICION, CON COMPLICACIONES MULTIPLES"
      },
      {
        "codigo": "E128",
        "valor": "DIABETES MELLITUS ASOCIADA CON DESNUTRICION, CON COMPLICACIONES NO ESPECIFICADAS"
      },
      {
        "codigo": "E129",
        "valor": "DIABETES MELLITUS ASOCIADA CON DESNUTRICION, SIN MENCION DE COMPLICACION"
      }
    ]
  },
  {
    "grupo": "E13 - OTRAS DIABETES MELLITUS ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "E130",
        "valor": "OTRAS DIABETES MELLITUS ESPECIFICADAS, CON COMA"
      },
      {
        "codigo": "E131",
        "valor": "OTRAS DIABETES MELLITUS ESPECIFICADAS, CON CETOACIDOSIS"
      },
      {
        "codigo": "E132",
        "valor": "OTRAS DIABETES MELLITUS ESPECIFICADAS, CON COMPLICACIONES RENALES"
      },
      {
        "codigo": "E133",
        "valor": "OTRAS DIABETES MELLITUS ESPECIFICADAS, CON COMPLICACIONES OFTALMICAS"
      },
      {
        "codigo": "E134",
        "valor": "OTRAS DIABETES MELLITUS ESPECIFICADAS, CON COMPLICACIONES NEUROLOGICAS"
      },
      {
        "codigo": "E135",
        "valor": "OTRAS DIABETES MELLITUS ESPECIFICADAS, CON COMPLICACIONES CIRCULATORIAS PERIFERICAS"
      },
      {
        "codigo": "E136",
        "valor": "OTRAS DIABETES MELLITUS ESPECIFICADAS, CON OTRAS COMPLICACIONES ESPECIFICADAS"
      },
      {
        "codigo": "E137",
        "valor": "OTRAS DIABETES MELLITUS ESPECIFICADAS, CON COMPLICACIONES MULTIPLES"
      },
      {
        "codigo": "E138",
        "valor": "OTRAS DIABETES MELLITUS ESPECIFICADAS, CON COMPLICACIONES NO ESPECIFICADAS"
      },
      {
        "codigo": "E139",
        "valor": "OTRAS DIABETES MELLITUS ESPECIFICADAS, SIN MENCION DE COMPLICACION"
      }
    ]
  },
  {
    "grupo": "E14 - DIABETES MELLITUS, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "E140",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, CON COMA"
      },
      {
        "codigo": "E141",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, CON CETOACIDOSIS"
      },
      {
        "codigo": "E142",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, CON COMPLICACIONES RENALES"
      },
      {
        "codigo": "E143",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, CON COMPLICACIONES OFTALMICAS"
      },
      {
        "codigo": "E144",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, CON COMPLICACIONES NEUROLOGICAS"
      },
      {
        "codigo": "E145",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, CON COMPLICACIONES CIRCULATORIAS PERIFERICAS"
      },
      {
        "codigo": "E146",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, CON OTRAS COMPLICACIONES ESPECIFICADAS"
      },
      {
        "codigo": "E147",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, CON COMPLICACIONES MULTIPLES"
      },
      {
        "codigo": "E148",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, CON COMPLICACIONES NO ESPECIFICADAS"
      },
      {
        "codigo": "E149",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, SIN MENCION DE COMPLICACION"
      }
    ]
  },
  {
    "grupo": "E15 - COMA HIPOGLICEMICO NO DIABETICO",
    "detalle": [
      {
        "codigo": "E15X",
        "valor": "COMA HIPOGLICEMICO NO DIABETICO"
      }
    ]
  },
  {
    "grupo": "E16 - OTROS TRASTORNOS DE LA SECRECION INTERNA DEL PANCREAS",
    "detalle": [
      {
        "codigo": "E160",
        "valor": "HIPOGLICEMIA SIN COMA, INDUCIDA POR DROGAS"
      },
      {
        "codigo": "E161",
        "valor": "OTRAS HIPOGLICEMIAS"
      },
      {
        "codigo": "E162",
        "valor": "HIPOGLICEMIA, NO ESPECIFICADA"
      },
      {
        "codigo": "E163",
        "valor": "SECRECION EXAGERADA DEL GLUCAGON"
      },
      {
        "codigo": "E164",
        "valor": "SECRECION ANORMAL DE GASTRINA"
      },
      {
        "codigo": "E168",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA SECRECION INTERNA DEL PANCREAS"
      },
      {
        "codigo": "E169",
        "valor": "TRASTORNOS DE LA SECRECION INTERNA DEL PANCREAS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "E20 - HIPOPARATIROIDISMO",
    "detalle": [
      {
        "codigo": "E200",
        "valor": "HIPOPARATIROIDISMO IDIOPATICO"
      },
      {
        "codigo": "E201",
        "valor": "PSEUDOHIPOPARATIROIDISMO"
      },
      {
        "codigo": "E208",
        "valor": "OTROS TIPOS DE HIPOPARATIROIDISMO"
      },
      {
        "codigo": "E209",
        "valor": "HIPOPARATIROIDISMO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E21 - HIPERPARATIROIDISMO Y OTROS TRASTORNOS DE LA GLANDULA PARATIROIDES",
    "detalle": [
      {
        "codigo": "E210",
        "valor": "HIPERPARATIROIDISMO PRIMARIO"
      },
      {
        "codigo": "E211",
        "valor": "HIPERPARATIROIDISMO SECUNDARIO NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "E212",
        "valor": "OTROS TIPOS DE HIPERPARATIROIDISMO"
      },
      {
        "codigo": "E213",
        "valor": "HIPERPARATIROIDISMO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "E214",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA GLANDULA PARATIROIDES"
      },
      {
        "codigo": "E215",
        "valor": "TRASTORNO DE LA GLANDULA PARATIROIDES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E22 - HIPERFUNCION DE LA GLANDULA HIPOFISIS",
    "detalle": [
      {
        "codigo": "E220",
        "valor": "ACROMEGALIA Y GIGANTISMO HIPOFISARIO"
      },
      {
        "codigo": "E221",
        "valor": "HIPERPROLACTINEMIA"
      },
      {
        "codigo": "E222",
        "valor": "SINDROME DE SECRECION INAPROPIADA DE HORMONA ANITIDIURETICA"
      },
      {
        "codigo": "E228",
        "valor": "OTRAS HIPERFUNCIONES DE LA GLANDULA HIPOFISIS"
      },
      {
        "codigo": "E229",
        "valor": "HIPERFUNCION DE LA GLANDULA HIPOFISIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E23 - HIPOFUNCION Y OTROS TRASTORNOS DE LA GLANDULA HIPOFISIS",
    "detalle": [
      {
        "codigo": "E230",
        "valor": "HIPOPITUITARISMO"
      },
      {
        "codigo": "E231",
        "valor": "HIPOPITUITARISMO INDUCIDO POR DROGAS"
      },
      {
        "codigo": "E232",
        "valor": "DIABETES INSIPIDA"
      },
      {
        "codigo": "E233",
        "valor": "DISFUNCION HIPOTALAMICA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "E236",
        "valor": "OTROS TRASTORNOS DE LA GLANDULA HIPOFISIS"
      },
      {
        "codigo": "E237",
        "valor": "TRASTORNO DE LA GLANDULA HIPOFISIS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E24 - SINDROME DE CUSHING",
    "detalle": [
      {
        "codigo": "E240",
        "valor": "ENFERMEDAD DE CUSHING DEPENDIENTE DE LA HIPOFISIS"
      },
      {
        "codigo": "E241",
        "valor": "SINDROME DE NELSON"
      },
      {
        "codigo": "E242",
        "valor": "SINDROME DE CUSHING INDUCIDO POR DROGAS"
      },
      {
        "codigo": "E243",
        "valor": "SINDROME DE ACTH ECTOPICO"
      },
      {
        "codigo": "E244",
        "valor": "SINDROME DE SEUDO-CUSHING INDUCIDO POR ALCOHOL"
      },
      {
        "codigo": "E248",
        "valor": "OTROS TIPOS DE SINDROME DE CUSHING"
      },
      {
        "codigo": "E249",
        "valor": "SINDROME DE CUSHING, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E25 - TRASTORNOS ADRENOGENITALES",
    "detalle": [
      {
        "codigo": "E250",
        "valor": "TRASTORNOS ADRENOGENITALES CONGENITOS CON DEFICIENCIA ENZIMATICA"
      },
      {
        "codigo": "E258",
        "valor": "OTROS TRASTORNOS ADRENOGENITALES"
      },
      {
        "codigo": "E259",
        "valor": "TRASTORNO ADRENOGENITAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E26 - HIPERALDOSTERONISMO",
    "detalle": [
      {
        "codigo": "E260",
        "valor": "HIPERALDOSTERONISMO PRIMARIO"
      },
      {
        "codigo": "E261",
        "valor": "HIPERALDOSTERONISMO SECUNDARIO"
      },
      {
        "codigo": "E268",
        "valor": "OTROS TIPOS DE HIPERALDOSTERONISMO"
      },
      {
        "codigo": "E269",
        "valor": "HIPERALDOSTERONISMO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E27 - OTROS TRASTORNOS DE LA GLANDULA SUPRARRENAL",
    "detalle": [
      {
        "codigo": "E270",
        "valor": "OTRA HIPERACTIVIDAD CORTICOSUPRARRENAL"
      },
      {
        "codigo": "E271",
        "valor": "INSUFICIENCIA CORTICOSUPRARRENAL PRIMARIA"
      },
      {
        "codigo": "E272",
        "valor": "CRISIS ADDISONIANA"
      },
      {
        "codigo": "E273",
        "valor": "INSUFICIENCIA CORTICOSUPRARRENAL INDUCIDA POR DROGAS"
      },
      {
        "codigo": "E274",
        "valor": "OTRAS INSUFICIENCIAS CORTICOSUPRARRENALES Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "E275",
        "valor": "HIPERFUNCION DE LA MEDULA SUPRARRENAL"
      },
      {
        "codigo": "E278",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA GLANDULA SUPRARRENAL"
      },
      {
        "codigo": "E279",
        "valor": "TRASTORNO DE LA GLANDULA SUPRARRENAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E28 - DISFUNCION OVARICA",
    "detalle": [
      {
        "codigo": "E280",
        "valor": "EXCESO DE ESTROGENOS"
      },
      {
        "codigo": "E281",
        "valor": "EXCESO DE ANDROGENOS"
      },
      {
        "codigo": "E282",
        "valor": "SINDROME DE OVARIO POLIQUISTICO"
      },
      {
        "codigo": "E283",
        "valor": "INSUFICIENCIA OVARICA PRIMARIA"
      },
      {
        "codigo": "E288",
        "valor": "OTRAS DISFUNCIONES OVARICAS"
      },
      {
        "codigo": "E289",
        "valor": "DISFUNCION OVARICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E29 - DISFUNCION TESTICULAR",
    "detalle": [
      {
        "codigo": "E290",
        "valor": "HIPERFUNCION TESTICULAR"
      },
      {
        "codigo": "E291",
        "valor": "HIPOFUNCION TESTICULAR"
      },
      {
        "codigo": "E298",
        "valor": "OTRAS DISFUNCIONES TESTICULARES"
      },
      {
        "codigo": "E299",
        "valor": "DISFUNCION TESTICULAR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E30 - TRASTORNOS DE LA PUBERTAD, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "E300",
        "valor": "PUBERTAD RETARDADA"
      },
      {
        "codigo": "E301",
        "valor": "PUBERTAD PRECOZ"
      },
      {
        "codigo": "E308",
        "valor": "OTROS TRASTORNOS DE LA PUBERTAD"
      },
      {
        "codigo": "E309",
        "valor": "TRASTORNO DE LA PUBERTAD, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E31 - DISFUNCION POLIGLANDULAR",
    "detalle": [
      {
        "codigo": "E310",
        "valor": "INSUFICIENCIA POLIGLANDULAR AUTOINMUNE"
      },
      {
        "codigo": "E311",
        "valor": "HIPERFUNCION POLIGLANDULAR"
      },
      {
        "codigo": "E318",
        "valor": "OTRAS DISFUNCIONES POLIGLANDULARES"
      },
      {
        "codigo": "E319",
        "valor": "DISFUNCION POLIGLANDULAR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E32 - ENFERMEDADES DEL TIMO",
    "detalle": [
      {
        "codigo": "E320",
        "valor": "HIPERPLASIA PERSISTENTE DEL TIMO"
      },
      {
        "codigo": "E321",
        "valor": "ABSCESO DEL TIMO"
      },
      {
        "codigo": "E328",
        "valor": "OTRAS ENFERMEDADES DEL TIMO"
      },
      {
        "codigo": "E329",
        "valor": "ENFERMEDAD DEL TIMO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E34 - OTROS TRASTORNOS ENDOCRINOS",
    "detalle": [
      {
        "codigo": "E340",
        "valor": "SINDROME CARCINOIDE"
      },
      {
        "codigo": "E341",
        "valor": "OTRAS HIPERSECRECIONES DE HORMONAS INTESTINALES"
      },
      {
        "codigo": "E342",
        "valor": "SECRECION HORMONAL ECTOPICA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "E343",
        "valor": "ENANISMO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "E3431",
        "valor": "TALLA BAJA"
      },
      {
        "codigo": "E344",
        "valor": "ESTATURA ALTA CONSTITUCIONAL"
      },
      {
        "codigo": "E345",
        "valor": "SINDROME DE RESISTENCIA ANDROGENICA"
      },
      {
        "codigo": "E348",
        "valor": "OTROS TRASTORNOS ENDOCRINOS ESPECIFICADOS"
      },
      {
        "codigo": "E349",
        "valor": "TRASTORNO ENDOCRINO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E35 - TRASTORNOS ENDOCRINOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "E350",
        "valor": "TRASTORNOS DE LA GLANDULA TIROIDES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "E351",
        "valor": "TRASTORNOS DE LAS GLANDULAS SUPRARRENALES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "E358",
        "valor": "TRASTORNOS DE OTRAS GLANDULAS ENDOCRINAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "E40 - KWASHIORKOR",
    "detalle": [
      {
        "codigo": "E40X",
        "valor": "KWASHIORKOR"
      }
    ]
  },
  {
    "grupo": "E41 - MARASMO NUTRICIONAL",
    "detalle": [
      {
        "codigo": "E41X",
        "valor": "MARASMO NUTRICIONAL"
      }
    ]
  },
  {
    "grupo": "E42 - KWASHIORKOR MARASMATICO",
    "detalle": [
      {
        "codigo": "E42X",
        "valor": "KWASHIORKOR MARASMATICO"
      }
    ]
  },
  {
    "grupo": "E43 - DESNUTRICION PROTEICOCALORICA SEVERA, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "E43X",
        "valor": "DESNUTRICION PROTEICOCALORICA SEVERA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E44 - DESNUTRICION PROTEICOCALORICA DE GRADO MODERADO Y LEVE",
    "detalle": [
      {
        "codigo": "E440",
        "valor": "DESNUTRICION PROTEICOCALORICA MODERADA"
      },
      {
        "codigo": "E441",
        "valor": "DESNUTRICION PROTEICOCALORICA LEVE"
      },
      {
        "codigo": "E449",
        "valor": "DESNUTRICION AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E45 - RETARDO DEL DESARROLLO DEBIDO A DESNUTRICION PROTEICOCALORICA",
    "detalle": [
      {
        "codigo": "E45X",
        "valor": "RETARDO DEL DESARROLLO DEBIDO A DESNUTRICION PROTEICOCALORICA"
      }
    ]
  },
  {
    "grupo": "E46 - DESNUTRICION PROTEICOCALORICA, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "E46X",
        "valor": "DESNUTRICION PROTEICOCALORICA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E50 - DEFICIENCIA DE VITAMINA A",
    "detalle": [
      {
        "codigo": "E500",
        "valor": "DEFICIENCIA DE VITAMINA A CON XEROSIS CONJUNTIVAL"
      },
      {
        "codigo": "E501",
        "valor": "DEFICIENCIA DE VITAMINA A CON MANCHA DE BITOT Y XEROSIS CONJUNTIVAL"
      },
      {
        "codigo": "E502",
        "valor": "DEFICIENCIA DE VITAMINA A CON XEROSIS CORNEAL"
      },
      {
        "codigo": "E503",
        "valor": "DEFICIENCIA DE VITAMINA A CON ULCERACION CORNEAL Y XEROSIS"
      },
      {
        "codigo": "E504",
        "valor": "DEFICIENCIA DE VITAMINA A CON QUERATOMALACIA"
      },
      {
        "codigo": "E505",
        "valor": "DEFICIENCIA DE VITAMINA A CON CEGUERA NOCTURNA"
      },
      {
        "codigo": "E506",
        "valor": "DEFICIENCIA DE VITAMINA A CON CICATRICES XEROFTALMICAS DE LA CORNEA"
      },
      {
        "codigo": "E507",
        "valor": "OTRAS MANIFESTACIONES OCULARES DE DEFICIENCIA DE VITAMINA A"
      },
      {
        "codigo": "E508",
        "valor": "OTRAS MANIFESTACIONES DE DEFICIENCIA DE VITAMINA A"
      },
      {
        "codigo": "E509",
        "valor": "DEFICIENCIA DE VITAMINA A, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E51 - DEFICIENCIA DE TIAMINA",
    "detalle": [
      {
        "codigo": "E511",
        "valor": "BERIBERI"
      },
      {
        "codigo": "E512",
        "valor": "ENCEFALOPATIA DE WERNICKE"
      },
      {
        "codigo": "E518",
        "valor": "OTRAS MANIFESTACIONES DE LA DEFICIENCIA DE TIAMINA"
      },
      {
        "codigo": "E519",
        "valor": "DEFICIENCIA DE TIAMINA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E52 - DEFICIENCIA DE NIACINA [PELAGRA]",
    "detalle": [
      {
        "codigo": "E52X",
        "valor": "DEFICIENCIA DE NIACINA [PELAGRA]"
      }
    ]
  },
  {
    "grupo": "E53 - DEFICIENCIAS DE OTRAS VITAMINAS DEL GRUPO B",
    "detalle": [
      {
        "codigo": "E530",
        "valor": "DEFICIENCIA DE RIBOFLAVINA"
      },
      {
        "codigo": "E531",
        "valor": "DEFICIENCIA DE PIRIDOXINA"
      },
      {
        "codigo": "E538",
        "valor": "DEFICIENCIA DE OTRAS VITAMINAS DEL GRUPO B"
      },
      {
        "codigo": "E539",
        "valor": "DEFICIENCIA DE VITAMINA B, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E54 - DEFICIENCIA DE ACIDO ASCORBICO",
    "detalle": [
      {
        "codigo": "E54X",
        "valor": "DEFICIENCIA DE ACIDO ASCORBICO"
      }
    ]
  },
  {
    "grupo": "E55 - DEFICIENCIA DE VITAMINA D",
    "detalle": [
      {
        "codigo": "E550",
        "valor": "RAQUITISMO ACTIVO"
      },
      {
        "codigo": "E559",
        "valor": "DEFICIENCIA DE VITAMINA D, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E56 - OTRAS DEFICIENCIAS DE VITAMINAS",
    "detalle": [
      {
        "codigo": "E560",
        "valor": "DEFICIENCIA DE VITAMINA E"
      },
      {
        "codigo": "E561",
        "valor": "DEFICIENCIA DE VITAMINA K"
      },
      {
        "codigo": "E568",
        "valor": "DEFICIENCIA DE OTRAS VITAMINAS"
      },
      {
        "codigo": "E569",
        "valor": "DEFICIENCIA DE VITAMINA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E58 - DEFICIENCIA DIETETICA DE CALCIO",
    "detalle": [
      {
        "codigo": "E58X",
        "valor": "DEFICIENCIA DIETETICA DE CALCIO"
      }
    ]
  },
  {
    "grupo": "E59 - DEFICIENCIA DIETETICA DE SELENIO",
    "detalle": [
      {
        "codigo": "E59X",
        "valor": "DEFICIENCIA DIETETICA DE SELENIO"
      }
    ]
  },
  {
    "grupo": "E60 - DEFICIENCIA DIETETICA DE ZINC",
    "detalle": [
      {
        "codigo": "E60X",
        "valor": "DEFICIENCIA DIETETICA DE ZINC"
      }
    ]
  },
  {
    "grupo": "E61 - DEFICIENCIAS DE OTROS ELEMENTOS NUTRICIONALES",
    "detalle": [
      {
        "codigo": "E610",
        "valor": "DEFICIENCIA DE COBRE"
      },
      {
        "codigo": "E611",
        "valor": "DEFICIENCIA DE HIERRO"
      },
      {
        "codigo": "E612",
        "valor": "DEFICIENCIA DE MAGNESIO"
      },
      {
        "codigo": "E613",
        "valor": "DEFICIENCIA DE MANGANESO"
      },
      {
        "codigo": "E614",
        "valor": "DEFICIENCIA DE CROMO"
      },
      {
        "codigo": "E615",
        "valor": "DEFICIENCIA DE MOLIBDENO"
      },
      {
        "codigo": "E616",
        "valor": "DEFICIENCIA DE VANADIO"
      },
      {
        "codigo": "E617",
        "valor": "DEFICIENCIA DE MULTIPLES ELEMENTOS NUTRICIONALES"
      },
      {
        "codigo": "E618",
        "valor": "DEFICIENCIA DE OTROS ELEMENTOS NUTRICIONALES ESPECIFICADOS"
      },
      {
        "codigo": "E619",
        "valor": "DEFICIENCIA DE OTRO ELEMENTO NUTRICIONAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E63 - OTRAS DEFICIENCIAS NUTRICIONALES",
    "detalle": [
      {
        "codigo": "E630",
        "valor": "DEFICIENCIA DE ACIDOS GRASOS ESENCIALES [AGE]"
      },
      {
        "codigo": "E631",
        "valor": "DESEQUILIBRIO DE LOS CONSTITUYENTES EN LA DIETA"
      },
      {
        "codigo": "E638",
        "valor": "OTRAS DEFICIENCIAS NUTRICIONALES ESPECIFICADAS"
      },
      {
        "codigo": "E639",
        "valor": "DEFICIENCIA NUTRICIONAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E64 - SECUELAS DE LA DESNUTRICION Y DE OTRAS DEFICIENCIAS NUTRICIONALES",
    "detalle": [
      {
        "codigo": "E640",
        "valor": "SECUELAS DE LA DESNUTRICION PROTEICOCALORICA"
      },
      {
        "codigo": "E641",
        "valor": "SECUELAS DE LA DEFICIENCIA DE VITAMINA A"
      },
      {
        "codigo": "E642",
        "valor": "SECUELAS DE LA DEFICIENCIA DE VITAMINA C"
      },
      {
        "codigo": "E643",
        "valor": "SECUELAS DEL RAQUITISMO"
      },
      {
        "codigo": "E648",
        "valor": "SECUELAS DE OTRAS DEFICIENCIAS NUTRICIONALES"
      },
      {
        "codigo": "E649",
        "valor": "SECUELAS DE LA DEFICIENCIA NUTRICIONAL NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E65 - ADIPOSIDAD LOCALIZADA",
    "detalle": [
      {
        "codigo": "E65X",
        "valor": "ADIPOSIDAD LOCALIZADA"
      }
    ]
  },
  {
    "grupo": "E66 - OBESIDAD",
    "detalle": [
      {
        "codigo": "E660",
        "valor": "OBESIDAD DEBIDA A EXCESO DE CALORIAS"
      },
      {
        "codigo": "E661",
        "valor": "OBESIDAD INDUCIDA POR DROGAS"
      },
      {
        "codigo": "E662",
        "valor": "OBESIDAD EXTREMA CON HIPOVENTILACION ALVEOLAR"
      },
      {
        "codigo": "E668",
        "valor": "OTROS TIPOS DE OBESIDAD"
      },
      {
        "codigo": "E669",
        "valor": "OBESIDAD, NO ESPECIFICADA"
      },
      {
        "codigo": "E6691",
        "valor": "OBESIDAD GRADO I"
      },
      {
        "codigo": "E6692",
        "valor": "OBESIDAD GRADO II"
      },
      {
        "codigo": "E6693",
        "valor": "OBESIDAD GRADO III"
      }
    ]
  },
  {
    "grupo": "E67 - OTROS TIPOS DE HIPERALIMENTACION",
    "detalle": [
      {
        "codigo": "E670",
        "valor": "HIPERVITAMINOSIS A"
      },
      {
        "codigo": "E671",
        "valor": "HIPERCAROTINEMIA"
      },
      {
        "codigo": "E672",
        "valor": "SINDROME DE MEGAVITAMINA B6"
      },
      {
        "codigo": "E673",
        "valor": "HIPERVITAMINOSIS D"
      },
      {
        "codigo": "E678",
        "valor": "OTROS TIPOS DE HIPERALIMENTACION ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "E68 - SECUELAS DE HIPERALIMENTACION",
    "detalle": [
      {
        "codigo": "E68X",
        "valor": "SECUELAS DE HIPERALIMENTACION"
      }
    ]
  },
  {
    "grupo": "E70 - TRASTORNOS DEL METABOLISMO DE LOS AMINOACIDOS AROMATICOS",
    "detalle": [
      {
        "codigo": "E700",
        "valor": "FENILCETONURIA CLASICA"
      },
      {
        "codigo": "E701",
        "valor": "OTRAS HIPERFENILALANINEMIAS"
      },
      {
        "codigo": "E702",
        "valor": "TRASTORNOS DEL METABOLISMO DE LA TIROSINA"
      },
      {
        "codigo": "E703",
        "valor": "ALBINISMO"
      },
      {
        "codigo": "E708",
        "valor": "OTROS TRASTORNOS DEL METABOLISMO DE LOS AMINOACIDOS AROMATICOS"
      },
      {
        "codigo": "E709",
        "valor": "TRASTORNO DEL METABOLISMO DE LOS AMINOACIDOS AROMATICOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E71 - TRASTORNOS DEL METABOLISMO DE LOS AMINOACIDOS DE CADENA RAMIFICADA Y DE LOS ACIDOS GRASOS",
    "detalle": [
      {
        "codigo": "E710",
        "valor": "ENFERMEDAD DE LA ORINA EN JARABE DE ARCE"
      },
      {
        "codigo": "E711",
        "valor": "OTROS TRASTORNOS DEL METABOLISMO DE LOS AMINOACIDOS DE CADENA RAMIFICADA"
      },
      {
        "codigo": "E712",
        "valor": "OTROS TRASTORNOS DEL METABOLISMO DE LOS AMINOACIDOS DE CADENA RAMIFICADA, NO ESPECIFICADOS"
      },
      {
        "codigo": "E713",
        "valor": "TRASTORNOS DEL METABOLISMO DE LOS ACIDOS GRASOS"
      }
    ]
  },
  {
    "grupo": "E72 - OTROS TRASTORNOS DEL METABOLISMO DE LOS AMINOACIDOS",
    "detalle": [
      {
        "codigo": "E720",
        "valor": "TRASTORNOS DEL TRANSPORTE DE LOS AMINOACIDOS"
      },
      {
        "codigo": "E721",
        "valor": "TRASTORNOS DEL METABOLISMO DE LOS AMINOACIDOS AZUFRADOS"
      },
      {
        "codigo": "E722",
        "valor": "TRASTORNOS DEL METABOLISMO DEL CICLO DE LA UREA"
      },
      {
        "codigo": "E723",
        "valor": "TRASTORNOS DEL METABOLISMO DE LA LISINA Y LA HIDROXILISINA"
      },
      {
        "codigo": "E724",
        "valor": "TRASTORNOS DEL METABOLISMO DE LA ORNITINA"
      },
      {
        "codigo": "E725",
        "valor": "TRASTORNOS DEL METABOLISMO DE LA GLICINA"
      },
      {
        "codigo": "E728",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL METABOLISMO DE LOS AMINOACIDOS"
      },
      {
        "codigo": "E729",
        "valor": "TRASTORNO DEL METABOLISMO DE LOS AMINOACIDOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E73 - INTOLERANCIA A LA LACTOSA",
    "detalle": [
      {
        "codigo": "E730",
        "valor": "DEFICIENCIA CONGENITA DE LACTASA"
      },
      {
        "codigo": "E731",
        "valor": "DEFICIENCIA SECUNDARIA DE LACTASA"
      },
      {
        "codigo": "E738",
        "valor": "OTROS TIPOS DE INTOLERANCIA A LA LACTOSA"
      },
      {
        "codigo": "E739",
        "valor": "INTOLERANCIA A LA LACTOSA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E74 - OTROS TRASTORNOS DEL METABOLISMO DE LOS CARBOHIDRATOS",
    "detalle": [
      {
        "codigo": "E740",
        "valor": "ENFERMEDAD DEL ALMACENAMIENTO DE GLUCOGENO"
      },
      {
        "codigo": "E741",
        "valor": "TRASTORNOS DEL METABOLISMO DE LA FRUCTOSA"
      },
      {
        "codigo": "E742",
        "valor": "TRASTORNO DEL METABOLISMO DE LA GALACTOSA"
      },
      {
        "codigo": "E743",
        "valor": "OTROS TRASTORNOS DE LA ABSORCION INTESTINAL DE CARBOHIDRATOS"
      },
      {
        "codigo": "E744",
        "valor": "TRASTORNOS DEL METABOLISMO DEL PIRUVATO Y DE LA GLUCONEOGENESIS"
      },
      {
        "codigo": "E748",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL METABOLISMO DE LOS CARBOHIDRATOS"
      },
      {
        "codigo": "E749",
        "valor": "TRASTORNO DEL METABOLISMO DE LOS CARBOHIDRATOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E75 - TRASTORNOS DEL METABOLISMO DE LOS ESFINGOLIPIDOS Y OTROS TRASTORNOS POR ALMACENAMIENTO DE LIPIDOS",
    "detalle": [
      {
        "codigo": "E750",
        "valor": "GANGLIOSIDOSIS GM2"
      },
      {
        "codigo": "E751",
        "valor": "OTRAS GANGLIOSIDOSIS"
      },
      {
        "codigo": "E752",
        "valor": "OTRAS ESFINGOLIPIDOSIS"
      },
      {
        "codigo": "E753",
        "valor": "ESFINGOLIPIDOSIS, NO ESPECIFICADA"
      },
      {
        "codigo": "E754",
        "valor": "LIPOFUSCINOSIS CEROIDE NEURONAL"
      },
      {
        "codigo": "E755",
        "valor": "OTROS TRASTORNOS DEL ALMACENAMIENTO DE LIPIDOS"
      },
      {
        "codigo": "E756",
        "valor": "TRASTORNO DEL ALMACENAMIENTO DE LIPIDOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E76 - TRASTORNOS DEL METABOLISMO DE LOS GLUCOSAMINOGLICANOS",
    "detalle": [
      {
        "codigo": "E760",
        "valor": "MUCOPOLISACARIDOSIS TIPO I"
      },
      {
        "codigo": "E761",
        "valor": "MUCOPOLISACARIDOSIS TIPO II"
      },
      {
        "codigo": "E762",
        "valor": "OTRAS MUCOPOLISACARIDOSIS"
      },
      {
        "codigo": "E763",
        "valor": "MUCOPOLISACARIDOSIS NO ESPECIFICADA"
      },
      {
        "codigo": "E768",
        "valor": "OTROS TRASTORNOS DEL METABOLISMO DE LOS GLUCOSAMINOGLICANOS"
      },
      {
        "codigo": "E769",
        "valor": "TRASTORNO DEL METABOLISMO DE LOS GLUCOSAMINOGLICANOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E77 - TRASTORNOS DEL METABOLISMO DE LAS GLUCOPROTEINAS",
    "detalle": [
      {
        "codigo": "E770",
        "valor": "DEFECTOS EN LA MODIFICACION POSTRASLACIONAL DE ENZIMAS LISOSOMALES"
      },
      {
        "codigo": "E771",
        "valor": "DEFECTOS DE LA DEGRADACION DE GLUCOPROTEINAS"
      },
      {
        "codigo": "E778",
        "valor": "OTROS TRASTORNOS DEL METABOLISMO DE LAS GLUCOPROTEINAS"
      },
      {
        "codigo": "E779",
        "valor": "TRASTORNOS DEL METABOLISMO DE LAS GLUCOPROTEINAS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E78 - TRASTORNOS DEL METABOLISMO DE LAS LIPOPROTEINAS Y OTRAS LIPIDEMIAS",
    "detalle": [
      {
        "codigo": "E780",
        "valor": "HIPERCOLESTEROLEMIA PURA"
      },
      {
        "codigo": "E781",
        "valor": "HIPERGLICERIDEMIA PURA"
      },
      {
        "codigo": "E782",
        "valor": "HIPERLIPIDEMIA MIXTA"
      },
      {
        "codigo": "E783",
        "valor": "HIPERQUILOMICRONEMIA"
      },
      {
        "codigo": "E784",
        "valor": "OTRA HIPERLIPIDEMIA"
      },
      {
        "codigo": "E785",
        "valor": "HIPERLIPIDEMIA NO ESPECIFICADA"
      },
      {
        "codigo": "E786",
        "valor": "DEFICIENCIA DE LIPOPROTEINAS"
      },
      {
        "codigo": "E788",
        "valor": "OTROS TRASTORNOS DEL METABOLISMO DE LAS LIPOPROTEINAS"
      },
      {
        "codigo": "E789",
        "valor": "TRASTORNO DEL METABOLISMO DE LAS LIPOPROTEINAS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E79 - TRASTORNOS DEL METABOLISMO DE LAS PURINAS Y DE LAS PIRIMIDINAS",
    "detalle": [
      {
        "codigo": "E790",
        "valor": "HIPERURICEMIA SIN SIGNOS DE ARTRITIS INFLAMATORIA Y ENFERMEDAD TOFACEA"
      },
      {
        "codigo": "E791",
        "valor": "SINDROME DE LESCH-NYHAN"
      },
      {
        "codigo": "E798",
        "valor": "OTROS TRASTORNOS DEL METABOLISMO DE LAS PURINAS Y DE LAS PIRIMIDINAS"
      },
      {
        "codigo": "E799",
        "valor": "TRASTORNO DEL METABOLISMO DE LAS PURINAS Y DE LAS PIRIMIDINAS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E80 - TRASTORNOS DEL METABOLISMO DE LAS PORFIRINAS Y DE LA BILIRRUBINA",
    "detalle": [
      {
        "codigo": "E800",
        "valor": "PORFIRIA ERITROPOYETICA HEREDITARIA"
      },
      {
        "codigo": "E801",
        "valor": "PORFIRIA CUTANEA TARDIA"
      },
      {
        "codigo": "E802",
        "valor": "OTRAS PORFIRIAS"
      },
      {
        "codigo": "E803",
        "valor": "DEFECTOS DE CATALASA Y PEROXIDASA"
      },
      {
        "codigo": "E804",
        "valor": "SINDROME DE GILBERT"
      },
      {
        "codigo": "E805",
        "valor": "SINDROME DE CRIGLER-NAJJAR"
      },
      {
        "codigo": "E806",
        "valor": "OTROS TRASTORNOS DEL METABOLISMO DE LA BILIRRUBINA"
      },
      {
        "codigo": "E807",
        "valor": "TRASTORNO DEL METABOLISMO DE LA BILIRRUBINA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E83 - TRASTORNOS DEL METABOLISMO DE LOS MINERALES",
    "detalle": [
      {
        "codigo": "E830",
        "valor": "TRASTORNOS DEL METABOLISMO DEL COBRE"
      },
      {
        "codigo": "E831",
        "valor": "TRASTORNOS DEL METABOLISMO DEL HIERRO"
      },
      {
        "codigo": "E832",
        "valor": "TRASTORNOS DEL METABOLISMO DEL ZINC"
      },
      {
        "codigo": "E833",
        "valor": "TRASTORNOS DEL METABOLISMO DEL FOSFORO Y FOSFATASA"
      },
      {
        "codigo": "E834",
        "valor": "TRASTORNOS DEL METABOLISMO DEL MAGNESIO"
      },
      {
        "codigo": "E835",
        "valor": "TRASTORNOS DEL METABOLISMO DEL CALCIO"
      },
      {
        "codigo": "E838",
        "valor": "OTROS TRASTORNOS DEL METABOLISMO DE LOS MINERALES"
      },
      {
        "codigo": "E839",
        "valor": "TRASTORNO DEL METABOLISMO DE LOS MINERALES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E84 - FIBROSIS QUISTICA",
    "detalle": [
      {
        "codigo": "E840",
        "valor": "FIBROSIS QUISTICA CON MANIFESTACIONES PULMONARES"
      },
      {
        "codigo": "E841",
        "valor": "FIBROSIS QUISTICA CON MANIFESTACIONES INTESTINALES"
      },
      {
        "codigo": "E848",
        "valor": "FIBROSIS QUISTICA CON OTRAS MANIFESTACIONES"
      },
      {
        "codigo": "E849",
        "valor": "FIBROSIS QUISTICA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "E85 - AMILOIDOSIS",
    "detalle": [
      {
        "codigo": "E850",
        "valor": "AMILOIDOSIS HEREDOFAMILIAR NO NEUROPATICA"
      },
      {
        "codigo": "E851",
        "valor": "AMILOIDOSIS HEREDOFAMILIAR NEUROPATICA"
      },
      {
        "codigo": "E852",
        "valor": "AMILOIDOSIS HEREDOFAMILIAR NO ESPECIFICADA"
      },
      {
        "codigo": "E853",
        "valor": "AMILOIDOSIS SISTEMICA SECUNDARIA"
      },
      {
        "codigo": "E854",
        "valor": "AMILOIDOSIS LIMITADA A UN ORGANO"
      },
      {
        "codigo": "E858",
        "valor": "OTRAS AMILOIDOSIS"
      },
      {
        "codigo": "E859",
        "valor": "AMILOIDOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "E86 - DEPLECION DEL VOLUMEN",
    "detalle": [
      {
        "codigo": "E86X",
        "valor": "DESHIDRATACION / DEPLECION DEL VOLUMEN"
      }
    ]
  },
  {
    "grupo": "E87 - OTROS TRASTORNOS DE LOS LIQUIDOS, DE LOS ELECTROLITOS Y DEL EQUILIBRIO",
    "detalle": [
      {
        "codigo": "E870",
        "valor": "HIPEROSMOLARIDAD E HIPERNATREMIA"
      },
      {
        "codigo": "E871",
        "valor": "HIPOSMOLARIDAD E HIPONATREMIA"
      },
      {
        "codigo": "E872",
        "valor": "ACIDOSIS"
      },
      {
        "codigo": "E873",
        "valor": "ALCALOSIS"
      },
      {
        "codigo": "E874",
        "valor": "TRASTORNOS MIXTOS DEL BALANCE ACIDO-BASICO"
      },
      {
        "codigo": "E875",
        "valor": "HIPERPOTASEMIA"
      },
      {
        "codigo": "E876",
        "valor": "HIPOPOTASMIA"
      },
      {
        "codigo": "E877",
        "valor": "SOBRECARGA DE LIQUIDOS"
      },
      {
        "codigo": "E878",
        "valor": "OTROS TRASTORNOS DEL EQUILIBRIO DE LOS ELECTROLITOS Y DE LOS LIQUIDOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "E88 - OTROS TRASTORNOS METABOLICOS",
    "detalle": [
      {
        "codigo": "E880",
        "valor": "TRASTORNOS DEL METABOLISMO DE LAS PROTEINAS PLASMATICAS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "E881",
        "valor": "LIPODISTROFIA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "E882",
        "valor": "LIPOMATOSIS, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "E883",
        "valor": "SINDROME DE LISIS TUMORAL"
      },
      {
        "codigo": "E888",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL METABOLISMO"
      },
      {
        "codigo": "E889",
        "valor": "TRASTORNO METABOLICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E89 - TRASTORNOS ENDOCRINOS Y METABOLICOS CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "E890",
        "valor": "HIPOTIROIDISMO CONSECUTIVO A PROCEDIMIENTOS"
      },
      {
        "codigo": "E891",
        "valor": "HIPOINSULINEMIA CONSECUTIVA A PROCEDIMIENTOS"
      },
      {
        "codigo": "E892",
        "valor": "HIPOPARATIROIDISMO CONSECUTIVO A PROCEDIMIENTOS"
      },
      {
        "codigo": "E893",
        "valor": "HIPOPITUITARISMO CONSECUTIVO A PROCEDIMIENTOS"
      },
      {
        "codigo": "E894",
        "valor": "INSUFICIENCIA OVARICA CONSECUTIVA A PROCEDIMIENTOS"
      },
      {
        "codigo": "E895",
        "valor": "HIPOFUNCION TESTICULAR CONSECUTIVA A PROCEDIMIENTOS"
      },
      {
        "codigo": "E896",
        "valor": "HIPOFUNCION ADRENOCORTICAL [MEDULA SUPRARRENAL] CONSECUTIVA A PROCEDIMIENTOS"
      },
      {
        "codigo": "E898",
        "valor": "OTROS TRASTORNOS METABOLICOS Y ENDOCRINOS CONSECUTIVOS A PROCEDIMIENTOS"
      },
      {
        "codigo": "E899",
        "valor": "TRASTORNO ENDOCRINO Y METABOLICO CONSECUTIVO A PROCEDIMIENTOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "E90 - TRASTORNOS NUTRICIONALES Y METABOLICOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "E90X",
        "valor": "TRASTORNOS NUTRICIONALES Y METABOLICOS EN ENFERMEDADES CLASIFICADAS EN OTRA PART"
      }
    ]
  },
  {
    "grupo": "F00 - DEMENCIA EN LA ENFERMEDAD DE ALZHEIMER (G30.-+)",
    "detalle": [
      {
        "codigo": "F000",
        "valor": "DEMENCIA EN LA ENFERMEDAD DE ALZHEIMER, DE COMIENZO TEMPRANO"
      },
      {
        "codigo": "F001",
        "valor": "DEMENCIA EN LA ENFERMEDAD DE ALZHEIMER, DE COMIENZO TARDIO"
      },
      {
        "codigo": "F002",
        "valor": "DEMENCIA EN LA ENFERMEDAD DE ALZHEIMER, ATIPICA O DE TIPO MIXTO"
      },
      {
        "codigo": "F009",
        "valor": "DEMENCIA EN LA ENFERMEDAD DE ALZHEIMER, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "F01 - DEMENCIA VASCULAR",
    "detalle": [
      {
        "codigo": "F010",
        "valor": "DEMENCIA VASCULAR DE COMIENZO AGUDO"
      },
      {
        "codigo": "F011",
        "valor": "DEMENCIA VASCULAR POR INFARTOS MULTIPLES"
      },
      {
        "codigo": "F012",
        "valor": "DEMENCIA VASCULAR SUBCORTICAL"
      },
      {
        "codigo": "F013",
        "valor": "DEMENCIA VASCULAR MIXTA, CORTICAL Y SUBCORTICAL"
      },
      {
        "codigo": "F018",
        "valor": "OTRAS DEMENCIA VASCULARES"
      },
      {
        "codigo": "F019",
        "valor": "DEMENCIA VASCULAR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "F02 - DEMENCIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "F020",
        "valor": "DEMENCIA EN LA ENFERMEDAD DE PICK"
      },
      {
        "codigo": "F021",
        "valor": "DEMENCIA EN LA ENFERMEDAD DE CREUTZFELDT-JAKOB"
      },
      {
        "codigo": "F022",
        "valor": "DEMENCIA EN LA ENFERMEDAD DE HUNTINGTON"
      },
      {
        "codigo": "F023",
        "valor": "DEMENCIA EN LA ENFERMEDAD DE PARKINSON"
      },
      {
        "codigo": "F024",
        "valor": "DEMENCIA EN LA ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]"
      },
      {
        "codigo": "F028",
        "valor": "DEMENCIA EN OTRAS ENFERMEDADES ESPECIFICADAS CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "F03 - DEMENCIA, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "F03X",
        "valor": "DEMENCIA SIN ESPECIFICACION."
      }
    ]
  },
  {
    "grupo": "F04 - SINDROME AMNESICO ORGANICO, NO INDUCIDO POR ALCOHOL O POR OTRAS SUSTANCIAS",
    "detalle": [
      {
        "codigo": "F04X",
        "valor": "SINDROME AMNESICO ORGANICO, NO INDUCIDO POR ALCOHOL O POR OTRAS SUSTANCIAS PSICO"
      }
    ]
  },
  {
    "grupo": "F05 - DELIRIO, NO INDUCIDO POR ALCOHOL O POR OTRAS SUSTANCIAS PSICOACTIVAS",
    "detalle": [
      {
        "codigo": "F050",
        "valor": "DELIRIO NO SUPERPUESTO A UN CUADRO DE DEMENCIA, ASI DESCRITO"
      },
      {
        "codigo": "F051",
        "valor": "DELIRIO SUPERPUESTO A UN CUADRO DE DEMENCIA"
      },
      {
        "codigo": "F058",
        "valor": "OTROS DELIRIOS"
      },
      {
        "codigo": "F059",
        "valor": "DELIRIO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F06 - OTROS TRASTORNOS MENTALES DEBIDOS A LESION Y DISFUNCION CEREBRAL, Y A ENFERMEDAD FISICA",
    "detalle": [
      {
        "codigo": "F060",
        "valor": "ALUCINOSIS ORGANICA"
      },
      {
        "codigo": "F061",
        "valor": "TRASTORNO CATATONICO, ORGANICO"
      },
      {
        "codigo": "F062",
        "valor": "TRASTORNO DELIRANTE [ESQUIZOFRENIFORME], ORGANICO"
      },
      {
        "codigo": "F063",
        "valor": "TRASTORNOS DEL HUMOR [AFECTIVOS], ORGANICOS"
      },
      {
        "codigo": "F064",
        "valor": "TRASTORNO DE ANSIEDAD, ORGANICO"
      },
      {
        "codigo": "F065",
        "valor": "TRASTORNO DISOCIATIVO, ORGANICO"
      },
      {
        "codigo": "F066",
        "valor": "TRASTORNO DE LABILIDAD EMOCIONAL [ASTENICO], ORGANICO"
      },
      {
        "codigo": "F067",
        "valor": "TRASTORNO COGNOSCITIVO LEVE"
      },
      {
        "codigo": "F068",
        "valor": "OTROS TRASTORNOS MENTALES ESPECIFICADOS DEBIDOS A LESION Y DISFUNCION CEREBRAL Y A ENFERMEDAD FISICA"
      },
      {
        "codigo": "F069",
        "valor": "TRASTORNO MENTAL NO ESPECIFICADO DEBIDO A LESION Y DISFUNCION CEREBRAL Y A ENFERMEDAD FISICA"
      }
    ]
  },
  {
    "grupo": "F07 - TRASTORNOS DE LA PERSONALIDAD Y DEL COMPORTAMIENTO DEBIDOS A ENFERMEDADES LESION O DISFUNCION CEREBRAL",
    "detalle": [
      {
        "codigo": "F070",
        "valor": "TRASTORNO DE LA PERSONALIDAD, ORGANICO"
      },
      {
        "codigo": "F071",
        "valor": "SINDROME POSTENCEFALITICO"
      },
      {
        "codigo": "F072",
        "valor": "SINDROME POSTCONCUSIONAL"
      },
      {
        "codigo": "F078",
        "valor": "OTROS TRASTORNOS ORGANICOS DE LA PERSONALIDAD Y DEL COMPORTAMIENTO DEBIDOS A ENFERMEDAD, LESION Y DISFUNCION CEREBRALES"
      },
      {
        "codigo": "F079",
        "valor": "TRASTORNO ORGANICO DE LA PERSONALIDAD Y DEL COMPORTAMIENTO, NO ESPECIFICADO, DEBIDO A ENFERMEDAD, LESION Y DISFUNCION CEREBRAL"
      }
    ]
  },
  {
    "grupo": "F09 - TRASTORNO MENTAL ORGANICO O SINTOMATICO, NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "F09X",
        "valor": "TRASTORNO MENTAL ORGANICO O SINTOMATICO SIN ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "F10 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL",
    "detalle": [
      {
        "codigo": "F100",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL, INTOXICACION AGUDA"
      },
      {
        "codigo": "F101",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL, USO NOCIVO"
      },
      {
        "codigo": "F1011",
        "valor": "ALTO RIESGO POR CONSUMO EXCESIVO DE ALCOHOL"
      },
      {
        "codigo": "F102",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL, SINDROME DE DEPENDENCIA"
      },
      {
        "codigo": "F103",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL, ESTADO DE ABSTINENCIA"
      },
      {
        "codigo": "F104",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL, ESTADO DE ABSTINENCIA CON DELIRIO"
      },
      {
        "codigo": "F105",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL, TRASTORNO PSICOTICO"
      },
      {
        "codigo": "F106",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL, SINDROME AMNESICO"
      },
      {
        "codigo": "F107",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL, TRASTORNO PSICOTICO RESIDUAL Y DE COMIENZO TARDIO"
      },
      {
        "codigo": "F108",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL, OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F109",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALCOHOL, TRASTORNO MENTAL Y DEL COMPORTAMIENTO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F11 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS",
    "detalle": [
      {
        "codigo": "F110",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS, INTOXICACION AGUDA"
      },
      {
        "codigo": "F111",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS, USO NOCIVO"
      },
      {
        "codigo": "F112",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS, SINDROME DE DEPENDENCIA"
      },
      {
        "codigo": "F113",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS, ESTADO DE ABSTINENCIA"
      },
      {
        "codigo": "F114",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS, ESTADO DE ABSTINENCIA CON DELIRIO"
      },
      {
        "codigo": "F115",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS, TRASTORNO PSICOTICO"
      },
      {
        "codigo": "F116",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS, SINDROME AMNESICO"
      },
      {
        "codigo": "F117",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS, TRASTORNO PSICOTICO RESIDUAL Y DE COMIENZO TARDIO"
      },
      {
        "codigo": "F118",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS, OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F119",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS, TRASTORNO MENTAL Y DEL COMPORTAMIENTO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F12 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANVE, VER SUSBDIVISIONES EN [F10]",
    "detalle": [
      {
        "codigo": "F120",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES, INTOXICACION AGUDA"
      },
      {
        "codigo": "F121",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES, USO NOCIVO"
      },
      {
        "codigo": "F122",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES, SINDROME DE DEPENDENCIA"
      },
      {
        "codigo": "F123",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES, ESTADO DE ABSTINENCIA"
      },
      {
        "codigo": "F124",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES, ESTADO DE ABSTINENCIA CON DELIRIO"
      },
      {
        "codigo": "F125",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES, TRASTORNO PSICOTICO"
      },
      {
        "codigo": "F126",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES, SINDROME AMNESICO"
      },
      {
        "codigo": "F127",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES, TRASTORNO PSICOTICO RESIDUAL Y DE COMIENZO TARDIO"
      },
      {
        "codigo": "F128",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES, OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F129",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES, TRASTORNO MENTAL Y DEL COMPORTAMIENTO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F13 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HINOPTICOS",
    "detalle": [
      {
        "codigo": "F130",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS, INTOXICACION AGUDA"
      },
      {
        "codigo": "F131",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS, USO NOCIVO"
      },
      {
        "codigo": "F132",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS, SINDROME DE DEPENDENCIA"
      },
      {
        "codigo": "F133",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS, ESTADO DE ABSTINENCIA"
      },
      {
        "codigo": "F134",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS, ESTADO DE ABSTINENCIA CON DELIRIO"
      },
      {
        "codigo": "F135",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS, TRASTORNO PSICOTICO"
      },
      {
        "codigo": "F136",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS, SINDROME AMNESICO"
      },
      {
        "codigo": "F137",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS, TRASTORNO PSICOTICO RESIDUAL Y DE COMIENZO TARDIO"
      },
      {
        "codigo": "F138",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS, OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F139",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS, TRASTORNOS MENTAL Y DEL COMPORTAMIENTO, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "F14 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA",
    "detalle": [
      {
        "codigo": "F140",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA, INTOXICACION AGUDA"
      },
      {
        "codigo": "F141",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA, USO NOCIVO"
      },
      {
        "codigo": "F142",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA, SINDROME DE DEPENDENCIA"
      },
      {
        "codigo": "F143",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA, ESTADO DE ABSTINENCIA"
      },
      {
        "codigo": "F144",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA, ESTADO DE ABSTINENCIA CON DELIRIO"
      },
      {
        "codigo": "F145",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA, TRASTORNO PSICOTICO"
      },
      {
        "codigo": "F146",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA, SINDROME AMNESICO"
      },
      {
        "codigo": "F147",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA, TRASTORNO PSICOTICO RESIDUAL Y DE COMIENZO TARDIO"
      },
      {
        "codigo": "F148",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA, OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F149",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA, TRASTORNO MENTAL Y DEL COMPORTAMIENTO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F15 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA",
    "detalle": [
      {
        "codigo": "F150",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA, INTOXICACION AGUDA"
      },
      {
        "codigo": "F151",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA, USO NOCIVO"
      },
      {
        "codigo": "F152",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA, SINDROME DE DEPENDENCIA"
      },
      {
        "codigo": "F153",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA, ESTADO DE ABSTINENCIA"
      },
      {
        "codigo": "F154",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA, ESTADO DE ABSTINENCIA CON DELIRIO"
      },
      {
        "codigo": "F155",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA, TRASTORNO PSICOTICO"
      },
      {
        "codigo": "F156",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA, SINDROME AMNESICO"
      },
      {
        "codigo": "F157",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA, TRASTORNO PSICOTICO RESIDUAL Y DE COMIENZO TARDIO"
      },
      {
        "codigo": "F158",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA, OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F159",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA, TRASTORNO MENTAL Y DEL COMPORTAMIENTO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F16 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS",
    "detalle": [
      {
        "codigo": "F160",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS, INTOXICACION AGUDA"
      },
      {
        "codigo": "F161",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS, USO NOCIVO"
      },
      {
        "codigo": "F162",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS, SINDROME DE DEPENDENCIA"
      },
      {
        "codigo": "F163",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS, ESTADO DE ABSTINENCIA"
      },
      {
        "codigo": "F164",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS, ESTADO DE ABSTINENCIA CON DELIRIO"
      },
      {
        "codigo": "F165",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS, TRASTORNO PSICOTICO"
      },
      {
        "codigo": "F166",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS, SINDROME AMNESICO"
      },
      {
        "codigo": "F167",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS, TRASTORNO PSICOTICO RESIDUAL Y DE COMIENZO TARDIO"
      },
      {
        "codigo": "F168",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS, OTROS TRASTORNO MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F169",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS, TRASTORNO MENTAL Y DEL COMPORTAMIENTO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F17 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO",
    "detalle": [
      {
        "codigo": "F170",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO, INTOXICACION AGUDA"
      },
      {
        "codigo": "F171",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO, USO NOCIVO"
      },
      {
        "codigo": "F172",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO, SINDROME DE DEPENDENCIA"
      },
      {
        "codigo": "F173",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO, ESTADO DE ABSTINENCIA"
      },
      {
        "codigo": "F174",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO, ESTADO DE ABSTINENCIA CON DELIRIO"
      },
      {
        "codigo": "F175",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO, TRASTORNO PSICOTICO"
      },
      {
        "codigo": "F176",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO, SINDROME AMNESICO"
      },
      {
        "codigo": "F177",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO, TRASTORNO PSICOTICO RESIDUAL Y DE COMIENZO TARDIO"
      },
      {
        "codigo": "F178",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO, OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F179",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO, TRASTORNO MENTAL Y DEL COMPORTAMIENTO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F18 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES",
    "detalle": [
      {
        "codigo": "F180",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES, INTOXICACION AGUDA"
      },
      {
        "codigo": "F181",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES, USO NOCIVO"
      },
      {
        "codigo": "F182",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES, SINDROME DE DEPENDENCIA"
      },
      {
        "codigo": "F183",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES, ESTADO DE ABSTINENCIA"
      },
      {
        "codigo": "F184",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES, ESTADO DE ABSTINENCIA CON DELIRIO"
      },
      {
        "codigo": "F185",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES, TRASTORNO PSICOTICO"
      },
      {
        "codigo": "F186",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES, SINDROME AMNESICO"
      },
      {
        "codigo": "F187",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES, TRASTORNO PSICOTICO RESIDUAL Y DE COMIENZO TARDIO"
      },
      {
        "codigo": "F188",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES, OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F189",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES, TRASTORNO MENTAL Y DEL COMPORTAMIENTO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F19 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES D DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS",
    "detalle": [
      {
        "codigo": "F190",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS, INTOXICACION AGUDA"
      },
      {
        "codigo": "F191",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS, USO NOCIVO"
      },
      {
        "codigo": "F192",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS, SINDROME DE DEPENDENDENCIA"
      },
      {
        "codigo": "F193",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS, ESTADO DE ABSTINENCIA"
      },
      {
        "codigo": "F194",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS, ESTADO DE ABSTINENCIA CON DELIRIO"
      },
      {
        "codigo": "F195",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS, TRASTORNO PSICOTICO"
      },
      {
        "codigo": "F196",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS, SINDROME AMNESICO"
      },
      {
        "codigo": "F197",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS, TRASTORNO PSICOTICO RESIDUAL Y DE COMIENZO TARDIO"
      },
      {
        "codigo": "F198",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS, OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F199",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTANCIAS PSICOACTIVAS, TRASTORNO MENTAL Y DEL COMPORTAMIENTO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F20 - ESQUIZOFRENIA",
    "detalle": [
      {
        "codigo": "F200",
        "valor": "ESQUIZOFRENIA PARANOIDE"
      },
      {
        "codigo": "F201",
        "valor": "ESQUIZOFRENIA HEBEFRENICA"
      },
      {
        "codigo": "F202",
        "valor": "ESQUIZOFRENIA CATATONICA"
      },
      {
        "codigo": "F203",
        "valor": "ESQUIZOFRENIA INDIFERENCIADA"
      },
      {
        "codigo": "F204",
        "valor": "DEPRESION POSTESQUIZOFRENICA"
      },
      {
        "codigo": "F205",
        "valor": "ESQUIZOFRENIA RESIDUAL"
      },
      {
        "codigo": "F206",
        "valor": "ESQUIZOFRENIA SIMPLE"
      },
      {
        "codigo": "F208",
        "valor": "OTRAS ESQUIZOFRENIAS"
      },
      {
        "codigo": "F209",
        "valor": "ESQUIZOFRENIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "F21 - TRASTORNO ESQUIZOTIPICO",
    "detalle": [
      {
        "codigo": "F21X",
        "valor": "TRASTORNO ESQUIZOTIPICO"
      }
    ]
  },
  {
    "grupo": "F22 - TRASTORNOS DELIRANTES PERSISTENTES",
    "detalle": [
      {
        "codigo": "F220",
        "valor": "TRASTORNO DELIRANTE"
      },
      {
        "codigo": "F228",
        "valor": "OTROS TRASTORNOS DELIRANTES PERSISTENTES"
      },
      {
        "codigo": "F229",
        "valor": "TRASTORNOS DELIRANTE PERSISTENTE, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F23 - TRASTORNOS PSICOTICOS AGUDOS Y TRANSITORIOS",
    "detalle": [
      {
        "codigo": "F230",
        "valor": "TRASTORNO PSICOTICO AGUDO POLIMORFO, SIN SINTOMAS DE ESQUIZOFRENIA"
      },
      {
        "codigo": "F231",
        "valor": "TRASTORNO PSICOTICO AGUDO POLIMORFO, CON SINTOMAS DE ESQUIZOFRENIA"
      },
      {
        "codigo": "F232",
        "valor": "TRASTORNO PSICOTICO AGUDO DE TIPO ESQUIZOFRENICO"
      },
      {
        "codigo": "F233",
        "valor": "OTRO TRASTORNO PSICOTICO AGUDO, CON PREDOMINIO DE IDEAS DELIRANTES"
      },
      {
        "codigo": "F238",
        "valor": "OTROS TRASTORNOS PSICOTICOS AGUDOS Y TRANSITORIOS"
      },
      {
        "codigo": "F239",
        "valor": "TRASTORNO PSICOTICO AGUDO Y TRANSITORIO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F24 - TRASTORNO DELIRANTE INDUCIDO",
    "detalle": [
      {
        "codigo": "F24X",
        "valor": "TRASTORNO DELIRANTE INDUCIDO"
      }
    ]
  },
  {
    "grupo": "F25 - TRASTORNOS ESQUIZOAFECTIVOS",
    "detalle": [
      {
        "codigo": "F250",
        "valor": "TRASTORNO ESQUIZOAFECTIVO DE TIPO MANIACO"
      },
      {
        "codigo": "F251",
        "valor": "TRASTORNO ESQUIZOAFECTIVO DE TIPO DEPRESIVO"
      },
      {
        "codigo": "F252",
        "valor": "TRASTORNO ESQUIZOAFECTIVO DE TIPO MIXTO"
      },
      {
        "codigo": "F258",
        "valor": "OTROS TRASTORNOS ESQUIZOAFECTIVOS"
      },
      {
        "codigo": "F259",
        "valor": "TRASTORNO ESQUIZOAFECTIVO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F28 - OTROS TRASTORNOS PSICOTICOS DE ORIGEN NO ORGANICO",
    "detalle": [
      {
        "codigo": "F28X",
        "valor": "OTROS TRASTORNOS PSICOTICOS NO ORGANICOS"
      }
    ]
  },
  {
    "grupo": "F29 - PSICOSIS DE ORIGEN NO ORGANICO, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "F29X",
        "valor": "PSICOSIS DE ORIGEN NO ORGANICO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "F30 - EPISODIO MANIACO",
    "detalle": [
      {
        "codigo": "F300",
        "valor": "HIPOMANIA"
      },
      {
        "codigo": "F301",
        "valor": "MANIA SIN SINTOMAS PSICOTICOS"
      },
      {
        "codigo": "F302",
        "valor": "MANIA CON SINTOMAS PSICOTICOS"
      },
      {
        "codigo": "F308",
        "valor": "OTROS EPISODIOS MANIACOS"
      },
      {
        "codigo": "F309",
        "valor": "EPISODIO MANIACO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F31 - TRASTORNO AFECTIVO BIPOLAR",
    "detalle": [
      {
        "codigo": "F310",
        "valor": "TRASTORNO AFECTIVO BIPOLAR, EPISODIO HIPOMANIACO PRESENTE"
      },
      {
        "codigo": "F311",
        "valor": "TRASTORNO AFECTIVO BIPOLAR, EPISODIO MANIACO PRESENTE SIN SINTOMAS PSICOTICOS"
      },
      {
        "codigo": "F312",
        "valor": "TRASTORNO AFECTIVO BIPOLAR, EPISODIO MANIACO PRESENTE CON SINTOMAS PSICOTICOS"
      },
      {
        "codigo": "F313",
        "valor": "TRASTORNO AFECTIVO BIPOLAR, EPISODIO DEPRESIVO PRESENTE LEVE O MODERADO"
      },
      {
        "codigo": "F314",
        "valor": "TRASTORNO AFECTIVO BIPOLAR, EPISODIO DEPRESIVO GRAVE PRESENTE SIN SINTOMAS PSICOTICOS"
      },
      {
        "codigo": "F315",
        "valor": "TRASTORNO AFECTIVO BIPOLAR, EPISODIO DEPRESIVO GRAVE PRESENTE CON SINTOMAS PSICOTICOS"
      },
      {
        "codigo": "F316",
        "valor": "TRASTORNO AFECTIVO BIPOLAR, EPISODIO MIXTO PRESENTE"
      },
      {
        "codigo": "F317",
        "valor": "TRASTORNO AFECTIVO BIPOLAR, ACTUALMENTE EN REMISION"
      },
      {
        "codigo": "F318",
        "valor": "OTROS TRASTORNOS AFECTIVOS BIPOLARES"
      },
      {
        "codigo": "F319",
        "valor": "TRASTORNO AFECTIVO BIPOLAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F32 - EPISODIO DEPRESIVO",
    "detalle": [
      {
        "codigo": "F320",
        "valor": "EPISODIO DEPRESIVO LEVE"
      },
      {
        "codigo": "F321",
        "valor": "EPISODIO DEPRESIVO MODERADO"
      },
      {
        "codigo": "F322",
        "valor": "EPISODIO DEPRESIVO GRAVE SIN SINTOMAS PSICOTICOS"
      },
      {
        "codigo": "F323",
        "valor": "EPISODIO DEPRESIVO GRAVE CON SINTOMAS PSICOTICOS"
      },
      {
        "codigo": "F328",
        "valor": "OTROS EPISODIOS DEPRESIVOS"
      },
      {
        "codigo": "F329",
        "valor": "EPISODIO DEPRESIVO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F33 - TRASTORNO DEPRESIVO RECURRENTE",
    "detalle": [
      {
        "codigo": "F330",
        "valor": "TRASTORNO DEPRESIVO RECURRENTE, EPISODIO LEVE PRESENTE"
      },
      {
        "codigo": "F331",
        "valor": "TRASTORNO DEPRESIVO RECURRENTE, EPISODIO MODERADO PRESENTE"
      },
      {
        "codigo": "F332",
        "valor": "TRASTORNO DEPRESIVO RECURRENTE, EPISODIO DEPRESIVO GRAVE PRESENTE SIN SINTOMAS PSICOTICOS"
      },
      {
        "codigo": "F333",
        "valor": "TRASTORNO DEPRESIVO RECURRENTE, EPISODIO DEPRESIVO GRAVE PRESENTE, CON SINTOMAS PSICOTICOS"
      },
      {
        "codigo": "F334",
        "valor": "TRASTORNO DEPRESIVO RECURRENTE ACTUALMENTE EN REMISION"
      },
      {
        "codigo": "F338",
        "valor": "OTROS TRASTORNOS DEPRESIVOS RECURRENTES"
      },
      {
        "codigo": "F339",
        "valor": "TRASTORNO DEPRESIVO RECURRENTE, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F34 - TRASTORNOS DEL HUMOR [AFECTIVOS] PERSISTENTES",
    "detalle": [
      {
        "codigo": "F340",
        "valor": "CICLOTIMIA"
      },
      {
        "codigo": "F341",
        "valor": "DISTIMIA"
      },
      {
        "codigo": "F348",
        "valor": "OTROS TRASTORNOS DEL HUMOR [AFECTIVOS] PERSISTENTES"
      },
      {
        "codigo": "F349",
        "valor": "TRASTORNO PERSISTENTE DEL HUMOR [AFECTIVO], NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F38 - OTROS TRASTORNOS DEL HUMOR [AFECTIVOS]",
    "detalle": [
      {
        "codigo": "F380",
        "valor": "OTROS TRASTORNOS DEL HUMOR [AFECTIVOS], AISLADOS"
      },
      {
        "codigo": "F381",
        "valor": "OTROS TRASTORNOS DEL HUMOR [AFECTIVOS], RECURRENTES"
      },
      {
        "codigo": "F388",
        "valor": "OTROS TRASTORNOS DEL HUMOR [AFECTIVOS], ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "F39 - TRASTORNO DEL HUMOR [AFECTIVO], NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "F39X",
        "valor": "TRASTORNO DEL HUMO SIN ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "F40 - TRASTORNOS FOBICOS DE ANSIEDAD",
    "detalle": [
      {
        "codigo": "F400",
        "valor": "AGORAFOBIA"
      },
      {
        "codigo": "F401",
        "valor": "FOBIAS SOCIALES"
      },
      {
        "codigo": "F402",
        "valor": "FOBIAS ESPECIFICAS (AISLADAS)"
      },
      {
        "codigo": "F408",
        "valor": "OTROS TRASTORNOS FOBICOS DE ANSIEDAD"
      },
      {
        "codigo": "F409",
        "valor": "TRASTORNO FOBICO DE ANSIEDAD, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F41 - OTROS TRASTORNOS DE ANSIEDAD",
    "detalle": [
      {
        "codigo": "F410",
        "valor": "TRASTORNO DE PANICO [ANSIEDAD PAROXISTICA EPISODICA]"
      },
      {
        "codigo": "F411",
        "valor": "TRASTORNO DE ANSIEDAD GENERALIZADA"
      },
      {
        "codigo": "F412",
        "valor": "TRASTORNO MIXTO DE ANSIEDAD Y DEPRESION"
      },
      {
        "codigo": "F413",
        "valor": "OTROS TRASTORNOS DE ANSIEDAD MIXTOS"
      },
      {
        "codigo": "F418",
        "valor": "OTROS TRASTORNOS DE ANSIEDAD ESPECIFICADOS"
      },
      {
        "codigo": "F419",
        "valor": "TRASTORNO DE ANSIEDAD, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F42 - TRASTORNO OBSESIVO-COMPULSIVO",
    "detalle": [
      {
        "codigo": "F420",
        "valor": "PREDOMINIO DE PENSAMIENTOS O RUMIACIONES OBSESIVAS"
      },
      {
        "codigo": "F421",
        "valor": "PREDOMINIO DE ACTOS COMPULSIVOS [RITUALES OBSESIVOS]"
      },
      {
        "codigo": "F422",
        "valor": "ACTOS E IDEAS OBSESIVAS MIXTOS"
      },
      {
        "codigo": "F428",
        "valor": "OTROS TRASTORNOS OBSESIVO-COMPULSIVOS"
      },
      {
        "codigo": "F429",
        "valor": "TRASTORNO OBSESIVO-COMPULSIVO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F43 - REACCION AL ESTRES GRAVE Y TRASTORNOS DE ADAPTACION",
    "detalle": [
      {
        "codigo": "F430",
        "valor": "REACCION AL ESTRES AGUDO"
      },
      {
        "codigo": "F431",
        "valor": "TRASTORNO DE ESTRES POSTRAUMATICO"
      },
      {
        "codigo": "F432",
        "valor": "TRASTORNOS DE ADAPTACION"
      },
      {
        "codigo": "F438",
        "valor": "OTRAS REACCIONES AL ESTRES GRAVE"
      },
      {
        "codigo": "F439",
        "valor": "REACCION AL ESTRES GRAVE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "F44 - TRASTORNOS DISOCIATIVOS [DE CONVERSION]",
    "detalle": [
      {
        "codigo": "F440",
        "valor": "AMNESIA DISOCIATIVA"
      },
      {
        "codigo": "F441",
        "valor": "FUGA DISOCIATIVA"
      },
      {
        "codigo": "F442",
        "valor": "ESTUPOR DISOCIATIVO"
      },
      {
        "codigo": "F443",
        "valor": "TRASTORNOS DE TRANCE Y DE POSESION"
      },
      {
        "codigo": "F444",
        "valor": "TRASTORNOS DISOCIATIVOS DEL MOVIMIENTO"
      },
      {
        "codigo": "F445",
        "valor": "CONVULSIONES DISOCIATIVAS"
      },
      {
        "codigo": "F446",
        "valor": "ANESTESIA DISOCIATIVA Y PERDIDA SENSORIAL"
      },
      {
        "codigo": "F447",
        "valor": "TRASTORNOS DISOCIATIVOS MIXTOS [Y DE CONVERSION]"
      },
      {
        "codigo": "F448",
        "valor": "OTROS TRASTORNOS DISOCIATIVOS [DE CONVERSION]"
      },
      {
        "codigo": "F449",
        "valor": "TRASTORNO DISOCIATIVO [DE CONVERSION], NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F45 - TRASTORNOS SOMATOMORFOS",
    "detalle": [
      {
        "codigo": "F450",
        "valor": "TRASTORNO DE SOMATIZACION"
      },
      {
        "codigo": "F451",
        "valor": "TRASTORNO SOMATOMORFO INDIFERENCIADO"
      },
      {
        "codigo": "F452",
        "valor": "TRASTORNO HIPOCONDRIACO"
      },
      {
        "codigo": "F453",
        "valor": "DISFUNCION AUTONOMICA SOMATOMORFA"
      },
      {
        "codigo": "F454",
        "valor": "TRASTORNO DE DOLOR PERSISTENTE SOMATOMORFO"
      },
      {
        "codigo": "F458",
        "valor": "OTROS TRASTORNOS SOMATOMORFOS"
      },
      {
        "codigo": "F459",
        "valor": "TRASTORNO SOMATOMORFO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F48 - OTROS TRASTORNOS NEUROTICOS",
    "detalle": [
      {
        "codigo": "F480",
        "valor": "NEURASTENIA"
      },
      {
        "codigo": "F481",
        "valor": "SINDROME DE DESPERSONALIZACION Y DESVINCULACION DE LA REALIDAD"
      },
      {
        "codigo": "F488",
        "valor": "OTROS TRASTORNOS NEUROTICOS ESPECIFICADOS"
      },
      {
        "codigo": "F489",
        "valor": "TRASTORNO NEUROTICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F50 - TRASTORNOS DE LA INGESTION DE ALIMENTOS",
    "detalle": [
      {
        "codigo": "F500",
        "valor": "ANOREXIA NERVIOSA"
      },
      {
        "codigo": "F501",
        "valor": "ANOREXIA NERVIOSA ATIPICA"
      },
      {
        "codigo": "F502",
        "valor": "BULIMIA NERVIOSA"
      },
      {
        "codigo": "F503",
        "valor": "BULIMIA NERVIOSA ATIPICA"
      },
      {
        "codigo": "F504",
        "valor": "HIPERFAGIA ASOCIADA CON OTRAS ALTERACIONES PSICOLOGICAS"
      },
      {
        "codigo": "F505",
        "valor": "VOMITOS ASOCIADOS CON OTRAS ALTERACIONES PSICOLOGICAS"
      },
      {
        "codigo": "F508",
        "valor": "OTROS TRASTORNOS DE LA INGESTION DE ALIMENTOS"
      },
      {
        "codigo": "F509",
        "valor": "TRASTORNO DE LA INGESTION DE ALIMENTOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F51 - TRASTORNOS NO ORGANICOS DEL SUEÑO",
    "detalle": [
      {
        "codigo": "F511",
        "valor": "HIPERSOMNIO NO ORGANICO"
      },
      {
        "codigo": "F510",
        "valor": "INSOMNIO NO ORGANICO"
      },
      {
        "codigo": "F512",
        "valor": "TRASTORNO NO ORGANICO DEL CICLO SUEÑO-VIGILIA"
      },
      {
        "codigo": "F513",
        "valor": "SONAMBULISMO"
      },
      {
        "codigo": "F514",
        "valor": "TERRORES DEL SUEÑO [TERRORES NOCTURNOS]"
      },
      {
        "codigo": "F515",
        "valor": "PESADILLAS"
      },
      {
        "codigo": "F518",
        "valor": "OTROS TRASTORNOS NO ORGANICOS DEL SUEÑO"
      },
      {
        "codigo": "F519",
        "valor": "TRASTORNO NO ORGANICO DEL SUEÑO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F52 - DISFUNCION SEXUAL NO OCASIONADA POR TRASTORNO NI ENFERMEDAD ORGANICOS",
    "detalle": [
      {
        "codigo": "F520",
        "valor": "FALTA O PERDIDA DEL DESEO SEXUAL"
      },
      {
        "codigo": "F521",
        "valor": "AVERSION AL SEXO Y FALTA DE GOCE SEXUAL"
      },
      {
        "codigo": "F522",
        "valor": "FALLA DE LA RESPUESTA GENITAL"
      },
      {
        "codigo": "F523",
        "valor": "DISFUNCION ORGASMICA"
      },
      {
        "codigo": "F524",
        "valor": "EYACULACION PRECOZ"
      },
      {
        "codigo": "F525",
        "valor": "VAGINISMO NO ORGANICO"
      },
      {
        "codigo": "F526",
        "valor": "DISPAREUNIA NO ORGANICA"
      },
      {
        "codigo": "F527",
        "valor": "IMPULSO SEXUAL EXCESIVO"
      },
      {
        "codigo": "F528",
        "valor": "OTRAS DISFUNCIONES SEXUALES, NO OCASIONADAS POR TRASTORNO NI POR ENFERMEDAD ORGANICOS"
      },
      {
        "codigo": "F529",
        "valor": "DISFUNCION SEXUAL NO OCASIONADA POR TRASTORNO NI POR ENFERMEDAD ORGANICOS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "F53 - TRASTORNOS MENTALES Y DEL COMPORTAMIENTO ASOCIADOS CON EL PUERPERIO, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "F530",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO LEVES, ASOCIADOS CON EL PUERPERIO, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "F531",
        "valor": "TRASTORNOS MENTALES Y DEL COMPORTAMIENTO GRAVES, ASOCIADOS CON EL PUERPERIO, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "F538",
        "valor": "OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO ASOCIADOS CON EL PUERPERIO, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "F539",
        "valor": "TRASTORNO MENTAL PUERPERAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F54 - FACTORES PSICOLOGICOS Y DEL COMPORTAMIENTO ASOCIADOS CON TRASTORNOS O ENFERMEDADES CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "F54X",
        "valor": "FACTORES PSICOLOGICOS Y DEL COMPORTAMIENTO ASOCIADOS CON TRASTORNOS O ENFERMEDAD"
      }
    ]
  },
  {
    "grupo": "F55 - ABUSO DE SUSTANCIAS QUE NO PRODUCEN DEPENDENCIA",
    "detalle": [
      {
        "codigo": "F55X",
        "valor": "ABUSO DE SUSTANCIAS QUE NO PRODUCEN DEPENDENCIA"
      }
    ]
  },
  {
    "grupo": "F59 - SINDROMES DEL COMPORTAMIENTO ASOCIADOS CON ALTERACIONES FISIOLOGICAS Y FACTORES FISICOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "F59X",
        "valor": "SINDROMES DEL COMPORTAMIENTO ASOCIADOS CON ALTERACIONES FISIOLOGICAS Y FACTORES"
      }
    ]
  },
  {
    "grupo": "F60 - TRASTORNOS ESPECIFICOS DE LA PERSONALIDAD",
    "detalle": [
      {
        "codigo": "F600",
        "valor": "TRASTORNO PARANOIDE DE LA PERSONALIDAD"
      },
      {
        "codigo": "F601",
        "valor": "TRASTORNO ESQUIZOIDE DE LA PERSONALIDAD"
      },
      {
        "codigo": "F602",
        "valor": "TRASTORNO ASOCIAL DE LA PERSONALIDAD"
      },
      {
        "codigo": "F603",
        "valor": "TRASTORNO DE LA PERSONALIDAD EMOCIONALMENTE INESTABLE"
      },
      {
        "codigo": "F604",
        "valor": "TRASTORNO HISTRIONICO DE LA PERSONALIDAD"
      },
      {
        "codigo": "F605",
        "valor": "TRASTORNO ANANCASTICO DE LA PERSONALIDAD"
      },
      {
        "codigo": "F606",
        "valor": "TRASTORNO DE LA PERSONALIDAD ANSIOSA (EVASIVA, ELUSIVA)"
      },
      {
        "codigo": "F607",
        "valor": "TRASTORNO DE LA PERSONALIDAD DEPENDIENTE"
      },
      {
        "codigo": "F608",
        "valor": "OTROS TRASTORNOS ESPECIFICOS DE LA PERSONALIDAD"
      },
      {
        "codigo": "F609",
        "valor": "TRASTORNO DE LA PERSONALIDAD, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F61 - TRASTORNOS MIXTOS Y OTROS TRASTORNOS DE LA PERSONALIDAD",
    "detalle": [
      {
        "codigo": "F61X",
        "valor": "TRASTORNOS MIXTOS Y OTROS TRASTORNOS DE LA PERSONALIDAD"
      }
    ]
  },
  {
    "grupo": "F62 - CAMBIOS PERDURABLES DE LA PERSONALIDAD, NO ATRIBUIBLES A LESION O A ENFERMEDAD CEREBRAL",
    "detalle": [
      {
        "codigo": "F620",
        "valor": "CAMBIO PERDURABLE DE LA PERSONALIDAD DESPUES DE UNA EXPERIENCIA CATASTROFICA"
      },
      {
        "codigo": "F621",
        "valor": "CAMBIO PERDURABLE DE LA PERSONALIDAD CONSECUTIVO A UNA ENFERMEDAD PSIQUIATRICA"
      },
      {
        "codigo": "F628",
        "valor": "OTROS CAMBIOS PERDURABLES DE LA PERSONALIDAD"
      },
      {
        "codigo": "F629",
        "valor": "CAMBIO PERDURABLE DE LA PERSONALIDAD, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F63 - TRASTORNOS DE LOS HABITOS Y DE LOS IMPULSOS",
    "detalle": [
      {
        "codigo": "F630",
        "valor": "JUEGO PATOLOGICO"
      },
      {
        "codigo": "F631",
        "valor": "PIROMANIA"
      },
      {
        "codigo": "F632",
        "valor": "HURTO PATOLOGICO [CLEPTOMANIA]"
      },
      {
        "codigo": "F633",
        "valor": "TRICOTILOMANIA"
      },
      {
        "codigo": "F638",
        "valor": "OTROS TRASTORNOS DE LOS HABITOS Y DE LOS IMPULSOS"
      },
      {
        "codigo": "F639",
        "valor": "TRASTORNO DE LOS HABITOS Y DE LOS IMPULSOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F65 - TRASTORNOS DE LA PREFERENCIA SEXUAL",
    "detalle": [
      {
        "codigo": "F650",
        "valor": "FETICHISMO"
      },
      {
        "codigo": "F652",
        "valor": "EXHIBICIONISMO"
      },
      {
        "codigo": "F653",
        "valor": "VOYEURISMO"
      },
      {
        "codigo": "F654",
        "valor": "PEDOFILIA"
      },
      {
        "codigo": "F655",
        "valor": "SADOMASOQUISMO"
      },
      {
        "codigo": "F656",
        "valor": "TRASTORNOS MULTIPLES DE LA PREFERENCIA SEXUAL"
      },
      {
        "codigo": "F657",
        "valor": "TRASTORNO PARAFILICO QUE INVOLUCRA COMPORTAMIENTOS EN SOLITARIO O INDIVIDUOS QUE DIERON SU CONSENTIMIENTO"
      },
      {
        "codigo": "F658",
        "valor": "OTROS TRASTORNOS DE LA PREFERENCIA SEXUAL"
      },
      {
        "codigo": "F659",
        "valor": "TRASTORNO DE LA PREFERENCIA SEXUAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F66 - TRASTORNOS PSICOLOGICOS Y DEL COMPORTAMIENTO ASOCIADOS CON EL DESARROLLO Y CON LA ORIENTACION SEXUALES",
    "detalle": [
      {
        "codigo": "F660",
        "valor": "TRASTORNO DE LA MADURACION SEXUAL"
      },
      {
        "codigo": "F662",
        "valor": "TRASTORNO DE LA RELACION SEXUAL"
      },
      {
        "codigo": "F668",
        "valor": "OTROS TRASTORNOS DEL DESARROLLO PSICOSEXUAL"
      },
      {
        "codigo": "F669",
        "valor": "TRASTORNO DEL DESARROLLO PSICOSEXUAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F68 - OTROS TRASTORNOS DE LA PERSONALIDAD Y DEL COMPORTAMIENTO EN ADULTOS",
    "detalle": [
      {
        "codigo": "F680",
        "valor": "ELABORACION DE SINTOMAS FISICOS POR CAUSAS PSICOLOGICAS"
      },
      {
        "codigo": "F681",
        "valor": "PRODUCCION INTENCIONAL O SIMULACION DE SINTOMAS O DE INCAPACIDADES, TANTO FISICAS COMO PSICOLOGICAS [TRASTORNO FACTICIO]"
      },
      {
        "codigo": "F688",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA PERSONALIDAD Y DEL COMPORTAMIENTO EN ADULTOS"
      }
    ]
  },
  {
    "grupo": "F69 - TRASTORNO DE LA PERSONALIDAD Y DEL COMPORTAMIENTO EN ADULTOS, NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "F69X",
        "valor": "TRASTORNO DE LA PERSONALIDAD Y DEL COMPORTAMIENTO EN ADULTOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F70 - RETRASO MENTAL LEVE",
    "detalle": [
      {
        "codigo": "F700",
        "valor": "RETRASO MENTAL LEVE, DETERIORO DEL COMPORTAMIENTO NULO O MINIMO"
      },
      {
        "codigo": "F701",
        "valor": "RETRASO MENTAL LEVE, DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIERE ATENCION O TRATAMIENTO"
      },
      {
        "codigo": "F708",
        "valor": "RETRASO MENTAL LEVE, OTROS DETERIOROS DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F709",
        "valor": "RETRASO MENTAL LEVE, DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F71 - RETRASO MENTAL MODERADO",
    "detalle": [
      {
        "codigo": "F710",
        "valor": "RETRASO MENTAL MODERADO, DETERIORO DEL COMPORTAMIENTO NULO O MINIMO"
      },
      {
        "codigo": "F711",
        "valor": "RETRASO MENTAL MODERADO, DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIERE ATENCION O TRATAMIENTO"
      },
      {
        "codigo": "F718",
        "valor": "RETRASO MENTAL MODERADO, OTROS DETERIOROS DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F719",
        "valor": "RETRASO MENTAL MODERADO, DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F72 - RETRASO MENTAL GRAVE",
    "detalle": [
      {
        "codigo": "F720",
        "valor": "RETRASO MENTAL GRAVE, DETERIORO DEL COMPORTAMIENTO NULO O MINIMO"
      },
      {
        "codigo": "F721",
        "valor": "RETRASO MENTAL GRAVE, DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIERE ATENCION O TRATAMIENTO"
      },
      {
        "codigo": "F728",
        "valor": "RETRASO MENTAL GRAVE, OTROS DETERIOROS DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F729",
        "valor": "RETRASO MENTAL GRAVE, DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F73 - RETRASO MENTAL PROFUNDO",
    "detalle": [
      {
        "codigo": "F730",
        "valor": "RETRASO MENTAL PROFUNDO, DETERIORO DEL COMPORTAMIENTO NULO O MINIMO"
      },
      {
        "codigo": "F731",
        "valor": "RETRASO MENTAL PROFUNDO, DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIERE ATENCION O TRATAMIENTO"
      },
      {
        "codigo": "F738",
        "valor": "RETRASO MENTAL PROFUNDO, OTROS DETERIOROS DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F739",
        "valor": "RETRASO MENTAL PROFUNDO, DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F78 - OTROS TIPOS DE RETRASO MENTAL",
    "detalle": [
      {
        "codigo": "F780",
        "valor": "OTROS TIPOS DE RETRASO MENTAL, DETERIORO DEL COMPORTAMIENTO NULO O MINIMO"
      },
      {
        "codigo": "F781",
        "valor": "OTROS TIPOS DE RETRASO MENTAL, DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIERE ATENCION O TRATAMIENTO"
      },
      {
        "codigo": "F788",
        "valor": "OTROS TIPOS DE RETRASO MENTAL, OTROS DETERIOROS DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F789",
        "valor": "OTROS TIPOS DE RETRASO MENTAL, DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F79 - RETRASO MENTAL, NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "F790",
        "valor": "RETRASO MENTAL, NO ESPECIFICADO, DETERIORO DEL COMPORTAMIENTO NULO O MINIMO"
      },
      {
        "codigo": "F791",
        "valor": "RETRASO MENTAL, NO ESPECIFICADO, DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIERE ATENCION O TRATAMIENTO"
      },
      {
        "codigo": "F798",
        "valor": "RETRASO MENTAL, NO ESPECIFICADO, OTROS DETERIOROS DEL COMPORTAMIENTO"
      },
      {
        "codigo": "F799",
        "valor": "RETRASO MENTAL, NO ESPECIFICADO, DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F80 - TRASTORNOS ESPECIFICOS DEL DESARROLLO DEL HABLA Y DEL LENGUAJE",
    "detalle": [
      {
        "codigo": "F800",
        "valor": "TRASTORNO ESPECIFICO DE LA PRONUNCIACION"
      },
      {
        "codigo": "F801",
        "valor": "TRASTORNO DEL LENGUAJE EXPRESIVO"
      },
      {
        "codigo": "F802",
        "valor": "TRASTORNO DE LA RECEPCION DEL LENGUAJE"
      },
      {
        "codigo": "F803",
        "valor": "AFASIA ADQUIRIDA CON EPILEPSIA [LANDAU-KLEFFNER]"
      },
      {
        "codigo": "F808",
        "valor": "OTROS TRASTORNOS DEL DESARROLLO DEL HABLA Y DEL LENGUAJE"
      },
      {
        "codigo": "F809",
        "valor": "TRASTORNO DEL DESARROLLO DEL HABLA Y DEL LENGUAJE NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F81 - TRASTORNOS ESPECIFICOS DEL DESARROLLO DE LAS HABILIDADES ESCOLARES",
    "detalle": [
      {
        "codigo": "F810",
        "valor": "TRASTORNO ESPECIFICO DE LA LECTURA"
      },
      {
        "codigo": "F811",
        "valor": "TRASTORNO ESPECIFICO DEL DELETREO [ORTOGRAFIA]"
      },
      {
        "codigo": "F812",
        "valor": "TRASTORNO ESPECIFICO DE LAS HABILIDADES ARITMETICAS"
      },
      {
        "codigo": "F813",
        "valor": "TRASTORNO MIXTO DE LAS HABILIDADES ESCOLARES"
      },
      {
        "codigo": "F818",
        "valor": "OTROS TRASTORNOS DEL DESARROLLO DE LAS HABILIDADES ESCOLARES"
      },
      {
        "codigo": "F819",
        "valor": "TRASTORNO DEL DESARROLLO DE LAS HABILIDADES ESCOLARES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F82 - TRASTORNO ESPECIFICO DEL DESARROLLO DE LA FUNCION MOTRIZ",
    "detalle": [
      {
        "codigo": "F82X",
        "valor": "TRASTORNO ESPECIFICO DEL DESARROLLO PSICOMOTOR"
      }
    ]
  },
  {
    "grupo": "F83 - TRASTORNOS ESPECIFICOS MIXTOS DEL DESARROLLO",
    "detalle": [
      {
        "codigo": "F83X",
        "valor": "TRASTORNOS ESPECIFICOS MIXTOS DEL DESARROLLO"
      }
    ]
  },
  {
    "grupo": "F84 - TRASTORNOS GENERALIZADOS DEL DESARROLLO",
    "detalle": [
      {
        "codigo": "F840",
        "valor": "AUTISMO EN LA NIÑEZ"
      },
      {
        "codigo": "F841",
        "valor": "AUTISMO ATIPICO"
      },
      {
        "codigo": "F842",
        "valor": "SINDROME DE RETT"
      },
      {
        "codigo": "F843",
        "valor": "OTRO TRASTORNO DESINTEGRATIVO DE LA NIÑEZ"
      },
      {
        "codigo": "F844",
        "valor": "TRASTORNO HIPERACTIVO ASOCIADO CON RETRASO MENTAL Y MOVIMIENTOS ESTEREOTIPADOS"
      },
      {
        "codigo": "F845",
        "valor": "SINDROME DE ASPERGER"
      },
      {
        "codigo": "F848",
        "valor": "OTROS TRASTORNOS GENERALIZADOS DEL DESARROLLO"
      },
      {
        "codigo": "F849",
        "valor": "TRASTORNO GENERALIZADO DEL DESARROLLO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F88 - OTROS TRASTORNOS DEL DESARROLLO PSICOLOGICO",
    "detalle": [
      {
        "codigo": "F88X",
        "valor": "OTROS TRASTORNOS DEL DESARROLLO PSICOLOGICO"
      }
    ]
  },
  {
    "grupo": "F89 - TRASTORNO DEL DESARROLLO PSICOLOGICO, NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "F89X",
        "valor": "TRASTORNO DEL DESARROLLO PSICOLOGICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F90 - TRASTORNOS HIPERCINETICOS",
    "detalle": [
      {
        "codigo": "F900",
        "valor": "PERTURBACION DE LA ACTIVIDAD Y DE LA ATENCION"
      },
      {
        "codigo": "F901",
        "valor": "TRASTORNO HIPERCINETICO DE LA CONDUCTA"
      },
      {
        "codigo": "F908",
        "valor": "OTROS TRASTORNOS HIPERCINETICOS"
      },
      {
        "codigo": "F909",
        "valor": "TRASTORNO HIPERCINETICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F91 - TRASTORNOS DE LA CONDUCTA",
    "detalle": [
      {
        "codigo": "F910",
        "valor": "TRASTORNO DE LA CONDUCTA LIMITADO AL CONTEXTO FAMILIAR"
      },
      {
        "codigo": "F911",
        "valor": "TRASTORNO DE LA CONDUCTA INSOCIABLE"
      },
      {
        "codigo": "F912",
        "valor": "TRASTORNO DE LA CONDUCTA SOCIABLE"
      },
      {
        "codigo": "F9121",
        "valor": "PERTENENCIA A PANDILLA (PRESENCIA DE AGRESIVIDAD Y VIOLENCIA)"
      },
      {
        "codigo": "F9122",
        "valor": "PERTENECIENTE A GRUPOS ORGANIZADOS"
      },
      {
        "codigo": "F913",
        "valor": "TRASTORNO OPOSITOR DESAFIANTE"
      },
      {
        "codigo": "F918",
        "valor": "OTROS TRASTORNOS DE LA CONDUCTA"
      },
      {
        "codigo": "F919",
        "valor": "TRASTORNO DE LA CONDUCTA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F92 - TRASTORNOS MIXTOS DE LA CONDUCTA Y DE LAS EMOCIONES",
    "detalle": [
      {
        "codigo": "F920",
        "valor": "TRASTORNO DEPRESIVO DE LA CONDUCTA"
      },
      {
        "codigo": "F928",
        "valor": "OTROS TRASTORNOS MIXTOS DE LA CONDUCTA Y DE LAS EMOCIONES"
      },
      {
        "codigo": "F929",
        "valor": "TRASTORNO MIXTO DE LA CONDUCTA Y DE LAS EMOCIONES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F93 - TRASTORNOS EMOCIONALES DE COMIENZO ESPECIFICO EN LA NIÑEZ",
    "detalle": [
      {
        "codigo": "F930",
        "valor": "TRASTORNO DE ANSIEDAD DE SEPARACION EN LA NIÑEZ"
      },
      {
        "codigo": "F931",
        "valor": "TRASTORNO DE ANSIEDAD FOBICA EN LA NIÑEZ"
      },
      {
        "codigo": "F932",
        "valor": "TRASTORNO DE ANSIEDAD SOCIAL EN LA NIÑEZ"
      },
      {
        "codigo": "F933",
        "valor": "TRASTORNO DE RIVALIDAD ENTRE HERMANOS"
      },
      {
        "codigo": "F938",
        "valor": "OTROS TRASTORNOS EMOCIONALES EN LA NIÑEZ"
      },
      {
        "codigo": "F939",
        "valor": "TRASTORNO EMOCIONAL EN LA NIÑEZ, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F94 - TRASTORNOS DEL COMPORTAMIENTO SOCIAL DE COMIENZO ESPECIFICO EN LA NIÑEZ",
    "detalle": [
      {
        "codigo": "F940",
        "valor": "MUTISMO ELECTIVO"
      },
      {
        "codigo": "F941",
        "valor": "TRASTORNO DE VINCULACION REACTIVA EN LA NIÑEZ"
      },
      {
        "codigo": "F942",
        "valor": "TRASTORNO DE VINCULACION DESINHIBIDA EN LA NIÑEZ"
      },
      {
        "codigo": "F948",
        "valor": "OTROS TRASTORNOS DEL COMPORTAMIENTO SOCIAL EN LA NIÑEZ"
      },
      {
        "codigo": "F949",
        "valor": "TRASTORNO DEL COMPORTAMIENTO SOCIAL EN LA NIÑEZ, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F95 - TRASTORNOS POR TICS",
    "detalle": [
      {
        "codigo": "F950",
        "valor": "TRASTORNO POR TIC TRANSITORIO"
      },
      {
        "codigo": "F951",
        "valor": "TRASTORNO POR TIC MOTOR O VOCAL CRONICO"
      },
      {
        "codigo": "F952",
        "valor": "TRASTORNO POR TICS MOTORES Y VOCALES MULTIPLES COMBINADOS [DE LA TOURETTE]"
      },
      {
        "codigo": "F958",
        "valor": "OTROS TRASTORNOS POR TICS"
      },
      {
        "codigo": "F959",
        "valor": "TRASTORNO POR TIC, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "F98 - OTROS TRASTORNOS EMOCIONALES Y DEL COMPORTAMIENTO QUE APARECEN HABITUAL",
    "detalle": [
      {
        "codigo": "F980",
        "valor": "ENURESIS NO ORGANICA"
      },
      {
        "codigo": "F981",
        "valor": "ENCOPRESIS NO ORGANICA"
      },
      {
        "codigo": "F982",
        "valor": "TRASTORNO DE LA INGESTION ALIMENTARIA EN LA INFANCIA Y LA NIÑEZ"
      },
      {
        "codigo": "F983",
        "valor": "PICA EN LA INFANCIA Y LA NIÑEZ"
      },
      {
        "codigo": "F984",
        "valor": "TRASTORNOS DE LOS MOVIMIENTOS ESTEREOTIPADOS"
      },
      {
        "codigo": "F985",
        "valor": "TARTAMUDEZ [ESPASMOFEMIA]"
      },
      {
        "codigo": "F986",
        "valor": "FARFULLEO"
      },
      {
        "codigo": "F988",
        "valor": "OTROS TRASTORNOS EMOCIONALES Y DEL COMPORTAMIENTO QUE APARECEN HABITUALMENTE EN LA NIÑEZ Y EN LA ADOLESCENCIA"
      },
      {
        "codigo": "F989",
        "valor": "TRASTORNOS NO ESPECIFICADOS, EMOCIONALES Y DEL COMPORTAMIENTO, QUE APARECEN HABITUALMENTE EN LA NIÑEZ Y EN LA ADOLESCENCIA"
      }
    ]
  },
  {
    "grupo": "F99 - TRASTORNO MENTAL, NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "F99X",
        "valor": "TRASTORNO MENTAL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G00 - MENINGITIS BACTERIANA, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G000",
        "valor": "MENINGITIS POR HEMOFILOS"
      },
      {
        "codigo": "G001",
        "valor": "MENINGITIS NEUMOCOCICA"
      },
      {
        "codigo": "G002",
        "valor": "MENINGITIS ESTREPTOCOCICA"
      },
      {
        "codigo": "G003",
        "valor": "MENINGITIS ESTAFILOCOCICA"
      },
      {
        "codigo": "G008",
        "valor": "OTRAS MENINGITIS BACTERIANAS"
      },
      {
        "codigo": "G009",
        "valor": "MENINGITIS BACTERIANA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G01 - MENINGITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G01X",
        "valor": "MENINGITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G02 - MENINGITIS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G020",
        "valor": "MENINGITIS EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G021",
        "valor": "MENINGITIS EN MICOSIS"
      },
      {
        "codigo": "G028",
        "valor": "MENINGITIS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS ESPECIFICADAS CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G03 - MENINGITIS DEBIDA A OTRAS CAUSAS Y A LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "G030",
        "valor": "MENINGITIS APIOGENA"
      },
      {
        "codigo": "G031",
        "valor": "MENINGITIS CRONICA"
      },
      {
        "codigo": "G032",
        "valor": "MENINGITIS RECURRENTE BENIGNA [MOLLARET]"
      },
      {
        "codigo": "G038",
        "valor": "MENINGITIS DEBIDAS A OTRAS CAUSAS ESPECIFICADAS"
      },
      {
        "codigo": "G039",
        "valor": "MENINGITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G04 - ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS",
    "detalle": [
      {
        "codigo": "G040",
        "valor": "ENCEFALITIS AGUDA DISEMINADA"
      },
      {
        "codigo": "G041",
        "valor": "MIELOPATIA ASOCIADA AL VIRUS LINFOTROPICO DE CELULAS T HUMANAS"
      },
      {
        "codigo": "G042",
        "valor": "MENINGOENCEFALITIS Y MENINGOMIELITIS BACTERIANAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G048",
        "valor": "OTRAS ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS"
      },
      {
        "codigo": "G049",
        "valor": "ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS, NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "G05 - ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS EN ENFERMEDADES CLASIFICADAS",
    "detalle": [
      {
        "codigo": "G050",
        "valor": "ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G051",
        "valor": "ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G052",
        "valor": "ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G058",
        "valor": "ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G06 - ABSCESO Y GRANULOMA INTRACRANEAL E INTRARRAQUIDEO",
    "detalle": [
      {
        "codigo": "G060",
        "valor": "ABSCESO Y GRANULOMA INTRACRANEAL"
      },
      {
        "codigo": "G061",
        "valor": "ABSCESO Y GRANULOMA INTRARRAQUIDEO"
      },
      {
        "codigo": "G062",
        "valor": "ABSCESO EXTRADURAL Y SUBDURAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G07 - ABSCESO Y GRANULOMA INTRACRANEAL E INTRARRAQUIDEO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G07X",
        "valor": "ABSCESO Y GRANULOMA INTRACRANEAL E INTRARRAQUIDEO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G08 - FLEBITIS Y TROMBOFLEBITIS INTRACRANEAL E INTRARRAQUIDEA",
    "detalle": [
      {
        "codigo": "G08X",
        "valor": "FLEBITIS Y TROMBOFLEBITIS INTRACRANEAL E INTRARRAQUIDEA"
      }
    ]
  },
  {
    "grupo": "G09 - SECUELAS DE ENFERMEDADES INFLAMATORIAS DEL SISTEMA NERVIOSO CENTRAL",
    "detalle": [
      {
        "codigo": "G09X",
        "valor": "SECUELAS DE ENFERMEDADES INFLAMATORIAS DEL SISTEMA NERVIOSO CENTRAL"
      }
    ]
  },
  {
    "grupo": "G10 - ENFERMEDAD DE HUNTINGTON",
    "detalle": [
      {
        "codigo": "G10X",
        "valor": "ENFERMEDAD DE HUNTINGTON"
      }
    ]
  },
  {
    "grupo": "G11 - ATAXIA HEREDITARIA",
    "detalle": [
      {
        "codigo": "G110",
        "valor": "ATAXIA CONGENITA NO PROGRESIVA"
      },
      {
        "codigo": "G111",
        "valor": "ATAXIA CEREBELOSA DE INICIACION TEMPRANA"
      },
      {
        "codigo": "G112",
        "valor": "ATAXIA CEREBELOSA DE INICIACION TARDIA"
      },
      {
        "codigo": "G113",
        "valor": "ATAXIA CEREBELOSA CON REPARACION DEFECTUOSA DEL ADN"
      },
      {
        "codigo": "G114",
        "valor": "PARAPLEJIA ESPASTICA HEREDITARIA"
      },
      {
        "codigo": "G118",
        "valor": "OTRAS ATAXIAS HEREDITARIAS"
      },
      {
        "codigo": "G119",
        "valor": "ATAXIA HEREDITARIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G12 - ATROFIA MUSCULAR ESPINAL Y SINDROMES AFINES",
    "detalle": [
      {
        "codigo": "G120",
        "valor": "ATROFIA MUSCULAR ESPINAL INFANTIL, TIPO I (WERDNIG-HOFFMAN)"
      },
      {
        "codigo": "G121",
        "valor": "OTRAS ATROFIAS MUSCULARES ESPINALES HEREDITARIAS"
      },
      {
        "codigo": "G122",
        "valor": "ENFERMEDADES DE LAS NEURONAS MOTORAS"
      },
      {
        "codigo": "G128",
        "valor": "OTRAS ATROFIAS MUSCULARES ESPINALES Y SINDROMES AFINES"
      },
      {
        "codigo": "G129",
        "valor": "ATROFIA MUSCULAR ESPINAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "G13 - ATROFIAS SISTEMICAS QUE AFECTAN PRIMARIAMENTE EL SISTEMA NERVIOSO CENTRAL DE ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G130",
        "valor": "NEUROMIOPATIA Y NEUROPATIA PARANEOPLASICA"
      },
      {
        "codigo": "G131",
        "valor": "OTRAS ATROFIAS SISTEMICAS QUE AFECTAN EL SISTEMA NERVIOSO CENTRAL EN ENFERMEDAD NEOPLASICA"
      },
      {
        "codigo": "G132",
        "valor": "ATROFIA SISTEMICA QUE AFECTA PRIMARIAMENTE EL SISTEMA NERVIOSO CENTRAL EN EL MIXEDEMA"
      },
      {
        "codigo": "G138",
        "valor": "ATROFIA SISTEMICA QUE AFECTA PRIMARIAMENTE EL SISTEMA NERVIOSO CENTRAL EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G14 - SINDROME POSTPOLIO",
    "detalle": [
      {
        "codigo": "G14X",
        "valor": "SINDROME POSTPOLIO"
      }
    ]
  },
  {
    "grupo": "G20 - ENFERMEDAD DE PARKINSON",
    "detalle": [
      {
        "codigo": "G20X",
        "valor": "ENFERMEDAD DE PARKINSON"
      }
    ]
  },
  {
    "grupo": "G21 - PARKINSONISMO SECUNDARIO",
    "detalle": [
      {
        "codigo": "G210",
        "valor": "SINDROME NEUROLEPTICO MALIGNO"
      },
      {
        "codigo": "G211",
        "valor": "OTRO PARKINSONISMO SECUNDARIO INDUCIDO POR DROGAS"
      },
      {
        "codigo": "G212",
        "valor": "PARKINSONISMO SECUNDARIO DEBIDO A OTROS AGENTES EXTERNOS"
      },
      {
        "codigo": "G213",
        "valor": "PARKINSONISMO POSTENCEFALITICO"
      },
      {
        "codigo": "G214",
        "valor": "PARKINSONISMO VASCULAR"
      },
      {
        "codigo": "G218",
        "valor": "OTROS TIPOS DE PARKINSONISMO SECUNDARIO"
      },
      {
        "codigo": "G219",
        "valor": "PARKINSONISMO SECUNDARIO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G22 - PARKINSONISMO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G22X",
        "valor": "PARKINSONISMO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G23 - OTRAS ENFERMEDADES DEGENERATIVAS DE LOS NUCLEOS DE LA BASE",
    "detalle": [
      {
        "codigo": "G230",
        "valor": "ENFERMEDAD DE HALLERVORDEN-SPATZ"
      },
      {
        "codigo": "G231",
        "valor": "OFTALMOPLEJIA SUPRANUCLEAR PROGRESIVA [STEELE-RICHARDSON-OLSZEWSKI]"
      },
      {
        "codigo": "G232",
        "valor": "ATROFIA SISTEMICA MULTIPLE, TIPO PARKINSONIANA [AMS-P]"
      },
      {
        "codigo": "G233",
        "valor": "ATROFIA MULTISISTEMICA TIPO CEREBELOSA [ASM-C]"
      },
      {
        "codigo": "G238",
        "valor": "OTRAS ENFERMEDADES DEGENERATIVAS ESPECIFICAS DE LOS NUCLEOS DE LA BASE"
      },
      {
        "codigo": "G239",
        "valor": "ENFERMEDAD DEGENERATIVA DE LOS NUCLEOS DE LA BASE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G24 - DISTONIA",
    "detalle": [
      {
        "codigo": "G240",
        "valor": "DISTONIA INDUCIDA POR DROGAS"
      },
      {
        "codigo": "G241",
        "valor": "DISTONIA IDIOPATICA FAMILIAR"
      },
      {
        "codigo": "G242",
        "valor": "DISTONIA IDIOPATICA NO FAMILIAR"
      },
      {
        "codigo": "G243",
        "valor": "TORTICOLIS ESPASMODICA"
      },
      {
        "codigo": "G244",
        "valor": "DISPONIA BUCOFACIAL IDIOPATICA"
      },
      {
        "codigo": "G245",
        "valor": "BLEFAROSPASMO"
      },
      {
        "codigo": "G248",
        "valor": "OTRAS DISTONIAS"
      },
      {
        "codigo": "G249",
        "valor": "DISTONIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G25 - OTROS TRASTORNOS EXTRAPIRAMIDALES Y DEL MOVIMIENTO",
    "detalle": [
      {
        "codigo": "G250",
        "valor": "TEMBLOR ESENCIAL"
      },
      {
        "codigo": "G251",
        "valor": "TEMBLOR INDUCIDO POR DROGAS"
      },
      {
        "codigo": "G252",
        "valor": "OTRAS FORMAS ESPECIFICADAS DE TEMBLOR"
      },
      {
        "codigo": "G253",
        "valor": "MIOCLONIA"
      },
      {
        "codigo": "G254",
        "valor": "COREA INDUCIDA POR DROGAS"
      },
      {
        "codigo": "G255",
        "valor": "OTRAS COREAS"
      },
      {
        "codigo": "G256",
        "valor": "TICS INDUCIDOS POR DROGAS Y OTROS TICS DE ORIGEN ORGANICO"
      },
      {
        "codigo": "G258",
        "valor": "OTROS TRASTORNOS EXTRAPIRAMIDALES Y DEL MOVIMIENTO"
      },
      {
        "codigo": "G259",
        "valor": "TRASTORNO EXTRAPIRAMIDAL Y DEL MOVIMIENTO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G26 - TRASTORNOS EXTRAPIRAMIDALES Y DEL MOVIMIENTO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G26X",
        "valor": "TRASTORNOS EXTRAPIRAMIDALES Y DEL MOVIMIENTO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G30 - ENFERMEDAD DE ALZHEIMER",
    "detalle": [
      {
        "codigo": "G300",
        "valor": "ENFERMEDAD DE ALZHEIMER DE COMIENZO TEMPRANO"
      },
      {
        "codigo": "G301",
        "valor": "ENFERMEDAD DE ALZHEIMER DE COMIENZO TARDIO"
      },
      {
        "codigo": "G308",
        "valor": "OTROS TIPOS DE ENFERMEDAD DE ALZHEIMER"
      },
      {
        "codigo": "G309",
        "valor": "ENFERMEDAD DE ALZHEIMER, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G31 - OTRAS ENFERMEDADES DEGENERATIVAS DEL SISTEMA NERVIOSO, NO CLASIFICADAS",
    "detalle": [
      {
        "codigo": "G310",
        "valor": "ATROFIA CEREBRAL CIRCUNSCRITA"
      },
      {
        "codigo": "G311",
        "valor": "DEGENERACION CEREBRAL SENIL NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "G312",
        "valor": "DEGENERACION DEL SISTEMA NERVIOSO DEBIDA AL ALCOHOL"
      },
      {
        "codigo": "G318",
        "valor": "OTRAS ENFERMEDADES DEGENERATIVAS ESPECIFICADAS DEL SISTEMA NERVIOSO"
      },
      {
        "codigo": "G319",
        "valor": "DEGENERACION DEL SISTEMA NERVIOSO, NO ESPECIFICADA"
      },
      {
        "codigo": "G3109",
        "valor": "DEMENCIA FRONTOTEMPORAL EN LA ENFERMEDAD DE PICK"
      }
    ]
  },
  {
    "grupo": "G32 - OTROS TRASTORNOS DEGENERATIVOS DEL SISTEMA NERVIOSO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G320",
        "valor": "DEGENERACION COMBINADA SUBAGUDA DE LA MEDULA ESPINAL EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G328",
        "valor": "OTROS TRASTORNOS DEGENERATIVOS ESPECIFICADOS DEL SISTEMA NERVIOSO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G35 - ESCLEROSIS MULTIPLE",
    "detalle": [
      {
        "codigo": "G35X",
        "valor": "ESCLEROSIS MULTIPLE"
      }
    ]
  },
  {
    "grupo": "G36 - OTRAS DESMIELINIZACIONES DISEMINADAS AGUDAS",
    "detalle": [
      {
        "codigo": "G360",
        "valor": "NEUROMIELITIS OPTICA [DEVIC]"
      },
      {
        "codigo": "G361",
        "valor": "LEUCOENCEFALITIS HEMORRAGICA AGUDA Y SUBAGUDA [HURST]"
      },
      {
        "codigo": "G368",
        "valor": "OTRAS DESMIELINIZACIONES AGUDAS DISEMINADAS ESPECIFICADAS"
      },
      {
        "codigo": "G369",
        "valor": "DESMIELINIZACION DISEMINADA AGUDA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "G37 - OTRAS ENFERMEDADES DESMIELINIZANTES DEL SISTEMA NERVIOSO CENTRAL",
    "detalle": [
      {
        "codigo": "G370",
        "valor": "ESCLEROSIS DIFUSA"
      },
      {
        "codigo": "G371",
        "valor": "DESMIELINIZACION CENTRAL DEL CUERPO CALLOSO"
      },
      {
        "codigo": "G372",
        "valor": "MIELINOLISIS CENTRAL PONTINA"
      },
      {
        "codigo": "G373",
        "valor": "MIELITIS TRANSVERSA AGUDA EN ENFERMEDAD DESMIELINIZANTE DEL SISTEMA NERVIOSO CENTRAL"
      },
      {
        "codigo": "G374",
        "valor": "MIELITIS NECROTIZANTE SUBAGUDA"
      },
      {
        "codigo": "G375",
        "valor": "ESCLEROSIS CONCENTRICA (BALO)"
      },
      {
        "codigo": "G378",
        "valor": "OTRAS ENFERMEDADES DESMIELINIZANTES DEL SISTEMA NERVIOSO CENTRAL, ESPECIFICADAS"
      },
      {
        "codigo": "G379",
        "valor": "ENFERMEDAD DESMIELINIZANTE DEL SISTEMA NERVIOSO CENTRAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G40 - EPILEPSIA",
    "detalle": [
      {
        "codigo": "G400",
        "valor": "EPILEPSIA Y SINDROMES EPILEPTICOS IDIOPATICOS RELACIONADOS CON LOCALIZACIONES (FOCALES)(PARCIALES) Y CON ATAQUES DE INICIO LOCALIZADO"
      },
      {
        "codigo": "G401",
        "valor": "EPILEPSIA Y SINDROMES EPILEPTICOS SINTOMATICOS RELACIONADOS CON LOCALIZACIONES (FOCALES)(PARCIALES) Y CON ATAQUES PARCIALES SIMPLES"
      },
      {
        "codigo": "G402",
        "valor": "EPILEPSIA Y SINDROMES EPILEPTICOS SINTOMATICOS RELACIONADOS CON LOCALIZACIONES (FOCALES)(PARCIALES) Y CON ATAQUES PARCIALES COMPLEJOS"
      },
      {
        "codigo": "G403",
        "valor": "EPILEPSIA Y SINDROMES EPILEPTICOS IDIOPATICOS GENERALIZADOS"
      },
      {
        "codigo": "G4030",
        "valor": "ATAQUES EPILEPTICOS ATONICOS (REFRACTARIOS AL TRATAMIENTO)"
      },
      {
        "codigo": "G4031",
        "valor": "ATAQUES EPILEPTICOS CLONICOS (REFRACTARIOS AL TRATAMIENTO)"
      },
      {
        "codigo": "G4032",
        "valor": "ATAQUES EPILEPTICOS MIOCLONICOS (REFRACTARIOS AL TRATAMIENTO)"
      },
      {
        "codigo": "G4033",
        "valor": "ATAQUE EPILEPTICOS TONICOS (REFRACTARIOS AL TRATAMIENTO)"
      },
      {
        "codigo": "G4034",
        "valor": "ATAQUE EPILEPTICOS TONICO-CLONICOS (REFRACTARIOS AL TRATAMIENTO)"
      },
      {
        "codigo": "G4035",
        "valor": "EPILEPSIA CON ATAQUES DE GRAN MAL AL DESPERTAR"
      },
      {
        "codigo": "G4036",
        "valor": "EPILEPSIA MIOCLONICA PROGRESIVA CON DISTONIA"
      },
      {
        "codigo": "G4037",
        "valor": "EPILEPSIA NEONATAL IDIOPATICA BENIGNA"
      },
      {
        "codigo": "G4038",
        "valor": "ENFERMEDAD DE LAFORA"
      },
      {
        "codigo": "G4039",
        "valor": "EPILEPSIA DE AUSENCIA INFANTIL"
      },
      {
        "codigo": "G404",
        "valor": "OTRAS EPILEPSIAS Y SINDROMES EPILEPTICOS GENERALIZADOS"
      },
      {
        "codigo": "G4041",
        "valor": "EPILEPSIA MIOCLONICA ASTATICA"
      },
      {
        "codigo": "G4042",
        "valor": "SINDROME DE ESPASMOS INFANTILES"
      },
      {
        "codigo": "G4043",
        "valor": "ENCEFALOPATIA MIOCLONICA SINTOMATICA PRECOZ"
      },
      {
        "codigo": "G4044",
        "valor": "ENCEFALOPATIA DISKINETICA EPILEPTICA INFANTIL"
      },
      {
        "codigo": "G4046",
        "valor": "MIOCLONIA PERIORAL CON AUSENCIAS"
      },
      {
        "codigo": "G4047",
        "valor": "SINDROME DE EAST"
      },
      {
        "codigo": "G4081",
        "valor": "SINDROME DE LENNOX -GASTAUT"
      },
      {
        "codigo": "G4082",
        "valor": "SINDROME DE WEST"
      },
      {
        "codigo": "G4083",
        "valor": "SINDROME DE DRAVET"
      },
      {
        "codigo": "G405",
        "valor": "SINDROMES EPILEPTICOS ESPECIALES"
      },
      {
        "codigo": "G406",
        "valor": "ATAQUES DE GRAN MAL, NO ESPECIFICADOS (CON O SIN PEQUEÑO MAL)"
      },
      {
        "codigo": "G407",
        "valor": "PEQUEÑO MAL, NO ESPECIFICADO (SIN ATAQUE DE GRAN MAL)"
      },
      {
        "codigo": "G408",
        "valor": "OTRAS EPILEPSIAS"
      },
      {
        "codigo": "G409",
        "valor": "EPILEPSIA, TIPO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G41 - ESTADO DE MAL EPILEPTICO",
    "detalle": [
      {
        "codigo": "G410",
        "valor": "ESTADO DE GRAN MAL EPILEPTICO"
      },
      {
        "codigo": "G411",
        "valor": "ESTADO DE PEQUEÑO MAL EPILEPTICO"
      },
      {
        "codigo": "G412",
        "valor": "ESTADO DE MAL EPILEPTICO PARCIAL COMPLEJO"
      },
      {
        "codigo": "G418",
        "valor": "OTROS ESTADOS EPILEPTICOS"
      },
      {
        "codigo": "G419",
        "valor": "ESTADO DE MAL EPILEPTICO DE TIPO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G43 - MIGRAÑA",
    "detalle": [
      {
        "codigo": "G430",
        "valor": "MIGRAÑA SIN AURA [MIGRAÑA COMUN]"
      },
      {
        "codigo": "G431",
        "valor": "MIGRAÑA CON AURA [MIGRAÑA CLASICA]"
      },
      {
        "codigo": "G432",
        "valor": "ESTADO MIGRAÑOSO"
      },
      {
        "codigo": "G433",
        "valor": "MIGRAÑA COMPLICADA"
      },
      {
        "codigo": "G438",
        "valor": "OTRAS MIGRAÑAS"
      },
      {
        "codigo": "G439",
        "valor": "MIGRAÑA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G44 - OTROS SINDROMES DE CEFALEA",
    "detalle": [
      {
        "codigo": "G440",
        "valor": "SINDROME DE CEFALEA EN RACIMOS"
      },
      {
        "codigo": "G441",
        "valor": "CEFALEA VASCULAR, NCOP"
      },
      {
        "codigo": "G442",
        "valor": "CEFALEA DEBIDA A TENSION"
      },
      {
        "codigo": "G443",
        "valor": "CEFALEA POSTRAUMATICA CRONICA"
      },
      {
        "codigo": "G444",
        "valor": "CEFALEA INDUCIDA POR DROGAS, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "G448",
        "valor": "OTROS SINDROMES DE CEFALEA ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "G45 - ATAQUES DE ISQUEMIA CEREBRAL TRANSITORIA Y SINDROMES AFINES",
    "detalle": [
      {
        "codigo": "G450",
        "valor": "SINDROME ARTERIAL VERTEBRO-BASILAR"
      },
      {
        "codigo": "G451",
        "valor": "SINDROME DE LA ARTERIA CAROTIDA (HEMISFERICO)"
      },
      {
        "codigo": "G452",
        "valor": "SINDROMES ARTERIALES PRECEREBRALES BILATERALES Y MULTIPLES"
      },
      {
        "codigo": "G453",
        "valor": "AMAUROSIS FUGAZ"
      },
      {
        "codigo": "G454",
        "valor": "AMNESIA GLOBAL TRANSITORIA"
      },
      {
        "codigo": "G458",
        "valor": "OTRAS ISQUEMIAS CEREBRALES TRANSITORIAS Y SINDROMES AFINES"
      },
      {
        "codigo": "G459",
        "valor": "ISQUEMIA CEREBRAL TRANSITORIA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "G46 - SINDROMES VASCULARES ENCEFALICOS EN ENFERMEDADES CEREBROVASCULARES (I60-I67†)",
    "detalle": [
      {
        "codigo": "G460",
        "valor": "SINDROME DE LA ARTERIA CEREBRAL MEDIA"
      },
      {
        "codigo": "G461",
        "valor": "SINDROME DE LA ARTERIA CEREBRAL ANTERIOR"
      },
      {
        "codigo": "G462",
        "valor": "SINDROME DE LA ARTERIA CEREBRAL POSTERIOR"
      },
      {
        "codigo": "G463",
        "valor": "SINDROMES APOPLETICOS DEL TALLO ENCEFALICO"
      },
      {
        "codigo": "G464",
        "valor": "SINDROME DE INFARTO CEREBELOSO"
      },
      {
        "codigo": "G465",
        "valor": "SINDROME LACUNAR MOTOR PURO"
      },
      {
        "codigo": "G466",
        "valor": "SINDROME LACUNAR SENSORIAL PURO"
      },
      {
        "codigo": "G467",
        "valor": "OTROS SINDROMES LACUNARES"
      },
      {
        "codigo": "G468",
        "valor": "OTROS SINDROMES VASCULARES ENCEFALICOS EN ENFERMEDADES CEREBROVASCULARES"
      }
    ]
  },
  {
    "grupo": "G47 - TRASTORNOS DEL SUEÑO",
    "detalle": [
      {
        "codigo": "G470",
        "valor": "TRASTORNOS DEL INICIO Y DEL MANTENIMIENTO DEL SUEÑO [INSOMNIOS]"
      },
      {
        "codigo": "G471",
        "valor": "TRASTORNOS DE SOMNOLENCIA EXCESIVA (HIPERSOMNIOS)"
      },
      {
        "codigo": "G472",
        "valor": "TRASTORNOS DEL RITMO NICTAMERAL"
      },
      {
        "codigo": "G473",
        "valor": "APNEA DEL SUEÑO"
      },
      {
        "codigo": "G474",
        "valor": "NARCOLEPSIA Y CATAPLEXIA"
      },
      {
        "codigo": "G478",
        "valor": "OTROS TRASTORNOS DEL SUEÑO"
      },
      {
        "codigo": "G479",
        "valor": "TRASTORNO DEL SUEÑO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G50 - TRASTORNOS DEL NERVIO TRIGEMINO",
    "detalle": [
      {
        "codigo": "G500",
        "valor": "NEURALGIA DEL TRIGEMINO"
      },
      {
        "codigo": "G501",
        "valor": "DOLOR FACIAL ATIPICO"
      },
      {
        "codigo": "G508",
        "valor": "OTROS TRASTORNOS DEL TRIGEMINO"
      },
      {
        "codigo": "G509",
        "valor": "TRASTORNO DEL TRIGEMINO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G51 - TRASTORNOS DEL NERVIO FACIAL",
    "detalle": [
      {
        "codigo": "G510",
        "valor": "PARALISIS DE BELL"
      },
      {
        "codigo": "G511",
        "valor": "GANGLIONITIS GENICULADA"
      },
      {
        "codigo": "G512",
        "valor": "SINDROME DE MELKERSSON"
      },
      {
        "codigo": "G513",
        "valor": "ESPASMO HEMIFACIAL CLONICO"
      },
      {
        "codigo": "G514",
        "valor": "MIOQUIMIA FACIAL"
      },
      {
        "codigo": "G518",
        "valor": "OTROS TRASTORNOS DEL NERVIO FACIAL"
      },
      {
        "codigo": "G519",
        "valor": "TRASTORNO DEL NERVIO FACIAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G52 - TRASTORNOS DE OTROS NERVIOS CRANEALES",
    "detalle": [
      {
        "codigo": "G520",
        "valor": "TRASTORNOS DEL NERVIO OLFATORIO"
      },
      {
        "codigo": "G521",
        "valor": "TRASTORNOS DEL NERVIO GLOSOFARINGEO"
      },
      {
        "codigo": "G522",
        "valor": "TRASTORNOS DEL NERVIO VAGO"
      },
      {
        "codigo": "G523",
        "valor": "TRASTORNOS DEL NERVIO HIPOGLOSO"
      },
      {
        "codigo": "G527",
        "valor": "TRASTORNOS DE MULTIPLES NERVIOS CRANEALES"
      },
      {
        "codigo": "G528",
        "valor": "TRASTORNOS DE OTROS NERVIOS CRANEALES ESPECIFICADOS"
      },
      {
        "codigo": "G529",
        "valor": "TRASTORNO DE NERVIO CRANEAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G53 - TRASTORNOS DE LOS NERVIOS CRANEALES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G530",
        "valor": "NEURALGIA POSTHERPES ZOSTER"
      },
      {
        "codigo": "G531",
        "valor": "PARALISIS MULTIPLE DE LOS NERVIOS CRANEALES EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G532",
        "valor": "PARALISIS MULTIPLE DE LOS NERVIOS CRANEALES, EN LA SARCOIDOSIS"
      },
      {
        "codigo": "G533",
        "valor": "PARALISIS MULTIPLE DE LOS NERVIOS CRANEALES, EN ENFERMEDADES NEOPLASICAS"
      },
      {
        "codigo": "G538",
        "valor": "OTROS TRASTORNOS DE LOS NERVIOS CRANEALES EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G54 - TRASTORNOS DE LAS RAICES Y DE LOS PLEXOS NERVIOSOS",
    "detalle": [
      {
        "codigo": "G540",
        "valor": "TRASTORNOS DEL PLEXO BRAQUIAL"
      },
      {
        "codigo": "G541",
        "valor": "TRASTORNOS DEL PLEXO LUMBOSACRO"
      },
      {
        "codigo": "G542",
        "valor": "TRASTORNOS DE LA RAIZ CERVICAL, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "G543",
        "valor": "TRASTORNOS DE LA RAIZ TORACICA, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "G544",
        "valor": "TRASTORNOS DE LA RAIZ LUMBOSACRA, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "G545",
        "valor": "AMIOTROFIA NEURALGICA"
      },
      {
        "codigo": "G546",
        "valor": "SINDROME DEL MIEMBRO FANTASMA CON DOLOR"
      },
      {
        "codigo": "G547",
        "valor": "SINDROME DEL MIEMBRO FANTASMA SIN DOLOR"
      },
      {
        "codigo": "G548",
        "valor": "OTROS TRASTORNOS DE LAS RAICES Y PLEXOS NERVIOSOS"
      },
      {
        "codigo": "G549",
        "valor": "TRASTORNO DE LA RAIZ Y PLEXOS NERVIOSOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G55 - COMPRESIONES DE LAS RAICES Y DE LOS PLEXOS NERVIOSOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G550",
        "valor": "COMPRESIONES DE LAS RAICES Y PLEXOS NERVIOSOS EN ENFERMEDADES NEOPLASICAS"
      },
      {
        "codigo": "G551",
        "valor": "COMPRESIONES DE LAS RAICES Y PLEXOS NERVIOSOS EN TRASTORNOS DE LOS DISCOS INTERVERTEBRALES"
      },
      {
        "codigo": "G552",
        "valor": "COMPRESIONES DE LAS RAICES Y PLEXOS NERVIOSOS EN LA ESPONDILOSIS"
      },
      {
        "codigo": "G553",
        "valor": "COMPRESIONES DE LAS RAICES Y PLEXOS NERVIOSOS EN OTRAS DORSOPATIAS"
      },
      {
        "codigo": "G558",
        "valor": "COMPRESIONES DE LAS RAICES Y PLEXOS NERVIOSOS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G56 - MONONEUROPATIAS DEL MIEMBRO SUPERIOR",
    "detalle": [
      {
        "codigo": "G560",
        "valor": "SINDROME DEL TUNEL CARPIANO"
      },
      {
        "codigo": "G561",
        "valor": "OTRAS LESIONES DEL NERVIO MEDIANO"
      },
      {
        "codigo": "G562",
        "valor": "LESION DEL NERVIO CUBITAL"
      },
      {
        "codigo": "G563",
        "valor": "LESION DEL NERVIO RADIAL"
      },
      {
        "codigo": "G564",
        "valor": "CAUSALGIA"
      },
      {
        "codigo": "G568",
        "valor": "OTRAS MONONEUROPATIAS DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "G569",
        "valor": "MONONEUROPATIA DEL MIEMBRO SUPERIOR, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "G57 - MONONEUROPATIAS DEL MIEMBRO INFERIOR",
    "detalle": [
      {
        "codigo": "G570",
        "valor": "LESION DEL NERVIO CIATICO"
      },
      {
        "codigo": "G571",
        "valor": "MERALGIA PARESTESICA"
      },
      {
        "codigo": "G572",
        "valor": "LESION DEL NERVIO CRURAL"
      },
      {
        "codigo": "G573",
        "valor": "LESION DEL NERVIO CIATICO POPLITEO EXTERNO"
      },
      {
        "codigo": "G574",
        "valor": "LESION DEL NERVIO CIATICO POPLITEO INTERNO"
      },
      {
        "codigo": "G575",
        "valor": "SINDROME DEL TUNEL CALCANEO"
      },
      {
        "codigo": "G576",
        "valor": "LESION DEL NERVIO PLANTAR"
      },
      {
        "codigo": "G578",
        "valor": "OTRAS MONONEUROPATIAS DEL MIEMBRO INFERIOR"
      },
      {
        "codigo": "G579",
        "valor": "MONONEUROPATIA DEL MIEMBRO INFERIOR, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "G58 - OTRAS MONONEUROPATIAS",
    "detalle": [
      {
        "codigo": "G580",
        "valor": "NEUROPATIA INTERCOSTAL"
      },
      {
        "codigo": "G587",
        "valor": "MONONEURITIS MULTIPLE"
      },
      {
        "codigo": "G588",
        "valor": "OTRAS MONONEUROPATIAS ESPECIFICADAS"
      },
      {
        "codigo": "G589",
        "valor": "MONONEUROPATIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G59 - MONONEUROPATIA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G590",
        "valor": "MONONEUROPATIA DIABETICA"
      },
      {
        "codigo": "G598",
        "valor": "OTRAS MONONEUROPATIAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G60 - NEUROPATIA HEREDITARIA E IDIOPATICA",
    "detalle": [
      {
        "codigo": "G600",
        "valor": "NEUROPATIA HEREDITARIA MOTORA Y SENSORIAL"
      },
      {
        "codigo": "G601",
        "valor": "ENFERMEDAD DE REFSUM"
      },
      {
        "codigo": "G602",
        "valor": "NEUROPATIA ASOCIADA CON ATAXIA HEREDITARIA"
      },
      {
        "codigo": "G603",
        "valor": "NEUROPATIA PROGRESIVA IDIOPATICA"
      },
      {
        "codigo": "G608",
        "valor": "OTRAS NEUROPATIAS HEREDITARIAS E IDIOPATICAS"
      },
      {
        "codigo": "G609",
        "valor": "NEUROPATIA HEREDITARIA E IDIOPATICA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "G61 - POLINEUROPATIA INFLAMATORIA",
    "detalle": [
      {
        "codigo": "G610",
        "valor": "SINDROME DE GUILLAIN-BARRE"
      },
      {
        "codigo": "G611",
        "valor": "NEUROPATIA AL SUERO"
      },
      {
        "codigo": "G618",
        "valor": "OTRAS POLINEUROPATIAS INFLAMATORIAS"
      },
      {
        "codigo": "G619",
        "valor": "POLINEUROPATIA INFLAMATORIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G62 - OTRAS POLINEUROPATIAS",
    "detalle": [
      {
        "codigo": "G620",
        "valor": "POLINEUROPATIA INDUCIDA POR DROGAS"
      },
      {
        "codigo": "G621",
        "valor": "POLINEUROPATIA ALCOHOLICA"
      },
      {
        "codigo": "G622",
        "valor": "POLINEUROPATIA DEBIDA A OTRO AGENTE TOXICO"
      },
      {
        "codigo": "G628",
        "valor": "OTRAS POLINEUROPATIAS ESPECIFICADAS"
      },
      {
        "codigo": "G629",
        "valor": "POLINEUROPATIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G63 - POLINEUROPATIAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G630",
        "valor": "POLINEUROPATIA EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G631",
        "valor": "POLINEUROPATIA EN ENFERMEDAD NEOPLASICA"
      },
      {
        "codigo": "G632",
        "valor": "POLINEUROPATIA DIABETICA"
      },
      {
        "codigo": "G633",
        "valor": "POLINEUROPATIA EN OTRAS ENFERMEDADES ENDOCRINAS Y METABOLICAS"
      },
      {
        "codigo": "G634",
        "valor": "POLINEUROPATIA EN DEFICIENCIA NUTRICIONAL"
      },
      {
        "codigo": "G635",
        "valor": "POLINEUROPATIA EN TRASTORNOS DEL TEJIDO CONECTIVO SISTEMICO"
      },
      {
        "codigo": "G636",
        "valor": "POLINEUROPATIA EN OTROS TRASTORNOS OSTEOMUSCULARES"
      },
      {
        "codigo": "G638",
        "valor": "POLINEUROPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G64 - OTROS TRASTORNOS DEL SISTEMA NERVIOSO PERIFERICO",
    "detalle": [
      {
        "codigo": "G64X",
        "valor": "OTROS TRASTORNOS DEL SISTEMA NERVIOSO PERIFERICO"
      }
    ]
  },
  {
    "grupo": "G70 - MIASTENIA GRAVIS Y OTROS TRASTORNOS NEUROMUSCULARES",
    "detalle": [
      {
        "codigo": "G700",
        "valor": "MIASTENIA GRAVIS"
      },
      {
        "codigo": "G701",
        "valor": "TRASTORNOS TOXICOS NEUROMUSCULARES"
      },
      {
        "codigo": "G702",
        "valor": "MIASTENIA CONGENITA O DEL DESARROLLO"
      },
      {
        "codigo": "G708",
        "valor": "OTROS TRASTORNOS NEUROMUSCULARES ESPECIFICADOS"
      },
      {
        "codigo": "G709",
        "valor": "TRASTORNO NEUROMUSCULAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G71 - TRASTORNOS MUSCULARES PRIMARIOS",
    "detalle": [
      {
        "codigo": "G710",
        "valor": "DISTROFIA MUSCULAR"
      },
      {
        "codigo": "G711",
        "valor": "TRASTORNOS MIOTONICOS"
      },
      {
        "codigo": "G712",
        "valor": "MIOPATIAS CONGENITAS"
      },
      {
        "codigo": "G713",
        "valor": "MIOPATIA MITOCONDRICA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "G718",
        "valor": "OTROS TRASTORNOS PRIMARIOS DE LOS MUSCULOS"
      },
      {
        "codigo": "G719",
        "valor": "TRASTORNO PRIMARIO DEL MUSCULO, TIPO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G72 - OTRAS MIOPATIAS",
    "detalle": [
      {
        "codigo": "G720",
        "valor": "MIOPATIA INDUCIDA POR DROGAS"
      },
      {
        "codigo": "G721",
        "valor": "MIOPATIA ALCOHOLICA"
      },
      {
        "codigo": "G722",
        "valor": "MIOPATIA DEBIDA A OTROS AGENTES TOXICOS"
      },
      {
        "codigo": "G723",
        "valor": "PARALISIS PERIODICA"
      },
      {
        "codigo": "G724",
        "valor": "MIOPATIA INFLAMATORIA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "G728",
        "valor": "OTRAS MIOPATIAS ESPECIFICADAS"
      },
      {
        "codigo": "G729",
        "valor": "MIOPATIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G73 - TRASTORNOS DEL MUSCULO Y DE LA UNION NEUROMUSCULAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G730",
        "valor": "SINDROMES MIASTENICOS EN ENFERMEDADES ENDOCRINAS"
      },
      {
        "codigo": "G731",
        "valor": "SINDROME DE EATON-LAMBERT (C00-D48)"
      },
      {
        "codigo": "G732",
        "valor": "OTROS SINDROMES MIASTENICOS EN ENFERMEDAD NEOPLASICA"
      },
      {
        "codigo": "G733",
        "valor": "SINDROMES MIASTENICOS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G734",
        "valor": "MIOPATIA EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G735",
        "valor": "MIOPATIA EN ENFERMEDADES ENDOCRINAS"
      },
      {
        "codigo": "G736",
        "valor": "MIOPATIA EN ENFERMEDADES METABOLICAS"
      },
      {
        "codigo": "G737",
        "valor": "MIOPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G80 - PARALISIS CEREBRAL",
    "detalle": [
      {
        "codigo": "G800",
        "valor": "PARALISIS CEREBRAL ESPASTICA CUADRIPLEJICA"
      },
      {
        "codigo": "G801",
        "valor": "PARALISIS CEREBRAL ESPASTICA DIPLEJICA"
      },
      {
        "codigo": "G802",
        "valor": "PARALISIS CEREBRAL ESPASTICA HEMIPLEJICA"
      },
      {
        "codigo": "G803",
        "valor": "PARALISIS CEREBRAL DISCINETICA"
      },
      {
        "codigo": "G804",
        "valor": "PARALISIS CEREBRAL ATAXICA"
      },
      {
        "codigo": "G808",
        "valor": "OTROS TIPOS DE PARALISIS CEREBRAL"
      },
      {
        "codigo": "G809",
        "valor": "PARALISIS CEREBRAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "G81 - HEMIPLEJIA",
    "detalle": [
      {
        "codigo": "G810",
        "valor": "HEMIPLEJIA FLACIDA"
      },
      {
        "codigo": "G811",
        "valor": "HEMIPLEJIA ESPASTICA"
      },
      {
        "codigo": "G819",
        "valor": "HEMIPLEJIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G82 - PARAPLEJIA Y CUADRIPLEJIA",
    "detalle": [
      {
        "codigo": "G820",
        "valor": "PARAPLEJIA FLACIDA"
      },
      {
        "codigo": "G821",
        "valor": "PARAPLEJIA ESPASTICA"
      },
      {
        "codigo": "G822",
        "valor": "PARAPLEJIA, NO ESPECIFICADA"
      },
      {
        "codigo": "G823",
        "valor": "CUADRIPLEJIA FLACIDA"
      },
      {
        "codigo": "G824",
        "valor": "CUADRIPLEJIA ESPASTICA"
      },
      {
        "codigo": "G825",
        "valor": "CUADRIPLEJIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G83 - OTROS SINDROMES PARALITICOS",
    "detalle": [
      {
        "codigo": "G830",
        "valor": "DIPLEJIA DE LOS MIEMBROS SUPERIORES"
      },
      {
        "codigo": "G831",
        "valor": "MONOPLEJIA DE MIEMBRO INFERIOR"
      },
      {
        "codigo": "G832",
        "valor": "MONOPLEJIA DE MIEMBRO SUPERIOR"
      },
      {
        "codigo": "G833",
        "valor": "MONOPLEJIA, NO ESPECIFICADA"
      },
      {
        "codigo": "G834",
        "valor": "SINDROME DE LA COLA DE CABALLO"
      },
      {
        "codigo": "G838",
        "valor": "OTROS SINDROMES PARALITICOS ESPECIFICADOS"
      },
      {
        "codigo": "G839",
        "valor": "SINDROME PARALITICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G90 - TRASTORNOS DEL SISTEMA NERVIOSO AUTONOMO",
    "detalle": [
      {
        "codigo": "G900",
        "valor": "NEUROPATIA AUTONOMA PERIFERICA IDIOPATICA"
      },
      {
        "codigo": "G901",
        "valor": "DISAUTONOMIA FAMILIAR [SINDROME DE RILEY-DAY]"
      },
      {
        "codigo": "G902",
        "valor": "SINDROME DE HORNER"
      },
      {
        "codigo": "G903",
        "valor": "DEGENERACION DE SISTEMAS MULTIPLES"
      },
      {
        "codigo": "G904",
        "valor": "DISREFLEXIA AUTONOMICA"
      },
      {
        "codigo": "G908",
        "valor": "OTROS TRASTORNOS DEL SISTEMA NERVIOSO AUTONOMO"
      },
      {
        "codigo": "G909",
        "valor": "TRASTORNO DEL SISTEMA NERVIOSO AUTONOMO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G91 - HIDROCEFALO",
    "detalle": [
      {
        "codigo": "G910",
        "valor": "HIDROCEFALO COMUNICANTE"
      },
      {
        "codigo": "G911",
        "valor": "HIDROCEFALO OBSTRUCTIVO"
      },
      {
        "codigo": "G912",
        "valor": "HIDROCEFALO DE PRESION NORMAL"
      },
      {
        "codigo": "G913",
        "valor": "HIDROCEFALO POSTRAUMATICO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "G918",
        "valor": "OTROS TIPOS DE HIDROCEFALO"
      },
      {
        "codigo": "G919",
        "valor": "HIDROCEFALO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G92 - ENCEFALOPATIA TOXICA",
    "detalle": [
      {
        "codigo": "G92X",
        "valor": "ENCEFALOPATIA TOXICA"
      }
    ]
  },
  {
    "grupo": "G93 - OTROS TRASTORNOS DEL ENCEFALO",
    "detalle": [
      {
        "codigo": "G930",
        "valor": "QUISTE CEREBRAL"
      },
      {
        "codigo": "G931",
        "valor": "LESION CEREBRAL ANOXICA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "G932",
        "valor": "HIPERTENSION INTRACRANEAL BENIGNA"
      },
      {
        "codigo": "G933",
        "valor": "SINDROME DE FATIGA POSTVIRAL"
      },
      {
        "codigo": "G934",
        "valor": "ENCEFALOPATIA NO ESPECIFICADA"
      },
      {
        "codigo": "G935",
        "valor": "COMPRESION DEL ENCEFALO"
      },
      {
        "codigo": "G936",
        "valor": "EDEMA CEREBRAL"
      },
      {
        "codigo": "G937",
        "valor": "SINDROME DE REYE"
      },
      {
        "codigo": "G938",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL ENCEFALO"
      },
      {
        "codigo": "G939",
        "valor": "TRASTORNO DEL ENCEFALO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G94 - OTROS TRASTORNOS DEL ENCEFALO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G940",
        "valor": "HIDROCEFALO EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G941",
        "valor": "HIDROCEFALO EN ENFERMEDAD NEOPLASICA"
      },
      {
        "codigo": "G942",
        "valor": "HIDROCEFALO EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G948",
        "valor": "OTROS TRASTORNOS ENCEFALICOS ESPECIFICADOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G95 - OTRAS ENFERMEDADES DE LA MEDULA ESPINAL",
    "detalle": [
      {
        "codigo": "G950",
        "valor": "SIRINGOMIELIA Y SIRINGOBULBIA"
      },
      {
        "codigo": "G951",
        "valor": "MIELOPATIAS VASCULARES"
      },
      {
        "codigo": "G952",
        "valor": "COMPRESION MEDULAR, NO ESPECIFICADA"
      },
      {
        "codigo": "G958",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DE LA MEDULA ESPINAL"
      },
      {
        "codigo": "G959",
        "valor": "ENFERMEDAD DE LA MEDULA ESPINAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "G96 - OTROS TRASTORNOS DEL SISTEMA NERVIOSO CENTRAL",
    "detalle": [
      {
        "codigo": "G960",
        "valor": "PERDIDA DE LIQUIDO CEFALORRAQUIDEO"
      },
      {
        "codigo": "G961",
        "valor": "TRASTORNOS DE LAS MENINGES, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "G968",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL SISTEMA NERVIOSO CENTRAL"
      },
      {
        "codigo": "G969",
        "valor": "TRASTORNO DEL SISTEMA NERVIOSO CENTRAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "G97 - TRASTORNOS DEL SISTEMA NERVIOSO CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G970",
        "valor": "PERDIDA DE LIQUIDO CEFALORRAQUIDEO POR PUNCION ESPINAL"
      },
      {
        "codigo": "G971",
        "valor": "OTRA REACCION A LA PUNCION ESPINAL Y LUMBAR"
      },
      {
        "codigo": "G972",
        "valor": "HIPOTENSION INTRACRANEAL POSTERIOR A ANASTOMOSIS VENTRICULAR"
      },
      {
        "codigo": "G978",
        "valor": "OTROS TRASTORNOS DEL SISTEMA NERVIOSO CONSECUTIVOS A PROCEDIMIENTOS"
      },
      {
        "codigo": "G979",
        "valor": "TRASTORNOS NO ESPECIFICADOS DEL SISTEMA NERVIOSO, CONSECUTIVOS A PROCEDIMIENTOS"
      }
    ]
  },
  {
    "grupo": "G98 - OTROS TRASTORNOS DEL SISTEMA NERVIOSO, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G98X",
        "valor": "OTROS TRASTORNOS DEL SISTEMA NERVIOSO, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "G99 - OTROS TRASTORNOS DEL SISTEMA NERVIOSO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "G990",
        "valor": "NEUROPATIA AUTONOMICA EN ENFERMEDADES METABOLICA Y ENDOCRINAS"
      },
      {
        "codigo": "G991",
        "valor": "OTROS TRASTORNOS DEL SISTEMA NERVIOSO AUTONOMO EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G992",
        "valor": "MIELOPATIA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "G998",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL SISTEMA NERVIOSO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H00 - ORZUELO Y CALACIO",
    "detalle": [
      {
        "codigo": "H000",
        "valor": "ORZUELO Y OTRAS INFLAMACIONES PROFUNDAS DEL PARPADO"
      },
      {
        "codigo": "H001",
        "valor": "CALACIO [CHALAZION]"
      }
    ]
  },
  {
    "grupo": "H01 - OTRAS INFLAMACIONES DEL PARPADO",
    "detalle": [
      {
        "codigo": "H010",
        "valor": "BLEFARITIS"
      },
      {
        "codigo": "H011",
        "valor": "DERMATOSIS NO INFECCIOSA DEL PARPADO"
      },
      {
        "codigo": "H018",
        "valor": "OTRAS INFLAMACIONES ESPECIFICADAS DEL PARPADO"
      },
      {
        "codigo": "H019",
        "valor": "INFLAMACION DEL PARPADO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H02 - OTROS TRASTORNOS DE LOS PARPADOS",
    "detalle": [
      {
        "codigo": "H020",
        "valor": "ENTROPION Y TRIQUIASIS PALPEBRAL"
      },
      {
        "codigo": "H021",
        "valor": "ECTROPION DEL PARPADO"
      },
      {
        "codigo": "H022",
        "valor": "LAGOFTALMOS"
      },
      {
        "codigo": "H023",
        "valor": "BLEFAROCALASIA"
      },
      {
        "codigo": "H024",
        "valor": "BLEFAROPTOSIS"
      },
      {
        "codigo": "H025",
        "valor": "OTROS TRASTORNOS FUNCIONALES DEL PARPADO"
      },
      {
        "codigo": "H026",
        "valor": "XANTELASMA DEL PARPADO"
      },
      {
        "codigo": "H027",
        "valor": "OTROS TRASTORNOS DEGENERATIVOS DEL PARPADO Y DEL AREA PERIOCULAR"
      },
      {
        "codigo": "H028",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL PARPADO"
      },
      {
        "codigo": "H029",
        "valor": "TRASTORNO DEL PARPADO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H03 - TRASTORNOS DEL PARPADO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H030",
        "valor": "INFECCION O INFESTACION PARASITARIA DEL PARPADO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H031",
        "valor": "COMPROMISO DEL PARPADO EN ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H038",
        "valor": "COMPROMISO DEL PARPADO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H04 - TRASTORNOS DEL APARATO LAGRIMAL",
    "detalle": [
      {
        "codigo": "H040",
        "valor": "DACRIOADENITIS"
      },
      {
        "codigo": "H041",
        "valor": "OTROS TRASTORNOS DE LA GLANDULA LAGRIMAL"
      },
      {
        "codigo": "H042",
        "valor": "EPIFORA"
      },
      {
        "codigo": "H043",
        "valor": "INFLAMACION AGUDA Y LA NO ESPECIFICADA DE LAS VIAS LAGRIMALES"
      },
      {
        "codigo": "H044",
        "valor": "INFLAMACION CRONICA DE LAS VIAS LAGRIMALES"
      },
      {
        "codigo": "H045",
        "valor": "ESTENOSIS E INSUFICIENCIA DE LAS VIAS LAGRIMALES"
      },
      {
        "codigo": "H046",
        "valor": "OTROS CAMBIOS DE LAS VIAS LAGRIMALES"
      },
      {
        "codigo": "H048",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL APARATO LAGRIMAL"
      },
      {
        "codigo": "H049",
        "valor": "TRASTORNO DEL APARATO LAGRIMAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H05 - TRASTORNOS DE LA ORBITA",
    "detalle": [
      {
        "codigo": "H050",
        "valor": "INFLAMACION AGUDA DE LA ORBITA"
      },
      {
        "codigo": "H051",
        "valor": "TRASTORNOS INFLAMATORIOS CRONICOS DE LA ORBITA"
      },
      {
        "codigo": "H052",
        "valor": "AFECCIONES EXOFTALMICAS"
      },
      {
        "codigo": "H053",
        "valor": "DEFORMIDAD DE LA ORBITA"
      },
      {
        "codigo": "H054",
        "valor": "ENOFTALMIA"
      },
      {
        "codigo": "H055",
        "valor": "RETENCION DE CUERPO EXTRAÑO (ANTIGUO), CONSECUTIVA A HERIDA PENETRANTE DE LA ORBITA"
      },
      {
        "codigo": "H058",
        "valor": "OTROS TRASTORNOS DE LA ORBITA"
      },
      {
        "codigo": "H059",
        "valor": "TRASTORNO DE LA ORBITA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H06 - TRASTORNOS DEL APARATO LAGRIMAL Y DE LA ORBITA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H060",
        "valor": "TRASTORNOS DEL APARATO LAGRIMAL EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H061",
        "valor": "INFECCION E INFESTACION PARASITARIAS DE LA ORBITA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H062",
        "valor": "EXOFTALMIA HIPERTIROIDEA"
      },
      {
        "codigo": "H063",
        "valor": "OTROS TRASTORNOS DE LA ORBITA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H10 - CONJUNTIVITIS",
    "detalle": [
      {
        "codigo": "H100",
        "valor": "CONJUNTIVITIS MUCOPURULENTA"
      },
      {
        "codigo": "H101",
        "valor": "CONJUNTIVITIS ATOPICA AGUDA"
      },
      {
        "codigo": "H102",
        "valor": "OTRAS CONJUNTIVITIS AGUDAS"
      },
      {
        "codigo": "H103",
        "valor": "CONJUNTIVITIS AGUDA, NO ESPECIFICADA"
      },
      {
        "codigo": "H104",
        "valor": "CONJUNTIVITIS CRONICA"
      },
      {
        "codigo": "H105",
        "valor": "BLEFAROCONJUNTIVITIS"
      },
      {
        "codigo": "H108",
        "valor": "OTRAS CONJUNTIVITIS"
      },
      {
        "codigo": "H109",
        "valor": "CONJUNTIVITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H11 - OTROS TRASTORNOS DE LA CONJUNTIVA",
    "detalle": [
      {
        "codigo": "H110",
        "valor": "PTERIGION"
      },
      {
        "codigo": "H111",
        "valor": "DEGENERACIONES Y DEPOSITOS CONJUNTIVALES"
      },
      {
        "codigo": "H112",
        "valor": "CICATRICES CONJUNTIVALES"
      },
      {
        "codigo": "H113",
        "valor": "HEMORRAGIA CONJUNTIVAL"
      },
      {
        "codigo": "H114",
        "valor": "OTROS TRASTORNOS VASCULARES Y QUISTES CONJUNTIVALES"
      },
      {
        "codigo": "H118",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA CONJUNTIVA"
      },
      {
        "codigo": "H119",
        "valor": "TRASTORNO DE LA CONJUNTIVA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H13 - TRASTORNOS DE LA CONJUNTIVA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H130",
        "valor": "INFECCION FILARICA DE LA CONJUNTIVA"
      },
      {
        "codigo": "H131",
        "valor": "CONJUNTIVITIS EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H132",
        "valor": "CONJUNTIVITIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H133",
        "valor": "PENFIGOIDE OCULAR"
      },
      {
        "codigo": "H138",
        "valor": "OTROS TRASTORNOS DE LA CONJUNTIVA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H15 - TRASTORNOS DE LA ESCLEROTICA",
    "detalle": [
      {
        "codigo": "H150",
        "valor": "ESCLERITIS"
      },
      {
        "codigo": "H151",
        "valor": "EPISCLERITIS"
      },
      {
        "codigo": "H158",
        "valor": "OTROS TRASTORNOS DE LA ESCLEROTICA"
      },
      {
        "codigo": "H159",
        "valor": "TRASTORNO DE LA ESCLEROTICA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H16 - QUERATITIS",
    "detalle": [
      {
        "codigo": "H160",
        "valor": "ULCERA DE LA CORNEA"
      },
      {
        "codigo": "H161",
        "valor": "OTRAS QUERATITIS SUPERFICIALES SIN CONJUNTIVITIS"
      },
      {
        "codigo": "H162",
        "valor": "QUERATOCONJUNTIVITIS"
      },
      {
        "codigo": "H163",
        "valor": "QUERATITIS INTERSTICIAL Y PROFUNDA"
      },
      {
        "codigo": "H164",
        "valor": "NEOVASCULARIZACION DE LA CORNEA"
      },
      {
        "codigo": "H168",
        "valor": "OTRAS QUERATITIS"
      },
      {
        "codigo": "H169",
        "valor": "QUERATITIS,NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H17 - OPACIDADES Y CICATRICES CORNEALES",
    "detalle": [
      {
        "codigo": "H170",
        "valor": "LEUCOMA ADHERENTE"
      },
      {
        "codigo": "H171",
        "valor": "OTRAS OPACIDADES CENTRALES DE LA CORNEA"
      },
      {
        "codigo": "H178",
        "valor": "OTRAS OPACIDADES O CICATRICES DE LA CORNEA"
      },
      {
        "codigo": "H179",
        "valor": "CICATRIZ U OPACIDAD DE LA CORNEA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H18 - OTROS TRASTORNOS DE LA CORNEA",
    "detalle": [
      {
        "codigo": "H180",
        "valor": "PIGMENTACIONES Y DEPOSITOS EN LA CORNEA"
      },
      {
        "codigo": "H181",
        "valor": "QUERATOPATIA VESICULAR"
      },
      {
        "codigo": "H182",
        "valor": "OTROS EDEMAS DE LA CORNEA"
      },
      {
        "codigo": "H183",
        "valor": "CAMBIOS EN LAS MEMBRANAS DE LA CORNEA"
      },
      {
        "codigo": "H184",
        "valor": "DEGENERACION DE LA CORNEA"
      },
      {
        "codigo": "H185",
        "valor": "DISTROFIA HEREDITARIA DE LA CORNEA"
      },
      {
        "codigo": "H186",
        "valor": "QUERATOCONO"
      },
      {
        "codigo": "H187",
        "valor": "OTRAS DEFORMIDADES DE LA CORNEA"
      },
      {
        "codigo": "H188",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA CORNEA"
      },
      {
        "codigo": "H189",
        "valor": "TRASTORNO DE LA CORNEA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H19 - TRASTORNOS DE LA ESCLEROTICA Y DE LA CORNEA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H190",
        "valor": "ESCLERITIS Y EPISCLERITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H191",
        "valor": "QUERATITIS Y QUERATOCONJUNTIVITIS POR HERPES SIMPLE"
      },
      {
        "codigo": "H192",
        "valor": "QUERATITIS Y QUERATOCONJUNTIVITIS EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS, CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H193",
        "valor": "QUERATITIS Y QUERATOCONJUNTIVITIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H198",
        "valor": "OTROS TRASTORNOS DE LA ESCLEROTICA Y DE LA CORNEA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H20 - IRIDOCICLITIS",
    "detalle": [
      {
        "codigo": "H200",
        "valor": "IRIDOCICLITIS AGUDA Y SUBAGUDA"
      },
      {
        "codigo": "H201",
        "valor": "IRIDOCICLITIS CRONICA"
      },
      {
        "codigo": "H202",
        "valor": "IRIDOCICLITIS INDUCIDA POR TRASTORNO DEL CRISTALINO"
      },
      {
        "codigo": "H208",
        "valor": "OTRAS IRIDOCICLITIS ESPECIFICADAS"
      },
      {
        "codigo": "H209",
        "valor": "IRIDOCICLITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H21 - OTROS TRASTORNOS DEL IRIS Y DEL CUERPO CILIAR",
    "detalle": [
      {
        "codigo": "H210",
        "valor": "HIFEMA"
      },
      {
        "codigo": "H211",
        "valor": "OTROS TRASTORNOS VASCULARES DEL IRIS Y DEL CUERPO CILIAR"
      },
      {
        "codigo": "H212",
        "valor": "DEGENERACION DEL IRIS Y DEL CUERPO CILIAR"
      },
      {
        "codigo": "H213",
        "valor": "QUISTE DEL IRIS, DEL CUERPO CILIAR Y DE LA CAMARA ANTERIOR"
      },
      {
        "codigo": "H214",
        "valor": "MEMBRANAS PUPILARES"
      },
      {
        "codigo": "H215",
        "valor": "OTRAS ADHERENCIAS Y DESGARROS DEL IRIS Y DEL CUERPO CILIAR"
      },
      {
        "codigo": "H218",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL IRIS Y DEL CUERPO CILIAR"
      },
      {
        "codigo": "H219",
        "valor": "TRASTORNO DEL IRIS Y DEL CUERPO CILIAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H22 - TRASTORNOS DEL IRIS Y DEL CUERPO CILIAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H220",
        "valor": "IRIDOCICLITIS EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H221",
        "valor": "IRIDOCICLITIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H228",
        "valor": "OTROS TRASTORNOS DEL IRIS Y DEL CUERPO CILIAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H25 - CATARATA SENIL",
    "detalle": [
      {
        "codigo": "H250",
        "valor": "CATARATA SENIL INCIPIENTE"
      },
      {
        "codigo": "H251",
        "valor": "CATARATA SENIL NUCLEAR"
      },
      {
        "codigo": "H252",
        "valor": "CATARATA SENIL, TIPO MORGAGNIAN"
      },
      {
        "codigo": "H258",
        "valor": "OTRAS CATARATAS SENILES"
      },
      {
        "codigo": "H259",
        "valor": "CATARATA SENIL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H26 - OTRAS CATARATAS",
    "detalle": [
      {
        "codigo": "H260",
        "valor": "CATARATA INFANTIL, JUVENIL Y PRESENIL"
      },
      {
        "codigo": "H261",
        "valor": "CATARATA TRAUMATICA"
      },
      {
        "codigo": "H262",
        "valor": "CATARATA COMPLICADA"
      },
      {
        "codigo": "H263",
        "valor": "CATARATA INDUCIDA POR DROGAS"
      },
      {
        "codigo": "H264",
        "valor": "CATARATA RESIDUAL"
      },
      {
        "codigo": "H268",
        "valor": "OTRAS FORMAS ESPECIFICADAS DE CATARATA"
      },
      {
        "codigo": "H269",
        "valor": "CATARATA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H27 - OTROS TRASTORNOS DEL CRISTALINO",
    "detalle": [
      {
        "codigo": "H270",
        "valor": "AFAQUIA"
      },
      {
        "codigo": "H271",
        "valor": "LUXACION DEL CRISTALINO"
      },
      {
        "codigo": "H278",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL CRISTALINO"
      },
      {
        "codigo": "H279",
        "valor": "TRASTORNO DEL CRISTALINO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H28 - CATARATA Y OTROS TRASTORNOS DEL CRISTALINO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H280",
        "valor": "CATARATA DIABETICA"
      },
      {
        "codigo": "H281",
        "valor": "CATARATA EN OTRAS ENFERMEDADES ENDOCRINAS, NUTRICIONALES Y METABOLICAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H282",
        "valor": "CATARATA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H288",
        "valor": "OTROS TRASTORNOS DEL CRISTALINO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H30 - INFLAMACION CORIORRETINIANA",
    "detalle": [
      {
        "codigo": "H300",
        "valor": "CORIORRETINITIS FOCAL"
      },
      {
        "codigo": "H301",
        "valor": "CORIORRETINITIS DISEMINADA"
      },
      {
        "codigo": "H302",
        "valor": "CICLITIS POSTERIOR"
      },
      {
        "codigo": "H308",
        "valor": "OTRAS CORIORRETINITIS"
      },
      {
        "codigo": "H309",
        "valor": "CORIORRETINITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H31 - OTROS TRASTORNOS DE LA COROIDES",
    "detalle": [
      {
        "codigo": "H310",
        "valor": "CICATRICES CORIORRETINIANAS"
      },
      {
        "codigo": "H311",
        "valor": "DEGENERACION COROIDEA"
      },
      {
        "codigo": "H312",
        "valor": "DISTROFIA COROIDEA HEREDITARIA"
      },
      {
        "codigo": "H313",
        "valor": "HEMORRAGIA Y RUPTURA DE LA COROIDES"
      },
      {
        "codigo": "H314",
        "valor": "DESPRENDIMIENTO DE LA COROIDES"
      },
      {
        "codigo": "H318",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA COROIDES"
      },
      {
        "codigo": "H319",
        "valor": "TRASTORNO DE LA COROIDES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H32 - TRASTORNOS CORIORRETINIANOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H320",
        "valor": "INFLAMACION CORIORRETINIANA EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H328",
        "valor": "OTROS TRASTORNOS CORIORRETINIANOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H33 - DESPRENDIMIENTO Y DESGARRO DE LA RETINA",
    "detalle": [
      {
        "codigo": "H330",
        "valor": "DESPRENDIMIENTO DE LA RETINA CON RUPTURA"
      },
      {
        "codigo": "H331",
        "valor": "RETINOSQUISIS Y QUISTES DE LA RETINA"
      },
      {
        "codigo": "H332",
        "valor": "DESPRENDIMIENTO SEROSO DE LA RETINA"
      },
      {
        "codigo": "H333",
        "valor": "DESGARRO DE LA RETINA SIN DESPRENDIMIENTO"
      },
      {
        "codigo": "H334",
        "valor": "DESPRENDIMIENTO DE LA RETINA POR TRACCION"
      },
      {
        "codigo": "H335",
        "valor": "OTROS DESPRENDIMIENTOS DE LA RETINA"
      }
    ]
  },
  {
    "grupo": "H34 - OCLUSION VASCULAR DE LA RETINA",
    "detalle": [
      {
        "codigo": "H340",
        "valor": "OCLUSION ARTERIAL TRANSITORIA DE LA RETINA"
      },
      {
        "codigo": "H341",
        "valor": "OCLUSION DE LA ARTERIA CENTRAL DE LA RETINA"
      },
      {
        "codigo": "H342",
        "valor": "OTRAS FORMAS DE OCLUSION DE LA ARTERIA DE LA RETINA"
      },
      {
        "codigo": "H348",
        "valor": "OTRAS OCLUSIONES VASCULARES RETINIANAS"
      },
      {
        "codigo": "H349",
        "valor": "OCLUSION VASCULAR RETINIANA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "H35 - OTROS TRASTORNOS DE LA RETINA",
    "detalle": [
      {
        "codigo": "H350",
        "valor": "RETINOPATIAS DEL FONDO Y CAMBIOS VASCULARES RETINIANOS"
      },
      {
        "codigo": "H351",
        "valor": "RETINOPATIA DE LA PREMATURIDAD"
      },
      {
        "codigo": "H352",
        "valor": "OTRAS RETINOPATIAS PROLIFERATIVAS"
      },
      {
        "codigo": "H353",
        "valor": "DEGENERACION DE LA MACULA Y DEL POLO POSTERIOR DEL OJO"
      },
      {
        "codigo": "H354",
        "valor": "DEGENERACION PERIFERICA DE LA RETINA"
      },
      {
        "codigo": "H355",
        "valor": "DISTROFIA HEREDITARIA DE LA RETINA"
      },
      {
        "codigo": "H356",
        "valor": "HEMORRAGIA RETINIANA"
      },
      {
        "codigo": "H357",
        "valor": "SEPARACION DE LAS CAPAS DE LA RETINA"
      },
      {
        "codigo": "H358",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA RETINA"
      },
      {
        "codigo": "H359",
        "valor": "TRASTORNO DE LA RETINA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H36 - TRASTORNOS DE LA RETINA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H360",
        "valor": "RETINOPATIA DIABETICA"
      },
      {
        "codigo": "H368",
        "valor": "OTROS TRASTORNOS DE LA RETINA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H40 - GLAUCOMA",
    "detalle": [
      {
        "codigo": "H400",
        "valor": "SOSPECHA DE GLAUCOMA"
      },
      {
        "codigo": "H401",
        "valor": "GLAUCOMA PRIMARIO DE ANGULO ABIERTO"
      },
      {
        "codigo": "H402",
        "valor": "GLAUCOMA PRIMARIO DE ANGULO CERRADO"
      },
      {
        "codigo": "H403",
        "valor": "GLAUCOMA SECUNDARIO A TRAUMATISMO OCULAR"
      },
      {
        "codigo": "H404",
        "valor": "GLAUCOMA SECUNDARIO A INFLAMACION OCULAR"
      },
      {
        "codigo": "H405",
        "valor": "GLAUCOMA SECUNDARIO A OTROS TRASTORNOS DEL OJO"
      },
      {
        "codigo": "H406",
        "valor": "GLAUCOMA SECUNDARIO A DROGAS"
      },
      {
        "codigo": "H408",
        "valor": "OTROS GLAUCOMAS"
      },
      {
        "codigo": "H409",
        "valor": "GLAUCOMA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H42 - GLAUCOMA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H420",
        "valor": "GLAUCOMA EN ENFERMEDADES ENDOCRINAS, NUTRICIONALES Y METABOLICAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H428",
        "valor": "GLAUCOMA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H43 - TRASTORNOS DEL CUERPO VITREO",
    "detalle": [
      {
        "codigo": "H430",
        "valor": "PROLAPSO DEL VITREO"
      },
      {
        "codigo": "H431",
        "valor": "HEMORRAGIA DEL VITREO"
      },
      {
        "codigo": "H432",
        "valor": "DEPOSITOS CRISTALINOS EN EL CUERPO VITREO"
      },
      {
        "codigo": "H433",
        "valor": "OTRAS OPACIDADES VITREAS"
      },
      {
        "codigo": "H438",
        "valor": "OTROS TRASTORNOS DEL CUERPO VITREO"
      },
      {
        "codigo": "H439",
        "valor": "TRASTORNO DEL CUERPO VITREO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H44 - TRASTORNOS DEL GLOBO OCULAR",
    "detalle": [
      {
        "codigo": "H440",
        "valor": "ENDOFTALMITIS PURULENTA"
      },
      {
        "codigo": "H441",
        "valor": "OTRAS ENDOFTALMITIS"
      },
      {
        "codigo": "H442",
        "valor": "MIOPIA DEGENERATIVA"
      },
      {
        "codigo": "H443",
        "valor": "OTROS TRASTORNOS DEGENERATIVOS DEL GLOBO OCULAR"
      },
      {
        "codigo": "H444",
        "valor": "HIPOTONIA OCULAR"
      },
      {
        "codigo": "H445",
        "valor": "AFECCIONES DEGENERATIVAS DEL GLOBO OCULAR"
      },
      {
        "codigo": "H446",
        "valor": "RETENCION INTRAOCULAR DE CUERPO EXTRAÑO MAGNETICO (ANTIGUO)"
      },
      {
        "codigo": "H447",
        "valor": "RETENCION INTRAOCULAR DE CUERPO EXTRAÑO NO MAGNETICO (ANTIGUO)"
      },
      {
        "codigo": "H448",
        "valor": "OTROS TRASTORNOS DEL GLOBO OCULAR"
      },
      {
        "codigo": "H449",
        "valor": "TRASTORNO DEL GLOBO OCULAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H45 - TRASTORNOS DEL CUERPO VITREO Y DEL GLOBO OCULAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H450",
        "valor": "HEMORRAGIA DEL VITREO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H451",
        "valor": "ENDOFTALMITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H458",
        "valor": "OTROS TRASTORNOS DEL CUERPO VITREO Y DEL GLOBO OCULAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H46 - NEURITIS OPTICA",
    "detalle": [
      {
        "codigo": "H46X",
        "valor": "NEURITIS OPTICA"
      }
    ]
  },
  {
    "grupo": "H47 - OTROS TRASTORNOS DEL NERVIO OPTICO [II PAR] Y DE LAS VIAS OPTICAS",
    "detalle": [
      {
        "codigo": "H470",
        "valor": "TRASTORNOS DEL NERVIO OPTICO, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "H471",
        "valor": "PAPILEDEMA, NO ESPECIFICADO"
      },
      {
        "codigo": "H472",
        "valor": "ATROFIA OPTICA"
      },
      {
        "codigo": "H473",
        "valor": "OTROS TRASTORNOS DEL DISCO OPTICO"
      },
      {
        "codigo": "H474",
        "valor": "TRASTORNOS DEL QUIASMA OPTICO"
      },
      {
        "codigo": "H475",
        "valor": "TRASTORNOS DE OTRAS VIAS OPTICAS"
      },
      {
        "codigo": "H476",
        "valor": "TRASTORNOS DE LA CORTEZA VISUAL"
      },
      {
        "codigo": "H477",
        "valor": "TRASTORNO DE LAS VIAS OPTICAS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H48 - TRASTORNOS DEL NERVIO OPTICO [II PAR] Y DE LAS VIAS OPTICAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H480",
        "valor": "ATROFIA OPTICA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H481",
        "valor": "NEURITIS RETROBULBAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H488",
        "valor": "OTROS TRASTORNOS DEL NERVIO OPTICO Y DE LAS VIAS OPTICAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H49 - ESTRABISMO PARALITICO",
    "detalle": [
      {
        "codigo": "H490",
        "valor": "PARALISIS DEL NERVIO MOTOR OCULAR COMUN [III PAR]"
      },
      {
        "codigo": "H491",
        "valor": "PARALISIS DEL NERVIO PATETICO [IV PAR]"
      },
      {
        "codigo": "H492",
        "valor": "PARALISIS DEL NERVIO MOTOR OCULAR EXTERNO [VI PAR]"
      },
      {
        "codigo": "H493",
        "valor": "OFTALMOPLEJIA TOTAL (EXTERNA)"
      },
      {
        "codigo": "H494",
        "valor": "OFTALMOPLEJIA EXTERNA PROGRESIVA"
      },
      {
        "codigo": "H498",
        "valor": "OTROS ESTRABISMOS PARALITICOS"
      },
      {
        "codigo": "H499",
        "valor": "ESTRABISMO PARALITICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H50 - OTROS ESTRABISMOS",
    "detalle": [
      {
        "codigo": "H500",
        "valor": "ESTRABISMO CONCOMITANTE CONVERGENTE"
      },
      {
        "codigo": "H501",
        "valor": "ESTRABISMO CONCOMITANTE DIVERGENTE"
      },
      {
        "codigo": "H502",
        "valor": "ESTRABISMO VERTICAL"
      },
      {
        "codigo": "H503",
        "valor": "HETEROTROPIA INTERMITENTE"
      },
      {
        "codigo": "H504",
        "valor": "OTRAS HETEROTROPIAS O LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "H505",
        "valor": "HETEROFORIA"
      },
      {
        "codigo": "H506",
        "valor": "ESTRABISMO MECANICO"
      },
      {
        "codigo": "H508",
        "valor": "OTROS ESTRABISMOS ESPECIFICADOS"
      },
      {
        "codigo": "H509",
        "valor": "ESTRABISMO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H51 - OTROS TRASTORNOS DE LOS MOVIMIENTOS BINOCULARES",
    "detalle": [
      {
        "codigo": "H510",
        "valor": "PARALISIS DE LA CONJUGACION DE LA MIRADA"
      },
      {
        "codigo": "H511",
        "valor": "EXCESO E INSUFICIENCIA DE LA CONVERGENCIA OCULAR"
      },
      {
        "codigo": "H512",
        "valor": "OFTALMOPLEJIA INTERNUCLEAR"
      },
      {
        "codigo": "H518",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LOS MOVIMIENTOS BINOCULARES"
      },
      {
        "codigo": "H519",
        "valor": "TRASTORNO DEL MOVIMIENTO BINOCULAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H52 - TRASTORNOS DE LA ACOMODACION Y DE LA REFRACCION",
    "detalle": [
      {
        "codigo": "H520",
        "valor": "HIPERMETROPIA"
      },
      {
        "codigo": "H521",
        "valor": "MIOPIA"
      },
      {
        "codigo": "H522",
        "valor": "ASTIGMATISMO"
      },
      {
        "codigo": "H523",
        "valor": "ANISOMETROPIA Y ANISEICONIA"
      },
      {
        "codigo": "H524",
        "valor": "PRESBICIA"
      },
      {
        "codigo": "H525",
        "valor": "TRASTORNOS DE LA ACOMODACION"
      },
      {
        "codigo": "H526",
        "valor": "OTROS TRASTORNOS DE LA REFRACCION"
      },
      {
        "codigo": "H527",
        "valor": "TRASTORNO DE LA REFRACCION, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H53 - ALTERACIONES DE LA VISION",
    "detalle": [
      {
        "codigo": "H530",
        "valor": "AMBLIOPIA EX ANOPSIA"
      },
      {
        "codigo": "H531",
        "valor": "ALTERACIONES VISUALES SUBJETIVAS"
      },
      {
        "codigo": "H532",
        "valor": "DIPLOPIA"
      },
      {
        "codigo": "H533",
        "valor": "OTROS TRASTORNOS DE LA VISION BINOCULAR"
      },
      {
        "codigo": "H534",
        "valor": "DEFECTOS DEL CAMPO VISUAL"
      },
      {
        "codigo": "H535",
        "valor": "DEFICIENCIA DE LA VISION CROMATICA"
      },
      {
        "codigo": "H536",
        "valor": "CEGUERA NOCTURNA"
      },
      {
        "codigo": "H538",
        "valor": "OTRAS ALTERACIONES VISUALES"
      },
      {
        "codigo": "H539",
        "valor": "ALTERACION VISUAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H54 - DISCAPACIDAD VISUAL, INCLUSIVE CEGUERA (BINOCULAR O MONOCULAR)",
    "detalle": [
      {
        "codigo": "H540",
        "valor": "CEGUERA BINOCULAR"
      },
      {
        "codigo": "H541",
        "valor": "DEFICIENCIA VISUAL SEVERA, BINOCULAR"
      },
      {
        "codigo": "H542",
        "valor": "DEFICIENCIA VISUAL MODERADA, BINOCULAR"
      },
      {
        "codigo": "H543",
        "valor": "DEFICIENCIA VISUAL LEVE O AUSENTE, BINOCULAR"
      },
      {
        "codigo": "H544",
        "valor": "CEGUERA MONOCULAR"
      },
      {
        "codigo": "H545",
        "valor": "DEFICIENCIA VISUAL SEVERA, MONOCULAR"
      },
      {
        "codigo": "H546",
        "valor": "DEFICIENCIA VISUAL MODERADA, MONOCULAR"
      },
      {
        "codigo": "H547",
        "valor": "DISMINUCION DE LA AGUDEZA VISUAL, SIN ESPECIFICACION"
      },
      {
        "codigo": "H549",
        "valor": "DEFICIENCIA VISUAL NO ESPECIFICADA (BINOCULAR)"
      }
    ]
  },
  {
    "grupo": "H55 - NISTAGMO Y OTROS MOVIMIENTOS OCULARES IRREGULARES",
    "detalle": [
      {
        "codigo": "H55X",
        "valor": "NISTAGMO Y OTROS MOVIMIENTOS OCULARES IRREGULARES"
      }
    ]
  },
  {
    "grupo": "H57 - OTROS TRASTORNOS DEL OJO Y SUS ANEXOS",
    "detalle": [
      {
        "codigo": "H570",
        "valor": "ANOMALIAS DE LA FUNCION PUPILAR"
      },
      {
        "codigo": "H571",
        "valor": "DOLOR OCULAR"
      },
      {
        "codigo": "H578",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL OJO Y SUS ANEXOS"
      },
      {
        "codigo": "H579",
        "valor": "TRASTORNO DEL OJO Y SUS ANEXOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H58 - OTROS TRASTORNOS DEL OJO Y SUS ANEXOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H580",
        "valor": "ANOMALIAS DE LA FUNCION PUPILAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H581",
        "valor": "ALTERACIONES DE LA VISION EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H588",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL OJO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H59 - TRASTORNOS DEL OJO Y SUS ANEXOS CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H590",
        "valor": "QUERATOPATIA (BULLOSA AFAQUICA) CONSECUTIVA A CIRUGIA DE CATARATA"
      },
      {
        "codigo": "H598",
        "valor": "OTROS TRASTORNOS DEL OJO Y SUS ANEXOS, CONSECUTIVOS A PROCEDIMIENTOS"
      },
      {
        "codigo": "H599",
        "valor": "TRASTORNO NO ESPECIFICADO DEL OJO Y SUS ANEXOS, CONSECUTIVO A PROCEDIMIENTOS"
      }
    ]
  },
  {
    "grupo": "H60 - OTITIS EXTERNA",
    "detalle": [
      {
        "codigo": "H600",
        "valor": "ABSCESO DEL OIDO EXTERNO"
      },
      {
        "codigo": "H601",
        "valor": "CELULITIS DEL OIDO EXTERNO"
      },
      {
        "codigo": "H602",
        "valor": "OTITIS EXTERNA MALIGNA"
      },
      {
        "codigo": "H603",
        "valor": "OTRAS OTITIS EXTERNAS INFECCIOSAS"
      },
      {
        "codigo": "H604",
        "valor": "COLESTEATOMA DEL OIDO EXTERNO"
      },
      {
        "codigo": "H605",
        "valor": "OTITIS EXTERNA AGUDA, NO INFECCIOSA"
      },
      {
        "codigo": "H608",
        "valor": "OTRAS OTITIS EXTERNAS"
      },
      {
        "codigo": "H609",
        "valor": "OTITIS EXTERNA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "H61 - OTROS TRASTORNOS DEL OIDO EXTERNO",
    "detalle": [
      {
        "codigo": "H610",
        "valor": "PERICONDRITIS DEL OIDO EXTERNO"
      },
      {
        "codigo": "H611",
        "valor": "AFECCIONES NO INFECCIOSAS DEL PABELLON AUDITIVO"
      },
      {
        "codigo": "H612",
        "valor": "CERUMEN IMPACTADO"
      },
      {
        "codigo": "H613",
        "valor": "ESTENOSIS ADQUIRIDA DEL CONDUCTO AUDITIVO EXTERNO"
      },
      {
        "codigo": "H618",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL OIDO EXTERNO"
      },
      {
        "codigo": "H619",
        "valor": "TRASTORNO DEL OIDO EXTERNO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H62 - TRASTORNOS DEL OIDO EXTERNO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H620",
        "valor": "OTITIS EXTERNA EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H621",
        "valor": "OTITITS EXTERNA EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H622",
        "valor": "OTITITS EXTERNA EN MICOSIS"
      },
      {
        "codigo": "H623",
        "valor": "OTITITS EXTERNA EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H624",
        "valor": "OTITITS EXTERNA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H628",
        "valor": "OTROS TRASTORNOS DEL OIDO EXTERNO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H65 - OTITIS MEDIA NO SUPURATIVA",
    "detalle": [
      {
        "codigo": "H650",
        "valor": "OTITIS MEDIA AGUDA SEROSA"
      },
      {
        "codigo": "H651",
        "valor": "OTRA OTITIS MEDIA AGUDA, NO SUPURATIVA"
      },
      {
        "codigo": "H652",
        "valor": "OTITIS MEDIA CRONICA SEROSA"
      },
      {
        "codigo": "H653",
        "valor": "OTITIS MEDIA CRONICA MUCOIDE"
      },
      {
        "codigo": "H654",
        "valor": "OTRAS OTITIS MEDIAS CRONICAS NO SUPURATIVAS"
      },
      {
        "codigo": "H659",
        "valor": "OTITIS MEDIA NO SUPURATIVA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "H66 - OTITIS MEDIA SUPURATIVA Y LA NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "H660",
        "valor": "OTITIS MEDIA SUPURATIVA AGUDA"
      },
      {
        "codigo": "H661",
        "valor": "OTITIS MEDIA TUBOTIMPANICA SUPURATIVA CRONICA"
      },
      {
        "codigo": "H662",
        "valor": "OTITIS MEDIA SUPURATIVA CRONICA ATICOANTRAL"
      },
      {
        "codigo": "H663",
        "valor": "OTRAS OTITIS MEDIAS CRONICAS SUPURATIVAS"
      },
      {
        "codigo": "H664",
        "valor": "OTITIS MEDIA SUPURATIVA, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "H669",
        "valor": "OTITIS MEDIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H67 - OTITIS MEDIA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H670",
        "valor": "OTITIS MEDIA EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H671",
        "valor": "OTITIS MEDIA EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H678",
        "valor": "OTITIS MEDIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H68 - INFLAMACION Y OBSTRUCCION DE LA TROMPA DE EUSTAQUIO",
    "detalle": [
      {
        "codigo": "H680",
        "valor": "SALPINGITIS EUSTAQUIANA"
      },
      {
        "codigo": "H681",
        "valor": "OBSTRUCCION DE LA TROMPA DE EUSTAQUIO"
      }
    ]
  },
  {
    "grupo": "H69 - OTROS TRASTORNOS DE LA TROMPA DE EUSTAQUIO",
    "detalle": [
      {
        "codigo": "H690",
        "valor": "DISTENSION DE LA TROMPA DE EUSTAQUIO"
      },
      {
        "codigo": "H698",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA TROMPA DE EUSTAQUIO"
      },
      {
        "codigo": "H699",
        "valor": "TRASTORNO DE LA TROMPA DE EUSTAQUIO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H70 - MASTOIDITIS Y AFECCIONES RELACIONADAS",
    "detalle": [
      {
        "codigo": "H700",
        "valor": "MASTOIDITIS AGUDA"
      },
      {
        "codigo": "H701",
        "valor": "MASTOIDITIS CRONICA"
      },
      {
        "codigo": "H702",
        "valor": "PETROSITIS"
      },
      {
        "codigo": "H708",
        "valor": "OTRAS MASTOIDITIS Y AFECCIONES RELACIONADAS"
      },
      {
        "codigo": "H709",
        "valor": "MASTOIDITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H71 - COLESTEATOMA DEL OIDO MEDIO",
    "detalle": [
      {
        "codigo": "H71X",
        "valor": "COLESTEATOMA DEL OIDO MEDIO"
      }
    ]
  },
  {
    "grupo": "H72 - PERFORACION DE LA MEMBRANA TIMPANICA",
    "detalle": [
      {
        "codigo": "H720",
        "valor": "PERFORACION CENTRAL DE LA MEMBRANA TIMPANICA"
      },
      {
        "codigo": "H721",
        "valor": "PERFORACION ATICA DE LA MEMBRANA TIMPANICA"
      },
      {
        "codigo": "H722",
        "valor": "OTRAS PERFORACIONES MARGINALES DE LA MEMBRANA TIMPANICA"
      },
      {
        "codigo": "H728",
        "valor": "OTRAS PERFORACIONES DE LA MEMBRANA TIMPANICA"
      },
      {
        "codigo": "H729",
        "valor": "PERFORACION DE LA MEMBRANA TIMPANICA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "H73 - OTROS TRASTORNOS DE LA MEMBRANA TIMPANICA",
    "detalle": [
      {
        "codigo": "H730",
        "valor": "MIRINGITIS AGUDA"
      },
      {
        "codigo": "H731",
        "valor": "MIRINGITIS CRONICA"
      },
      {
        "codigo": "H738",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA MEMBRANA TIMPANICA"
      },
      {
        "codigo": "H739",
        "valor": "TRASTORNO DE LA MEMBRANA TIMPANICA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H74 - OTROS TRASTORNOS DEL OIDO MEDIO Y DE LA APOFISIS MASTOIDES",
    "detalle": [
      {
        "codigo": "H740",
        "valor": "TIMPANOSCLEROSIS"
      },
      {
        "codigo": "H741",
        "valor": "ENFERMEDAD ADHESIVA DEL OIDO MEDIO"
      },
      {
        "codigo": "H742",
        "valor": "DISCONTINUIDAD Y DISLOCACION DE LOS HUESECILLOS DEL OIDO"
      },
      {
        "codigo": "H743",
        "valor": "OTRAS ANORMALIDADES ADQUIRIDAS DE LOS HUESECILLOS DEL OIDO"
      },
      {
        "codigo": "H744",
        "valor": "POLIPO DEL OIDO MEDIO"
      },
      {
        "codigo": "H748",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL OIDO MEDIO Y DE LA APOFISIS MASTOIDES"
      },
      {
        "codigo": "H749",
        "valor": "TRASTORNO DEL OIDO MEDIO Y DE LA APOFISIS MASTOIDES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H75 - OTROS TRASTORNOS DEL OIDO MEDIO Y DE LA APOFISIS MASTOIDES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H750",
        "valor": "MASTOIDITIS EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H758",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL OIDO MEDIO Y DE LA APOFISIS MASTOIDES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H80 - OTOSCLEROSIS",
    "detalle": [
      {
        "codigo": "H800",
        "valor": "OTOSCLEROSIS QUE AFECTA LA VENTANA OVAL, NO OBLITERANTE"
      },
      {
        "codigo": "H801",
        "valor": "OTOSCLEROSIS QUE AFECTA LA VENTANA OVAL, OBLITERANTE"
      },
      {
        "codigo": "H802",
        "valor": "OTOSCLEROSIS COCLEAR"
      },
      {
        "codigo": "H808",
        "valor": "OTRAS OTOSCLEROSIS"
      },
      {
        "codigo": "H809",
        "valor": "OTOSCLEROSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H81 - TRASTORNOS DE LA FUNCION VESTIBULAR",
    "detalle": [
      {
        "codigo": "H810",
        "valor": "ENFERMEDAD DE MENIERE"
      },
      {
        "codigo": "H811",
        "valor": "VERTIGO PAROXISTICO BENIGNO"
      },
      {
        "codigo": "H812",
        "valor": "NEURONITIS VESTIBULAR"
      },
      {
        "codigo": "H813",
        "valor": "OTROS VERTIGOS PERIFERICOS"
      },
      {
        "codigo": "H814",
        "valor": "VERTIGO DE ORIGEN CENTRAL"
      },
      {
        "codigo": "H818",
        "valor": "OTROS TRASTORNOS DE LA FUNCION VESTIBULAR"
      },
      {
        "codigo": "H819",
        "valor": "TRASTORNO DE LA FUNCION VESTIBULAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H82 - SINDROMES VERTIGINOSOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H82X",
        "valor": "SINDROMES VERTIGINOSOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H83 - OTROS TRASTORNOS DEL OIDO INTERNO",
    "detalle": [
      {
        "codigo": "H830",
        "valor": "LABERINTITIS"
      },
      {
        "codigo": "H831",
        "valor": "FISTULA DEL LABERINTO"
      },
      {
        "codigo": "H832",
        "valor": "DISFUNCION DEL LABERINTO"
      },
      {
        "codigo": "H833",
        "valor": "EFECTOS DEL RUIDO SOBRE EL OIDO INTERNO"
      },
      {
        "codigo": "H838",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL OIDO INTERNO"
      },
      {
        "codigo": "H839",
        "valor": "TRASTORNO DEL OIDO INTERNO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H90 - HIPOACUSIA CONDUCTIVA Y NEUROSENSORIAL",
    "detalle": [
      {
        "codigo": "H900",
        "valor": "HIPOACUSIA CONDUCTIVA BILATERAL"
      },
      {
        "codigo": "H901",
        "valor": "HIPOACUSIA CONDUCTIVA, UNILATERAL CON AUDICION IRRESTRICTA CONTRALATERAL"
      },
      {
        "codigo": "H902",
        "valor": "HIPOACUSIA CONDUCTIVA, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "H903",
        "valor": "HIPOACUSIA NEUROSENSORIAL, BILATERAL"
      },
      {
        "codigo": "H904",
        "valor": "HIPOACUSIA NEUROSENSORIAL, UNILATERAL CON AUDICION IRRESTRICTA CONTRALATERAL"
      },
      {
        "codigo": "H905",
        "valor": "HIPOACUSIA NEUROSENSORIAL, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "H906",
        "valor": "HIPOACUSIA MIXTA CONDUCTIVA Y NEUROSENSORIAL, BILATERAL"
      },
      {
        "codigo": "H907",
        "valor": "HIPOACUSIA MIXTA CONDUCTIVA Y NEUROSENSORIAL, UNILATERAL CON AUDICION IRRESTRICTA CONTRALATERAL"
      },
      {
        "codigo": "H908",
        "valor": "HIPOACUSIA MIXTA CONDUCTIVA Y NEUROSENSORIAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H91 - OTRAS HIPOACUSIAS",
    "detalle": [
      {
        "codigo": "H910",
        "valor": "HIPOACUSIA OTOTOXICA"
      },
      {
        "codigo": "H911",
        "valor": "PRESBIACUSIA"
      },
      {
        "codigo": "H912",
        "valor": "HIPOACUSIA SUBITA IDIOPATICA"
      },
      {
        "codigo": "H913",
        "valor": "SORDOMUDEZ, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "H918",
        "valor": "OTRAS HIPOACUSIAS ESPECIFICADAS"
      },
      {
        "codigo": "H919",
        "valor": "HIPOACUSIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "H92 - OTALGIA Y SECRECION DEL OIDO",
    "detalle": [
      {
        "codigo": "H920",
        "valor": "OTALGIA"
      },
      {
        "codigo": "H921",
        "valor": "OTORREA"
      },
      {
        "codigo": "H922",
        "valor": "OTORRAGIA"
      }
    ]
  },
  {
    "grupo": "H93 - OTROS TRASTORNOS DEL OIDO, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H930",
        "valor": "TRASTORNOS DEGENERATIVOS Y VASCULARES DEL OIDO"
      },
      {
        "codigo": "H931",
        "valor": "TINNITUS"
      },
      {
        "codigo": "H932",
        "valor": "OTRAS PERCEPCIONES AUDITIVAS ANORMALES"
      },
      {
        "codigo": "H933",
        "valor": "TRASTORNOS DEL NERVIO AUDITIVO"
      },
      {
        "codigo": "H938",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL OIDO"
      },
      {
        "codigo": "H939",
        "valor": "TRASTORNO DEL OIDO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "H94 - OTROS TRASTORNOS DEL OIDO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H940",
        "valor": "NEURITIS DEL NERVIO AUDITIVO EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "H948",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL OIDO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "H95 - TRASTORNOS DEL OIDO Y DE LA APOFISIS MASTOIDES CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "H950",
        "valor": "COLESTEATOMA RECURRENTE DE LA CAVIDAD RESULTANTE DE LA MASTOIDECTOMIA"
      },
      {
        "codigo": "H951",
        "valor": "OTROS TRASTORNOS POSTERIORES A LA MASTOIDECTOMIA"
      },
      {
        "codigo": "H958",
        "valor": "OTROS TRASTORNOS DEL OIDO Y DE LA APOFISIS MASTOIDES, CONSECUTIVOS A PROCEDIMIENTOS"
      },
      {
        "codigo": "H959",
        "valor": "TRASTORNOS NO ESPECIFICADOS DEL OIDO Y DE LA APOFISIS MASTOIDES, CONSECUTIVOS A PROCEDIMIENTOS"
      }
    ]
  },
  {
    "grupo": "I00 - FIEBRE REUMATICA SIN MENCION DE COMPLICACION CARDIACA",
    "detalle": [
      {
        "codigo": "I00X",
        "valor": "FIEBRE REUMATICA SIN MENCION DE COMPLICACION CARDIACA"
      }
    ]
  },
  {
    "grupo": "I01 - FIEBRE REUMATICA CON COMPLICACION CARDIACA",
    "detalle": [
      {
        "codigo": "I010",
        "valor": "PERICARDITIS REUMATICA AGUDA"
      },
      {
        "codigo": "I011",
        "valor": "ENDOCARDITIS REUMATICA AGUDA"
      },
      {
        "codigo": "I012",
        "valor": "MIOCARDITIS REUMATICA AGUDA"
      },
      {
        "codigo": "I018",
        "valor": "OTRAS ENFERMEDADES REUMATICAS AGUDAS DEL CORAZON"
      },
      {
        "codigo": "I019",
        "valor": "ENFERMEDAD REUMATICA AGUDA DEL CORAZON, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I02 - COREA REUMATICA",
    "detalle": [
      {
        "codigo": "I020",
        "valor": "COREA REUMATICA CON COMPLICACION CARDIACA"
      },
      {
        "codigo": "I029",
        "valor": "COREA REUMATICA SIN MENCION DE COMPLICACION CARDIACA"
      }
    ]
  },
  {
    "grupo": "I05 - ENFERMEDADES REUMATICAS DE LA VALVULA MITRAL",
    "detalle": [
      {
        "codigo": "I050",
        "valor": "ESTENOSIS MITRAL"
      },
      {
        "codigo": "I051",
        "valor": "INSUFICIENCIA MITRAL REUMATICA"
      },
      {
        "codigo": "I052",
        "valor": "ESTENOSIS MITRAL CON INSUFICIENCIA"
      },
      {
        "codigo": "I058",
        "valor": "OTRAS ENFERMEDADES DE LA VALVULA MITRAL"
      },
      {
        "codigo": "I059",
        "valor": "ENFERMEDAD VALVULAR MITRAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I06 - ENFERMEDADES REUMATICAS DE LA VALVULA AORTICA",
    "detalle": [
      {
        "codigo": "I060",
        "valor": "ESTENOSIS AORTICA REUMATICA"
      },
      {
        "codigo": "I061",
        "valor": "INSUFICIENCIA AORTICA REUMATICA"
      },
      {
        "codigo": "I062",
        "valor": "ESTENOSIS AORTICA REUMATICA CON INSUFICIENCIA"
      },
      {
        "codigo": "I068",
        "valor": "OTRAS ENFERMEDADES REUMATICAS DE LA VALVULA AORTICA"
      },
      {
        "codigo": "I069",
        "valor": "ENFERMEDAD VALVULAR AORTICA REUMATICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I07 - ENFERMEDADES REUMATICAS DE LA VALVULA TRICUSPIDE",
    "detalle": [
      {
        "codigo": "I070",
        "valor": "ESTENOSIS TRICUSPIDE"
      },
      {
        "codigo": "I071",
        "valor": "INSUFICIENCIA TRICUSPIDE"
      },
      {
        "codigo": "I072",
        "valor": "ESTENOSIS E INSUFICIENCIA TRICUSPIDE"
      },
      {
        "codigo": "I078",
        "valor": "OTRAS ENFERMEDADES DE LA VALVULA TRICUSPIDE"
      },
      {
        "codigo": "I079",
        "valor": "ENFERMEDAD DE LA VALVULA TRICUSPIDE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I08 - ENFERMEDADES VALVULARES MULTIPLES",
    "detalle": [
      {
        "codigo": "I080",
        "valor": "TRASTORNOS DE LAS VALVULAS MITRAL Y AORTICA"
      },
      {
        "codigo": "I081",
        "valor": "TRASTORNOS DE LAS VALVULAS MITRAL Y TRICUSPIDE"
      },
      {
        "codigo": "I082",
        "valor": "TRASTORNOS DE LAS VALVULAS AORTICA Y TRICUSPIDE"
      },
      {
        "codigo": "I083",
        "valor": "TRASTORNOS COMBINADOS DE LAS VALVULAS MITRAL, TRICUSPIDE Y AORTICA"
      },
      {
        "codigo": "I088",
        "valor": "OTRAS ENFERMEDADES DE MULTIPLES VALVULAS"
      },
      {
        "codigo": "I089",
        "valor": "ENFERMEDAD DE MULTIPLES VALVULAS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I09 - OTRAS ENFERMEDADES REUMATICAS DEL CORAZON",
    "detalle": [
      {
        "codigo": "I090",
        "valor": "MIOCARDITIS REUMATICA"
      },
      {
        "codigo": "I091",
        "valor": "ENFERMEDADES REUMATICAS DEL ENDOCARDIO, VALVULA NO ESPECIFICADA"
      },
      {
        "codigo": "I092",
        "valor": "PERICARDITIS REUMATICA CRONICA"
      },
      {
        "codigo": "I098",
        "valor": "OTRAS ENFERMEDADES REUMATICAS ESPECIFICADAS DEL CORAZON"
      },
      {
        "codigo": "I099",
        "valor": "ENFERMEDAD REUMATICA DEL CORAZON, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I10 - HIPERTENSION ESENCIAL (PRIMARIA)",
    "detalle": [
      {
        "codigo": "I10X",
        "valor": "HIPERTENSION ESENCIAL (PRIMARIA)"
      }
    ]
  },
  {
    "grupo": "I11 - ENFERMEDAD CARDIACA HIPERTENSIVA",
    "detalle": [
      {
        "codigo": "I110",
        "valor": "ENFERMEDAD CARDIACA HIPERTENSIVA CON INSUFICIENCIA CARDIACA (CONGESTIVA)"
      },
      {
        "codigo": "I119",
        "valor": "ENFERMEDAD CARDIACA HIPERTENSIVA SIN INSUFICIENCIA CARDIACA (CONGESTIVA)"
      }
    ]
  },
  {
    "grupo": "I12 - ENFERMEDAD RENAL HIPERTENSIVA",
    "detalle": [
      {
        "codigo": "I120",
        "valor": "ENFERMEDAD RENAL HIPERTENSIVA CON INSUFICIENCIA RENAL"
      },
      {
        "codigo": "I129",
        "valor": "ENFERMEDAD RENAL HIPERTENSIVA SIN INSUFICIENCIA RENAL"
      }
    ]
  },
  {
    "grupo": "I13 - ENFERMEDAD CARDIORRENAL HIPERTENSIVA",
    "detalle": [
      {
        "codigo": "I130",
        "valor": "ENFERMEDAD CARDIORRENAL HIPERTENSIVA CON INSUFICIENCIA CARDIACA (CONGESTIVA)"
      },
      {
        "codigo": "I131",
        "valor": "ENFERMEDAD CARDIORRENAL HIPERTENSIVA CON INSUFICIENCIA RENAL"
      },
      {
        "codigo": "I132",
        "valor": "ENFERMEDAD CARDIORRENAL HIPERTENSIVA CON INSUFICIENCIA CARDIACA (CONGESTIVA) E INSUFICIENCIA RENAL"
      },
      {
        "codigo": "I139",
        "valor": "ENFERMEDAD CARDIORRENAL HIPERTENSIVA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I15 - HIPERTENSION SECUNDARIA",
    "detalle": [
      {
        "codigo": "I150",
        "valor": "HIPERTENSION RENOVASCULAR"
      },
      {
        "codigo": "I151",
        "valor": "HIPERTENSION SECUNDARIA A OTROS TRASTORNOS RENALES"
      },
      {
        "codigo": "I152",
        "valor": "HIPERTENSION SECUNDARIA A TRASTORNOS ENDOCRINOS"
      },
      {
        "codigo": "I158",
        "valor": "OTROS TIPOS DE HIPERTENSION SECUNDARIA"
      },
      {
        "codigo": "I159",
        "valor": "HIPERTENSION SECUNDARIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I20 - ANGINA DE PECHO",
    "detalle": [
      {
        "codigo": "I200",
        "valor": "ANGINA INESTABLE"
      },
      {
        "codigo": "I201",
        "valor": "ANGINA DE PECHO CON ESPASMO DOCUMENTADO"
      },
      {
        "codigo": "I208",
        "valor": "OTRAS FORMAS ESPECIFICADAS DE ANGINA DE PECHO"
      },
      {
        "codigo": "I209",
        "valor": "ANGINA DE PECHO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I21 - INFARTO AGUDO DEL MIOCARDIO",
    "detalle": [
      {
        "codigo": "I210",
        "valor": "INFARTO TRANSMURAL AGUDO DEL MIOCARDIO DE LA PARED ANTERIOR"
      },
      {
        "codigo": "I211",
        "valor": "INFARTO TRANSMURAL AGUDO DEL MIOCARDIO DE LA PARED INFERIOR"
      },
      {
        "codigo": "I212",
        "valor": "INFARTO AGUDO TRANSMURAL DEL MIOCARDIO DE OTROS SITIOS"
      },
      {
        "codigo": "I213",
        "valor": "INFARTO TRANSMURAL AGUDO DEL MIOCARDIO, DE SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "I214",
        "valor": "INFARTO SUBENDOCARDICO AGUDO DEL MIOCARDIO"
      },
      {
        "codigo": "I219",
        "valor": "INFARTO AGUDO DEL MIOCARDIO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "I22 - INFARTO SUBSECUENTE DEL MIOCARDIO",
    "detalle": [
      {
        "codigo": "I220",
        "valor": "INFARTO SUBSECUENTE DEL MIOCARDIO DE LA PARED ANTERIOR"
      },
      {
        "codigo": "I221",
        "valor": "INFARTO SUBSECUENTE DEL MIOCARDIO DE LA PARED INFERIOR"
      },
      {
        "codigo": "I228",
        "valor": "INFARTO SUBSECUENTE DEL MIOCARDIO DE OTROS SITIOS"
      },
      {
        "codigo": "I229",
        "valor": "INFARTO SUBSECUENTE DEL MIOCARDIO, DE PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I23 - CIERTAS COMPLICACIONES PRESENTES POSTERIORES AL INFARTO AGUDO DEL MIOCARDIO",
    "detalle": [
      {
        "codigo": "I230",
        "valor": "HEMOPERICARDIO COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO AGUDO DEL MIOCARDIO"
      },
      {
        "codigo": "I231",
        "valor": "DEFECTO DEL TABIQUE AURICULAR COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO DEL MIOCARDIO"
      },
      {
        "codigo": "I232",
        "valor": "DEFECTO DEL TABIQUE VENTRICULAR COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO DEL MIOCARDIO"
      },
      {
        "codigo": "I233",
        "valor": "RUPTURA DE LA PARED CARDIACA SIN HEMOPERICARDIO COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO AGUDO DEL MIOCARDIO"
      },
      {
        "codigo": "I234",
        "valor": "RUPTURA DE LAS CUERDAS TENDINOSAS COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO AGUDO DEL MIOCARDIO"
      },
      {
        "codigo": "I235",
        "valor": "RUPTURA DE MUSCULO PAPILAR COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO AGUDO DEL MIOCARDIO"
      },
      {
        "codigo": "I236",
        "valor": "TROMBOSIS DE LA AURICULA, APENDICE AURICULAR Y VENTRICULO COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO AGUDO DEL MIOCARDIO"
      },
      {
        "codigo": "I238",
        "valor": "OTRAS COMPLICACIONES PRESENTES POSTERIORES AL INFARTO AGUDO DEL MIOCARDIO"
      }
    ]
  },
  {
    "grupo": "I24 - OTRAS ENFERMEDADES ISQUEMICAS AGUDAS DEL CORAZON",
    "detalle": [
      {
        "codigo": "I240",
        "valor": "TROMBOSIS CORONARIA QUE NO RESULTA EN INFARTO DEL MIOCARDIO"
      },
      {
        "codigo": "I241",
        "valor": "SINDROME DE DRESSLER"
      },
      {
        "codigo": "I248",
        "valor": "OTRAS FORMAS DE ENFERMEDAD ISQUEMICA AGUDA DEL CORAZON"
      },
      {
        "codigo": "I249",
        "valor": "ENFERMEDAD ISQUEMICA AGUDA DEL CORAZON, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I25 - ENFERMEDAD ISQUEMICA CRONICA DEL CORAZON",
    "detalle": [
      {
        "codigo": "I250",
        "valor": "ENFERMEDAD CARDIOVASCULAR ATEROSCLEROTICA, ASI DESCRITA"
      },
      {
        "codigo": "I251",
        "valor": "ENFERMEDAD ATEROSCLEROTICA DEL CORAZON"
      },
      {
        "codigo": "I252",
        "valor": "INFARTO ANTIGUO DEL MIOCARDIO"
      },
      {
        "codigo": "I253",
        "valor": "ANEURISMA CARDIACO"
      },
      {
        "codigo": "I254",
        "valor": "ANEURISMA DE ARTERIA CORONARIA"
      },
      {
        "codigo": "I255",
        "valor": "CARDIOMIOPATIA ISQUEMICA"
      },
      {
        "codigo": "I256",
        "valor": "ISQUEMIA SILENTE DEL MIOCARDIO"
      },
      {
        "codigo": "I258",
        "valor": "OTRAS FORMAS DE ENFERMEDAD ISQUEMICA CRONICA DEL CORAZON"
      },
      {
        "codigo": "I259",
        "valor": "ENFERMEDAD ISQUEMICA CRONICA DEL CORAZON, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I26 - EMBOLIA PULMONAR",
    "detalle": [
      {
        "codigo": "I260",
        "valor": "EMBOLIA PULMONAR CON MENCION DE CORAZON PULMONAR AGUDO"
      },
      {
        "codigo": "I269",
        "valor": "EMBOLIA PULMONAR SIN MENCION DE CORAZON PULMONAR AGUDO"
      }
    ]
  },
  {
    "grupo": "I27 - OTRAS ENFERMEDADES CARDIOPULMONARES",
    "detalle": [
      {
        "codigo": "I270",
        "valor": "HIPERTENSION PULMONAR PRIMARIA"
      },
      {
        "codigo": "I271",
        "valor": "ENFERMEDAD CIFOSCOLIOTICA DEL CORAZON"
      },
      {
        "codigo": "I272",
        "valor": "OTRAS HIPERTENSIONES PULMONARES SECUNDARIAS"
      },
      {
        "codigo": "I278",
        "valor": "OTRAS ENFERMEDADES CARDIOPULMONARES ESPECIFICADAS"
      },
      {
        "codigo": "I279",
        "valor": "ENFERMEDAD PULMONAR DEL CORAZON, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I28 - OTRAS ENFERMEDADES DE LOS VASOS PULMONARES",
    "detalle": [
      {
        "codigo": "I280",
        "valor": "FISTULA ARTERIOVENOSA DE LOS VASOS PULMONARES"
      },
      {
        "codigo": "I281",
        "valor": "ANEURISMA DE LA ARTERIA PULMONAR"
      },
      {
        "codigo": "I288",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DE LOS VASOS PULMONARES"
      },
      {
        "codigo": "I289",
        "valor": "ENFERMEDAD DE LOS VASOS PULMONARES, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I30 - PERICARDITIS AGUDA",
    "detalle": [
      {
        "codigo": "I300",
        "valor": "PERICARDITIS IDIOPATICA AGUDA INESPECIFICA"
      },
      {
        "codigo": "I301",
        "valor": "PERICARDITIS INFECCIOSA"
      },
      {
        "codigo": "I308",
        "valor": "OTRAS FORMAS DE PERICARDITIS AGUDA"
      },
      {
        "codigo": "I309",
        "valor": "PERICARDITIS AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I31 - OTRAS ENFERMEDADES DEL PERICARDIO",
    "detalle": [
      {
        "codigo": "I310",
        "valor": "PERICARDITIS CRONICA ADHESIVA"
      },
      {
        "codigo": "I311",
        "valor": "PERICARDITIS CONSTRICTIVA CRONICA"
      },
      {
        "codigo": "I312",
        "valor": "HEMOPERICARDIO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "I313",
        "valor": "DERRAME PERICARDICO (NO INFLAMATORIO)"
      },
      {
        "codigo": "I318",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DEL PERICARDIO"
      },
      {
        "codigo": "I319",
        "valor": "ENFERMEDAD DEL PERICARDIO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I32 - PERICARDITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "I320",
        "valor": "PERICARDITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I321",
        "valor": "PERICARDITIS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I328",
        "valor": "PERICARDITIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRAS PARTE"
      }
    ]
  },
  {
    "grupo": "I33 - ENDOCARDITIS AGUDA Y SUBAGUDA",
    "detalle": [
      {
        "codigo": "I330",
        "valor": "ENDOCARDITIS INFECCIOSA AGUDA Y SUBAGUDA"
      },
      {
        "codigo": "I339",
        "valor": "ENDOCARDITIS AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I34 - TRASTORNOS NO REUMATICOS DE LA VALVULA MITRAL",
    "detalle": [
      {
        "codigo": "I340",
        "valor": "INSUFICIENCIA (DE LA VALVULA) MITRAL"
      },
      {
        "codigo": "I341",
        "valor": "PROLAPSO (DE LA VALVULA) MITRAL"
      },
      {
        "codigo": "I342",
        "valor": "ESTENOSIS (DE LA VALVULA) MITRAL, NO REUMATICA"
      },
      {
        "codigo": "I348",
        "valor": "OTROS TRASTORNOS NO REUMATICOS DE LA VALVULA MITRAL"
      },
      {
        "codigo": "I349",
        "valor": "TRASTORNO MITRAL NO REUMATICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I35 - TRASTORNOS NO REUMATICOS DE LA VALVULA AORTICA",
    "detalle": [
      {
        "codigo": "I350",
        "valor": "ESTENOSIS (DE LA VALVULA) AORTICA"
      },
      {
        "codigo": "I351",
        "valor": "INSUFICIENCIA (DE LA VALVULA) AORTICA"
      },
      {
        "codigo": "I352",
        "valor": "ESTENOSIS (DE LA VALVULA) AORTICA CON INSUFICIENCIA"
      },
      {
        "codigo": "I358",
        "valor": "OTROS TRASTORNOS DE LA VALVULA AORTICA"
      },
      {
        "codigo": "I359",
        "valor": "TRASTORNO DE LA VALVULA AORTICA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I36 - TRASTORNOS NO REUMATICOS DE LA VALVULA TRICUSPIDE",
    "detalle": [
      {
        "codigo": "I360",
        "valor": "ESTENOSIS NO REUMATICA (DE LA VALVULA) TRICUSPIDE"
      },
      {
        "codigo": "I361",
        "valor": "INSUFICIENCIA NO REUMATICA (DE LA VALVULA) TRICUSPIDE"
      },
      {
        "codigo": "I362",
        "valor": "ESTENOSIS CON INSUFICIENCIA NO REUMATICA (DE LA VALVULA) TRICUSPIDE"
      },
      {
        "codigo": "I368",
        "valor": "OTROS TRASTORNOS NO REUMATICOS DE LA VALVULA TRICUSPIDE"
      },
      {
        "codigo": "I369",
        "valor": "TRASTORNO NO REUMATICO DE LA VALVULA TRICUSPIDE, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I37 - TRASTORNOS DE LA VALVULA PULMONAR",
    "detalle": [
      {
        "codigo": "I370",
        "valor": "ESTENOSIS DE LA VALVULA PULMONAR"
      },
      {
        "codigo": "I371",
        "valor": "INSUFICIENCIA DE LA VALVULA PULMONAR"
      },
      {
        "codigo": "I372",
        "valor": "ESTENOSIS DE LA VALVULA PULMONAR CON INSUFICIENCIA"
      },
      {
        "codigo": "I378",
        "valor": "OTROS TRASTORNOS DE LA VALVULA PULMONAR"
      },
      {
        "codigo": "I379",
        "valor": "TRASTORNO DE LA VALVULA PULMONAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I38 - ENDOCARDITIS, VALVULA NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "I38X",
        "valor": "ENDOCARDITIS, VALVULA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I39 - ENDOCARDITIS Y TRASTORNOS VALVULARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "I390",
        "valor": "TRASTORNOS DE LA VALVULA MITRAL EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I391",
        "valor": "TRASTORNOS DE LA VALVULA AORTICA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I392",
        "valor": "TRASTORNOS DE LA VALVULA TRICUSPIDE EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I393",
        "valor": "TRASTORNOS DE LA VALVULA PULMONAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I394",
        "valor": "TRASTORNOS VALVULARES MULTIPLES EN ENFERMEDADES CLASIFICADAS EN OTRAS PARTE"
      },
      {
        "codigo": "I398",
        "valor": "ENDOCARDITIS, VALVULA NO ESPECIFICADA, EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "I40 - MIOCARDITIS AGUDA",
    "detalle": [
      {
        "codigo": "I400",
        "valor": "MIOCARDITIS INFECCIOSA"
      },
      {
        "codigo": "I401",
        "valor": "MIOCARDITIS AISLADA"
      },
      {
        "codigo": "I408",
        "valor": "OTRAS MIOCARDITIS AGUDAS"
      },
      {
        "codigo": "I409",
        "valor": "MIOCARDITIS AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I41 - MIOCARDITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "I410",
        "valor": "MIOCARDITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I411",
        "valor": "MIOCARDITIS EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I412",
        "valor": "MIOCARDITIS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I418",
        "valor": "MIOCARDITIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "I42 - CARDIOMIOPATIA",
    "detalle": [
      {
        "codigo": "I420",
        "valor": "CARDIOMIOPATIA DILATADA"
      },
      {
        "codigo": "I421",
        "valor": "CARDIOMIOPATIA HIPERTROFICA OBSTRUCTIVA"
      },
      {
        "codigo": "I422",
        "valor": "OTRAS CARDIOMIOPATIAS HIPERTROFICAS"
      },
      {
        "codigo": "I423",
        "valor": "ENFERMEDAD ENDOMIOCARDICA (EOSINOFILICA)"
      },
      {
        "codigo": "I424",
        "valor": "FIBROELASTOSIS ENDOCARDICA"
      },
      {
        "codigo": "I425",
        "valor": "OTRAS CARDIOMIOPATIAS RESTRICTIVAS"
      },
      {
        "codigo": "I426",
        "valor": "CARDIOMIOPATIA ALCOHOLICA"
      },
      {
        "codigo": "I427",
        "valor": "CARDIOMIOPATIA DEBIDA A DROGAS Y OTROS AGENTES EXTERNOS"
      },
      {
        "codigo": "I428",
        "valor": "OTRAS CARDIOMIOPATIAS"
      },
      {
        "codigo": "I429",
        "valor": "CARDIOMIOPATIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I43 - CARDIOMIOPATIA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "I430",
        "valor": "CARDIOMIOPATIA EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I431",
        "valor": "CARDIOMIOPATIA EN ENFERMEDADES METABOLICAS"
      },
      {
        "codigo": "I432",
        "valor": "CARDIOMIOPATIA EN ENFERMEDADES NUTRICIONALES"
      },
      {
        "codigo": "I438",
        "valor": "CARDIOMIOPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "I44 - BLOQUEO AURICULOVENTRICULAR Y DE RAMA IZQUIERDA DEL HAZ",
    "detalle": [
      {
        "codigo": "I440",
        "valor": "BLOQUEO AURICULOVENTRICULAR DE PRIMER GRADO"
      },
      {
        "codigo": "I441",
        "valor": "BLOQUEO AURICULOVENTRICULAR DE SEGUNDO GRADO"
      },
      {
        "codigo": "I442",
        "valor": "BLOQUEO AURICULOVENTRICULAR COMPLETO"
      },
      {
        "codigo": "I443",
        "valor": "OTROS TIPOS DE BLOQUEO AURICULOVENTRICULAR Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "I444",
        "valor": "BLOQUEO FASCICULAR ANTERIOR IZQUIERDO"
      },
      {
        "codigo": "I445",
        "valor": "BLOQUEO FASCICULAR POSTERIOR IZQUIERDO"
      },
      {
        "codigo": "I446",
        "valor": "OTROS TIPOS DE BLOQUEO FASCICULAR Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "I447",
        "valor": "BLOQUEO DE RAMA IZQUIERDA DEL HAZ, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "I45 - OTROS TRASTORNOS DE LA CONDUCCION",
    "detalle": [
      {
        "codigo": "I450",
        "valor": "BLOQUEO FASCICULAR DERECHO"
      },
      {
        "codigo": "I451",
        "valor": "OTROS TIPOS DE BLOQUEO DE RAMA DERECHA DEL HAZ Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "I452",
        "valor": "BLOQUEO BIFASCICULAR"
      },
      {
        "codigo": "I453",
        "valor": "BLOQUEO TRIFASCICULAR"
      },
      {
        "codigo": "I454",
        "valor": "BLOQUEO INTRAVENTRICULAR NO ESPECIFICADO"
      },
      {
        "codigo": "I455",
        "valor": "OTROS TIPOS ESPECIFICADOS DE BLOQUEO DEL CORAZON"
      },
      {
        "codigo": "I456",
        "valor": "SINDROME DE PREEXCITACION"
      },
      {
        "codigo": "I458",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA CONDUCCION"
      },
      {
        "codigo": "I459",
        "valor": "TRASTORNO DE LA CONDUCCION, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I46 - PARO CARDIACO",
    "detalle": [
      {
        "codigo": "I460",
        "valor": "PARO CARDIACO CON RESUCITACION EXITOSA"
      },
      {
        "codigo": "I461",
        "valor": "MUERTE CARDIACA SUBITA, ASI DESCRITA"
      },
      {
        "codigo": "I469",
        "valor": "PARO CARDIACO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I47 - TAQUICARDIA PAROXISTICA",
    "detalle": [
      {
        "codigo": "I470",
        "valor": "ARRITMIA POR REENTRADA VENTRICULAR"
      },
      {
        "codigo": "I471",
        "valor": "TAQUICARDIA SUPRAVENTRICULAR"
      },
      {
        "codigo": "I472",
        "valor": "TAQUICARDIA VENTRICULAR"
      },
      {
        "codigo": "I479",
        "valor": "TAQUICARDIA PAROXISTICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I48 - FIBRILACION Y ALETEO AURICULAR",
    "detalle": [
      {
        "codigo": "I480",
        "valor": "FIBRILACION AURICULAR PAROXISTICA"
      },
      {
        "codigo": "I481",
        "valor": "FIBRILACION AURICULAR PERSISTENTE"
      },
      {
        "codigo": "I482",
        "valor": "FIBRILACION AURICULAR CRONICA"
      },
      {
        "codigo": "I483",
        "valor": "ALETEO AURICULAR TIPICO"
      },
      {
        "codigo": "I484",
        "valor": "ALETEO AURICULAR ATIPICO"
      },
      {
        "codigo": "I489",
        "valor": "FIBRILACION Y ALETEO AURICULAR, NO ESPECIFICADO"
      },
      {
        "codigo": "I48X",
        "valor": "FIBRILACION Y ALETEO AURICULAR"
      }
    ]
  },
  {
    "grupo": "I49 - OTRAS ARRITMIAS CARDIACAS",
    "detalle": [
      {
        "codigo": "I490",
        "valor": "FIBRILACION Y ALETEO VENTRICULAR"
      },
      {
        "codigo": "I491",
        "valor": "DESPOLARIZACION AURICULAR PREMATURA"
      },
      {
        "codigo": "I492",
        "valor": "DESPOLARIZACION PREMATURA NODAL"
      },
      {
        "codigo": "I493",
        "valor": "DESPOLARIZACION VENTRICULAR PREMATURA"
      },
      {
        "codigo": "I494",
        "valor": "OTROS TIPOS DE DESPOLARIZACION PREMATURA Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "I495",
        "valor": "SINDROME DEL SENO ENFERMO"
      },
      {
        "codigo": "I498",
        "valor": "OTRAS ARRITMIAS CARDIACAS ESPECIFICADAS"
      },
      {
        "codigo": "I499",
        "valor": "ARRITMIA CARDIACA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I50 - INSUFICIENCIA CARDIACA",
    "detalle": [
      {
        "codigo": "I500",
        "valor": "INSUFICIENCIA CARDIACA CONGESTIVA"
      },
      {
        "codigo": "I501",
        "valor": "INSUFICIENCIA VENTRICULAR IZQUIERDA"
      },
      {
        "codigo": "I509",
        "valor": "INSUFICIENCIA CARDIACA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I51 - COMPLICACIONES Y DESCRIPCIONES MAL DEFINIDAS DE ENFERMEDAD CARDIACA",
    "detalle": [
      {
        "codigo": "I510",
        "valor": "DEFECTO DEL TABIQUE CARDIACO, ADQUIRIDO"
      },
      {
        "codigo": "I511",
        "valor": "RUPTURA DE CUERDA TENDINOSA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "I512",
        "valor": "RUPTURA DE MUSCULO PAPILAR, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "I513",
        "valor": "TROMBOSIS INTRACARDIACA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "I514",
        "valor": "MIOCARDITIS, NO ESPECIFICADA"
      },
      {
        "codigo": "I515",
        "valor": "DEGENERACION MIOCARDICA"
      },
      {
        "codigo": "I516",
        "valor": "ENFERMEDAD CARDIOVASCULAR, NO ESPECIFICADA"
      },
      {
        "codigo": "I517",
        "valor": "CARDIOMEGALIA"
      },
      {
        "codigo": "I518",
        "valor": "OTRAS ENFERMEDADES CARDIACAS MAL DEFINIDAS"
      },
      {
        "codigo": "I519",
        "valor": "ENFERMEDAD CARDIACA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I52 - OTROS TRASTORNOS CARDIACOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "I520",
        "valor": "OTROS TRASTORNOS CARDIACOS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I521",
        "valor": "OTROS TRASTORNOS CARDIACOS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I528",
        "valor": "OTROS TRASTORNOS CARDIACOS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "I60 - HEMORRAGIA SUBARACNOIDEA",
    "detalle": [
      {
        "codigo": "I600",
        "valor": "HEMORRAGIA SUBARACNOIDEA DE SIFON Y BIFURCACION CAROTIDEA"
      },
      {
        "codigo": "I601",
        "valor": "HEMORRAGIA SUBARACNOIDEA DE ARTERIA CEREBRAL MEDIA"
      },
      {
        "codigo": "I602",
        "valor": "HEMORRAGIA SUBARACNOIDEA DE ARTERIA COMUNICANTE ANTERIOR"
      },
      {
        "codigo": "I603",
        "valor": "HEMORRAGIA SUBARACNOIDEA DE ARTERIA COMUNICANTE POSTERIOR"
      },
      {
        "codigo": "I604",
        "valor": "HEMORRAGIA SUBARACNOIDEA DE ARTERIA BASILAR"
      },
      {
        "codigo": "I605",
        "valor": "HEMORRAGIA SUBARACNOIDEA DE ARTERIA VERTEBRAL"
      },
      {
        "codigo": "I606",
        "valor": "HEMORRAGIA SUBARACNOIDEA DE OTRAS ARTERIAS INTRACRANEALES"
      },
      {
        "codigo": "I607",
        "valor": "HEMORRAGIA SUBARACNOIDEA DE ARTERIA INTRACRANEAL NO ESPECIFICADA"
      },
      {
        "codigo": "I608",
        "valor": "OTRAS HEMORRAGIAS SUBARACNOIDEAS"
      },
      {
        "codigo": "I609",
        "valor": "HEMORRAGIA SUBARACNOIDEA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I61 - HEMORRAGIA INTRAENCEFALICA",
    "detalle": [
      {
        "codigo": "I610",
        "valor": "HEMORRAGIA INTRACEREBRAL EN HEMISFERIO, SUBCORTICAL"
      },
      {
        "codigo": "I611",
        "valor": "HEMORRAGIA INTRACEREBRAL EN HEMISFERIO, CORTICAL"
      },
      {
        "codigo": "I612",
        "valor": "HEMORRAGIA INTRACEREBRAL EN HEMISFERIO, NO ESPECIFICADA"
      },
      {
        "codigo": "I613",
        "valor": "HEMORRAGIA INTRAENCEFALICA EN TALLO CEREBRAL"
      },
      {
        "codigo": "I614",
        "valor": "HEMORRAGIA INTRAENCEFALICA EN CEREBELO"
      },
      {
        "codigo": "I615",
        "valor": "HEMORRAGIA INTRAENCEFALICA, INTRAVENTRICULAR"
      },
      {
        "codigo": "I616",
        "valor": "HEMORRAGIA INTRAENCEFALICA DE LOCALIZACIONES MULTIPLES"
      },
      {
        "codigo": "I618",
        "valor": "OTRAS HEMORRAGIAS INTRAENCEFALICAS"
      },
      {
        "codigo": "I619",
        "valor": "HEMORRAGIA INTRAENCEFALICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I62 - OTRAS HEMORRAGIAS INTRACRANEALES NO TRAUMATICAS",
    "detalle": [
      {
        "codigo": "I620",
        "valor": "HEMORRAGIA SUBDURAL (AGUDA) (NO TRAUMATICA)"
      },
      {
        "codigo": "I621",
        "valor": "HEMORRAGIA EXTRADURAL NO TRAUMATICA"
      },
      {
        "codigo": "I629",
        "valor": "HEMORRAGIA INTRACRANEAL (NO TRAUMATICA), NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I63 - INFARTO CEREBRAL",
    "detalle": [
      {
        "codigo": "I630",
        "valor": "INFARTO CEREBRAL DEBIDO A TROMBOSIS DE ARTERIAS PRECEREBRALES"
      },
      {
        "codigo": "I631",
        "valor": "INFARTO CEREBRAL DEBIDO A EMBOLIA DE ARTERIAS PRECEREBRALES"
      },
      {
        "codigo": "I632",
        "valor": "INFARTO CEREBRAL DEBIDO A OCLUSION O ESTENOSIS NO ESPECIFICADA DE ARTERIAS PRECEREBRALES"
      },
      {
        "codigo": "I633",
        "valor": "INFARTO CEREBRAL DEBIDO A TROMBOSIS DE ARTERIAS CEREBRALES"
      },
      {
        "codigo": "I634",
        "valor": "INFARTO CEREBRAL DEBIDO A EMBOLIA DE ARTERIAS CEREBRALES"
      },
      {
        "codigo": "I635",
        "valor": "INFARTO CEREBRAL DEBIDO A OCLUSION O ESTENOSIS NO ESPECIFICADA DE ARTERIAS CEREBRALES"
      },
      {
        "codigo": "I636",
        "valor": "INFARTO CEREBRAL DEBIDO A TROMBOSIS DE VENAS CEREBRALES, NO PIOGENO"
      },
      {
        "codigo": "I638",
        "valor": "OTROS INFARTOS CEREBRALES"
      },
      {
        "codigo": "I639",
        "valor": "INFARTO CEREBRAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I64 - ACCIDENTE VASCULAR ENCEFALICO AGUDO, NO ESPECIFICADO COMO HEMORRAGICO O ISQUEMICO",
    "detalle": [
      {
        "codigo": "I64X",
        "valor": "ACCIDENTE VASCULAR ENCEFALICO AGUDO, NO ESPECIFICADO COMO HEMORRAGICO O ISQUEMICO"
      }
    ]
  },
  {
    "grupo": "I65 - OCLUSION Y ESTENOSIS DE LAS ARTERIAS PRECEREBRALES SIN OCASIONAR INFARTO CEREBRAL",
    "detalle": [
      {
        "codigo": "I650",
        "valor": "OCLUSION Y ESTENOSIS DE ARTERIA VERTEBRAL"
      },
      {
        "codigo": "I651",
        "valor": "OCLUSION Y ESTENOSIS DE ARTERIA BASILAR"
      },
      {
        "codigo": "I652",
        "valor": "OCLUSION Y ESTENOSIS DE ARTERIA CAROTIDA"
      },
      {
        "codigo": "I653",
        "valor": "OCLUSION Y ESTENOSIS MULTIPLE BILATERAL DE ARTERIAS PRECEREBRALES"
      },
      {
        "codigo": "I658",
        "valor": "OCLUSION Y ESTENOSIS DE OTRAS ARTERIAS PRECEREBRALES"
      },
      {
        "codigo": "I659",
        "valor": "OCLUSION Y ESTENOSIS DE ARTERIA PRECEREBRAL NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I66 - OCLUSION Y ESTENOSIS DE LAS ARTERIAS CEREBRALES SIN OCASIONAR INFARTO",
    "detalle": [
      {
        "codigo": "I660",
        "valor": "OCLUSION Y ESTENOSIS DE LA ARTERIA CEREBRAL MEDIA"
      },
      {
        "codigo": "I661",
        "valor": "OCLUSION Y ESTENOSIS DE LA ARTERIA CEREBRAL ANTERIOR"
      },
      {
        "codigo": "I662",
        "valor": "OCLUSION Y ESTENOSIS DE LA ARTERIA CEREBRAL POSTERIOR"
      },
      {
        "codigo": "I663",
        "valor": "OCLUSION Y ESTENOSIS DE ARTERIAS CEREBELOSAS"
      },
      {
        "codigo": "I664",
        "valor": "OCLUSION Y ESTENOSIS MULTIPLE BILATERAL DE ARTERIAS CEREBRALES"
      },
      {
        "codigo": "I668",
        "valor": "OCLUSION Y ESTENOSIS DE OTRAS ARTERIAS CEREBRALES"
      },
      {
        "codigo": "I669",
        "valor": "OCLUSION Y ESTENOSIS DE ARTERIA CEREBRAL NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I67 - OTRAS ENFERMEDADES CEREBROVASCULARES",
    "detalle": [
      {
        "codigo": "I670",
        "valor": "DISECCION DE ARTERIAS CEREBRALES, SIN RUPTURA"
      },
      {
        "codigo": "I671",
        "valor": "ANEURISMA CEREBRAL, SIN RUPTURA"
      },
      {
        "codigo": "I672",
        "valor": "ATEROSCLEROSIS CEREBRAL"
      },
      {
        "codigo": "I673",
        "valor": "LEUCOENCEFALOPATIA VASCULAR PROGRESIVA"
      },
      {
        "codigo": "I674",
        "valor": "ENCEFALOPATIA HIPERTENSIVA"
      },
      {
        "codigo": "I675",
        "valor": "ENFERMEDAD DE MOYAMOYA"
      },
      {
        "codigo": "I676",
        "valor": "TROMBOSIS APIOGENA DEL SISTEMA VENOSO INTRACRANEAL"
      },
      {
        "codigo": "I677",
        "valor": "ARTERITIS CEREBRAL, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "I678",
        "valor": "OTRAS ENFERMEDADES CEREBROVASCULARES ESPECIFICADAS"
      },
      {
        "codigo": "I679",
        "valor": "ENFERMEDAD CEREBROVASCULAR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I68 - TRASTORNOS CEREBROVASCULARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "I680",
        "valor": "ANGIOPATIA CEREBRAL AMILOIDE"
      },
      {
        "codigo": "I681",
        "valor": "ARTERITIS CEREBRAL EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I682",
        "valor": "ARTERITIS CEREBRAL EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I688",
        "valor": "OTROS TRASTORNOS CEREBROVASCULARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "I69 - SECUELAS DE ENFERMEDAD CEREBROVASCULAR",
    "detalle": [
      {
        "codigo": "I690",
        "valor": "SECUELAS DE HEMORRAGIA SUBARACNOIDEA"
      },
      {
        "codigo": "I691",
        "valor": "SECUELAS DE HEMORRAGIA INTRAENCEFALICA"
      },
      {
        "codigo": "I692",
        "valor": "SECUELAS DE OTRAS HEMORRAGIAS INTRACRANEALES NO TRAUMATICAS"
      },
      {
        "codigo": "I693",
        "valor": "SECUELAS DE INFARTO CEREBRAL"
      },
      {
        "codigo": "I694",
        "valor": "SECUELAS DE ACCIDENTE VASCULAR ENCEFALICO, NO ESPECIFICADO COMO HEMORRAGICO O ISQUEMICO"
      },
      {
        "codigo": "I698",
        "valor": "SECUELAS DE OTRAS ENFERMEDADES CEREBROVASCULARES Y DE LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "I70 - ATEROSCLEROSIS",
    "detalle": [
      {
        "codigo": "I700",
        "valor": "ATEROSCLEROSIS DE LA AORTA"
      },
      {
        "codigo": "I701",
        "valor": "ATEROSCLEROSIS DE LA ARTERIA RENAL"
      },
      {
        "codigo": "I702",
        "valor": "ATEROSCLEROSIS DE LAS ARTERIAS DE LOS MIEMBROS"
      },
      {
        "codigo": "I708",
        "valor": "ATEROSCLEROSIS DE OTRAS ARTERIAS"
      },
      {
        "codigo": "I709",
        "valor": "ATEROSCLEROSIS GENERALIZADA Y LA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I71 - ANEURISMA Y DISECCION AORTICOS",
    "detalle": [
      {
        "codigo": "I710",
        "valor": "DISECCION DE AORTA (CUALQUIER PARTE)"
      },
      {
        "codigo": "I711",
        "valor": "RUPTURA DE ANEURISMA DE LA AORTA TORACICA"
      },
      {
        "codigo": "I712",
        "valor": "ANEURISMA DE LA AORTA TORACICA, SIN MENCION DE RUPTURA"
      },
      {
        "codigo": "I713",
        "valor": "RUPTURA DE ANEURISMA DE LA AORTA ABDOMINAL"
      },
      {
        "codigo": "I714",
        "valor": "ANEURISMA DE LA AORTA ABDOMINAL, SIN MENCION DE RUPTURA"
      },
      {
        "codigo": "I715",
        "valor": "RUPTURA DE ANEURISMA DE LA AORTA TORACOABDOMINAL"
      },
      {
        "codigo": "I716",
        "valor": "ANEURISMA DE LA AORTA TORACOABDOMINAL, SIN MENCION DE RUPTURA"
      },
      {
        "codigo": "I718",
        "valor": "RUPTURA DE ANEURISMA AORTICO, SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "I719",
        "valor": "ANEURISMA DE LA AORTA, SITIO NO ESPECIFICADO, SIN MENCION DE RUPTURA"
      }
    ]
  },
  {
    "grupo": "I72 - OTROS ANEURISMAS Y DISECCIONES",
    "detalle": [
      {
        "codigo": "I720",
        "valor": "ANEURISMA Y DISECCION DE LA ARTERIA CAROTIDA"
      },
      {
        "codigo": "I721",
        "valor": "ANEURISMA Y DISECCION DE ARTERIA DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "I722",
        "valor": "ANEURISMA Y DISECCION DE ARTERIA RENAL"
      },
      {
        "codigo": "I723",
        "valor": "ANEURISMA Y DISECCION DE ARTERIA ILIACA"
      },
      {
        "codigo": "I724",
        "valor": "ANEURISMA Y DISECCION DE ARTERIA DEL MIEMBRO INFERIOR"
      },
      {
        "codigo": "I725",
        "valor": "ANEURISMA Y DISECCION DE OTRAS ARTERIAS PRECEREBRALES"
      },
      {
        "codigo": "I726",
        "valor": "ANEURISMA Y DISECCION DE ARTERIA VERTEBRAL"
      },
      {
        "codigo": "I728",
        "valor": "ANEURISMA Y DISECCION DE OTRAS ARTERIAS ESPECIFICADAS"
      },
      {
        "codigo": "I729",
        "valor": "ANEURISMA Y DISECCION DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I73 - OTRAS ENFERMEDADES VASCULARES PERIFERICAS",
    "detalle": [
      {
        "codigo": "I730",
        "valor": "SINDROME DE RAYNAUD"
      },
      {
        "codigo": "I731",
        "valor": "TROMBOANGEITIS OBLITERANTE [BUERGER]"
      },
      {
        "codigo": "I738",
        "valor": "OTRAS ENFERMEDADES VASCULARES PERIFERICAS ESPECIFICADAS"
      },
      {
        "codigo": "I739",
        "valor": "ENFERMEDAD VASCULAR PERIFERICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I74 - EMBOLIA Y TROMBOSIS ARTERIALES",
    "detalle": [
      {
        "codigo": "I740",
        "valor": "EMBOLIA Y TROMBOSIS DE LA AORTA ABDOMINAL"
      },
      {
        "codigo": "I741",
        "valor": "EMBOLIA Y TROMBOSIS DE OTRAS PORCIONES Y LAS NO ESPECIFICADAS DE LA AORTA"
      },
      {
        "codigo": "I742",
        "valor": "EMBOLIA Y TROMBOSIS DE ARTERIAS DE LOS MIEMBROS SUPERIORES"
      },
      {
        "codigo": "I743",
        "valor": "EMBOLIA Y TROMBOSIS DE ARTERIAS DE LOS MIEMBROS INFERIORES"
      },
      {
        "codigo": "I744",
        "valor": "EMBOLIA Y TROMBOSIS DE ARTERIAS DE LOS MIEMBROS, NO ESPECIFICADAS"
      },
      {
        "codigo": "I745",
        "valor": "EMBOLIA Y TROMBOSIS DE ARTERIA ILIACA"
      },
      {
        "codigo": "I748",
        "valor": "EMBOLIA Y TROMBOSIS DE OTRAS ARTERIAS"
      },
      {
        "codigo": "I749",
        "valor": "EMBOLIA Y TROMBOSIS DE ARTERIA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I77 - OTROS TRASTORNOS ARTERIALES O ARTERIOLARES",
    "detalle": [
      {
        "codigo": "I770",
        "valor": "FISTULA ARTERIOVENOSA, ADQUIRIDA"
      },
      {
        "codigo": "I771",
        "valor": "ESTRECHEZ ARTERIAL"
      },
      {
        "codigo": "I772",
        "valor": "RUPTURA ARTERIAL"
      },
      {
        "codigo": "I773",
        "valor": "DISPLASIA FIBROMUSCULAR ARTERIAL"
      },
      {
        "codigo": "I774",
        "valor": "SINDROME DE COMPRESION DEL TRONCO CELIACO"
      },
      {
        "codigo": "I775",
        "valor": "NECROSIS ARTERIAL"
      },
      {
        "codigo": "I776",
        "valor": "ARTERITIS, NO ESPECIFICADA"
      },
      {
        "codigo": "I778",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE ARTERIAS Y ARTERIOLAS"
      },
      {
        "codigo": "I779",
        "valor": "TRASTORNO DE ARTERIAS Y ARTERIOLAS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I78 - ENFERMEDADES DE LOS VASOS CAPILARES",
    "detalle": [
      {
        "codigo": "I780",
        "valor": "TELANGIECTASIA HEMORRAGICA HEREDITARIA"
      },
      {
        "codigo": "I781",
        "valor": "NEVO, NO NEOPLASICO"
      },
      {
        "codigo": "I788",
        "valor": "OTRAS ENFERMEDADES DE LOS CAPILARES"
      },
      {
        "codigo": "I789",
        "valor": "ENFERMEDAD DE LOS VASOS CAPILARES, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I79 - TRASTORNOS DE LAS ARTERIAS, DE LAS ARTERIOLAS Y DE LOS VASOS CAPILARES",
    "detalle": [
      {
        "codigo": "I790",
        "valor": "ANEURISMA DE LA AORTA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I791",
        "valor": "AORTITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I792",
        "valor": "ANGIOPATIA PERIFERICA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I798",
        "valor": "OTROS TRASTORNOS DE ARTERIAS, ARTERIOLAS Y VASOS CAPILARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "I80 - FLEBITIS Y TROMBOFLEBITIS",
    "detalle": [
      {
        "codigo": "I800",
        "valor": "FLEBITIS Y TROMBOFLEBITIS DE VASOS SUPERFICIALES DE LOS MIEMBROS INFERIORES"
      },
      {
        "codigo": "I801",
        "valor": "FLEBITIS Y TROMBOFLEBITIS DE LA VENA FEMORAL"
      },
      {
        "codigo": "I802",
        "valor": "FLEBITIS Y TROMBOFLEBITIS DE OTROS VASOS PROFUNDOS DE LOS MIEMBROS INFERIORES"
      },
      {
        "codigo": "I803",
        "valor": "FLEBITIS Y TROMBOFLEBITIS DE LOS MIEMBROS INFERIORES, NO ESPECIFICADA"
      },
      {
        "codigo": "I808",
        "valor": "FLEBITIS Y TROMBOFLEBITIS DE OTROS SITIOS"
      },
      {
        "codigo": "I809",
        "valor": "FLEBITIS Y TROMBOFLEBITIS DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I81 - TROMBOSIS DE LA VENA PORTA",
    "detalle": [
      {
        "codigo": "I81X",
        "valor": "TROMBOSIS DE LA VENA PORTA"
      }
    ]
  },
  {
    "grupo": "I82 - OTRAS EMBOLIAS Y TROMBOSIS VENOSAS",
    "detalle": [
      {
        "codigo": "I820",
        "valor": "SINDROME DE BUDD-CHIARI"
      },
      {
        "codigo": "I821",
        "valor": "TROMBOFLEBITIS MIGRATORIA"
      },
      {
        "codigo": "I822",
        "valor": "EMBOLIA Y TROMBOSIS DE VENA CAVA"
      },
      {
        "codigo": "I823",
        "valor": "EMBOLIA Y TROMBOSIS DE VENA RENAL"
      },
      {
        "codigo": "I828",
        "valor": "EMBOLIA Y TROMBOSIS DE OTRAS VENAS ESPECIFICADAS"
      },
      {
        "codigo": "I829",
        "valor": "EMBOLIA Y TROMBOSIS DE VENA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I83 - VENAS VARICOSAS DE LOS MIEMBROS INFERIORES",
    "detalle": [
      {
        "codigo": "I830",
        "valor": "VENAS VARICOSAS DE LOS MIEMBROS INFERIORES CON ULCERA"
      },
      {
        "codigo": "I831",
        "valor": "VENAS VARICOSAS DE LOS MIEMBROS INFERIORES CON INFLAMACION"
      },
      {
        "codigo": "I832",
        "valor": "VENAS VARICOSAS DE LOS MIEMBROS INFERIORES CON ULCERA E INFLAMACION"
      },
      {
        "codigo": "I839",
        "valor": "VENAS VARICOSAS DE LOS MIEMBROS INFERIORES SIN ULCERA NI INFLAMACION"
      }
    ]
  },
  {
    "grupo": "I85 - VARICES ESOFAGICAS",
    "detalle": [
      {
        "codigo": "I850",
        "valor": "VARICES ESOFAGICAS CON HEMORRAGIA"
      },
      {
        "codigo": "I859",
        "valor": "VARICES ESOFAGICAS SIN HEMORRAGIA"
      }
    ]
  },
  {
    "grupo": "I86 - VARICES DE OTROS SITIOS",
    "detalle": [
      {
        "codigo": "I860",
        "valor": "VARICES SUBLINGUALES"
      },
      {
        "codigo": "I861",
        "valor": "VARICES ESCROTALES"
      },
      {
        "codigo": "I862",
        "valor": "VARICES PELVICAS"
      },
      {
        "codigo": "I863",
        "valor": "VARICES DE LA VULVA"
      },
      {
        "codigo": "I864",
        "valor": "VARICES GASTRICAS"
      },
      {
        "codigo": "I868",
        "valor": "VARICES EN OTROS SITIOS ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "I87 - OTROS TRASTORNOS DE LAS VENAS",
    "detalle": [
      {
        "codigo": "I870",
        "valor": "SINDROME POSTROMBOTICO"
      },
      {
        "codigo": "I871",
        "valor": "COMPRESION DE VENA"
      },
      {
        "codigo": "I872",
        "valor": "INSUFICIENCIA VENOSA (CRONICA) (PERIFERICA)"
      },
      {
        "codigo": "I878",
        "valor": "OTROS TRASTORNOS VENOSOS ESPECIFICADOS"
      },
      {
        "codigo": "I879",
        "valor": "TRASTORNO VENOSO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I88 - LINFADENITIS INESPECIFICA",
    "detalle": [
      {
        "codigo": "I880",
        "valor": "LINFADENITIS MESENTERICA INESPECIFICA"
      },
      {
        "codigo": "I881",
        "valor": "LINFADENITIS CRONICA, EXCEPTO LA MESENTERICA"
      },
      {
        "codigo": "I888",
        "valor": "OTRAS LINFADENITIS INESPECIFICAS"
      },
      {
        "codigo": "I889",
        "valor": "LINFADENITIS INESPECIFICA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I89 - OTROS TRASTORNOS NO INFECCIOSOS DE LOS VASOS Y GANGLIOS LINFATICOS",
    "detalle": [
      {
        "codigo": "I890",
        "valor": "LINFEDEMA, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "I891",
        "valor": "LINFANGITIS"
      },
      {
        "codigo": "I898",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS NO INFECCIOSOS DE LOS VASOS Y GANGLIOS LINFATICOS"
      },
      {
        "codigo": "I899",
        "valor": "TRASTORNO NO INFECCIOSO DE VASOS Y GANGLIOS LINFATICOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "I95 - HIPOTENSION",
    "detalle": [
      {
        "codigo": "I950",
        "valor": "HIPOTENSION IDIOPATICA"
      },
      {
        "codigo": "I951",
        "valor": "HIPOTENSION ORTOSTATICA"
      },
      {
        "codigo": "I952",
        "valor": "HIPOTENSION DEBIDA A DROGAS"
      },
      {
        "codigo": "I958",
        "valor": "OTROS TIPOS DE HIPOTENSION"
      },
      {
        "codigo": "I959",
        "valor": "HIPOTENSION, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "I97 - TRASTORNOS DEL SISTEMA CIRCULATORIO CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "I970",
        "valor": "SINDROME DE POSTCARDIOTOMIA"
      },
      {
        "codigo": "I971",
        "valor": "OTRAS ALTERACIONES FUNCIONALES CONSECUTIVAS A CIRUGIA CARDIACA"
      },
      {
        "codigo": "I972",
        "valor": "SINDROME DE LINFEDEMA POSTMASTECTOMIA"
      },
      {
        "codigo": "I978",
        "valor": "OTROS TRASTORNOS DEL SISTEMA CIRCULATORIO CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "I979",
        "valor": "TRASTORNO NO ESPECIFICADO DEL SISTEMA CIRCULATORIO CONSECUTIVO A PROCEDIMIENTOS"
      }
    ]
  },
  {
    "grupo": "I98 - OTROS TRASTORNOS DEL SISTEMA CIRCULATORIO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "I980",
        "valor": "SIFILIS CARDIOVASCULAR"
      },
      {
        "codigo": "I981",
        "valor": "TRASTORNOS CARDIOVASCULARES EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I982",
        "valor": "VARICES ESOFAGICAS SIN HEMORRAGIA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I983",
        "valor": "VARICES ESOFAGICAS CON HEMORRAGIA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "I988",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL APARATO CIRCULATORIO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "I99 - OTROS TRASTORNOS Y LOS NO ESPECIFICADOS DEL SISTEMA CIRCULATORIO",
    "detalle": [
      {
        "codigo": "I99X",
        "valor": "OTROS TRASTORNOS Y LOS NO ESPECIFICADOS DEL SISTEMA CIRCULATORIO"
      }
    ]
  },
  {
    "grupo": "J00 - RINOFARINGITIS AGUDA [RESFRIADO COMUN]",
    "detalle": [
      {
        "codigo": "J00X",
        "valor": "RINOFARINGITIS AGUDA, RINITIS AGUDA"
      }
    ]
  },
  {
    "grupo": "J01 - SINUSITIS AGUDA",
    "detalle": [
      {
        "codigo": "J010",
        "valor": "SINUSITIS MAXILAR AGUDA"
      },
      {
        "codigo": "J011",
        "valor": "SINUSITIS FRONTAL AGUDA"
      },
      {
        "codigo": "J012",
        "valor": "SINUSITIS ETMOIDAL AGUDA"
      },
      {
        "codigo": "J013",
        "valor": "SINUSITIS ESFENOIDAL AGUDA"
      },
      {
        "codigo": "J014",
        "valor": "PANSINUSITIS AGUDA"
      },
      {
        "codigo": "J018",
        "valor": "OTRAS SINUSITIS AGUDAS"
      },
      {
        "codigo": "J019",
        "valor": "SINUSITIS AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J02 - FARINGITIS AGUDA",
    "detalle": [
      {
        "codigo": "J020",
        "valor": "FARINGITIS ESTREPTOCOCICA"
      },
      {
        "codigo": "J028",
        "valor": "FARINGITIS AGUDA DEBIDA A OTROS MICROORGANISMOS ESPECIFICADOS"
      },
      {
        "codigo": "J029",
        "valor": "FARINGITIS AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J03 - AMIGDALITIS AGUDA",
    "detalle": [
      {
        "codigo": "J030",
        "valor": "AMIGDALITIS ESTREPTOCOCICA"
      },
      {
        "codigo": "J038",
        "valor": "AMIGDALITIS AGUDA DEBIDA A OTROS MICROORGANISMOS ESPECIFICADOS"
      },
      {
        "codigo": "J039",
        "valor": "AMIGDALITIS AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J04 - LARINGITIS Y TRAQUEITIS AGUDAS",
    "detalle": [
      {
        "codigo": "J040",
        "valor": "LARINGITIS AGUDA"
      },
      {
        "codigo": "J041",
        "valor": "TRAQUEITIS AGUDA"
      },
      {
        "codigo": "J042",
        "valor": "LARINGOTRAQUEITIS AGUDA"
      }
    ]
  },
  {
    "grupo": "J05 - LARINGITIS OBSTRUCTIVA AGUDA [CRUP] Y EPIGLOTITIS",
    "detalle": [
      {
        "codigo": "J050",
        "valor": "LARINGITIS OBSTRUCTIVA, AGUDA [CRUP]"
      },
      {
        "codigo": "J0501",
        "valor": "CRUP LEVE"
      },
      {
        "codigo": "J0502",
        "valor": "CRUP MODERADO"
      },
      {
        "codigo": "J0503",
        "valor": "CRUP SEVERO"
      },
      {
        "codigo": "J051",
        "valor": "EPIGLOTITIS AGUDA"
      }
    ]
  },
  {
    "grupo": "J06 - INFECCIONES AGUDAS DE LAS VIAS RESPIRATORIAS SUPERIORES, DE SITIOS MULTIPLES O NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "J060",
        "valor": "LARINGOFARINGITIS AGUDA"
      },
      {
        "codigo": "J068",
        "valor": "OTRAS INFECCIONES AGUDAS DE SITIOS MULTIPLES DE LAS VIAS RESPIRATORIAS SUPERIORES"
      },
      {
        "codigo": "J0681",
        "valor": "FARINGO AMIGDALITIS PURULENTA"
      },
      {
        "codigo": "J0682",
        "valor": "OTRAS FARINGOADMIGDALITIS"
      },
      {
        "codigo": "J069",
        "valor": "INFECCION AGUDA DE LAS VIAS RESPIRATORIAS SUPERIORES, NO ESPECIFICADA"
      },
      {
        "codigo": "J0691",
        "valor": "NO NEUMONIA"
      }
    ]
  },
  {
    "grupo": "J09 - INFLUENZA AVIAR",
    "detalle": [
      {
        "codigo": "J09X",
        "valor": "INFLUENZA AVIAR"
      }
    ]
  },
  {
    "grupo": "J10 - INFLUENZA DEBIDA A VIRUS DE LA INFLUENZA IDENTIFICADO",
    "detalle": [
      {
        "codigo": "J100",
        "valor": "INFLUENZA CON NEUMONIA, DEBIDA A OTRO VIRUS DE LA INFLUENZA ESTACIONAL IDENTIFICADO"
      },
      {
        "codigo": "J101",
        "valor": "INFLUENZA CON OTRAS MANIFESTACIONES RESPIRATORIAS, DEBIDA A VIRUS DE LA INFLUENZA ESTACIONAL IDENTIFICADO"
      },
      {
        "codigo": "J108",
        "valor": "INFLUENZA, CON OTRAS MANIFESTACIONES, DEBIDA A VIRUS DE LA INFLUENZA ESTACIONAL IDENTIFICADO"
      },
      {
        "codigo": "J10X",
        "valor": "INFLUENZA POR AH1N1 - INFLUENZA DEBIDA A OTRO VIRUS DE INFLUENZA IDENTIFICADO"
      }
    ]
  },
  {
    "grupo": "J11 - INFLUENZA DEBIDA A VIRUS NO IDENTIFICADO",
    "detalle": [
      {
        "codigo": "J110",
        "valor": "INFLUENZA CON NEUMONIA, VIRUS NO IDENTIFICADO"
      },
      {
        "codigo": "J111",
        "valor": "INFLUENZA CON OTRAS MANIFESTACIONES RESPIRATORIAS, VIRUS NO IDENTIFICADO"
      },
      {
        "codigo": "J118",
        "valor": "INFLUENZA CON OTRAS MANIFESTACIONES, VIRUS NO IDENTIFICADO"
      }
    ]
  },
  {
    "grupo": "J12 - NEUMONIA VIRAL, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J120",
        "valor": "NEUMONIA DEBIDA A ADENOVIRUS"
      },
      {
        "codigo": "J121",
        "valor": "NEUMONIA DEBIDA A VIRUS SINCITIAL RESPIRATORIO"
      },
      {
        "codigo": "J122",
        "valor": "NEUMONIA DEBIDA A VIRUS PARAINFLUENZA"
      },
      {
        "codigo": "J123",
        "valor": "NEUMONIA DEBIDA A METANEUMOVIRUS HUMANO"
      },
      {
        "codigo": "J128",
        "valor": "NEUMONIA DEBIDA A OTROS VIRUS"
      },
      {
        "codigo": "J129",
        "valor": "NEUMONIA VIRAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J13 - NEUMONIA DEBIDA A STREPTOCOCCUS PNEUMONIAE",
    "detalle": [
      {
        "codigo": "J13X",
        "valor": "NEUMONIA DEBIDA A STREPTOCOCCUS PENUMONIAE"
      }
    ]
  },
  {
    "grupo": "J14 - NEUMONIA DEBIDA A HAEMOPHILUS INFLUENZAE",
    "detalle": [
      {
        "codigo": "J14X",
        "valor": "NEUMONIA DEBIDA A HAEMOPHILUS INFLUENZAE"
      }
    ]
  },
  {
    "grupo": "J15 - NEUMONIA BACTERIANA, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J150",
        "valor": "NEUMONIA DEBIDA A KLEBSIELLA PNEUMONIAE"
      },
      {
        "codigo": "J151",
        "valor": "NEUMONIA DEBIDA A PSEUDOMONAS"
      },
      {
        "codigo": "J152",
        "valor": "NEUMONIA DEBIDA A ESTAFILOCOCOS"
      },
      {
        "codigo": "J153",
        "valor": "NEUMONIA DEBIDA A ESTREPTOCOCOS DEL GRUPO B"
      },
      {
        "codigo": "J154",
        "valor": "NEUMONIA DEBIDA A OTROS ESTREPTOCOCOS"
      },
      {
        "codigo": "J155",
        "valor": "NEUMONIA DEBIDA A ESCHERICHIA COLI"
      },
      {
        "codigo": "J156",
        "valor": "NEUMONIA DEBIDA A OTRAS BACTERIAS AEROBICAS GRAMNEGATIVAS"
      },
      {
        "codigo": "J157",
        "valor": "NEUMONIA DEBIDA A MYCOPLASMA PNEUMONIAE"
      },
      {
        "codigo": "J158",
        "valor": "OTRAS NEUMONIAS BACTERIANAS"
      },
      {
        "codigo": "J159",
        "valor": "NEUMONIA BACTERIANA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J16 - NEUMONIA DEBIDA A OTROS MICROORGANISMOS INFECCIOSOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J160",
        "valor": "NEUMONIA DEBIDA A CLAMIDIAS"
      },
      {
        "codigo": "J168",
        "valor": "NEUMONIA DEBIDA A OTROS MICROORGANISMOS INFECCIOSOS ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "J17 - NEUMONIA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J170",
        "valor": "NEUMONIA EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "J171",
        "valor": "NEUMONIA EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "J172",
        "valor": "NEUMONIA EN MICOSIS"
      },
      {
        "codigo": "J173",
        "valor": "NEUMONIA EN ENFERMEDADES PARASITARIAS"
      },
      {
        "codigo": "J178",
        "valor": "NEUMONIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "J18 - NEUMONIA, ORGANISMO NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "J180",
        "valor": "BRONCONEUMONIA, NO ESPECIFICADA"
      },
      {
        "codigo": "J181",
        "valor": "NEUMONIA LOBAR, NO ESPECIFICADA"
      },
      {
        "codigo": "J182",
        "valor": "NEUMONIA HIPOSTATICA, NO ESPECIFICADA"
      },
      {
        "codigo": "J188",
        "valor": "OTRAS NEUMONIAS, DE MICROORGANISMO NO ESPECIFICADO"
      },
      {
        "codigo": "J189",
        "valor": "NEUMONIA, NO ESPECIFICADA"
      },
      {
        "codigo": "J1891",
        "valor": "NEUMONIA GRAVE"
      },
      {
        "codigo": "J1892",
        "valor": "ENFERMEDAD MUY GRAVE"
      }
    ]
  },
  {
    "grupo": "J20 - BRONQUITIS AGUDA",
    "detalle": [
      {
        "codigo": "J200",
        "valor": "BRONQUITIS AGUDA DEBIDA A MYCOPLASMA PNEUMONIAE"
      },
      {
        "codigo": "J201",
        "valor": "BRONQUITIS AGUDA DEBIDA A HAEMOPHILUS INFLUENZAE"
      },
      {
        "codigo": "J202",
        "valor": "BRONQUITIS AGUDA DEBIDA A ESTREPTOCOCOS"
      },
      {
        "codigo": "J203",
        "valor": "BRONQUITIS AGUDA DEBIDA A VIRUS COXSACKIE"
      },
      {
        "codigo": "J204",
        "valor": "BRONQUITIS AGUDA DEBIDA A VIRUS PARAINFLUENZA"
      },
      {
        "codigo": "J205",
        "valor": "BRONQUITIS AGUDA DEBIDA A VIRUS SINCITIAL RESPIRATORIO"
      },
      {
        "codigo": "J206",
        "valor": "BRONQUITIS AGUDA DEBIDA A RINOVIRUS"
      },
      {
        "codigo": "J207",
        "valor": "BRONQUITIS AGUDA DEBIDA A VIRUS ECHO"
      },
      {
        "codigo": "J208",
        "valor": "BRONQUITIS AGUDA DEBIDA A OTROS MICROORGANISMOS ESPECIFICADOS"
      },
      {
        "codigo": "J209",
        "valor": "BRONQUITIS AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J21 - BRONQUIOLITIS AGUDA",
    "detalle": [
      {
        "codigo": "J210",
        "valor": "BRONQUIOLITIS AGUDA DEBIDA A VIRUS SINCITIAL RESPIRATORIO"
      },
      {
        "codigo": "J211",
        "valor": "BRONQUIOLITIS AGUDA DEBIDA A METANEUMOVIRUS HUMANO"
      },
      {
        "codigo": "J218",
        "valor": "BRONQUIOLITIS AGUDA DEBIDA A OTROS MICROORGANISMOS ESPECIFICADOS"
      },
      {
        "codigo": "J219",
        "valor": "BRONQUIOLITIS AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J22 - INFECCION AGUDA NO ESPECIFICADA DE LAS VIAS RESPIRATORIAS INFERIORES",
    "detalle": [
      {
        "codigo": "J22X",
        "valor": "INFECCION AGUDA NO ESPECIFICADA DE LAS VIAS RESPIRATORIAS INFERIORES"
      }
    ]
  },
  {
    "grupo": "J30 - RINITIS ALERGICA Y VASOMOTORA",
    "detalle": [
      {
        "codigo": "J300",
        "valor": "RINITIS VASOMOTORA"
      },
      {
        "codigo": "J301",
        "valor": "RINITIS ALERGICA DEBIDA AL POLEN"
      },
      {
        "codigo": "J302",
        "valor": "OTRA RINITIS ALERGICA ESTACIONAL"
      },
      {
        "codigo": "J303",
        "valor": "OTRAS RINITIS ALERGICAS"
      },
      {
        "codigo": "J304",
        "valor": "RINITIS ALERGICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J31 - RINITIS, RINOFARINGITIS Y FARINGITIS CRONICAS",
    "detalle": [
      {
        "codigo": "J310",
        "valor": "RINITIS CRONICA"
      },
      {
        "codigo": "J311",
        "valor": "RINOFARINGITIS CRONICA"
      },
      {
        "codigo": "J312",
        "valor": "FARINGITIS CRONICA"
      }
    ]
  },
  {
    "grupo": "J32 - SINUSITIS CRONICA",
    "detalle": [
      {
        "codigo": "J320",
        "valor": "SINUSITIS MAXILAR CRONICA"
      },
      {
        "codigo": "J321",
        "valor": "SINUSITIS FRONTAL CRONICA"
      },
      {
        "codigo": "J322",
        "valor": "SINUSITIS ETMOIDAL CRONICA"
      },
      {
        "codigo": "J323",
        "valor": "SINUSITIS ESFENOIDAL CRONICA"
      },
      {
        "codigo": "J324",
        "valor": "PANSINUSITIS CRONICA"
      },
      {
        "codigo": "J328",
        "valor": "OTRAS SINUSITIS CRONICAS"
      },
      {
        "codigo": "J329",
        "valor": "SINUSITIS CRONICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J33 - POLIPO NASAL",
    "detalle": [
      {
        "codigo": "J330",
        "valor": "POLIPO DE LA CAVIDAD NASAL"
      },
      {
        "codigo": "J331",
        "valor": "DEGENERACION POLIPOIDE DE SENO PARANASAL"
      },
      {
        "codigo": "J338",
        "valor": "OTROS POLIPOS DE LOS SENOS PARANASALES"
      },
      {
        "codigo": "J339",
        "valor": "POLIPO NASAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "J34 - OTROS TRASTORNOS DE LA NARIZ Y DE LOS SENOS PARANASALES",
    "detalle": [
      {
        "codigo": "J340",
        "valor": "ABSCESO, FURUNCULO Y CARBUNCO DE LA NARIZ"
      },
      {
        "codigo": "J341",
        "valor": "QUISTE Y MUCOCELE DE LA NARIZ Y DEL SENO PARANASAL"
      },
      {
        "codigo": "J342",
        "valor": "DESVIACION DEL TABIQUE NASAL"
      },
      {
        "codigo": "J343",
        "valor": "HIPERTROFIA DE LOS CORNETES NASALES"
      },
      {
        "codigo": "J348",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA NARIZ Y DE LOS SENOS PARANASALES"
      }
    ]
  },
  {
    "grupo": "J35 - ENFERMEDADES CRONICAS DE LAS AMIGDALAS Y DE LAS ADENOIDES",
    "detalle": [
      {
        "codigo": "J350",
        "valor": "AMIGDALITIS CRONICA"
      },
      {
        "codigo": "J351",
        "valor": "HIPERTROFIA DE LAS AMIGDALAS"
      },
      {
        "codigo": "J352",
        "valor": "HIPERTROFIA DE LAS ADENOIDES"
      },
      {
        "codigo": "J353",
        "valor": "HIPERTROFIA DE LAS AMIGDALAS CON HIPERTROFIA DE LAS ADENOIDES"
      },
      {
        "codigo": "J358",
        "valor": "OTRAS ENFERMEDADES CRONICAS DE LAS AMIGDALAS Y DE LAS ADENOIDES"
      },
      {
        "codigo": "J359",
        "valor": "ENFERMEDAD CRONICA DE LAS AMIGDALAS Y DE LAS ADENOIDES, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J36 - ABSCESO PERIAMIGDALINO",
    "detalle": [
      {
        "codigo": "J36X",
        "valor": "ABSCESO PERIAMIGDALINO"
      }
    ]
  },
  {
    "grupo": "J37 - LARINGITIS Y LARINGOTRAQUEITIS CRONICAS",
    "detalle": [
      {
        "codigo": "J370",
        "valor": "LARINGITIS CRONICA"
      },
      {
        "codigo": "J371",
        "valor": "LARINGOTRAQUEITIS CRONICA"
      }
    ]
  },
  {
    "grupo": "J38 - ENFERMEDADES DE LAS CUERDAS VOCALES Y DE LA LARINGE, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J380",
        "valor": "PARALISIS DE LAS CUERDAS VOCALES Y DE LA LARINGE"
      },
      {
        "codigo": "J381",
        "valor": "POLIPO DE LAS CUERDAS VOCALES Y DE LA LARINGE"
      },
      {
        "codigo": "J382",
        "valor": "NODULOS DE LAS CUERDAS VOCALES"
      },
      {
        "codigo": "J383",
        "valor": "OTRAS ENFERMEDADES DE LAS CUERDAS VOCALES"
      },
      {
        "codigo": "J384",
        "valor": "EDEMA DE LARINGE"
      },
      {
        "codigo": "J385",
        "valor": "ESPASMO LARINGEO"
      },
      {
        "codigo": "J386",
        "valor": "ESTENOSIS LARINGEA"
      },
      {
        "codigo": "J387",
        "valor": "OTRAS ENFERMEDADES DE LA LARINGE"
      }
    ]
  },
  {
    "grupo": "J39 - OTRAS ENFERMEDADES DE LAS VIAS RESPIRATORIAS SUPERIORES",
    "detalle": [
      {
        "codigo": "J390",
        "valor": "ABSCESO RETROFARINGEO Y PARAFARINGEO"
      },
      {
        "codigo": "J391",
        "valor": "OTROS ABSCESOS DE LA FARINGE"
      },
      {
        "codigo": "J392",
        "valor": "OTRAS ENFERMEDADES DE LA FARINGE"
      },
      {
        "codigo": "J393",
        "valor": "REACCION DE HIPERSENSIBILIDAD DE LAS VIAS RESPIRATORIAS SUPERIORES, SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "J398",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DE LAS VIAS RESPIRATORIAS SUPERIORES"
      },
      {
        "codigo": "J399",
        "valor": "ENFERMEDAD DE LAS VIAS RESPIRATORIAS SUPERIORES, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J40 - BRONQUITIS, NO ESPECIFICADA COMO AGUDA O CRONICA",
    "detalle": [
      {
        "codigo": "J40X",
        "valor": "BRONQUITIS, NO ESPECIFICADA COMO AGUDA O CRONICA"
      }
    ]
  },
  {
    "grupo": "J41 - BRONQUITIS CRONICA SIMPLE Y MUCOPURULENTA",
    "detalle": [
      {
        "codigo": "J410",
        "valor": "BRONQUITIS CRONICA SIMPLE"
      },
      {
        "codigo": "J411",
        "valor": "BRONQUITIS CRONICA MUCOPURULENTA"
      },
      {
        "codigo": "J418",
        "valor": "BRONQUITIS CRONICA MIXTA SIMPLE Y MUCOPURULENTA"
      }
    ]
  },
  {
    "grupo": "J42 - BRONQUITIS CRONICA NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "J42X",
        "valor": "BRONQUITIS CRONICA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J43 - ENFISEMA",
    "detalle": [
      {
        "codigo": "J430",
        "valor": "SINDROME DE MACLEOD"
      },
      {
        "codigo": "J431",
        "valor": "ENFISEMA PANLOBULAR"
      },
      {
        "codigo": "J432",
        "valor": "ENFISEMA CENTROLOBULAR"
      },
      {
        "codigo": "J438",
        "valor": "OTROS TIPOS DE ENFISEMA"
      },
      {
        "codigo": "J439",
        "valor": "ENFISEMA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "J44 - OTRAS ENFERMEDADES PULMONARES OBSTRUCTIVAS CRONICAS",
    "detalle": [
      {
        "codigo": "J440",
        "valor": "ENFERMEDAD PULMONAR OBSTRUCTIVA CRONICA CON INFECCION AGUDA DE LAS VIAS RESPIRATORIAS INFERIORES"
      },
      {
        "codigo": "J441",
        "valor": "ENFERMEDAD PULMONAR OBSTRUCTIVA CRONICA CON EXACERBACION AGUDA, NO ESPECIFICADA"
      },
      {
        "codigo": "J448",
        "valor": "OTRAS ENFERMEDADES PULMONARES OBSTRUCTIVAS CRONICAS ESPECIFICADAS"
      },
      {
        "codigo": "J449",
        "valor": "ENFERMEDAD PULMONAR OBSTRUCTIVA CRONICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J45 - ASMA",
    "detalle": [
      {
        "codigo": "J450",
        "valor": "ASMA PREDOMINANTEMENTE ALERGICA"
      },
      {
        "codigo": "J451",
        "valor": "ASMA NO ALERGICA"
      },
      {
        "codigo": "J458",
        "valor": "ASMA MIXTA"
      },
      {
        "codigo": "J459",
        "valor": "ASMA, NO ESPECIFICADO"
      },
      {
        "codigo": "J4591",
        "valor": "SOB / SIBILANCIA HIPERACTIVIDAD BRONQUIAL"
      }
    ]
  },
  {
    "grupo": "J46 - ESTADO ASMATICO",
    "detalle": [
      {
        "codigo": "J46X",
        "valor": "ESTADO ASMATICO. ASMA AGUDA SEVERA."
      }
    ]
  },
  {
    "grupo": "J47 - BRONQUIECTASIA",
    "detalle": [
      {
        "codigo": "J47X",
        "valor": "BRONQUIECTASIA"
      }
    ]
  },
  {
    "grupo": "J60 - NEUMOCONIOSIS DE LOS MINEROS DEL CARBON",
    "detalle": [
      {
        "codigo": "J60X",
        "valor": "NEUMOCONIOSIS DE LOS MINEROS DEL CARBON"
      }
    ]
  },
  {
    "grupo": "J61 - NEUMOCONIOSIS DEBIDA AL ASBESTO Y A OTRAS FIBRAS MINERALES",
    "detalle": [
      {
        "codigo": "J61X",
        "valor": "NEUMOCONIOSIS DEBIDA AL ASBESTO Y A OTRAS FIBRAS MINERALES"
      }
    ]
  },
  {
    "grupo": "J62 - NEUMOCONIOSIS DEBIDA A POLVO DE SILICE",
    "detalle": [
      {
        "codigo": "J620",
        "valor": "NEUMOCONIOSIS DEBIDA A POLVO DE TALCO"
      },
      {
        "codigo": "J628",
        "valor": "NEUMOCONIOSIS DEBIDA A OTROS POLVOS QUE CONTIENEN SILICE"
      }
    ]
  },
  {
    "grupo": "J63 - NEUMOCONIOSIS DEBIDA A OTROS POLVOS INORGANICOS",
    "detalle": [
      {
        "codigo": "J630",
        "valor": "ALUMINOSIS (DEL PULMON)"
      },
      {
        "codigo": "J631",
        "valor": "FIBROSIS (DEL PULMON) DEBIDA A BAUXITA"
      },
      {
        "codigo": "J632",
        "valor": "BERILIOSIS"
      },
      {
        "codigo": "J633",
        "valor": "FIBROSIS (DEL PULMON) DEBIDA A GRAFITO"
      },
      {
        "codigo": "J634",
        "valor": "SIDEROSIS"
      },
      {
        "codigo": "J635",
        "valor": "ESTAÑOSIS"
      },
      {
        "codigo": "J638",
        "valor": "NEUMOCONIOSIS DEBIDA A OTROS POLVOS INORGANICOS ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "J64 - NEUMOCONIOSIS, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "J64X",
        "valor": "NEUMOCONIOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J65 - NEUMOCONIOSIS ASOCIADA CON TUBERCULOSIS",
    "detalle": [
      {
        "codigo": "J65X",
        "valor": "NEUMOCONIOSIS ASOCIADA CON TUBERCULOSIS"
      }
    ]
  },
  {
    "grupo": "J66 - ENFERMEDADES DE LAS VIAS AEREAS DEBIDAS A POLVOS ORGANICOS ESPECIFICOS",
    "detalle": [
      {
        "codigo": "J660",
        "valor": "BISINOSIS"
      },
      {
        "codigo": "J661",
        "valor": "ENFERMEDAD DE LOS TRABAJADORES DEL LINO"
      },
      {
        "codigo": "J662",
        "valor": "CANABINOSIS"
      },
      {
        "codigo": "J668",
        "valor": "ENFERMEDAD DE LAS VIAS AEREAS DEBIDA A OTROS POLVOS ORGANICOS ESPECIFICOS"
      }
    ]
  },
  {
    "grupo": "J67 - NEUMONITIS DEBIDA A HIPERSENSIBILIDAD AL POLVO ORGANICO",
    "detalle": [
      {
        "codigo": "J670",
        "valor": "PULMON DEL GRANJERO"
      },
      {
        "codigo": "J671",
        "valor": "BAGAZOSIS"
      },
      {
        "codigo": "J672",
        "valor": "PULMON DEL ORNITOFILO"
      },
      {
        "codigo": "J673",
        "valor": "SUBEROSIS"
      },
      {
        "codigo": "J674",
        "valor": "PULMON DEL MANIPULADOR DE MALTA"
      },
      {
        "codigo": "J675",
        "valor": "PULMON DEL MANIPULADOR DE HONGOS"
      },
      {
        "codigo": "J676",
        "valor": "PULMON DEL DESCORTEZADOR DEL ARCE"
      },
      {
        "codigo": "J677",
        "valor": "NEUMONITIS DE LA VENTILACION DEBIDA AL ACONDICIONADOR Y HUMIDIFICADOR DEL AIRE"
      },
      {
        "codigo": "J678",
        "valor": "NEUMONITIS DEBIDAS A HIPERSENSIBILIDAD A OTROS POLVOS ORGANICOS"
      },
      {
        "codigo": "J679",
        "valor": "NEUMONITIS DEBIDA A HIPERSENSIBILIDAD A POLVO ORGANICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "J68 - AFECCIONES RESPIRATORIAS DEBIDAS A INHALACION DE GASES, HUMOS, VAPORES",
    "detalle": [
      {
        "codigo": "J680",
        "valor": "BRONQUITIS Y NEUMONITIS DEBIDAS A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS"
      },
      {
        "codigo": "J681",
        "valor": "EDEMA PULMONAR AGUDO DEBIDO A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS"
      },
      {
        "codigo": "J682",
        "valor": "INFLAMACION RESPIRATORIA SUPERIOR DEBIDA A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "J683",
        "valor": "OTRAS AFECCIONES RESPIRATORIAS AGUDAS Y SUBAGUDAS DEBIDAS A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS"
      },
      {
        "codigo": "J684",
        "valor": "AFECCIONES RESPIRATORIAS CRONICAS DEBIDAS A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS"
      },
      {
        "codigo": "J688",
        "valor": "OTRAS AFECCIONES RESPIRATORIAS DEBIDAS A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS"
      },
      {
        "codigo": "J689",
        "valor": "AFECCION RESPIRATORIA NO ESPECIFICADA, DEBIDA A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS"
      }
    ]
  },
  {
    "grupo": "J69 - NEUMONITIS DEBIDA A SOLIDOS Y LIQUIDOS",
    "detalle": [
      {
        "codigo": "J690",
        "valor": "NEUMONITIS DEBIDA A ASPIRACION DE ALIMENTO O VOMITO"
      },
      {
        "codigo": "J691",
        "valor": "NEUMONITIS DEBIDA A ASPIRACION DE ACEITES Y ESENCIAS"
      },
      {
        "codigo": "J698",
        "valor": "NEUMONITIS DEBIDA A ASPIRACION DE OTROS SOLIDOS Y LIQUIDOS"
      }
    ]
  },
  {
    "grupo": "J70 - AFECCIONES RESPIRATORIAS DEBIDAS A OTROS AGENTES EXTERNOS",
    "detalle": [
      {
        "codigo": "J700",
        "valor": "MANIFESTACIONES PULMONARES AGUDAS DEBIDAS A RADIACION"
      },
      {
        "codigo": "J701",
        "valor": "MANIFESTACIONES PULMONARES CRONICAS Y OTRAS MANIFESTACIONES DEBIDAS A RADIACION"
      },
      {
        "codigo": "J702",
        "valor": "TRASTORNOS PULMONARES INTERSTICIALES AGUDOS INDUCIDOS POR DROGAS"
      },
      {
        "codigo": "J703",
        "valor": "TRASTORNOS PULMONARES INTERSTICIALES CRONICOS INDUCIDOS POR DROGAS"
      },
      {
        "codigo": "J704",
        "valor": "TRASTORNOS PULMONARES INTERSTICIALES NO ESPECIFICADOS INDUCIDOS POR DROGAS"
      },
      {
        "codigo": "J708",
        "valor": "AFECCIONES RESPIRATORIAS DEBIDAS A OTROS AGENTES EXTERNOS ESPECIFICADOS"
      },
      {
        "codigo": "J709",
        "valor": "AFECCIONES RESPIRATORIAS DEBIDAS A AGENTES EXTERNOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "J80 - SINDROME DE DIFICULTAD RESPIRATORIA DEL ADULTO",
    "detalle": [
      {
        "codigo": "J80X",
        "valor": "SINDROME DE DIFICULTAD RESPIRATORIA DEL ADULTO"
      }
    ]
  },
  {
    "grupo": "J81 - EDEMA PULMONAR",
    "detalle": [
      {
        "codigo": "J81X",
        "valor": "EDEMA PULMONAR"
      }
    ]
  },
  {
    "grupo": "J82 - EOSINOFILIA PULMONAR, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J82X",
        "valor": "EOSINOFILIA PULMONAR, NO CLASIFICADA EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "J84 - OTRAS ENFERMEDADES PULMONARES INTERSTICIALES",
    "detalle": [
      {
        "codigo": "J840",
        "valor": "AFECCIONES ALVEOLARES Y ALVEOLOPARIETALES"
      },
      {
        "codigo": "J841",
        "valor": "OTRAS ENFERMEDADES PULMONARES INTERSTICIALES CON FIBROSIS"
      },
      {
        "codigo": "J848",
        "valor": "OTRAS ENFERMEDADES PULMONARES INTERSTICIALES ESPECIFICADAS"
      },
      {
        "codigo": "J849",
        "valor": "ENFERMEDAD PULMONAR INTERSTICIAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J85 - ABSCESO DEL PULMON Y DEL MEDIASTINO",
    "detalle": [
      {
        "codigo": "J850",
        "valor": "GANGRENA Y NECROSIS DEL PULMON"
      },
      {
        "codigo": "J851",
        "valor": "ABSCESO DEL PULMON CON NEUMONIA"
      },
      {
        "codigo": "J852",
        "valor": "ABSCESO DEL PULMON SIN NEUMONIA"
      },
      {
        "codigo": "J853",
        "valor": "ABSCESO DEL MEDIASTINO"
      }
    ]
  },
  {
    "grupo": "J86 - PIOTORAX",
    "detalle": [
      {
        "codigo": "J860",
        "valor": "PIOTORAX CON FISTULA"
      },
      {
        "codigo": "J869",
        "valor": "PIOTORAX SIN FISTULA"
      }
    ]
  },
  {
    "grupo": "J90 - DERRAME PLEURAL NO CLASIFICADO EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J90X",
        "valor": "PLEURESIA NO TUBERCULOSA"
      }
    ]
  },
  {
    "grupo": "J91 - DERRAME PLEURAL EN AFECCIONES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J91X",
        "valor": "DERRAME PLEURAL EN AFECCIONES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "J92 - PAQUIPLEURITIS",
    "detalle": [
      {
        "codigo": "J920",
        "valor": "PAQUIPLEURITIS CON ASBESTOSIS"
      },
      {
        "codigo": "J929",
        "valor": "PAQUIPLEURITIS SIN ASBESTOSIS"
      }
    ]
  },
  {
    "grupo": "J93 - NEUMOTORAX",
    "detalle": [
      {
        "codigo": "J930",
        "valor": "NEUMOTORAX ESPONTANEO A PRESION"
      },
      {
        "codigo": "J931",
        "valor": "OTROS TIPOS DE NEUMOTORAX ESPONTANEO"
      },
      {
        "codigo": "J938",
        "valor": "OTROS NEUMOTORAX"
      },
      {
        "codigo": "J939",
        "valor": "NEUMOTORAX, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "J94 - OTRAS AFECCIONES DE LA PLEURA",
    "detalle": [
      {
        "codigo": "J940",
        "valor": "QUILOTORAX"
      },
      {
        "codigo": "J941",
        "valor": "FIBROTORAX"
      },
      {
        "codigo": "J942",
        "valor": "HEMOTORAX"
      },
      {
        "codigo": "J948",
        "valor": "OTRAS AFECCIONES ESPECIFICADAS DE LA PLEURA"
      },
      {
        "codigo": "J949",
        "valor": "AFECCION PLEURAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J95 - TRASTORNOS DEL SISTEMA RESPIRATORIO CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J950",
        "valor": "FUNCIONAMIENTO DEFECTUOSO DE LA TRAQUEOSTOMIA"
      },
      {
        "codigo": "J951",
        "valor": "INSUFICIENCIA PULMONAR AGUDA CONSECUTIVA A CIRUGIA TORACICA"
      },
      {
        "codigo": "J952",
        "valor": "INSUFICIENCIA PULMONAR AGUDA CONSECUTIVA DEBIDA A CIRUGIA EXTRAÑORACICA"
      },
      {
        "codigo": "J953",
        "valor": "INSUFICIENCIA PULMONAR CRONICA CONSECUTIVA A CIRUGIA"
      },
      {
        "codigo": "J954",
        "valor": "SINDROME DE MENDELSON"
      },
      {
        "codigo": "J955",
        "valor": "ESTENOSIS SUBGLOTICA CONSECUTIVA A PROCEDIMIENTOS"
      },
      {
        "codigo": "J958",
        "valor": "OTROS TRASTORNOS RESPIRATORIOS CONSECUTIVOS A PROCEDIMIENTOS"
      },
      {
        "codigo": "J959",
        "valor": "TRASTORNO NO ESPECIFICADO DEL SISTEMA RESPIRATORIO, CONSECUTIVO A PROCEDIMIENTOS"
      }
    ]
  },
  {
    "grupo": "J96 - INSUFICIENCIA RESPIRATORIA, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J960",
        "valor": "INSUFICIENCIA RESPIRATORIA AGUDA"
      },
      {
        "codigo": "J961",
        "valor": "INSUFICIENCIA RESPIRATORIA CRONICA"
      },
      {
        "codigo": "J969",
        "valor": "INSUFICIENCIA RESPIRATORIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "J98 - OTROS TRASTORNOS RESPIRATORIOS",
    "detalle": [
      {
        "codigo": "J980",
        "valor": "ENFERMEDADES DE LA TRAQUEA Y DE LOS BRONQUIOS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "J981",
        "valor": "COLAPSO PULMONAR"
      },
      {
        "codigo": "J982",
        "valor": "ENFISEMA INTERSTICIAL"
      },
      {
        "codigo": "J983",
        "valor": "ENFISEMA COMPENSATORIO"
      },
      {
        "codigo": "J984",
        "valor": "OTROS TRASTORNOS DEL PULMON"
      },
      {
        "codigo": "J985",
        "valor": "ENFERMEDADES DEL MEDIASTINO, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "J986",
        "valor": "TRASTORNOS DEL DIAFRAGMA"
      },
      {
        "codigo": "J988",
        "valor": "OTROS TRASTORNOS RESPIRATORIOS ESPECIFICADOS"
      },
      {
        "codigo": "J989",
        "valor": "TRASTORNO RESPIRATORIO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "J99 - TRASTORNOS RESPIRATORIOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "J990",
        "valor": "ENFERMEDAD PULMONAR REUMATOIDE"
      },
      {
        "codigo": "J991",
        "valor": "TRASTORNOS RESPIRATORIOS EN OTROS TRASTORNOS DIFUSOS DEL TEJIDO CONJUNTIVO"
      },
      {
        "codigo": "J998",
        "valor": "TRASTORNOS RESPIRATORIOS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "K00 - TRASTORNOS DEL DESARROLLO Y DE LA ERUPCION DE LOS DIENTES",
    "detalle": [
      {
        "codigo": "K000",
        "valor": "ANODONCIA"
      },
      {
        "codigo": "K001",
        "valor": "DIENTES SUPERNUMERARIOS"
      },
      {
        "codigo": "K002",
        "valor": "ANOMALIAS DEL TAMAÑO Y DE LA FORMA DEL DIENTE"
      },
      {
        "codigo": "K003",
        "valor": "DIENTES MOTEADOS"
      },
      {
        "codigo": "K004",
        "valor": "ALTERACIONES EN LA FORMACION DENTARIA"
      },
      {
        "codigo": "K005",
        "valor": "ALTERACIONES HEREDITARIAS DE LA ESTRUCTURA DENTARIA, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "K006",
        "valor": "ALTERACIONES EN LA ERUPCION DENTARIA"
      },
      {
        "codigo": "K007",
        "valor": "SINDROME DE LA ERUPCION DENTARIA"
      },
      {
        "codigo": "K008",
        "valor": "OTROS TRASTORNOS DEL DESARROLLO DE LOS DIENTES"
      },
      {
        "codigo": "K009",
        "valor": "TRASTORNO DEL DESARROLLO DE LOS DIENTES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "K01 - DIENTES INCLUIDOS E IMPACTADOS",
    "detalle": [
      {
        "codigo": "K010",
        "valor": "DIENTES INCLUIDOS"
      },
      {
        "codigo": "K011",
        "valor": "DIENTES IMPACTADOS"
      }
    ]
  },
  {
    "grupo": "K02 - CARIES DENTAL",
    "detalle": [
      {
        "codigo": "K020",
        "valor": "CARIES LIMITADA AL ESMALTE"
      },
      {
        "codigo": "K021",
        "valor": "CARIES DE LA DENTINA"
      },
      {
        "codigo": "K022",
        "valor": "CARIES DEL CEMENTO"
      },
      {
        "codigo": "K023",
        "valor": "CARIES DENTARIA DETENIDA"
      },
      {
        "codigo": "K024",
        "valor": "ODONTOCLASIA"
      },
      {
        "codigo": "K025",
        "valor": "CARIES CON EXPOSICION PULPAR"
      },
      {
        "codigo": "K028",
        "valor": "OTRAS CARIES DENTALES"
      },
      {
        "codigo": "K029",
        "valor": "CARIES DENTAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K03 - OTRAS ENFERMEDADES DE LOS TEJIDOS DUROS DE LOS DIENTES",
    "detalle": [
      {
        "codigo": "K030",
        "valor": "ATRICION EXCESIVA DE LOS DIENTES"
      },
      {
        "codigo": "K031",
        "valor": "ABRASION DE LOS DIENTES"
      },
      {
        "codigo": "K032",
        "valor": "EROSION DE LOS DIENTES"
      },
      {
        "codigo": "K033",
        "valor": "REABSORCION PATOLOGICA DE LOS DIENTES"
      },
      {
        "codigo": "K034",
        "valor": "HIPERCEMENTOSIS"
      },
      {
        "codigo": "K035",
        "valor": "ANQUILOSIS DENTAL"
      },
      {
        "codigo": "K036",
        "valor": "DEPOSITOS [ACRECIONES] EN LOS DIENTES"
      },
      {
        "codigo": "K037",
        "valor": "CAMBIOS POSTERUPTIVOS DEL COLOR DE LOS TEJIDOS DENTALES DUROS"
      },
      {
        "codigo": "K038",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DE LOS TEJIDOS DUROS DE LOS DIENTES"
      },
      {
        "codigo": "K039",
        "valor": "ENFERMEDAD NO ESPECIFICADA DE LOS TEJIDOS DENTALES DUROS"
      }
    ]
  },
  {
    "grupo": "K04 - ENFERMEDADES DE LA PULPA Y DE LOS TEJIDOS PERIAPICALES",
    "detalle": [
      {
        "codigo": "K040",
        "valor": "PULPITIS"
      },
      {
        "codigo": "K041",
        "valor": "NECROSIS DE LA PULPA"
      },
      {
        "codigo": "K042",
        "valor": "DEGENERACION DE LA PULPA"
      },
      {
        "codigo": "K043",
        "valor": "FORMACION ANORMAL DE TEJIDO DURO EN LA PULPA"
      },
      {
        "codigo": "K044",
        "valor": "PERIODONTITIS APICAL AGUDA ORIGINADA EN LA PULPA"
      },
      {
        "codigo": "K045",
        "valor": "PERIODONTITIS APICAL CRONICA"
      },
      {
        "codigo": "K046",
        "valor": "ABSCESO PERIAPICAL CON FISTULA"
      },
      {
        "codigo": "K047",
        "valor": "ABSCESO PERIAPICAL SIN FISTULA"
      },
      {
        "codigo": "K048",
        "valor": "QUISTE RADICULAR"
      },
      {
        "codigo": "K049",
        "valor": "OTRAS ENFERMEDADES Y LAS NO ESPECIFICADAS DE LA PULPA Y DEL TEJIDO PERIAPICAL"
      }
    ]
  },
  {
    "grupo": "K05 - GINGIVITIS Y ENFERMEDADES PERIODONTALES",
    "detalle": [
      {
        "codigo": "K050",
        "valor": "GINGIVITIS AGUDA"
      },
      {
        "codigo": "K051",
        "valor": "GINGIVITIS CRONICA"
      },
      {
        "codigo": "K052",
        "valor": "PERIODONTITIS AGUDA"
      },
      {
        "codigo": "K053",
        "valor": "PERIODONTITIS CRONICA"
      },
      {
        "codigo": "K054",
        "valor": "PERIODONTOSIS"
      },
      {
        "codigo": "K055",
        "valor": "OTRAS ENFERMEDADES PERIODONTALES"
      },
      {
        "codigo": "K056",
        "valor": "ENFERMEDAD DEL PERIODONTO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K06 - OTROS TRASTORNOS DE LA ENCIA Y DE LA ZONA EDENTULA",
    "detalle": [
      {
        "codigo": "K060",
        "valor": "RETRACCION GINGIVAL"
      },
      {
        "codigo": "K061",
        "valor": "HIPERPLASIA GINGIVAL"
      },
      {
        "codigo": "K062",
        "valor": "LESIONES DE LA ENCIA Y DE LA ZONA EDENTULA ASOCIADAS CON TRAUMATISMO"
      },
      {
        "codigo": "K068",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA ENCIA Y DE LA ZONA EDENTULA"
      },
      {
        "codigo": "K069",
        "valor": "TRASTORNO NO ESPECIFICADO DE LA ENCIA Y DE LA ZONA EDENTULA"
      }
    ]
  },
  {
    "grupo": "K07 - ANOMALIAS DENTOFACIALES [INCLUSO LA MALOCLUSION]",
    "detalle": [
      {
        "codigo": "K070",
        "valor": "ANOMALIAS EVIDENTES DEL TAMAÑO DE LOS MAXILARES"
      },
      {
        "codigo": "K071",
        "valor": "ANOMALIAS DE LA RELACION MAXILOBASILAR"
      },
      {
        "codigo": "K072",
        "valor": "ANOMALIAS DE LA RELACION ENTRE LOS ARCOS DENTARIOS"
      },
      {
        "codigo": "K073",
        "valor": "ANOMALIAS DE LA POSICION DEL DIENTE"
      },
      {
        "codigo": "K074",
        "valor": "MALOCLUSION DE TIPO NO ESPECIFICADO"
      },
      {
        "codigo": "K075",
        "valor": "ANOMALIAS DENTOFACIALES FUNCIONALES"
      },
      {
        "codigo": "K076",
        "valor": "TRASTORNOS DE LA ARTICULACION TEMPOROMAXILAR"
      },
      {
        "codigo": "K078",
        "valor": "OTRAS ANOMALIAS DENTOFACIALES"
      },
      {
        "codigo": "K079",
        "valor": "ANOMALIA DENTOFACIAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K08 - OTROS TRASTORNOS DE LOS DIENTES Y DE SUS ESTRUCTURAS DE SOSTEN",
    "detalle": [
      {
        "codigo": "K080",
        "valor": "EXFOLIACION DE LOS DIENTES DEBIDA A CAUSAS SISTEMICAS"
      },
      {
        "codigo": "K081",
        "valor": "PERDIDA DE DIENTES DEBIDA A ACCIDENTE, EXTRACCION O ENFERMEDAD PERIODONTAL LOCAL"
      },
      {
        "codigo": "K082",
        "valor": "ATROFIA DEL REBORDE ALVEOLAR DESDENTADO"
      },
      {
        "codigo": "K083",
        "valor": "RAIZ DENTAL RETENIDA"
      },
      {
        "codigo": "K088",
        "valor": "OTRAS AFECCIONES ESPECIFICADAS DE LOS DIENTES Y DE SUS ESTRUCTURAS DE SOSTEN"
      },
      {
        "codigo": "K089",
        "valor": "TRASTORNO DE LOS DIENTES Y DE SUS ESTRUTURAS DE SOSTEN, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "K09 - QUISTES DE LA REGION BUCAL, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "K090",
        "valor": "QUISTES ORIGINADOS POR EL DESARROLLO DE LOS DIENTES"
      },
      {
        "codigo": "K091",
        "valor": "QUISTES DE LAS FISURAS DE LA REGION ORAL (NO ODONTOGENICOS)"
      },
      {
        "codigo": "K092",
        "valor": "OTROS QUISTES DE LOS MAXILARES"
      },
      {
        "codigo": "K098",
        "valor": "OTROS QUISTES DE LA REGION BUCAL, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "K099",
        "valor": "QUISTE DE LA REGION BUCAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "K10 - OTRAS ENFERMEDADES DE LOS MAXILARES",
    "detalle": [
      {
        "codigo": "K100",
        "valor": "TRASTORNOS DEL DESARROLLO DE LOS MAXILARES"
      },
      {
        "codigo": "K101",
        "valor": "GRANULOMA CENTRAL DE CELULAS GIGANTES"
      },
      {
        "codigo": "K102",
        "valor": "AFECCIONES INFLAMATORIAS DE LOS MAXILARES"
      },
      {
        "codigo": "K103",
        "valor": "ALVEOLITIS DEL MAXILAR"
      },
      {
        "codigo": "K108",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DE LOS MAXILARES"
      },
      {
        "codigo": "K109",
        "valor": "ENFERMEDAD DE LOS MAXILARES, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K11 - ENFERMEDADES DE LAS GLANDULAS SALIVALES",
    "detalle": [
      {
        "codigo": "K110",
        "valor": "ATROFIA DE GLANDULA SALIVAL"
      },
      {
        "codigo": "K111",
        "valor": "HIPERTROFIA DE GLANDULA SALIVAL"
      },
      {
        "codigo": "K112",
        "valor": "SIALADENITIS"
      },
      {
        "codigo": "K113",
        "valor": "ABSCESO DE GLANDULA SALIVAL"
      },
      {
        "codigo": "K114",
        "valor": "FISTULA DE GLANDULA SALIVAL"
      },
      {
        "codigo": "K115",
        "valor": "SIALOLITIASIS"
      },
      {
        "codigo": "K116",
        "valor": "MUCOCELE DE GLANDULA SALIVAL"
      },
      {
        "codigo": "K117",
        "valor": "ALTERACIONES DE LA SECRECION SALIVAL"
      },
      {
        "codigo": "K118",
        "valor": "OTRAS ENFERMEDADES DE LAS GLANDULAS SALIVALES"
      },
      {
        "codigo": "K119",
        "valor": "ENFERMEDAD DE GLANDULA SALIVAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K12 - ESTOMATITIS Y LESIONES AFINES",
    "detalle": [
      {
        "codigo": "K120",
        "valor": "ESTOMATITIS AFTOSA RECURRENTE"
      },
      {
        "codigo": "K121",
        "valor": "OTRAS FORMAS DE ESTOMATITIS"
      },
      {
        "codigo": "K122",
        "valor": "CELULITIS Y ABSCESO DE BOCA"
      },
      {
        "codigo": "K123",
        "valor": "MUCOSITIS ORAL (ULCERATIVA)"
      }
    ]
  },
  {
    "grupo": "K13 - OTRAS ENFERMEDADES DE LOS LABIOS Y DE LA MUCOSA BUCAL",
    "detalle": [
      {
        "codigo": "K130",
        "valor": "ENFERMEDADES DE LOS LABIOS"
      },
      {
        "codigo": "K131",
        "valor": "MORDEDURA DEL LABIO Y DE LA MEJILLA"
      },
      {
        "codigo": "K132",
        "valor": "LEUCOPLASIA Y OTRAS ALTERACIONES DEL EPITELIO BUCAL, INCLUYENDO LA LENGUA"
      },
      {
        "codigo": "K133",
        "valor": "LEUCOPLASIA PILOSA"
      },
      {
        "codigo": "K134",
        "valor": "GRANULOMA Y LESIONES SEMEJANTES DE LA MUCOSA BUCAL"
      },
      {
        "codigo": "K135",
        "valor": "FIBROSIS DE LA SUBMUCOSA BUCAL"
      },
      {
        "codigo": "K136",
        "valor": "HIPERPLASIA IRRITATIVA DE LA MUCOSA BUCAL"
      },
      {
        "codigo": "K137",
        "valor": "OTRAS LESIONES Y LAS NO ESPECIFICADAS DE LA MUCOSA BUCAL"
      }
    ]
  },
  {
    "grupo": "K14 - ENFERMEDADES DE LA LENGUA",
    "detalle": [
      {
        "codigo": "K140",
        "valor": "GLOSITIS"
      },
      {
        "codigo": "K141",
        "valor": "LENGUA GEOGRAFICA"
      },
      {
        "codigo": "K142",
        "valor": "GLOSITIS ROMBOIDEA MEDIANA"
      },
      {
        "codigo": "K143",
        "valor": "HIPERTROFIA DE LAS PAPILAS LINGUALES"
      },
      {
        "codigo": "K144",
        "valor": "ATROFIA DE LAS PAPILAS LINGUALES"
      },
      {
        "codigo": "K145",
        "valor": "LENGUA PLEGADA"
      },
      {
        "codigo": "K146",
        "valor": "GLOSODINIA"
      },
      {
        "codigo": "K148",
        "valor": "OTRAS ENFERMEDADES DE LA LENGUA"
      },
      {
        "codigo": "K149",
        "valor": "ENFERMEDAD DE LA LENGUA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K20 - ESOFAGITIS",
    "detalle": [
      {
        "codigo": "K20X",
        "valor": "ESOFAGITIS"
      }
    ]
  },
  {
    "grupo": "K21 - ENFERMEDAD DEL REFLUJO GASTROESOFAGICO",
    "detalle": [
      {
        "codigo": "K210",
        "valor": "ENFERMEDAD DEL REFLUJO GASTROESOFAGICO CON ESOFAGITIS"
      },
      {
        "codigo": "K219",
        "valor": "ENFERMEDAD DEL REFLUJO GASTROESOFAGICO SIN ESOFAGITIS"
      }
    ]
  },
  {
    "grupo": "K22 - OTRAS ENFERMEDADES DEL ESOFAGO",
    "detalle": [
      {
        "codigo": "K220",
        "valor": "ACALASIA DEL CARDIAS"
      },
      {
        "codigo": "K221",
        "valor": "ULCERA DEL ESOFAGO"
      },
      {
        "codigo": "K222",
        "valor": "OBSTRUCCION DEL ESOFAGO"
      },
      {
        "codigo": "K223",
        "valor": "PERFORACION DEL ESOFAGO"
      },
      {
        "codigo": "K224",
        "valor": "DISQUINESIA DEL ESOFAGO"
      },
      {
        "codigo": "K225",
        "valor": "DIVERTICULO DEL ESOFAGO, ADQUIRIDO"
      },
      {
        "codigo": "K226",
        "valor": "SINDROME DE LACERACION Y HEMORRAGIA GASTROESOFAGICAS"
      },
      {
        "codigo": "K227",
        "valor": "ESOFAGO DE BARRETT"
      },
      {
        "codigo": "K228",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DEL ESOFAGO"
      },
      {
        "codigo": "K229",
        "valor": "ENFERMEDAD DEL ESOFAGO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K23 - TRASTORNOS DEL ESOFAGO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "K230",
        "valor": "ESOFAGITIS TUBERCULOSA"
      },
      {
        "codigo": "K231",
        "valor": "MEGAESOFAGO EN LA ENFERMEDAD DE CHAGAS"
      },
      {
        "codigo": "K238",
        "valor": "TRASTORNOS DEL ESOFAGO EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "K25 - ULCERA GASTRICA",
    "detalle": [
      {
        "codigo": "K250",
        "valor": "ULCERA GASTRICA, AGUDA CON HEMORRAGIA"
      },
      {
        "codigo": "K251",
        "valor": "ULCERA GASTRICA, AGUDA CON PERFORACION"
      },
      {
        "codigo": "K252",
        "valor": "ULCERA GASTRICA, AGUDA CON HEMORRAGIA Y PERFORACION"
      },
      {
        "codigo": "K253",
        "valor": "ULCERA GASTRICA, AGUDA SIN HEMORRAGIA NI PERFORACION"
      },
      {
        "codigo": "K254",
        "valor": "ULCERA GASTRICA, CRONICA O NO ESPECIFICADA, CON HEMORRAGIA"
      },
      {
        "codigo": "K255",
        "valor": "ULCERA GASTRICA, CRONICA O NO ESPECIFICADA, CON PERFORACION"
      },
      {
        "codigo": "K256",
        "valor": "ULCERA GASTRICA, CRONICA O NO ESPECIFICADA, CON HEMORRAGIA Y PERFORACION"
      },
      {
        "codigo": "K257",
        "valor": "ULCERA GASTRICA, CRONICA SIN HEMORRAGIA NI PERFORACION"
      },
      {
        "codigo": "K259",
        "valor": "ULCERA GASTRICA, NO ESPECIFICADA COMO AGUDA NI CRONICA, SIN HEMORRAGIA NI PERFORACION"
      }
    ]
  },
  {
    "grupo": "K26 - ULCERA DUODENAL",
    "detalle": [
      {
        "codigo": "K260",
        "valor": "ULCERA DUODENAL, AGUDA CON HEMORRAGIA"
      },
      {
        "codigo": "K261",
        "valor": "ULCERA DUODENAL, AGUDA CON PERFORACION"
      },
      {
        "codigo": "K262",
        "valor": "ULCERA DUODENAL, AGUDA CON HEMORRAGIA Y PERFORACION"
      },
      {
        "codigo": "K263",
        "valor": "ULCERA DUODENAL, AGUDA SIN HEMORRAGIA NI PERFORACION"
      },
      {
        "codigo": "K264",
        "valor": "ULCERA DUODENAL, CRONICA O NO ESPECIFICADA, CON HEMORRAGIA"
      },
      {
        "codigo": "K265",
        "valor": "ULCERA DUODENAL, CRONICA O NO ESPECIFICADA, CON PERFORACION"
      },
      {
        "codigo": "K266",
        "valor": "ULCERA DUODENAL, CRONICA O NO ESPECIFICADA, CON HEMORRAGIA Y PERFORACION"
      },
      {
        "codigo": "K267",
        "valor": "ULCERA DUODENAL, CRONICA SIN HEMORRAGIA NI PERFORACION"
      },
      {
        "codigo": "K269",
        "valor": "ULCERA DUODENAL, NO ESPECIFICADA COMO AGUDA NI CRONICA, SIN HEMORRAGIA NI PERFORACION"
      }
    ]
  },
  {
    "grupo": "K27 - ULCERA PEPTICA, DE SITIO NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "K270",
        "valor": "ULCERA PEPTICA, DE SITIO NO ESPECIFICADO, AGUDA CON HEMORRAGIA"
      },
      {
        "codigo": "K271",
        "valor": "ULCERA PEPTICA, DE SITIO NO ESPECIFICADO, AGUDA CON PERFORACION"
      },
      {
        "codigo": "K272",
        "valor": "ULCERA PEPTICA, DE SITIO NO ESPECIFICADO, AGUDA CON HEMORRAGIA Y PERFORACION"
      },
      {
        "codigo": "K273",
        "valor": "ULCERA PEPTICA, DE SITIO NO ESPECIFICADO, AGUDA SIN HEMORRAGIA NI PERFORACION"
      },
      {
        "codigo": "K274",
        "valor": "ULCERA PEPTICA, DE SITIO NO ESPECIFICADO, CRONICA O NO ESPECIFICADA, CON HEMORRAGIA"
      },
      {
        "codigo": "K275",
        "valor": "ULCERA PEPTICA, DE SITIO NO ESPECIFICADO, CRONICA O NO ESPECIFICADA, CON PERFORACION"
      },
      {
        "codigo": "K276",
        "valor": "ULCERA PEPTICA, DE SITIO NO ESPECIFICADO, CRONICA O NO ESPECIFICADA, CON HEMORRAGIA Y PERFORACION"
      },
      {
        "codigo": "K277",
        "valor": "ULCERA PEPTICA, DE SITIO NO ESPECIFICADO, CRONICA SIN HEMORRAGIA NI PERFORACION"
      },
      {
        "codigo": "K279",
        "valor": "ULCERA PEPTICA, DE SITIO NO ESPECIFICADO, NO ESPECIFICADA COMO AGUDA NI CRONICA, SIN HEMORRAGIA NI PERFORACION"
      }
    ]
  },
  {
    "grupo": "K28 - ULCERA GASTROYEYUNAL",
    "detalle": [
      {
        "codigo": "K280",
        "valor": "ULCERA GASTROYEYUNAL, AGUDA CON HEMORRAGIA"
      },
      {
        "codigo": "K281",
        "valor": "ULCERA GASTROYEYUNAL, AGUDA CON PERFORACION"
      },
      {
        "codigo": "K282",
        "valor": "ULCERA GASTROYEYUNAL, AGUDA CON HEMORRAGIA Y PERFORACION"
      },
      {
        "codigo": "K283",
        "valor": "ULCERA GASTROYEYUNAL, AGUDA SIN HEMORRAGIA NI PERFORACION"
      },
      {
        "codigo": "K284",
        "valor": "ULCERA GASTROYEYUNAL, CRONICA O NO ESPECIFICADA, CON HEMORRAGIA"
      },
      {
        "codigo": "K285",
        "valor": "ULCERA GASTROYEYUNAL, CRONICA O NO ESPECIFICADA, CON PERFORACION"
      },
      {
        "codigo": "K286",
        "valor": "ULCERA GASTROYEYUNAL, CRONICA O NO ESPECIFICADA, CON HEMORRAGIA Y PERFORACION"
      },
      {
        "codigo": "K287",
        "valor": "ULCERA GASTROYEYUNAL, CRONICA SIN HEMORRAGIA NI PERFORACION"
      },
      {
        "codigo": "K289",
        "valor": "ULCERA GASTROYEYUNAL, NO ESPECIFICADA COMO AGUDA NI CRONICA, SIN HEMORRAGIA NI PERFORACION"
      }
    ]
  },
  {
    "grupo": "K29 - GASTRITIS Y DUODENITIS",
    "detalle": [
      {
        "codigo": "K290",
        "valor": "GASTRITIS AGUDA HEMORRAGICA"
      },
      {
        "codigo": "K291",
        "valor": "OTRAS GASTRITIS AGUDAS"
      },
      {
        "codigo": "K292",
        "valor": "GASTRITIS ALCOHOLICA"
      },
      {
        "codigo": "K293",
        "valor": "GASTRITIS CRONICA SUPERFICIAL"
      },
      {
        "codigo": "K294",
        "valor": "GASTRITIS CRONICA ATROFICA"
      },
      {
        "codigo": "K295",
        "valor": "GASTRITIS CRONICA, NO ESPECIFICADA"
      },
      {
        "codigo": "K296",
        "valor": "OTRAS GASTRITIS"
      },
      {
        "codigo": "K297",
        "valor": "GASTRITIS, NO ESPECIFICADA"
      },
      {
        "codigo": "K298",
        "valor": "DUODENITIS"
      },
      {
        "codigo": "K299",
        "valor": "GASTRODUODENITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K30 - DISPEPSIA",
    "detalle": [
      {
        "codigo": "K30X",
        "valor": "DISPEPSIA"
      }
    ]
  },
  {
    "grupo": "K31 - OTRAS ENFERMEDADES DEL ESTOMAGO Y DEL DUODENO",
    "detalle": [
      {
        "codigo": "K310",
        "valor": "DILATACION AGUDA DEL ESTOMAGO"
      },
      {
        "codigo": "K311",
        "valor": "ESTENOSIS PILORICA HIPERTROFICA DEL ADULTO"
      },
      {
        "codigo": "K312",
        "valor": "ESTRECHEZ O ESTENOSIS DEL ESTOMAGO EN RELOJ DE ARENA"
      },
      {
        "codigo": "K313",
        "valor": "ESPASMO DEL PILORO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "K314",
        "valor": "DIVERTICULO GASTRICO"
      },
      {
        "codigo": "K315",
        "valor": "OBSTRUCCION DEL DUODENO"
      },
      {
        "codigo": "K316",
        "valor": "FISTULA DEL ESTOMAGO Y DEL DUODENO"
      },
      {
        "codigo": "K317",
        "valor": "POLIPO DEL ESTOMAGO Y DEL DUODENO"
      },
      {
        "codigo": "K318",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DEL ESTOMAGO Y DEL DUODENO"
      },
      {
        "codigo": "K319",
        "valor": "ENFERMEDAD DEL ESTOMAGO Y DEL DUODENO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K35 - APENDICITIS AGUDA",
    "detalle": [
      {
        "codigo": "K350",
        "valor": "APENDICITIS AGUDA CON PERITONITIS GENERALIZADA"
      },
      {
        "codigo": "K351",
        "valor": "APENDICITIS AGUDA CON ABSCESO PERITONEAL"
      },
      {
        "codigo": "K353",
        "valor": "APENDICITIS AGUDA CON PERITONITIS LOCALIZADA"
      },
      {
        "codigo": "K358",
        "valor": "OTRAS APENDICITIS AGUDAS, Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "K359",
        "valor": "APENDICITIS AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K36 - OTROS TIPOS DE APENDICITIS",
    "detalle": [
      {
        "codigo": "K36X",
        "valor": "OTROS TIPOS DE APENDICITIS"
      }
    ]
  },
  {
    "grupo": "K37 - APENDICITIS, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "K37X",
        "valor": "APENDICITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K38 - OTRAS ENFERMEDADES DEL APENDICE",
    "detalle": [
      {
        "codigo": "K380",
        "valor": "HIPERPLASIA DEL APENDICE"
      },
      {
        "codigo": "K381",
        "valor": "CONCRECIONES APENDICULARES"
      },
      {
        "codigo": "K382",
        "valor": "DIVERTICULO DEL APENDICE"
      },
      {
        "codigo": "K383",
        "valor": "FISTULA DEL APENDICE"
      },
      {
        "codigo": "K388",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DEL APENDICE"
      },
      {
        "codigo": "K389",
        "valor": "ENFERMEDAD DEL APENDICE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K40 - HERNIA INGUINAL",
    "detalle": [
      {
        "codigo": "K400",
        "valor": "HERNIA INGUINAL BILATERAL CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K401",
        "valor": "HERNIA INGUINAL BILATERAL, CON GANGRENA"
      },
      {
        "codigo": "K402",
        "valor": "HERNIA INGUINAL BILATERAL, SIN OBSTRUCCION NI GANGRENA"
      },
      {
        "codigo": "K403",
        "valor": "HERNIA INGUINAL UNILATERAL O NO ESPECIFICADA, CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K404",
        "valor": "HERNIA INGUINAL UNILATERAL O NO ESPECIFICADA, CON GANGRENA"
      },
      {
        "codigo": "K409",
        "valor": "HERNIA INGUINAL UNILATERAL O NO ESPECIFICADA, SIN OBSTRUCCION NI GANGRENA"
      }
    ]
  },
  {
    "grupo": "K41 - HERNIA FEMORAL",
    "detalle": [
      {
        "codigo": "K410",
        "valor": "HERNIA FEMORAL BILATERAL, CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K411",
        "valor": "HERNIA FEMORAL BILATERAL, CON GANGRENA"
      },
      {
        "codigo": "K412",
        "valor": "HERNIA FEMORAL BILATERAL, SIN OBSTRUCCION NI GANGRENA"
      },
      {
        "codigo": "K413",
        "valor": "HERNIA FEMORAL UNILATERAL O NO ESPECIFICADA, CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K414",
        "valor": "HERNIA FEMORAL UNILATERAL O NO ESPECIFICADA, CON GANGRENA"
      },
      {
        "codigo": "K419",
        "valor": "HERNIA FEMORAL UNILATERAL O NO ESPECIFICADA, SIN OBSTRUCCION NI GANGRENA"
      }
    ]
  },
  {
    "grupo": "K42 - HERNIA UMBILICAL",
    "detalle": [
      {
        "codigo": "K420",
        "valor": "HERNIA UMBILICAL CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K421",
        "valor": "HERNIA UMBILICAL CON GANGRENA"
      },
      {
        "codigo": "K429",
        "valor": "HERNIA UMBILICAL SIN OBSTRUCCION NI GANGRENA"
      }
    ]
  },
  {
    "grupo": "K43 - HERNIA VENTRAL",
    "detalle": [
      {
        "codigo": "K430",
        "valor": "HERNIA INCISIONAL CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K431",
        "valor": "HERNIA INCISIONAL CON GANGRENA"
      },
      {
        "codigo": "K432",
        "valor": "HERNIA INCISIONAL SIN OBSTRUCCION O GANGRENA"
      },
      {
        "codigo": "K433",
        "valor": "HERNIA PARAESTOMAL CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K434",
        "valor": "HERNIA PARAESTOMAL CON GANGRENA"
      },
      {
        "codigo": "K435",
        "valor": "HERNIA PARAESTOMAL SIN OBSTRUCCION O GANGRENA"
      },
      {
        "codigo": "K436",
        "valor": "OTRAS HERNIAS VENTRALES Y LAS NO ESPECIFICADAS CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K437",
        "valor": "OTRAS HERNIAS VENTRALES Y LAS NO ESPECIFICADAS CON GANGRENA"
      },
      {
        "codigo": "K439",
        "valor": "OTRAS HERNIAS VENTRALES Y LAS NO ESPECIFICADAS SIN OBSTRUCCION O GANGRENA"
      }
    ]
  },
  {
    "grupo": "K44 - HERNIA DIAFRAGMATICA",
    "detalle": [
      {
        "codigo": "K440",
        "valor": "HERNIA DIAFRAGMATICA CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K441",
        "valor": "HERNIA DIAFRAGMATICA CON GANGRENA"
      },
      {
        "codigo": "K449",
        "valor": "HERNIA DIAFRAGMATICA SIN OBSTRUCCION NI GANGRENA"
      }
    ]
  },
  {
    "grupo": "K45 - OTRAS HERNIAS DE LA CAVIDAD ABDOMINAL",
    "detalle": [
      {
        "codigo": "K450",
        "valor": "OTRAS HERNIAS DE LA CAVIDAD ABDOMINAL ESPECIFICADAS, CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K451",
        "valor": "OTRAS HERNIAS DE LA CAVIDAD ABDOMINAL ESPECIFICADAS, CON GANGRENA"
      },
      {
        "codigo": "K458",
        "valor": "OTRAS HERNIAS DE LA CAVIDAD ABDOMINAL ESPECIFICADAS, SIN OBSTRUCCION NI GANGRENA"
      }
    ]
  },
  {
    "grupo": "K46 - HERNIA NO ESPECIFICADA DE LA CAVIDAD ABDOMINAL",
    "detalle": [
      {
        "codigo": "K460",
        "valor": "HERNIA ABDOMINAL NO ESPECIFICADA, CON OBSTRUCCION, SIN GANGRENA"
      },
      {
        "codigo": "K461",
        "valor": "HERNIA ABDOMINAL NO ESPECIFICADA, CON GANGRENA"
      },
      {
        "codigo": "K469",
        "valor": "HERNIA ABDOMINAL NO ESPECIFICADA, SIN OBSTRUCCION NI GANGRENA"
      }
    ]
  },
  {
    "grupo": "K50 - ENFERMEDAD DE CROHN [ENTERITIS REGIONAL]",
    "detalle": [
      {
        "codigo": "K500",
        "valor": "ENFERMEDAD DE CROHN DEL INTESTINO DELGADO"
      },
      {
        "codigo": "K501",
        "valor": "ENFERMEDAD DE CROHN DEL INTESTINO GRUESO"
      },
      {
        "codigo": "K508",
        "valor": "OTROS TIPOS DE ENFERMEDAD DE CROHN"
      },
      {
        "codigo": "K509",
        "valor": "ENFERMEDAD DE CROHN, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K51 - COLITIS ULCERATIVA",
    "detalle": [
      {
        "codigo": "K510",
        "valor": "PANCOLITIS ULCERATIVA (CRONICA)"
      },
      {
        "codigo": "K511",
        "valor": "ILEOCOLITIS (CRONICA) ULCERATIVA"
      },
      {
        "codigo": "K512",
        "valor": "PROCTITIS (CRONICA) ULCERATIVA"
      },
      {
        "codigo": "K513",
        "valor": "RECTOSIGMOIDITIS (CRONICA) ULCERATIVA"
      },
      {
        "codigo": "K514",
        "valor": "POLIPOS INFLAMATORIOS"
      },
      {
        "codigo": "K515",
        "valor": "COLITIS DEL LADO IZQUIERDO"
      },
      {
        "codigo": "K518",
        "valor": "OTRAS COLITIS ULCERATIVAS"
      },
      {
        "codigo": "K519",
        "valor": "COLITIS ULCERATIVA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "K52 - OTRAS COLITIS Y GASTROENTERITIS NO INFECCIOSAS",
    "detalle": [
      {
        "codigo": "K520",
        "valor": "COLITIS Y GASTROENTERITIS DEBIDAS A RADIACION"
      },
      {
        "codigo": "K521",
        "valor": "COLITIS Y GASTROENTERITIS TOXICAS"
      },
      {
        "codigo": "K522",
        "valor": "COLITIS Y GASTROENTERITIS ALERGICAS Y DIETETICAS"
      },
      {
        "codigo": "K523",
        "valor": "COLITIS DE ETIOLOGIA INDETERMINADA"
      },
      {
        "codigo": "K528",
        "valor": "OTRAS COLITIS Y GASTROENTERITIS NO INFECCIOSAS ESPECIFICADAS"
      },
      {
        "codigo": "K529",
        "valor": "COLITIS Y GASTROENTERITIS NO INFECCIOSAS, NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "K55 - TRASTORNOS VASCULARES DE LOS INTESTINOS",
    "detalle": [
      {
        "codigo": "K550",
        "valor": "TRASTORNO VASCULAR AGUDO DE LOS INTESTINOS"
      },
      {
        "codigo": "K551",
        "valor": "TRASTORNO VASCULAR CRONICO DEL INTESTINO"
      },
      {
        "codigo": "K552",
        "valor": "ANGIODISPLASIA DEL COLON"
      },
      {
        "codigo": "K558",
        "valor": "OTROS TRASTORNOS VASCULARES DEL INTESTINO"
      },
      {
        "codigo": "K559",
        "valor": "TRASTORNO VASCULAR DEL INTESTINO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "K56 - ILEO PARALITICO Y OBSTRUCCION INTESTINAL SIN HERNIA",
    "detalle": [
      {
        "codigo": "K560",
        "valor": "ILEO PARALITICO"
      },
      {
        "codigo": "K561",
        "valor": "INVAGINACION"
      },
      {
        "codigo": "K562",
        "valor": "VOLVULO"
      },
      {
        "codigo": "K563",
        "valor": "ILEO POR CALCULO BILIAR"
      },
      {
        "codigo": "K564",
        "valor": "OTRAS OBSTRUCCIONES DEL INTESTINO"
      },
      {
        "codigo": "K565",
        "valor": "ADHERENCIAS [BRIDAS] INTESTINALES CON OBSTRUCCION"
      },
      {
        "codigo": "K566",
        "valor": "OTRAS OBSTRUCCIONES INTESTINALES Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "K567",
        "valor": "ILEO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "K57 - ENFERMEDAD DIVERTICULAR DEL INTESTINO",
    "detalle": [
      {
        "codigo": "K570",
        "valor": "ENFERMEDAD DIVERTICULAR DEL INTESTINO DELGADO CON PERFORACION Y ABSCESO"
      },
      {
        "codigo": "K571",
        "valor": "ENFERMEDAD DIVERTICULAR DEL INTESTINO DELGADO SIN PERFORACION NI ABSCESO"
      },
      {
        "codigo": "K572",
        "valor": "ENFERMEDAD DIVERTICULAR DEL INTESTINO GRUESO CON PERFORACION Y ABSCESO"
      },
      {
        "codigo": "K573",
        "valor": "ENFERMEDAD DIVERTICULAR DEL INTESTINO GRUESO SIN PERFORACION NI ABSCESO"
      },
      {
        "codigo": "K574",
        "valor": "ENFERMEDAD DIVERTICULAR DE AMBOS INTESTINOS CON PERFORACION Y ABSCESO"
      },
      {
        "codigo": "K575",
        "valor": "ENFERMEDAD DIVERTICULAR DE AMBOS INTESTINOS, SIN PERFORACION NI ABSCESO"
      },
      {
        "codigo": "K578",
        "valor": "ENFERMEDAD DIVERTICULAR DEL INTESTINO, PARTE NO ESPECIFICADA, CON PERFORACION Y ABSCESO"
      },
      {
        "codigo": "K579",
        "valor": "ENFERMEDAD DIVERTICULAR DEL INTESTINO, PARTE NO ESPECIFICADA, SIN PERFORACION NI ABSCESO"
      }
    ]
  },
  {
    "grupo": "K58 - SINDROME DEL COLON IRRITABLE",
    "detalle": [
      {
        "codigo": "K580",
        "valor": "SINDROME DEL COLON IRRITABLE CON DIARREA"
      },
      {
        "codigo": "K589",
        "valor": "SINDROME DEL COLON IRRITABLE SIN DIARREA"
      }
    ]
  },
  {
    "grupo": "K59 - OTROS TRASTORNOS FUNCIONALES DEL INTESTINO",
    "detalle": [
      {
        "codigo": "K590",
        "valor": "CONSTIPACION"
      },
      {
        "codigo": "K591",
        "valor": "DIARREA FUNCIONAL"
      },
      {
        "codigo": "K592",
        "valor": "INTESTINO NEUROGENICO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "K593",
        "valor": "MEGACOLON, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "K594",
        "valor": "ESPASMO ANAL"
      },
      {
        "codigo": "K598",
        "valor": "OTROS TRASTORNOS FUNCIONALES ESPECIFICADOS DEL INTESTINO"
      },
      {
        "codigo": "K599",
        "valor": "TRASTORNO FUNCIONAL INTESTINAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "K60 - FISURA Y FISTULA DE LAS REGIONES ANAL Y RECTAL",
    "detalle": [
      {
        "codigo": "K600",
        "valor": "FISURA ANAL AGUDA"
      },
      {
        "codigo": "K601",
        "valor": "FISURA ANAL CRONICA"
      },
      {
        "codigo": "K602",
        "valor": "FISURA ANAL, NO ESPECIFICADA"
      },
      {
        "codigo": "K603",
        "valor": "FISTULA ANAL"
      },
      {
        "codigo": "K604",
        "valor": "FISTULA RECTAL"
      },
      {
        "codigo": "K605",
        "valor": "FISTULA ANORRECTAL"
      }
    ]
  },
  {
    "grupo": "K61 - ABSCESO DE LAS REGIONES ANAL Y RECTAL",
    "detalle": [
      {
        "codigo": "K610",
        "valor": "ABSCESO ANAL"
      },
      {
        "codigo": "K611",
        "valor": "ABSCESO RECTAL"
      },
      {
        "codigo": "K612",
        "valor": "ABSCESO ANORRECTAL"
      },
      {
        "codigo": "K613",
        "valor": "ABSCESO ISQUIORRECTAL"
      },
      {
        "codigo": "K614",
        "valor": "ABSCESO INTRAESFINTERIANO"
      }
    ]
  },
  {
    "grupo": "K62 - OTRAS ENFERMEDADES DEL ANO Y DEL RECTO",
    "detalle": [
      {
        "codigo": "K620",
        "valor": "POLIPO ANAL"
      },
      {
        "codigo": "K621",
        "valor": "POLIPO RECTAL"
      },
      {
        "codigo": "K622",
        "valor": "PROLAPSO ANAL"
      },
      {
        "codigo": "K623",
        "valor": "PROLAPSO RECTAL"
      },
      {
        "codigo": "K624",
        "valor": "ESTENOSIS DEL ANO Y DEL RECTO"
      },
      {
        "codigo": "K625",
        "valor": "HEMORRAGIA DEL ANO Y DEL RECTO"
      },
      {
        "codigo": "K626",
        "valor": "ULCERA DEL ANO Y DEL RECTO"
      },
      {
        "codigo": "K627",
        "valor": "PROCTITIS POR RADIACION"
      },
      {
        "codigo": "K628",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DEL ANO Y DEL RECTO"
      },
      {
        "codigo": "K629",
        "valor": "ENFERMEDAD DEL ANO Y DEL RECTO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K63 - OTRAS ENFERMEDADES DE LOS INTESTINOS",
    "detalle": [
      {
        "codigo": "K630",
        "valor": "ABSCESO DEL INTESTINO"
      },
      {
        "codigo": "K631",
        "valor": "PERFORACION DEL INTESTINO (NO TRAUMATICA)"
      },
      {
        "codigo": "K632",
        "valor": "FISTULA DEL INTESTINO"
      },
      {
        "codigo": "K633",
        "valor": "ULCERA DEL INTESTINO"
      },
      {
        "codigo": "K634",
        "valor": "ENTEROPTOSIS"
      },
      {
        "codigo": "K635",
        "valor": "POLIPO DEL COLON"
      },
      {
        "codigo": "K638",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DEL INTESTINO"
      },
      {
        "codigo": "K639",
        "valor": "ENFERMEDAD DEL INTESTINO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K64 - HEMORROIDES Y TROMBOSIS VENOSA PERIAANAL",
    "detalle": [
      {
        "codigo": "K640",
        "valor": "HEMORROIDES DE PRIMER GRADO"
      },
      {
        "codigo": "K641",
        "valor": "HEMORROIDES DE SEGUNDO GRADO"
      },
      {
        "codigo": "K642",
        "valor": "HEMORROIDES DE TERCER GRADO"
      },
      {
        "codigo": "K643",
        "valor": "HEMORROIDES DE CUARTO GRADO"
      },
      {
        "codigo": "K644",
        "valor": "MARCAS RESIDUALES EN LA PIEL, DE HEMORROIDES"
      },
      {
        "codigo": "K645",
        "valor": "TROMBOSIS VENOSA PERIANAL"
      },
      {
        "codigo": "K648",
        "valor": "OTRAS HEMORROIDES ESPECIFICADAS"
      },
      {
        "codigo": "K649",
        "valor": "HEMORROIDES, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "K65 - PERITONITIS",
    "detalle": [
      {
        "codigo": "K650",
        "valor": "PERITONITIS AGUDA"
      },
      {
        "codigo": "K658",
        "valor": "OTRAS PERITONITIS"
      },
      {
        "codigo": "K659",
        "valor": "PERITONITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K66 - OTROS TRASTORNOS DEL PERITONEO",
    "detalle": [
      {
        "codigo": "K660",
        "valor": "ADHERENCIAS PERITONEALES"
      },
      {
        "codigo": "K661",
        "valor": "HEMOPERITONEO"
      },
      {
        "codigo": "K668",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL PERITONEO"
      },
      {
        "codigo": "K669",
        "valor": "TRASTORNO DEL PERITONEO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "K67 - TRASTORNOS DEL PERITONEO EN ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "K670",
        "valor": "PERITONITIS POR CLAMIDIAS"
      },
      {
        "codigo": "K671",
        "valor": "PERITONITIS GONOCOCICA"
      },
      {
        "codigo": "K672",
        "valor": "PERITONITIS SIFILITICA"
      },
      {
        "codigo": "K673",
        "valor": "PERITONITIS TUBERCULOSA"
      },
      {
        "codigo": "K678",
        "valor": "OTROS TRASTORNOS DEL PERITONEO EN ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "K70 - ENFERMEDAD ALCOHOLICA DEL HIGADO",
    "detalle": [
      {
        "codigo": "K700",
        "valor": "HIGADO ALCOHOLICO ADIPOSO"
      },
      {
        "codigo": "K701",
        "valor": "HEPATITIS ALCOHOLICA"
      },
      {
        "codigo": "K702",
        "valor": "FIBROSIS Y ESCLEROSIS DEL HIGADO, ALCOHOLICA"
      },
      {
        "codigo": "K703",
        "valor": "CIRROSIS HEPATICA ALCOHOLICA"
      },
      {
        "codigo": "K704",
        "valor": "INSUFICIENCIA HEPATICA ALCOHOLICA"
      },
      {
        "codigo": "K709",
        "valor": "ENFERMEDAD HEPATICA ALCOHOLICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K71 - ENFERMEDAD TOXICA DEL HIGADO",
    "detalle": [
      {
        "codigo": "K710",
        "valor": "ENFERMEDAD TOXICA DEL HIGADO, CON COLESTASIS"
      },
      {
        "codigo": "K711",
        "valor": "ENFERMEDAD TOXICA DEL HIGADO CON NECROSIS HEPATICA"
      },
      {
        "codigo": "K712",
        "valor": "ENFERMEDAD TOXICA DEL HIGADO CON HEPATITIS AGUDA"
      },
      {
        "codigo": "K713",
        "valor": "ENFERMEDAD TOXICA DEL HIGADO CON HEPATITIS CRONICA PERSISTENTE"
      },
      {
        "codigo": "K714",
        "valor": "ENFERMEDAD TOXICA DEL HIGADO CON HEPATITIS CRONICA LOBULAR"
      },
      {
        "codigo": "K715",
        "valor": "ENFERMEDAD TOXICA DEL HIGADO CON HEPATITIS CRONICA ACTIVA"
      },
      {
        "codigo": "K716",
        "valor": "ENFERMEDAD TOXICA DEL HIGADO CON HEPATITIS NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "K717",
        "valor": "ENFERMEDAD TOXICA DEL HIGADO CON CIRROSIS Y FIBROSIS DEL HIGADO"
      },
      {
        "codigo": "K718",
        "valor": "ENFERMEDAD TOXICA DEL HIGADO CON OTROS TRASTORNOS HEPATICOS"
      },
      {
        "codigo": "K719",
        "valor": "ENFERMEDAD TOXICA DEL HIGADO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K72 - INSUFICIENCIA HEPATICA, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "K720",
        "valor": "INSUFICIENCIA HEPATICA AGUDA O SUBAGUDA"
      },
      {
        "codigo": "K721",
        "valor": "INSUFICIENCIA HEPATICA CRONICA"
      },
      {
        "codigo": "K729",
        "valor": "INSUFICIENCIA HEPATICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K73 - HEPATITIS CRONICA, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "K730",
        "valor": "HEPATITIS CRONICA PERSISTENTE, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "K731",
        "valor": "HEPATITIS CRONICA LOBULAR, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "K732",
        "valor": "HEPATITIS CRONICA ACTIVA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "K738",
        "valor": "OTRAS HEPATITIS CRONICAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "K739",
        "valor": "HEPATITIS CRONICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K74 - FIBROSIS Y CIRROSIS DEL HIGADO",
    "detalle": [
      {
        "codigo": "K740",
        "valor": "FIBROSIS HEPATICA"
      },
      {
        "codigo": "K741",
        "valor": "ESCLEROSIS HEPATICA"
      },
      {
        "codigo": "K742",
        "valor": "FIBROSIS HEPATICA CON ESCLEROSIS HEPATICA"
      },
      {
        "codigo": "K743",
        "valor": "CIRROSIS BILIAR PRIMARIA"
      },
      {
        "codigo": "K744",
        "valor": "CIRROSIS BILIAR SECUNDARIA"
      },
      {
        "codigo": "K745",
        "valor": "CIRROSIS BILIAR, NO ESPECIFICADA"
      },
      {
        "codigo": "K746",
        "valor": "OTRAS CIRROSIS DEL HIGADO Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "K75 - OTRAS ENFERMEDADES INFLAMATORIAS DEL HIGADO",
    "detalle": [
      {
        "codigo": "K750",
        "valor": "ABSCESO DEL HIGADO"
      },
      {
        "codigo": "K751",
        "valor": "FLEBITIS DE LA VENA PORTA"
      },
      {
        "codigo": "K752",
        "valor": "HEPATITIS REACTIVA NO ESPECIFICADA"
      },
      {
        "codigo": "K753",
        "valor": "HEPATITIS GRANULOMATOSA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "K754",
        "valor": "HEPATITIS AUTOINMUNE"
      },
      {
        "codigo": "K758",
        "valor": "OTRAS ENFERMEDADES INFLAMATORIAS DEL HIGADO, ESPECIFICADAS"
      },
      {
        "codigo": "K759",
        "valor": "ENFERMEDAD INFLAMATORIA DEL HIGADO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K76 - OTRAS ENFERMEDADES DEL HIGADO",
    "detalle": [
      {
        "codigo": "K760",
        "valor": "DEGENERACION GRASA DEL HIGADO, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "K761",
        "valor": "CONGESTION PASIVA CRONICA DEL HIGADO"
      },
      {
        "codigo": "K762",
        "valor": "NECROSIS HEMORRAGICA CENTRAL DEL HIGADO"
      },
      {
        "codigo": "K763",
        "valor": "INFARTO DEL HIGADO"
      },
      {
        "codigo": "K764",
        "valor": "PELIOSIS HEPATICA"
      },
      {
        "codigo": "K765",
        "valor": "ENFERMEDAD VENO-OCLUSIVA DEL HIGADO"
      },
      {
        "codigo": "K766",
        "valor": "HIPERTENSION PORTAL"
      },
      {
        "codigo": "K767",
        "valor": "SINDROME HEPATORRENAL"
      },
      {
        "codigo": "K768",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DEL HIGADO"
      },
      {
        "codigo": "K769",
        "valor": "ENFERMEDAD DEL HIGADO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K77 - TRASTORNOS DEL HIGADO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "K770",
        "valor": "TRASTORNOS DEL HIGADO EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "K778",
        "valor": "TRASTORNOS DEL HIGADO EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "K80 - COLELITIASIS",
    "detalle": [
      {
        "codigo": "K800",
        "valor": "CALCULO DE LA VESICULA BILIAR CON COLECISTITIS AGUDA"
      },
      {
        "codigo": "K801",
        "valor": "CALCULO DE LA VESICULA BILIAR CON OTRA COLECISTITIS"
      },
      {
        "codigo": "K802",
        "valor": "CALCULO DE LA VESICULA BILIAR SIN COLECISTITIS"
      },
      {
        "codigo": "K803",
        "valor": "CALCULO DE CONDUCTO BILIAR CON COLANGITIS"
      },
      {
        "codigo": "K804",
        "valor": "CALCULO DE CONDUCTO BILIAR CON COLECISTITIS"
      },
      {
        "codigo": "K805",
        "valor": "CALCULO DE CONDUCTO BILIAR SIN COLANGITIS NI COLECISTITIS"
      },
      {
        "codigo": "K808",
        "valor": "OTRAS COLELITIASIS"
      }
    ]
  },
  {
    "grupo": "K81 - COLECISTITIS",
    "detalle": [
      {
        "codigo": "K810",
        "valor": "COLECISTITIS AGUDA"
      },
      {
        "codigo": "K811",
        "valor": "COLECISTITIS CRONICA"
      },
      {
        "codigo": "K818",
        "valor": "OTRAS COLECISTITIS"
      },
      {
        "codigo": "K819",
        "valor": "COLECISTITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K82 - OTRAS ENFERMEDADES DE LA VESICULA BILIAR",
    "detalle": [
      {
        "codigo": "K820",
        "valor": "OBSTRUCCION DE LA VESICULA BILIAR"
      },
      {
        "codigo": "K821",
        "valor": "HIDROPESIA DE LA VESICULA BILIAR"
      },
      {
        "codigo": "K822",
        "valor": "PERFORACION DE LA VESICULA BILIAR"
      },
      {
        "codigo": "K823",
        "valor": "FISTULA DE LA VESICULA BILIAR"
      },
      {
        "codigo": "K824",
        "valor": "COLESTEROLOSIS DE LA VESICULA BILIAR"
      },
      {
        "codigo": "K828",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DE LA VESICULA BILIAR"
      },
      {
        "codigo": "K829",
        "valor": "ENFERMEDAD DE LA VESICULA BILIAR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K83 - OTRAS ENFERMEDADES DE LAS VIAS BILIARES",
    "detalle": [
      {
        "codigo": "K830",
        "valor": "COLANGITIS"
      },
      {
        "codigo": "K831",
        "valor": "OBSTRUCCION DEL CONDUCTO BILIAR"
      },
      {
        "codigo": "K832",
        "valor": "PERFORACION DEL CONDUCTO BILIAR"
      },
      {
        "codigo": "K833",
        "valor": "FISTULA DEL CONDUCTO BILIAR"
      },
      {
        "codigo": "K834",
        "valor": "ESPASMO DEL ESFINTER DE ODDI"
      },
      {
        "codigo": "K835",
        "valor": "QUISTE BILIAR"
      },
      {
        "codigo": "K838",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DE LAS VIAS BILIARES"
      },
      {
        "codigo": "K839",
        "valor": "ENFERMEDAD DE LAS VIAS BILIARES, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K85 - PANCREATITIS AGUDA",
    "detalle": [
      {
        "codigo": "K850",
        "valor": "PANCREATITIS IDIOPATICA AGUDA"
      },
      {
        "codigo": "K851",
        "valor": "PANCREATITIS BILIAR AGUDA"
      },
      {
        "codigo": "K852",
        "valor": "PANCREATITIS AGUDA INDUCIDA POR ALCOHOL"
      },
      {
        "codigo": "K853",
        "valor": "PANCREATITITS AGUDA INDUCIDA POR DROGAS"
      },
      {
        "codigo": "K858",
        "valor": "OTRAS PANCREATITIS AGUDAS"
      },
      {
        "codigo": "K859",
        "valor": "PANCREATITIS AGUDA, NO ESPECIFICADA"
      },
      {
        "codigo": "K85X",
        "valor": "PANCREATITIS AGUDA"
      }
    ]
  },
  {
    "grupo": "K86 - OTRAS ENFERMEDADES DEL PANCREAS",
    "detalle": [
      {
        "codigo": "K860",
        "valor": "PANCREATITIS CRONICA INDUCIDA POR EL ALCOHOL"
      },
      {
        "codigo": "K861",
        "valor": "OTRAS PANCREATITIS CRONICAS"
      },
      {
        "codigo": "K862",
        "valor": "QUISTE DEL PANCREAS"
      },
      {
        "codigo": "K863",
        "valor": "SEUDOQUISTE DEL PANCREAS"
      },
      {
        "codigo": "K868",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DEL PANCREAS"
      },
      {
        "codigo": "K869",
        "valor": "ENFERMEDAD DEL PANCREAS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K87 - TRASTORNOS DE LA VESICULA BILIAR, DE LAS VIAS BILIARES Y DEL PANCREAS",
    "detalle": [
      {
        "codigo": "K870",
        "valor": "TRASTORNOS DE LA VESICULA BILIAR Y DE LAS VIAS BILIARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "K871",
        "valor": "TRASTORNOS DEL PANCREAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "K90 - MALABSORCION INTESTINAL",
    "detalle": [
      {
        "codigo": "K900",
        "valor": "ENFERMEDAD CELIACA"
      },
      {
        "codigo": "K901",
        "valor": "ESPRUE TROPICAL"
      },
      {
        "codigo": "K902",
        "valor": "SINDROME DEL ASA CIEGA, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "K903",
        "valor": "ESTEATORREA PANCREATICA"
      },
      {
        "codigo": "K904",
        "valor": "MALABSORCION DEBIDA A INTOLERANCIA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "K908",
        "valor": "OTROS TIPOS DE MALABSORCION INTESTINAL"
      },
      {
        "codigo": "K909",
        "valor": "MALABSORCION INTESTINAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K91 - TRASTORNOS DEL SISTEMA DIGESTIVO CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "K910",
        "valor": "VOMITO POSTCIRUGIA GASTROINTESTINAL"
      },
      {
        "codigo": "K911",
        "valor": "SINDROMES CONSECUTIVOS A LA CIRUGIA GASTRICA"
      },
      {
        "codigo": "K912",
        "valor": "MALABSORCION POSTQUIRURGICA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "K913",
        "valor": "OBSTRUCCION INTESTINAL POSTOPERATORIA"
      },
      {
        "codigo": "K914",
        "valor": "DISFUNCION DE COLOSTOMIA O ENTEROSTOMIA"
      },
      {
        "codigo": "K915",
        "valor": "SINDROME DE POSTCOLECISTECTOMIA"
      },
      {
        "codigo": "K918",
        "valor": "OTROS TRASTORNOS DEL SISTEMA DIGESTIVO CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "K919",
        "valor": "TRASTORNO NO ESPECIFICADO DEL SISTEMA DIGESTIVO CONSECUTIVO A PROCEDIMIENTOS"
      }
    ]
  },
  {
    "grupo": "K92 - OTRAS ENFERMEDADES DEL SISTEMA DIGESTIVO",
    "detalle": [
      {
        "codigo": "K920",
        "valor": "HEMATEMESIS"
      },
      {
        "codigo": "K921",
        "valor": "MELENA"
      },
      {
        "codigo": "K922",
        "valor": "HEMORRAGIA GASTROINTESTINAL, NO ESPECIFICADA"
      },
      {
        "codigo": "K928",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS DEL SISTEMA DIGESTIVO"
      },
      {
        "codigo": "K929",
        "valor": "ENFERMEDAD DEL SISTEMA DIGESTIVO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "K93 - TRASTORNOS DE OTROS ORGANOS DIGESTIVOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "K930",
        "valor": "TRASTORNOS TUBERCULOSOS DEL INTESTINO, PERITONEO Y GANGLIOS MESENTERICOS"
      },
      {
        "codigo": "K931",
        "valor": "MEGACOLON EN LA ENFERMEDAD DE CHAGAS"
      },
      {
        "codigo": "K938",
        "valor": "TRASTORNOS DE OTROS ORGANOS DIGESTIVOS ESPECIFICADOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "L00 - SINDROME ESTAFILOCOCICO DE LA PIEL ESCALDADA",
    "detalle": [
      {
        "codigo": "L00X",
        "valor": "SINDROME ESTAFILOCOCCICO DE LA PIEL ESCALDADA"
      }
    ]
  },
  {
    "grupo": "L01 - IMPETIGO",
    "detalle": [
      {
        "codigo": "L010",
        "valor": "IMPETIGO [CUALQUIER SITIO ANATOMICO] [CUALQUIER ORGANISMO]"
      },
      {
        "codigo": "L011",
        "valor": "IMPETIGINIZACION DE OTRAS DERMATOSIS"
      }
    ]
  },
  {
    "grupo": "L02 - ABSCESO CUTANEO, FURUNCULO Y CARBUNCO",
    "detalle": [
      {
        "codigo": "L020",
        "valor": "ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE LA CARA"
      },
      {
        "codigo": "L021",
        "valor": "ABSCESO CUTANEO, FURUNCULO Y ANTRAX DEL CUELLO"
      },
      {
        "codigo": "L022",
        "valor": "ABSCESO CUTANEO, FURUNCULO Y ANTRAX DEL TRONCO"
      },
      {
        "codigo": "L023",
        "valor": "ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE GLUTEOS"
      },
      {
        "codigo": "L024",
        "valor": "ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE MIEMBRO"
      },
      {
        "codigo": "L028",
        "valor": "ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE OTROS SITIOS"
      },
      {
        "codigo": "L029",
        "valor": "ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L03 - CELULITIS",
    "detalle": [
      {
        "codigo": "L030",
        "valor": "CELULITIS DE LOS DEDOS DE LA MANO Y DEL PIE"
      },
      {
        "codigo": "L031",
        "valor": "CELULITIS DE OTRAS PARTES DE LOS MIEMBROS"
      },
      {
        "codigo": "L032",
        "valor": "CELULITIS DE LA CARA"
      },
      {
        "codigo": "L033",
        "valor": "CELULITIS DEL TRONCO"
      },
      {
        "codigo": "L038",
        "valor": "CELULITIS DE OTROS SITIOS"
      },
      {
        "codigo": "L039",
        "valor": "CELULITIS DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L04 - LINFADENITIS AGUDA",
    "detalle": [
      {
        "codigo": "L040",
        "valor": "LINFADENITIS AGUDA DE CARA, CABEZA Y CUELLO"
      },
      {
        "codigo": "L041",
        "valor": "LINFADENITIS AGUDA DEL TRONCO"
      },
      {
        "codigo": "L042",
        "valor": "LINFADENITIS AGUDA DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "L043",
        "valor": "LINFADENITIS AGUDA DEL MIEMBRO INFERIOR"
      },
      {
        "codigo": "L048",
        "valor": "LINFADENITIS AGUDA DE OTROS SITIOS"
      },
      {
        "codigo": "L049",
        "valor": "LINFADENITIS AGUDA DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L05 - QUISTE PILONIDAL",
    "detalle": [
      {
        "codigo": "L050",
        "valor": "QUISTE PILONIDAL CON ABSCESO"
      },
      {
        "codigo": "L059",
        "valor": "QUISTE PILONIDAL SIN ABSCESO"
      }
    ]
  },
  {
    "grupo": "L08 - OTRAS INFECCIONES LOCALES DE LA PIEL Y DEL TEJIDO SUBCUTANEO",
    "detalle": [
      {
        "codigo": "L080",
        "valor": "PIODERMA"
      },
      {
        "codigo": "L081",
        "valor": "ERITRASMA"
      },
      {
        "codigo": "L088",
        "valor": "OTRAS INFECCIONES LOCALES ESPECIFICADAS DE LA PIEL Y DEL TEJIDO SUBCUTANEO"
      },
      {
        "codigo": "L089",
        "valor": "INFECCION LOCAL DE LA PIEL Y DEL TEJIDO SUBCUTANEO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L10 - PENFIGO",
    "detalle": [
      {
        "codigo": "L100",
        "valor": "PENFIGO VULGAR"
      },
      {
        "codigo": "L101",
        "valor": "PENFIGO VEGETANTE"
      },
      {
        "codigo": "L102",
        "valor": "PENFIGO FOLIACEO"
      },
      {
        "codigo": "L103",
        "valor": "PENFIGO BRASILEÑO [FOGO SELVAGEM]"
      },
      {
        "codigo": "L104",
        "valor": "PENFIGO ERITEMATOSO"
      },
      {
        "codigo": "L105",
        "valor": "PENFIGO INDUCIDO POR DROGAS"
      },
      {
        "codigo": "L108",
        "valor": "OTROS PENFIGOS"
      },
      {
        "codigo": "L109",
        "valor": "PENFIGO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L11 - OTROS TRASTORNOS ACANTOLITICOS",
    "detalle": [
      {
        "codigo": "L110",
        "valor": "QUERATOSIS FOLICULAR ADQUIRIDA"
      },
      {
        "codigo": "L111",
        "valor": "DERMATOSIS ACANTOLITICA TRANSITORIA [GROVER]"
      },
      {
        "codigo": "L118",
        "valor": "OTROS TRASTORNOS ACANTOLITICOS ESPECIFICADOS"
      },
      {
        "codigo": "L119",
        "valor": "TRASTORNO ACANTOLITICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L12 - PENFIGOIDE",
    "detalle": [
      {
        "codigo": "L120",
        "valor": "PENFIGOIDE FLICTENULAR"
      },
      {
        "codigo": "L121",
        "valor": "PENFIGOIDE CICATRICIAL"
      },
      {
        "codigo": "L122",
        "valor": "ENFERMEDAD FLICTENULAR CRONICA DE LA INFANCIA"
      },
      {
        "codigo": "L123",
        "valor": "EPIDERMOLISIS BULLOSA ADQUIRIDA"
      },
      {
        "codigo": "L128",
        "valor": "OTROS PENFIGOIDES"
      },
      {
        "codigo": "L129",
        "valor": "PENFIGOIDE, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L13 - OTROS TRASTORNOS FLICTENULARES",
    "detalle": [
      {
        "codigo": "L130",
        "valor": "DERMATITIS HERPETIFORME"
      },
      {
        "codigo": "L131",
        "valor": "DERMATITIS PUSTULOSA SUBCORNEAL"
      },
      {
        "codigo": "L138",
        "valor": "OTROS TRASTORNOS FLICTENULARES ESPECIFICADOS"
      },
      {
        "codigo": "L139",
        "valor": "TRASTORNO FLICTENULAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L14 - TRASTORNOS FLICTENULARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "L14X",
        "valor": "TRASTORNOS FLICTENULARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "L20 - DERMATITIS ATOPICA",
    "detalle": [
      {
        "codigo": "L200",
        "valor": "PRURIGO DE BESNIER"
      },
      {
        "codigo": "L208",
        "valor": "OTRAS DERMATITIS ATOPICAS"
      },
      {
        "codigo": "L209",
        "valor": "DERMATITIS ATOPICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L21 - DERMATITIS SEBORREICA",
    "detalle": [
      {
        "codigo": "L210",
        "valor": "SEBORREA CAPITIS"
      },
      {
        "codigo": "L211",
        "valor": "DERMATITIS SEBORREICA INFANTIL"
      },
      {
        "codigo": "L218",
        "valor": "OTRAS DERMATITIS SEBORREICAS"
      },
      {
        "codigo": "L219",
        "valor": "DERMATITIS SEBORREICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L22 - DERMATITIS DEL PAÑAL",
    "detalle": [
      {
        "codigo": "L22X",
        "valor": "DERMATITIS DEL PAÑAL"
      }
    ]
  },
  {
    "grupo": "L23 - DERMATITIS ALERGICA DE CONTACTO",
    "detalle": [
      {
        "codigo": "L230",
        "valor": "DERMATITIS ALERGICA DE CONTACTO DEBIDA A METALES"
      },
      {
        "codigo": "L231",
        "valor": "DERMATITIS ALERGICA DE CONTACTO DEBIDA A ADHESIVOS"
      },
      {
        "codigo": "L232",
        "valor": "DERMATITIS ALERGICA DE CONTACTO DEBIDA A COSMETICOS"
      },
      {
        "codigo": "L233",
        "valor": "DERMATITIS ALERGICA DE CONTACTO DEBIDA A DROGAS EN CONTACTO CON LA PIEL"
      },
      {
        "codigo": "L234",
        "valor": "DERMATITIS ALERGICA DE CONTACTO DEBIDA A COLORANTES"
      },
      {
        "codigo": "L235",
        "valor": "DERMATITIS ALERGICA DE CONTACTO DEBIDA A OTROS PRODUCTOS QUIMICOS"
      },
      {
        "codigo": "L236",
        "valor": "DERMATITIS ALERGICA DE CONTACTO DEBIDA A ALIMENTOS EN CONTACTO CON LA PIEL"
      },
      {
        "codigo": "L237",
        "valor": "DERMATITIS ALERGICA DE CONTACTO DEBIDA A PLANTAS, EXCEPTO LAS ALIMENTICIAS"
      },
      {
        "codigo": "L238",
        "valor": "DERMATITIS ALERGICA DE CONTACTO DEBIDA A OTROS AGENTES"
      },
      {
        "codigo": "L239",
        "valor": "DERMATITIS ALERGICA DE CONTACTO, DE CAUSA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L24 - DERMATITIS DE CONTACTO POR IRRITANTES",
    "detalle": [
      {
        "codigo": "L240",
        "valor": "DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A DETERGENTES"
      },
      {
        "codigo": "L241",
        "valor": "DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A ACEITES Y GRASAS"
      },
      {
        "codigo": "L242",
        "valor": "DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A DISOLVENTES"
      },
      {
        "codigo": "L243",
        "valor": "DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A COSMETICOS"
      },
      {
        "codigo": "L244",
        "valor": "DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A DROGAS EN CONTACTO CON LA PIEL"
      },
      {
        "codigo": "L245",
        "valor": "DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A OTROS PRODUCTOS QUIMICOS"
      },
      {
        "codigo": "L246",
        "valor": "DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A ALIMENTOS EN CONTACTO CON LA PIEL"
      },
      {
        "codigo": "L247",
        "valor": "DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A PLANTAS, EXCEPTO LAS ALIMENTICIAS"
      },
      {
        "codigo": "L248",
        "valor": "DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A OTROS AGENTES"
      },
      {
        "codigo": "L249",
        "valor": "DERMATITIS DE CONTACTO POR IRRITANTES, DE CAUSA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L25 - DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "L250",
        "valor": "DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA, DEBIDA A COSMETICOS"
      },
      {
        "codigo": "L251",
        "valor": "DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA, DEBIDA A DROGAS EN CONTACTO CON LA PIEL"
      },
      {
        "codigo": "L252",
        "valor": "DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA, DEBIDA A COLORANTES"
      },
      {
        "codigo": "L253",
        "valor": "DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA, DEBIDA A OTROS PRODUCTOS QUIMICOS"
      },
      {
        "codigo": "L254",
        "valor": "DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA, DEBIDA A ALIMENTOS EN CONTACTO CON LA PIEL"
      },
      {
        "codigo": "L255",
        "valor": "DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA, DEBIDA A PLANTAS, EXCEPTO LAS ALIMENTICIAS"
      },
      {
        "codigo": "L258",
        "valor": "DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA, DEBIDA A OTROS AGENTES"
      },
      {
        "codigo": "L259",
        "valor": "DERMATITIS DE CONTACTO, FORMA Y CAUSA NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "L26 - DERMATITIS EXFOLIATIVA",
    "detalle": [
      {
        "codigo": "L26X",
        "valor": "DERMATITIS EXFOLIATIVA"
      }
    ]
  },
  {
    "grupo": "L27 - DERMATITIS DEBIDA A SUSTANCIAS INGERIDAS",
    "detalle": [
      {
        "codigo": "L270",
        "valor": "ERUPCION CUTANEA GENERALIZADA DEBIDA A DROGAS Y MEDICAMENTOS"
      },
      {
        "codigo": "L271",
        "valor": "ERUPCION CUTANEA LOCALIZADA DEBIDA A DROGAS Y MEDICAMENTOS"
      },
      {
        "codigo": "L272",
        "valor": "DERMATITIS DEBIDA A INGESTION DE ALIMENTOS"
      },
      {
        "codigo": "L278",
        "valor": "DERMATITIS DEBIDA A OTRAS SUSTANCIAS INGERIDAS"
      },
      {
        "codigo": "L279",
        "valor": "DERMATITIS DEBIDA A SUSTANCIAS INGERIDAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "L28 - LIQUEN SIMPLE CRONICO Y PRURIGO",
    "detalle": [
      {
        "codigo": "L280",
        "valor": "LIQUEN SIMPLE CRONICO"
      },
      {
        "codigo": "L281",
        "valor": "PRURIGO NODULAR"
      },
      {
        "codigo": "L282",
        "valor": "OTROS PRURIGOS"
      }
    ]
  },
  {
    "grupo": "L29 - PRURITO",
    "detalle": [
      {
        "codigo": "L290",
        "valor": "PRURITO ANAL"
      },
      {
        "codigo": "L291",
        "valor": "PRURITO ESCROTAL"
      },
      {
        "codigo": "L292",
        "valor": "PRURITO VULVAR"
      },
      {
        "codigo": "L293",
        "valor": "PRURITO ANOGENITAL, NO ESPECIFICADO"
      },
      {
        "codigo": "L298",
        "valor": "OTROS PRURITOS"
      },
      {
        "codigo": "L299",
        "valor": "PRURITO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L30 - OTRAS DERMATITIS",
    "detalle": [
      {
        "codigo": "L300",
        "valor": "DERMATITIS NUMULAR"
      },
      {
        "codigo": "L301",
        "valor": "DISHIDROSIS [PONFOLIX]"
      },
      {
        "codigo": "L302",
        "valor": "AUTOSENSIBILIZACION CUTANEA"
      },
      {
        "codigo": "L303",
        "valor": "DERMATITIS INFECCIOSA"
      },
      {
        "codigo": "L304",
        "valor": "ERITEMA INTERTRIGO"
      },
      {
        "codigo": "L305",
        "valor": "PITIRIASIS ALBA"
      },
      {
        "codigo": "L308",
        "valor": "OTRAS DERMATITIS ESPECIFICADAS"
      },
      {
        "codigo": "L309",
        "valor": "DERMATITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L40 - PSORIASIS",
    "detalle": [
      {
        "codigo": "L400",
        "valor": "PSORIASIS VULGAR"
      },
      {
        "codigo": "L401",
        "valor": "PSORIASIS PUSTULOSA GENERALIZADA"
      },
      {
        "codigo": "L402",
        "valor": "ACRODERMATITIS CONTINUA"
      },
      {
        "codigo": "L403",
        "valor": "PUSTULOSIS PALMAR Y PLANTAR"
      },
      {
        "codigo": "L404",
        "valor": "PSORIASIS GUTTATA"
      },
      {
        "codigo": "L405",
        "valor": "ARTROPATIA PSORIASICA"
      },
      {
        "codigo": "L408",
        "valor": "OTRAS PSORIASIS"
      },
      {
        "codigo": "L409",
        "valor": "PSORIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L41 - PARAPSORIASIS",
    "detalle": [
      {
        "codigo": "L410",
        "valor": "PITIRIASIS LIQUENOIDE Y VARIOLIFORME AGUDA"
      },
      {
        "codigo": "L411",
        "valor": "PITIRIASIS LIQUENOIDE CRONICA"
      },
      {
        "codigo": "L412",
        "valor": "PAPULOSIS LINFOMATOIDE"
      },
      {
        "codigo": "L413",
        "valor": "PARAPSORIASIS EN PLACAS PEQUEÑAS"
      },
      {
        "codigo": "L414",
        "valor": "PARAPSORIASIS EN PLACAS GRANDES"
      },
      {
        "codigo": "L415",
        "valor": "PARAPSORIASIS RETIFORME"
      },
      {
        "codigo": "L418",
        "valor": "OTRAS PARAPSORIASIS"
      },
      {
        "codigo": "L419",
        "valor": "PARAPSORIASIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L42 - PITIRIASIS ROSADA",
    "detalle": [
      {
        "codigo": "L42X",
        "valor": "PITIRIASIS ROSADA"
      }
    ]
  },
  {
    "grupo": "L43 - LIQUEN PLANO",
    "detalle": [
      {
        "codigo": "L430",
        "valor": "LIQUEN PLANO HIPERTROFICO"
      },
      {
        "codigo": "L431",
        "valor": "LIQUEN PLANO FLICTENULAR"
      },
      {
        "codigo": "L432",
        "valor": "REACCION LIQUENOIDE DEBIDA A DROGAS"
      },
      {
        "codigo": "L433",
        "valor": "LIQUEN PLANO SUBAGUDO (ACTIVO)"
      },
      {
        "codigo": "L438",
        "valor": "OTROS LIQUENES PLANOS"
      },
      {
        "codigo": "L439",
        "valor": "LIQUEN PLANO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L44 - OTROS TRASTORNOS PAPULOESCAMOSOS",
    "detalle": [
      {
        "codigo": "L440",
        "valor": "PITIRIASIS RUBRA PILARIS"
      },
      {
        "codigo": "L441",
        "valor": "LIQUEN NITIDO"
      },
      {
        "codigo": "L442",
        "valor": "LIQUEN ESTRIADO"
      },
      {
        "codigo": "L443",
        "valor": "LIQUEN ROJO MONILIFORME"
      },
      {
        "codigo": "L444",
        "valor": "ACRODERMATITIS PAPULAR INFANTIL [GIANNOTTI-CROSTI]"
      },
      {
        "codigo": "L448",
        "valor": "OTROS TRASTORNOS PAPULOESCAMOSOS ESPECIFICADOS"
      },
      {
        "codigo": "L449",
        "valor": "TRASTORNO PAPULOESCAMOSO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L45 - TRASTORNOS PAPULOESCAMOSOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "L45X",
        "valor": "TRASTORNOS PAPULOESCAMOSOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "L50 - URTICARIA",
    "detalle": [
      {
        "codigo": "L500",
        "valor": "URTICARIA ALERGICA"
      },
      {
        "codigo": "L501",
        "valor": "URTICARIA IDIOPATICA"
      },
      {
        "codigo": "L502",
        "valor": "URTICARIA DEBIDA AL CALOR Y AL FRIO"
      },
      {
        "codigo": "L503",
        "valor": "URTICARIA DERMATOGRAFICA"
      },
      {
        "codigo": "L504",
        "valor": "URTICARIA VIBRATORIA"
      },
      {
        "codigo": "L505",
        "valor": "URTICARIA COLINERGICA"
      },
      {
        "codigo": "L506",
        "valor": "URTICARIA POR CONTACTO"
      },
      {
        "codigo": "L508",
        "valor": "OTRAS URTICARIAS"
      },
      {
        "codigo": "L509",
        "valor": "URTICARIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L51 - ERITEMA MULTIFORME",
    "detalle": [
      {
        "codigo": "L510",
        "valor": "ERITEMA MULTIFORME NO FLICTENULAR"
      },
      {
        "codigo": "L511",
        "valor": "ERITEMA MULTIFORME FLICTENULAR"
      },
      {
        "codigo": "L512",
        "valor": "NECROLISIS EPIDERMICA TOXICA [LYELL]"
      },
      {
        "codigo": "L518",
        "valor": "OTROS ERITEMAS MULTIFORMES"
      },
      {
        "codigo": "L519",
        "valor": "ERITEMA MULTIFORME, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L52 - ERITEMA NUDOSO",
    "detalle": [
      {
        "codigo": "L52X",
        "valor": "ERITEMA NUDOSO"
      }
    ]
  },
  {
    "grupo": "L53 - OTRAS AFECCIONES ERITEMATOSAS",
    "detalle": [
      {
        "codigo": "L530",
        "valor": "ERITEMA TOXICO"
      },
      {
        "codigo": "L531",
        "valor": "ERITEMA ANULAR CENTRIFUGO"
      },
      {
        "codigo": "L532",
        "valor": "ERITEMA MARGINADO"
      },
      {
        "codigo": "L533",
        "valor": "OTROS ERITEMAS FIGURADOS CRONICOS"
      },
      {
        "codigo": "L538",
        "valor": "OTRAS AFECCIONES ERITEMATOSAS ESPECIFICADAS"
      },
      {
        "codigo": "L539",
        "valor": "AFECCION ERITEMATOSA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L54 - ERITEMA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "L540",
        "valor": "ERITEMA MARGINADO EN LA FIEBRE REUMATICA AGUDA"
      },
      {
        "codigo": "L548",
        "valor": "ERITEMA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "L55 - QUEMADURA SOLAR",
    "detalle": [
      {
        "codigo": "L550",
        "valor": "QUEMADURA SOLAR DE PRIMER GRADO"
      },
      {
        "codigo": "L551",
        "valor": "QUEMADURA SOLAR DE SEGUNDO GRADO"
      },
      {
        "codigo": "L552",
        "valor": "QUEMADURA SOLAR DE TERCER GRADO"
      },
      {
        "codigo": "L558",
        "valor": "OTRAS QUEMADURAS SOLARES"
      },
      {
        "codigo": "L559",
        "valor": "QUEMADURA SOLAR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L56 - OTROS CAMBIOS AGUDOS DE LA PIEL DEBIDOS A RADIACION ULTRAVIOLETA",
    "detalle": [
      {
        "codigo": "L560",
        "valor": "RESPUESTA FOTOTOXICA A DROGAS"
      },
      {
        "codigo": "L561",
        "valor": "RESPUESTA FOTOALERGICA A DROGAS"
      },
      {
        "codigo": "L562",
        "valor": "DERMATITIS POR FOTOCONTACTO [DERMATITIS DE BERLOQUE]"
      },
      {
        "codigo": "L563",
        "valor": "URTICARIA SOLAR"
      },
      {
        "codigo": "L564",
        "valor": "ERUPCION POLIMORFA A LA LUZ"
      },
      {
        "codigo": "L568",
        "valor": "OTROS CAMBIOS AGUDOS ESPECIFICADOS DE LA PIEL DEBIDOS A RADIACION ULTRAVIOLETA"
      },
      {
        "codigo": "L569",
        "valor": "CAMBIO AGUDO DE LA PIEL DEBIDO A RADIACION ULTRAVIOLETA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "L57 - CAMBIOS DE LA PIEL DEBIDOS A EXPOSICION CRONICA A RADIACION NO IONIZAN",
    "detalle": [
      {
        "codigo": "L570",
        "valor": "QUERATOSIS ACTINICA"
      },
      {
        "codigo": "L571",
        "valor": "RETICULOIDE ACTINICO"
      },
      {
        "codigo": "L572",
        "valor": "PIEL ROMBOIDAL DE LA NUCA"
      },
      {
        "codigo": "L573",
        "valor": "POIQUILODERMIA DE CIVATTE"
      },
      {
        "codigo": "L574",
        "valor": "PIEL LAXA SENIL"
      },
      {
        "codigo": "L575",
        "valor": "GRANULOMA ACTINICO"
      },
      {
        "codigo": "L578",
        "valor": "OTROS CAMBIOS DE LA PIEL DEBIDOS A EXPOSICION CRONICA A RADIACION NO IONIZANTE"
      },
      {
        "codigo": "L579",
        "valor": "CAMBIOS DE LA PIEL DEBIDOS A EXPOSICION CRONICA A RADIACION NO IONIZANTE, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "L58 - RADIODERMATITIS",
    "detalle": [
      {
        "codigo": "L580",
        "valor": "RADIODERMATITIS AGUDA"
      },
      {
        "codigo": "L581",
        "valor": "RADIODERMATITIS CRONICA"
      },
      {
        "codigo": "L589",
        "valor": "RADIODERMATITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L59 - OTROS TRASTORNOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO RELACIONADOS CON RADIACION",
    "detalle": [
      {
        "codigo": "L590",
        "valor": "ERITEMA AB IGNE [DERMATITIS AB IGNE]"
      },
      {
        "codigo": "L598",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO RELACIONADOS CON RADIACION"
      },
      {
        "codigo": "L599",
        "valor": "TRASTORNOS NO ESPECIFICADOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO RELACIONADOS CON RADIACION"
      }
    ]
  },
  {
    "grupo": "L60 - TRASTORNOS DE LAS UÑAS",
    "detalle": [
      {
        "codigo": "L600",
        "valor": "UÑA ENCARNADA"
      },
      {
        "codigo": "L601",
        "valor": "ONICOLISIS"
      },
      {
        "codigo": "L602",
        "valor": "ONICOGRIPOSIS"
      },
      {
        "codigo": "L603",
        "valor": "DISTROFIA UNGUEAL"
      },
      {
        "codigo": "L604",
        "valor": "LINEAS DE BEAU"
      },
      {
        "codigo": "L605",
        "valor": "SINDROME DE LA UÑA AMARILLA"
      },
      {
        "codigo": "L608",
        "valor": "OTROS TRASTORNOS DE LAS UÑAS"
      },
      {
        "codigo": "L609",
        "valor": "TRASTORNO DE LA UÑA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L62 - TRASTORNOS DE LAS UÑAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "L620",
        "valor": "UÑA DEFORME DE LA PAQUIDERMOPERIOSTOSIS"
      },
      {
        "codigo": "L628",
        "valor": "TRASTORNOS DE LAS UÑAS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "L63 - ALOPECIA AREATA",
    "detalle": [
      {
        "codigo": "L630",
        "valor": "ALOPECIA (CAPITIS) TOTAL"
      },
      {
        "codigo": "L631",
        "valor": "ALOPECIA UNIVERSAL"
      },
      {
        "codigo": "L632",
        "valor": "OFIASIS"
      },
      {
        "codigo": "L638",
        "valor": "OTRAS ALOPECIAS AREATAS"
      },
      {
        "codigo": "L639",
        "valor": "ALOPECIA AREATA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L64 - ALOPECIA ANDROGENA",
    "detalle": [
      {
        "codigo": "L640",
        "valor": "ALOPECIA ANDROGENA, INDUCIDA POR DROGAS"
      },
      {
        "codigo": "L648",
        "valor": "OTRAS ALOPECIAS ANDROGENAS"
      },
      {
        "codigo": "L649",
        "valor": "ALOPECIA ANDROGENA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L65 - OTRA PERDIDA NO CICATRICIAL DEL PELO",
    "detalle": [
      {
        "codigo": "L650",
        "valor": "PERDIDA CAPILAR TELOGENA"
      },
      {
        "codigo": "L651",
        "valor": "PERDIDA CAPILAR ANAGENA"
      },
      {
        "codigo": "L652",
        "valor": "ALOPECIA MUCINOSA"
      },
      {
        "codigo": "L658",
        "valor": "OTRAS PERDIDAS ESPECIFICADAS NO CICATRICIALES DEL PELO"
      },
      {
        "codigo": "L659",
        "valor": "PERDIDA NO CICATRICIAL DEL PELO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "L66 - ALOPECIA CICATRICIAL [PERDIDA CICATRICIAL DEL PELO]",
    "detalle": [
      {
        "codigo": "L660",
        "valor": "SEUDOPELADA"
      },
      {
        "codigo": "L661",
        "valor": "LIQUEN PLANO PILARIS"
      },
      {
        "codigo": "L662",
        "valor": "FOLICULITIS DECALVANTE"
      },
      {
        "codigo": "L663",
        "valor": "PERIFOLICULITIS CAPITIS ABSCEDENS"
      },
      {
        "codigo": "L664",
        "valor": "FOLICULITIS ULERITEMATOSA RETICULADA"
      },
      {
        "codigo": "L668",
        "valor": "OTRAS ALOPECIAS CICATRICIALES"
      },
      {
        "codigo": "L669",
        "valor": "ALOPECIA CICATRICIAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L67 - ANORMALIDADES DEL TALLO Y DEL COLOR DEL PELO",
    "detalle": [
      {
        "codigo": "L670",
        "valor": "TRICORREXIS NUDOSA"
      },
      {
        "codigo": "L671",
        "valor": "VARIACION DEL COLOR DEL PELO"
      },
      {
        "codigo": "L678",
        "valor": "OTRAS ANORMALIDADES DEL TALLO Y DEL COLOR DEL PELO"
      },
      {
        "codigo": "L679",
        "valor": "ANORMALIDAD NO ESPECIFICADA DEL TALLO Y DEL COLOR DEL PELO"
      }
    ]
  },
  {
    "grupo": "L68 - HIPERTRICOSIS",
    "detalle": [
      {
        "codigo": "L680",
        "valor": "HIRSUTISMO"
      },
      {
        "codigo": "L681",
        "valor": "HIPERTRICOSIS LANUGINOSA ADQUIRIDA"
      },
      {
        "codigo": "L682",
        "valor": "HIPERTRICOSIS LOCALIZADA"
      },
      {
        "codigo": "L683",
        "valor": "POLITRIQUIA"
      },
      {
        "codigo": "L688",
        "valor": "OTRAS HIPERTRICOSIS"
      },
      {
        "codigo": "L689",
        "valor": "HIPERTRICOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L70 - ACNE",
    "detalle": [
      {
        "codigo": "L700",
        "valor": "ACNE VULGAR"
      },
      {
        "codigo": "L701",
        "valor": "ACNE CONGLOBADO"
      },
      {
        "codigo": "L702",
        "valor": "ACNE VARIOLIFORME"
      },
      {
        "codigo": "L703",
        "valor": "ACNE TROPICAL"
      },
      {
        "codigo": "L704",
        "valor": "ACNE INFANTIL"
      },
      {
        "codigo": "L705",
        "valor": "ACNE EXCORIADO DE LA MUJER JOVEN"
      },
      {
        "codigo": "L708",
        "valor": "OTROS ACNES"
      },
      {
        "codigo": "L709",
        "valor": "ACNE, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L71 - ROSACEA",
    "detalle": [
      {
        "codigo": "L710",
        "valor": "DERMATITIS PERIBUCAL"
      },
      {
        "codigo": "L711",
        "valor": "RINOFIMA"
      },
      {
        "codigo": "L718",
        "valor": "OTRAS ROSACEAS"
      },
      {
        "codigo": "L719",
        "valor": "ROSACEA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "L72 - QUISTE FOLICULAR DE LA PIEL Y DEL TEJIDO SUBCUTANEO",
    "detalle": [
      {
        "codigo": "L720",
        "valor": "QUISTE EPIDERMICO"
      },
      {
        "codigo": "L721",
        "valor": "QUISTE TRICODERMICO"
      },
      {
        "codigo": "L722",
        "valor": "ESTEATOCISTOMA MULTIPLE"
      },
      {
        "codigo": "L728",
        "valor": "OTROS QUISTES FOLICULARES DE LA PIEL Y DEL TEJIDO SUBCUTANEO"
      },
      {
        "codigo": "L729",
        "valor": "QUISTE FOLICULAR DE LA PIEL Y DEL TEJIDO SUBCUTANEO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "L73 - OTROS TRASTORNOS FOLICULARES",
    "detalle": [
      {
        "codigo": "L730",
        "valor": "ACNE QUELOIDE"
      },
      {
        "codigo": "L731",
        "valor": "SEUDOFOLICULITIS DE LA BARBA"
      },
      {
        "codigo": "L732",
        "valor": "HIDRADENITIS SUPURATIVA"
      },
      {
        "codigo": "L738",
        "valor": "OTROS TRASTORNOS FOLICULARES ESPECIFICADOS"
      },
      {
        "codigo": "L739",
        "valor": "TRASTORNO FOLICULAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L74 - TRASTORNOS SUDORIPAROS ECRINOS",
    "detalle": [
      {
        "codigo": "L740",
        "valor": "MILIARIA RUBRA"
      },
      {
        "codigo": "L741",
        "valor": "MILIARIA CRISTALINA"
      },
      {
        "codigo": "L742",
        "valor": "MILIARIA PROFUNDA"
      },
      {
        "codigo": "L743",
        "valor": "MILIARIA, NO ESPECIFICADA"
      },
      {
        "codigo": "L744",
        "valor": "ANHIDROSIS"
      },
      {
        "codigo": "L748",
        "valor": "OTROS TRASTORNOS SUDORIPAROS ECRINOS"
      },
      {
        "codigo": "L749",
        "valor": "TRASTORNO SUDORIPARO ECRINO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L75 - TRASTORNOS SUDORIPAROS APOCRINOS",
    "detalle": [
      {
        "codigo": "L750",
        "valor": "BROMHIDROSIS"
      },
      {
        "codigo": "L751",
        "valor": "CROMHIDROSIS"
      },
      {
        "codigo": "L752",
        "valor": "MILIARIA APOCRINA"
      },
      {
        "codigo": "L758",
        "valor": "OTROS TRASTORNOS SUDORIPAROS APOCRINOS"
      },
      {
        "codigo": "L759",
        "valor": "TRASTORNO SUDORIPARO APOCRINO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L80 - VITILIGO",
    "detalle": [
      {
        "codigo": "L80X",
        "valor": "VITILIGO"
      }
    ]
  },
  {
    "grupo": "L81 - OTROS TRASTORNOS DE LA PIGMENTACION",
    "detalle": [
      {
        "codigo": "L810",
        "valor": "HIPERPIGMENTACION POSTINFLAMATORIA"
      },
      {
        "codigo": "L811",
        "valor": "CLOASMA"
      },
      {
        "codigo": "L812",
        "valor": "EFELIDE"
      },
      {
        "codigo": "L813",
        "valor": "MANCHAS CAFE CON LECHE"
      },
      {
        "codigo": "L814",
        "valor": "OTROS TIPOS DE HIPERPIGMENTACION MELANODERMICA"
      },
      {
        "codigo": "L815",
        "valor": "LEUCODERMIA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "L816",
        "valor": "OTROS TRASTORNOS DE DISMINUCION DE LA FORMACION DE LA MELANINA"
      },
      {
        "codigo": "L817",
        "valor": "DERMATOSIS PURPURICA PIGMENTADA"
      },
      {
        "codigo": "L818",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA PIGMENTACION"
      },
      {
        "codigo": "L819",
        "valor": "TRASTORNO DE LA PIGMENTACION, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L82 - QUERATOSIS SEBORREICA",
    "detalle": [
      {
        "codigo": "L82X",
        "valor": "QUERATOSIS SEBORREICA"
      }
    ]
  },
  {
    "grupo": "L83 - ACANTOSIS NIGRICANS",
    "detalle": [
      {
        "codigo": "L83X",
        "valor": "ACANTOSIS NIGRICANS"
      }
    ]
  },
  {
    "grupo": "L84 - CALLOS Y CALLOSIDADES",
    "detalle": [
      {
        "codigo": "L84X",
        "valor": "CALLOS Y CALLOSIDADES"
      }
    ]
  },
  {
    "grupo": "L85 - OTROS TIPOS DE ENGROSAMIENTO EPIDERMICO",
    "detalle": [
      {
        "codigo": "L850",
        "valor": "ICTIOSIS ADQUIRIDA"
      },
      {
        "codigo": "L851",
        "valor": "QUERATOSIS [QUERATODERMIA] PALMAR Y PLANTAR ADQUIRIDA"
      },
      {
        "codigo": "L852",
        "valor": "QUERATOSIS PUNCTATA (PALMAR Y PLANTAR)"
      },
      {
        "codigo": "L853",
        "valor": "XEROSIS DEL CUTIS"
      },
      {
        "codigo": "L858",
        "valor": "OTROS ENGROSAMIENTOS EPIDERMICOS ESPECIFICADOS"
      },
      {
        "codigo": "L859",
        "valor": "ENGROSAMIENTO EPIDERMICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L86 - QUERATODERMA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "L86X",
        "valor": "QUERATODERMA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "L87 - TRASTORNOS DE LA ELIMINACION TRANSEPIDERMICA",
    "detalle": [
      {
        "codigo": "L870",
        "valor": "QUERATOSIS FOLICULAR Y PARAFOLICULAR PENETRANTE DEL CUTIS [KYRLE]"
      },
      {
        "codigo": "L871",
        "valor": "COLAGENOSIS PERFORANTE REACTIVA"
      },
      {
        "codigo": "L872",
        "valor": "ELASTOSIS SERPIGINOSA PERFORANTE"
      },
      {
        "codigo": "L878",
        "valor": "OTROS TRASTORNOS DE LA ELIMINACION TRANSEPIDERMICA"
      },
      {
        "codigo": "L879",
        "valor": "TRASTORNO DE LA ELIMINACION TRANSEPIDERMICA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L88 - PIODERMA GANGRENOSO",
    "detalle": [
      {
        "codigo": "L88X",
        "valor": "PIODERMA GANGRENOSO"
      }
    ]
  },
  {
    "grupo": "L89 - ULCERA DE DECUBITO Y AREA DE PRESION",
    "detalle": [
      {
        "codigo": "L890",
        "valor": "ULCERA DE DECUBITO Y POR AREA DE PRESION, ETAPA I"
      },
      {
        "codigo": "L891",
        "valor": "ULCERA DE DECUBITO, ETAPA II"
      },
      {
        "codigo": "L892",
        "valor": "ULCERA DE DECUBITO, ETAPA III"
      },
      {
        "codigo": "L893",
        "valor": "ULCERA DE DECUBITO, ETAPA IV"
      },
      {
        "codigo": "L899",
        "valor": "ULCERA DE DECUBITO Y POR AREA DE PRESION, NO ESPECIFICADA"
      },
      {
        "codigo": "L89X",
        "valor": "ULCERA DE DECUBITO"
      }
    ]
  },
  {
    "grupo": "L90 - TRASTORNOS ATROFICOS DE LA PIEL",
    "detalle": [
      {
        "codigo": "L900",
        "valor": "LIQUEN ESCLEROSO Y ATROFICO"
      },
      {
        "codigo": "L901",
        "valor": "ANETODERMIA DE SCHWENINGER-BUZZI"
      },
      {
        "codigo": "L902",
        "valor": "ANETODERMIA DE JADASSOHN-PELLIZZARI"
      },
      {
        "codigo": "L903",
        "valor": "ATROFODERMA DE PASINI Y PRERINI"
      },
      {
        "codigo": "L904",
        "valor": "ACRODERMATITIS CRONICA ATROFICA"
      },
      {
        "codigo": "L905",
        "valor": "FIBROSIS Y AFECCIONES CICATRICIALES DE LA PIEL"
      },
      {
        "codigo": "L906",
        "valor": "ESTRIAS ATROFICAS"
      },
      {
        "codigo": "L908",
        "valor": "OTROS TRASTORNOS ATROFICOS DE LA PIEL"
      },
      {
        "codigo": "L909",
        "valor": "TRASTORNO ATROFICO DE LA PIEL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L91 - TRASTORNOS HIPERTROFICOS DE LA PIEL",
    "detalle": [
      {
        "codigo": "L910",
        "valor": "CICATRIZ HIPERTROFICA"
      },
      {
        "codigo": "L918",
        "valor": "OTROS TRASTORNOS HIPERTROFICOS DE LA PIEL"
      },
      {
        "codigo": "L919",
        "valor": "TRASTORNO HIPERTROFICO DE LA PIEL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L92 - TRASTORNOS GRANULOMATOSOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO",
    "detalle": [
      {
        "codigo": "L920",
        "valor": "GRANULOMA ANULAR"
      },
      {
        "codigo": "L921",
        "valor": "NECROBIOSIS LIPIDICA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "L922",
        "valor": "GRANULOMA FACIAL (GRANULOMA EOSINOFILO DE LA PIEL)"
      },
      {
        "codigo": "L923",
        "valor": "GRANULOMA POR CUERPO EXTRAÑO EN LA PIEL Y EN EL TEJIDO SUBCUTANEO"
      },
      {
        "codigo": "L928",
        "valor": "OTROS TRASTORNOS GRANULOMATOSOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO"
      },
      {
        "codigo": "L929",
        "valor": "TRASTORNO GRANULOMATOSO DE LA PIEL Y DEL TEJIDO SUBCUTANEO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L93 - LUPUS ERITEMATOSO",
    "detalle": [
      {
        "codigo": "L930",
        "valor": "LUPUS ERITEMATOSO DISCOIDE"
      },
      {
        "codigo": "L931",
        "valor": "LUPUS ERITEMATOSO CUTANEO SUBAGUDO"
      },
      {
        "codigo": "L932",
        "valor": "OTROS LUPUS ERITEMATOSOS LOCALIZADOS"
      }
    ]
  },
  {
    "grupo": "L94 - OTROS TRASTORNOS LOCALIZADOS DEL TEJIDO CONJUNTIVO",
    "detalle": [
      {
        "codigo": "L940",
        "valor": "ESCLERODERMA LOCALIZADO [MORFEA]"
      },
      {
        "codigo": "L941",
        "valor": "ESCLERODERMA LINEAL"
      },
      {
        "codigo": "L942",
        "valor": "CALCINOSIS DE LA PIEL"
      },
      {
        "codigo": "L943",
        "valor": "ESCLERODACTILIA"
      },
      {
        "codigo": "L944",
        "valor": "PAPULAS DE GOTTRON"
      },
      {
        "codigo": "L945",
        "valor": "POIQUILODERMIA VASCULAR ATROFICA"
      },
      {
        "codigo": "L946",
        "valor": "AINHUM"
      },
      {
        "codigo": "L948",
        "valor": "OTROS TRASTORNOS LOCALIZADOS ESPECIFICADOS DEL TEJIDO CONJUNTIVO"
      },
      {
        "codigo": "L949",
        "valor": "TRASTORNO LOCALIZADO DEL TEJIDO CONJUNTIVO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L95 - VASCULITIS LIMITADA A LA PIEL, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "L950",
        "valor": "VASCULITIS LIVEDOIDE"
      },
      {
        "codigo": "L951",
        "valor": "ERITEMA ELEVATUM DIUTINUM"
      },
      {
        "codigo": "L958",
        "valor": "OTRAS VASCULITIS LIMITADAS A LA PIEL"
      },
      {
        "codigo": "L959",
        "valor": "VASCULITIS LIMITADA A LA PIEL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "L97 - ULCERA DE MIEMBRO INFERIOR, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "L97X",
        "valor": "ULCERA DE MIEMBRO INFERIOR, NO CLASIFICADA EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "L98 - OTROS TRASTORNOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "L980",
        "valor": "GRANULOMA PIOGENO"
      },
      {
        "codigo": "L981",
        "valor": "DERMATITIS FACTICIA"
      },
      {
        "codigo": "L982",
        "valor": "DERMATOSIS NEUTROFILA FEBRIL [SWEET]"
      },
      {
        "codigo": "L983",
        "valor": "CELULITIS EOSINOFILIA [WELLS]"
      },
      {
        "codigo": "L984",
        "valor": "ULCERA CRONICA DE LA PIEL, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "L985",
        "valor": "MUCINOSIS DE LA PIEL"
      },
      {
        "codigo": "L986",
        "valor": "OTROS TRASTORNOS INFILTRATIVOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO"
      },
      {
        "codigo": "L988",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO"
      },
      {
        "codigo": "L989",
        "valor": "TRASTORNO DE LA PIEL Y DEL TEJIDO SUBCUTANEO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "L99 - OTROS TRASTORNOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "L990",
        "valor": "AMILOIDOSIS DE LA PIEL"
      },
      {
        "codigo": "L998",
        "valor": "OTROS TRASTORNOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M00 - ARTRITIS PIOGENA",
    "detalle": [
      {
        "codigo": "M000",
        "valor": "ARTRITIS Y POLIARTRITIS ESTAFILOCOCICA"
      },
      {
        "codigo": "M001",
        "valor": "ARTRITIS Y POLIARTRITIS NEUMOCOCICA"
      },
      {
        "codigo": "M002",
        "valor": "OTRAS ARTRITIS Y POLIARTRITIS ESTREPTOCOCICAS"
      },
      {
        "codigo": "M008",
        "valor": "ARTRITIS Y POLIARTRITIS DEBIDAS A OTROS AGENTES BACTERIANOS ESPECIFICADOS"
      },
      {
        "codigo": "M009",
        "valor": "ARTRITIS PIOGENA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M01 - INFECCIONES DIRECTAS DE LA ARTICULACION EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M010",
        "valor": "ARTRITIS MENINGOCOCICA"
      },
      {
        "codigo": "M011",
        "valor": "ARTRITIS TUBERCULOSA"
      },
      {
        "codigo": "M012",
        "valor": "ARTRITIS EN LA ENFERMEDAD DE LYME"
      },
      {
        "codigo": "M013",
        "valor": "ARTRITIS EN OTRAS ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M014",
        "valor": "ARTRITIS EN RUBEOLA"
      },
      {
        "codigo": "M015",
        "valor": "ARTRITIS EN OTRAS ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M016",
        "valor": "ARTRITIS EN MICOSIS"
      },
      {
        "codigo": "M018",
        "valor": "ARTRITIS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M02 - ARTROPATIAS REACTIVAS",
    "detalle": [
      {
        "codigo": "M020",
        "valor": "ARTROPATIA CONSECUTIVA A DERIVACION INTESTINAL"
      },
      {
        "codigo": "M021",
        "valor": "ARTROPATIA POSTDISENTERICA"
      },
      {
        "codigo": "M022",
        "valor": "ARTROPATIA POSTINMUNIZACION"
      },
      {
        "codigo": "M023",
        "valor": "ENFERMEDAD DE REITER"
      },
      {
        "codigo": "M028",
        "valor": "OTRAS ARTROPATIAS REACTIVAS"
      },
      {
        "codigo": "M029",
        "valor": "ARTROPATIA REACTIVA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M03 - ARTROPATIAS POSTINFECCIOSAS Y REACTIVAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M030",
        "valor": "ARTRITIS POSTMENINGOCOCICA"
      },
      {
        "codigo": "M031",
        "valor": "ARTROPATIA POSTINFECCIOSA EN SIFILIS"
      },
      {
        "codigo": "M032",
        "valor": "OTRAS ARTROPATIAS POSTINFECCIOSAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M036",
        "valor": "ARTROPATIA REACTIVA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M05 - ARTRITIS REUMATOIDE SEROPOSITIVA",
    "detalle": [
      {
        "codigo": "M050",
        "valor": "SINDROME DE FELTY"
      },
      {
        "codigo": "M051",
        "valor": "ENFERMEDAD REUMATOIDE DEL PULMON"
      },
      {
        "codigo": "M052",
        "valor": "VASCULITIS REUMATOIDE"
      },
      {
        "codigo": "M053",
        "valor": "ARTRITIS REUMATOIDE CON COMPROMISO DE OTROS ORGANOS O SISTEMAS"
      },
      {
        "codigo": "M058",
        "valor": "OTRAS ARTRITIS REUMATOIDEAS SEROPOSITIVAS"
      },
      {
        "codigo": "M059",
        "valor": "ARTRITIS REUMATOIDEA SEROPOSITIVA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "M06 - OTRAS ARTRITIS REUMATOIDES",
    "detalle": [
      {
        "codigo": "M060",
        "valor": "ARTRITIS REUMATOIDE SERONEGATIVA"
      },
      {
        "codigo": "M061",
        "valor": "ENFERMEDAD DE STILL DE COMIENZO EN EL ADULTO"
      },
      {
        "codigo": "M062",
        "valor": "BURSITIS REUMATOIDE"
      },
      {
        "codigo": "M063",
        "valor": "NODULO REUMATOIDE"
      },
      {
        "codigo": "M064",
        "valor": "POLIARTROPATIA INFLAMATORIA"
      },
      {
        "codigo": "M068",
        "valor": "OTRAS ARTRITIS REUMATOIDES ESPECIFICADAS"
      },
      {
        "codigo": "M069",
        "valor": "ARTRITIS REUMATOIDE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M07 - ARTROPATIAS PSORIASICAS Y ENTEROPATICAS",
    "detalle": [
      {
        "codigo": "M070",
        "valor": "ARTROPATIA PSORIASICA INTERFALANGICA DISTAL"
      },
      {
        "codigo": "M071",
        "valor": "ARTRITIS MUTILANTE"
      },
      {
        "codigo": "M072",
        "valor": "ESPONDILITIS PSORIASICA"
      },
      {
        "codigo": "M073",
        "valor": "OTRAS ARTROPATIAS PSORIASICAS"
      },
      {
        "codigo": "M074",
        "valor": "ARTROPATIA EN LA ENFERMEDAD DE CROHN [ENTERITIS REGIONAL]"
      },
      {
        "codigo": "M075",
        "valor": "ARTROPATIA EN LA COLITIS ULCERATIVA"
      },
      {
        "codigo": "M076",
        "valor": "OTRAS ARTROPATIAS ENTEROPATICAS"
      }
    ]
  },
  {
    "grupo": "M08 - ARTRITIS JUVENIL",
    "detalle": [
      {
        "codigo": "M080",
        "valor": "ARTRITIS REUMATOIDE JUVENIL"
      },
      {
        "codigo": "M081",
        "valor": "ESPONDILITIS ANQUILOSANTE JUVENIL"
      },
      {
        "codigo": "M082",
        "valor": "ARTRITIS JUVENIL DE COMIENZO GENERALIZADO"
      },
      {
        "codigo": "M083",
        "valor": "POLIARTRITIS JUVENIL (SERONEGATIVA)"
      },
      {
        "codigo": "M084",
        "valor": "ARTRITIS JUVENIL PAUCIARTICULAR"
      },
      {
        "codigo": "M088",
        "valor": "OTRAS ARTRITIS JUVENILES"
      },
      {
        "codigo": "M089",
        "valor": "ARTRITIS JUVENIL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M09 - ARTRITIS JUVENIL EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M090",
        "valor": "ARTRITIS JUVENIL EN LA PSORIASIS"
      },
      {
        "codigo": "M091",
        "valor": "ARTRITIS JUVENIL EN LA ENFERMEDAD DE CROHN [ENTERITIS REGIONAL]"
      },
      {
        "codigo": "M092",
        "valor": "ARTRITIS JUVENIL EN LA COLITIS ULCERATIVA"
      },
      {
        "codigo": "M098",
        "valor": "ARTRITIS JUVENIL EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M10 - GOTA",
    "detalle": [
      {
        "codigo": "M100",
        "valor": "GOTA IDIOPATICA"
      },
      {
        "codigo": "M101",
        "valor": "GOTA SATURNINA"
      },
      {
        "codigo": "M102",
        "valor": "GOTA INDUCIDA POR DROGAS"
      },
      {
        "codigo": "M103",
        "valor": "GOTA DEBIDA A ALTERACION DE LA FUNCION RENAL"
      },
      {
        "codigo": "M104",
        "valor": "OTRAS GOTAS SECUNDARIAS"
      },
      {
        "codigo": "M109",
        "valor": "GOTA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M11 - OTRAS ARTROPATIAS POR CRISTALES",
    "detalle": [
      {
        "codigo": "M110",
        "valor": "ENFERMEDAD POR DEPOSITO DE HIDROXIAPATITA"
      },
      {
        "codigo": "M111",
        "valor": "CONDROCALCINOSIS FAMILIAR"
      },
      {
        "codigo": "M112",
        "valor": "OTRAS CONDROCALCINOSIS"
      },
      {
        "codigo": "M118",
        "valor": "OTRAS ARTROPATIAS POR CRISTALES, ESPECIFICADAS"
      },
      {
        "codigo": "M119",
        "valor": "ARTROPATIA POR CRISTALES, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M12 - OTRAS ARTROPATIAS ESPECIFICAS",
    "detalle": [
      {
        "codigo": "M120",
        "valor": "ARTROPATIA POSTRAUMATICA CRONICA [DE JACCOUD]"
      },
      {
        "codigo": "M121",
        "valor": "ENFERMEDAD DE KASCHIN-BECK"
      },
      {
        "codigo": "M122",
        "valor": "SINOVITIS VELLONODULAR (PIGMENTADA)"
      },
      {
        "codigo": "M123",
        "valor": "REUMATISMO PALINDROMICO"
      },
      {
        "codigo": "M124",
        "valor": "HIDRARTROSIS INTERMITENTE"
      },
      {
        "codigo": "M125",
        "valor": "ARTROPATIA TRAUMATICA"
      },
      {
        "codigo": "M128",
        "valor": "OTRAS ARTROPATIAS ESPECIFICAS, NO CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M13 - OTRAS ARTRITIS",
    "detalle": [
      {
        "codigo": "M130",
        "valor": "POLIARTRITIS, NO ESPECIFICADA"
      },
      {
        "codigo": "M131",
        "valor": "MONOARTRITIS, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M138",
        "valor": "OTRAS ARTRITIS ESPECIFICADAS"
      },
      {
        "codigo": "M139",
        "valor": "ARTRITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M14 - ARTROPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M140",
        "valor": "ARTROPATIA GOTOSA DEBIDA A DEFECTOS ENZIMATICOS Y A OTROS TRASTORNOS HEREDITARIOS, CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "M141",
        "valor": "ARTROPATIA POR CRISTALES EN OTROS TRASTORNOS METABOLICOS"
      },
      {
        "codigo": "M142",
        "valor": "ARTROPATIA DIABETICA"
      },
      {
        "codigo": "M143",
        "valor": "DERMATOARTRITIS LIPOIDE"
      },
      {
        "codigo": "M144",
        "valor": "ARTROPATIA EN LA AMILOIDOSIS"
      },
      {
        "codigo": "M145",
        "valor": "ARTROPATIA EN OTROS TRASTORNOS ENDOCRINOS, METABOLICOS Y NUTRICIONALES"
      },
      {
        "codigo": "M146",
        "valor": "ARTROPATIA NEUROPATICA"
      },
      {
        "codigo": "M148",
        "valor": "ARTROPATIA EN OTRAS ENFERMEDADES ESPECIFICADAS, CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M15 - POLIARTROSIS",
    "detalle": [
      {
        "codigo": "M150",
        "valor": "(OSTEO)ARTROSIS PRIMARIA GENERALIZADA"
      },
      {
        "codigo": "M151",
        "valor": "NODULOS DE HEBERDEN (CON ARTROPATIA)"
      },
      {
        "codigo": "M152",
        "valor": "NODULOS DE BOUCHARD (CON ARTROPATIA)"
      },
      {
        "codigo": "M153",
        "valor": "ARTROSIS SECUNDARIA MULTIPLE"
      },
      {
        "codigo": "M154",
        "valor": "(OSTEO)ARTROSIS EROSIVA"
      },
      {
        "codigo": "M158",
        "valor": "OTRAS POLIARTROSIS"
      },
      {
        "codigo": "M159",
        "valor": "POLIARTROSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M16 - COXARTROSIS [ARTROSIS DE LA CADERA]",
    "detalle": [
      {
        "codigo": "M160",
        "valor": "COXARTROSIS PRIMARIA, BILATERAL"
      },
      {
        "codigo": "M161",
        "valor": "OTRAS COXARTROSIS PRIMARIAS"
      },
      {
        "codigo": "M162",
        "valor": "COXARTROSIS A CONSECUENCIA DE DISPLASIA, BILATERAL"
      },
      {
        "codigo": "M163",
        "valor": "OTRAS COXARTROSIS DISPLASICAS"
      },
      {
        "codigo": "M164",
        "valor": "COXARTROSIS POSTRAUMATICA, BILATERAL"
      },
      {
        "codigo": "M165",
        "valor": "OTRA COXARTROSIS POSTRAUMATICA"
      },
      {
        "codigo": "M166",
        "valor": "OTRA COXARTROSIS SECUNDARIA, BILATERAL"
      },
      {
        "codigo": "M167",
        "valor": "OTRAS COXARTROSIS SECUNDARIAS"
      },
      {
        "codigo": "M169",
        "valor": "COXARTROSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M17 - GONARTROSIS [ARTROSIS DE LA RODILLA]",
    "detalle": [
      {
        "codigo": "M170",
        "valor": "GONARTROSIS PRIMARIA, BILATERAL"
      },
      {
        "codigo": "M171",
        "valor": "OTRAS GONARTROSIS PRIMARIAS"
      },
      {
        "codigo": "M172",
        "valor": "GONARTROSIS POSTRAUMATICA, BILATERAL"
      },
      {
        "codigo": "M173",
        "valor": "OTRAS GONARTROSIS POSTRAUMATICAS"
      },
      {
        "codigo": "M174",
        "valor": "OTRAS GONARTROSIS SECUNDARIAS, BILATERALES"
      },
      {
        "codigo": "M175",
        "valor": "OTRAS GONARTROSIS SECUNDARIAS"
      },
      {
        "codigo": "M179",
        "valor": "GONARTROSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M18 - ARTROSIS DE LA PRIMERA ARTICULACION CARPOMETACARPIANA",
    "detalle": [
      {
        "codigo": "M180",
        "valor": "ARTROSIS PRIMARIA DE LA PRIMERA ARTICULACION CARPOMETACARPIANA, BILATERAL"
      },
      {
        "codigo": "M181",
        "valor": "OTRAS ARTROSIS PRIMARIAS DE LA PRIMERA ARTICULACION CARPOMETACARPIANA"
      },
      {
        "codigo": "M182",
        "valor": "ARTROSIS POSTRAUMATICA DE LA PRIMERA ARTICULACION CARPOMETACARPIANA, BILATERAL"
      },
      {
        "codigo": "M183",
        "valor": "OTRAS ARTROSIS POSTRAUMATICAS DE LA PRIMERA ARTICULACION CARPOMETACARPIANA"
      },
      {
        "codigo": "M184",
        "valor": "OTRAS ARTROSIS SECUNDARIAS DE LA PRIMERA ARTICULACION CARPOMETACARPIANA, BILATERALES"
      },
      {
        "codigo": "M185",
        "valor": "OTRAS ARTROSIS SECUNDARIAS DE LA PRIMERA ARTICULACION CARPOMETACARPIANA"
      },
      {
        "codigo": "M189",
        "valor": "ARTROSIS DE LA PRIMERA ARTICULACION CARPOMETACARPIANA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "M19 - OTRAS ARTROSIS",
    "detalle": [
      {
        "codigo": "M190",
        "valor": "ARTROSIS PRIMARIA DE OTRAS ARTICULACIONES"
      },
      {
        "codigo": "M191",
        "valor": "ARTROSIS POSTRAUMATICA DE OTRAS ARTICULACIONES"
      },
      {
        "codigo": "M192",
        "valor": "OTRAS ARTROSIS SECUNDARIAS"
      },
      {
        "codigo": "M198",
        "valor": "OTRAS ARTROSIS ESPECIFICADAS"
      },
      {
        "codigo": "M199",
        "valor": "ARTROSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M20 - DEFORMIDADES ADQUIRIDAS DE LOS DEDOS DE LA MANO Y DEL PIE",
    "detalle": [
      {
        "codigo": "M200",
        "valor": "DEFORMIDAD DE DEDO(S) DE LA MANO"
      },
      {
        "codigo": "M201",
        "valor": "HALLUX VALGUS (ADQUIRIDO)"
      },
      {
        "codigo": "M202",
        "valor": "HALLUX RIGIDUS"
      },
      {
        "codigo": "M203",
        "valor": "OTRAS DEFORMIDADES DEL HALLUX (ADQUIRIDAS)"
      },
      {
        "codigo": "M204",
        "valor": "OTRO(S) DEDO(S) DEL PIE EN MARTILLO (ADQUIRIDOS)"
      },
      {
        "codigo": "M205",
        "valor": "OTRAS DEFORMIDADES (ADQUIRIDAS) DEL (DE LOS) DEDO(S) DEL PIE"
      },
      {
        "codigo": "M206",
        "valor": "DEFORMIDADES ADQUIRIDAS DE LOS DEDOS DEL PIE, NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "M21 - OTRAS DEFORMIDADES ADQUIRIDAS DE LOS MIEMBROS",
    "detalle": [
      {
        "codigo": "M210",
        "valor": "DEFORMIDAD EN VALGO, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M211",
        "valor": "DEFORMIDAD EN VARO, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M212",
        "valor": "DEFORMIDAD EN FLEXION"
      },
      {
        "codigo": "M213",
        "valor": "MUÑECA O PIE EN PENDULO (ADQUIRIDO)"
      },
      {
        "codigo": "M214",
        "valor": "PIE PLANO [PES PLANUS] (ADQUIRIDO)"
      },
      {
        "codigo": "M215",
        "valor": "MANO O PIE EN GARRA O EN TALIPES, PIE EQUINOVARO O ZAMBO ADQUIRIDOS"
      },
      {
        "codigo": "M216",
        "valor": "OTRAS DEFORMIDADES ADQUIRIDAS DEL TOBILLO Y DEL PIE"
      },
      {
        "codigo": "M217",
        "valor": "LONGITUD DESIGUAL DE LOS MIEMBROS (ADQUIRIDA)"
      },
      {
        "codigo": "M218",
        "valor": "OTRAS DEFORMIDADES ADQUIRIDAS DE LOS MIEMBROS, ESPECIFICADAS"
      },
      {
        "codigo": "M219",
        "valor": "DEFORMIDAD ADQUIRIDA DEL MIEMBRO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M22 - TRASTORNOS DE LA ROTULA",
    "detalle": [
      {
        "codigo": "M220",
        "valor": "LUXACION RECIDIVANTE DE LA ROTULA"
      },
      {
        "codigo": "M221",
        "valor": "SUBLUXACION RECIDIVANTE DE LA ROTULA"
      },
      {
        "codigo": "M222",
        "valor": "TRASTORNOS ROTULOFEMORALES"
      },
      {
        "codigo": "M223",
        "valor": "OTROS DESARREGLOS DE LA ROTULA"
      },
      {
        "codigo": "M224",
        "valor": "CONDROMALACIA DE LA ROTULA"
      },
      {
        "codigo": "M228",
        "valor": "OTROS TRASTORNOS DE LA ROTULA"
      },
      {
        "codigo": "M229",
        "valor": "TRASTORNO DE LA ROTULA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M23 - TRASTORNO INTERNO DE LA RODILLA",
    "detalle": [
      {
        "codigo": "M230",
        "valor": "MENISCO QUISTICO"
      },
      {
        "codigo": "M231",
        "valor": "MENISCO DISCOIDE (CONGENITO)"
      },
      {
        "codigo": "M232",
        "valor": "TRASTORNO DE MENISCO DEBIDO A DESGARRO O LESION ANTIGUA"
      },
      {
        "codigo": "M233",
        "valor": "OTROS TRASTORNOS DE LOS MENISCOS"
      },
      {
        "codigo": "M234",
        "valor": "CUERPO FLOTANTE EN LA RODILLA"
      },
      {
        "codigo": "M235",
        "valor": "INESTABILIDAD CRONICA DE LA RODILLA"
      },
      {
        "codigo": "M236",
        "valor": "OTRA RUPTURA ESPONTANEA DEL (DE LOS) LIGAMENTO(S) DE LA RODILLA"
      },
      {
        "codigo": "M238",
        "valor": "OTROS TRASTORNOS INTERNOS DE LA RODILLA"
      },
      {
        "codigo": "M239",
        "valor": "TRASTORNO INTERNO DE LA RODILLA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M24 - OTROS TRASTORNOS ARTICULARES ESPECIFICOS",
    "detalle": [
      {
        "codigo": "M240",
        "valor": "CUERPO FLOTANTE ARTICULAR"
      },
      {
        "codigo": "M241",
        "valor": "OTROS TRASTORNOS DEL CARTILAGO ARTICULAR"
      },
      {
        "codigo": "M242",
        "valor": "TRASTORNO DEL LIGAMENTO"
      },
      {
        "codigo": "M243",
        "valor": "LUXACION Y SUBLUXACION PATOLOGICA DE LA ARTICULACION, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M244",
        "valor": "LUXACION Y SUBLUXACION RECIDIVANTE DE LA ARTICULACION"
      },
      {
        "codigo": "M245",
        "valor": "CONTRACTURA ARTICULAR"
      },
      {
        "codigo": "M246",
        "valor": "ANQUILOSIS ARTICULAR"
      },
      {
        "codigo": "M247",
        "valor": "PROTRUSION DE ACETABULO"
      },
      {
        "codigo": "M248",
        "valor": "OTRAS LESIONES ARTICULARES ESPECIFICAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M249",
        "valor": "DESARREGLO ARTICULAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M25 - OTROS TRASTORNOS ARTICULARES, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M250",
        "valor": "HEMARTROSIS"
      },
      {
        "codigo": "M251",
        "valor": "FISTULA ARTICULAR"
      },
      {
        "codigo": "M252",
        "valor": "ARTICULACION INESTABLE"
      },
      {
        "codigo": "M253",
        "valor": "OTRAS INESTABILIDADES ARTICULARES"
      },
      {
        "codigo": "M254",
        "valor": "DERRAME ARTICULAR"
      },
      {
        "codigo": "M255",
        "valor": "DOLOR EN ARTICULACION"
      },
      {
        "codigo": "M256",
        "valor": "RIGIDEZ ARTICULAR, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M257",
        "valor": "OSTEOFITO"
      },
      {
        "codigo": "M258",
        "valor": "OTROS TRASTORNOS ARTICULARES ESPECIFICADOS"
      },
      {
        "codigo": "M259",
        "valor": "TRASTORNO ARTICULAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M30 - POLIARTERITIS NUDOSA Y AFECCIONES RELACIONADAS",
    "detalle": [
      {
        "codigo": "M300",
        "valor": "POLIARTERITIS NUDOSA"
      },
      {
        "codigo": "M301",
        "valor": "POLIARTERITIS CON COMPROMISO PULMONAR [CHURG-STRAUSS]"
      },
      {
        "codigo": "M302",
        "valor": "POLIARTERITIS JUVENIL"
      },
      {
        "codigo": "M303",
        "valor": "SINDROME MUCOCUTANEO LINFONODULAR [KAWASAKI]"
      },
      {
        "codigo": "M308",
        "valor": "OTRAS AFECCIONES RELACIONADAS CON LA POLIARTERITIS NUDOSA"
      }
    ]
  },
  {
    "grupo": "M31 - OTRAS VASCULOPATIAS NECROTIZANTES",
    "detalle": [
      {
        "codigo": "M310",
        "valor": "ANGIITIS DEBIDA A HIPERSENSIBILIDAD"
      },
      {
        "codigo": "M311",
        "valor": "MICROANGIOPATIA TROMBOTICA"
      },
      {
        "codigo": "M312",
        "valor": "GRANULOMA LETAL DE LA LINEA MEDIA"
      },
      {
        "codigo": "M313",
        "valor": "GRANULOMATOSIS DE WEGENER"
      },
      {
        "codigo": "M314",
        "valor": "SINDROME DEL CAYADO DE LA AORTA [TAKAYASU]"
      },
      {
        "codigo": "M315",
        "valor": "ARTERITIS DE CELULAS GIGANTES CON POLIMIALGIA REUMATICA"
      },
      {
        "codigo": "M316",
        "valor": "OTRAS ARTERITIS DE CELULAS GIGANTES"
      },
      {
        "codigo": "M317",
        "valor": "POLIANGIITIS MICROSCOPICA"
      },
      {
        "codigo": "M318",
        "valor": "OTRAS VASCULOPATIAS NECROTIZANTES ESPECIFICADAS"
      },
      {
        "codigo": "M319",
        "valor": "VASCULOPATIA NECROTIZANTE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M32 - LUPUS ERITEMATOSO SISTEMICO",
    "detalle": [
      {
        "codigo": "M320",
        "valor": "LUPUS ERITEMATOSO SISTEMICO, INDUCIDO POR DROGAS"
      },
      {
        "codigo": "M321",
        "valor": "LUPUS ERITEMATOSO SISTEMICO CON COMPROMISO DE ORGANOS O SISTEMAS"
      },
      {
        "codigo": "M328",
        "valor": "OTRAS FORMAS DE LUPUS ERITEMATOSO SISTEMICO"
      },
      {
        "codigo": "M329",
        "valor": "LUPUS ERITEMATOSO SISTEMICO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "M33 - DERMATOPOLIMIOSITIS",
    "detalle": [
      {
        "codigo": "M330",
        "valor": "DERMATOMIOSITIS JUVENIL"
      },
      {
        "codigo": "M331",
        "valor": "OTRAS DERMATOMIOSITIS"
      },
      {
        "codigo": "M332",
        "valor": "POLIMIOSITIS"
      },
      {
        "codigo": "M339",
        "valor": "DERMATOPOLIMIOSITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M34 - ESCLEROSIS SISTEMICA",
    "detalle": [
      {
        "codigo": "M340",
        "valor": "ESCLEROSIS SISTEMICA PROGRESIVA"
      },
      {
        "codigo": "M341",
        "valor": "SINDROME CR(E)ST"
      },
      {
        "codigo": "M342",
        "valor": "ESCLEROSIS SISTEMICA INDUCIDA POR DROGAS O PRODUCTOS QUIMICOS"
      },
      {
        "codigo": "M348",
        "valor": "OTRAS FORMAS DE ESCLEROSIS SISTEMICA"
      },
      {
        "codigo": "M349",
        "valor": "ESCLEROSIS SISTEMICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M35 - OTRO COMPROMISO SISTEMICO DEL TEJIDO CONJUNTIVO",
    "detalle": [
      {
        "codigo": "M350",
        "valor": "SINDROME SECO [SJÖGREN]"
      },
      {
        "codigo": "M351",
        "valor": "OTROS SINDROMES SUPERPUESTOS"
      },
      {
        "codigo": "M352",
        "valor": "ENFERMEDAD DE BEHCET"
      },
      {
        "codigo": "M353",
        "valor": "POLIMIALGIA REUMATICA"
      },
      {
        "codigo": "M354",
        "valor": "FASCITIS DIFUSA (EOSINOFILICA)"
      },
      {
        "codigo": "M355",
        "valor": "FIBROSCLEROSIS MULTIFOCAL"
      },
      {
        "codigo": "M356",
        "valor": "PANICULITIS RECIDIVANTE [WEBER-CHRISTIAN]"
      },
      {
        "codigo": "M357",
        "valor": "SINDROME DE HIPERMOVILIDAD"
      },
      {
        "codigo": "M358",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS CON COMPROMISO SISTEMICO DEL TEJIDO CONJUNTIVO"
      },
      {
        "codigo": "M359",
        "valor": "COMPROMISO SISTEMICO DEL TEJIDO CONJUNTIVO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M36 - TRASTORNOS SISTEMICOS DEL TEJIDO CONJUNTIVO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M360",
        "valor": "DERMATO(POLI)MIOSITIS EN ENFERMEDAD NEOPLASICA"
      },
      {
        "codigo": "M361",
        "valor": "ARTROPATIA EN ENFERMEDAD NEOPLASICA"
      },
      {
        "codigo": "M362",
        "valor": "ARTROPATIA HEMOFILICA"
      },
      {
        "codigo": "M363",
        "valor": "ARTROPATIA EN OTROS TRASTORNOS DE LA SANGRE"
      },
      {
        "codigo": "M364",
        "valor": "ARTROPATIA EN REACCIONES DE HIPERSENSIBILIDAD CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M368",
        "valor": "TRASTORNOS SISTEMICOS DEL TEJIDO CONJUNTIVO EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M40 - CIFOSIS Y LORDOSIS",
    "detalle": [
      {
        "codigo": "M400",
        "valor": "CIFOSIS POSTURAL"
      },
      {
        "codigo": "M401",
        "valor": "OTRAS CIFOSIS SECUNDARIAS"
      },
      {
        "codigo": "M402",
        "valor": "OTRAS CIFOSIS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "M403",
        "valor": "SINDROME DE ESPALDA PLANA"
      },
      {
        "codigo": "M404",
        "valor": "OTRAS LORDOSIS"
      },
      {
        "codigo": "M405",
        "valor": "LORDOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M41 - ESCOLIOSIS",
    "detalle": [
      {
        "codigo": "M410",
        "valor": "ESCOLIOSIS IDIOPATICA INFANTIL"
      },
      {
        "codigo": "M411",
        "valor": "ESCOLIOSIS IDIOPATICA JUVENIL"
      },
      {
        "codigo": "M412",
        "valor": "OTRAS ESCOLIOSIS IDIOPATICAS"
      },
      {
        "codigo": "M413",
        "valor": "ESCOLIOSIS TORACOGENICA"
      },
      {
        "codigo": "M414",
        "valor": "ESCOLIOSIS NEUROMUSCULAR"
      },
      {
        "codigo": "M415",
        "valor": "OTRAS ESCOLIOSIS SECUNDARIAS"
      },
      {
        "codigo": "M418",
        "valor": "OTRAS FORMAS DE ESCOLIOSIS"
      },
      {
        "codigo": "M419",
        "valor": "ESCOLIOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M42 - OSTEOCONDROSIS DE LA COLUMNA VERTEBRAL",
    "detalle": [
      {
        "codigo": "M420",
        "valor": "OSTEOCONDROSIS JUVENIL DE LA COLUMNA VERTEBRAL"
      },
      {
        "codigo": "M421",
        "valor": "OSTEOCONDROSIS DE LA COLUMNA VERTEBRAL DEL ADULTO"
      },
      {
        "codigo": "M429",
        "valor": "OSTEOCONDROSIS VERTEBRAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M43 - OTRAS DORSOPATIAS DEFORMANTES",
    "detalle": [
      {
        "codigo": "M430",
        "valor": "ESPONDILOLISIS"
      },
      {
        "codigo": "M431",
        "valor": "ESPONDILOLISTESIS"
      },
      {
        "codigo": "M432",
        "valor": "OTRAS FUSIONES DE LA COLUMNA VERTEBRAL"
      },
      {
        "codigo": "M433",
        "valor": "SUBLUXACION ATLANTO-AXOIDEA RECURRENTE, CON MIELOPATIA"
      },
      {
        "codigo": "M434",
        "valor": "OTRAS SUBLUXACIONES ATLANTO-AXOIDEAS RECURRENTES"
      },
      {
        "codigo": "M435",
        "valor": "OTRAS SUBLUXACIONES VERTEBRALES RECURRENTES"
      },
      {
        "codigo": "M436",
        "valor": "TORTICOLIS"
      },
      {
        "codigo": "M438",
        "valor": "OTRAS DORSOPATIAS DEFORMANTES DE LA COLUMNA VERTEBRAL ESPECIFICADAS"
      },
      {
        "codigo": "M439",
        "valor": "DORSOPATIA DEFORMANTE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M45 - ESPONDILITIS ANQUILOSANTE",
    "detalle": [
      {
        "codigo": "M450",
        "valor": "ESPONDILITIS ANQUILOSANTE, SITIOS MULTIPLES DE LA COLUMNA VERTEBRAL"
      },
      {
        "codigo": "M451",
        "valor": "ESPONDILITIS ANQUILOSANTE, REGION OCCIPITOCERVICAL"
      },
      {
        "codigo": "M452",
        "valor": "ESPONDILITIS ANQUILOSANTE, REGION CERVICAL"
      },
      {
        "codigo": "M453",
        "valor": "ESPONDILITIS ANQUILOSANTE, REGION CERVICOTORACICA"
      },
      {
        "codigo": "M454",
        "valor": "ESPONDILITIS ANQUILOSANTE, REGION TORACICA"
      },
      {
        "codigo": "M455",
        "valor": "ESPONDILITIS ANQUILOSANTE, REGION TORACOLUMBAR"
      },
      {
        "codigo": "M456",
        "valor": "ESPONDILITIS ANQUILOSANTE, REGION LUMBAR"
      },
      {
        "codigo": "M457",
        "valor": "ESPONDILITIS ANQUILOSANTE, REGION LUMBOSACRA"
      },
      {
        "codigo": "M458",
        "valor": "ESPONDILITIS ANQUILOSANTE, REGION SACRA Y SACROCOCCIGEA"
      },
      {
        "codigo": "M459",
        "valor": "ESPONDILITIS ANQUILOSANTE, SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "M45X",
        "valor": "ESPONDILITIS ANQUILOSANTE"
      }
    ]
  },
  {
    "grupo": "M46 - OTRAS ESPONDILOPATIAS INFLAMATORIAS",
    "detalle": [
      {
        "codigo": "M460",
        "valor": "ENTESOPATIA VERTEBRAL"
      },
      {
        "codigo": "M461",
        "valor": "SACROILIITIS, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M462",
        "valor": "OSTEOMIELITIS DE VERTEBRA"
      },
      {
        "codigo": "M463",
        "valor": "INFECCION DE DISCO INTERVERTEBRAL (PIOGENA)"
      },
      {
        "codigo": "M464",
        "valor": "DISCITIS, NO ESPECIFICADA"
      },
      {
        "codigo": "M465",
        "valor": "OTRAS ESPONDILOPATIAS INFECCIOSAS"
      },
      {
        "codigo": "M468",
        "valor": "OTRAS ESPONDILOPATIAS INFLAMATORIAS ESPECIFICADAS"
      },
      {
        "codigo": "M469",
        "valor": "ESPONDILOPATIA INFLAMATORIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M47 - ESPONDILOSIS",
    "detalle": [
      {
        "codigo": "M470",
        "valor": "SINDROMES DE COMPRESION DE LA ARTERIA ESPINAL O VERTEBRAL ANTERIOR"
      },
      {
        "codigo": "M471",
        "valor": "OTRAS ESPONDILOSIS CON MIELOPATIA"
      },
      {
        "codigo": "M472",
        "valor": "OTRAS ESPONDILOSIS CON RADICULOPATIA"
      },
      {
        "codigo": "M478",
        "valor": "OTRAS ESPONDILOSIS"
      },
      {
        "codigo": "M479",
        "valor": "ESPONDILOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M48 - OTRAS ESPONDILOPATIAS",
    "detalle": [
      {
        "codigo": "M480",
        "valor": "ESTENOSIS ESPINAL"
      },
      {
        "codigo": "M481",
        "valor": "HIPEROSTOSIS ANQUILOSANTE [FORESTIER]"
      },
      {
        "codigo": "M482",
        "valor": "ESPONDILOPATIA INTERESPINOSA (VERTEBRAS EN BESO)"
      },
      {
        "codigo": "M483",
        "valor": "ESPONDILOPATIA TRAUMATICA"
      },
      {
        "codigo": "M484",
        "valor": "FRACTURA DE VERTEBRA POR FATIGA"
      },
      {
        "codigo": "M485",
        "valor": "VERTEBRA COLAPSADA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M488",
        "valor": "OTRAS ESPONDILOPATIAS ESPECIFICADAS"
      },
      {
        "codigo": "M489",
        "valor": "ESPONDILOPATIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M49 - ESPONDILOPATIAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M490",
        "valor": "TUBERCULOSIS DE LA COLUMNA VERTEBRAL"
      },
      {
        "codigo": "M491",
        "valor": "ESPONDILITIS POR BRUCELOSIS"
      },
      {
        "codigo": "M492",
        "valor": "ESPONDILITIS POR ENTEROBACTERIAS"
      },
      {
        "codigo": "M493",
        "valor": "ESPONDILOPATIA EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M494",
        "valor": "ESPONDILOPATIA NEUROPATICA"
      },
      {
        "codigo": "M495",
        "valor": "VERTEBRA COLAPSADA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M498",
        "valor": "ESPONDILOPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M50 - TRASTORNOS DE DISCO CERVICAL",
    "detalle": [
      {
        "codigo": "M500",
        "valor": "TRASTORNO DE DISCO CERVICAL CON MIELOPATIA"
      },
      {
        "codigo": "M501",
        "valor": "TRASTORNO DE DISCO CERVICAL CON RADICULOPATIA"
      },
      {
        "codigo": "M502",
        "valor": "OTROS DESPLAZAMIENTOS DE DISCO CERVICAL"
      },
      {
        "codigo": "M503",
        "valor": "OTRAS DEGENERACIONES DE DISCO CERVICAL"
      },
      {
        "codigo": "M508",
        "valor": "OTROS TRASTORNOS DE DISCO CERVICAL"
      },
      {
        "codigo": "M509",
        "valor": "TRASTORNO DE DISCO CERVICAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M51 - OTROS TRASTORNOS DE LOS DISCOS INTERVERTEBRALES",
    "detalle": [
      {
        "codigo": "M510",
        "valor": "TRASTORNOS DE DISCOS INTERVERTEBRALES LUMBARES Y OTROS, CON MIELOPATIA"
      },
      {
        "codigo": "M511",
        "valor": "TRASTORNOS DE DISCO LUMBAR Y OTROS, CON RADICULOPATIA"
      },
      {
        "codigo": "M512",
        "valor": "OTROS DESPLAZAMIENTOS ESPECIFICADOS DE DISCO INTERVERTEBRAL"
      },
      {
        "codigo": "M513",
        "valor": "OTRAS DEGENERACIONES ESPECIFICADAS DE DISCO INTERVERTEBRAL"
      },
      {
        "codigo": "M514",
        "valor": "NODULOS DE SCHMORL"
      },
      {
        "codigo": "M518",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LOS DISCOS INTERVERTEBRALES"
      },
      {
        "codigo": "M519",
        "valor": "TRASTORNO DE LOS DISCOS INTERVERTEBRALES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M53 - OTRAS DORSOPATIAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M530",
        "valor": "SINDROME CERVICOCRANEAL"
      },
      {
        "codigo": "M531",
        "valor": "SINDROME CERVICOBRAQUIAL"
      },
      {
        "codigo": "M532",
        "valor": "INESTABILIDAD DE LA COLUMNA VERTEBRAL"
      },
      {
        "codigo": "M533",
        "valor": "TRASTORNOS SACROCOCCIGEOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "M538",
        "valor": "OTRAS DORSOPATIAS ESPECIFICADAS"
      },
      {
        "codigo": "M539",
        "valor": "DORSOPATIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M54 - DORSALGIA",
    "detalle": [
      {
        "codigo": "M540",
        "valor": "PANICULITIS QUE AFECTA REGIONES DEL CUELLO Y DE LA ESPALDA"
      },
      {
        "codigo": "M541",
        "valor": "RADICULOPATIA"
      },
      {
        "codigo": "M542",
        "valor": "CERVICALGIA"
      },
      {
        "codigo": "M543",
        "valor": "CIATICA"
      },
      {
        "codigo": "M544",
        "valor": "LUMBAGO CON CIATICA"
      },
      {
        "codigo": "M545",
        "valor": "LUMBAGO NO ESPECIFICADO"
      },
      {
        "codigo": "M546",
        "valor": "DOLOR EN LA COLUMNA DORSAL"
      },
      {
        "codigo": "M548",
        "valor": "OTRAS DORSALGIAS"
      },
      {
        "codigo": "M549",
        "valor": "DORSALGIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M60 - MIOSITIS",
    "detalle": [
      {
        "codigo": "M600",
        "valor": "MIOSITIS INFECCIOSA"
      },
      {
        "codigo": "M601",
        "valor": "MIOSITIS INTERSTICIAL"
      },
      {
        "codigo": "M602",
        "valor": "GRANULOMA POR CUERPO EXTRAÑO EN TEJIDO BLANDO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "M608",
        "valor": "OTRAS MIOSITIS"
      },
      {
        "codigo": "M609",
        "valor": "MIOSITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M61 - CALCIFICACION Y OSIFICACION DEL MUSCULO",
    "detalle": [
      {
        "codigo": "M610",
        "valor": "MIOSITIS OSIFICANTE TRAUMATICA"
      },
      {
        "codigo": "M611",
        "valor": "MIOSITIS OSIFICANTE PROGRESIVA"
      },
      {
        "codigo": "M612",
        "valor": "CALCIFICACION Y OSIFICACION PARALITICA DEL MUSCULO"
      },
      {
        "codigo": "M613",
        "valor": "CALCIFICACION Y OSIFICACION DE LOS MUSCULOS ASOCIADAS CON QUEMADURAS"
      },
      {
        "codigo": "M614",
        "valor": "OTRAS CALCIFICACIONES DEL MUSCULO"
      },
      {
        "codigo": "M615",
        "valor": "OTRAS OSIFICACIONES DEL MUSCULO"
      },
      {
        "codigo": "M619",
        "valor": "CALCIFICACION Y OSIFICACION DEL MUSCULO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M62 - OTROS TRASTORNOS DE LOS MUSCULOS",
    "detalle": [
      {
        "codigo": "M620",
        "valor": "DIASTASIS DEL MUSCULO"
      },
      {
        "codigo": "M621",
        "valor": "OTROS DESGARROS (NO TRAUMATICOS) DEL MUSCULO"
      },
      {
        "codigo": "M622",
        "valor": "INFARTO ISQUEMICO DEL MUSCULO"
      },
      {
        "codigo": "M623",
        "valor": "SINDROME DE INMOVILIDAD (PARAPLEJICO)"
      },
      {
        "codigo": "M624",
        "valor": "CONTRACTURA MUSCULAR"
      },
      {
        "codigo": "M625",
        "valor": "ATROFIA Y DESGASTE MUSCULARES, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "M626",
        "valor": "DISTENSION MUSCULAR"
      },
      {
        "codigo": "M628",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LOS MUSCULOS"
      },
      {
        "codigo": "M629",
        "valor": "TRASTORNO MUSCULAR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M63 - TRASTORNOS DE LOS MUSCULOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M630",
        "valor": "MIOSITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M631",
        "valor": "MIOSITIS EN INFECCIONES POR PROTOZOARIOS Y PARASITOS CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "M632",
        "valor": "MIOSITIS EN OTRAS ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M633",
        "valor": "MIOSITIS EN SARCOIDOSIS"
      },
      {
        "codigo": "M638",
        "valor": "OTROS TRASTORNOS DE LOS MUSCULOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M65 - SINOVITIS Y TENOSINOVITIS",
    "detalle": [
      {
        "codigo": "M650",
        "valor": "ABSCESO DE VAINA TENDINOSA"
      },
      {
        "codigo": "M651",
        "valor": "OTRAS (TENO)SINOVITIS INFECCIOSAS"
      },
      {
        "codigo": "M652",
        "valor": "TENDINITIS CALCIFICADA"
      },
      {
        "codigo": "M653",
        "valor": "DEDO EN GATILLO"
      },
      {
        "codigo": "M654",
        "valor": "TENOSINOVITIS DE ESTILOIDES RADIAL [DE QUERVAIN]"
      },
      {
        "codigo": "M658",
        "valor": "OTRAS SINOVITIS Y TENOSINOVITIS"
      },
      {
        "codigo": "M659",
        "valor": "SINOVITIS Y TENOSINOVITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M66 - RUPTURA ESPONTANEA DE LA SINOVIA Y DEL TENDON",
    "detalle": [
      {
        "codigo": "M660",
        "valor": "RUPTURA DE QUISTE SINOVIAL POPLITEO"
      },
      {
        "codigo": "M661",
        "valor": "RUPTURA DE LA SINOVIA"
      },
      {
        "codigo": "M662",
        "valor": "RUPTURA ESPONTANEA DE TENDONES EXTENSORES"
      },
      {
        "codigo": "M663",
        "valor": "RUPTURA ESPONTANEA DE TENDONES FLEXORES"
      },
      {
        "codigo": "M664",
        "valor": "RUPTURA ESPONTANEA DE OTROS TENDONES"
      },
      {
        "codigo": "M665",
        "valor": "RUPTURA ESPONTANEA DE TENDON NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M67 - OTROS TRASTORNOS DE LA SINOVIA Y DEL TENDON",
    "detalle": [
      {
        "codigo": "M670",
        "valor": "ACORTAMIENTO DEL TENDON DE AQUILES (ADQUIRIDO)"
      },
      {
        "codigo": "M671",
        "valor": "OTRAS CONTRACTURAS DE TENDON (VAINA)"
      },
      {
        "codigo": "M672",
        "valor": "HIPERTROFIA SINOVIAL, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M673",
        "valor": "SINOVITIS TRANSITORIA"
      },
      {
        "codigo": "M674",
        "valor": "GANGLION"
      },
      {
        "codigo": "M678",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA SINOVIA Y DEL TENDON"
      },
      {
        "codigo": "M679",
        "valor": "TRASTORNO SINOVIAL Y TENDINOSO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M68 - TRASTORNOS DE LOS TENDONES Y DE LA SINOVIA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M680",
        "valor": "SINOVITIS Y TENOSINOVITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M688",
        "valor": "OTROS TRASTORNOS SINOVIALES Y TENDINOSOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M70 - TRASTORNOS DE LOS TEJIDOS BLANDOS RELACIONADOS CON EL USO, EL USO EXCESIVO Y LA PRESION",
    "detalle": [
      {
        "codigo": "M700",
        "valor": "SINOVITIS CREPITANTE CRONICA DE LA MANO Y DE LA MUÑECA"
      },
      {
        "codigo": "M701",
        "valor": "BURSITIS DE LA MANO"
      },
      {
        "codigo": "M702",
        "valor": "BURSITIS DEL OLECRANON"
      },
      {
        "codigo": "M703",
        "valor": "OTRAS BURSITIS DEL CODO"
      },
      {
        "codigo": "M704",
        "valor": "OTRAS BURSITIS PRERROTULIANAS"
      },
      {
        "codigo": "M705",
        "valor": "OTRAS BURSITIS DE LA RODILLA"
      },
      {
        "codigo": "M706",
        "valor": "BURSITIS DEL TROCANTER"
      },
      {
        "codigo": "M707",
        "valor": "OTRAS BURSITIS DE LA CADERA"
      },
      {
        "codigo": "M708",
        "valor": "OTROS TRASTORNOS DE LOS TEJIDOS BLANDOS RELACIONADOS CON EL USO, EL USO EXCESIVO Y LA PRESION"
      },
      {
        "codigo": "M709",
        "valor": "TRASTORNO NO ESPECIFICADO DE LOS TEJIDOS BLANDOS RELACIONADO CON EL USO, EL USO EXCESIVO Y LA PRESION"
      }
    ]
  },
  {
    "grupo": "M71 - OTRAS BURSOPATIAS",
    "detalle": [
      {
        "codigo": "M710",
        "valor": "ABSCESO DE LA BOLSA SINOVIAL"
      },
      {
        "codigo": "M711",
        "valor": "OTRAS BURSITIS INFECCIOSAS"
      },
      {
        "codigo": "M712",
        "valor": "QUISTE SINOVIAL DEL HUECO POPLITEO [DE BAKER]"
      },
      {
        "codigo": "M713",
        "valor": "OTROS QUISTES DE LA BOLSA SEROSA"
      },
      {
        "codigo": "M714",
        "valor": "DEPOSITO DE CALCIO EN LA BOLSA SEROSA"
      },
      {
        "codigo": "M715",
        "valor": "OTRAS BURSITIS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M718",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA BOLSA SEROSA"
      },
      {
        "codigo": "M719",
        "valor": "BURSOPATIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M72 - TRASTORNOS FIBROBLASTICOS",
    "detalle": [
      {
        "codigo": "M720",
        "valor": "FIBROMATOSIS DE LA APONEUROSIS PALMAR [DUPUYTREN]"
      },
      {
        "codigo": "M721",
        "valor": "NODULOS INTERFALANGICOS"
      },
      {
        "codigo": "M722",
        "valor": "FIBROMATOSIS DE LA APONEUROSIS PLANTAR"
      },
      {
        "codigo": "M723",
        "valor": "FASCITIS NODULAR"
      },
      {
        "codigo": "M724",
        "valor": "FIBROMATOSIS SEUDOSARCOMATOSA"
      },
      {
        "codigo": "M725",
        "valor": "FASCITIS, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M726",
        "valor": "FASCITIS NECROTIZANTE"
      },
      {
        "codigo": "M728",
        "valor": "OTROS TRASTORNOS FIBROBLASTICOS"
      },
      {
        "codigo": "M729",
        "valor": "TRASTORNO FIBROBLASTICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M73 - TRASTORNOS DE LOS TEJIDOS BLANDOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M730",
        "valor": "BURSITIS GONOCOCICA"
      },
      {
        "codigo": "M731",
        "valor": "BURSITIS SIFILITICA"
      },
      {
        "codigo": "M738",
        "valor": "OTROS TRASTORNOS DE LOS TEJIDOS BLANDOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M75 - LESIONES DEL HOMBRO",
    "detalle": [
      {
        "codigo": "M750",
        "valor": "CAPSULITIS ADHESIVA DEL HOMBRO"
      },
      {
        "codigo": "M751",
        "valor": "SINDROME DEL MANGUITO ROTATORIO"
      },
      {
        "codigo": "M752",
        "valor": "TENDINITIS DEL BICEPS"
      },
      {
        "codigo": "M753",
        "valor": "TENDINITIS CALCIFICANTE DEL HOMBRO"
      },
      {
        "codigo": "M754",
        "valor": "SINDROME DE ABDUCCION DOLOROSA DEL HOMBRO"
      },
      {
        "codigo": "M755",
        "valor": "BURSITIS DEL HOMBRO"
      },
      {
        "codigo": "M758",
        "valor": "OTRAS LESIONES DEL HOMBRO"
      },
      {
        "codigo": "M759",
        "valor": "LESION DEL HOMBRO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M76 - ENTESOPATIAS DEL MIEMBRO INFERIOR, EXCLUIDO EL PIE",
    "detalle": [
      {
        "codigo": "M760",
        "valor": "TENDINITIS DEL GLUTEO"
      },
      {
        "codigo": "M761",
        "valor": "TENDINITIS DEL PSOAS"
      },
      {
        "codigo": "M762",
        "valor": "ESPOLON DE LA CRESTA ILIACA"
      },
      {
        "codigo": "M763",
        "valor": "SINDROME DEL TENDON DEL TENSOR DE LA FASCIA LATA"
      },
      {
        "codigo": "M764",
        "valor": "BURSITIS TIBIAL COLATERAL [PELLEGRINI-STIEDA]"
      },
      {
        "codigo": "M765",
        "valor": "TENDINITIS ROTULIANA"
      },
      {
        "codigo": "M766",
        "valor": "TENDINITIS AQUILIANA"
      },
      {
        "codigo": "M767",
        "valor": "TENDINITIS PERONEAL"
      },
      {
        "codigo": "M768",
        "valor": "OTRAS ENTESOPATIAS DEL MIEMBRO INFERIOR, EXCLUIDO EL PIE"
      },
      {
        "codigo": "M769",
        "valor": "ENTESOPATIA DEL MIEMBRO INFERIOR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M77 - OTRAS ENTESOPATIAS",
    "detalle": [
      {
        "codigo": "M770",
        "valor": "EPICONDILITIS MEDIA"
      },
      {
        "codigo": "M771",
        "valor": "EPICONDILITIS LATERAL"
      },
      {
        "codigo": "M772",
        "valor": "PERIARTRITIS DE LA MUÑECA"
      },
      {
        "codigo": "M773",
        "valor": "ESPOLON CALCANEO"
      },
      {
        "codigo": "M774",
        "valor": "METATARSALGIA"
      },
      {
        "codigo": "M775",
        "valor": "OTRAS ENTESOPATIAS DEL PIE"
      },
      {
        "codigo": "M778",
        "valor": "OTRAS ENTESOPATIAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M779",
        "valor": "ENTESOPATIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M79 - OTROS TRASTORNOS DE LOS TEJIDOS BLANDOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M790",
        "valor": "REUMATISMO, NO ESPECIFICADO"
      },
      {
        "codigo": "M791",
        "valor": "MIALGIA"
      },
      {
        "codigo": "M792",
        "valor": "NEURALGIA Y NEURITIS, NO ESPECIFICADAS"
      },
      {
        "codigo": "M793",
        "valor": "PANICULITIS, NO ESPECIFICADA"
      },
      {
        "codigo": "M794",
        "valor": "HIPERTROFIA DE PAQUETE ADIPOSO (INFRARROTULIANO)"
      },
      {
        "codigo": "M795",
        "valor": "CUERPO EXTRAÑO RESIDUAL EN TEJIDO BLANDO"
      },
      {
        "codigo": "M796",
        "valor": "DOLOR EN MIEMBRO"
      },
      {
        "codigo": "M797",
        "valor": "FIBROMIALGIA"
      },
      {
        "codigo": "M798",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LOS TEJIDOS BLANDOS"
      },
      {
        "codigo": "M799",
        "valor": "TRASTORNO DE LOS TEJIDOS BLANDOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M80 - OSTEOPOROSIS CON FRACTURA PATOLOGICA",
    "detalle": [
      {
        "codigo": "M800",
        "valor": "OSTEOPOROSIS POSTMENOPAUSICA, CON FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M801",
        "valor": "OSTEOPOROSIS POSTOOFORECTOMIA, CON FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M802",
        "valor": "OSTEOPOROSIS POR DESUSO, CON FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M803",
        "valor": "OSTEOPOROSIS POR MALABSORCION POSTQUIRURGICA, CON FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M804",
        "valor": "OSTEOPOROSIS INDUCIDA POR DROGAS, CON FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M805",
        "valor": "OSTEOPOROSIS IDIOPATICA, CON FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M808",
        "valor": "OTRAS OSTEOPOROSIS, CON FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M809",
        "valor": "OSTEOPOROSIS NO ESPECIFICADA, CON FRACTURA PATOLOGICA"
      }
    ]
  },
  {
    "grupo": "M81 - OSTEOPOROSIS SIN FRACTURA PATOLOGICA",
    "detalle": [
      {
        "codigo": "M810",
        "valor": "OSTEOPOROSIS POSTMENOPAUSICA, SIN FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M811",
        "valor": "OSTEOPOROSIS POSTOOFORECTOMIA, SIN FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M812",
        "valor": "OSTEOPOROSIS POR DESUSO, SIN FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M813",
        "valor": "OSTEOPOROSIS POR MALABSORCION POSTQUIRURGICA, SIN FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M814",
        "valor": "OSTEOPOROSIS INDUCIDA POR DROGAS, SIN FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M815",
        "valor": "OSTEOPOROSIS IDIOPATICA, SIN FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M816",
        "valor": "OSTEOPOROSIS LOCALIZADA [LEQUESNE], SIN FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M818",
        "valor": "OTRAS OSTEOPOROSIS, SIN FRACTURA PATOLOGICA"
      },
      {
        "codigo": "M819",
        "valor": "OSTEOPOROSIS NO ESPECIFICADA, SIN FRACTURA PATOLOGICA"
      }
    ]
  },
  {
    "grupo": "M82 - OSTEOPOROSIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M820",
        "valor": "OSTEOPOROSIS EN MIELOMATOSIS MULTIPLE"
      },
      {
        "codigo": "M821",
        "valor": "OSTEOPOROSIS EN TRASTORNOS ENDOCRINOS"
      },
      {
        "codigo": "M828",
        "valor": "OSTEOPOROSIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M83 - OSTEOMALACIA DEL ADULTO",
    "detalle": [
      {
        "codigo": "M830",
        "valor": "OSTEOMALACIA PUERPERAL"
      },
      {
        "codigo": "M831",
        "valor": "OSTEOMALACIA SENIL"
      },
      {
        "codigo": "M832",
        "valor": "OSTEOMALACIA DEL ADULTO DEBIDA A MALABSORCION"
      },
      {
        "codigo": "M833",
        "valor": "OSTEOMALACIA DEL ADULTO DEBIDA A DESNUTRICION"
      },
      {
        "codigo": "M834",
        "valor": "ENFERMEDAD DE LOS HUESOS POR ALUMINIO"
      },
      {
        "codigo": "M835",
        "valor": "OTRAS OSTEOMALACIAS DEL ADULTO INDUCIDAS POR DROGAS"
      },
      {
        "codigo": "M838",
        "valor": "OTRAS OSTEOMALACIAS DEL ADULTO"
      },
      {
        "codigo": "M839",
        "valor": "OSTEOMALACIA DEL ADULTO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M84 - TRASTORNOS DE LA CONTINUIDAD DEL HUESO",
    "detalle": [
      {
        "codigo": "M840",
        "valor": "CONSOLIDACION DEFECTUOSA DE FRACTURA"
      },
      {
        "codigo": "M841",
        "valor": "FALTA DE CONSOLIDACION DE FRACTURA [SEUDOARTROSIS]"
      },
      {
        "codigo": "M842",
        "valor": "CONSOLIDACION RETARDADA DE FRACTURA"
      },
      {
        "codigo": "M843",
        "valor": "FRACTURA POR TENSION, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M844",
        "valor": "FRACTURA PATOLOGICA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "M848",
        "valor": "OTROS TRASTORNOS DE LA CONTINUIDAD DEL HUESO"
      },
      {
        "codigo": "M849",
        "valor": "TRASTORNO DE LA CONTINUIDAD DEL HUESO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M85 - OTROS TRASTORNOS DE LA DENSIDAD Y DE LA ESTRUCTURA OSEAS",
    "detalle": [
      {
        "codigo": "M850",
        "valor": "DISPLASIA FIBROSA (MONOSTOTICA)"
      },
      {
        "codigo": "M851",
        "valor": "FLUOROSIS DEL ESQUELETO"
      },
      {
        "codigo": "M852",
        "valor": "HIPEROSTOSIS DEL CRANEO"
      },
      {
        "codigo": "M853",
        "valor": "OSTEITIS CONDENSANTE"
      },
      {
        "codigo": "M854",
        "valor": "QUISTE OSEO SOLITARIO"
      },
      {
        "codigo": "M855",
        "valor": "QUISTE OSEO ANEURISMATICO"
      },
      {
        "codigo": "M856",
        "valor": "OTROS QUISTES OSEOS"
      },
      {
        "codigo": "M858",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA DENSIDAD Y DE LA ESTRUCTURA OSEAS"
      },
      {
        "codigo": "M859",
        "valor": "TRASTORNO DE LA DENSIDAD Y DE LA ESTRUCTURA OSEAS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M86 - OSTEOMIELITIS",
    "detalle": [
      {
        "codigo": "M860",
        "valor": "OSTEOMIELITIS HEMATOGENA AGUDA"
      },
      {
        "codigo": "M861",
        "valor": "OTRAS OSTEOMIELITIS AGUDAS"
      },
      {
        "codigo": "M862",
        "valor": "OSTEOMIELITIS SUBAGUDA"
      },
      {
        "codigo": "M863",
        "valor": "OSTEOMIELITIS MULTIFOCAL CRONICA"
      },
      {
        "codigo": "M864",
        "valor": "OSTEOMIELITIS CRONICA CON DRENAJE DEL SENO"
      },
      {
        "codigo": "M865",
        "valor": "OTRAS OSTEOMIELITIS HEMATOGENAS CRONICAS"
      },
      {
        "codigo": "M866",
        "valor": "OTRAS OSTEOMIELITIS CRONICAS"
      },
      {
        "codigo": "M868",
        "valor": "OTRAS OSTEOMIELITIS"
      },
      {
        "codigo": "M869",
        "valor": "OSTEOMIELITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M87 - OSTEONECROSIS",
    "detalle": [
      {
        "codigo": "M870",
        "valor": "NECROSIS ASEPTICA IDIOPATICA OSEA"
      },
      {
        "codigo": "M871",
        "valor": "OSTEONECROSIS DEBIDA A DROGAS"
      },
      {
        "codigo": "M872",
        "valor": "OSTEONECROSIS DEBIDA A TRAUMATISMO PREVIO"
      },
      {
        "codigo": "M873",
        "valor": "OTRAS OSTEONECROSIS SECUNDARIAS"
      },
      {
        "codigo": "M878",
        "valor": "OTRAS OSTEONECROSIS"
      },
      {
        "codigo": "M879",
        "valor": "OSTEONECROSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M88 - ENFERMEDAD DE PAGET DE LOS HUESOS [OSTEITIS DEFORMANTE]",
    "detalle": [
      {
        "codigo": "M880",
        "valor": "ENFERMEDAD DE PAGET DEL CRANEO"
      },
      {
        "codigo": "M888",
        "valor": "ENFERMEDAD DE PAGET DE OTROS HUESOS"
      },
      {
        "codigo": "M889",
        "valor": "ENFERMEDAD OSEA DE PAGET, HUESOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "M89 - OTROS TRASTORNOS DEL HUESO",
    "detalle": [
      {
        "codigo": "M890",
        "valor": "ALGONEURODISTROFIA"
      },
      {
        "codigo": "M891",
        "valor": "DETENCION DEL CRECIMIENTO EPIFISARIO"
      },
      {
        "codigo": "M892",
        "valor": "OTROS TRASTORNOS DEL DESARROLLO Y CRECIMIENTO OSEO"
      },
      {
        "codigo": "M893",
        "valor": "HIPERTROFIA DEL HUESO"
      },
      {
        "codigo": "M894",
        "valor": "OTRAS OSTEOARTROPATIAS HIPERTROFICAS"
      },
      {
        "codigo": "M895",
        "valor": "OSTEOLISIS"
      },
      {
        "codigo": "M896",
        "valor": "OSTEOPATIA A CONSECUENCIA DE POLIOMIELITIS"
      },
      {
        "codigo": "M898",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL HUESO"
      },
      {
        "codigo": "M899",
        "valor": "TRASTORNO DEL HUESO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M90 - OSTEOPATIAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M900",
        "valor": "TUBERCULOSIS OSEA"
      },
      {
        "codigo": "M901",
        "valor": "PERIOSTITIS EN OTRAS ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M902",
        "valor": "OSTEOPATIA EN OTRAS ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M903",
        "valor": "OSTEONECROSIS EN LA ENFERMEDAD CAUSADA POR DESCOMPRESION"
      },
      {
        "codigo": "M904",
        "valor": "OSTEONECROSIS DEBIDA A HEMOGLOBINOPATIA"
      },
      {
        "codigo": "M905",
        "valor": "OSTEONECROSIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "M906",
        "valor": "OSTEITIS DEFORMANTE EN ENFERMEDAD NEOPLASICA"
      },
      {
        "codigo": "M907",
        "valor": "FRACTURA OSEA EN ENFERMEDAD NEOPLASICA"
      },
      {
        "codigo": "M908",
        "valor": "OSTEOPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "M91 - OSTEOCONDROSIS JUVENIL DE LA CADERA Y DE LA PELVIS",
    "detalle": [
      {
        "codigo": "M910",
        "valor": "OSTEOCONDROSIS JUVENIL DE LA PELVIS"
      },
      {
        "codigo": "M911",
        "valor": "OSTEOCONDROSIS JUVENIL DE LA CABEZA DEL FEMUR [LEGG-CALVE-PERTHES]"
      },
      {
        "codigo": "M912",
        "valor": "COXA PLANA"
      },
      {
        "codigo": "M913",
        "valor": "PSEUDOCOXALGIA"
      },
      {
        "codigo": "M918",
        "valor": "OTRAS OSTEOCONDROSIS JUVENILES DE LA CADERA Y DE LA PELVIS"
      },
      {
        "codigo": "M919",
        "valor": "OSTEOCONDROSIS JUVENIL DE LA CADERA Y DE LA PELVIS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "M92 - OTRAS OSTEOCONDROSIS JUVENILES",
    "detalle": [
      {
        "codigo": "M920",
        "valor": "OSTEOCONDROSIS JUVENIL DEL HUMERO"
      },
      {
        "codigo": "M921",
        "valor": "OSTEOCONDROSIS JUVENIL DEL CUBITO Y DEL RADIO"
      },
      {
        "codigo": "M922",
        "valor": "OSTEOCONDROSIS JUVENIL DE LA MANO"
      },
      {
        "codigo": "M923",
        "valor": "OTRAS OSTEOCONDROSIS JUVENILES DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "M924",
        "valor": "OSTEOCONDROSIS JUVENIL DE LA ROTULA"
      },
      {
        "codigo": "M925",
        "valor": "OSTEOCONDROSIS JUVENIL DE LA TIBIA Y DEL PERONE"
      },
      {
        "codigo": "M926",
        "valor": "OSTEOCONDROSIS JUVENIL DEL TARSO"
      },
      {
        "codigo": "M927",
        "valor": "OSTEOCONDROSIS JUVENIL DEL METATARSO"
      },
      {
        "codigo": "M928",
        "valor": "OTRAS OSTEOCONDROSIS JUVENILES ESPECIFICADAS"
      },
      {
        "codigo": "M929",
        "valor": "OSTEOCONDROSIS JUVENIL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M93 - OTRAS OSTEOCONDROPATIAS",
    "detalle": [
      {
        "codigo": "M930",
        "valor": "DESLIZAMIENTO DE LA EPIFISIS FEMORAL SUPERIOR (NO TRAUMATICO)"
      },
      {
        "codigo": "M931",
        "valor": "ENFERMEDAD DE KIENBÖCK DEL ADULTO"
      },
      {
        "codigo": "M932",
        "valor": "OSTEOCONDRITIS DISECANTE"
      },
      {
        "codigo": "M938",
        "valor": "OTRAS OSTEOCONDROPATIAS ESPECIFICADAS"
      },
      {
        "codigo": "M939",
        "valor": "OSTEOCONDROPATIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M94 - OTROS TRASTORNOS DEL CARTILAGO",
    "detalle": [
      {
        "codigo": "M940",
        "valor": "SINDROME DE LA ARTICULACION CONDROCOSTAL [TIETZE]"
      },
      {
        "codigo": "M941",
        "valor": "POLICONDRITIS RECIDIVANTE"
      },
      {
        "codigo": "M942",
        "valor": "CONDROMALACIA"
      },
      {
        "codigo": "M943",
        "valor": "CONDROLISIS"
      },
      {
        "codigo": "M948",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL CARTILAGO"
      },
      {
        "codigo": "M949",
        "valor": "TRASTORNO DEL CARTILAGO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "M95 - OTRAS DEFORMIDADES ADQUIRIDAS DEL SISTEMA OSTEOMUSCULAR Y DEL TEJIDO CONJUNTIVO",
    "detalle": [
      {
        "codigo": "M950",
        "valor": "DEFORMIDAD ADQUIRIDA DE LA NARIZ"
      },
      {
        "codigo": "M951",
        "valor": "OREJA EN COLIFLOR"
      },
      {
        "codigo": "M952",
        "valor": "OTRAS DEFORMIDADES ADQUIRIDAS DE LA CABEZA"
      },
      {
        "codigo": "M953",
        "valor": "DEFORMIDAD ADQUIRIDA DEL CUELLO"
      },
      {
        "codigo": "M954",
        "valor": "DEFORMIDAD ADQUIRIDA DE COSTILLAS Y TORAX"
      },
      {
        "codigo": "M955",
        "valor": "DEFORMIDAD ADQUIRIDA DE LA PELVIS"
      },
      {
        "codigo": "M958",
        "valor": "OTRAS DEFORMIDADES ADQUIRIDAS ESPECIFICADAS DEL SISTEMA OSTEOMUSCULAR"
      },
      {
        "codigo": "M959",
        "valor": "DEFORMIDAD ADQUIRIDA DEL SISTEMA OSTEOMUSCULAR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "M96 - TRASTORNOS OSTEOMUSCULARES CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M960",
        "valor": "SEUDOARTROSIS CONSECUTIVA A FUSION O ARTRODESIS"
      },
      {
        "codigo": "M961",
        "valor": "SINDROME POSTLAMINECTOMIA, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "M962",
        "valor": "CIFOSIS POSTRADIACION"
      },
      {
        "codigo": "M963",
        "valor": "CIFOSIS POSTLAMINECTOMIA"
      },
      {
        "codigo": "M964",
        "valor": "LORDOSIS POSTQUIRURGICA"
      },
      {
        "codigo": "M965",
        "valor": "ESCOLIOSIS POSTRRADIACION"
      },
      {
        "codigo": "M966",
        "valor": "FRACTURA DE HUESO POSTERIOR A INSERCION O IMPLANTE ORTOPEDICO, PROTESIS ARTICULAR O PLACA OSEA"
      },
      {
        "codigo": "M968",
        "valor": "OTROS TRASTORNOS OSTEOMUSCULARES CONSECUTIVOS A PROCEDIMIENTOS"
      },
      {
        "codigo": "M969",
        "valor": "TRASTORNOS OSTEOMUSCULARES NO ESPECIFICADOS CONSECUTIVOS A PROCEDIMIENTOS"
      }
    ]
  },
  {
    "grupo": "M99 - LESIONES BIOMECANICAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "M990",
        "valor": "DISFUNCION SEGMENTAL O SOMATICA"
      },
      {
        "codigo": "M991",
        "valor": "COMPLEJO DE SUBLUXACION (VERTEBRAL)"
      },
      {
        "codigo": "M992",
        "valor": "SUBLUXACION CON ESTENOSIS DEL CANAL NEURAL"
      },
      {
        "codigo": "M993",
        "valor": "ESTENOSIS OSEA DEL CANAL NEURAL"
      },
      {
        "codigo": "M994",
        "valor": "ESTENOSIS DEL CANAL NEURAL POR TEJIDO CONJUNTIVO"
      },
      {
        "codigo": "M995",
        "valor": "ESTENOSIS DEL CANAL NEURAL POR DISCO INTERVERTEBRAL"
      },
      {
        "codigo": "M996",
        "valor": "ESTENOSIS OSEA Y SUBLUXACION DE LOS AGUJEROS INTERVERTEBRALES"
      },
      {
        "codigo": "M997",
        "valor": "ESTENOSIS DE LOS AGUJEROS INTERVERTEBRALES POR TEJIDO CONJUNTIVO O POR DISCO INTERVERTEBRAL"
      },
      {
        "codigo": "M998",
        "valor": "OTRAS LESIONES BIOMECANICAS"
      },
      {
        "codigo": "M999",
        "valor": "LESION BIOMECANICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N00 - SINDROME NEFRITICO AGUDO",
    "detalle": [
      {
        "codigo": "N000",
        "valor": "SINDROME NEFRITICO AGUDO, ANOMALIA GLOMERULAR MINIMA"
      },
      {
        "codigo": "N001",
        "valor": "SINDROME NEFRITICO AGUDO, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
      },
      {
        "codigo": "N002",
        "valor": "SINDROME NEFRITICO AGUDO, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
      },
      {
        "codigo": "N003",
        "valor": "SINDROME NEFRITICO AGUDO, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
      },
      {
        "codigo": "N004",
        "valor": "SINDROME NEFRITICO AGUDO, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
      },
      {
        "codigo": "N005",
        "valor": "SINDROME NEFRITICO AGUDO, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
      },
      {
        "codigo": "N006",
        "valor": "SINDROME NEFRITICO AGUDO, ENFERMEDAD POR DEPOSITOS DENSOS"
      },
      {
        "codigo": "N007",
        "valor": "SINDROME NEFRITICO AGUDO, GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA"
      },
      {
        "codigo": "N008",
        "valor": "SINDROME NEFRITICO AGUDO, OTRAS"
      },
      {
        "codigo": "N009",
        "valor": "SINDROME NEFRITICO AGUDO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N01 - SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO",
    "detalle": [
      {
        "codigo": "N010",
        "valor": "SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO, ANOMALIA GLOMERULAR MINIMA"
      },
      {
        "codigo": "N011",
        "valor": "SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
      },
      {
        "codigo": "N012",
        "valor": "SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
      },
      {
        "codigo": "N013",
        "valor": "SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
      },
      {
        "codigo": "N014",
        "valor": "SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
      },
      {
        "codigo": "N015",
        "valor": "SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
      },
      {
        "codigo": "N016",
        "valor": "SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO, ENFERMEDAD POR DEPOSITOS DENSOS"
      },
      {
        "codigo": "N017",
        "valor": "SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO, GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA"
      },
      {
        "codigo": "N018",
        "valor": "SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO, OTRAS"
      },
      {
        "codigo": "N019",
        "valor": "SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N02 - HEMATURIA RECURRENTE Y PERSISTENTE",
    "detalle": [
      {
        "codigo": "N020",
        "valor": "HEMATURIA RECURRENTE Y PERSISTENTE, ANOMALIA GLOMERULAR MINIMA"
      },
      {
        "codigo": "N021",
        "valor": "HEMATURIA RECURRENTE Y PERSISTENTE, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
      },
      {
        "codigo": "N022",
        "valor": "HEMATURIA RECURRENTE Y PERSISTENTE, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
      },
      {
        "codigo": "N023",
        "valor": "HEMATURIA RECURRENTE Y PERSISTENTE, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
      },
      {
        "codigo": "N024",
        "valor": "HEMATURIA RECURRENTE Y PERSISTENTE, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
      },
      {
        "codigo": "N025",
        "valor": "HEMATURIA RECURRENTE Y PERSISTENTE, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
      },
      {
        "codigo": "N026",
        "valor": "HEMATURIA RECURRENTE Y PERSISTENTE, ENFERMEDAD POR DEPOSITOS DENSOS"
      },
      {
        "codigo": "N027",
        "valor": "HEMATURIA RECURRENTE Y PERSISTENTE, GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA"
      },
      {
        "codigo": "N028",
        "valor": "HEMATURIA RECURRENTE Y PERSISTENTE, OTRAS"
      },
      {
        "codigo": "N029",
        "valor": "HEMATURIA RECURRENTE Y PERSISTENTE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N03 - SINDROME NEFRITICO CRONICO",
    "detalle": [
      {
        "codigo": "N030",
        "valor": "SINDROME NEFRITICO CRONICO, ANOMALIA GLOMERULAR MINIMA"
      },
      {
        "codigo": "N031",
        "valor": "SINDROME NEFRITICO CRONICO, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
      },
      {
        "codigo": "N032",
        "valor": "SINDROME NEFRITICO CRONICO, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
      },
      {
        "codigo": "N033",
        "valor": "SINDROME NEFRITICO CRONICO, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
      },
      {
        "codigo": "N034",
        "valor": "SINDROME NEFRITICO CRONICO, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
      },
      {
        "codigo": "N035",
        "valor": "SINDROME NEFRITICO CRONICO, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
      },
      {
        "codigo": "N036",
        "valor": "SINDROME NEFRITICO CRONICO, ENFERMEDAD POR DEPOSITOS DENSOS"
      },
      {
        "codigo": "N037",
        "valor": "SINDROME NEFRITICO CRONICO, GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA"
      },
      {
        "codigo": "N038",
        "valor": "SINDROME NEFRITICO CRONICO, OTRAS"
      },
      {
        "codigo": "N039",
        "valor": "SINDROME NEFRITICO CRONICO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N04 - SINDROME NEFROTICO",
    "detalle": [
      {
        "codigo": "N040",
        "valor": "SINDROME NEFROTICO, ANOMALIA GLOMERULAR MINIMA"
      },
      {
        "codigo": "N041",
        "valor": "SINDROME NEFROTICO, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
      },
      {
        "codigo": "N042",
        "valor": "SINDROME NEFROTICO, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
      },
      {
        "codigo": "N043",
        "valor": "SINDROME NEFROTICO, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
      },
      {
        "codigo": "N044",
        "valor": "SINDROME NEFROTICO, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
      },
      {
        "codigo": "N045",
        "valor": "SINDROME NEFROTICO, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
      },
      {
        "codigo": "N046",
        "valor": "SINDROME NEFROTICO, ENFERMEDAD POR DEPOSITOS DENSOS"
      },
      {
        "codigo": "N047",
        "valor": "SINDROME NEFROTICO, GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA"
      },
      {
        "codigo": "N048",
        "valor": "SINDROME NEFROTICO, OTRAS"
      },
      {
        "codigo": "N049",
        "valor": "SINDROME NEFROTICO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N05 - SINDROME NEFRITICO NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "N050",
        "valor": "SINDROME NEFRITICO NO ESPECIFICADO, ANOMALIA GLOMERULAR MINIMA"
      },
      {
        "codigo": "N051",
        "valor": "SINDROME NEFRITICO NO ESPECIFICADO, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
      },
      {
        "codigo": "N052",
        "valor": "SINDROME NEFRITICO NO ESPECIFICADO, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
      },
      {
        "codigo": "N053",
        "valor": "SINDROME NEFRITICO NO ESPECIFICADO, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
      },
      {
        "codigo": "N054",
        "valor": "SINDROME NEFRITICO NO ESPECIFICADO, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
      },
      {
        "codigo": "N055",
        "valor": "SINDROME NEFRITICO NO ESPECIFICADO, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
      },
      {
        "codigo": "N056",
        "valor": "SINDROME NEFRITICO NO ESPECIFICADO, ENFERMEDAD POR DEPOSITOS DENSOS"
      },
      {
        "codigo": "N057",
        "valor": "SINDROME NEFRITICO NO ESPECIFICADO, GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA"
      },
      {
        "codigo": "N058",
        "valor": "SINDROME NEFRITICO NO ESPECIFICADO, OTRAS"
      },
      {
        "codigo": "N059",
        "valor": "SINDROME NEFRITICO NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N06 - PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA",
    "detalle": [
      {
        "codigo": "N060",
        "valor": "PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA, ANOMALIA GLOMERULAR MINIMA"
      },
      {
        "codigo": "N061",
        "valor": "PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
      },
      {
        "codigo": "N062",
        "valor": "PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
      },
      {
        "codigo": "N063",
        "valor": "PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
      },
      {
        "codigo": "N064",
        "valor": "PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
      },
      {
        "codigo": "N065",
        "valor": "PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
      },
      {
        "codigo": "N066",
        "valor": "PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA, ENFERMEDAD POR DEPOSITOS DENSOS"
      },
      {
        "codigo": "N067",
        "valor": "PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA, GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA"
      },
      {
        "codigo": "N068",
        "valor": "PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA, OTRAS"
      },
      {
        "codigo": "N069",
        "valor": "PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N07 - NEFROPATIA HEREDITARIA, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N070",
        "valor": "NEFROPATIA HEREDITARIA, NCOP, ANOMALIA GLOMERULAR MINIMA"
      },
      {
        "codigo": "N071",
        "valor": "NEFROPATIA HEREDITARIA, NCOP, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
      },
      {
        "codigo": "N072",
        "valor": "NEFROPATIA HEREDITARIA, NCOP, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
      },
      {
        "codigo": "N073",
        "valor": "NEFROPATIA HEREDITARIA, NCOP, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
      },
      {
        "codigo": "N074",
        "valor": "NEFROPATIA HEREDITARIA, NCOP, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
      },
      {
        "codigo": "N075",
        "valor": "NEFROPATIA HEREDITARIA, NCOP, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
      },
      {
        "codigo": "N076",
        "valor": "NEFROPATIA HEREDITARIA, NCOP, ENFERMEDAD POR DEPOSITOS DENSOS"
      },
      {
        "codigo": "N077",
        "valor": "NEFROPATIA HEREDITARIA, NCOP, GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA"
      },
      {
        "codigo": "N078",
        "valor": "NEFROPATIA HEREDITARIA, NCOP, OTRAS"
      },
      {
        "codigo": "N079",
        "valor": "NEFROPATIA HEREDITARIA, NCOP, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N08 - TRASTORNOS GLOMERULARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N080",
        "valor": "TRASTORNOS GLOMERULARES EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "N081",
        "valor": "TRASTORNOS GLOMERULARES EN ENFERMEDADES NEOPLASICAS"
      },
      {
        "codigo": "N082",
        "valor": "TRASTORNOS GLOMERULARES EN ENFERMEDADES DE LA SANGRE Y OTROS TRASTORNOS QUE AFECTAN EL MECANISMO INMUNITARIO"
      },
      {
        "codigo": "N083",
        "valor": "TRASTORNOS GLOMERULARES EN DIABETES MELLITUS"
      },
      {
        "codigo": "N084",
        "valor": "TRASTORNOS GLOMERULARES EN OTRAS ENFERMEDADES ENDOCRINAS, NUTRICIONALES Y METABOLICAS"
      },
      {
        "codigo": "N085",
        "valor": "TRASTORNOS GLOMERULARES EN TRASTORNOS SISTEMICOS DEL TEJIDO CONJUNTIVO"
      },
      {
        "codigo": "N088",
        "valor": "TRASTORNOS GLOMERULARES EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "N10 - NEFRITIS TUBULOINTERSTICIAL AGUDA",
    "detalle": [
      {
        "codigo": "N10X",
        "valor": "NEFRITIS TUBULOINTERSTICIAL AGUDA"
      }
    ]
  },
  {
    "grupo": "N11 - NEFRITIS TUBULOINTERSTICIAL CRONICA",
    "detalle": [
      {
        "codigo": "N110",
        "valor": "PIELONEFRITIS CRONICA NO OBSTRUCTIVA ASOCIADA CON REFLUJO"
      },
      {
        "codigo": "N111",
        "valor": "PIELONEFRITIS CRONICA OBSTRUCTIVA"
      },
      {
        "codigo": "N118",
        "valor": "OTRAS NEFRITIS TUBULOINTERSTICIALES CRONICAS"
      },
      {
        "codigo": "N119",
        "valor": "NEFRITIS TUBULOINTERSTICIAL CRONICA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "N12 - NEFRITIS TUBULOINTERSTICIAL, NO ESPECIFICADA COMO AGUDA O CRONICA",
    "detalle": [
      {
        "codigo": "N12X",
        "valor": "NEFRITIS TUBULOINTERSTICIAL, NO ESPECIFICADA COMO AGUDA O CRONICA"
      }
    ]
  },
  {
    "grupo": "N13 - UROPATIA OBSTRUCTIVA Y POR REFLUJO",
    "detalle": [
      {
        "codigo": "N130",
        "valor": "HIDRONEFROSIS CON OBSTRUCCION DE LA UNION URETERO-PELVICA"
      },
      {
        "codigo": "N131",
        "valor": "HIDRONEFROSIS CON ESTRECHEZ URETERAL, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "N132",
        "valor": "HIDRONEFROSIS CON OBSTRUCCION POR CALCULOS DEL RIÑON Y DEL URETER"
      },
      {
        "codigo": "N133",
        "valor": "OTRAS HIDRONEFROSIS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "N134",
        "valor": "HIDROURETER"
      },
      {
        "codigo": "N135",
        "valor": "TORSION Y ESTRECHEZ DEL URETER SIN HIDRONEFROSIS"
      },
      {
        "codigo": "N136",
        "valor": "PIONEFROSIS"
      },
      {
        "codigo": "N137",
        "valor": "UROPATIA ASOCIADA CON REFLUJO VESICOURETERAL"
      },
      {
        "codigo": "N138",
        "valor": "OTRAS UROPATIAS OBSTRUCTIVAS Y POR REFLUJO"
      },
      {
        "codigo": "N139",
        "valor": "UROPATIA OBSTRUCTIVA Y POR REFLUJO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "N14 - AFECCIONES TUBULARES Y TUBULOINTERSTICIALES INDUCIDAS POR DROGAS Y POR DROGAS POR METALES PESADOS",
    "detalle": [
      {
        "codigo": "N140",
        "valor": "NEFROPATIA INDUCIDA POR ANALGESICOS"
      },
      {
        "codigo": "N141",
        "valor": "NEFROPATIA INDUCIDA POR OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS"
      },
      {
        "codigo": "N142",
        "valor": "NEFROPATIA INDUCIDA POR DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS"
      },
      {
        "codigo": "N143",
        "valor": "NEFROPATIA INDUCIDA POR METALES PESADOS"
      },
      {
        "codigo": "N144",
        "valor": "NEFROPATIA TOXICA, NO CLASIFICADA EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "N15 - OTRAS ENFERMEDADES RENALES TUBULOINTERSTICIALES",
    "detalle": [
      {
        "codigo": "N150",
        "valor": "NEFROPATIA DE LOS BALCANES"
      },
      {
        "codigo": "N151",
        "valor": "ABSCESO RENAL Y PERIRRENAL"
      },
      {
        "codigo": "N158",
        "valor": "OTRAS ENFERMEDADES RENALES TUBULOINTERSTICIALES ESPECIFICADAS"
      },
      {
        "codigo": "N159",
        "valor": "ENFERMEDAD RENAL TUBULOINTERSTICIAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N16 - TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N160",
        "valor": "TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "N161",
        "valor": "TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES NEOPLASICAS"
      },
      {
        "codigo": "N162",
        "valor": "TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES DE LA SANGRE Y EN TRASTORNOS QUE AFECTAN EL MECANISMO INMUNITARIO"
      },
      {
        "codigo": "N163",
        "valor": "TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES METABOLICAS"
      },
      {
        "codigo": "N164",
        "valor": "TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES DEL TEJIDO CONJUNTIVO"
      },
      {
        "codigo": "N165",
        "valor": "TRASTORNOS RENALES TUBULOINTERSTICIALES EN RECHAZO DE TRASPLANTE"
      },
      {
        "codigo": "N168",
        "valor": "TRASTORNOS RENALES TUBULOINTERSTICIALES EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "N17 - INSUFICIENCIA RENAL AGUDA",
    "detalle": [
      {
        "codigo": "N170",
        "valor": "INSUFICIENCIA RENAL AGUDA CON NECROSIS TUBULAR"
      },
      {
        "codigo": "N171",
        "valor": "INSUFICIENCIA RENAL AGUDA CON NECROSIS CORTICAL AGUDA"
      },
      {
        "codigo": "N172",
        "valor": "INSUFICIENCIA RENAL AGUDA CON NECROSIS MEDULAR"
      },
      {
        "codigo": "N178",
        "valor": "OTRAS INSUFICIENCIAS RENALES AGUDAS"
      },
      {
        "codigo": "N179",
        "valor": "INSUFICIENCIA RENAL AGUDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N18 - ENFERMEDAD RENAL CRONICA",
    "detalle": [
      {
        "codigo": "N180",
        "valor": "INSUFICIENCIA RENAL TERMINAL"
      },
      {
        "codigo": "N181",
        "valor": "ENFERMEDAD RENAL CRONICA, ETAPA 1"
      },
      {
        "codigo": "N182",
        "valor": "ENFERMEDAD RENAL CRONICA, ETAPA 2"
      },
      {
        "codigo": "N183",
        "valor": "ENFERMEDAD RENAL CRONICA, ETAPA 3"
      },
      {
        "codigo": "N184",
        "valor": "ENFERMEDAD RENAL CRONICA, ETAPA 4"
      },
      {
        "codigo": "N185",
        "valor": "ENFERMEDAD RENAL CRONICA, ETAPA 5"
      },
      {
        "codigo": "N188",
        "valor": "OTRAS INSUFICIENCIAS RENALES CRONICAS"
      },
      {
        "codigo": "N189",
        "valor": "ENFERMEDAD RENAL CRONICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N19 - INSUFICIENCIA RENAL NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "N19X",
        "valor": "INSUFICIENCIA RENAL NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N20 - CALCULO DEL RIÑON Y DEL URETER",
    "detalle": [
      {
        "codigo": "N200",
        "valor": "CALCULO DEL RIÑON"
      },
      {
        "codigo": "N201",
        "valor": "CALCULO DEL URETER"
      },
      {
        "codigo": "N202",
        "valor": "CALCULO DEL RIÑON CON CALCULO DEL URETER"
      },
      {
        "codigo": "N209",
        "valor": "CALCULO URINARIO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N21 - CALCULO DE LAS VIAS URINARIAS INFERIORES",
    "detalle": [
      {
        "codigo": "N210",
        "valor": "CALCULO EN LA VEJIGA"
      },
      {
        "codigo": "N211",
        "valor": "CALCULO EN LA URETRA"
      },
      {
        "codigo": "N218",
        "valor": "OTROS CALCULOS DE LAS VIAS URINARIAS INFERIORES"
      },
      {
        "codigo": "N219",
        "valor": "CALCULO DE LAS VIAS URINARIAS INFERIORES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N22 - CALCULO DE LAS VIAS URINARIAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N220",
        "valor": "LITIASIS URINARIA EN ESQUISTOSOMIASIS [BILHARZIASIS]"
      },
      {
        "codigo": "N228",
        "valor": "CALCULO DE LAS VIAS URINARIAS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "N23 - COLICO RENAL, NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "N23X",
        "valor": "COLICO RENAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N25 - TRASTORNOS RESULTANTES DE LA FUNCION TUBULAR RENAL ALTERADA",
    "detalle": [
      {
        "codigo": "N250",
        "valor": "OSTEODISTROFIA RENAL"
      },
      {
        "codigo": "N251",
        "valor": "DIABETES INSIPIDA NEFROGENA"
      },
      {
        "codigo": "N258",
        "valor": "OTROS TRASTORNOS RESULTANTES DE LA FUNCION TUBULAR RENAL ALTERADA"
      },
      {
        "codigo": "N259",
        "valor": "TRASTORNO NO ESPECIFICADO, RESULTANTE DE LA FUNCION TUBULAR RENAL ALTERADA"
      }
    ]
  },
  {
    "grupo": "N26 - RIÑON CONTRAIDO, NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "N26X",
        "valor": "RINON CONTRAIDO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N27 - RIÑON PEQUEÑO DE CAUSA DESCONOCIDA",
    "detalle": [
      {
        "codigo": "N270",
        "valor": "RIÑON PEQUEÑO, UNILATERAL"
      },
      {
        "codigo": "N271",
        "valor": "RIÑON PEQUEÑO, BILATERAL"
      },
      {
        "codigo": "N279",
        "valor": "RIÑON PEQUEÑO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N28 - OTROS TRASTORNOS DEL RIÑON Y DEL URETER, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N280",
        "valor": "ISQUEMIA E INFARTO DEL RIÑON"
      },
      {
        "codigo": "N281",
        "valor": "QUISTE DE RIÑON, ADQUIRIDO"
      },
      {
        "codigo": "N288",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL RIÑON Y DEL URETER"
      },
      {
        "codigo": "N289",
        "valor": "TRASTORNO DEL RIÑON Y DEL URETER, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N29 - OTROS TRASTORNOS DEL RIÑON Y DEL URETER EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N290",
        "valor": "SIFILIS RENAL TARDIA"
      },
      {
        "codigo": "N291",
        "valor": "OTROS TRASTORNOS DEL RIÑON Y DEL URETER EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "N298",
        "valor": "OTROS TRASTORNOS DEL RIÑON Y DEL URETER EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "N30 - CISTITIS",
    "detalle": [
      {
        "codigo": "N300",
        "valor": "CISTITIS AGUDA"
      },
      {
        "codigo": "N301",
        "valor": "CISTITIS INTERSTICIAL (CRONICA)"
      },
      {
        "codigo": "N302",
        "valor": "OTRAS CISTITIS CRONICAS"
      },
      {
        "codigo": "N303",
        "valor": "TRIGONITIS"
      },
      {
        "codigo": "N304",
        "valor": "CISTITIS POR IRRADIACION"
      },
      {
        "codigo": "N308",
        "valor": "OTRAS CISTITIS"
      },
      {
        "codigo": "N309",
        "valor": "CISTITIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N31 - DISFUNCION NEUROMUSCULAR DE LA VEJIGA, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N310",
        "valor": "VEJIGA NEUROPATICA NO INHIBIDA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "N311",
        "valor": "VEJIGA NEUROPATICA REFLEJA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "N312",
        "valor": "VEJIGA NEUROPATICA FLACIDA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "N318",
        "valor": "OTRAS DISFUNCIONES NEUROMUSCULARES DE LA VEJIGA"
      },
      {
        "codigo": "N319",
        "valor": "DISFUNCION NEUROMUSCULAR DE LA VEJIGA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N32 - OTROS TRASTORNOS DE LA VEJIGA",
    "detalle": [
      {
        "codigo": "N320",
        "valor": "OBSTRUCCION DE CUELLO DE LA VEJIGA"
      },
      {
        "codigo": "N321",
        "valor": "FISTULA VESICOINTESTINAL"
      },
      {
        "codigo": "N322",
        "valor": "FISTULA DE LA VEJIGA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "N323",
        "valor": "DIVERTICULO DE LA VEJIGA"
      },
      {
        "codigo": "N324",
        "valor": "RUPTURA DE LA VEJIGA, NO TRAUMATICA"
      },
      {
        "codigo": "N328",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA VEJIGA"
      },
      {
        "codigo": "N329",
        "valor": "TRASTORNO DE LA VEJIGA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N33 - TRASTORNOS DE LA VEJIGA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N330",
        "valor": "CISTITIS TUBERCULOSA"
      },
      {
        "codigo": "N338",
        "valor": "TRASTORNOS DE LA VEJIGA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "N34 - URETRITIS Y SINDROME URETRAL",
    "detalle": [
      {
        "codigo": "N340",
        "valor": "ABSCESO URETRAL"
      },
      {
        "codigo": "N341",
        "valor": "URETRITIS NO ESPECIFICA"
      },
      {
        "codigo": "N342",
        "valor": "OTRAS URETRITIS"
      },
      {
        "codigo": "N343",
        "valor": "SINDROME URETRAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N35 - ESTRECHEZ URETRAL",
    "detalle": [
      {
        "codigo": "N350",
        "valor": "ESTRECHEZ URETRAL POSTRAUMATICA"
      },
      {
        "codigo": "N351",
        "valor": "ESTRECHEZ URETRAL POSTINFECCION, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "N358",
        "valor": "OTRAS ESTRECHECES URETRALES"
      },
      {
        "codigo": "N359",
        "valor": "ESTRECHEZ URETRAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N36 - OTROS TRASTORNOS DE LA URETRA",
    "detalle": [
      {
        "codigo": "N360",
        "valor": "FISTULA DE LA URETRA"
      },
      {
        "codigo": "N361",
        "valor": "DIVERTICULO DE LA URETRA"
      },
      {
        "codigo": "N362",
        "valor": "CARUNCULA URETRAL"
      },
      {
        "codigo": "N363",
        "valor": "PROLAPSO DE LA MUCOSA URETRAL"
      },
      {
        "codigo": "N368",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA URETRA"
      },
      {
        "codigo": "N369",
        "valor": "TRASTORNO DE LA URETRA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N37 - TRASTORNOS DE LA URETRA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N370",
        "valor": "URETRITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "N378",
        "valor": "OTROS TRASTORNOS URETRALES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "N39 - OTROS TRASTORNOS DEL SISTEMA URINARIO",
    "detalle": [
      {
        "codigo": "N390",
        "valor": "INFECCION DE VIAS URINARIAS, SITIO NO ESPECIFICADO"
      },
      {
        "codigo": "N391",
        "valor": "PROTEINURIA PERSISTENTE, NO ESPECIFICADA"
      },
      {
        "codigo": "N392",
        "valor": "PROTEINURIA ORTOSTATICA, NO ESPECIFICADA"
      },
      {
        "codigo": "N393",
        "valor": "INCONTINENCIA URINARIA POR TENSION"
      },
      {
        "codigo": "N394",
        "valor": "OTRAS INCONTINENCIAS URINARIAS ESPECIFICADAS"
      },
      {
        "codigo": "N398",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL SISTEMA URINARIO"
      },
      {
        "codigo": "N399",
        "valor": "TRASTORNO DEL SISTEMA URINARIO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N40 - HIPERPLASIA DE LA PROSTATA",
    "detalle": [
      {
        "codigo": "N40X",
        "valor": "HIPERPLASIA DE LA PROSTATA"
      }
    ]
  },
  {
    "grupo": "N41 - ENFERMEDADES INFLAMATORIAS DE LA PROSTATA",
    "detalle": [
      {
        "codigo": "N410",
        "valor": "PROSTATITIS AGUDA"
      },
      {
        "codigo": "N411",
        "valor": "PROSTATITIS CRONICA"
      },
      {
        "codigo": "N412",
        "valor": "ABSCESO DE LA PROSTATA"
      },
      {
        "codigo": "N413",
        "valor": "PROSTATOCISTITIS"
      },
      {
        "codigo": "N418",
        "valor": "OTRAS ENFERMEDADES INFLAMATORIAS DE LA PROSTATA"
      },
      {
        "codigo": "N419",
        "valor": "ENFERMEDAD INFLAMATORIA DE LA PROSTATA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N42 - OTROS TRASTORNOS DE LA PROSTATA",
    "detalle": [
      {
        "codigo": "N420",
        "valor": "CALCULO DE LA PROSTATA"
      },
      {
        "codigo": "N421",
        "valor": "CONGESTION Y HEMORRAGIA DE LA PROSTATA"
      },
      {
        "codigo": "N422",
        "valor": "ATROFIA DE LA PROSTATA"
      },
      {
        "codigo": "N423",
        "valor": "DISPLASIA DE LA PROSTATA"
      },
      {
        "codigo": "N428",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA PROSTATA"
      },
      {
        "codigo": "N429",
        "valor": "TRASTORNO DE LA PROSTATA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N43 - HIDROCELE Y ESPERMATOCELE",
    "detalle": [
      {
        "codigo": "N430",
        "valor": "HIDROCELE ENQUISTADO"
      },
      {
        "codigo": "N431",
        "valor": "HIDROCELE INFECTADO"
      },
      {
        "codigo": "N432",
        "valor": "OTROS HIDROCELES"
      },
      {
        "codigo": "N433",
        "valor": "HIDROCELE, NO ESPECIFICADO"
      },
      {
        "codigo": "N434",
        "valor": "ESPERMATOCELE"
      }
    ]
  },
  {
    "grupo": "N44 - TORSION DEL TESTICULO",
    "detalle": [
      {
        "codigo": "N44X",
        "valor": "TORSION DEL TESTICULO"
      }
    ]
  },
  {
    "grupo": "N45 - ORQUITIS Y EPIDIDIMITIS",
    "detalle": [
      {
        "codigo": "N450",
        "valor": "ORQUITIS, EPIDIDIMITIS Y ORQUIEPIDIDIMITIS CON ABSCESO"
      },
      {
        "codigo": "N459",
        "valor": "ORQUITIS, EPIDIDIMITIS Y ORQUIEPIDIDIMITIS SIN ABSCESO"
      }
    ]
  },
  {
    "grupo": "N46 - ESTERILIDAD EN EL VARON",
    "detalle": [
      {
        "codigo": "N46X",
        "valor": "ESTERILIDAD EN EL VARON"
      }
    ]
  },
  {
    "grupo": "N47 - PREPUCIO REDUNDANTE, FIMOSIS Y PARAFIMOSIS",
    "detalle": [
      {
        "codigo": "N47X",
        "valor": "PREPUCIO REDUNDANTE, FIMOSIS Y PARAFIMOSIS"
      }
    ]
  },
  {
    "grupo": "N48 - OTROS TRASTORNOS DEL PENE",
    "detalle": [
      {
        "codigo": "N480",
        "valor": "LEUCOPLASIA DEL PENE"
      },
      {
        "codigo": "N481",
        "valor": "BALANOPOSTITIS"
      },
      {
        "codigo": "N482",
        "valor": "OTROS TRASTORNOS INFLAMATORIOS DEL PENE"
      },
      {
        "codigo": "N483",
        "valor": "PRIAPISMO"
      },
      {
        "codigo": "N484",
        "valor": "IMPOTENCIA DE ORIGEN ORGANICO"
      },
      {
        "codigo": "N485",
        "valor": "ULCERA DEL PENE"
      },
      {
        "codigo": "N486",
        "valor": "INDURACION PLASTICA DEL PENE"
      },
      {
        "codigo": "N488",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL PENE"
      },
      {
        "codigo": "N489",
        "valor": "TRASTORNO DEL PENE, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N49 - TRASTORNOS INFLAMATORIOS DE ORGANOS GENITALES MASCULINOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N490",
        "valor": "TRASTORNOS INFLAMATORIOS DE VESICULA SEMINAL"
      },
      {
        "codigo": "N491",
        "valor": "TRASTORNOS INFLAMATORIOS DEL CORDON ESPERMATICO, TUNICA VAGINAL Y CONDUCTO DEFERENTE"
      },
      {
        "codigo": "N492",
        "valor": "TRASTORNOS INFLAMATORIOS DEL ESCROTO"
      },
      {
        "codigo": "N498",
        "valor": "OTROS TRASTORNOS INFLAMATORIOS DE LOS ORGANOS GENITALES MASCULINOS"
      },
      {
        "codigo": "N499",
        "valor": "TRASTORNO INFLAMATORIO DE ORGANO GENITAL MASCULINO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N50 - OTROS TRASTORNOS DE LOS ORGANOS GENITALES MASCULINOS",
    "detalle": [
      {
        "codigo": "N500",
        "valor": "ATROFIA DEL TESTICULO"
      },
      {
        "codigo": "N501",
        "valor": "TRASTORNOS VASCULARES DE LOS ORGANOS GENITALES MASCULINOS"
      },
      {
        "codigo": "N508",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LOS ORGANOS GENITALES MASCULINOS"
      },
      {
        "codigo": "N509",
        "valor": "TRASTORNO NO ESPECIFICADO DE LOS ORGANOS GENITALES MASCULINOS"
      }
    ]
  },
  {
    "grupo": "N51 - TRASTORNOS DE LOS ORGANOS GENITALES MASCULINOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N510",
        "valor": "TRASTORNOS DE PROSTATA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "N511",
        "valor": "TRASTORNOS DEL TESTICULO Y DEL EPIDIDIMO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "N512",
        "valor": "BALANITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "N518",
        "valor": "OTROS TRASTORNOS DE LOS ORGANOS GENITALES MASCULINOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "N60 - DISPLASIA MAMARIA BENIGNA",
    "detalle": [
      {
        "codigo": "N600",
        "valor": "QUISTE SOLITARIO DE LA MAMA"
      },
      {
        "codigo": "N601",
        "valor": "MASTOPATIA QUISTICA DIFUSA"
      },
      {
        "codigo": "N602",
        "valor": "FIBROADENOSIS DE MAMA"
      },
      {
        "codigo": "N603",
        "valor": "FIBROESCLEROSIS DE MAMA"
      },
      {
        "codigo": "N604",
        "valor": "ECTASIA DE CONDUCTO MAMARIO"
      },
      {
        "codigo": "N608",
        "valor": "OTRAS DISPLASIAS MAMARIAS BENIGNAS"
      },
      {
        "codigo": "N609",
        "valor": "DISPLASIA MAMARIA BENIGNA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "N61 - TRASTORNOS INFLAMATORIOS DE LA MAMA",
    "detalle": [
      {
        "codigo": "N61X",
        "valor": "TRASTORNOS INFLAMATORIOS DE LA MAMA"
      }
    ]
  },
  {
    "grupo": "N62 - HIPERTROFIA DE LA MAMA",
    "detalle": [
      {
        "codigo": "N62X",
        "valor": "HIPERTROFIA DE LA MAMA"
      }
    ]
  },
  {
    "grupo": "N63 - MASA NO ESPECIFICADA EN LA MAMA",
    "detalle": [
      {
        "codigo": "N63X",
        "valor": "MASA NO ESPECIFICADA EN LA MAMA"
      }
    ]
  },
  {
    "grupo": "N64 - OTROS TRASTORNOS DE LA MAMA",
    "detalle": [
      {
        "codigo": "N640",
        "valor": "FISURA Y FISTULA DEL PEZON"
      },
      {
        "codigo": "N641",
        "valor": "NECROSIS GRASA DE LA MAMA"
      },
      {
        "codigo": "N642",
        "valor": "ATROFIA DE LA MAMA"
      },
      {
        "codigo": "N643",
        "valor": "GALACTORREA NO ASOCIADA CON EL PARTO"
      },
      {
        "codigo": "N644",
        "valor": "MASTODINIA"
      },
      {
        "codigo": "N645",
        "valor": "OTROS SIGNOS Y SINTOMAS RELATIVOS A LA MAMA"
      },
      {
        "codigo": "N648",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DE LA MAMA"
      },
      {
        "codigo": "N649",
        "valor": "TRASTORNO DE LA MAMA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N70 - SALPINGITIS Y OOFORITIS",
    "detalle": [
      {
        "codigo": "N700",
        "valor": "SALPINGITIS Y OOFORITIS AGUDA"
      },
      {
        "codigo": "N701",
        "valor": "SALPINGITIS Y OOFORITIS CRONICA"
      },
      {
        "codigo": "N709",
        "valor": "SALPINGITIS Y OOFORITIS, NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "N71 - ENFERMEDAD INFLAMATORIA DEL UTERO, EXCEPTO DEL CUELLO UTERINO",
    "detalle": [
      {
        "codigo": "N710",
        "valor": "ENFERMEDAD INFLAMATORIA AGUDA DEL UTERO"
      },
      {
        "codigo": "N711",
        "valor": "ENFERMEDAD INFLAMATORIA CRONICA DEL UTERO"
      },
      {
        "codigo": "N719",
        "valor": "ENFERMEDAD INFLAMATORIA DEL UTERO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N72 - ENFERMEDAD INFLAMATORIA DEL CUELLO UTERINO",
    "detalle": [
      {
        "codigo": "N72X",
        "valor": "ENFERMEDAD INFLAMATORIA DEL CUELLO UTERINO"
      }
    ]
  },
  {
    "grupo": "N73 - OTRAS ENFERMEDADES PELVICAS INFLAMATORIAS FEMENINAS",
    "detalle": [
      {
        "codigo": "N730",
        "valor": "PARAMETRITIS Y CELULITIS PELVICA AGUDA"
      },
      {
        "codigo": "N731",
        "valor": "PARAMETRITIS Y CELULITIS PELVICA CRONICA"
      },
      {
        "codigo": "N732",
        "valor": "PARAMETRITIS Y CELULITIS PELVICA NO ESPECIFICADA"
      },
      {
        "codigo": "N733",
        "valor": "PERITONITIS PELVICA AGUDA, FEMENINA"
      },
      {
        "codigo": "N734",
        "valor": "PERITONITIS PELVICA CRONICA, FEMENINA"
      },
      {
        "codigo": "N735",
        "valor": "PERITONITIS PELVICA FEMENINA, NO ESPECIFICADA"
      },
      {
        "codigo": "N736",
        "valor": "ADHERENCIAS PERITONEALES PELVICAS FEMENINAS"
      },
      {
        "codigo": "N738",
        "valor": "OTRAS ENFERMEDADES INFLAMATORIAS PELVICAS FEMENINAS"
      },
      {
        "codigo": "N739",
        "valor": "ENFERMEDAD INFLAMATORIA PELVICA FEMENINA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N74 - TRASTORNOS INFLAMATORIOS DE LA PELVIS FEMENINA EN ENFERMEDADES CLASIFIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N740",
        "valor": "INFECCION TUBERCULOSA DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "N741",
        "valor": "ENFERMEDAD INFLAMATORIA PELVICA FEMENINA POR TUBERCULOSIS"
      },
      {
        "codigo": "N742",
        "valor": "ENFERMEDAD INFLAMATORIA PELVICA FEMENINA POR SIFILIS"
      },
      {
        "codigo": "N743",
        "valor": "ENFERMEDAD INFLAMATORIA PELVICA FEMENINA POR GONOCOCOS"
      },
      {
        "codigo": "N744",
        "valor": "ENFERMEDAD INFLAMATORIA PELVICA FEMENINA POR CLAMIDIAS"
      },
      {
        "codigo": "N748",
        "valor": "TRASTORNOS INFLAMATORIOS PELVICOS FEMENINOS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "N75 - ENFERMEDADES DE LA GLANDULA DE BARTHOLIN",
    "detalle": [
      {
        "codigo": "N750",
        "valor": "QUISTE DE LA GLANDULA DE BARTHOLIN"
      },
      {
        "codigo": "N751",
        "valor": "ABSCESO DE LA GLANDULA DE BARTHOLIN"
      },
      {
        "codigo": "N758",
        "valor": "OTRAS ENFERMEDADES DE LA GLANDULA DE BARTHOLIN"
      },
      {
        "codigo": "N759",
        "valor": "ENFERMEDAD DE LA GLANDULA DE BARTHOLIN, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N76 - OTRAS AFECCIONES INFLAMATORIAS DE LA VAGINA Y DE LA VULVA",
    "detalle": [
      {
        "codigo": "N760",
        "valor": "VAGINITIS AGUDA"
      },
      {
        "codigo": "N761",
        "valor": "VAGINITIS SUBAGUDA Y CRONICA"
      },
      {
        "codigo": "N762",
        "valor": "VULVITIS AGUDA"
      },
      {
        "codigo": "N763",
        "valor": "VULVITIS SUBAGUDA Y CRONICA"
      },
      {
        "codigo": "N764",
        "valor": "ABSCESO VULVAR"
      },
      {
        "codigo": "N765",
        "valor": "ULCERACION DE LA VAGINA"
      },
      {
        "codigo": "N766",
        "valor": "ULCERACION DE LA VULVA"
      },
      {
        "codigo": "N768",
        "valor": "OTRAS INFLAMACIONES ESPECIFICADAS DE LA VAGINA Y DE LA VULVA"
      },
      {
        "codigo": "N7681",
        "valor": "VAGINOSIS BACTERIANA"
      }
    ]
  },
  {
    "grupo": "N77 - ULCERACION E INFLAMACION VULVOVAGINAL EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N770",
        "valor": "ULCERACION DE LA VULVA EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "N771",
        "valor": "VAGINITIS, VULVITIS Y VULVOVAGINITIS EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "N778",
        "valor": "ULCERACION E INFLAMACION VULVOVAGINAL EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "N80 - ENDOMETRIOSIS",
    "detalle": [
      {
        "codigo": "N800",
        "valor": "ENDOMETRIOSIS DEL UTERO"
      },
      {
        "codigo": "N801",
        "valor": "ENDOMETRIOSIS DEL OVARIO"
      },
      {
        "codigo": "N802",
        "valor": "ENDOMETRIOSIS DE LA TROMPA DE FALOPIO"
      },
      {
        "codigo": "N803",
        "valor": "ENDOMETRIOSIS DEL PERITONEO PELVICO"
      },
      {
        "codigo": "N804",
        "valor": "ENDOMETRIOSIS DEL TABIQUE RECTOVAGINAL Y DE LA VAGINA"
      },
      {
        "codigo": "N805",
        "valor": "ENDOMETRIOSIS DEL INTESTINO"
      },
      {
        "codigo": "N806",
        "valor": "ENDOMETRIOSIS EN CICATRIZ CUTANEA"
      },
      {
        "codigo": "N808",
        "valor": "OTRAS ENDOMETRIOSIS"
      },
      {
        "codigo": "N809",
        "valor": "ENDOMETRIOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N81 - PROLAPSO GENITAL FEMENINO",
    "detalle": [
      {
        "codigo": "N810",
        "valor": "URETROCELE FEMENINO"
      },
      {
        "codigo": "N811",
        "valor": "CISTOCELE"
      },
      {
        "codigo": "N812",
        "valor": "PROLAPSO UTEROVAGINAL INCOMPLETO"
      },
      {
        "codigo": "N813",
        "valor": "PROLAPSO UTEROVAGINAL COMPLETO"
      },
      {
        "codigo": "N814",
        "valor": "PROLAPSO UTEROVAGINAL, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "N815",
        "valor": "ENTEROCELE VAGINAL"
      },
      {
        "codigo": "N816",
        "valor": "RECTOCELE"
      },
      {
        "codigo": "N818",
        "valor": "OTROS PROLAPSOS GENITALES FEMENINOS"
      },
      {
        "codigo": "N819",
        "valor": "PROLAPSO GENITAL FEMENINO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N82 - FISTULAS QUE AFECTAN EL TRACTO GENITAL FEMENINO",
    "detalle": [
      {
        "codigo": "N820",
        "valor": "FISTULA VESICOVAGINAL"
      },
      {
        "codigo": "N821",
        "valor": "OTRAS FISTULAS DE LAS VIAS GENITOURINARIAS FEMENINAS"
      },
      {
        "codigo": "N822",
        "valor": "FISTULA DE LA VAGINA AL INTESTINO DELGADO"
      },
      {
        "codigo": "N823",
        "valor": "FISTULA DE LA VAGINA AL INTESTINO GRUESO"
      },
      {
        "codigo": "N824",
        "valor": "OTRAS FISTULAS DEL TRACTO GENITAL FEMENINO AL TRACTO INTESTINAL"
      },
      {
        "codigo": "N825",
        "valor": "FISTULA DEL TRACTO GENITAL FEMENINO A LA PIEL"
      },
      {
        "codigo": "N828",
        "valor": "OTRAS FISTULAS DEL TRACTO GENITAL FEMENINO"
      },
      {
        "codigo": "N829",
        "valor": "FISTULA DEL TRACTO GENITAL FEMENINO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "N83 - TRASTORNOS NO INFLAMATORIOS DEL OVARIO, DE LA TROMPA DE FALOPIO Y DEL LIGAMENTO ANCHO",
    "detalle": [
      {
        "codigo": "N830",
        "valor": "QUISTE FOLICULAR DEL OVARIO"
      },
      {
        "codigo": "N831",
        "valor": "QUISTE DEL CUERPO AMARILLO"
      },
      {
        "codigo": "N832",
        "valor": "OTROS QUISTES OVARICOS Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "N833",
        "valor": "ATROFIA ADQUIRIDA DEL OVARIO Y DE LA TROMPA DE FALOPIO"
      },
      {
        "codigo": "N834",
        "valor": "PROLAPSO Y HERNIA DEL OVARIO Y DE LA TROMPA DE FALOPIO"
      },
      {
        "codigo": "N835",
        "valor": "TORSION DE OVARIO, PEDICULO DE OVARIO Y TROMPA DE FALOPIO"
      },
      {
        "codigo": "N836",
        "valor": "HEMATOSALPINX"
      },
      {
        "codigo": "N837",
        "valor": "HEMATOMA DEL LIGAMENTO ANCHO"
      },
      {
        "codigo": "N838",
        "valor": "OTROS TRASTORNOS NO INFLAMATORIOS DEL OVARIO, DE LA TROMPA DE FALOPIO Y DEL LIGAMENTO ANCHO"
      },
      {
        "codigo": "N839",
        "valor": "ENFERMEDAD NO INFLAMATORIA DEL OVARIO, DE LA TROMPA DE FALOPIO Y DEL LIGAMENTO ANCHO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N84 - POLIPO DEL TRACTO GENITAL FEMENINO",
    "detalle": [
      {
        "codigo": "N840",
        "valor": "POLIPO DEL CUERPO DEL UTERO"
      },
      {
        "codigo": "N841",
        "valor": "POLIPO DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "N842",
        "valor": "POLIPO DE LA VAGINA"
      },
      {
        "codigo": "N843",
        "valor": "POLIPO DE LA VULVA"
      },
      {
        "codigo": "N848",
        "valor": "POLIPOS DE OTRAS PARTES DEL TRACTO GENITAL FEMENINO"
      },
      {
        "codigo": "N849",
        "valor": "POLIPO DEL TRACTO GENITAL FEMENINO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N85 - OTROS TRASTORNOS NO INFLAMATORIOS DEL UTERO, EXCEPTO DEL CUELLO",
    "detalle": [
      {
        "codigo": "N850",
        "valor": "HIPERPLASIA DE GLANDULA DEL ENDOMETRIO"
      },
      {
        "codigo": "N851",
        "valor": "HIPERPLASIA ADENOMATOSA DEL ENDOMETRIO"
      },
      {
        "codigo": "N852",
        "valor": "HIPERTROFIA DEL UTERO"
      },
      {
        "codigo": "N853",
        "valor": "SUBINVOLUCION DEL UTERO"
      },
      {
        "codigo": "N854",
        "valor": "MALA POSICION DEL UTERO"
      },
      {
        "codigo": "N855",
        "valor": "INVERSION DEL UTERO"
      },
      {
        "codigo": "N856",
        "valor": "SINEQUIAS INTRAUTERINAS"
      },
      {
        "codigo": "N857",
        "valor": "HEMATOMETRA"
      },
      {
        "codigo": "N858",
        "valor": "OTROS TRASTORNOS NO INFLAMATORIOS ESPECIFICADOS DEL UTERO"
      },
      {
        "codigo": "N859",
        "valor": "TRASTORNO NO INFLAMATORIO DEL UTERO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N86 - EROSION Y ECTROPION DEL CUELLO DEL UTERO",
    "detalle": [
      {
        "codigo": "N86X",
        "valor": "EROSION Y ECTROPION DEL CUELLO DEL UTERO"
      }
    ]
  },
  {
    "grupo": "N87 - DISPLASIA DEL CUELLO UTERINO",
    "detalle": [
      {
        "codigo": "N870",
        "valor": "DISPLASIA CERVICAL LEVE"
      },
      {
        "codigo": "N871",
        "valor": "DISPLASIA CERVICAL MODERADA"
      },
      {
        "codigo": "N872",
        "valor": "DISPLASIA CERVICAL SEVERA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "N879",
        "valor": "DISPLASIA DEL CUELLO DEL UTERO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N88 - OTROS TRASTORNOS NO INFLAMATORIOS DEL CUELLO DEL UTERO",
    "detalle": [
      {
        "codigo": "N880",
        "valor": "LEUCOPLASIA DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "N881",
        "valor": "LACERACION ANTIGUA DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "N882",
        "valor": "ESTRECHEZ Y ESTENOSIS DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "N883",
        "valor": "INCOMPETENCIA DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "N884",
        "valor": "ELONGACION HIPERTROFICA DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "N888",
        "valor": "OTROS TRASTORNOS NO INFLAMATORIOS ESPECIFICADOS DEL CUELLO DEL UTERO"
      },
      {
        "codigo": "N889",
        "valor": "TRASTORNO NO INFLAMATORIO DEL CUELLO DEL UTERO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N89 - OTROS TRASTORNOS NO INFLAMATORIOS DE LA VAGINA",
    "detalle": [
      {
        "codigo": "N890",
        "valor": "DISPLASIA VAGINAL LEVE"
      },
      {
        "codigo": "N891",
        "valor": "DISPLASIA VAGINAL MODERADA"
      },
      {
        "codigo": "N892",
        "valor": "DISPLASIA VAGINAL SEVERA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "N893",
        "valor": "DISPLASIA DE LA VAGINA, NO ESPECIFICADA"
      },
      {
        "codigo": "N894",
        "valor": "LEUCOPLASIA DE LA VAGINA"
      },
      {
        "codigo": "N895",
        "valor": "ESTRECHEZ Y ATRESIA DE LA VAGINA"
      },
      {
        "codigo": "N896",
        "valor": "ANILLO DE HIMEN ESTRECHO"
      },
      {
        "codigo": "N897",
        "valor": "HEMATOCOLPOS"
      },
      {
        "codigo": "N898",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS NO INFLAMATORIOS DE LA VAGINA"
      },
      {
        "codigo": "N899",
        "valor": "TRASTORNO NO INFLAMATORIO DE LA VAGINA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N90 - OTROS TRASTORNOS NO INFLAMATORIOS DE LA VULVA Y DEL PERINEO",
    "detalle": [
      {
        "codigo": "N900",
        "valor": "DISPLASIA VULVAR LEVE"
      },
      {
        "codigo": "N901",
        "valor": "DISPLASIA VULVAR MODERADA"
      },
      {
        "codigo": "N902",
        "valor": "DISPLASIA VULVAR SEVERA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "N903",
        "valor": "DISPLASIA DE LA VULVA, NO ESPECIFICADA"
      },
      {
        "codigo": "N904",
        "valor": "LEUCOPLASIA DE LA VULVA"
      },
      {
        "codigo": "N905",
        "valor": "ATROFIA DE LA VULVA"
      },
      {
        "codigo": "N906",
        "valor": "HIPERTROFIA DE LA VULVA"
      },
      {
        "codigo": "N907",
        "valor": "QUISTE DE LA VULVA"
      },
      {
        "codigo": "N908",
        "valor": "OTROS TRASTORNOS NO INFLAMATORIOS ESPECIFICADOS DE LA VULVA Y DEL PERINEO"
      },
      {
        "codigo": "N909",
        "valor": "TRASTORNO NO INFLAMATORIO DE LA VULVA Y DEL PERINEO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N91 - MENSTRUACION AUSENTE, ESCASA O RARA",
    "detalle": [
      {
        "codigo": "N910",
        "valor": "AMENORREA PRIMARIA"
      },
      {
        "codigo": "N911",
        "valor": "AMENORREA SECUNDARIA"
      },
      {
        "codigo": "N912",
        "valor": "AMENORREA, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "N913",
        "valor": "OLIGOMENORREA PRIMARIA"
      },
      {
        "codigo": "N914",
        "valor": "OLIGOMENORREA SECUNDARIA"
      },
      {
        "codigo": "N915",
        "valor": "OLIGOMENORREA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N92 - MENSTRUACION EXCESIVA, FRECUENTE E IRREGULAR",
    "detalle": [
      {
        "codigo": "N920",
        "valor": "MENSTRUACION EXCESIVA Y FRECUENTE CON CICLO REGULAR"
      },
      {
        "codigo": "N921",
        "valor": "MENSTRUACION EXCESIVA Y FRECUENTE CON CICLO IRREGULAR"
      },
      {
        "codigo": "N922",
        "valor": "MENSTRUACION EXCESIVA EN LA PUBERTAD"
      },
      {
        "codigo": "N923",
        "valor": "HEMORRAGIA POR OVULACION"
      },
      {
        "codigo": "N924",
        "valor": "HEMORRAGIA EXCESIVA EN PERIODO PREMENOPAUSICO"
      },
      {
        "codigo": "N925",
        "valor": "OTRAS MENSTRUACIONES IRREGULARES ESPECIFICADAS"
      },
      {
        "codigo": "N926",
        "valor": "MENSTRUACION IRREGULAR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N93 - OTRAS HEMORRAGIAS UTERINAS O VAGINALES ANORMALES",
    "detalle": [
      {
        "codigo": "N930",
        "valor": "HEMORRAGIA POSTCOITO Y POSTCONTACTO"
      },
      {
        "codigo": "N938",
        "valor": "OTRAS HEMORRAGIAS UTERINAS O VAGINALES ANORMALES ESPECIFICADAS"
      },
      {
        "codigo": "N939",
        "valor": "HEMORRAGIA VAGINAL Y UTERINA ANORMAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N94 - DOLOR Y OTRAS AFECCIONES RELACIONADAS CON LOS ORGANOS GENITALES FEMENINOS Y CON EL CICLIO MENSTRUAL",
    "detalle": [
      {
        "codigo": "N940",
        "valor": "DOLOR INTERMENSTRUAL"
      },
      {
        "codigo": "N941",
        "valor": "DISPAREUNIA"
      },
      {
        "codigo": "N942",
        "valor": "VAGINISMO"
      },
      {
        "codigo": "N943",
        "valor": "SINDROME DE TENSION PREMENSTRUAL"
      },
      {
        "codigo": "N944",
        "valor": "DISMENORREA PRIMARIA"
      },
      {
        "codigo": "N945",
        "valor": "DISMENORREA SECUNDARIA"
      },
      {
        "codigo": "N946",
        "valor": "DISMENORREA, NO ESPECIFICADA"
      },
      {
        "codigo": "N948",
        "valor": "OTRAS AFECCIONES ESPECIFICADAS ASOCIADAS CON LOS ORGANOS GENITALES FEMENINOS Y EL CICLO MENSTRUAL"
      },
      {
        "codigo": "N949",
        "valor": "AFECCIONES NO ESPECIFICADAS ASOCIADAS CON LOS ORGANOS GENITALES FEMENINOS Y EL CICLO MENSTRUAL"
      }
    ]
  },
  {
    "grupo": "N95 - OTROS TRASTORNOS MENOPAUSICOS Y PERIMENOPAUSICOS",
    "detalle": [
      {
        "codigo": "N950",
        "valor": "HEMORRAGIA POSTMENOPAUSICA"
      },
      {
        "codigo": "N951",
        "valor": "ESTADOS MENOPAUSICOS Y CLIMATERICOS FEMENINOS"
      },
      {
        "codigo": "N952",
        "valor": "VAGINITIS ATROFICA POSTMENOPAUSICA"
      },
      {
        "codigo": "N953",
        "valor": "ESTADOS ASOCIADOS CON MENOPAUSIA ARTIFICIAL"
      },
      {
        "codigo": "N958",
        "valor": "OTROS TRASTORNOS MENOPAUSICOS Y PERIMENOPAUSICOS ESPECIFICADOS"
      },
      {
        "codigo": "N959",
        "valor": "TRASTORNO MENOPAUSICO Y PERIMENOPAUSICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "N96 - ABORTADORA HABITUAL",
    "detalle": [
      {
        "codigo": "N96X",
        "valor": "ABORTADORA HABITUAL"
      }
    ]
  },
  {
    "grupo": "N97 - INFERTILIDAD FEMENINA",
    "detalle": [
      {
        "codigo": "N970",
        "valor": "INFERTILIDAD FEMENINA ASOCIADA CON FALTA DE OVULACION"
      },
      {
        "codigo": "N971",
        "valor": "INFERTILIDAD FEMENINA DE ORIGEN TUBARICO"
      },
      {
        "codigo": "N972",
        "valor": "INFERTILIDAD FEMENINA DE ORIGEN UTERINO"
      },
      {
        "codigo": "N973",
        "valor": "INFERTILIDAD FEMENINA DE ORIGEN CERVICAL"
      },
      {
        "codigo": "N974",
        "valor": "INFERTILIDAD FEMENINA ASOCIADA CON FACTORES MASCULINOS"
      },
      {
        "codigo": "N978",
        "valor": "INFERTILIDAD FEMENINA DE OTRO ORIGEN"
      },
      {
        "codigo": "N979",
        "valor": "INFERTILIDAD FEMENINA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "N98 - COMPLICACIONES ASOCIADAS CON LA FECUNDACION ARTIFICIAL",
    "detalle": [
      {
        "codigo": "N980",
        "valor": "INFECCION ASOCIADA CON INSEMINACION ARTIFICIAL"
      },
      {
        "codigo": "N981",
        "valor": "HIPERESTIMULACION DE OVARIOS"
      },
      {
        "codigo": "N982",
        "valor": "COMPLICACIONES EN EL INTENTO DE INTRODUCCION DEL HUEVO FECUNDADO EN LA FERTILIZACION IN VITRO"
      },
      {
        "codigo": "N983",
        "valor": "COMPLICACIONES EN EL INTENTO DE INTRODUCCION DEL EMBRION EN LA TRANSFERENCIA DE EMBRIONES"
      },
      {
        "codigo": "N988",
        "valor": "OTRAS COMPLICACIONES ASOCIADAS CON LA FECUNDACION ARTIFICIAL"
      },
      {
        "codigo": "N989",
        "valor": "COMPLICACION NO ESPECIFICADA ASOCIADA CON LA FECUNDACION ARTIFICIAL"
      }
    ]
  },
  {
    "grupo": "N99 - TRASTORNOS DEL SISTEMA GENITOURINARIO CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "N990",
        "valor": "INSUFICIENCIA RENAL CONSECUTIVA A PROCEDIMIENTOS"
      },
      {
        "codigo": "N991",
        "valor": "ESTRECHEZ URETRAL CONSECUTIVA A PROCEDIMIENTOS"
      },
      {
        "codigo": "N992",
        "valor": "ADHERENCIAS POSTOPERATORIAS DE LA VAGINA"
      },
      {
        "codigo": "N993",
        "valor": "PROLAPSO DE LA CUPULA VAGINAL DESPUES DE HISTERECTOMIA"
      },
      {
        "codigo": "N994",
        "valor": "ADHERENCIAS PERITONEALES PELVICAS CONSECUTIVAS A PROCEDIMIENTOS"
      },
      {
        "codigo": "N995",
        "valor": "MAL FUNCIONAMIENTO DE ESTOMA EXTERNO DE VIAS URINARIAS"
      },
      {
        "codigo": "N998",
        "valor": "OTROS TRASTORNOS DEL SISTEMA GENITOURINARIO CONSECUTIVOS A PROCEDIMIENTOS"
      },
      {
        "codigo": "N999",
        "valor": "TRASTORNO NO ESPECIFICADO DEL SISTEMA GENITOURINARIO CONSECUTIVO A PROCEDIMIENTOS"
      }
    ]
  },
  {
    "grupo": "O00 - EMBARAZO ECTOPICO",
    "detalle": [
      {
        "codigo": "O000",
        "valor": "EMBARAZO ABDOMINAL"
      },
      {
        "codigo": "O001",
        "valor": "EMBARAZO TUBARICO"
      },
      {
        "codigo": "O002",
        "valor": "EMBARAZO OVARICO"
      },
      {
        "codigo": "O008",
        "valor": "OTROS EMBARAZOS ECTOPICOS"
      },
      {
        "codigo": "O009",
        "valor": "EMBARAZO ECTOPICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O01 - MOLA HIDATIFORME",
    "detalle": [
      {
        "codigo": "O010",
        "valor": "MOLA HIDATIFORME CLASICA"
      },
      {
        "codigo": "O011",
        "valor": "MOLA HIDATIFORME, INCOMPLETA O PARCIAL"
      },
      {
        "codigo": "O019",
        "valor": "MOLA HIDATIFORME, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O02 - OTROS PRODUCTOS ANORMALES DE LA CONCEPCION",
    "detalle": [
      {
        "codigo": "O020",
        "valor": "DETENCION DEL DESARROLLO DEL HUEVO Y MOLA NO HIDATIFORME"
      },
      {
        "codigo": "O021",
        "valor": "ABORTO RETENIDO"
      },
      {
        "codigo": "O028",
        "valor": "OTROS PRODUCTOS ANORMALES ESPECIFICADOS DE LA CONCEPCION"
      },
      {
        "codigo": "O029",
        "valor": "PRODUCTO ANORMAL DE LA CONCEPCION, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O03 - ABORTO ESPONTANEO",
    "detalle": [
      {
        "codigo": "O030",
        "valor": "ABORTO ESPONTANEO INCOMPLETO, COMPLICADO CON INFECCION GENITAL Y PELVIANA"
      },
      {
        "codigo": "O031",
        "valor": "ABORTO ESPONTANEO INCOMPLETO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA"
      },
      {
        "codigo": "O032",
        "valor": "ABORTO ESPONTANEO INCOMPLETO, COMPLICADO POR EMBOLIA"
      },
      {
        "codigo": "O033",
        "valor": "ABORTO ESPONTANEO INCOMPLETO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "O034",
        "valor": "ABORTO ESPONTANEO INCOMPLETO, SIN COMPLICACION"
      },
      {
        "codigo": "O035",
        "valor": "ABORTO ESPONTANEO COMPLETO O NO ESPECIFICADO, COMPLICADO CON INFECCION GENITAL Y PELVIANA"
      },
      {
        "codigo": "O036",
        "valor": "ABORTO ESPONTANEO COMPLETO O NO ESPECIFICADO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA"
      },
      {
        "codigo": "O037",
        "valor": "ABORTO ESPONTANEO COMPLETO O NO ESPECIFICADO, COMPLICADO POR EMBOLIA"
      },
      {
        "codigo": "O038",
        "valor": "ABORTO ESPONTANEO COMPLETO O NO ESPECIFICADO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "O039",
        "valor": "ABORTO ESPONTANEO COMPLETO O NO ESPECIFICADO, SIN COMPLICACION"
      }
    ]
  },
  {
    "grupo": "O04 - ABORTO MEDICO",
    "detalle": [
      {
        "codigo": "O040",
        "valor": "ABORTO MEDICO INCOMPLETO, COMPLICADO CON INFECCION GENITAL Y PELVIANA"
      },
      {
        "codigo": "O041",
        "valor": "ABORTO MEDICO INCOMPLETO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA"
      },
      {
        "codigo": "O042",
        "valor": "ABORTO MEDICO INCOMPLETO, COMPLICADO POR EMBOLIA"
      },
      {
        "codigo": "O043",
        "valor": "ABORTO MEDICO INCOMPLETO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "O044",
        "valor": "ABORTO MEDICO INCOMPLETO, SIN COMPLICACION"
      },
      {
        "codigo": "O045",
        "valor": "ABORTO MEDICO COMPLETO O NO ESPECIFICADO, COMPLICADO CON INFECCION GENITAL Y PELVIANA"
      },
      {
        "codigo": "O046",
        "valor": "ABORTO MEDICO COMPLETO O NO ESPECIFICADO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA"
      },
      {
        "codigo": "O047",
        "valor": "ABORTO MEDICO COMPLETO O NO ESPECIFICADO, COMPLICADO POR EMBOLIA"
      },
      {
        "codigo": "O048",
        "valor": "ABORTO MEDICO COMPLETO O NO ESPECIFICADO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "O049",
        "valor": "ABORTO MEDICO COMPLETO O NO ESPECIFICADO, SIN COMPLICACION"
      }
    ]
  },
  {
    "grupo": "O05 - OTRO ABORTO",
    "detalle": [
      {
        "codigo": "O050",
        "valor": "OTRO ABORTO INCOMPLETO, COMPLICADO CON INFECCION GENITAL Y PELVIANA"
      },
      {
        "codigo": "O051",
        "valor": "OTRO ABORTO INCOMPLETO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA"
      },
      {
        "codigo": "O052",
        "valor": "OTRO ABORTO INCOMPLETO, COMPLICADO POR EMBOLIA"
      },
      {
        "codigo": "O053",
        "valor": "OTRO ABORTO INCOMPLETO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "O054",
        "valor": "OTRO ABORTO INCOMPLETO, SIN COMPLICACION"
      },
      {
        "codigo": "O055",
        "valor": "OTRO ABORTO COMPLETO O NO ESPECIFICADO, COMPLICADO CON INFECCION GENITAL Y PELVIANA"
      },
      {
        "codigo": "O056",
        "valor": "OTRO ABORTO COMPLETO O NO ESPECIFICADO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA"
      },
      {
        "codigo": "O057",
        "valor": "OTRO ABORTO COMPLETO O NO ESPECIFICADO, COMPLICADO POR EMBOLIA"
      },
      {
        "codigo": "O058",
        "valor": "OTRO ABORTO COMPLETO O NO ESPECIFICADO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "O059",
        "valor": "OTRO ABORTO COMPLETO O NO ESPECIFICADO, SIN COMPLICACION"
      }
    ]
  },
  {
    "grupo": "O06 - ABORTO NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "O060",
        "valor": "ABORTO NO ESPECIFICADO INCOMPLETO, COMPLICADO CON INFECCION GENITAL Y PELVIANA"
      },
      {
        "codigo": "O061",
        "valor": "ABORTO NO ESPECIFICADO INCOMPLETO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA"
      },
      {
        "codigo": "O062",
        "valor": "ABORTO NO ESPECIFICADO INCOMPLETO, COMPLICADO POR EMBOLIA"
      },
      {
        "codigo": "O063",
        "valor": "ABORTO NO ESPECIFICADO INCOMPLETO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "O064",
        "valor": "ABORTO NO ESPECIFICADO INCOMPLETO, SIN COMPLICACION"
      },
      {
        "codigo": "O065",
        "valor": "ABORTO NO ESPECIFICADO COMPLETO O NO ESPECIFICADO, COMPLICADO CON INFECCION GENITAL Y PELVIANA"
      },
      {
        "codigo": "O066",
        "valor": "ABORTO NO ESPECIFICADO COMPLETO O NO ESPECIFICADO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA"
      },
      {
        "codigo": "O067",
        "valor": "ABORTO NO ESPECIFICADO COMPLETO O NO ESPECIFICADO, COMPLICADO POR EMBOLIA"
      },
      {
        "codigo": "O068",
        "valor": "ABORTO NO ESPECIFICADO COMPLETO O NO ESPECIFICADO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "O069",
        "valor": "ABORTO NO ESPECIFICADO COMPLETO O NO ESPECIFICADO, SIN COMPLICACION"
      }
    ]
  },
  {
    "grupo": "O07 - INTENTO FALLIDO DE ABORTO",
    "detalle": [
      {
        "codigo": "O070",
        "valor": "FALLA DE LA INDUCCION MEDICA DEL ABORTO, COMPLICADO POR INFECCION GENITAL Y PELVIANA"
      },
      {
        "codigo": "O071",
        "valor": "FALLA DE LA INDUCCION MEDICA DEL ABORTO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA"
      },
      {
        "codigo": "O072",
        "valor": "FALLA DE LA INDUCCION MEDICA DEL ABORTO, COMPLICADO POR EMBOLIA"
      },
      {
        "codigo": "O073",
        "valor": "FALLA DE LA INDUCCION MEDICA DEL ABORTO, CON OTRAS COMPLICACIONES Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "O074",
        "valor": "FALLA DE LA INDUCCION MEDICA DEL ABORTO, SIN COMPLICACION"
      },
      {
        "codigo": "O075",
        "valor": "OTROS INTENTOS FALLIDOS DE ABORTO Y LOS NO ESPECIFICADOS, COMPLICADOS POR INFECCION GENITAL Y PELVIANA"
      },
      {
        "codigo": "O076",
        "valor": "OTROS INTENTOS FALLIDOS DE ABORTO Y LOS NO ESPECIFICADOS, COMPLICADOS POR HEMORRAGIA EXCESIVA O TARDIA"
      },
      {
        "codigo": "O077",
        "valor": "OTROS INTENTOS FALLIDOS DE ABORTO Y LOS NO ESPECIFICADOS, COMPLICADOS POR EMBOLIA"
      },
      {
        "codigo": "O078",
        "valor": "OTROS INTENTOS FALLIDOS DE ABORTO Y LOS NO ESPECIFICADOS, CON OTRAS COMPLICACIONES Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "O079",
        "valor": "OTROS INTENTOS FALLIDOS DE ABORTO Y LOS NO ESPECIFICADOS, SIN COMPLICACION"
      }
    ]
  },
  {
    "grupo": "O08 - COMPLICACIONES CONSECUTIVAS AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR",
    "detalle": [
      {
        "codigo": "O080",
        "valor": "INFECCION GENITAL Y PELVIANA CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR"
      },
      {
        "codigo": "O081",
        "valor": "HEMORRAGIA EXCESIVA O TARDIA CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR"
      },
      {
        "codigo": "O082",
        "valor": "EMBOLIA CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR"
      },
      {
        "codigo": "O083",
        "valor": "CHOQUE CONSECUTIVO AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR"
      },
      {
        "codigo": "O084",
        "valor": "INSUFICIENCIA RENAL CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR"
      },
      {
        "codigo": "O085",
        "valor": "TRASTORNO METABOLICO CONSECUTIVO AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR"
      },
      {
        "codigo": "O086",
        "valor": "LESION DE ORGANOS O TEJIDOS DE LA PELVIS CONSECUTIVO AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR"
      },
      {
        "codigo": "O087",
        "valor": "OTRAS COMPLICACIONES VENOSAS CONSECUTIVAS AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR"
      },
      {
        "codigo": "O088",
        "valor": "OTRAS COMPLICACIONES CONSECUTIVAS AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR"
      },
      {
        "codigo": "O089",
        "valor": "COMPLICACION NO ESPECIFICADA CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR"
      }
    ]
  },
  {
    "grupo": "O10 - HIPERTENSION PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "detalle": [
      {
        "codigo": "O100",
        "valor": "HIPERTENSION ESENCIAL PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O101",
        "valor": "ENFERMEDAD CARDIACA HIPERTENSIVA PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O102",
        "valor": "ENFERMEDAD RENAL HIPERTENSIVA PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O103",
        "valor": "ENFERMEDAD CARDIORRENAL HIPERTENSIVA PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O104",
        "valor": "HIPERTENSION SECUNDARIA PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O109",
        "valor": "HIPERTENSION PREEXISTENTE NO ESPECIFICADA, QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      }
    ]
  },
  {
    "grupo": "O11 - TRASTORNOS HIPERTENSIVOS PREEXISTENTES, CON PROTEINURIA AGREGADA",
    "detalle": [
      {
        "codigo": "O11X",
        "valor": "TRASTORNOS HIPERTENSIVOS PREEXISTENTES, CON PROTEINURIA AGREGADA"
      }
    ]
  },
  {
    "grupo": "O12 - EDEMA Y PROTEINURIA GESTACIONALES [INDUCIDOS POR EL EMBARAZO] SIN HIPERTENSION",
    "detalle": [
      {
        "codigo": "O120",
        "valor": "EDEMA GESTACIONAL"
      },
      {
        "codigo": "O121",
        "valor": "PROTEINURIA GESTACIONAL"
      },
      {
        "codigo": "O122",
        "valor": "EDEMA GESTACIONAL CON PROTEINURIA"
      }
    ]
  },
  {
    "grupo": "O13 - HIPERTENSION GESTACIONAL [INDUCIDA POR EL EMBARAZO]",
    "detalle": [
      {
        "codigo": "O13X",
        "valor": "PRE- ECLAMPSIA LEVE"
      }
    ]
  },
  {
    "grupo": "O14 - PREECLAMPSIA",
    "detalle": [
      {
        "codigo": "O140",
        "valor": "PREECLAMPSIA LEVE A MODERADA"
      },
      {
        "codigo": "O141",
        "valor": "PREECLAMPSIA SEVERA"
      },
      {
        "codigo": "O142",
        "valor": "SINDROME HELLP"
      },
      {
        "codigo": "O149",
        "valor": "PREECLAMPSIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O15 - ECLAMPSIA",
    "detalle": [
      {
        "codigo": "O150",
        "valor": "ECLAMPSIA EN EL EMBARAZO"
      },
      {
        "codigo": "O151",
        "valor": "ECLAMPSIA DURANTE EL TRABAJO DE PARTO"
      },
      {
        "codigo": "O152",
        "valor": "ECLAMPSIA EN EL PUERPERIO"
      },
      {
        "codigo": "O159",
        "valor": "ECLAMPSIA, EN PERIODO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O16 - HIPERTENSION MATERNA, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "O16X",
        "valor": "HIPERTENSION MATERNA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O20 - HEMORRAGIA PRECOZ DEL EMBARAZO",
    "detalle": [
      {
        "codigo": "O200",
        "valor": "AMENAZA DE ABORTO"
      },
      {
        "codigo": "O208",
        "valor": "OTRAS HEMORRAGIAS PRECOCES DEL EMBARAZO"
      },
      {
        "codigo": "O209",
        "valor": "HEMORRAGIA PRECOZ DEL EMBARAZO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "O21 - VOMITOS EXCESIVOS EN EL EMBARAZO",
    "detalle": [
      {
        "codigo": "O210",
        "valor": "HIPEREMESIS GRAVIDICA LEVE"
      },
      {
        "codigo": "O211",
        "valor": "HIPEREMESIS GRAVIDICA CON TRASTORNOS METABOLICOS"
      },
      {
        "codigo": "O212",
        "valor": "HIPEREMESIS GRAVIDICA TARDIA"
      },
      {
        "codigo": "O218",
        "valor": "OTROS VOMITOS QUE COMPLICAN EL EMBARAZO"
      },
      {
        "codigo": "O219",
        "valor": "VOMITOS DEL EMBARAZO, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "O22 - COMPLICACIONES VENOSAS EN EL EMBARAZO",
    "detalle": [
      {
        "codigo": "O220",
        "valor": "VENAS VARICOSAS DE LOS MIEMBROS INFERIORES EN EL EMBARAZO"
      },
      {
        "codigo": "O221",
        "valor": "VARICES GENITALES EN EL EMBARAZO"
      },
      {
        "codigo": "O222",
        "valor": "TROMBOFLEBITIS SUPERFICIAL EN EL EMBARAZO"
      },
      {
        "codigo": "O223",
        "valor": "FLEBOTROMBOSIS PROFUNDA EN EL EMBARAZO"
      },
      {
        "codigo": "O224",
        "valor": "HEMORROIDES EN EL EMBARAZO"
      },
      {
        "codigo": "O225",
        "valor": "TROMBOSIS VENOSA CEREBRAL EN EL EMBARAZO"
      },
      {
        "codigo": "O228",
        "valor": "OTRAS COMPLICACIONES VENOSAS EN EL EMBARAZO"
      },
      {
        "codigo": "O229",
        "valor": "COMPLICACION VENOSA NO ESPECIFICADA EN EL EMBARAZO"
      }
    ]
  },
  {
    "grupo": "O23 - INFECCION DE LAS VIAS GENITOURINARIAS EN EL EMBARAZO",
    "detalle": [
      {
        "codigo": "O230",
        "valor": "INFECCION DEL RIÑON EN EL EMBARAZO"
      },
      {
        "codigo": "O231",
        "valor": "INFECCION DE LA VEJIGA URINARIA EN EL EMBARAZO"
      },
      {
        "codigo": "O232",
        "valor": "INFECCION DE LA URETRA EN EL EMBARAZO"
      },
      {
        "codigo": "O233",
        "valor": "INFECCION DE OTRAS PARTES DE LAS VIAS URINARIAS EN EL EMBARAZO"
      },
      {
        "codigo": "O234",
        "valor": "INFECCION NO ESPECIFICADA DE LAS VIAS URINARIAS EN EL EMBARAZO"
      },
      {
        "codigo": "O235",
        "valor": "INFECCION GENITAL EN EL EMBARAZO"
      },
      {
        "codigo": "O239",
        "valor": "OTRAS INFECCIONES Y LAS NO ESPECIFICADAS DE LAS VIAS GENITOURINARIAS EN EL EMBARAZO"
      }
    ]
  },
  {
    "grupo": "O24 - DIABETES MELLITUS EN EL EMBARAZO",
    "detalle": [
      {
        "codigo": "O240",
        "valor": "DIABETES MELLITUS PREEXISTENTE TIPO 1, EN EL EMBARAZO"
      },
      {
        "codigo": "O241",
        "valor": "DIABETES MELLITUS PREEXISTENTE TIPO 2, EN EL EMBARAZO"
      },
      {
        "codigo": "O242",
        "valor": "DIABETES MELLITUS PREEXISTENTE RELACIONADA CON DESNUTRICION, EN EL EMBARAZO"
      },
      {
        "codigo": "O243",
        "valor": "DIABETES MELLITUS PREEXISTENTE, SIN OTRA ESPECIFICACION, EN EL EMBARAZO"
      },
      {
        "codigo": "O244",
        "valor": "DIABETES MELLITUS QUE SE ORIGINA CON EL EMBARAZO"
      },
      {
        "codigo": "O249",
        "valor": "DIABETES MELLITUS NO ESPECIFICADA, EN EL EMBARAZO"
      }
    ]
  },
  {
    "grupo": "O25 - DESNUTRICION EN EL EMBARAZO",
    "detalle": [
      {
        "codigo": "O25X",
        "valor": "DESNUTRICION EN EL EMBARAZO"
      }
    ]
  },
  {
    "grupo": "O26 - ATENCION A LA MADRE POR OTRAS COMPLICACIONES PRINCIPALMENTE RELACIONADAS CON EL EMBARAZO",
    "detalle": [
      {
        "codigo": "O260",
        "valor": "AUMENTO EXCESIVO DE PESO EN EL EMBARAZO"
      },
      {
        "codigo": "O261",
        "valor": "AUMENTO PEQUEÑO DE PESO EN EL EMBARAZO"
      },
      {
        "codigo": "O262",
        "valor": "ATENCION DEL EMBARAZO EN UNA ABORTADORA HABITUAL"
      },
      {
        "codigo": "O263",
        "valor": "RETENCION DE DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO EN EL EMBARAZO"
      },
      {
        "codigo": "O264",
        "valor": "HERPES GESTACIONAL"
      },
      {
        "codigo": "O265",
        "valor": "SINDROME DE HIPOTENSION MATERNA"
      },
      {
        "codigo": "O266",
        "valor": "TRASTORNOS DEL HIGADO EN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O267",
        "valor": "SUBLUXACION DE LA SINFISIS (DEL PUBIS) EN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O268",
        "valor": "OTRAS COMPLICACIONES ESPECIFICADAS RELACIONADAS CON EL EMBARAZO"
      },
      {
        "codigo": "O2680",
        "valor": "GINGIVITIS DEL EMBARAZO"
      },
      {
        "codigo": "O2681",
        "valor": "GRANULOMA DEL EMBARAZO [GRANULOMA GRAVIDO]"
      },
      {
        "codigo": "O2688",
        "valor": "OTRAS MANIFESTACIONES BUCALES ESPECIFICADAS"
      },
      {
        "codigo": "O2689",
        "valor": "MANIFESTACIONES BUCALES, NO ESPECIFICADAS"
      },
      {
        "codigo": "O269",
        "valor": "COMPLICACION RELACIONADA CON EL EMBARAZO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O28 - HALLAZGOS ANORMALES EN EL EXAMEN PRENATAL DE LA MADRE",
    "detalle": [
      {
        "codigo": "O280",
        "valor": "HALLAZGO HEMATOLOGICO ANORMAL EN EL EXAMEN PRENATAL DE LA MADRE"
      },
      {
        "codigo": "O281",
        "valor": "HALLAZGO BIOQUIMICO ANORMAL EN EL EXAMEN PRENATAL DE LA MADRE"
      },
      {
        "codigo": "O282",
        "valor": "HALLAZGO CITOLOGICO ANORMAL EN EL EXAMEN PRENATAL DE LA MADRE"
      },
      {
        "codigo": "O283",
        "valor": "HALLAZGO ULTRASONICO ANORMAL EN EL EXAMEN PRENATAL DE LA MADRE"
      },
      {
        "codigo": "O284",
        "valor": "HALLAZGO RADIOLOGICO ANORMAL EN EL EXAMEN PRENATAL DE LA MADRE"
      },
      {
        "codigo": "O285",
        "valor": "HALLAZGO CROMOSOMICO O GENETICO ANORMAL EN EL EXAMEN PRENATAL DE LA MADRE"
      },
      {
        "codigo": "O288",
        "valor": "OTROS HALLAZGOS ANORMALES EN EL EXAMEN PRENATAL DE LA MADRE"
      },
      {
        "codigo": "O2881",
        "valor": "HEMOLISIS, ENZIMAS HEPATICAS ELEVADAS Y PLAQUETAS BAJAS (HELLP)"
      },
      {
        "codigo": "O289",
        "valor": "HALLAZGO ANORMAL NO ESPECIFICADO EN EL EXAMEN PRENATAL DE LA MADRE"
      }
    ]
  },
  {
    "grupo": "O29 - COMPLICACIONES DE LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO",
    "detalle": [
      {
        "codigo": "O290",
        "valor": "COMPLICACIONES PULMONARES DE LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO"
      },
      {
        "codigo": "O291",
        "valor": "COMPLICACIONES CARDIACAS DE LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO"
      },
      {
        "codigo": "O292",
        "valor": "COMPLICACIONES DEL SISTEMA NERVIOSO CENTRAL DEBIDAS A LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO"
      },
      {
        "codigo": "O293",
        "valor": "REACCION TOXICA A LA ANESTESIA LOCAL ADMINISTRADA DURANTE EL EMBARAZO"
      },
      {
        "codigo": "O294",
        "valor": "CEFALALGIA INDUCIDA POR LA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL EMBARAZO"
      },
      {
        "codigo": "O295",
        "valor": "OTRAS COMPLICACIONES DE LA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL EMBARAZO"
      },
      {
        "codigo": "O296",
        "valor": "FALLA O DIFICULTAD EN LA INTUBACION DURANTE EL EMBARAZO"
      },
      {
        "codigo": "O298",
        "valor": "OTRAS COMPLICACIONES DE LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO"
      },
      {
        "codigo": "O299",
        "valor": "COMPLICACION NO ESPECIFICADA DE LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO"
      }
    ]
  },
  {
    "grupo": "O30 - EMBARAZO MULTIPLE",
    "detalle": [
      {
        "codigo": "O300",
        "valor": "EMBARAZO DOBLE"
      },
      {
        "codigo": "O301",
        "valor": "EMBARAZO TRIPLE"
      },
      {
        "codigo": "O302",
        "valor": "EMBARAZO CUADRUPLE"
      },
      {
        "codigo": "O308",
        "valor": "OTROS EMBARAZOS MULTIPLES"
      },
      {
        "codigo": "O309",
        "valor": "EMBARAZO MULTIPLE, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O31 - COMPLICACIONES ESPECIFICAS DEL EMBARAZO MULTIPLE",
    "detalle": [
      {
        "codigo": "O310",
        "valor": "FETO PAPIRACEO"
      },
      {
        "codigo": "O311",
        "valor": "EMBARAZO QUE CONTINUA DESPUES DEL ABORTO DE UN FETO O MAS"
      },
      {
        "codigo": "O312",
        "valor": "EMBARAZO QUE CONTINUA DESPUES DE LA MUERTE INTRAUTERINA DE UN FETO O MAS"
      },
      {
        "codigo": "O318",
        "valor": "OTRAS COMPLICACIONES ESPECIFICAS DEL EMBARAZO MULTIPLE"
      }
    ]
  },
  {
    "grupo": "O32 - ATENCION MATERNA POR PRESENTACION ANORMAL DEL FETO, CONOCIDA O PRESUNTA",
    "detalle": [
      {
        "codigo": "O320",
        "valor": "ATENCION MATERNA POR POSICION FETAL INESTABLE"
      },
      {
        "codigo": "O321",
        "valor": "ATENCION MATERNA POR PRESENTACION DE NALGAS"
      },
      {
        "codigo": "O322",
        "valor": "ATENCION MATERNA POR POSICION FETAL OBLICUA O TRANSVERSA"
      },
      {
        "codigo": "O323",
        "valor": "ATENCION MATERNA POR PRESENTACION DE CARA, DE FRENTE O DE MENTON"
      },
      {
        "codigo": "O324",
        "valor": "ATENCION MATERNA POR CABEZA ALTA EN GESTACION A TERMINO"
      },
      {
        "codigo": "O325",
        "valor": "ATENCION MATERNA POR EMBARAZO MULTIPLE CON PRESENTACION ANORMAL DE UN FETO O MAS"
      },
      {
        "codigo": "O326",
        "valor": "ATENCION MATERNA POR PRESENTACION COMPUESTA"
      },
      {
        "codigo": "O328",
        "valor": "ATENCION MATERNA POR OTRAS PRESENTACIONES ANORMALES DEL FETO"
      },
      {
        "codigo": "O329",
        "valor": "ATENCION MATERNA POR PRESENTACION ANORMAL NO ESPECIFICADA DEL FETO"
      }
    ]
  },
  {
    "grupo": "O33 - ATENCION MATERNA POR DESPROPORCION CONOCIDA O PRESUNTA",
    "detalle": [
      {
        "codigo": "O330",
        "valor": "ATENCION MATERNA POR DESPROPORCION DEBIDA A DEFORMIDAD DE LA PELVIS OSEA EN LA MADRE"
      },
      {
        "codigo": "O331",
        "valor": "ATENCION MATERNA POR DESPROPORCION DEBIDA A ESTRECHEZ GENERAL DE LA PELVIS"
      },
      {
        "codigo": "O332",
        "valor": "ATENCION MATERNA POR DESPROPORCION DEBIDA A DISMINUCION DEL ESTRECHO SUPERIOR DE LA PELVIS"
      },
      {
        "codigo": "O333",
        "valor": "ATENCION MATERNA POR DESPROPORCION DEBIDA A DISMINUCION DEL ESTRECHO INFERIOR DE LA PELVIS"
      },
      {
        "codigo": "O334",
        "valor": "ATENCION MATERNA POR DESPROPORCION FETOPELVIANA DE ORIGEN MIXTO, MATERNO Y FETAL"
      },
      {
        "codigo": "O335",
        "valor": "ATENCION MATERNA POR DESPROPORCION DEBIDA A FETO DEMASIADO GRANDE"
      },
      {
        "codigo": "O336",
        "valor": "ATENCION MATERNA POR DESPROPORCION DEBIDA A FETO HIDROCEFALICO"
      },
      {
        "codigo": "O337",
        "valor": "ATENCION MATERNA POR DESPROPORCION DEBIDA A OTRA DEFORMIDAD FETAL"
      },
      {
        "codigo": "O338",
        "valor": "ATENCION MATERNA POR DESPROPORCION DE OTRO ORIGEN"
      },
      {
        "codigo": "O339",
        "valor": "ATENCION MATERNA POR DESPROPORCION DE ORIGEN NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O34 - ATENCION MATERNA POR ANORMALIDADES CONOCIDAS O PRESUNTAS DE LOS ORGANOS PELVIANOS DE LA MADRE",
    "detalle": [
      {
        "codigo": "O340",
        "valor": "ATENCION MATERNA POR ANOMALIA CONGENITA DEL UTERO"
      },
      {
        "codigo": "O341",
        "valor": "ATENCION MATERNA POR TUMOR DEL CUERPO DEL UTERO"
      },
      {
        "codigo": "O342",
        "valor": "ATENCION MATERNA POR CICATRIZ UTERINA DEBIDA A CIRUGIA PREVIA"
      },
      {
        "codigo": "O343",
        "valor": "ATENCION MATERNA POR INCOMPETENCIA DEL CUELLO UTERINO"
      },
      {
        "codigo": "O344",
        "valor": "ATENCION MATERNA POR OTRA ANORMALIDAD DEL CUELLO UTERINO"
      },
      {
        "codigo": "O345",
        "valor": "ATENCION MATERNA POR OTRAS ANORMALIDADES DEL UTERO GRAVIDO"
      },
      {
        "codigo": "O346",
        "valor": "ATENCION MATERNA POR ANORMALIDAD DE LA VAGINA"
      },
      {
        "codigo": "O347",
        "valor": "ATENCION MATERNA POR ANORMALIDAD DE LA VULVA Y DEL PERINEO"
      },
      {
        "codigo": "O348",
        "valor": "ATENCION MATERNA POR OTRAS ANORMALIDADES DE LOS ORGANOS PELVIANOS"
      },
      {
        "codigo": "O349",
        "valor": "ATENCION MATERNA POR ANORMALIDAD NO ESPECIFICADA DE ORGANO PELVIANO"
      }
    ]
  },
  {
    "grupo": "O35 - ATENCION MATERNA POR ANORMALIDAD O LESION FETAL, CONOCIDA O PRESUNTA",
    "detalle": [
      {
        "codigo": "O350",
        "valor": "ATENCION MATERNA POR (PRESUNTA) MALFORMACION DEL SISTEMA NERVIOSO CENTRAL EN EL FETO"
      },
      {
        "codigo": "O351",
        "valor": "ATENCION MATERNA POR (PRESUNTA) ANORMALIDAD CROMOSOMICA EN EL FETO"
      },
      {
        "codigo": "O352",
        "valor": "ATENCION MATERNA POR (PRESUNTA) ENFERMEDAD HEREDITARIA EN EL FETO"
      },
      {
        "codigo": "O353",
        "valor": "ATENCION MATERNA POR (PRESUNTA) LESION FETAL DEBIDA A ENFERMEDAD VIRICA EN LA MADRE"
      },
      {
        "codigo": "O354",
        "valor": "ATENCION MATERNA POR (PRESUNTA) LESION AL FETO DEBIDA AL ALCOHOL"
      },
      {
        "codigo": "O355",
        "valor": "ATENCION MATERNA POR (PRESUNTA) LESION FETAL DEBIDA A DROGAS"
      },
      {
        "codigo": "O356",
        "valor": "ATENCION MATERNA POR (PRESUNTA) LESION AL FETO DEBIDA A RADIACION"
      },
      {
        "codigo": "O357",
        "valor": "ATENCION MATERNA POR (PRESUNTA) LESION FETAL DEBIDA A OTROS PROCEDIMIENTOS MEDICOS"
      },
      {
        "codigo": "O358",
        "valor": "ATENCION MATERNA POR OTRAS (PRESUNTAS) ANORMALIDADES Y LESIONES FETALES"
      },
      {
        "codigo": "O359",
        "valor": "ATENCION MATERNA POR (PRESUNTA) ANORMALIDAD Y LESION FETAL NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O36 - ATENCION MATERNA POR OTROS PROBLEMAS FETALES CONOCIDOS O PRESUNTOS POLIHIDRAMNIOS",
    "detalle": [
      {
        "codigo": "O360",
        "valor": "ATENCION MATERNA POR ISOINMUNIZACION RHESUS"
      },
      {
        "codigo": "O361",
        "valor": "ATENCION MATERNA POR OTRA ISOINMUNIZACION"
      },
      {
        "codigo": "O362",
        "valor": "ATENCION MATERNA POR HIDROPESIA FETAL"
      },
      {
        "codigo": "O363",
        "valor": "ATENCION MATERNA POR SIGNOS DE HIPOXIA FETAL"
      },
      {
        "codigo": "O364",
        "valor": "ATENCION MATERNA POR MUERTE INTRAUTERINA"
      },
      {
        "codigo": "O365",
        "valor": "ATENCION MATERNA POR DEFICIT DEL CRECIMIENTO FETAL"
      },
      {
        "codigo": "O366",
        "valor": "ATENCION MATERNA POR CRECIMIENTO FETAL EXCESIVO"
      },
      {
        "codigo": "O367",
        "valor": "ATENCION MATERNA POR FETO VIABLE EN EMBARAZO ABDOMINAL"
      },
      {
        "codigo": "O368",
        "valor": "ATENCION MATERNA POR OTROS PROBLEMAS FETALES ESPECIFICADOS"
      },
      {
        "codigo": "O369",
        "valor": "ATENCION MATERNA POR PROBLEMAS FETALES NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "O40 - POLIHIDRAMNIOS",
    "detalle": [
      {
        "codigo": "O40X",
        "valor": "POLIHIDRAMNIOS"
      }
    ]
  },
  {
    "grupo": "O41 - OTROS TRASTORNOS DEL LIQUIDO AMNIOTICO Y DE LAS MEMBRANAS",
    "detalle": [
      {
        "codigo": "O410",
        "valor": "OLIGOHIDRAMNIOS"
      },
      {
        "codigo": "O411",
        "valor": "INFECCION DE LA BOLSA AMNIOTICA O DE LAS MEMBRANAS"
      },
      {
        "codigo": "O418",
        "valor": "OTROS TRASTORNOS ESPECIFICADOS DEL LIQUIDO AMNIOTICO Y DE LAS MEMBRANAS"
      },
      {
        "codigo": "O419",
        "valor": "TRASTORNO DEL LIQUIDO AMNIOTICO Y DE LAS MEMBRANAS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O42 - RUPTURA PREMATURA DE LAS MEMBRANAS",
    "detalle": [
      {
        "codigo": "O420",
        "valor": "RUPTURA PREMATURA DE LAS MEMBRANAS, E INICIO DEL TRABAJO DE PARTO DENTRO DE LAS 24 HORAS"
      },
      {
        "codigo": "O421",
        "valor": "RUPTURA PREMATURA DE LAS MEMBRANAS, E INICIO DEL TRABAJO DE PARTO DESPUES DE LAS 24 HORAS"
      },
      {
        "codigo": "O422",
        "valor": "RUPTURA PREMATURA DE LAS MEMBRANAS, TRABAJO DE PARTO RETRASADO POR LA TERAPEUTICA"
      },
      {
        "codigo": "O429",
        "valor": "RUPTURA PREMATURA DE LAS MEMBRANAS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "O43 - TRASTORNOS PLACENTARIOS",
    "detalle": [
      {
        "codigo": "O430",
        "valor": "SINDROME DE TRANSFUSION PLACENTARIA"
      },
      {
        "codigo": "O431",
        "valor": "MALFORMACION DE LA PLACENTA"
      },
      {
        "codigo": "O432",
        "valor": "PLACENTA ANORMALMENTE ADHERIDA"
      },
      {
        "codigo": "O438",
        "valor": "OTROS TRASTORNOS PLACENTARIOS"
      },
      {
        "codigo": "O439",
        "valor": "TRASTORNO DE LA PLACENTA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O44 - PLACENTA PREVIA",
    "detalle": [
      {
        "codigo": "O440",
        "valor": "PLACENTA PREVIA CON ESPECIFICACION DE QUE NO HUBO HEMORRAGIA"
      },
      {
        "codigo": "O441",
        "valor": "PLACENTA PREVIA CON HEMORRAGIA"
      }
    ]
  },
  {
    "grupo": "O45 - DESPRENDIMIENTO PREMATURO DE LA PLACENTA [ABRUPTIO PLACENTAE]",
    "detalle": [
      {
        "codigo": "O450",
        "valor": "DESPRENDIMIENTO PREMATURO DE LA PLACENTA CON DEFECTO DE LA COAGULACION"
      },
      {
        "codigo": "O458",
        "valor": "OTROS DESPRENDIMIENTOS PREMATUROS DE LA PLACENTA"
      },
      {
        "codigo": "O459",
        "valor": "DESPRENDIMIENTO PREMATURO DE LA PLACENTA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "O46 - HEMORRAGIA ANTEPARTO, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "O460",
        "valor": "HEMORRAGIA ANTEPARTO CON DEFECTO DE LA COAGULACION"
      },
      {
        "codigo": "O468",
        "valor": "OTRAS HEMORRAGIAS ANTEPARTO"
      },
      {
        "codigo": "O469",
        "valor": "HEMORRAGIA ANTEPARTO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O47 - FALSO TRABAJO DE PARTO",
    "detalle": [
      {
        "codigo": "O470",
        "valor": "FALSO TRABAJO DE PARTO ANTES DE LAS 37 SEMANAS COMPLETAS DE GESTACION"
      },
      {
        "codigo": "O471",
        "valor": "FALSO TRABAJO DE PARTO A LAS 37 Y MAS SEMANAS COMPLETAS DE GESTACION"
      },
      {
        "codigo": "O479",
        "valor": "FALSO TRABAJO DE PARTO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "O48 - EMBARAZO PROLONGADO",
    "detalle": [
      {
        "codigo": "O48X",
        "valor": "EMBARAZO PROLONGADO"
      }
    ]
  },
  {
    "grupo": "O60 - TRABAJO DE PARTO PREMATURO",
    "detalle": [
      {
        "codigo": "O600",
        "valor": "TRABAJO DE PARTO PREMATURO SIN PARTO"
      },
      {
        "codigo": "O601",
        "valor": "TRABAJO DE PARTO PREMATURO ESPONTANEO CON PARTO PREMATURO"
      },
      {
        "codigo": "O602",
        "valor": "TRABAJO DE PARTO PREMATURO ESPONTANEO CON PARTO A TERMINO"
      },
      {
        "codigo": "O603",
        "valor": "PARTO PREMATURO SIN TRABAJO DE PARTO ESPONTANEO"
      },
      {
        "codigo": "O60X",
        "valor": "PARTO PREMATURO"
      }
    ]
  },
  {
    "grupo": "O61 - FRACASO DE LA INDUCCION DEL TRABAJO DE PARTO",
    "detalle": [
      {
        "codigo": "O610",
        "valor": "FRACASO DE LA INDUCCION MEDICA DEL TRABAJO DE PARTO"
      },
      {
        "codigo": "O611",
        "valor": "FRACASO DE LA INDUCCION INSTRUMENTAL DEL TRABAJO DE PARTO"
      },
      {
        "codigo": "O618",
        "valor": "OTROS FRACASOS DE LA INDUCCION DEL TRABAJO DE PARTO"
      },
      {
        "codigo": "O619",
        "valor": "FRACASO NO ESPECIFICADO DE LA INDUCCION DEL TRABAJO DE PARTO"
      }
    ]
  },
  {
    "grupo": "O62 - ANORMALIDADES DE LA DINAMICA DEL TRABAJO DE PARTO",
    "detalle": [
      {
        "codigo": "O620",
        "valor": "CONTRACCIONES PRIMARIAS INADECUADAS"
      },
      {
        "codigo": "O621",
        "valor": "INERCIA UTERINA SECUNDARIA"
      },
      {
        "codigo": "O622",
        "valor": "OTRAS INERCIAS UTERINAS"
      },
      {
        "codigo": "O623",
        "valor": "TRABAJO DE PARTO PRECIPITADO"
      },
      {
        "codigo": "O624",
        "valor": "CONTRACCIONES UTERINAS HIPERTONICAS, INCOORDINADAS Y PROLONGADAS"
      },
      {
        "codigo": "O628",
        "valor": "OTRAS ANOMALIAS DINAMICAS DEL TRABAJO DE PARTO"
      },
      {
        "codigo": "O629",
        "valor": "ANOMALIA DINAMICA DEL TRABAJO DE PARTO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O63 - TRABAJO DE PARTO PROLONGADO",
    "detalle": [
      {
        "codigo": "O630",
        "valor": "PROLONGACION DEL PRIMER PERIODO (DEL TRABAJO DE PARTO)"
      },
      {
        "codigo": "O631",
        "valor": "PROLONGACION DEL SEGUNDO PERIODO (DEL TRABAJO DE PARTO)"
      },
      {
        "codigo": "O632",
        "valor": "RETRASO DE LA EXPULSION DEL SEGUNDO GEMELO, DEL TERCERO, ETC."
      },
      {
        "codigo": "O639",
        "valor": "TRABAJO DE PARTO PROLONGADO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O64 - TRABAJO DE PARTO OBSTRUIDO DEBIDO A MALA POSICION Y PRESENTACION ANORMALES",
    "detalle": [
      {
        "codigo": "O640",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A ROTACION INCOMPLETA DE LA CABEZA FETAL"
      },
      {
        "codigo": "O641",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION DE NALGAS"
      },
      {
        "codigo": "O642",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION DE CARA"
      },
      {
        "codigo": "O643",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION DE FRENTE"
      },
      {
        "codigo": "O644",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION DE HOMBRO"
      },
      {
        "codigo": "O645",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION COMPUESTA"
      },
      {
        "codigo": "O648",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A OTRAS PRESENTACIONES ANORMALES DEL FETO"
      },
      {
        "codigo": "O649",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION ANORMAL DEL FETO NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O65 - TRABAJO DE PARTO OBSTRUIDO DEBIDO A ANORMALIDAD DE LA PELVIS MATERNA",
    "detalle": [
      {
        "codigo": "O650",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A DEFORMIDAD DE LA PELVIS"
      },
      {
        "codigo": "O651",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A ESTRECHEZ GENERAL DE LA PELVIS"
      },
      {
        "codigo": "O652",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISMINUCION DEL ESTRECHO SUPERIOR DE LA PELVIS"
      },
      {
        "codigo": "O653",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISMINUCION DEL ESTRECHO INFERIOR DE LA PELVIS"
      },
      {
        "codigo": "O654",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A DESPROPORCION FETOPELVIANA, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "O655",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A ANOMALIAS DE LOS ORGANOS PELVIANOS MATERNOS"
      },
      {
        "codigo": "O658",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A OTRAS ANOMALIAS PELVIANAS MATERNAS"
      },
      {
        "codigo": "O659",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A ANOMALIA PELVIANA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O66 - OTRAS OBSTRUCCIONES DEL TRABAJO DE PARTO",
    "detalle": [
      {
        "codigo": "O660",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISTOCIA DE HOMBROS"
      },
      {
        "codigo": "O661",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISTOCIA GEMELAR"
      },
      {
        "codigo": "O662",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISTOCIA POR FETO INUSUALMENTE GRANDE"
      },
      {
        "codigo": "O663",
        "valor": "TRABAJO DE PARTO OBSTRUIDO DEBIDO A OTRAS ANORMALIDADES DEL FETO"
      },
      {
        "codigo": "O664",
        "valor": "FRACASO DE LA PRUEBA DEL TRABAJO DE PARTO, NO ESPECIFICADA"
      },
      {
        "codigo": "O665",
        "valor": "FRACASO NO ESPECIFICADO DE LA APLICACION DE FORCEPS O DE VENTOSA EXTRACTORA"
      },
      {
        "codigo": "O668",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DEL TRABAJO DE PARTO"
      },
      {
        "codigo": "O669",
        "valor": "TRABAJO DE PARTO OBSTRUIDO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "O67 - TRABAJO DE PARTO Y PARTO COMPLICADOS POR HEMORRAGIA INTRAPARTO, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "O670",
        "valor": "HEMORRAGIA INTRAPARTO CON DEFECTOS DE LA COAGULACION"
      },
      {
        "codigo": "O678",
        "valor": "OTRAS HEMORRAGIAS INTRAPARTO"
      },
      {
        "codigo": "O679",
        "valor": "HEMORRAGIA INTRAPARTO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O68 - TRABAJO DE PARTO Y PARTO COMPLICADOS POR SUFRIMIENTO FETAL",
    "detalle": [
      {
        "codigo": "O680",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR ANOMALIA DE LA FRECUENCIA CARDIACA FETAL"
      },
      {
        "codigo": "O681",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR LA PRESENCIA DE MECONIO EN EL LIQUIDO AMNIOTICO"
      },
      {
        "codigo": "O682",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR ANOMALIA DE LA FRECUENCIA CARDIACA FETAL ASOCIADA CON PRESENCIA DE MECONIO EN EL LIQUIDO AMNIOTICO"
      },
      {
        "codigo": "O683",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR EVIDENCIA BIOQUIMICA DE SUFRIMIENTO FETAL"
      },
      {
        "codigo": "O688",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR OTRAS EVIDENCIAS DE SUFRIMIENTO FETAL"
      },
      {
        "codigo": "O689",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR SUFRIMIENTO FETAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "O69 - TRABAJO DE PARTO Y PARTO COMPLICADOS POR PROBLEMAS DEL CORDON UMBILICAL",
    "detalle": [
      {
        "codigo": "O690",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR PROLAPSO DEL CORDON UMBILICAL"
      },
      {
        "codigo": "O691",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR CIRCULAR PERICERVICAL DEL CORDON, CON COMPRESION"
      },
      {
        "codigo": "O692",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR OTROS ENREDOS DEL CORDON UMBLICAL CON COMPRESION"
      },
      {
        "codigo": "O693",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR CORDON UMBILICAL CORTO"
      },
      {
        "codigo": "O694",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR VASA PREVIA"
      },
      {
        "codigo": "O695",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR LESION VASCULAR DEL CORDON"
      },
      {
        "codigo": "O698",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR OTROS PROBLEMAS DEL CORDON UMBILICAL"
      },
      {
        "codigo": "O699",
        "valor": "TRABAJO DE PARTO Y PARTO COMPLICADOS POR PROBLEMAS NO ESPECIFICADOS DEL CORDON UMBILICAL"
      }
    ]
  },
  {
    "grupo": "O70 - DESGARRO PERINEAL DURANTE EL PARTO",
    "detalle": [
      {
        "codigo": "O700",
        "valor": "DESGARRO PERINEAL DE PRIMER GRADO DURANTE EL PARTO"
      },
      {
        "codigo": "O701",
        "valor": "DESGARRO PERINEAL DE SEGUNDO GRADO DURANTE EL PARTO"
      },
      {
        "codigo": "O702",
        "valor": "DESGARRO PERINEAL DE TERCER GRADO DURANTE EL PARTO"
      },
      {
        "codigo": "O703",
        "valor": "DESGARRO PERINEAL DE CUARTO GRADO DURANTE EL PARTO"
      },
      {
        "codigo": "O709",
        "valor": "DESGARRO PERINEAL DURANTE EL PARTO, DE GRADO NO EPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O71 - OTRO TRAUMA OBSTETRICO",
    "detalle": [
      {
        "codigo": "O710",
        "valor": "RUPTURA DEL UTERO ANTES DEL INICIO DEL TRABAJO DE PARTO"
      },
      {
        "codigo": "O711",
        "valor": "RUPTURA DEL UTERO DURANTE EL TRABAJO DE PARTO"
      },
      {
        "codigo": "O712",
        "valor": "INVERSION DEL UTERO, POSTPARTO"
      },
      {
        "codigo": "O713",
        "valor": "DESGARRO OBSTETRICO DEL CUELLO UTERINO"
      },
      {
        "codigo": "O714",
        "valor": "DESGARRO VAGINAL OBSTETRICO ALTO"
      },
      {
        "codigo": "O715",
        "valor": "OTROS TRAUMATISMOS OBSTETRICOS DE LOS ORGANOS PELVIANOS"
      },
      {
        "codigo": "O716",
        "valor": "TRAUMATISMO OBSTETRICO DE LOS LIGAMENTOS Y ARTICULACIONES DE LA PELVIS"
      },
      {
        "codigo": "O717",
        "valor": "HEMATOMA OBSTETRICO DE LA PELVIS"
      },
      {
        "codigo": "O718",
        "valor": "OTROS TRAUMAS OBSTETRICOS ESPECIFICADOS"
      },
      {
        "codigo": "O719",
        "valor": "TRAUMA OBSTETRICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O72 - HEMORRAGIA POSTPARTO",
    "detalle": [
      {
        "codigo": "O720",
        "valor": "HEMORRAGIA DEL TERCER PERIODO DEL PARTO"
      },
      {
        "codigo": "O721",
        "valor": "OTRAS HEMORRAGIAS POSTPARTO INMEDIATAS"
      },
      {
        "codigo": "O722",
        "valor": "HEMORRAGIA POSTPARTO SECUNDARIA O TARDIA"
      },
      {
        "codigo": "O723",
        "valor": "DEFECTO DE LA COAGULACION POSTPARTO"
      }
    ]
  },
  {
    "grupo": "O73 - RETENCION DE LA PLACENTA O DE LAS MEMBRANAS, SIN HEMORRAGIA",
    "detalle": [
      {
        "codigo": "O730",
        "valor": "RETENCION DE LA PLACENTA SIN HEMORRAGIA"
      },
      {
        "codigo": "O731",
        "valor": "RETENCION DE FRAGMENTOS DE LA PLACENTA O DE LAS MEMBRANAS, SIN HEMORRAGIA"
      }
    ]
  },
  {
    "grupo": "O74 - COMPLICACIONES DE LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO",
    "detalle": [
      {
        "codigo": "O740",
        "valor": "NEUMONITIS POR ASPIRACION DEBIDA A LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O741",
        "valor": "OTRAS COMPLICACIONES PULMONARES DEBIDAS A LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O742",
        "valor": "COMPLICACIONES CARDIACAS DE LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O743",
        "valor": "COMPLICACIONES DEL SISTEMA NERVIOSO CENTRAL POR LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O744",
        "valor": "REACCION TOXICA A LA ANESTESIA LOCAL ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O745",
        "valor": "CEFALALGIA INDUCIDA POR LA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O746",
        "valor": "OTRAS COMPLICACIONES DE LA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O747",
        "valor": "FALLA O DIFICULTAD EN LA INTUBACION DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O748",
        "valor": "OTRAS COMPLICACIONES DE LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O749",
        "valor": "COMPLICACION NO ESPECIFICADA DE LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      }
    ]
  },
  {
    "grupo": "O75 - OTRAS COMPLICACIONES DEL TRABAJO DE PARTO Y DEL PARTO, NO CLASIFICADAS",
    "detalle": [
      {
        "codigo": "O750",
        "valor": "SUFRIMIENTO MATERNO DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O751",
        "valor": "CHOQUE DURANTE O DESPUES DEL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "O752",
        "valor": "PIREXIA DURANTE EL TRABAJO DE PARTO, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "O753",
        "valor": "OTRAS INFECCIONES DURANTE EL TRABAJO DE PARTO"
      },
      {
        "codigo": "O754",
        "valor": "OTRAS COMPLICACIONES DE PROCEDIMIENTOS Y DE CIRUGIA OBSTETRICA"
      },
      {
        "codigo": "O755",
        "valor": "RETRASO DEL PARTO DESPUES DE LA RUPTURA ARTIFICIAL DE LAS MEMBRANAS"
      },
      {
        "codigo": "O756",
        "valor": "RETRASO DEL PARTO DESPUES DE LA RUPTURA ESPONTANEA O NO ESPECIFICADA DE LAS MEMBRANAS"
      },
      {
        "codigo": "O757",
        "valor": "PARTO VAGINAL POSTERIOR A UNA CESAREA PREVIA"
      },
      {
        "codigo": "O758",
        "valor": "OTRAS COMPLICACIONES ESPECIFICADAS DEL TRABAJO DE PARTO Y DEL PARTO"
      },
      {
        "codigo": "O759",
        "valor": "COMPLICACION NO ESPECIFICADA DEL TRABAJO DE PARTO Y DEL PARTO"
      }
    ]
  },
  {
    "grupo": "O80 - PARTO UNICO ESPONTANEO",
    "detalle": [
      {
        "codigo": "O800",
        "valor": "PARTO UNICO ESPONTANEO, PRESENTACION CEFALICA DE VERTICE"
      },
      {
        "codigo": "O8000",
        "valor": "PARTO VERTICAL"
      },
      {
        "codigo": "O8001",
        "valor": "PARTO HORIZONTAL"
      },
      {
        "codigo": "O801",
        "valor": "PARTO UNICO ESPONTANEO, PRESENTACION DE NALGAS O PODALICA"
      },
      {
        "codigo": "O808",
        "valor": "PARTO UNICO ESPONTANEO, OTRAS PRESENTACIONES"
      },
      {
        "codigo": "O809",
        "valor": "PARTO UNICO ESPONTANEO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "O81 - PARTO UNICO CON FORCEPS Y VENTOSA EXTRACTORA",
    "detalle": [
      {
        "codigo": "O810",
        "valor": "PARTO CON FORCEPS BAJO"
      },
      {
        "codigo": "O811",
        "valor": "PARTO CON FORCEPS MEDIO"
      },
      {
        "codigo": "O812",
        "valor": "PARTO CON FORCEPS MEDIO CON ROTACION"
      },
      {
        "codigo": "O813",
        "valor": "PARTO CON FORCEPS DE OTROS TIPOS Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "O814",
        "valor": "PARTO CON VENTOSA EXTRACTORA"
      },
      {
        "codigo": "O815",
        "valor": "PARTO CON COMBINACION DE FORCEPS Y VENTOSA EXTRACTORA"
      }
    ]
  },
  {
    "grupo": "O82 - PARTO UNICO POR CESAREA",
    "detalle": [
      {
        "codigo": "O820",
        "valor": "PARTO POR CESAREA ELECTIVA"
      },
      {
        "codigo": "O821",
        "valor": "PARTO POR CESAREA DE EMERGENCIA"
      },
      {
        "codigo": "O822",
        "valor": "PARTO POR CESAREA CON HISTERECTOMIA"
      },
      {
        "codigo": "O828",
        "valor": "OTROS PARTOS UNICOS POR CESAREA"
      },
      {
        "codigo": "O829",
        "valor": "PARTO POR CESAREA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "O83 - OTROS PARTOS UNICOS ASISTIDOS",
    "detalle": [
      {
        "codigo": "O830",
        "valor": "EXTRACCION DE NALGAS"
      },
      {
        "codigo": "O831",
        "valor": "OTROS PARTOS UNICOS ASISTIDOS, DE NALGAS"
      },
      {
        "codigo": "O832",
        "valor": "OTROS PARTOS UNICOS CON AYUDA DE MANIPULACION OBSTETRICA"
      },
      {
        "codigo": "O833",
        "valor": "PARTO DE FETO VIABLE EN EMBARAZO ABDOMINAL"
      },
      {
        "codigo": "O834",
        "valor": "OPERACION DESTRUCTIVA PARA FACILITAR EL PARTO"
      },
      {
        "codigo": "O838",
        "valor": "OTROS PARTOS UNICOS ASISTIDOS ESPECIFICADOS"
      },
      {
        "codigo": "O839",
        "valor": "PARTO UNICO ASISTIDO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "O84 - PARTO MULTIPLE",
    "detalle": [
      {
        "codigo": "O840",
        "valor": "PARTO MULTIPLE, TODOS ESPONTANEOS"
      },
      {
        "codigo": "O841",
        "valor": "PARTO MULTIPLE, TODOS POR FORCEPS Y VENTOSA EXTRACTORA"
      },
      {
        "codigo": "O842",
        "valor": "PARTO MULTIPLE, TODOS POR CESAREA"
      },
      {
        "codigo": "O848",
        "valor": "OTROS PARTOS MULTIPLES"
      },
      {
        "codigo": "O849",
        "valor": "PARTO MULTIPLE, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "O85 - SEPSIS PUERPERAL",
    "detalle": [
      {
        "codigo": "O85X",
        "valor": "SEPSIS PUERPERAL (ENDOMETRITIS POS PARTO)"
      }
    ]
  },
  {
    "grupo": "O86 - OTRAS INFECCIONES PUERPERALES",
    "detalle": [
      {
        "codigo": "O860",
        "valor": "INFECCION DE HERIDA QUIRURGICA OBSTETRICA"
      },
      {
        "codigo": "O861",
        "valor": "OTRAS INFECCIONES GENITALES CONSECUTIVAS AL PARTO"
      },
      {
        "codigo": "O862",
        "valor": "INFECCION DE LAS VIAS URINARIAS CONSECUTIVA AL PARTO"
      },
      {
        "codigo": "O863",
        "valor": "OTRAS INFECCIONES DE LAS VIAS GENITOURINARIAS CONSECUTIVAS AL PARTO"
      },
      {
        "codigo": "O864",
        "valor": "PIREXIA DE ORIGEN DESCONOCIDO CONSECUTIVA AL PARTO"
      },
      {
        "codigo": "O868",
        "valor": "OTRAS INFECCIONES PUERPERALES ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "O87 - COMPLICACIONES VENOSAS EN EL PUERPERIO",
    "detalle": [
      {
        "codigo": "O870",
        "valor": "TROMBOFLEBITIS SUPERFICIAL EN EL PUERPERIO"
      },
      {
        "codigo": "O871",
        "valor": "FLEBOTROMBOSIS PROFUNDA EN EL PUERPERIO"
      },
      {
        "codigo": "O872",
        "valor": "HEMORROIDES EN EL PUERPERIO"
      },
      {
        "codigo": "O873",
        "valor": "TROMBOSIS VENOSA CEREBRAL EN EL PUERPERIO"
      },
      {
        "codigo": "O878",
        "valor": "OTRAS COMPLICACIONES VENOSAS EN EL PUERPERIO"
      },
      {
        "codigo": "O879",
        "valor": "COMPLICACION VENOSA EN EL PUERPERIO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O88 - EMBOLIA OBSTETRICA",
    "detalle": [
      {
        "codigo": "O880",
        "valor": "EMBOLIA GASEOSA, OBSTETRICA"
      },
      {
        "codigo": "O881",
        "valor": "EMBOLIA DE LIQUIDO AMNIOTICO"
      },
      {
        "codigo": "O882",
        "valor": "EMBOLIA DE COAGULO SANGUINEO, OBSTETRICA"
      },
      {
        "codigo": "O883",
        "valor": "EMBOLIA SEPTICA Y PIEMICA, OBSTETRICA"
      },
      {
        "codigo": "O888",
        "valor": "OTRAS EMBOLIAS OBSTETRICAS"
      }
    ]
  },
  {
    "grupo": "O89 - COMPLICACIONES DE LA ANESTESIA ADMINISTRADA DURANTE EL PUERPERIO",
    "detalle": [
      {
        "codigo": "O890",
        "valor": "COMPLICACIONES PULMONARES DE LA ANESTESIA ADMINISTRADA DURANTE EL PUERPERIO"
      },
      {
        "codigo": "O891",
        "valor": "COMPLICACIONES CARDIACAS DE LA ANESTESIA ADMINISTRADA DURANTE EL PUERPERIO"
      },
      {
        "codigo": "O892",
        "valor": "COMPLICACIONES DEL SISTEMA NERVIOSO CENTRAL DEBIDAS A LA ANESTESIA ADMINISTRADA DURANTE EL PUERPERIO"
      },
      {
        "codigo": "O893",
        "valor": "REACCION TOXICA A LA ANESTESIA LOCAL ADMINISTRADA DURANTE EL PUERPERIO"
      },
      {
        "codigo": "O894",
        "valor": "CEFALALGIA INDUCIDA POR LA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL PUERPERIO"
      },
      {
        "codigo": "O895",
        "valor": "OTRAS COMPLICACIONES DE LA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL PUERPERIO"
      },
      {
        "codigo": "O896",
        "valor": "FALLA O DIFICULTAD DE INTUBACION DURANTE EL PUERPERIO"
      },
      {
        "codigo": "O898",
        "valor": "OTRAS COMPLICACIONES DE LA ANESTESIA ADMINISTRADA DURANTE EL PUERPERIO"
      },
      {
        "codigo": "O899",
        "valor": "COMPLICACION NO ESPECIFICADA DE LA ANESTESIA ADMINISTRADA DURANTE EL PUERPERIO"
      }
    ]
  },
  {
    "grupo": "O90 - COMPLICACIONES DEL PUERPERIO, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "O900",
        "valor": "DEHISCENCIA DE SUTURA DE CESAREA"
      },
      {
        "codigo": "O901",
        "valor": "DEHISCENCIA DE SUTURA OBSTETRICA PERINEAL"
      },
      {
        "codigo": "O902",
        "valor": "HEMATOMA DE HERIDA QUIRURGICA OBSTETRICA"
      },
      {
        "codigo": "O903",
        "valor": "CARDIOMIOPATIA EN EL PUERPERIO"
      },
      {
        "codigo": "O904",
        "valor": "INSUFICIENCIA RENAL AGUDA POSTPARTO"
      },
      {
        "codigo": "O905",
        "valor": "TIROIDITIS POSTPARTO"
      },
      {
        "codigo": "O908",
        "valor": "OTRAS COMPLICACIONES PUERPERALES, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "O909",
        "valor": "COMPLICACION PUERPERAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O91 - INFECCIONES DE LA MAMA ASOCIADAS CON EL PARTO",
    "detalle": [
      {
        "codigo": "O910",
        "valor": "INFECCIONES DEL PEZON ASOCIADOS CON EL PARTO"
      },
      {
        "codigo": "O911",
        "valor": "ABSCESO DE LA MAMA ASOCIADO CON EL PARTO"
      },
      {
        "codigo": "O912",
        "valor": "MASTITIS NO PURULENTA ASOCIADA CON EL PARTO"
      }
    ]
  },
  {
    "grupo": "O92 - OTROS TRASTORNOS DE LA MAMA Y DE LA LACTANCIA ASOCIADOS CON EL PARTO",
    "detalle": [
      {
        "codigo": "O920",
        "valor": "RETRACCION DEL PEZON ASOCIADA CON EL PARTO"
      },
      {
        "codigo": "O921",
        "valor": "FISURAS DEL PEZON ASOCIADAS CON EL PARTO"
      },
      {
        "codigo": "O922",
        "valor": "OTROS TRASTORNOS DE LA MAMA Y LOS NO ESPECIFICADOS ASOCIADOS CON EL PARTO"
      },
      {
        "codigo": "O923",
        "valor": "AGALACTIA"
      },
      {
        "codigo": "O924",
        "valor": "HIPOGALACTIA"
      },
      {
        "codigo": "O925",
        "valor": "SUPRESION DE LA LACTANCIA"
      },
      {
        "codigo": "O926",
        "valor": "GALACTORREA"
      },
      {
        "codigo": "O927",
        "valor": "OTROS TRASTORNOS Y LOS NO ESPECIFICADOS DE LA LACTANCIA"
      }
    ]
  },
  {
    "grupo": "O94 - SECUELAS DE COMPLICACIONES DEL EMBARAZO, DEL PARTO Y DEL PUERPERIO",
    "detalle": [
      {
        "codigo": "O94X",
        "valor": "SECUELAS DE COMPLICACIONES DEL EMBARAZO, DEL PARTO Y DEL PUERPERIO"
      }
    ]
  },
  {
    "grupo": "O95 - MUERTE OBSTETRICA DE CAUSA NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "O95X",
        "valor": "MUERTE OBSTETRICA DE CAUSA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "O96 - MUERTE MATERNA DEBIDA A CUALQUIER CAUSA OBSTETRICA QUE OCURRE DESPUES",
    "detalle": [
      {
        "codigo": "O960",
        "valor": "MUERTE POR CAUSA OBSTETRICA DIRECTA QUE OCURRE DESPUES DE 42 DIAS PERO ANTES DE UN AÑO DEL PARTO"
      },
      {
        "codigo": "O961",
        "valor": "MUERTE POR CAUSA OBSTETRICA INDIRECTA QUE OCURRE DESPUES DE 42 DIAS PERO ANTES DE UN AÑO DEL PARTO"
      },
      {
        "codigo": "O969",
        "valor": "MUERTE PORÂ CAUSA OBSTETRICA NO ESPECIFICADA, QUE OCURRE DESPUES DE 42 DIAS PERO ANTES DE UN AÑO DEL PARTO"
      },
      {
        "codigo": "O96X",
        "valor": "MUERTE MATERNA DEBIDA A CUALQUIER CAUSA OBSTETRICA QUE OCURRE DESPUES DE 42 DIAS"
      }
    ]
  },
  {
    "grupo": "O97 - MUERTE POR SECUELAS DE CAUSAS OBSTETRICAS",
    "detalle": [
      {
        "codigo": "O970",
        "valor": "MUERTE POR SECUELAS DE CAUSA OBSTETRICA DIRECTA"
      },
      {
        "codigo": "O971",
        "valor": "MUERTE POR SECUELAS DE CAUSA OBSTETRICA INDIRECTA"
      },
      {
        "codigo": "O979",
        "valor": "MUERTE POR SECUELAS DEÂ CAUSA OBSTETRICA NO ESPECIFICADA"
      },
      {
        "codigo": "O97X",
        "valor": "MUERTE POR SECUELAS DE CAUSAS OBSTETRICAS DIRECTAS"
      }
    ]
  },
  {
    "grupo": "O98 - ENFERMEDADES MATERNAS INFECCIOSAS Y PARASITARIAS CLASIFICABLES EN OTRA",
    "detalle": [
      {
        "codigo": "O980",
        "valor": "TUBERCULOSIS QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O981",
        "valor": "SIFILIS QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O982",
        "valor": "GONORREA QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O983",
        "valor": "OTRAS INFECCIONES CON UN MODO DE TRANSMISION PREDOMINANTEMENTE SEXUAL QUE COMPLICAN EL EMBARAZO, PARTO Y PUERPERIO"
      },
      {
        "codigo": "O984",
        "valor": "HEPATITIS VIRAL QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O985",
        "valor": "OTRAS ENFERMEDADES VIRALES QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O986",
        "valor": "ENFERMEDADES CAUSADAS POR PROTOZOARIOS QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O987",
        "valor": "ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH] QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O988",
        "valor": "OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS MATERNAS QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O989",
        "valor": "ENFERMEDAD INFECCIOSA Y PARASITARIA MATERNA NO ESPECIFICADA QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      }
    ]
  },
  {
    "grupo": "O99 - OTRAS ENFERMEDADES MATERNAS CLASIFICABLES EN OTRA PARTE, PERO QUE COMPLICAN EL EMBARAZO, PARTO Y EL PUERPERIO",
    "detalle": [
      {
        "codigo": "O990",
        "valor": "ANEMIA QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O991",
        "valor": "OTRAS ENFERMEDADES DE LA SANGRE Y ORGANOS HEMATOPOYETICOS Y CIERTOS TRASTORNOS QUE AFECTAN EL SISTEMA INMUNITARIO CUANDO COMPLICAN EL EMBARAZO, EL PARTO Y PUERPERIO"
      },
      {
        "codigo": "O992",
        "valor": "ENFERMEDADES ENDOCRINAS, DE LA NUTRICION Y DEL METABOLISMO QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O993",
        "valor": "TRASTORNOS MENTALES Y ENFERMEDADES DEL SISTEMA NERVIOSO QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O994",
        "valor": "ENFERMEDADES DEL SISTEMA CIRCULATORIO QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PURPERIO"
      },
      {
        "codigo": "O995",
        "valor": "ENFERMEDADES DEL SISTEMA RESPIRATORIO QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O996",
        "valor": "ENFERMEDADES DEL SISTEMA DIGESTIVO QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O997",
        "valor": "ENFERMEDADES DE LA PIEL Y DEL TEJIDO SUBCUTANEO QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      },
      {
        "codigo": "O998",
        "valor": "OTRAS ENFERMEDADES ESPECIFICADAS Y AFECCIONES QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
      }
    ]
  },
  {
    "grupo": "P00 - FETO Y RECIEN NACIDO AFECTADOS POR CONDICIONES DE LA MADRE NO NECESARIAMENTE RELACIONADAS CON EL EMBARAZO PRESENTE",
    "detalle": [
      {
        "codigo": "P000",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR TRASTORNOS HIPERTENSIVOS DE LA MADRE"
      },
      {
        "codigo": "P001",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR ENFERMEDADES RENALES Y DE LAS VIAS URINARIAS DE LA MADRE"
      },
      {
        "codigo": "P002",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR ENFERMEDADES INFECCIOSAS Y PARASITARIAS DE LA MADRE"
      },
      {
        "codigo": "P003",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRAS ENFERMEDADES CIRCULATORIAS Y RESPIRATORIAS DE LA MADRE"
      },
      {
        "codigo": "P004",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR TRASTORNOS NUTRICIONALES DE LA MADRE"
      },
      {
        "codigo": "P005",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR TRAUMATISMO DE LA MADRE"
      },
      {
        "codigo": "P006",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR PROCEDIMIENTO QUIRURGICO EN LA MADRE"
      },
      {
        "codigo": "P007",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRO PROCEDIMIENTO MEDICO EN LA MADRE, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "P008",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRAS AFECCIONES MATERNAS"
      },
      {
        "codigo": "P009",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR AFECCION MATERNA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P01 - FETO Y RECIEN NACIDO AFECTADOS POR COMPLICACIONES MATERNAS DEL EMBARAZO",
    "detalle": [
      {
        "codigo": "P010",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR INCOMPETENCIA DEL CUELLO UTERINO"
      },
      {
        "codigo": "P011",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR RUPTURA PREMATURA DE LAS MEMBRANAS"
      },
      {
        "codigo": "P012",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OLIGOHIDRAMNIOS"
      },
      {
        "codigo": "P013",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR POLIHIDRAMNIOS"
      },
      {
        "codigo": "P014",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR EMBARAZO ECTOPICO"
      },
      {
        "codigo": "P015",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR EMBARAZO MULTIPLE"
      },
      {
        "codigo": "P016",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR MUERTE MATERNA"
      },
      {
        "codigo": "P017",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR PRESENTACION ANOMALA ANTES DEL TRABAJO DE PARTO"
      },
      {
        "codigo": "P018",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRAS COMPLICACIONES MATERNAS DEL EMBARAZO"
      },
      {
        "codigo": "P019",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR COMPLICACIONES MATERNAS NO ESPECIFICADAS DEL EMBARAZO"
      }
    ]
  },
  {
    "grupo": "P02 - FETO Y RECIEN NACIDO AFECTADOS POR COMPLICACIONES DE LA PLACENTA, DEL CORDON UMBILICAL Y DE LAS MEMBRANAS",
    "detalle": [
      {
        "codigo": "P020",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR PLACENTA PREVIA"
      },
      {
        "codigo": "P021",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRAS FORMAS DE DESPRENDIMIENTO Y DE HEMORRAGIA PLACENTARIOS"
      },
      {
        "codigo": "P022",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRAS ANORMALIDADES MORFOLOGICAS Y FUNCIONALES DE LA PLACENTA Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "P023",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR SINDROMES DE TRANSFUSION PLACENTARIA"
      },
      {
        "codigo": "P024",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR PROLAPSO DEL CORDON UMBILICAL"
      },
      {
        "codigo": "P025",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRA COMPRESION DEL CORDON UMBILICAL"
      },
      {
        "codigo": "P026",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRAS COMPLICACIONES DEL CORDON UMBILICAL Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "P027",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR CORIOAMNIONITIS"
      },
      {
        "codigo": "P028",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRAS ANORMALIDADES DE LAS MEMBRANAS"
      },
      {
        "codigo": "P029",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR ANORMALIDAD NO ESPECIFICADA DE LAS MEMBRANAS"
      }
    ]
  },
  {
    "grupo": "P03 - FETO Y RECIEN NACIDO AFECTADOS POR OTRAS COMPLICACIONES DEL TRABAJO DE PARTO Y DEL PARTO",
    "detalle": [
      {
        "codigo": "P030",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR PARTO Y EXTRACCION DE NALGAS"
      },
      {
        "codigo": "P031",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRA PRESENTACION ANOMALA, POSICION ANOMALA Y DESPROPORCION DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "P032",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR PARTO CON FORCEPS"
      },
      {
        "codigo": "P033",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR PARTO CON VENTOSA EXTRACTORA"
      },
      {
        "codigo": "P034",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR PARTO POR CESAREA"
      },
      {
        "codigo": "P035",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR PARTO PRECIPITADO"
      },
      {
        "codigo": "P036",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR CONTRACCIONES UTERINAS ANORMALES"
      },
      {
        "codigo": "P038",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRAS COMPLICACIONES ESPECIFICADAS DEL TRABAJO DE PARTO Y DEL PARTO"
      },
      {
        "codigo": "P039",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR COMPLICACIONES NO ESPECIFICADAS DEL TRABAJO DE PARTO Y DEL PARTO"
      }
    ]
  },
  {
    "grupo": "P04 - FETO Y RECIEN NACIDO AFECTADOS POR INFLUENCIAS NOCIVAS TRANSMITIDAS A TRAVES DE LA PLACENTA O DE LA LECHE MATERNA",
    "detalle": [
      {
        "codigo": "P040",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR ANESTESIA Y ANALGESIA MATERNA EN EL EMBARAZO, TRABAJO DE PARTO Y EN EL PARTO"
      },
      {
        "codigo": "P041",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRAS MEDICACIONES MATERNAS"
      },
      {
        "codigo": "P042",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR TABAQUISMO DE LA MADRE"
      },
      {
        "codigo": "P043",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR ALCOHOLISMO DE LA MADRE"
      },
      {
        "codigo": "P044",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR DROGADICCION MATERNA"
      },
      {
        "codigo": "P045",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR EL USO MATERNO DE SUSTANCIAS QUIMICAS NUTRICIONALES"
      },
      {
        "codigo": "P046",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR EXPOSICION MATERNA A SUSTANCIAS QUIMICAS AMBIENTALES"
      },
      {
        "codigo": "P048",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR OTRAS INFLUENCIAS NOCIVAS DE LA MADRE"
      },
      {
        "codigo": "P049",
        "valor": "FETO Y RECIEN NACIDO AFECTADOS POR INFLUENCIAS NOCIVAS DE LA MADRE, NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "P05 - RETARDO DEL CRECIMIENTO FETAL Y DESNUTRICION FETAL",
    "detalle": [
      {
        "codigo": "P050",
        "valor": "BAJO PESO PARA LA EDAD GESTACIONAL"
      },
      {
        "codigo": "P051",
        "valor": "PEQUEÑO PARA LA EDAD GESTACIONAL"
      },
      {
        "codigo": "P052",
        "valor": "DESNUTRICION FETAL, SIN MENCION DE PESO O TALLA BAJOS PARA LA EDAD GESTACIONAL"
      },
      {
        "codigo": "P059",
        "valor": "RETARDO DEL CRECIMIENTO FETAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "P07 - TRASTORNOS RELACIONADOS CON DURACION CORTA DE LA GESTACION Y CON BAJO PESO AL NACER, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "P070",
        "valor": "PESO EXTREMADAMENTE BAJO AL NACER"
      },
      {
        "codigo": "P071",
        "valor": "OTRO PESO BAJO AL NACER"
      },
      {
        "codigo": "P0711",
        "valor": "RECIEN NACIDO DE MUY BAJO PESO AL NACER (< 1500 GRAMOS)"
      },
      {
        "codigo": "P0712",
        "valor": "RECIEN NACIDO DE BAJO PESO AL NACER (< 2500 GRAMOS)"
      },
      {
        "codigo": "P0713",
        "valor": "RECIEN NACIDO PREMATURO"
      },
      {
        "codigo": "P072",
        "valor": "INMATURIDAD EXTREMA"
      },
      {
        "codigo": "P073",
        "valor": "OTROS RECIEN NACIDOS PRETERMINO"
      }
    ]
  },
  {
    "grupo": "P08 - TRASTORNOS RELACIONADOS CON EL EMBARAZO PROLONGADO Y CON SOBREPESO AL NACER",
    "detalle": [
      {
        "codigo": "P080",
        "valor": "RECIEN NACIDO EXCEPCIONALMENTE GRANDE"
      },
      {
        "codigo": "P081",
        "valor": "OTROS RECIEN NACIDOS CON SOBREPESO PARA LA EDAD GESTACIONAL"
      },
      {
        "codigo": "P082",
        "valor": "RECIEN NACIDO POSTERMINO SIN SOBREPESO PARA SU EDAD GESTACIONAL"
      }
    ]
  },
  {
    "grupo": "P10 - HEMORRAGIA Y LACERACION INTRACRANEAL DEBIDAS A TRAUMATISMO DEL NACIMIENTO",
    "detalle": [
      {
        "codigo": "P100",
        "valor": "HEMORRAGIA SUBDURAL DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P101",
        "valor": "HEMORRAGIA CEREBRAL DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P102",
        "valor": "HEMORRAGIA INTRAVENTRICULAR DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P103",
        "valor": "HEMORRAGIA SUBARACNOIDEA DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P104",
        "valor": "DESGARRO TENTORIAL DEBIDO A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P108",
        "valor": "OTRAS HEMORRAGIAS Y LACERACIONES INTRACRANEALES DEBIDAS A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P109",
        "valor": "HEMORRAGIA Y LACERACION INTRACRANEALES NO ESPECIFICADAS, DEBIDAS A TRAUMATISMO DEL NACIMIENTO"
      }
    ]
  },
  {
    "grupo": "P11 - OTROS TRAUMATISMOS DEL NACIMIENTO EN EL SISTEMA NERVIOSO CENTRAL",
    "detalle": [
      {
        "codigo": "P110",
        "valor": "EDEMA CEREBRAL DEBIDO A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P111",
        "valor": "OTRAS LESIONES ESPECIFICADAS DEL ENCEFALO, DEBIDAS A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P112",
        "valor": "LESION NO ESPECIFICADA DEL ENCEFALO, DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P113",
        "valor": "TRAUMATISMO DEL NACIMIENTO EN EL NERVIO FACIAL"
      },
      {
        "codigo": "P114",
        "valor": "TRAUMATISMO DEL NACIMIENTO EN OTROS NERVIOS CRANEALES"
      },
      {
        "codigo": "P115",
        "valor": "TRAUMATISMO DEL NACIMIENTO EN LA COLUMNA VERTEBRAL Y EN LA MEDULA ESPINAL"
      },
      {
        "codigo": "P119",
        "valor": "TRAUMATISMO DEL NACIMIENTO EN EL SISTEMA NERVIOSO CENTRAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "P12 - TRAUMATISMO DEL NACIMIENTO EN EL CUERO CABELLUDO",
    "detalle": [
      {
        "codigo": "P120",
        "valor": "CEFALOHEMATOMA DEBIDO A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P121",
        "valor": "CAPUT SUCCEDANEUM DEBIDO A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P122",
        "valor": "HEMORRAGIA EPICRANEAL SUBAPONEUROTICA DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P123",
        "valor": "EQUIMOSIS DEL CUERO CABELLUDO DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P124",
        "valor": "TRAUMATISMO EN EL CUERO CABELLUDO DEL RECIEN NACIDO POR MONITOREO FETAL"
      },
      {
        "codigo": "P128",
        "valor": "OTROS TRAUMATISMOS DEL NACIMIENTO EN EL CUERO CABELLUDO"
      },
      {
        "codigo": "P129",
        "valor": "TRAUMATISMO DEL NACIMIENTO EN EL CUERO CABELLUDO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "P13 - TRAUMATISMO DEL ESQUELETO DURANTE EL NACIMIENTO",
    "detalle": [
      {
        "codigo": "P130",
        "valor": "FRACTURA DEL CRANEO DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P131",
        "valor": "OTROS TRAUMATISMOS DEL CRANEO DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P132",
        "valor": "TRAUMATISMO DEL FEMUR DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P133",
        "valor": "TRAUMATISMO DE OTROS HUESOS LARGOS DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P134",
        "valor": "FRACTURA DE LA CLAVICULA DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P138",
        "valor": "TRAUMATISMO DEL NACIMIENTO EN OTRAS PARTES DEL ESQUELETO"
      },
      {
        "codigo": "P139",
        "valor": "TRAUMATISMO NO ESPECIFICADO DEL ESQUELETO DURANTE EL NACIMIENTO"
      }
    ]
  },
  {
    "grupo": "P14 - TRAUMATISMO DEL SISTEMA NERVIOSO PERIFERICO DURANTE EL NACIMIENTO",
    "detalle": [
      {
        "codigo": "P140",
        "valor": "PARALISIS DE ERB DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P141",
        "valor": "PARALISIS DE KLUMPKE DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P142",
        "valor": "PARALISIS DEL NERVIO FRENICO DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P143",
        "valor": "OTRO TRAUMATISMO DEL PLEXO BRAQUIAL DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P148",
        "valor": "TRAUMATISMO DURANTE EL NACIMIENTO EN OTRAS PARTES DEL SISTEMA NERVIOSO PERIFERICO"
      },
      {
        "codigo": "P149",
        "valor": "TRAUMATISMO NO ESPECIFICADO DEL SISTEMA NERVIOSO PERIFERICO DURANTE EL NACIMIENTO"
      }
    ]
  },
  {
    "grupo": "P15 - OTROS TRAUMATISMOS DEL NACIMIENTO",
    "detalle": [
      {
        "codigo": "P150",
        "valor": "LESION DEL HIGADO DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P151",
        "valor": "LESION DEL BAZO DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P152",
        "valor": "TRAUMATISMO DEL MUSCULO ESTERNOCLEIDOMASTOIDEO DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P153",
        "valor": "TRAUMATISMO OCULAR DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P154",
        "valor": "TRAUMATISMO FACIAL DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P155",
        "valor": "TRAUMATISMO DE LOS GENITALES EXTERNOS DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P156",
        "valor": "NECROSIS GRASA SUBCUTANEA DEBIDA A TRAUMATISMO DEL NACIMIENTO"
      },
      {
        "codigo": "P158",
        "valor": "OTROS TRAUMATISMOS ESPECIFICADOS, DURANTE EL NACIMIENTO"
      },
      {
        "codigo": "P159",
        "valor": "TRAUMATISMO NO ESPECIFICADO, DURANTE EL NACIMIENTO"
      }
    ]
  },
  {
    "grupo": "P20 - HIPOXIA INTRAUTERINA",
    "detalle": [
      {
        "codigo": "P200",
        "valor": "HIPOXIA INTRAUTERINA NOTADA POR PRIMERA VEZ ANTES DEL INICIO DEL TRABAJO DE PARTO"
      },
      {
        "codigo": "P201",
        "valor": "HIPOXIA INTRAUTERINA NOTADA POR PRIMERA VEZ DURANTE EL TRABAJO DE PARTO Y EL PARTO"
      },
      {
        "codigo": "P209",
        "valor": "HIPOXIA INTRAUTERINA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P21 - ASFIXIA DEL NACIMIENTO",
    "detalle": [
      {
        "codigo": "P210",
        "valor": "ASFIXIA DEL NACIMIENTO, SEVERA"
      },
      {
        "codigo": "P211",
        "valor": "ASFIXIA DEL NACIMIENTO, LEVE Y MODERADA"
      },
      {
        "codigo": "P219",
        "valor": "ASFIXIA DEL NACIMIENTO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P22 - DIFICULTAD RESPIRATORIA DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P220",
        "valor": "SINDROME DE DIFICULTAD RESPIRATORIA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P221",
        "valor": "TAQUIPNEA TRANSITORIA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P228",
        "valor": "OTRAS DIFICULTADES RESPIRATORIAS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P229",
        "valor": "DIFICULTAD RESPIRATORIA DEL RECIEN NACIDO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P23 - NEUMONIA CONGENITA",
    "detalle": [
      {
        "codigo": "P230",
        "valor": "NEUMONIA CONGENITA DEBIDA A AGENTE VIRAL"
      },
      {
        "codigo": "P231",
        "valor": "NEUMONIA CONGENITA DEBIDA A CHLAMYDIA"
      },
      {
        "codigo": "P232",
        "valor": "NEUMONIA CONGENITA DEBIDA A ESTAFILOCOCOS"
      },
      {
        "codigo": "P233",
        "valor": "NEUMONIA CONGENITA DEBIDA A ESTREPTOCOCOS DEL GRUPO B"
      },
      {
        "codigo": "P234",
        "valor": "NEUMONIA CONGENITA DEBIDA A ESCHERICHIA COLI"
      },
      {
        "codigo": "P235",
        "valor": "NEUMONIA CONGENITA DEBIDA A PSEUDOMONAS"
      },
      {
        "codigo": "P236",
        "valor": "NEUMONIA CONGENITA DEBIDA A OTROS AGENTES BACTERIANOS"
      },
      {
        "codigo": "P238",
        "valor": "NEUMONIA CONGENITA DEBIDA A OTROS ORGANISMOS"
      },
      {
        "codigo": "P239",
        "valor": "NEUMONIA CONGENITA, ORGANISMO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "P24 - SINDROMES DE ASPIRACION NEONATAL",
    "detalle": [
      {
        "codigo": "P240",
        "valor": "ASPIRACION NEONATAL DE MECONIO"
      },
      {
        "codigo": "P241",
        "valor": "ASPIRACION NEONATAL DE LIQUIDO AMNIOTICO Y DE MOCO"
      },
      {
        "codigo": "P242",
        "valor": "ASPIRACION NEONATAL DE SANGRE"
      },
      {
        "codigo": "P243",
        "valor": "ASPIRACION NEONATAL DE LECHE Y ALIMENTO REGURGITADO"
      },
      {
        "codigo": "P248",
        "valor": "OTROS SINDROMES DE ASPIRACION NEONATAL"
      },
      {
        "codigo": "P249",
        "valor": "SINDROME DE ASPIRACION NEONATAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "P25 - ENFISEMA INTERSTICIAL Y AFECCIONES RELACIONADAS, ORIGINADAS EN EL PERIODO PERINATAL",
    "detalle": [
      {
        "codigo": "P250",
        "valor": "ENFISEMA INTERSTICIAL ORIGINADO EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P251",
        "valor": "NEUMOTORAX ORIGINADO EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P252",
        "valor": "NEUMOMEDIASTINO ORIGINADO EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P253",
        "valor": "NEUMOPERICARDIO ORIGINADO EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P258",
        "valor": "OTRAS AFECCIONES RELACIONADAS CON EL ENFISEMA INTERSTICIAL, ORIGINADAS EN EL PERIODO PERINATAL"
      }
    ]
  },
  {
    "grupo": "P26 - HEMORRAGIA PULMONAR ORIGINADA EN EL PERIODO PERINATAL",
    "detalle": [
      {
        "codigo": "P260",
        "valor": "HEMORRAGIA TRAQUEOBRONQUIAL ORIGINADA EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P261",
        "valor": "HEMORRAGIA PULMONAR MASIVA ORIGINADA EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P268",
        "valor": "OTRAS HEMORRAGIAS PULMONARES ORIGINADAS EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P269",
        "valor": "HEMORRAGIA PULMONAR NO ESPECIFICADA, ORIGINADA EN EL PERIODO PERINATAL"
      }
    ]
  },
  {
    "grupo": "P27 - ENFERMEDAD RESPIRATORIA CRONICA ORIGINADA EN EL PERIODO PERINATAL",
    "detalle": [
      {
        "codigo": "P270",
        "valor": "SINDROME DE WILSON-MIKITY"
      },
      {
        "codigo": "P271",
        "valor": "DISPLASIA BRONCOPULMONAR ORIGINADA EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P278",
        "valor": "OTRAS ENFERMEDADES RESPIRATORIAS CRONICAS ORIGINADAS EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P279",
        "valor": "ENFERMEDAD RESPIRATORIA CRONICA NO ESPECIFICADA ORIGINADA EN EL PERIODO PERINATAL"
      }
    ]
  },
  {
    "grupo": "P28 - OTROS PROBLEMAS RESPIRATORIOS DEL RECIEN NACIDO, ORIGINADOS EN EL PERIODO PERINATAL",
    "detalle": [
      {
        "codigo": "P280",
        "valor": "ATELECTASIA PRIMARIA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P281",
        "valor": "OTRAS ATELECTASIAS DEL RECIEN NACIDO Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "P282",
        "valor": "ATAQUE CIANOTICO DEL RECIEN NACIDO"
      },
      {
        "codigo": "P283",
        "valor": "APNEA PRIMARIA DEL SUEÑO DEL RECIEN NACIDO"
      },
      {
        "codigo": "P284",
        "valor": "OTRAS APNEAS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P285",
        "valor": "INSUFICIENCIA RESPIRATORIA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P288",
        "valor": "OTROS PROBLEMAS RESPIRATORIOS ESPECIFICADOS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P289",
        "valor": "AFECCION RESPIRATORIA NO ESPECIFICADA DEL RECIEN NACIDO"
      }
    ]
  },
  {
    "grupo": "P29 - TRASTORNOS CARDIOVASCULARES ORIGINADOS EN EL PERIODO PERINATAL",
    "detalle": [
      {
        "codigo": "P290",
        "valor": "INSUFICIENCIA CARDIACA NEONATAL"
      },
      {
        "codigo": "P291",
        "valor": "DISRITMIA CARDIACA NEONATAL"
      },
      {
        "codigo": "P292",
        "valor": "HIPERTENSION NEONATAL"
      },
      {
        "codigo": "P293",
        "valor": "PERSISTENCIA DE LA CIRCULACION FETAL"
      },
      {
        "codigo": "P294",
        "valor": "ISQUEMIA MIOCARDICA TRANSITORIA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P298",
        "valor": "OTROS TRASTORNOS CARDIOVASCULARES ORIGINADOS EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P299",
        "valor": "TRASTORNO CARDIOVASCULAR NO ESPECIFICADO, ORIGINADO EN EL PERIODO PERINATAL"
      }
    ]
  },
  {
    "grupo": "P35 - ENFERMEDADES VIRALES CONGENITAS",
    "detalle": [
      {
        "codigo": "P350",
        "valor": "SINDROME DE RUBEOLA CONGENITA"
      },
      {
        "codigo": "P351",
        "valor": "INFECCION CITOMEGALOVIRICA CONGENITA"
      },
      {
        "codigo": "P352",
        "valor": "INFECCIONES CONGENITAS POR VIRUS DEL HERPES SIMPLE"
      },
      {
        "codigo": "P353",
        "valor": "HEPATITIS VIRAL CONGENITA"
      },
      {
        "codigo": "P358",
        "valor": "OTRAS ENFERMEDADES VIRALES CONGENITAS"
      },
      {
        "codigo": "P359",
        "valor": "ENFERMEDAD VIRAL CONGENITA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "P36 - SEPSIS BACTERIANA DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P360",
        "valor": "SEPSIS DEL RECIEN NACIDO DEBIDA A ESTREPTOCOCO DEL GRUPO B"
      },
      {
        "codigo": "P361",
        "valor": "SEPSIS DEL RECIEN NACIDO DEBIDA A OTROS ESTREPTOCOCOS Y A LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "P362",
        "valor": "SEPSIS DEL RECIEN NACIDO DEBIDA A STAPHYLOCOCCUS AUREUS"
      },
      {
        "codigo": "P363",
        "valor": "SEPSIS DEL RECIEN NACIDO DEBIDA A OTROS ESTAFILOCOCOS Y A LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "P364",
        "valor": "SEPSIS DEL RECIEN NACIDO DEBIDA A ESCHERICHIA COLI"
      },
      {
        "codigo": "P365",
        "valor": "SEPSIS DEL RECIEN NACIDO DEBIDA A ANAEROBIOS"
      },
      {
        "codigo": "P368",
        "valor": "SEPSIS DEL RECIEN NACIDO DEBIDA A OTRAS BACTERIAS"
      },
      {
        "codigo": "P369",
        "valor": "SEPSIS BACTERIANA DEL RECIEN NACIDO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P37 - OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CONGENITAS",
    "detalle": [
      {
        "codigo": "P370",
        "valor": "TUBERCULOSIS CONGENITA"
      },
      {
        "codigo": "P371",
        "valor": "TOXOPLASMOSIS CONGENITA"
      },
      {
        "codigo": "P372",
        "valor": "LISTERIOSIS CONGENITA (DISEMINADA)"
      },
      {
        "codigo": "P373",
        "valor": "PALUDISMO CONGENITO POR PLASMODIUM FALCIPARUM"
      },
      {
        "codigo": "P374",
        "valor": "OTROS PALUDISMOS CONGENITOS"
      },
      {
        "codigo": "P375",
        "valor": "CANDIDIASIS NEONATAL"
      },
      {
        "codigo": "P378",
        "valor": "OTRAS ENFERMEDADES NEONATALES INFECCIOSAS O PARASITARIAS ESPECIFICADAS"
      },
      {
        "codigo": "P379",
        "valor": "ENFERMEDAD INFECCIOSA Y PARASITARIA CONGENITA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P38 - ONFALITIS DEL RECIEN NACIDO CON O SIN HEMORRAGIA LEVE",
    "detalle": [
      {
        "codigo": "P38X",
        "valor": "ONFALITIS DEL RECIEN NACIDO CON O SIN HEMORRAGIA LEVE"
      }
    ]
  },
  {
    "grupo": "P39 - OTRAS INFECCIONES ESPECIFICAS DEL PERIODO PERINATAL",
    "detalle": [
      {
        "codigo": "P390",
        "valor": "MASTITIS INFECCIOSA NEONATAL"
      },
      {
        "codigo": "P391",
        "valor": "CONJUNTIVITIS Y DACRIOCISTITIS NEONATALES"
      },
      {
        "codigo": "P392",
        "valor": "INFECCION INTRAAMNIOTICA DEL FETO, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "P393",
        "valor": "INFECCION NEONATAL DE LAS VIAS URINARIAS"
      },
      {
        "codigo": "P394",
        "valor": "INFECCION CUTANEA NEONATAL"
      },
      {
        "codigo": "P398",
        "valor": "OTRAS INFECCIONES ESPECIFICADAS PROPIAS DEL PERIODO PERINATAL"
      },
      {
        "codigo": "P399",
        "valor": "INFECCION PROPIA DEL PERIODO PERINATAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P50 - PERDIDA DE SANGRE FETAL",
    "detalle": [
      {
        "codigo": "P500",
        "valor": "PERDIDA DE SANGRE FETAL POR VASA PREVIA"
      },
      {
        "codigo": "P501",
        "valor": "PERDIDA DE SANGRE FETAL POR RUPTURA DEL CORDON UMBILICAL"
      },
      {
        "codigo": "P502",
        "valor": "PERDIDA DE SANGRE FETAL POR LA PLACENTA"
      },
      {
        "codigo": "P503",
        "valor": "HEMORRAGIA FETAL HACIA EL OTRO GEMELO"
      },
      {
        "codigo": "P504",
        "valor": "HEMORRAGIA FETAL HACIA LA CIRCULACION MATERNA"
      },
      {
        "codigo": "P505",
        "valor": "PERDIDA DE SANGRE FETAL POR EL CORTE DEL CORDON UMBILICAL EN EL OTRO GEMELO"
      },
      {
        "codigo": "P508",
        "valor": "OTRAS PERDIDAS DE SANGRE FETAL"
      },
      {
        "codigo": "P509",
        "valor": "PERDIDA DE SANGRE FETAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P51 - HEMORRAGIA UMBILICAL DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P510",
        "valor": "HEMORRAGIA UMBILICAL MASIVA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P518",
        "valor": "OTRAS HEMORRAGIAS UMBILICALES DEL RECIEN NACIDO"
      },
      {
        "codigo": "P519",
        "valor": "HEMORRAGIA UMBILICAL DEL RECIEN NACIDO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "P52 - HEMORRAGIA INTRACRANEAL NO TRAUMATICA DEL FETO Y DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P520",
        "valor": "HEMORRAGIA INTRAVENTRICULAR (NO TRAUMATICA) GRADO 1, DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P521",
        "valor": "HEMORRAGIA INTRAVENTRICULAR (NO TRAUMATICA) GRADO 2, DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P522",
        "valor": "HEMORRAGIA INTRAVENTRICULAR (NO TRAUMATICA) GRADO 3, DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P523",
        "valor": "HEMORRAGIA INTRAVENTRICULAR (NO TRAUMATICA) DEL FETO Y DEL RECIEN NACIDO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "P524",
        "valor": "HEMORRAGIA INTRACEREBRAL (NO TRAUMATICA) DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P525",
        "valor": "HEMORRAGIA SUBARACNOIDEA (NO TRAUMATICA) DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P526",
        "valor": "HEMORRAGIA CEREBELOSA Y DE LA FOSA POSTERIOR (NO TRAUMATICA) DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P528",
        "valor": "OTRAS HEMORRAGIAS INTRACRANEALES (NO TRAUMATICAS) DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P529",
        "valor": "HEMORRAGIA INTRACRANEAL (NO TRAUMATICA) DEL FETO Y DEL RECIEN NACIDO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "P53 - ENFERMEDAD HEMORRAGICA DEL FETO Y DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P53X",
        "valor": "ENFERMEDAD HEMORRAGICA DEL FETO Y DEL RECIEN NACIDO ( VIT. K )"
      }
    ]
  },
  {
    "grupo": "P54 - OTRAS HEMORRAGIAS NEONATALES",
    "detalle": [
      {
        "codigo": "P540",
        "valor": "HEMATEMESIS NEONATAL"
      },
      {
        "codigo": "P541",
        "valor": "MELENA NEONATAL"
      },
      {
        "codigo": "P542",
        "valor": "HEMORRAGIA RECTAL NEONATAL"
      },
      {
        "codigo": "P543",
        "valor": "OTRAS HEMORRAGIAS GASTROINTESTINALES NEONATALES"
      },
      {
        "codigo": "P544",
        "valor": "HEMORRAGIA SUPRARRENAL NEONATAL"
      },
      {
        "codigo": "P545",
        "valor": "HEMORRAGIA CUTANEA NEONATAL"
      },
      {
        "codigo": "P546",
        "valor": "HEMORRAGIA VAGINAL NEONATAL"
      },
      {
        "codigo": "P548",
        "valor": "OTRAS HEMORRAGIAS FETALES Y NEONATALES ESPECIFICADAS"
      },
      {
        "codigo": "P549",
        "valor": "HEMORRAGIA NEONATAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P55 - ENFERMEDAD HEMOLITICA DEL FETO Y DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P550",
        "valor": "INCOMPATIBILIDAD RH DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P551",
        "valor": "INCOMPATIBILIDAD ABO DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P558",
        "valor": "OTRAS ENFERMEDADES HEMOLITICAS DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P559",
        "valor": "ENFERMEDAD HEMOLITICA DEL FETO Y DEL RECIEN NACIDO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P56 - HIDROPESIA FETAL DEBIDA A ENFERMEDAD HEMOLITICA",
    "detalle": [
      {
        "codigo": "P560",
        "valor": "HIDROPESIA FETAL DEBIDA A INCOMPATIBILIDAD"
      },
      {
        "codigo": "P569",
        "valor": "HIDROPESIA FETAL DEBIDA A OTRAS ENFERMEDADES HEMOLITICAS ESPECIFICADAS Y A LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "P57 - KERNICTERUS",
    "detalle": [
      {
        "codigo": "P570",
        "valor": "KERNICTERUS DEBIDO A INCOMPATIBILIDAD"
      },
      {
        "codigo": "P578",
        "valor": "KERNICTERUS DEBIDO A OTRAS CAUSAS ESPECIFICADAS"
      },
      {
        "codigo": "P579",
        "valor": "KERNICTERUS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "P58 - ICTERICIA NEONATAL DEBIDA A OTRAS HEMOLISIS EXCESIVAS",
    "detalle": [
      {
        "codigo": "P580",
        "valor": "ICTERICIA NEONATAL DEBIDA A CONTUSION"
      },
      {
        "codigo": "P581",
        "valor": "ICTERICIA NEONATAL DEBIDA A HEMORRAGIA"
      },
      {
        "codigo": "P582",
        "valor": "ICTERICIA NEONATAL DEBIDA A INFECCION"
      },
      {
        "codigo": "P583",
        "valor": "ICTERICIA NEONATAL DEBIDA A POLICITEMIA"
      },
      {
        "codigo": "P584",
        "valor": "ICTERICIA NEONATAL DEBIDA A DROGAS O TOXINAS TRANSMITIDAS POR LA MADRE O ADMINISTRADAS AL RECIEN NACIDO"
      },
      {
        "codigo": "P585",
        "valor": "ICTERICIA NEONATAL DEBIDA A DEGLUCION DE SANGRE MATERNA"
      },
      {
        "codigo": "P588",
        "valor": "ICTERICIA NEONATAL DEBIDA A OTRAS HEMOLISIS EXCESIVAS ESPECIFICADAS"
      },
      {
        "codigo": "P589",
        "valor": "ICTERICIA NEONATAL DEBIDA A HEMOLISIS EXCESIVA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "P59 - ICTERICIA NEONATAL POR OTRAS CAUSAS Y POR LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "P590",
        "valor": "ICTERICIA NEONATAL ASOCIADA CON EL PARTO ANTES DE TERMINO"
      },
      {
        "codigo": "P591",
        "valor": "SINDROME DE LA BILIS ESPESA"
      },
      {
        "codigo": "P592",
        "valor": "ICTERICIA NEONATAL DEBIDA A OTRA LESION HEPATICA ESPECIFICADA O NO"
      },
      {
        "codigo": "P593",
        "valor": "ICTERICIA NEONATAL POR INHIBIDOR DE LA LECHE MATERNA"
      },
      {
        "codigo": "P598",
        "valor": "ICTERICIA NEONATAL POR OTRAS CAUSAS ESPECIFICADAS"
      },
      {
        "codigo": "P599",
        "valor": "ICTERICIA NEONATAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P60 - COAGULACION INTRAVASCULAR DISEMINADA EN EL FETO Y EL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P60X",
        "valor": "COAGULACION INTRAVASCULAR DISEMINADA EN EL FETO Y EL RECIEN NACIDO"
      }
    ]
  },
  {
    "grupo": "P61 - OTROS TRASTORNOS HEMATOLOGICOS PERINATALES",
    "detalle": [
      {
        "codigo": "P610",
        "valor": "TROMBOCITOPENIA NEONATAL TRANSITORIA"
      },
      {
        "codigo": "P611",
        "valor": "POLICITEMIA NEONATAL"
      },
      {
        "codigo": "P612",
        "valor": "ANEMIA DE LA PREMATURIDAD"
      },
      {
        "codigo": "P613",
        "valor": "ANEMIA CONGENITA DEBIDA A PERDIDA DE SANGRE FETAL"
      },
      {
        "codigo": "P614",
        "valor": "OTRAS ANEMIAS CONGENITAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "P615",
        "valor": "NEUTROPENIA NEONATAL TRANSITORIA"
      },
      {
        "codigo": "P616",
        "valor": "OTROS TRASTORNOS NEONATALES TRANSITORIOS DE LA COAGULACION"
      },
      {
        "codigo": "P618",
        "valor": "OTROS TRASTORNOS HEMATOLOGICOS PERINATALES ESPECIFICADOS"
      },
      {
        "codigo": "P619",
        "valor": "TRASTORNO HEMATOLOGICO PERINATAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "P70 - TRASTORNOS TRANSITORIOS DEL METABOLISMO DE LOS CARBOHIDRATOS ESPECIFICOS DEL FETO Y DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P700",
        "valor": "SINDROME DEL RECIEN NACIDO DE MADRE CON DIABETES GESTACIONAL"
      },
      {
        "codigo": "P701",
        "valor": "SINDROME DEL RECIEN NACIDO DE MADRE DIABETICA"
      },
      {
        "codigo": "P702",
        "valor": "DIABETES MELLITUS NEONATAL"
      },
      {
        "codigo": "P703",
        "valor": "HIPOGLICEMIA NEONATAL YATROGENICA"
      },
      {
        "codigo": "P704",
        "valor": "OTRAS HIPOGLICEMIAS NEONATALES"
      },
      {
        "codigo": "P708",
        "valor": "OTROS TRASTORNOS TRANSITORIOS DEL METABOLISMO DE LOS CARBOHIDRATOS EN EL FETO Y EL RECIEN NACIDO"
      },
      {
        "codigo": "P709",
        "valor": "TRASTORNO TRANSITORIO NO ESPECIFICADO DEL METABOLISMO DE LOS CARBOHIDRATOS EN EL FETO Y EL RECIEN NACIDO"
      }
    ]
  },
  {
    "grupo": "P71 - TRASTORNOS NEONATALES TRANSITORIOS DEL METABOLISMO DEL CALCIO Y DEL MAGNESIO",
    "detalle": [
      {
        "codigo": "P710",
        "valor": "HIPOCALCEMIA DEL RECIEN NACIDO DEBIDA A LA LECHE DE VACA"
      },
      {
        "codigo": "P711",
        "valor": "OTRA HIPOCALCEMIA NEONATAL"
      },
      {
        "codigo": "P712",
        "valor": "HIPOMAGNESEMIA NEONATAL"
      },
      {
        "codigo": "P713",
        "valor": "TETANIA NEONATAL SIN MENCION DE DEFICIENCIA DE CALCIO O DE MAGNESIO"
      },
      {
        "codigo": "P714",
        "valor": "HIPOPARATIROIDISMO NEONATAL TRANSITORIO"
      },
      {
        "codigo": "P718",
        "valor": "OTROS TRASTORNOS NEONATALES TRANSITORIOS DEL METABOLISMO DEL CALCIO Y DEL MAGNESIO"
      },
      {
        "codigo": "P719",
        "valor": "TRASTORNO NEONATAL TRANSITORIO NO ESPECIFICADO DEL METABOLISMO DEL CALCIO Y DEL MAGNESIO"
      }
    ]
  },
  {
    "grupo": "P72 - OTROS TRASTORNOS ENDOCRINOS NEONATALES TRANSITORIOS",
    "detalle": [
      {
        "codigo": "P720",
        "valor": "BOCIO NEONATAL, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "P721",
        "valor": "HIPERTIROIDISMO NEONATAL TRANSITORIO"
      },
      {
        "codigo": "P722",
        "valor": "OTROS TRASTORNOS NEONATALES TRANSITORIOS DE LA FUNCION TIROIDEA, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "P728",
        "valor": "OTROS TRASTORNOS ENDOCRINOS NEONATALES TRANSITORIOS ESPECIFICADOS"
      },
      {
        "codigo": "P729",
        "valor": "TRASTORNO ENDOCRINO NEONATAL TRANSITORIO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "P74 - OTRAS ALTERACIONES METABOLICAS Y ELECTROLITICAS NEONATALES TRANSITORIAS",
    "detalle": [
      {
        "codigo": "P740",
        "valor": "ACIDOSIS METABOLICA TARDIA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P741",
        "valor": "DESHIDRATACION DEL RECIEN NACIDO"
      },
      {
        "codigo": "P742",
        "valor": "ALTERACIONES DEL EQUILIBRIO DEL SODIO EN EL RECIEN NACIDO"
      },
      {
        "codigo": "P743",
        "valor": "ALTERACIONES DEL EQUILIBRIO DEL POTASIO EN EL RECIEN NACIDO"
      },
      {
        "codigo": "P744",
        "valor": "OTRAS ALTERACIONES ELECTROLITICAS TRANSITORIAS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P745",
        "valor": "TIROSINEMIA TRANSITORIA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P748",
        "valor": "OTRAS ALTERACIONES METABOLICAS TRANSITORIAS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P749",
        "valor": "TRASTORNO METABOLICO TRANSITORIO DEL RECIEN NACIDO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "P75 - ILEO MECONIAL EN LA FIBROSIS QUISTICA (E84.1+)",
    "detalle": [
      {
        "codigo": "P75X",
        "valor": "ILEO MECONIAL EN LA FIBROSIS QUISTICA (E841)"
      }
    ]
  },
  {
    "grupo": "P76 - OTRAS OBSTRUCCIONES INTESTINALES DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P760",
        "valor": "SINDROME DEL TAPON DE MECONIO"
      },
      {
        "codigo": "P761",
        "valor": "ILEO TRANSITORIO DEL RECIEN NACIDO"
      },
      {
        "codigo": "P762",
        "valor": "OBSTRUCCION INTESTINAL DEBIDA A LA LECHE ESPESA"
      },
      {
        "codigo": "P768",
        "valor": "OTRAS OBSTRUCCIONES INTESTINALES ESPECIFICADAS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P769",
        "valor": "OBSTRUCCION INTESTINAL DEL RECIEN NACIDO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P77 - ENTEROCOLITIS NECROTIZANTE DEL FETO Y DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P77X",
        "valor": "ENTEROCOLITIS NECROTIZANTE DEL FETO Y DEL RECIEN NACIDO"
      }
    ]
  },
  {
    "grupo": "P78 - OTROS TRASTORNOS PERINATALES DEL SISTEMA DIGESTIVO",
    "detalle": [
      {
        "codigo": "P780",
        "valor": "PERFORACION INTESTINAL PERINATAL"
      },
      {
        "codigo": "P781",
        "valor": "OTRAS PERITONITIS NEONATALES"
      },
      {
        "codigo": "P782",
        "valor": "HEMATEMESIS Y MELENA NEONATALES DEBIDAS A LA DEGLUCION DE SANGRE MATERNA"
      },
      {
        "codigo": "P783",
        "valor": "DIARREA NEONATAL NO INFECCIOSA"
      },
      {
        "codigo": "P788",
        "valor": "OTROS TRASTORNOS PERINATALES ESPECIFICOS DEL SISTEMA DIGESTIVO"
      },
      {
        "codigo": "P789",
        "valor": "TRASTORNO PERINATAL DEL SISTEMA DIGESTIVO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "P80 - HIPOTERMIA DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P800",
        "valor": "SINDROME DEL ENFRIAMIENTO"
      },
      {
        "codigo": "P808",
        "valor": "OTRAS HIPOTERMIAS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P809",
        "valor": "HIPOTERMIA DEL RECIEN NACIDO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "P81 - OTRAS ALTERACIONES DE LA REGULACION DE LA TEMPERATURA EN EL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P810",
        "valor": "HIPERTERMIA DEL RECIEN NACIDO INDUCIDA POR LAS CONDICIONES AMBIENTALES"
      },
      {
        "codigo": "P818",
        "valor": "OTRAS ALTERACIONES ESPECIFICADAS DE LA REGULACION DE LA TEMPERATURA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P819",
        "valor": "ALTERACION NO ESPECIFICADA DE LA REGULACION DE LA TEMPERATURA EN EL RECIEN NACIDO"
      }
    ]
  },
  {
    "grupo": "P83 - OTRAS AFECCIONES DE LA PIEL ESPECIFICAS DEL FETO Y DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P830",
        "valor": "ESCLEREMA NEONATAL"
      },
      {
        "codigo": "P831",
        "valor": "ERITEMA TOXICO NEONATAL"
      },
      {
        "codigo": "P832",
        "valor": "HIDROPESIA FETAL NO DEBIDA A ENFERMEDAD HEMOLITICA"
      },
      {
        "codigo": "P833",
        "valor": "OTROS EDEMAS Y LOS NO ESPECIFICADOS, PROPIOS DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P834",
        "valor": "INGURGITACION MAMARIA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P835",
        "valor": "HIDROCELE CONGENITO"
      },
      {
        "codigo": "P836",
        "valor": "POLIPO UMBILICAL DEL RECIEN NACIDO"
      },
      {
        "codigo": "P838",
        "valor": "OTRAS AFECCIONES ESPECIFICADAS DE LA PIEL, PROPIAS DEL FETO Y DEL RECIEN NACIDO"
      },
      {
        "codigo": "P839",
        "valor": "AFECCION NO ESPECIFICADA DE LA PIEL, PROPIA DEL FETO Y DEL RECIEN NACIDO"
      }
    ]
  },
  {
    "grupo": "P90 - CONVULSIONES DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P90X",
        "valor": "CONVULSIONES DEL RN"
      }
    ]
  },
  {
    "grupo": "P91 - OTRAS ALTERACIONES CEREBRALES DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P910",
        "valor": "ISQUEMIA CEREBRAL NEONATAL"
      },
      {
        "codigo": "P911",
        "valor": "QUISTES PERIVENTRICULARES ADQUIRIDOS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P912",
        "valor": "LEUCOMALACIA CEREBRAL NEONATAL"
      },
      {
        "codigo": "P913",
        "valor": "IRRITABILIDAD CEREBRAL NEONATAL"
      },
      {
        "codigo": "P914",
        "valor": "DEPRESION CEREBRAL NEONATAL"
      },
      {
        "codigo": "P915",
        "valor": "COMA NEONATAL"
      },
      {
        "codigo": "P916",
        "valor": "ENCEFALOPATIA HIPOXICO ISQUEMICA DEL RECIEN NACIDO"
      },
      {
        "codigo": "P918",
        "valor": "OTRAS ALTERACIONES CEREBRALES ESPECIFICADAS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P919",
        "valor": "ALTERACION CEREBRAL NO ESPECIFICADA DEL RECIEN NACIDO"
      }
    ]
  },
  {
    "grupo": "P92 - PROBLEMAS DE LA INGESTION DE ALIMENTOS DEL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P920",
        "valor": "VOMITOS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P921",
        "valor": "REGURGITACION Y RUMIACION DEL RECIEN NACIDO"
      },
      {
        "codigo": "P922",
        "valor": "LENTITUD EN LA INGESTION DE ALIMENTOS DEL RECIEN NACIDO"
      },
      {
        "codigo": "P923",
        "valor": "HIPOALIMENTACION DEL RECIEN NACIDO"
      },
      {
        "codigo": "P924",
        "valor": "HIPERALIMENTACION DEL RECIEN NACIDO"
      },
      {
        "codigo": "P925",
        "valor": "DIFICULTAD NEONATAL EN LA LACTANCIA MATERNA"
      },
      {
        "codigo": "P928",
        "valor": "OTROS PROBLEMAS DE ALIMENTACION DEL RECIEN NACIDO"
      },
      {
        "codigo": "P929",
        "valor": "PROBLEMA NO ESPECIFICADO DE LA ALIMENTACION DEL RECIEN NACIDO"
      }
    ]
  },
  {
    "grupo": "P93 - REACCIONES E INTOXICACIONES DEBIDAS A DROGAS ADMINISTRADAS AL FETO Y AL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P93X",
        "valor": "REACCIONES E INTOXICACIONES DEBIDAS A DROGAS ADMINISTRADAS AL FETO Y AL RECIEN N"
      }
    ]
  },
  {
    "grupo": "P94 - TRASTORNOS DEL TONO MUSCULAR EN EL RECIEN NACIDO",
    "detalle": [
      {
        "codigo": "P940",
        "valor": "MIASTENIA GRAVE NEONATAL TRANSITORIA"
      },
      {
        "codigo": "P941",
        "valor": "HIPERTONIA CONGENITA"
      },
      {
        "codigo": "P942",
        "valor": "HIPOTONIA CONGENITA"
      },
      {
        "codigo": "P948",
        "valor": "OTROS TRASTORNOS DEL TONO MUSCULAR EN EL RECIEN NACIDO"
      },
      {
        "codigo": "P949",
        "valor": "TRASTORNO NO ESPECIFICADO DEL TONO MUSCULAR EN EL RECIEN NACIDO"
      }
    ]
  },
  {
    "grupo": "P95 - MUERTE FETAL DE CAUSA NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "P95X",
        "valor": "MUERTE FETAL (NACIDO MUERTO)"
      }
    ]
  },
  {
    "grupo": "P96 - OTRAS AFECCIONES ORIGINADAS EN EL PERIODO PERINATAL",
    "detalle": [
      {
        "codigo": "P960",
        "valor": "INSUFICIENCIA RENAL CONGENITA"
      },
      {
        "codigo": "P961",
        "valor": "SINTOMAS NEONATALES DE ABSTINENCIA POR DROGADICCION MATERNA"
      },
      {
        "codigo": "P962",
        "valor": "SINTOMAS DE ABSTINENCIA POR EL USO TERAPEUTICO DE DROGAS EN EL RECIEN NACIDO"
      },
      {
        "codigo": "P963",
        "valor": "AMPLITUD DE LAS SUTURAS CRANEALES DEL RECIEN NACIDO"
      },
      {
        "codigo": "P964",
        "valor": "TERMINACION DEL EMBARAZO, FETO Y RECIEN NACIDO"
      },
      {
        "codigo": "P965",
        "valor": "COMPLICACIONES DE PROCEDIMIENTOS INTRAUTERINOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "P968",
        "valor": "OTRAS AFECCIONES ESPECIFICADAS ORIGINADAS EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "P969",
        "valor": "AFECCION NO ESPECIFICADA ORIGINADA EN EL PERIODO PERINATAL"
      }
    ]
  },
  {
    "grupo": "Q00 - ANENCEFALIA Y MALFORMACIONES CONGENITAS SIMILARES",
    "detalle": [
      {
        "codigo": "Q000",
        "valor": "ANENCEFALIA"
      },
      {
        "codigo": "Q001",
        "valor": "CRANEORRAQUISQUISIS"
      },
      {
        "codigo": "Q002",
        "valor": "INIENCEFALIA"
      }
    ]
  },
  {
    "grupo": "Q01 - ENCEFALOCELE",
    "detalle": [
      {
        "codigo": "Q010",
        "valor": "ENCEFALOCELE FRONTAL"
      },
      {
        "codigo": "Q011",
        "valor": "ENCEFALOCELE NASOFRONTAL"
      },
      {
        "codigo": "Q012",
        "valor": "ENCEFALOCELE OCCIPITAL"
      },
      {
        "codigo": "Q018",
        "valor": "ENCEFALOCELE DE OTROS SITIOS"
      },
      {
        "codigo": "Q019",
        "valor": "ENCEFALOCELE, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Q02 - MICROCEFALIA",
    "detalle": [
      {
        "codigo": "Q02X",
        "valor": "MICROCEFALIA"
      }
    ]
  },
  {
    "grupo": "Q03 - HIDROCEFALO CONGENITO",
    "detalle": [
      {
        "codigo": "Q030",
        "valor": "MALFORMACIONES DEL ACUEDUCTO DE SILVIO"
      },
      {
        "codigo": "Q0301",
        "valor": "ANOMALIA DEL ACUEDUCTO DE SILVIO"
      },
      {
        "codigo": "Q0302",
        "valor": "ESTENOSIS DEL ACUEDUCTO DE SILVIO"
      },
      {
        "codigo": "Q0303",
        "valor": "OBSTRUCCION CONGENITA DEL ACUEDUCTO DE SILVIO"
      },
      {
        "codigo": "Q031",
        "valor": "ATRESIA DE LOS AGUJEROS DE MAGENDIE Y DE LUSCHKA"
      },
      {
        "codigo": "Q0311",
        "valor": "SINDROME DE DANDY–WALKER"
      },
      {
        "codigo": "Q038",
        "valor": "OTROS HIDROCEFALOS CONGENITOS"
      },
      {
        "codigo": "Q039",
        "valor": "HIDROCEFALO CONGENITO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Q04 - OTRAS MALFORMACIONES CONGENITAS DEL ENCEFALO",
    "detalle": [
      {
        "codigo": "Q040",
        "valor": "MALFORMACIONES CONGENITAS DEL CUERPO CALLOSO"
      },
      {
        "codigo": "Q041",
        "valor": "ARRINENCEFALIA"
      },
      {
        "codigo": "Q042",
        "valor": "HOLOPROSENCEFALIA"
      },
      {
        "codigo": "Q043",
        "valor": "OTRAS ANOMALIAS HIPOPLASICAS DEL ENCEFALO"
      },
      {
        "codigo": "Q044",
        "valor": "DISPLASIA OPTICOSEPTAL"
      },
      {
        "codigo": "Q045",
        "valor": "MEGALENCEFALIA"
      },
      {
        "codigo": "Q046",
        "valor": "QUISTES CEREBRALES CONGENITOS"
      },
      {
        "codigo": "Q048",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL ENCEFALO, ESPECIFICADAS"
      },
      {
        "codigo": "Q049",
        "valor": "MALFORMACION CONGENITA DEL ENCEFALO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q05 - ESPINA BIFIDA",
    "detalle": [
      {
        "codigo": "Q050",
        "valor": "ESPINA BIFIDA CERVICAL CON HIDROCEFALO"
      },
      {
        "codigo": "Q051",
        "valor": "ESPINA BIFIDA TORACICA CON HIDROCEFALO"
      },
      {
        "codigo": "Q052",
        "valor": "ESPINA BIFIDA LUMBAR CON HIDROCEFALO"
      },
      {
        "codigo": "Q053",
        "valor": "ESPINA BIFIDA SACRA CON HIDROCEFALO"
      },
      {
        "codigo": "Q054",
        "valor": "ESPINA BIFIDA CON HIDROCEFALO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "Q055",
        "valor": "ESPINA BIFIDA CERVICAL SIN HIDROCEFALO"
      },
      {
        "codigo": "Q056",
        "valor": "ESPINA BIFIDA TORACICA SIN HIDROCEFALO"
      },
      {
        "codigo": "Q057",
        "valor": "ESPINA BIFIDA LUMBAR SIN HIDROCEFALO"
      },
      {
        "codigo": "Q058",
        "valor": "ESPINA BIFIDA SACRA SIN HIDROCEFALO"
      },
      {
        "codigo": "Q059",
        "valor": "ESPINA BIFIDA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q06 - OTRAS MALFORMACIONES CONGENITAS DE LA MEDULA ESPINAL",
    "detalle": [
      {
        "codigo": "Q060",
        "valor": "AMIELIA"
      },
      {
        "codigo": "Q061",
        "valor": "HIPOPLASIA Y DISPLASIA DE LA MEDULA ESPINAL"
      },
      {
        "codigo": "Q062",
        "valor": "DIASTEMATOMIELIA"
      },
      {
        "codigo": "Q063",
        "valor": "OTRAS ANOMALIAS CONGENITAS DE LA COLA DE CABALLO"
      },
      {
        "codigo": "Q064",
        "valor": "HIDROMIELIA"
      },
      {
        "codigo": "Q068",
        "valor": "OTRAS MALFORMACIONES CONGENITAS ESPECIFICADAS DE LA MEDULA ESPINAL"
      },
      {
        "codigo": "Q069",
        "valor": "MALFORMACION CONGENITA DE LA MEDULA ESPINAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q07 - OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA NERVIOSO",
    "detalle": [
      {
        "codigo": "Q070",
        "valor": "SINDROME DE ARNOLD-CHIARI"
      },
      {
        "codigo": "Q078",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA NERVIOSO, ESPECIFICADAS"
      },
      {
        "codigo": "Q079",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA NERVIOSO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q10 - MALFORMACIONES CONGENITAS DE LOS PARPADOS, DEL APARATO LAGRIMAL Y DE LA ORBITA",
    "detalle": [
      {
        "codigo": "Q100",
        "valor": "BLEFAROPTOSIS CONGENITA"
      },
      {
        "codigo": "Q101",
        "valor": "ECTROPION CONGENITO"
      },
      {
        "codigo": "Q102",
        "valor": "ENTROPION CONGENITO"
      },
      {
        "codigo": "Q103",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LOS PARPADOS"
      },
      {
        "codigo": "Q104",
        "valor": "AUSENCIA Y AGENESIA DEL APARATO LAGRIMAL"
      },
      {
        "codigo": "Q105",
        "valor": "ESTENOSIS Y ESTRECHEZ CONGENITAS DEL CONDUCTO LAGRIMAL"
      },
      {
        "codigo": "Q106",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL APARATO LAGRIMAL"
      },
      {
        "codigo": "Q107",
        "valor": "MALFORMACION CONGENITA DE LA ORBITA"
      }
    ]
  },
  {
    "grupo": "Q11 - ANOFTALMIA, MICROFTALMIA Y MACROFTALMIA",
    "detalle": [
      {
        "codigo": "Q110",
        "valor": "GLOBO OCULAR QUISTICO"
      },
      {
        "codigo": "Q111",
        "valor": "OTRAS ANOFTALMIAS"
      },
      {
        "codigo": "Q112",
        "valor": "MICROFTALMIA"
      },
      {
        "codigo": "Q113",
        "valor": "MACROFTALMIA"
      }
    ]
  },
  {
    "grupo": "Q12 - MALFORMACIONES CONGENITAS DEL CRISTALINO",
    "detalle": [
      {
        "codigo": "Q120",
        "valor": "CATARATA CONGENITA"
      },
      {
        "codigo": "Q121",
        "valor": "DESPLAZAMIENTO CONGENITO DEL CRISTALINO"
      },
      {
        "codigo": "Q122",
        "valor": "COLOBOMA DEL CRISTALINO"
      },
      {
        "codigo": "Q123",
        "valor": "AFAQUIA CONGENITA"
      },
      {
        "codigo": "Q124",
        "valor": "ESFEROFAQUIA"
      },
      {
        "codigo": "Q128",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL CRISTALINO"
      },
      {
        "codigo": "Q129",
        "valor": "MALFORMACION CONGENITA DEL CRISTALINO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q13 - MALFORMACIONES CONGENITAS DEL SEGMENTO ANTERIOR DEL OJO",
    "detalle": [
      {
        "codigo": "Q130",
        "valor": "COLOBOMA DEL IRIS"
      },
      {
        "codigo": "Q131",
        "valor": "AUSENCIA DEL IRIS"
      },
      {
        "codigo": "Q132",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL IRIS"
      },
      {
        "codigo": "Q133",
        "valor": "OPACIDAD CORNEAL CONGENITA"
      },
      {
        "codigo": "Q134",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA CORNEA"
      },
      {
        "codigo": "Q135",
        "valor": "ESCLEROTICA AZUL"
      },
      {
        "codigo": "Q138",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL SEGMENTO ANTERIOR DEL OJO"
      },
      {
        "codigo": "Q139",
        "valor": "MALFORMACION CONGENITA DEL SEGMENTO ANTERIOR DEL OJO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q14 - MALFORMACIONES CONGENITAS DEL SEGMENTO POSTERIOR DEL OJO",
    "detalle": [
      {
        "codigo": "Q140",
        "valor": "MALFORMACION CONGENITA DEL HUMOR VITREO"
      },
      {
        "codigo": "Q141",
        "valor": "MALFORMACION CONGENITA DE LA RETINA"
      },
      {
        "codigo": "Q142",
        "valor": "MALFORMACION CONGENITA DEL DISCO OPTICO"
      },
      {
        "codigo": "Q143",
        "valor": "MALFORMACION CONGENITA DE LA COROIDES"
      },
      {
        "codigo": "Q148",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL SEGMENTO POSTERIOR DEL OJO"
      },
      {
        "codigo": "Q149",
        "valor": "MALFORMACION CONGENITA DEL SEGMENTO POSTERIOR DEL OJO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q15 - OTRAS MALFORMACIONES CONGENITAS DEL OJO",
    "detalle": [
      {
        "codigo": "Q150",
        "valor": "GLAUCOMA CONGENITO"
      },
      {
        "codigo": "Q158",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL OJO, ESPECIFICADAS"
      },
      {
        "codigo": "Q159",
        "valor": "MALFORMACIONES CONGENITAS DEL OJO, NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Q16 - MALFORMACIONES CONGENITAS DEL OIDO QUE CAUSAN ALTERACION DE LA AUDICIO",
    "detalle": [
      {
        "codigo": "Q160",
        "valor": "AUSENCIA CONGENITA DEL PABELLON (DE LA OREJA)"
      },
      {
        "codigo": "Q161",
        "valor": "AUSENCIA CONGENITA, ATRESIA O ESTRECHEZ DEL CONDUCTO AUDITIVO (EXTERNO)"
      },
      {
        "codigo": "Q162",
        "valor": "AUSENCIA DE LA TROMPA DE EUSTAQUIO"
      },
      {
        "codigo": "Q163",
        "valor": "MALFORMACION CONGENITA DE LOS HUESECILLOS DEL OIDO"
      },
      {
        "codigo": "Q164",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL OIDO MEDIO"
      },
      {
        "codigo": "Q165",
        "valor": "MALFORMACION CONGENITA DEL OIDO INTERNO"
      },
      {
        "codigo": "Q169",
        "valor": "MALFORMACION CONGENITA DEL OIDO QUE CAUSA ALTERACION DE LA AUDICION, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Q17 - OTRAS MALFORMACIONES CONGENITAS DEL OIDO",
    "detalle": [
      {
        "codigo": "Q170",
        "valor": "OREJA SUPERNUMERARIA"
      },
      {
        "codigo": "Q171",
        "valor": "MACROTIA"
      },
      {
        "codigo": "Q172",
        "valor": "MICROTIA"
      },
      {
        "codigo": "Q173",
        "valor": "OTRAS DEFORMIDADES DEL PABELLON AURICULAR"
      },
      {
        "codigo": "Q174",
        "valor": "ANOMALIA DE LA POSICION DE LA OREJA"
      },
      {
        "codigo": "Q175",
        "valor": "OREJA PROMINENTE"
      },
      {
        "codigo": "Q178",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL OIDO, ESPECIFICADAS"
      },
      {
        "codigo": "Q179",
        "valor": "MALFORMACION CONGENITA DEL OIDO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q18 - OTRAS MALFORMACIONES CONGENITAS DE LA CARA Y DEL CUELLO",
    "detalle": [
      {
        "codigo": "Q180",
        "valor": "SENO, FISTULA O QUISTE DE LA HENDIDURA BRANQUIAL"
      },
      {
        "codigo": "Q181",
        "valor": "SENO Y QUISTE PREAURICULAR"
      },
      {
        "codigo": "Q182",
        "valor": "OTRAS MALFORMACIONES DE LAS HENDIDURAS BRANQUIALES"
      },
      {
        "codigo": "Q183",
        "valor": "PTERIGION DEL CUELLO"
      },
      {
        "codigo": "Q184",
        "valor": "MACROSTOMIA"
      },
      {
        "codigo": "Q185",
        "valor": "MICROSTOMIA"
      },
      {
        "codigo": "Q186",
        "valor": "MACROQUEILIA"
      },
      {
        "codigo": "Q187",
        "valor": "MICROQUEILIA"
      },
      {
        "codigo": "Q188",
        "valor": "OTRAS MALFORMACIONES CONGENITAS ESPECIFICADAS DE CARA Y CUELLO"
      },
      {
        "codigo": "Q189",
        "valor": "MALFORMACION CONGENITA DE LA CARA Y DEL CUELLO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q20 - MALFORMACIONES CONGENITAS DE LAS CAMARAS CARDIACAS Y SUS CONEXIONES",
    "detalle": [
      {
        "codigo": "Q200",
        "valor": "TRONCO ARTERIOSO COMUN"
      },
      {
        "codigo": "Q201",
        "valor": "TRANSPOSICION DE LOS GRANDES VASOS EN VENTRICULO DERECHO"
      },
      {
        "codigo": "Q202",
        "valor": "TRANSPOSICION DE LOS GRANDES VASOS EN VENTRICULO IZQUIERDO"
      },
      {
        "codigo": "Q203",
        "valor": "DISCORDANCIA DE LA CONEXION VENTRICULOARTERIAL"
      },
      {
        "codigo": "Q204",
        "valor": "VENTRICULO CON DOBLE ENTRADA"
      },
      {
        "codigo": "Q205",
        "valor": "DISCORDANCIA DE LA CONEXION AURICULOVENTRICULAR"
      },
      {
        "codigo": "Q206",
        "valor": "ISOMERISMO DE LOS APENDICES AURICULARES"
      },
      {
        "codigo": "Q208",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LAS CAMARAS CARDIACAS Y SUS CONEXIONES"
      },
      {
        "codigo": "Q209",
        "valor": "MALFORMACION CONGENITA DE LAS CAMARAS CARDIACAS Y SUS CONEXIONES, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q21 - MALFORMACIONES CONGENITAS DE LOS TABIQUES CARDIACOS",
    "detalle": [
      {
        "codigo": "Q210",
        "valor": "DEFECTO DEL TABIQUE VENTRICULAR"
      },
      {
        "codigo": "Q211",
        "valor": "DEFECTO DEL TABIQUE AURICULAR"
      },
      {
        "codigo": "Q212",
        "valor": "DEFECTO DEL TABIQUE AURICULOVENTRICULAR"
      },
      {
        "codigo": "Q213",
        "valor": "TETRALOGIA DE FALLOT"
      },
      {
        "codigo": "Q214",
        "valor": "DEFECTO DEL TABIQUE AORTOPULMONAR"
      },
      {
        "codigo": "Q218",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LOS TABIQUES CARDIACOS"
      },
      {
        "codigo": "Q219",
        "valor": "MALFORMACION CONGENITA DEL TABIQUE CARDIACO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q22 - MALFORMACIONES CONGENITAS DE LAS VALVULAS PULMONAR Y TRICUSPIDE",
    "detalle": [
      {
        "codigo": "Q220",
        "valor": "ATRESIA DE LA VALVULA PULMONAR"
      },
      {
        "codigo": "Q221",
        "valor": "ESTENOSIS CONGENITA DE LA VALVULA PULMONAR"
      },
      {
        "codigo": "Q222",
        "valor": "INSUFICIENCIA CONGENITA DE LA VALVULA PULMONAR"
      },
      {
        "codigo": "Q223",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA VALVULA PULMONAR"
      },
      {
        "codigo": "Q224",
        "valor": "ESTENOSIS CONGENITA DE LA VALVULA TRICUSPIDE"
      },
      {
        "codigo": "Q225",
        "valor": "ANOMALIA DE EBSTEIN"
      },
      {
        "codigo": "Q226",
        "valor": "SINDROME DE HIPOPLASIA DEL CORAZON DERECHO"
      },
      {
        "codigo": "Q228",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA VALVULA TRICUSPIDE"
      },
      {
        "codigo": "Q229",
        "valor": "MALFORMACION CONGENITA DE LA VALVULA TRICUSPIDE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q23 - MALFORMACIONES CONGENITAS DE LAS VALVULAS AORTICA Y MITRAL",
    "detalle": [
      {
        "codigo": "Q230",
        "valor": "ESTENOSIS CONGENITA DE LA VALVULA AORTICA"
      },
      {
        "codigo": "Q231",
        "valor": "INSUFICIENCIA CONGENITA DE LA VALVULA AORTICA"
      },
      {
        "codigo": "Q232",
        "valor": "ESTENOSIS MITRAL CONGENITA"
      },
      {
        "codigo": "Q233",
        "valor": "INSUFICIENCIA MITRAL CONGENITA"
      },
      {
        "codigo": "Q234",
        "valor": "SINDROME DE HIPOPLASIA DEL CORAZON IZQUIERDO"
      },
      {
        "codigo": "Q238",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LAS VALVULAS AORTICA Y MITRAL"
      },
      {
        "codigo": "Q239",
        "valor": "MALFORMACION CONGENITA DE LAS VALVULAS AORTICA Y MITRAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q24 - OTRAS MALFORMACIONES CONGENITAS DEL CORAZON",
    "detalle": [
      {
        "codigo": "Q240",
        "valor": "DEXTROCARDIA"
      },
      {
        "codigo": "Q241",
        "valor": "LEVOCARDIA"
      },
      {
        "codigo": "Q242",
        "valor": "CORAZON TRIAURICULAR"
      },
      {
        "codigo": "Q243",
        "valor": "ESTENOSIS DEL INFUNDIBULO PULMONAR"
      },
      {
        "codigo": "Q244",
        "valor": "ESTENOSIS SUBAORTICA CONGENITA"
      },
      {
        "codigo": "Q245",
        "valor": "MALFORMACION DE LOS VASOS CORONARIOS"
      },
      {
        "codigo": "Q246",
        "valor": "BLOQUEO CARDIACO CONGENITO"
      },
      {
        "codigo": "Q248",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL CORAZON, ESPECIFICADAS"
      },
      {
        "codigo": "Q249",
        "valor": "MALFORMACION CONGENITA DEL CORAZON, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q25 - MALFORMACIONES CONGENITAS DE LAS GRANDES ARTERIAS",
    "detalle": [
      {
        "codigo": "Q250",
        "valor": "CONDUCTO ARTERIOSO PERSISTENTE"
      },
      {
        "codigo": "Q251",
        "valor": "COARTACION DE LA AORTA"
      },
      {
        "codigo": "Q252",
        "valor": "ATRESIA DE LA AORTA"
      },
      {
        "codigo": "Q253",
        "valor": "ESTENOSIS DE LA AORTA"
      },
      {
        "codigo": "Q254",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA AORTA"
      },
      {
        "codigo": "Q255",
        "valor": "ATRESIA DE LA ARTERIA PULMONAR"
      },
      {
        "codigo": "Q256",
        "valor": "ESTENOSIS DE LA ARTERIA PULMONAR"
      },
      {
        "codigo": "Q257",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA ARTERIA PULMONAR"
      },
      {
        "codigo": "Q258",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LAS GRANDES ARTERIAS"
      },
      {
        "codigo": "Q259",
        "valor": "MALFORMACION CONGENITA DE LAS GRANDES ARTERIAS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q26 - MALFORMACIONES CONGENITAS DE LAS GRANDES VENAS",
    "detalle": [
      {
        "codigo": "Q260",
        "valor": "ESTENOSIS CONGENITA DE LA VENA CAVA"
      },
      {
        "codigo": "Q261",
        "valor": "PERSISTENCIA DE LA VENA CAVA SUPERIOR IZQUIERDA"
      },
      {
        "codigo": "Q262",
        "valor": "CONEXION ANOMALA TOTAL DE LAS VENAS PULMONARES"
      },
      {
        "codigo": "Q263",
        "valor": "CONEXION ANOMALA PARCIAL DE LAS VENAS PULMONARES"
      },
      {
        "codigo": "Q264",
        "valor": "CONEXION ANOMALA DE LAS VENAS PULMONARES, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "Q265",
        "valor": "CONEXION ANOMALA DE LA VENA PORTA"
      },
      {
        "codigo": "Q266",
        "valor": "FISTULA ARTERIA HEPATICA-VENA PORTA"
      },
      {
        "codigo": "Q268",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LAS GRANDES VENAS"
      },
      {
        "codigo": "Q269",
        "valor": "MALFORMACION CONGENITA DE LAS GRANDES VENAS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q27 - OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA VASCULAR PERIFERICO",
    "detalle": [
      {
        "codigo": "Q270",
        "valor": "AUSENCIA E HIPOPLASIA CONGENITA DE LA ARTERIA UMBILICAL"
      },
      {
        "codigo": "Q271",
        "valor": "ESTENOSIS CONGENITA DE LA ARTERIA RENAL"
      },
      {
        "codigo": "Q272",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA ARTERIA RENAL"
      },
      {
        "codigo": "Q273",
        "valor": "MALFORMACION ARTERIOVENOSA PERIFERICA"
      },
      {
        "codigo": "Q274",
        "valor": "FLEBECTASIA CONGENITA"
      },
      {
        "codigo": "Q278",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA VASCULAR PERIFERICO, ESPECIFICADAS"
      },
      {
        "codigo": "Q279",
        "valor": "MALFORMACION CONGENITA DEL SISTEMA VASCULAR PERIFERICO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q28 - OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA CIRCULATORIO",
    "detalle": [
      {
        "codigo": "Q280",
        "valor": "MALFORMACION ARTERIOVENOSA DE LOS VASOS PRECEREBRALES"
      },
      {
        "codigo": "Q281",
        "valor": "OTRAS MALFORMACIONES DE LOS VASOS PRECEREBRALES"
      },
      {
        "codigo": "Q282",
        "valor": "MALFORMACION ARTERIOVENOSA DE LOS VASOS CEREBRALES"
      },
      {
        "codigo": "Q283",
        "valor": "OTRAS MALFORMACIONES DE LOS VASOS CEREBRALES"
      },
      {
        "codigo": "Q288",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA CIRCULATORIO, ESPECIFICADAS"
      },
      {
        "codigo": "Q289",
        "valor": "MALFORMACION CONGENITA DEL SISTEMA CIRCULATORIO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q30 - MALFORMACIONES CONGENITAS DE LA NARIZ",
    "detalle": [
      {
        "codigo": "Q300",
        "valor": "ATRESIA DE LAS COANAS"
      },
      {
        "codigo": "Q301",
        "valor": "AGENESIA O HIPOPLASIA DE LA NARIZ"
      },
      {
        "codigo": "Q302",
        "valor": "HENDIDURA, FISURA O MUESCA DE LA NARIZ"
      },
      {
        "codigo": "Q303",
        "valor": "PERFORACION CONGENITA DEL TABIQUE NASAL"
      },
      {
        "codigo": "Q308",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA NARIZ"
      },
      {
        "codigo": "Q309",
        "valor": "MALFORMACION CONGENITA DE LA NARIZ, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q31 - MALFORMACIONES CONGENITAS DE LA LARINGE",
    "detalle": [
      {
        "codigo": "Q310",
        "valor": "PTERIGION DE LA LARINGE"
      },
      {
        "codigo": "Q311",
        "valor": "ESTENOSIS SUBGLOTICA CONGENITA"
      },
      {
        "codigo": "Q312",
        "valor": "HIPOPLASIA LARINGEA"
      },
      {
        "codigo": "Q313",
        "valor": "LARINGOCELE"
      },
      {
        "codigo": "Q314",
        "valor": "ESTRIDOR LARINGEO CONGENITO"
      },
      {
        "codigo": "Q315",
        "valor": "LARINGOMALASIA CONGENITA"
      },
      {
        "codigo": "Q318",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA LARINGE"
      },
      {
        "codigo": "Q319",
        "valor": "MALFORMACION CONGENITA DE LA LARINGE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q32 - MALFORMACIONES CONGENITAS DE LA TRAQUEA Y DE LOS BRONQUIOS",
    "detalle": [
      {
        "codigo": "Q320",
        "valor": "TRAQUEOMALACIA CONGENITA"
      },
      {
        "codigo": "Q321",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA TRAQUEA"
      },
      {
        "codigo": "Q322",
        "valor": "BRONCOMALACIA CONGENITA"
      },
      {
        "codigo": "Q323",
        "valor": "ESTENOSIS CONGENITA DE LOS BRONQUIOS"
      },
      {
        "codigo": "Q324",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LOS BRONQUIOS"
      }
    ]
  },
  {
    "grupo": "Q33 - MALFORMACIONES CONGENITAS DEL PULMON",
    "detalle": [
      {
        "codigo": "Q330",
        "valor": "QUISTE PULMONAR CONGENITO"
      },
      {
        "codigo": "Q331",
        "valor": "LOBULO PULMONAR SUPERNUMERARIO"
      },
      {
        "codigo": "Q332",
        "valor": "SECUESTRO DEL PULMON"
      },
      {
        "codigo": "Q333",
        "valor": "AGENESIA DEL PULMON"
      },
      {
        "codigo": "Q334",
        "valor": "BRONQUIECTASIA CONGENITA"
      },
      {
        "codigo": "Q335",
        "valor": "TEJIDO ECTOPICO EN EL PULMON"
      },
      {
        "codigo": "Q336",
        "valor": "HIPOPLASIA Y DISPLASIA PULMONAR"
      },
      {
        "codigo": "Q338",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL PULMON"
      },
      {
        "codigo": "Q339",
        "valor": "MALFORMACION CONGENITA DEL PULMON, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q34 - OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA RESPIRATORIO",
    "detalle": [
      {
        "codigo": "Q340",
        "valor": "ANOMALIA DE LA PLEURA"
      },
      {
        "codigo": "Q341",
        "valor": "QUISTE CONGENITO DEL MEDIASTINO"
      },
      {
        "codigo": "Q348",
        "valor": "OTRAS MALFORMACIONES CONGENITAS ESPECIFICADAS DEL SISTEMA RESPIRATORIO"
      },
      {
        "codigo": "Q349",
        "valor": "MALFORMACION CONGENITA DEL SISTEMA RESPIRATORIO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q35 - FISURA DEL PALADAR",
    "detalle": [
      {
        "codigo": "Q350",
        "valor": "FISURA DEL PALADAR DURO, BILATERAL"
      },
      {
        "codigo": "Q351",
        "valor": "FISURA DEL PALADAR DURO"
      },
      {
        "codigo": "Q352",
        "valor": "FISURA DEL PALADAR BLANDO, BILATERAL"
      },
      {
        "codigo": "Q353",
        "valor": "FISURA DEL PALADAR BLANDO"
      },
      {
        "codigo": "Q354",
        "valor": "FISURA DEL PALADAR DURO Y DEL PALADAR BLANDO, BILATERAL"
      },
      {
        "codigo": "Q355",
        "valor": "FISURA DEL PALADAR DURO Y DEL PALADAR BLANDO"
      },
      {
        "codigo": "Q356",
        "valor": "FISURA DEL PALADAR, LINEA MEDIA"
      },
      {
        "codigo": "Q357",
        "valor": "FISURA DE LA UVULA"
      },
      {
        "codigo": "Q358",
        "valor": "FISURA DEL PALADAR, BILATERAL SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "Q359",
        "valor": "FISURA DEL PALADAR, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Q36 - LABIO LEPORINO",
    "detalle": [
      {
        "codigo": "Q360",
        "valor": "LABIO LEPORINO, BILATERAL"
      },
      {
        "codigo": "Q361",
        "valor": "LABIO LEPORINO, LINEA MEDIA"
      },
      {
        "codigo": "Q369",
        "valor": "LABIO LEPORINO, UNILATERAL"
      }
    ]
  },
  {
    "grupo": "Q37 - FISURA DEL PALADAR CON LABIO LEPORINO",
    "detalle": [
      {
        "codigo": "Q370",
        "valor": "FISURA DEL PALADAR DURO CON LABIO LEPORINO BILATERAL"
      },
      {
        "codigo": "Q371",
        "valor": "FISURA DEL PALADAR DURO CON LABIO LEPORINO UNILATERAL"
      },
      {
        "codigo": "Q372",
        "valor": "FISURA DEL PALADAR BLANDO CON LABIO LEPORINO BILATERAL"
      },
      {
        "codigo": "Q373",
        "valor": "FISURA DEL PALADAR BLANDO CON LABIO LEPORINO UNILATERAL"
      },
      {
        "codigo": "Q374",
        "valor": "FISURA DEL PALADAR DURO Y DEL PALADAR BLANDO CON LABIO LEPORINO BILATERAL"
      },
      {
        "codigo": "Q375",
        "valor": "FISURA DEL PALADAR DURO Y DEL PALADAR BLANDO CON LABIO LEPORINO UNILATERAL"
      },
      {
        "codigo": "Q378",
        "valor": "FISURA DEL PALADAR CON LABIO LEPORINO BILATERAL, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "Q379",
        "valor": "FISURA DEL PALADAR CON LABIO LEPORINO UNILATERAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Q38 - OTRAS MALFORMACIONES CONGENITAS DE LA LENGUA, DE LA BOCA Y DE LA FARIN",
    "detalle": [
      {
        "codigo": "Q380",
        "valor": "MALFORMACIONES CONGENITAS DE LOS LABIOS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Q381",
        "valor": "ANQUILOGLOSIA"
      },
      {
        "codigo": "Q382",
        "valor": "MACROGLOSIA"
      },
      {
        "codigo": "Q383",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA LENGUA"
      },
      {
        "codigo": "Q384",
        "valor": "MALFORMACIONES CONGENITAS DE LAS GLANDULAS Y DE LOS CONDUCTOS SALIVALES"
      },
      {
        "codigo": "Q385",
        "valor": "MALFORMACIONES CONGENITAS DEL PALADAR, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Q386",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA BOCA"
      },
      {
        "codigo": "Q387",
        "valor": "DIVERTICULO FARINGEO"
      },
      {
        "codigo": "Q388",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA FARINGE"
      }
    ]
  },
  {
    "grupo": "Q39 - MALFORMACIONES CONGENITAS DEL ESOFAGO",
    "detalle": [
      {
        "codigo": "Q390",
        "valor": "ATRESIA DEL ESOFAGO SIN MENCION DE FISTULA"
      },
      {
        "codigo": "Q391",
        "valor": "ATRESIA DEL ESOFAGO CON FISTULA TRAQUEOESOFAGICA"
      },
      {
        "codigo": "Q392",
        "valor": "FISTULA TRAQUEOESOFAGICA CONGENITA SIN MENCION DE ATRESIA"
      },
      {
        "codigo": "Q393",
        "valor": "ESTRECHEZ O ESTENOSIS CONGENITA DEL ESOFAGO"
      },
      {
        "codigo": "Q394",
        "valor": "PTERIGION DEL ESOFAGO"
      },
      {
        "codigo": "Q395",
        "valor": "DILATACION CONGENITA DEL ESOFAGO"
      },
      {
        "codigo": "Q396",
        "valor": "DIVERTICULO DEL ESOFAGO"
      },
      {
        "codigo": "Q398",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL ESOFAGO"
      },
      {
        "codigo": "Q399",
        "valor": "MALFORMACION CONGENITA DEL ESOFAGO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q40 - OTRAS MALFORMACIONES CONGENITAS DE LA PARTE SUPERIOR DEL TUBO DIGESTIVO",
    "detalle": [
      {
        "codigo": "Q400",
        "valor": "ESTENOSIS HIPERTROFICA CONGENITA DEL PILORO"
      },
      {
        "codigo": "Q401",
        "valor": "HERNIA HIATAL CONGENITA"
      },
      {
        "codigo": "Q402",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL ESTOMAGO, ESPECIFICADAS"
      },
      {
        "codigo": "Q403",
        "valor": "MALFORMACION CONGENITA DEL ESTOMAGO, NO ESPECIFICADA"
      },
      {
        "codigo": "Q408",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA PARTE SUPERIOR DEL TUBO DIGESTIVO"
      },
      {
        "codigo": "Q409",
        "valor": "MALFORMACION CONGENITA DE LA PARTE SUPERIOR DEL TUBO DIGESTIVO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q41 - AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL INTESTINO DELGADO",
    "detalle": [
      {
        "codigo": "Q410",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL DUODENO"
      },
      {
        "codigo": "Q411",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL YEYUNO"
      },
      {
        "codigo": "Q412",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL ILEON"
      },
      {
        "codigo": "Q418",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DE OTRAS PARTES ESPECIFICADAS DEL INTESTINO DELGADO"
      },
      {
        "codigo": "Q419",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL INTESTINO DELGADO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q42 - AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL INTESTINO GRUESO",
    "detalle": [
      {
        "codigo": "Q420",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL RECTO, CON FISTULA"
      },
      {
        "codigo": "Q421",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL RECTO, SIN FISTULA"
      },
      {
        "codigo": "Q422",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL ANO, CON FISTULA"
      },
      {
        "codigo": "Q423",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL ANO, SIN FISTULA"
      },
      {
        "codigo": "Q428",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DE OTRAS PARTES DEL INTESTINO GRUESO"
      },
      {
        "codigo": "Q429",
        "valor": "AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL INTESTINO GRUESO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q43 - OTRAS MALFORMACIONES CONGENITAS DEL INTESTINO",
    "detalle": [
      {
        "codigo": "Q430",
        "valor": "DIVERTICULO DE MECKEL"
      },
      {
        "codigo": "Q431",
        "valor": "ENFERMEDAD DE HIRSCHSPRUNG"
      },
      {
        "codigo": "Q432",
        "valor": "OTROS TRASTORNOS FUNCIONALES CONGENITOS DEL COLON"
      },
      {
        "codigo": "Q433",
        "valor": "MALFORMACIONES CONGENITAS DE LA FIJACION DEL INTESTINO"
      },
      {
        "codigo": "Q434",
        "valor": "DUPLICACION DEL INTESTINO"
      },
      {
        "codigo": "Q435",
        "valor": "ANO ECTOPICO"
      },
      {
        "codigo": "Q436",
        "valor": "FISTULA CONGENITA DEL RECTO Y DEL ANO"
      },
      {
        "codigo": "Q437",
        "valor": "PERSISTENCIA DE LA CLOACA"
      },
      {
        "codigo": "Q438",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL INTESTINO, ESPECIFICADAS"
      },
      {
        "codigo": "Q439",
        "valor": "MALFORMACION CONGENITA DEL INTESTINO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q44 - MALFORMACIONES CONGENITAS DE LA VESICULA BILIAR, DE LOS CONDUCTOS BILIARES Y DEL HIGADO",
    "detalle": [
      {
        "codigo": "Q440",
        "valor": "AGENESIA, APLASIA E HIPOPLASIA DE LA VESICULA BILIAR"
      },
      {
        "codigo": "Q441",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA VESICULA BILIAR"
      },
      {
        "codigo": "Q442",
        "valor": "ATRESIA DE LOS CONDUCTOS BILIARES"
      },
      {
        "codigo": "Q443",
        "valor": "ESTRECHEZ Y ESTENOSIS CONGENITA DE LOS CONDUCTOS BILIARES"
      },
      {
        "codigo": "Q444",
        "valor": "QUISTE DEL COLEDOCO"
      },
      {
        "codigo": "Q445",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LOS CONDUCTOS BILIARES"
      },
      {
        "codigo": "Q446",
        "valor": "ENFERMEDAD QUISTICA DEL HIGADO"
      },
      {
        "codigo": "Q447",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL HIGADO"
      }
    ]
  },
  {
    "grupo": "Q45 - OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA DIGESTIVO",
    "detalle": [
      {
        "codigo": "Q450",
        "valor": "AGENESIA, APLASIA E HIPOPLASIA DEL PANCREAS"
      },
      {
        "codigo": "Q451",
        "valor": "PANCREAS ANULAR"
      },
      {
        "codigo": "Q452",
        "valor": "QUISTE CONGENITO DEL PANCREAS"
      },
      {
        "codigo": "Q453",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL PANCREAS Y DEL CONDUCTO PANCREATICO"
      },
      {
        "codigo": "Q458",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA DIGESTIVO, ESPECIFICADAS"
      },
      {
        "codigo": "Q459",
        "valor": "MALFORMACION CONGENITA DEL SISTEMA DIGESTIVO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q50 - MALFORMACIONES CONGENITAS DE LOS OVARIOS, DE LAS TROMPAS DE FALOPIO Y DE LOS LIGAMENTOS ANCHOS",
    "detalle": [
      {
        "codigo": "Q500",
        "valor": "AUSENCIA CONGENITA DE OVARIO"
      },
      {
        "codigo": "Q501",
        "valor": "QUISTE EN DESARROLLO DEL OVARIO"
      },
      {
        "codigo": "Q502",
        "valor": "TORSION CONGENITA DEL OVARIO"
      },
      {
        "codigo": "Q503",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LOS OVARIOS"
      },
      {
        "codigo": "Q504",
        "valor": "QUISTE EMBRIONARIO DE LA TROMPA DE FALOPIO"
      },
      {
        "codigo": "Q505",
        "valor": "QUISTE EMBRIONARIO DEL LIGAMENTO ANCHO"
      },
      {
        "codigo": "Q506",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA TROMPA DE FALOPIO Y DEL LIGAMENTO ANCHO"
      }
    ]
  },
  {
    "grupo": "Q51 - MALFORMACIONES CONGENITAS DEL UTERO Y DEL CUELLO UTERINO",
    "detalle": [
      {
        "codigo": "Q510",
        "valor": "AGENESIA Y APLASIA DEL UTERO"
      },
      {
        "codigo": "Q511",
        "valor": "DUPLICACION DEL UTERO CON DUPLICACION DEL CUELLO UTERINO Y DE LA VAGINA"
      },
      {
        "codigo": "Q512",
        "valor": "OTRA DUPLICACION DEL UTERO"
      },
      {
        "codigo": "Q513",
        "valor": "UTERO BICORNE"
      },
      {
        "codigo": "Q514",
        "valor": "UTERO UNICORNE"
      },
      {
        "codigo": "Q515",
        "valor": "AGENESIA Y APLASIA DEL CUELLO UTERINO"
      },
      {
        "codigo": "Q516",
        "valor": "QUISTE EMBRIONARIO DEL CUELLO UTERINO"
      },
      {
        "codigo": "Q517",
        "valor": "FISTULA CONGENITA ENTRE EL UTERO Y EL TRACTO DIGESTIVO Y URINARIO"
      },
      {
        "codigo": "Q518",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL UTERO Y DEL CUELLO UTERINO"
      },
      {
        "codigo": "Q519",
        "valor": "MALFORMACION CONGENITA DEL UTERO Y DEL CUELLO UTERINO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q52 - OTRAS MALFORMACIONES CONGENITAS DE LOS ORGANOS GENITALES FEMENINOS",
    "detalle": [
      {
        "codigo": "Q520",
        "valor": "AUSENCIA CONGENITA DE LA VAGINA"
      },
      {
        "codigo": "Q521",
        "valor": "DUPLICACION DE LA VAGINA"
      },
      {
        "codigo": "Q522",
        "valor": "FISTULA RECTOVAGINAL CONGENITA"
      },
      {
        "codigo": "Q523",
        "valor": "HIMEN IMPERFORADO"
      },
      {
        "codigo": "Q524",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA VAGINA"
      },
      {
        "codigo": "Q525",
        "valor": "FUSION DE LABIOS DE LA VULVA"
      },
      {
        "codigo": "Q526",
        "valor": "MALFORMACION CONGENITA DEL CLITORIS"
      },
      {
        "codigo": "Q527",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA VULVA"
      },
      {
        "codigo": "Q528",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LOS ORGANOS GENITALES FEMENINOS, ESPECIFICADAS"
      },
      {
        "codigo": "Q529",
        "valor": "MALFORMACION CONGENITA DE LOS GENITALES FEMENINOS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q53 - TESTICULO NO DESCENDIDO",
    "detalle": [
      {
        "codigo": "Q530",
        "valor": "ECTOPIA TESTICULAR"
      },
      {
        "codigo": "Q531",
        "valor": "TESTICULO NO DESCENDIDO, UNILATERAL"
      },
      {
        "codigo": "Q532",
        "valor": "TESTICULO NO DESCENDIDO, BILATERAL"
      },
      {
        "codigo": "Q539",
        "valor": "TESTICULO NO DESCENDIDO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Q54 - HIPOSPADIAS",
    "detalle": [
      {
        "codigo": "Q540",
        "valor": "HIPOSPADIAS DEL GLANDE"
      },
      {
        "codigo": "Q541",
        "valor": "HIPOSPADIAS PENEANA"
      },
      {
        "codigo": "Q542",
        "valor": "HIPOSPADIAS PENOSCROTAL"
      },
      {
        "codigo": "Q543",
        "valor": "HIPOSPADIAS PERINEAL"
      },
      {
        "codigo": "Q544",
        "valor": "ENCORDAMIENTO CONGENITO DEL PENE"
      },
      {
        "codigo": "Q548",
        "valor": "OTRAS HIPOSPADIAS"
      },
      {
        "codigo": "Q549",
        "valor": "HIPOSPADIAS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q55 - OTRAS MALFORMACIONES CONGENITAS DE LOS ORGANOS GENITALES MASCULINOS",
    "detalle": [
      {
        "codigo": "Q550",
        "valor": "AUSENCIA Y APLASIA DEL TESTICULO"
      },
      {
        "codigo": "Q551",
        "valor": "HIPOPLASIA DEL TESTICULO Y DEL ESCROTO"
      },
      {
        "codigo": "Q552",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LOS TESTICULOS Y DEL ESCROTO"
      },
      {
        "codigo": "Q553",
        "valor": "ATRESIA DEL CONDUCTO DEFERENTE"
      },
      {
        "codigo": "Q554",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LOS CONDUCTOS DEFERENTES, DEL EPIDIDIMO, DE LAS VESICULAS SEMINALES Y DE LA PROSTATA"
      },
      {
        "codigo": "Q555",
        "valor": "APLASIA Y AUSENCIA CONGENITA DEL PENE"
      },
      {
        "codigo": "Q556",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL PENE"
      },
      {
        "codigo": "Q558",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LOS ORGANOS GENITALES MASCULINOS, ESPECIFICADAS"
      },
      {
        "codigo": "Q559",
        "valor": "MALFORMACION CONGENITA DE LOS ORGANOS GENITALES MASCULINOS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q56 - SEXO INDETERMINADO Y SEUDOHERMAFRODITISMO",
    "detalle": [
      {
        "codigo": "Q560",
        "valor": "HERMAFRODITISMO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "Q561",
        "valor": "SEUDOHERMAFRODITISMO MASCULINO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "Q562",
        "valor": "SEUDOHERMAFRODITISMO FEMENINO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "Q563",
        "valor": "SEUDOHERMAFRODITISMO, NO ESPECIFICADO"
      },
      {
        "codigo": "Q564",
        "valor": "SEXO INDETERMINADO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Q60 - AGENESIA RENAL Y OTRAS MALFORMACIONES HIPOPLASICAS DEL RIÑON",
    "detalle": [
      {
        "codigo": "Q600",
        "valor": "AGENESIA RENAL, UNILATERAL"
      },
      {
        "codigo": "Q601",
        "valor": "AGENESIA RENAL, BILATERAL"
      },
      {
        "codigo": "Q602",
        "valor": "AGENESIA RENAL, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "Q603",
        "valor": "HIPOPLASIA RENAL, UNILATERAL"
      },
      {
        "codigo": "Q604",
        "valor": "HIPOPLASIA RENAL, BILATERAL"
      },
      {
        "codigo": "Q605",
        "valor": "HIPOPLASIA RENAL, NO ESPECIFICADA"
      },
      {
        "codigo": "Q606",
        "valor": "SINDROME DE POTTER"
      }
    ]
  },
  {
    "grupo": "Q61 - ENFERMEDAD QUISTICA DEL RIÑON",
    "detalle": [
      {
        "codigo": "Q610",
        "valor": "QUISTE RENAL SOLITARIO CONGENITO"
      },
      {
        "codigo": "Q611",
        "valor": "RIÑON POLIQUISTICO, AUTOSOMICO RECESIVO"
      },
      {
        "codigo": "Q612",
        "valor": "RIÑON POLIQUISTICO, AUTOSOMICO DOMINANTE"
      },
      {
        "codigo": "Q613",
        "valor": "RIÑON POLIQUISTICO, TIPO NO ESPECIFICADO"
      },
      {
        "codigo": "Q614",
        "valor": "DISPLASIA RENAL"
      },
      {
        "codigo": "Q615",
        "valor": "RIÑON QUISTICO MEDULAR"
      },
      {
        "codigo": "Q618",
        "valor": "OTRAS ENFERMEDADES RENALES QUISTICAS"
      },
      {
        "codigo": "Q619",
        "valor": "ENFERMEDAD QUISTICA DEL RIÑON, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q62 - DEFECTOS OBSTRUCTIVOS CONGENITOS DE LA PELVIS RENAL Y MALFORMACIONES",
    "detalle": [
      {
        "codigo": "Q620",
        "valor": "HIDRONEFROSIS CONGENITA"
      },
      {
        "codigo": "Q621",
        "valor": "ATRESIA Y ESTENOSIS DEL URETER"
      },
      {
        "codigo": "Q622",
        "valor": "MEGALOURETER CONGENITO"
      },
      {
        "codigo": "Q623",
        "valor": "OTROS DEFECTOS OBSTRUCTIVOS DE LA PELVIS RENAL Y DEL URETER"
      },
      {
        "codigo": "Q624",
        "valor": "AGENESIA DEL URETER"
      },
      {
        "codigo": "Q625",
        "valor": "DUPLICACION DEL URETER"
      },
      {
        "codigo": "Q626",
        "valor": "MALA POSICION DEL URETER"
      },
      {
        "codigo": "Q627",
        "valor": "REFLUJO VESICO-URETERO-RENAL CONGENITO"
      },
      {
        "codigo": "Q628",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL URETER"
      }
    ]
  },
  {
    "grupo": "Q63 - OTRAS MALFORMACIONES CONGENITAS DEL RIÑON",
    "detalle": [
      {
        "codigo": "Q630",
        "valor": "RIÑON SUPERNUMERARIO"
      },
      {
        "codigo": "Q631",
        "valor": "RIÑON LOBULADO, FUSIONADO Y EN HERRADURA"
      },
      {
        "codigo": "Q632",
        "valor": "RIÑON ECTOPICO"
      },
      {
        "codigo": "Q633",
        "valor": "HIPERPLASIA RENAL Y RIÑON GIGANTE"
      },
      {
        "codigo": "Q638",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL RIÑON, ESPECIFICADAS"
      },
      {
        "codigo": "Q639",
        "valor": "MALFORMACION CONGENITA DEL RIÑON, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q64 - OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA URINARIO",
    "detalle": [
      {
        "codigo": "Q640",
        "valor": "EPISPADIAS"
      },
      {
        "codigo": "Q641",
        "valor": "EXTROFIA DE LA VEJIGA URINARIA"
      },
      {
        "codigo": "Q642",
        "valor": "VALVULAS URETRALES POSTERIORES CONGENITAS"
      },
      {
        "codigo": "Q643",
        "valor": "OTRAS ATRESIAS Y ESTENOSIS DE LA URETRA Y DEL CUELLO DE LA VEJIGA"
      },
      {
        "codigo": "Q644",
        "valor": "MALFORMACION DEL URACO"
      },
      {
        "codigo": "Q645",
        "valor": "AUSENCIA CONGENITA DE LA VEJIGA Y DE LA URETRA"
      },
      {
        "codigo": "Q646",
        "valor": "DIVERTICULO CONGENITO DE LA VEJIGA"
      },
      {
        "codigo": "Q647",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA VEJIGA Y DE LA URETRA"
      },
      {
        "codigo": "Q648",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL APARATO URINARIO, ESPECIFICADAS"
      },
      {
        "codigo": "Q649",
        "valor": "MALFORMACION CONGENITA DEL APARATO URINARIO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q65 - DEFORMIDADES CONGENITAS DE LA CADERA",
    "detalle": [
      {
        "codigo": "Q650",
        "valor": "LUXACION CONGENITA DE LA CADERA, UNILATERAL"
      },
      {
        "codigo": "Q651",
        "valor": "LUXACION CONGENITA DE LA CADERA, BILATERAL"
      },
      {
        "codigo": "Q652",
        "valor": "LUXACION CONGENITA DE LA CADERA, NO ESPECIFICADA"
      },
      {
        "codigo": "Q653",
        "valor": "SUBLUXACION CONGENITA DE LA CADERA, UNILATERAL"
      },
      {
        "codigo": "Q654",
        "valor": "SUBLUXACION CONGENITA DE LA CADERA, BILATERAL"
      },
      {
        "codigo": "Q655",
        "valor": "SUBLUXACION CONGENITA DE LA CADERA, NO ESPECIFICADA"
      },
      {
        "codigo": "Q656",
        "valor": "CADERA INESTABLE"
      },
      {
        "codigo": "Q658",
        "valor": "OTRAS DEFORMIDADES CONGENITAS DE LA CADERA"
      },
      {
        "codigo": "Q659",
        "valor": "DEFORMIDAD CONGENITA DE LA CADERA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q66 - DEFORMIDADES CONGENITAS DE LOS PIES",
    "detalle": [
      {
        "codigo": "Q660",
        "valor": "TALIPES EQUINOVARUS"
      },
      {
        "codigo": "Q661",
        "valor": "TALIPES CALCANEOVARUS"
      },
      {
        "codigo": "Q662",
        "valor": "METATARSUS VARUS"
      },
      {
        "codigo": "Q663",
        "valor": "OTRAS DEFORMIDADES VARUS CONGENITAS DE LOS PIES"
      },
      {
        "codigo": "Q664",
        "valor": "TALIPES CALCANEOVALGUS"
      },
      {
        "codigo": "Q665",
        "valor": "PIE PLANO CONGENITO"
      },
      {
        "codigo": "Q666",
        "valor": "OTRAS DEFORMIDADES VALGUS CONGENITAS DE LOS PIES"
      },
      {
        "codigo": "Q667",
        "valor": "PIE CAVUS"
      },
      {
        "codigo": "Q668",
        "valor": "OTRAS DEFORMIDADES CONGENITAS DE LOS PIES"
      },
      {
        "codigo": "Q669",
        "valor": "DEFORMIDAD CONGENITA DE LOS PIES, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q67 - DEFORMIDADES OSTEOMUSCULARES CONGENITAS DE LA CABEZA, DE LA CARA, DE LA COLUMNA VERTEBRAL Y DEL TORAX",
    "detalle": [
      {
        "codigo": "Q670",
        "valor": "ASIMETRIA FACIAL"
      },
      {
        "codigo": "Q671",
        "valor": "FACIES COMPRIMIDA"
      },
      {
        "codigo": "Q672",
        "valor": "DOLICOCEFALIA"
      },
      {
        "codigo": "Q673",
        "valor": "PLAGIOCEFALIA"
      },
      {
        "codigo": "Q674",
        "valor": "OTRAS DEFORMIDADES CONGENITAS DEL CRANEO, DE LA CARA Y DE LA MANDIBULA"
      },
      {
        "codigo": "Q675",
        "valor": "DEFORMIDAD CONGENITA DE LA COLUMNA VERTEBRAL"
      },
      {
        "codigo": "Q676",
        "valor": "TORAX EXCAVADO"
      },
      {
        "codigo": "Q677",
        "valor": "TORAX EN QUILLA"
      },
      {
        "codigo": "Q678",
        "valor": "OTRAS DEFORMIDADES CONGENITAS DEL TORAX"
      }
    ]
  },
  {
    "grupo": "Q68 - OTRAS DEFORMIDADES OSTEOMUSCULARES CONGENITAS",
    "detalle": [
      {
        "codigo": "Q680",
        "valor": "DEFORMIDAD CONGENITA DEL MUSCULO ESTERNOCLEIDOMASTOIDEO"
      },
      {
        "codigo": "Q681",
        "valor": "DEFORMIDAD CONGENITA DE LA MANO"
      },
      {
        "codigo": "Q682",
        "valor": "DEFORMIDAD CONGENITA DE LA RODILLA"
      },
      {
        "codigo": "Q683",
        "valor": "CURVATURA CONGENITA DEL FEMUR"
      },
      {
        "codigo": "Q684",
        "valor": "CURVATURA CONGENITA DE LA TIBIA Y DEL PERONE"
      },
      {
        "codigo": "Q685",
        "valor": "CURVATURA CONGENITA DE HUESO(S) LARGO(S) DEL MIEMBRO INFERIOR, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "Q688",
        "valor": "OTRAS DEFORMIDADES CONGENITAS OSTEOMUSCULARES, ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Q69 - POLIDACTILIA",
    "detalle": [
      {
        "codigo": "Q690",
        "valor": "DEDO(S) SUPERNUMERARIO(S) DE LA MANO"
      },
      {
        "codigo": "Q691",
        "valor": "PULGAR(ES) SUPERNUMERARIO(S)"
      },
      {
        "codigo": "Q692",
        "valor": "DEDO(S) SUPERNUMERARIO(S) DEL PIE"
      },
      {
        "codigo": "Q699",
        "valor": "POLIDACTILIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q70 - SINDACTILIA",
    "detalle": [
      {
        "codigo": "Q700",
        "valor": "FUSION DE LOS DEDOS DE LA MANO"
      },
      {
        "codigo": "Q701",
        "valor": "MEMBRANA INTERDIGITAL DE LA MANO"
      },
      {
        "codigo": "Q702",
        "valor": "FUSION DE LOS DEDOS DEL PIE"
      },
      {
        "codigo": "Q703",
        "valor": "MEMBRANA INTERDIGITAL DEL PIE"
      },
      {
        "codigo": "Q704",
        "valor": "POLISINDACTILIA"
      },
      {
        "codigo": "Q709",
        "valor": "SINDACTILIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q71 - DEFECTOS POR REDUCCION DEL MIEMBRO SUPERIOR",
    "detalle": [
      {
        "codigo": "Q710",
        "valor": "AUSENCIA CONGENITA COMPLETA DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES)"
      },
      {
        "codigo": "Q711",
        "valor": "AUSENCIA CONGENITA DEL BRAZO Y DEL ANTEBRAZO CON PRESENCIA DE LA MANO"
      },
      {
        "codigo": "Q712",
        "valor": "AUSENCIA CONGENITA DEL ANTEBRAZO Y DE LA MANO"
      },
      {
        "codigo": "Q713",
        "valor": "AUSENCIA CONGENITA DE LA MANO Y EL (LOS) DEDO(S)"
      },
      {
        "codigo": "Q714",
        "valor": "DEFECTO POR REDUCCION LONGITUDINAL DEL RADIO"
      },
      {
        "codigo": "Q715",
        "valor": "DEFECTO POR REDUCCION LONGITUDINAL DEL CUBITO"
      },
      {
        "codigo": "Q716",
        "valor": "MANO EN PINZA DE LANGOSTA"
      },
      {
        "codigo": "Q718",
        "valor": "OTROS DEFECTOS POR REDUCCION DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES)"
      },
      {
        "codigo": "Q719",
        "valor": "DEFECTO POR REDUCCION DEL MIEMBRO SUPERIOR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Q72 - DEFECTOS POR REDUCCION DEL MIEMBRO INFERIOR",
    "detalle": [
      {
        "codigo": "Q720",
        "valor": "AUSENCIA CONGENITA COMPLETA DEL (DE LOS) MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "Q721",
        "valor": "AUSENCIA CONGENITA DEL MUSLO Y DE LA PIERNA CON PRESENCIA DEL PIE"
      },
      {
        "codigo": "Q722",
        "valor": "AUSENCIA CONGENITA DE LA PIERNA Y DEL PIE"
      },
      {
        "codigo": "Q723",
        "valor": "AUSENCIA CONGENITA DEL PIE Y DEDO(S) DEL PIE"
      },
      {
        "codigo": "Q724",
        "valor": "DEFECTO POR REDUCCION LONGITUDINAL DEL FEMUR"
      },
      {
        "codigo": "Q725",
        "valor": "DEFECTO POR REDUCCION LONGITUDINAL DE LA TIBIA"
      },
      {
        "codigo": "Q726",
        "valor": "DEFECTO POR REDUCCION LONGITUDINAL DEL PERONE"
      },
      {
        "codigo": "Q727",
        "valor": "PIE HENDIDO"
      },
      {
        "codigo": "Q728",
        "valor": "OTROS DEFECTOS POR REDUCCION DEL (DE LOS) MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "Q729",
        "valor": "DEFECTO POR REDUCCION DEL MIEMBRO INFERIOR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Q73 - DEFECTOS POR REDUCCION DE MIEMBRO NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "Q730",
        "valor": "AUSENCIA COMPLETA DE MIEMBRO(S) NO ESPECIFICADO(S)"
      },
      {
        "codigo": "Q731",
        "valor": "FOCOMELIA, MIEMBRO(S) NO ESPECIFICADO(S)"
      },
      {
        "codigo": "Q738",
        "valor": "OTROS DEFECTOS POR REDUCCION DE MIEMBRO(S) NO ESPECIFICADO(S)"
      }
    ]
  },
  {
    "grupo": "Q74 - OTRAS ANOMALIAS CONGENITAS DEL (DE LOS) MIEMBRO(S)",
    "detalle": [
      {
        "codigo": "Q740",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES), INCLUIDA LA CINTURA ESCAPULAR"
      },
      {
        "codigo": "Q741",
        "valor": "MALFORMACION CONGENITA DE LA RODILLA"
      },
      {
        "codigo": "Q742",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL (DE LOS) MIEMBRO(S) INFERIOR(ES), INCLUIDA LA CINTURA PELVIANA"
      },
      {
        "codigo": "Q743",
        "valor": "ARTROGRIPOSIS MULTIPLE CONGENITA"
      },
      {
        "codigo": "Q748",
        "valor": "OTRAS MALFORMACIONES CONGENITAS ESPECIFICADAS DEL (DE LOS) MIEMBRO(S)"
      },
      {
        "codigo": "Q749",
        "valor": "MALFORMACION CONGENITA DE MIEMBRO(S), NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q75 - OTRAS MALFORMACIONES CONGENITAS DE LOS HUESOS DEL CRANEO Y DE LA CARA",
    "detalle": [
      {
        "codigo": "Q750",
        "valor": "CRANEOSINOSTOSIS"
      },
      {
        "codigo": "Q751",
        "valor": "DISOSTOSIS CRANEOFACIAL"
      },
      {
        "codigo": "Q752",
        "valor": "HIPERTELORISMO"
      },
      {
        "codigo": "Q753",
        "valor": "MACROCEFALIA"
      },
      {
        "codigo": "Q754",
        "valor": "DISOSTOSIS MAXILOFACIAL"
      },
      {
        "codigo": "Q755",
        "valor": "DISOSTOSIS OCULOMAXILAR"
      },
      {
        "codigo": "Q758",
        "valor": "OTRAS MALFORMACIONES CONGENITAS ESPECIFICADAS DE LOS HUESOS DEL CRANEO Y DE LA CARA"
      },
      {
        "codigo": "Q759",
        "valor": "MALFORMACION CONGENITA NO ESPECIFICADA DE LOS HUESOS DEL CRANEO Y DE LA CARA"
      }
    ]
  },
  {
    "grupo": "Q76 - MALFORMACIONES CONGENITAS DE LA COLUMNA VERTEBRAL Y TORAX OSEO",
    "detalle": [
      {
        "codigo": "Q760",
        "valor": "ESPINA BIFIDA OCULTA"
      },
      {
        "codigo": "Q761",
        "valor": "SINDROME DE KLIPPEL-FEIL"
      },
      {
        "codigo": "Q762",
        "valor": "ESPONDILOLISTESIS CONGENITA"
      },
      {
        "codigo": "Q763",
        "valor": "ESCOLIOSIS CONGENITA DEBIDA A MALFORMACION CONGENITA OSEA"
      },
      {
        "codigo": "Q764",
        "valor": "OTRA MALFORMACION CONGENITA DE LA COLUMNA VERTEBRAL, NO ASOCIADA CON ESCOLIOSIS"
      },
      {
        "codigo": "Q765",
        "valor": "COSTILLA CERVICAL"
      },
      {
        "codigo": "Q766",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LAS COSTILLAS"
      },
      {
        "codigo": "Q767",
        "valor": "MALFORMACION CONGENITA DEL ESTERNON"
      },
      {
        "codigo": "Q768",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL TORAX OSEO"
      },
      {
        "codigo": "Q769",
        "valor": "MALFORMACION CONGENITA DEL TORAX OSEO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q77 - OSTEOCONDRODISPLASIA CON DEFECTO DEL CRECIMIENTO DE LOS HUESOS LARGOS Y DE LA COLUMNA VERTEBRAL",
    "detalle": [
      {
        "codigo": "Q770",
        "valor": "ACONDROGENESIS"
      },
      {
        "codigo": "Q771",
        "valor": "ENANISMO TANATOFORICO"
      },
      {
        "codigo": "Q772",
        "valor": "SINDROME DE COSTILLA CORTA"
      },
      {
        "codigo": "Q773",
        "valor": "CONDRODISPLASIA PUNCTATA"
      },
      {
        "codigo": "Q774",
        "valor": "ACONDROPLASIA"
      },
      {
        "codigo": "Q775",
        "valor": "DISPLASIA DISTROFICA"
      },
      {
        "codigo": "Q776",
        "valor": "DISPLASIA CONDROECTODERMICA"
      },
      {
        "codigo": "Q777",
        "valor": "DISPLASIA ESPONDILOEPIFISARIA"
      },
      {
        "codigo": "Q778",
        "valor": "OTRAS OSTEOCONDRODISPLASIAS CON DEFECTOS DEL CRECIMIENTO DE LOS HUESOS LARGOS Y DE LA COLUMNA VERTEBRAL"
      },
      {
        "codigo": "Q779",
        "valor": "OSTEOCONDRODISPLASIA CON DEFECTOS DEL CRECIMIENTO DE LOS HUESOS LARGOS Y DE LA COLUMNA VERTEBRAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Q78 - OTRAS OSTEOCONDRODISPLASIAS",
    "detalle": [
      {
        "codigo": "Q780",
        "valor": "OSTEOGENESIS IMPERFECTA"
      },
      {
        "codigo": "Q781",
        "valor": "DISPLASIA POLIOSTOTICA FIBROSA"
      },
      {
        "codigo": "Q782",
        "valor": "OSTEOPETROSIS"
      },
      {
        "codigo": "Q783",
        "valor": "DISPLASIA DIAFISARIA PROGRESIVA"
      },
      {
        "codigo": "Q784",
        "valor": "ENCONDROMATOSIS"
      },
      {
        "codigo": "Q785",
        "valor": "DISPLASIA METAFISARIA"
      },
      {
        "codigo": "Q786",
        "valor": "EXOSTOSIS CONGENITA MULTIPLE"
      },
      {
        "codigo": "Q788",
        "valor": "OTRAS OSTEOCONDRODISPLASIAS ESPECIFICADAS"
      },
      {
        "codigo": "Q789",
        "valor": "OSTEOCONDRODISPLASIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q79 - MALFORMACIONES CONGENITAS DEL SISTEMA OSTEOMUSCULAR, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Q790",
        "valor": "HERNIA DIAFRAGMATICA CONGENITA"
      },
      {
        "codigo": "Q791",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL DIAFRAGMA"
      },
      {
        "codigo": "Q792",
        "valor": "EXONFALOS"
      },
      {
        "codigo": "Q793",
        "valor": "GASTROSQUISIS"
      },
      {
        "codigo": "Q794",
        "valor": "SINDROME DEL ABDOMEN EN CIRUELA PASA"
      },
      {
        "codigo": "Q795",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA PARED ABDOMINAL"
      },
      {
        "codigo": "Q796",
        "valor": "SINDROME DE EHLERS-DANLOS"
      },
      {
        "codigo": "Q798",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA OSTEOMUSCULAR"
      },
      {
        "codigo": "Q799",
        "valor": "MALFORMACION CONGENITA DEL SISTEMA OSTEOMUSCULAR, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q80 - ICTIOSIS CONGENITA",
    "detalle": [
      {
        "codigo": "Q800",
        "valor": "ICTIOSIS VULGAR"
      },
      {
        "codigo": "Q801",
        "valor": "ICTIOSIS LIGADA AL CROMOSOMA X"
      },
      {
        "codigo": "Q802",
        "valor": "ICTIOSIS LAMELAR"
      },
      {
        "codigo": "Q803",
        "valor": "ERITRODERMIA ICTIOSIFORME VESICULAR CONGENITA"
      },
      {
        "codigo": "Q804",
        "valor": "FETO ARLEQUIN"
      },
      {
        "codigo": "Q808",
        "valor": "OTRAS ICTIOSIS CONGENITAS"
      },
      {
        "codigo": "Q809",
        "valor": "ICTIOSIS CONGENITA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q81 - EPIDERMOLISIS BULLOSA",
    "detalle": [
      {
        "codigo": "Q810",
        "valor": "EPIDERMOLISIS BULLOSA SIMPLE"
      },
      {
        "codigo": "Q811",
        "valor": "EPIDERMOLISIS BULLOSA LETAL"
      },
      {
        "codigo": "Q812",
        "valor": "EPIDERMOLISIS BULLOSA DISTROFICA"
      },
      {
        "codigo": "Q818",
        "valor": "OTRAS EPIDERMOLISIS BULLOSAS"
      },
      {
        "codigo": "Q819",
        "valor": "EPIDERMOLISIS BULLOSA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q82 - OTRAS MALFORMACIONES CONGENITAS DE LA PIEL",
    "detalle": [
      {
        "codigo": "Q820",
        "valor": "LINFEDEMA HEREDITARIO"
      },
      {
        "codigo": "Q821",
        "valor": "XERODERMA PIGMENTOSO"
      },
      {
        "codigo": "Q822",
        "valor": "MASTOCITOSIS"
      },
      {
        "codigo": "Q823",
        "valor": "INCONTINENCIA PIGMENTARIA"
      },
      {
        "codigo": "Q824",
        "valor": "DISPLASIA ECTODERMICA (ANHIDROTICA)"
      },
      {
        "codigo": "Q825",
        "valor": "NEVO NO NEOPLASICO, CONGENITO"
      },
      {
        "codigo": "Q828",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA PIEL, ESPECIFICADAS"
      },
      {
        "codigo": "Q829",
        "valor": "MALFORMACION CONGENITA DE LA PIEL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q83 - MALFORMACIONES CONGENITAS DE LA MAMA",
    "detalle": [
      {
        "codigo": "Q830",
        "valor": "AUSENCIA CONGENITA DE LA MAMA CON AUSENCIA DEL PEZON"
      },
      {
        "codigo": "Q831",
        "valor": "MAMA SUPERNUMERARIA"
      },
      {
        "codigo": "Q832",
        "valor": "AUSENCIA DEL PEZON"
      },
      {
        "codigo": "Q833",
        "valor": "PEZON SUPERNUMERARIO"
      },
      {
        "codigo": "Q838",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LA MAMA"
      },
      {
        "codigo": "Q839",
        "valor": "MALFORMACION CONGENITA DE LA MAMA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q84 - OTRAS MALFORMACIONES CONGENITAS DE LAS FANERAS",
    "detalle": [
      {
        "codigo": "Q840",
        "valor": "ALOPECIA CONGENITA"
      },
      {
        "codigo": "Q841",
        "valor": "ALTERACIONES MORFOLOGICAS CONGENITAS DEL PELO, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Q842",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DEL PELO"
      },
      {
        "codigo": "Q843",
        "valor": "ANONIQUIA"
      },
      {
        "codigo": "Q844",
        "valor": "LEUCONIQUIA CONGENITA"
      },
      {
        "codigo": "Q845",
        "valor": "AGRANDAMIENTO E HIPERTROFIA DE LAS UÑAS"
      },
      {
        "codigo": "Q846",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LAS UÑAS"
      },
      {
        "codigo": "Q848",
        "valor": "OTRAS MALFORMACIONES CONGENITAS DE LAS FANERAS, ESPECIFICADAS"
      },
      {
        "codigo": "Q849",
        "valor": "MALFORMACION CONGENITA DE LAS FANERAS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q85 - FACOMATOSIS, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Q850",
        "valor": "NEUROFIBROMATOSIS (NO MALIGNA)"
      },
      {
        "codigo": "Q851",
        "valor": "ESCLEROSIS TUBEROSA"
      },
      {
        "codigo": "Q858",
        "valor": "OTRAS FACOMATOSIS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Q859",
        "valor": "FACOMATOSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q86 - SINDROMES DE MALFORMACIONES CONGENITAS DEBIDOS A CAUSAS EXOGENAS CONOCIDAS NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Q860",
        "valor": "SINDROME FETAL (DISMORFICO) DEBIDO AL ALCOHOL"
      },
      {
        "codigo": "Q861",
        "valor": "SINDROME DE HIDANTOINA FETAL"
      },
      {
        "codigo": "Q862",
        "valor": "DISMORFISMO DEBIDO A WARFARINA"
      },
      {
        "codigo": "Q868",
        "valor": "OTROS SINDROMES DE MALFORMACIONES CONGENITAS DEBIDOS A CAUSAS EXOGENAS CONOCIDAS"
      }
    ]
  },
  {
    "grupo": "Q87 - OTROS SINDROMES DE MALFORMACIONES CONGENITAS ESPECIFICADOS QUE AFECTAN MULTIPLES SISTEMAS",
    "detalle": [
      {
        "codigo": "Q870",
        "valor": "SINDROMES DE MALFORMACIONES CONGENITAS QUE AFECTAN PRINCIPALMENTE LA APARIENCIA FACIAL"
      },
      {
        "codigo": "Q871",
        "valor": "SINDROMES DE MALFORMACIONES CONGENITAS ASOCIADAS PRINCIPALMENTE CON ESTATURA BAJA"
      },
      {
        "codigo": "Q872",
        "valor": "SINDROMES DE MALFORMACIONES CONGENITAS QUE AFECTAN PRINCIPALMENTE LOS MIEMBROS"
      },
      {
        "codigo": "Q873",
        "valor": "SINDROMES DE MALFORMACIONES CONGENITAS CON EXCESO DE CRECIMIENTO PRECOZ"
      },
      {
        "codigo": "Q874",
        "valor": "SINDROME DE MARFAN"
      },
      {
        "codigo": "Q875",
        "valor": "OTROS SINDROMES DE MALFORMACIONES CONGENITAS CON OTROS CAMBIOS ESQUELETICOS"
      },
      {
        "codigo": "Q878",
        "valor": "OTROS SINDROMES DE MALFORMACIONES CONGENITAS ESPECIFICADOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Q89 - OTRAS MALFORMACIONES CONGENITAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Q890",
        "valor": "MALFORMACIONES CONGENITAS DEL BAZO"
      },
      {
        "codigo": "Q891",
        "valor": "MALFORMACIONES CONGENITAS DE LA GLANDULA SUPRARRENAL"
      },
      {
        "codigo": "Q892",
        "valor": "MALFORMACIONES CONGENITAS DE OTRAS GLANDULAS ENDOCRINAS"
      },
      {
        "codigo": "Q893",
        "valor": "SITUS INVERSUS"
      },
      {
        "codigo": "Q894",
        "valor": "GEMELOS SIAMESES"
      },
      {
        "codigo": "Q897",
        "valor": "MALFORMACIONES CONGENITAS MULTIPLES, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Q898",
        "valor": "OTRAS MALFORMACIONES CONGENITAS, ESPECIFICADAS"
      },
      {
        "codigo": "Q899",
        "valor": "MALFORMACION CONGENITA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q90 - SINDROME DE DOWN",
    "detalle": [
      {
        "codigo": "Q900",
        "valor": "TRISOMIA 21, POR FALTA DE DISYUNCION MEIOTICA"
      },
      {
        "codigo": "Q901",
        "valor": "TRISOMIA 21, MOSAICO (POR FALTA DE DISYUNCION MITOTICA)"
      },
      {
        "codigo": "Q902",
        "valor": "TRISOMIA 21, POR TRANSLOCACION"
      },
      {
        "codigo": "Q909",
        "valor": "SINDROME DE DOWN, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Q91 - SINDROME DE EDWARDS Y SINDROME DE PATAU",
    "detalle": [
      {
        "codigo": "Q910",
        "valor": "TRISOMIA 18, POR FALTA DE DISYUNCION MEIOTICA"
      },
      {
        "codigo": "Q911",
        "valor": "TRISOMIA 18, MOSAICO (POR FALTA DE DISYUNCION MITOTICA)"
      },
      {
        "codigo": "Q912",
        "valor": "TRISOMIA 18, POR TRANSLOCACION"
      },
      {
        "codigo": "Q913",
        "valor": "SINDROME DE EDWARDS, NO ESPECIFICADO"
      },
      {
        "codigo": "Q914",
        "valor": "TRISOMIA 13, POR FALTA DE DISYUNCION MEIOTICA"
      },
      {
        "codigo": "Q915",
        "valor": "TRISOMIA 13, MOSAICO (POR FALTA DE DISYUNCION MITOTICA)"
      },
      {
        "codigo": "Q916",
        "valor": "TRISOMIA 13, POR TRANSLOCACION"
      },
      {
        "codigo": "Q917",
        "valor": "SINDROME DE PATAU, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Q92 - OTRAS TRISOMIAS Y TRISOMIAS PARCIALES DE LOS AUTOSOMAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Q920",
        "valor": "TRISOMIA DE UN CROMOSOMA COMPLETO, POR FALTA DE DISYUNCION MEIOTICA"
      },
      {
        "codigo": "Q921",
        "valor": "TRISOMIA DE UN CROMOSOMA COMPLETO, MOSAICO (POR FALTA DE DISYUNCION MITOTICA)"
      },
      {
        "codigo": "Q922",
        "valor": "TRISOMIA PARCIAL MAYOR"
      },
      {
        "codigo": "Q923",
        "valor": "TRISOMIA PARCIAL MENOR"
      },
      {
        "codigo": "Q924",
        "valor": "DUPLICACIONES VISIBLES SOLO EN LA PROMETAFASE"
      },
      {
        "codigo": "Q925",
        "valor": "DUPLICACIONES CON OTROS REORDENAMIENTOS COMPLEJOS"
      },
      {
        "codigo": "Q926",
        "valor": "CROMOSOMAS MARCADORES SUPLEMENTARIOS"
      },
      {
        "codigo": "Q927",
        "valor": "TRIPLOIDIA Y POLIPLOIDIA"
      },
      {
        "codigo": "Q928",
        "valor": "OTRAS TRISOMIAS Y TRISOMIAS PARCIALES DE LOS AUTOSOMAS, ESPECIFICADAS"
      },
      {
        "codigo": "Q929",
        "valor": "TRISOMIA Y TRISOMIA PARCIAL DE LOS AUTOSOMAS, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Q93 - MONOSOMIAS Y SUPRESIONES DE LOS AUTOSOMAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Q930",
        "valor": "MONOSOMIA COMPLETA DE UN CROMOSOMA, POR FALTA DE DISYUNCION MEIOTICA"
      },
      {
        "codigo": "Q931",
        "valor": "MONOSOMIA COMPLETA DE UN CROMOSOMA, MOSAICO (POR FALTA DE DISYUNCION MITOTICA)"
      },
      {
        "codigo": "Q932",
        "valor": "CROMOSOMA REEMPLAZADO POR ANILLO O DICENTRICO"
      },
      {
        "codigo": "Q933",
        "valor": "SUPRESION DEL BRAZO CORTO DEL CROMOSOMA 4"
      },
      {
        "codigo": "Q934",
        "valor": "SUPRESION DEL BRAZO CORTO DEL CROMOSOMA 5"
      },
      {
        "codigo": "Q935",
        "valor": "OTRAS SUPRESIONES DE PARTE DE UN CROMOSOMA"
      },
      {
        "codigo": "Q936",
        "valor": "SUPRESIONES VISIBLES SOLO EN LA PROMETAFASE"
      },
      {
        "codigo": "Q937",
        "valor": "SUPRESIONES CON OTROS REORDENAMIENTOS COMPLEJOS"
      },
      {
        "codigo": "Q938",
        "valor": "OTRAS SUPRESIONES DE LOS AUTOSOMAS"
      },
      {
        "codigo": "Q939",
        "valor": "SUPRESION DE LOS AUTOSOMAS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Q95 - REORDENAMIENTOS EQUILIBRADOS Y MARCADORES ESTRUCTURALES, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Q950",
        "valor": "TRANSLOCACION EQUILIBRADA E INSERCION EN INDIVIDUO NORMAL"
      },
      {
        "codigo": "Q951",
        "valor": "INVERSION CROMOSOMICA EN INDIVIDUO NORMAL"
      },
      {
        "codigo": "Q952",
        "valor": "REORDENAMIENTO AUTOSOMICO EQUILIBRADO EN INDIVIDUO ANORMAL"
      },
      {
        "codigo": "Q953",
        "valor": "REORDENAMIENTO AUTOSOMICO/SEXUAL EQUILIBRADO EN INDIVIDUO ANORMAL"
      },
      {
        "codigo": "Q954",
        "valor": "INDIVIDUOS CON HETEROCROMATINA MARCADORA"
      },
      {
        "codigo": "Q955",
        "valor": "INDIVIDUOS CON SITIO FRAGIL AUTOSOMICO"
      },
      {
        "codigo": "Q958",
        "valor": "OTROS REORDENAMIENTOS EQUILIBRADOS Y MARCADORES ESTRUCTURALES"
      },
      {
        "codigo": "Q959",
        "valor": "REORDENAMIENTO EQUILIBRADO Y MARCADOR ESTRUCTURAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Q96 - SINDROME DE TURNER",
    "detalle": [
      {
        "codigo": "Q960",
        "valor": "CARIOTIPO 45,X"
      },
      {
        "codigo": "Q961",
        "valor": "CARIOTIPO 46,X ISO (XQ)"
      },
      {
        "codigo": "Q962",
        "valor": "CARIOTIPO 46,X CON CROMOSOMA SEXUAL ANORMAL EXCEPTO ISO (XQ)"
      },
      {
        "codigo": "Q963",
        "valor": "MOSAICO 45, X/46,XX O XY"
      },
      {
        "codigo": "Q964",
        "valor": "MOSAICO 45,X/OTRA(S) LINEA(S) CELULAR(ES) CON CROMOSOMA SEXUAL ANORMAL"
      },
      {
        "codigo": "Q968",
        "valor": "OTRAS VARIANTES DEL SINDROME DE TURNER"
      },
      {
        "codigo": "Q969",
        "valor": "SINDROME DE TURNER, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Q97 - OTRAS ANOMALIAS DE LOS CROMOSOMAS SEXUALES, CON FENOTIPO FEMENINO, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Q970",
        "valor": "CARIOTIPO 47, XXX"
      },
      {
        "codigo": "Q971",
        "valor": "MUJER CON MAS DE TRES CROMOSOMAS X"
      },
      {
        "codigo": "Q972",
        "valor": "MOSAICO, LINEAS CON NUMERO VARIABLE DE CROMOSOMAS X"
      },
      {
        "codigo": "Q973",
        "valor": "MUJER CON CARIOTIPO 46, XY"
      },
      {
        "codigo": "Q978",
        "valor": "OTRAS ANOMALIAS DE LOS CROMOSOMAS SEXUALES, CON FENOTIPO FEMENINO, ESPECIFICADAS"
      },
      {
        "codigo": "Q979",
        "valor": "ANOMALIA DE LOS CROMOSOMAS SEXUALES, CON FENOTIPO FEMENINO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Q98 - OTRAS ANOMALIAS DE LOS CROMOSOMAS SEXUALES, CON FENOTIPO MASCULINO, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Q980",
        "valor": "SINDROME DE KLINEFELTER, CARIOTIPO 47, XXY"
      },
      {
        "codigo": "Q981",
        "valor": "SINDROME DE KLINEFELTER, HOMBRE CON MAS DE DOS CROMOSOMAS X"
      },
      {
        "codigo": "Q982",
        "valor": "SINDROME DE KLINEFELTER, HOMBRE CON CARIOTIPO 46, XX"
      },
      {
        "codigo": "Q983",
        "valor": "OTRO HOMBRE CON CARIOTIPO 46, XX"
      },
      {
        "codigo": "Q984",
        "valor": "SINDROME DE KLINEFELTER, NO ESPECIFICADO"
      },
      {
        "codigo": "Q985",
        "valor": "CARIOTIPO 47, XYY"
      },
      {
        "codigo": "Q986",
        "valor": "HOMBRE CON CROMOSOMA SEXUAL ESTRUCTURALMENTE ANORMAL"
      },
      {
        "codigo": "Q987",
        "valor": "HOMBRE CON MOSAICO DE CROMOSOMAS SEXUALES"
      },
      {
        "codigo": "Q988",
        "valor": "OTRAS ANOMALIAS DE LOS CROMOSOMAS SEXUALES, CON FENOTIPO MASCULINO, ESPECIFICADAS"
      },
      {
        "codigo": "Q989",
        "valor": "ANOMALIA DE LOS CROMOSOMAS SEXUALES, FENOTIPO MASCULINO, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Q99 - OTRAS ANOMALIAS CROMOSOMICAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Q990",
        "valor": "QUIMERA 46, XX/46, XY"
      },
      {
        "codigo": "Q991",
        "valor": "HERMAFRODITA VERDADERO 46, XX"
      },
      {
        "codigo": "Q992",
        "valor": "CROMOSOMA X FRAGIL"
      },
      {
        "codigo": "Q998",
        "valor": "OTRAS ANOMALIAS DE LOS CROMOSOMAS, ESPECIFICADAS"
      },
      {
        "codigo": "Q999",
        "valor": "ANOMALIA CROMOSOMICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "R00 - ANORMALIDADES DEL LATIDO CARDIACO",
    "detalle": [
      {
        "codigo": "R000",
        "valor": "TAQUICARDIA, NO ESPECIFICADA"
      },
      {
        "codigo": "R001",
        "valor": "BRADICARDIA, NO ESPECIFICADA"
      },
      {
        "codigo": "R002",
        "valor": "PALPITACIONES"
      },
      {
        "codigo": "R008",
        "valor": "OTRAS ANORMALIDADES DEL LATIDO CARDIACO Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R01 - SOPLOS Y OTROS SONIDOS CARDIACOS",
    "detalle": [
      {
        "codigo": "R010",
        "valor": "SOPLOS CARDIACOS BENIGNOS O INOCENTES"
      },
      {
        "codigo": "R011",
        "valor": "SOPLO CARDIACO, NO ESPECIFICADO"
      },
      {
        "codigo": "R012",
        "valor": "OTROS SONIDOS CARDIACOS"
      }
    ]
  },
  {
    "grupo": "R02 - GANGRENA, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "R02X",
        "valor": "GANGRENA, NO CLASIFICADA EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "R03 - LECTURA DE PRESION SANGUINEA ANORMAL, SIN DIAGNOSTICO",
    "detalle": [
      {
        "codigo": "R030",
        "valor": "LECTURA ELEVADA DE LA PRESION SANGUINEA, SIN DIAGNOSTICO DE HIPERTENSION"
      },
      {
        "codigo": "R031",
        "valor": "LECTURA DE PRESION BAJA NO ESPECIFICA"
      }
    ]
  },
  {
    "grupo": "R04 - HEMORRAGIAS DE LAS VIAS RESPIRATORIAS",
    "detalle": [
      {
        "codigo": "R040",
        "valor": "EPISTAXIS"
      },
      {
        "codigo": "R041",
        "valor": "HEMORRAGIA DE LA GARGANTA"
      },
      {
        "codigo": "R042",
        "valor": "HEMOPTISIS"
      },
      {
        "codigo": "R048",
        "valor": "HEMORRAGIA DE OTROS SITIOS DE LAS VIAS RESPIRATORIAS"
      },
      {
        "codigo": "R049",
        "valor": "HEMORRAGIA DE LAS VIAS RESPIRATORIAS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "R05 - TOS",
    "detalle": [
      {
        "codigo": "R05X",
        "valor": "TOS"
      }
    ]
  },
  {
    "grupo": "R06 - ANORMALIDADES DE LA RESPIRACION",
    "detalle": [
      {
        "codigo": "R060",
        "valor": "DISNEA"
      },
      {
        "codigo": "R061",
        "valor": "ESTRIDOR"
      },
      {
        "codigo": "R062",
        "valor": "SILBIDO"
      },
      {
        "codigo": "R063",
        "valor": "RESPIRACION PERIODICA"
      },
      {
        "codigo": "R064",
        "valor": "HIPERVENTILACION"
      },
      {
        "codigo": "R065",
        "valor": "RESPIRACION CON LA BOCA"
      },
      {
        "codigo": "R066",
        "valor": "HIPO"
      },
      {
        "codigo": "R067",
        "valor": "ESTORNUDO"
      },
      {
        "codigo": "R068",
        "valor": "OTRAS ANORMALIDADES DE LA RESPIRACION Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R07 - DOLOR DE GARGANTA Y EN EL PECHO",
    "detalle": [
      {
        "codigo": "R070",
        "valor": "DOLOR DE GARGANTA"
      },
      {
        "codigo": "R071",
        "valor": "DOLOR EN EL PECHO AL RESPIRAR"
      },
      {
        "codigo": "R072",
        "valor": "DOLOR PRECORDIAL"
      },
      {
        "codigo": "R073",
        "valor": "OTROS DOLORES EN EL PECHO"
      },
      {
        "codigo": "R074",
        "valor": "DOLOR EN EL PECHO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "R09 - OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LOS SISTEMAS CIRCULATORIO Y RESPIRATORIO",
    "detalle": [
      {
        "codigo": "R090",
        "valor": "ASFIXIA"
      },
      {
        "codigo": "R091",
        "valor": "PLEURESIA"
      },
      {
        "codigo": "R092",
        "valor": "PARO RESPIRATORIO"
      },
      {
        "codigo": "R093",
        "valor": "ESPUTO ANORMAL"
      },
      {
        "codigo": "R098",
        "valor": "OTROS SINTOMAS Y SIGNOS ESPECIFICADOS QUE INVOLUCRAN LOS SISTEMAS CIRCULATORIO Y RESPIRATORIO"
      }
    ]
  },
  {
    "grupo": "R10 - DOLOR ABDOMINAL Y PELVICO",
    "detalle": [
      {
        "codigo": "R100",
        "valor": "ABDOMEN AGUDO"
      },
      {
        "codigo": "R101",
        "valor": "DOLOR ABDOMINAL LOCALIZADO EN PARTE SUPERIOR"
      },
      {
        "codigo": "R102",
        "valor": "DOLOR PELVICO Y PERINEAL"
      },
      {
        "codigo": "R103",
        "valor": "DOLOR LOCALIZADO EN OTRAS PARTES INFERIORES DEL ABDOMEN"
      },
      {
        "codigo": "R104",
        "valor": "OTROS DOLORES ABDOMINALES Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R11 - NAUSEA Y VOMITO",
    "detalle": [
      {
        "codigo": "R11X",
        "valor": "NAUSEA Y VOMITO"
      }
    ]
  },
  {
    "grupo": "R12 - ACIDEZ",
    "detalle": [
      {
        "codigo": "R12X",
        "valor": "ACIDEZ"
      }
    ]
  },
  {
    "grupo": "R13 - DISFAGIA",
    "detalle": [
      {
        "codigo": "R13X",
        "valor": "DISFAGIA"
      }
    ]
  },
  {
    "grupo": "R14 - FLATULENCIA Y AFECCIONES AFINES",
    "detalle": [
      {
        "codigo": "R14X",
        "valor": "FLATULENCIA Y AFECCIONES AFINES"
      }
    ]
  },
  {
    "grupo": "R15 - INCONTINENCIA FECAL",
    "detalle": [
      {
        "codigo": "R15X",
        "valor": "INCONTINENCIA FECAL"
      }
    ]
  },
  {
    "grupo": "R16 - HEPATOMEGALIA Y ESPLENOMEGALIA, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "R160",
        "valor": "HEPATOMEGALIA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "R161",
        "valor": "ESPLENOMEGALIA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "R162",
        "valor": "HEPATOMEGALIA CON ESPLENOMEGALIA, NO CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "R17 - ICTERICIA NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "R17X",
        "valor": "ICTERICIA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "R18 - ASCITIS",
    "detalle": [
      {
        "codigo": "R18X",
        "valor": "ASCITIS"
      }
    ]
  },
  {
    "grupo": "R19 - OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN EL SISTEMA DIGESTIVO Y EL ABDOMEN",
    "detalle": [
      {
        "codigo": "R190",
        "valor": "TUMEFACCION, MASA O PROMINENCIA INTRAABDOMINAL Y PELVICA"
      },
      {
        "codigo": "R191",
        "valor": "SONIDOS INTESTINALES ANORMALES"
      },
      {
        "codigo": "R192",
        "valor": "PERISTALSIS VISIBLE"
      },
      {
        "codigo": "R193",
        "valor": "RIGIDEZ ABDOMINAL"
      },
      {
        "codigo": "R194",
        "valor": "CAMBIOS EN LOS HABITOS INTESTINALES"
      },
      {
        "codigo": "R195",
        "valor": "OTRAS ANORMALIDADES FECALES"
      },
      {
        "codigo": "R196",
        "valor": "HALITOSIS"
      },
      {
        "codigo": "R198",
        "valor": "OTROS SINTOMAS Y SIGNOS ESPECIFICADOS QUE INVOLUCRAN EL SISTEMA DIGESTIVO Y EL ABDOMEN"
      }
    ]
  },
  {
    "grupo": "R20 - ALTERACIONES DE LA SENSIBILIDAD CUTANEA",
    "detalle": [
      {
        "codigo": "R200",
        "valor": "ANESTESIA DE LA PIEL"
      },
      {
        "codigo": "R201",
        "valor": "HIPOESTESIA DE LA PIEL"
      },
      {
        "codigo": "R202",
        "valor": "PARESTESIA DE LA PIEL"
      },
      {
        "codigo": "R203",
        "valor": "HIPERESTESIA"
      },
      {
        "codigo": "R208",
        "valor": "OTRAS ALTERACIONES DE LA SENSIBILIDAD CUTANEA Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R21 - SALPULLIDO Y OTRAS ERUPCIONES CUTANEAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "R21X",
        "valor": "SALPULLIDO Y OTRAS ERUPCIONES CUTANEAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R22 - TUMEFACCION, MASA O PROMINENCIA DE LA PIEL Y DEL TEJIDO SUBCUTANEO LOCALIZADAS",
    "detalle": [
      {
        "codigo": "R220",
        "valor": "TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN LA CABEZA"
      },
      {
        "codigo": "R221",
        "valor": "TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN EL CUELLO"
      },
      {
        "codigo": "R222",
        "valor": "TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN EL TRONCO"
      },
      {
        "codigo": "R223",
        "valor": "TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN EL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "R224",
        "valor": "TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN EL MIEMBRO INFERIOR"
      },
      {
        "codigo": "R227",
        "valor": "TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN SITIOS MULTIPLES"
      },
      {
        "codigo": "R229",
        "valor": "TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "R23 - OTROS CAMBIOS EN LA PIEL",
    "detalle": [
      {
        "codigo": "R230",
        "valor": "CIANOSIS"
      },
      {
        "codigo": "R231",
        "valor": "PALIDEZ"
      },
      {
        "codigo": "R232",
        "valor": "RUBOR"
      },
      {
        "codigo": "R233",
        "valor": "EQUIMOSIS ESPONTANEA"
      },
      {
        "codigo": "R234",
        "valor": "CAMBIOS EN LA TEXTURA DE LA PIEL"
      },
      {
        "codigo": "R238",
        "valor": "OTROS CAMBIOS DE LA PIEL Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R25 - MOVIMIENTOS INVOLUNTARIOS ANORMALES",
    "detalle": [
      {
        "codigo": "R250",
        "valor": "MOVIMIENTOS ANORMALES DE LA CABEZA"
      },
      {
        "codigo": "R251",
        "valor": "TEMBLOR NO ESPECIFICADO"
      },
      {
        "codigo": "R252",
        "valor": "CALAMBRES Y ESPASMOS"
      },
      {
        "codigo": "R253",
        "valor": "FASCICULACION"
      },
      {
        "codigo": "R258",
        "valor": "OTROS MOVIMIENTOS ANORMALES INVOLUNTARIOS Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R26 - ANORMALIDADES DE LA MARCHA Y DE LA MOVILIDAD",
    "detalle": [
      {
        "codigo": "R260",
        "valor": "MARCHA ATAXICA"
      },
      {
        "codigo": "R261",
        "valor": "MARCHA PARALITICA"
      },
      {
        "codigo": "R262",
        "valor": "DIFICULTAD PARA CAMINAR, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "R263",
        "valor": "INMOVILIDAD"
      },
      {
        "codigo": "R268",
        "valor": "OTRAS ANORMALIDADES DE LA MARCHA Y DE LA MOVILIDAD Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R27 - OTRAS FALLAS DE COORDINACION",
    "detalle": [
      {
        "codigo": "R270",
        "valor": "ATAXIA, NO ESPECIFICADA"
      },
      {
        "codigo": "R278",
        "valor": "OTRAS FALLAS DE LA COORDINACION Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R29 - OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LOS SISTEMAS NERVIOSO Y OSTEOMUSCULAR",
    "detalle": [
      {
        "codigo": "R290",
        "valor": "TETANIA"
      },
      {
        "codigo": "R291",
        "valor": "MENINGISMO"
      },
      {
        "codigo": "R292",
        "valor": "REFLEJOS ANORMALES"
      },
      {
        "codigo": "R293",
        "valor": "POSTURA ANORMAL"
      },
      {
        "codigo": "R294",
        "valor": "CHASQUIDO DE LA CADERA"
      },
      {
        "codigo": "R296",
        "valor": "TENDENCIA A CAER, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "R298",
        "valor": "OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LOS SISTEMAS NERVIOSO Y OSTEOMUSCULAR Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R30 - DOLOR ASOCIADO CON LA MICCION",
    "detalle": [
      {
        "codigo": "R300",
        "valor": "DISURIA"
      },
      {
        "codigo": "R301",
        "valor": "TENESMO VESICAL"
      },
      {
        "codigo": "R309",
        "valor": "MICCION DOLOROSA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "R31 - HEMATURIA, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "R31X",
        "valor": "HEMATURIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "R32 - INCONTINENCIA URINARIA, NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "R32X",
        "valor": "INCONTINENCIA URINARIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "R33 - RETENCION DE ORINA",
    "detalle": [
      {
        "codigo": "R33X",
        "valor": "RETENCION DE ORINA"
      }
    ]
  },
  {
    "grupo": "R34 - ANURIA Y OLIGURIA",
    "detalle": [
      {
        "codigo": "R34X",
        "valor": "ANURIA Y OLIGURIA"
      }
    ]
  },
  {
    "grupo": "R35 - POLIURIA",
    "detalle": [
      {
        "codigo": "R35X",
        "valor": "POLIURIA"
      }
    ]
  },
  {
    "grupo": "R36 - DESCARGA URETRAL",
    "detalle": [
      {
        "codigo": "R36X",
        "valor": "DESCARGA URETRAL"
      }
    ]
  },
  {
    "grupo": "R39 - OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN EL SISTEMA URINARIO",
    "detalle": [
      {
        "codigo": "R390",
        "valor": "EXTRAVASACION DE LA ORINA"
      },
      {
        "codigo": "R391",
        "valor": "OTRAS DIFICULTADES DE LA MICCION"
      },
      {
        "codigo": "R392",
        "valor": "UREMIA EXTRARRENAL"
      },
      {
        "codigo": "R398",
        "valor": "OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN EL SISTEMA URINARIO Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R40 - SOMNOLENCIA, ESTUPOR Y COMA",
    "detalle": [
      {
        "codigo": "R400",
        "valor": "SOMNOLENCIA"
      },
      {
        "codigo": "R401",
        "valor": "ESTUPOR"
      },
      {
        "codigo": "R402",
        "valor": "COMA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "R41 - OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LA FUNCION COGNOSCITIVA Y LA CONCIENCIA",
    "detalle": [
      {
        "codigo": "R410",
        "valor": "DESORIENTACION NO ESPECIFICADA"
      },
      {
        "codigo": "R411",
        "valor": "AMNESIA ANTEROGRADA"
      },
      {
        "codigo": "R412",
        "valor": "AMNESIA RETROGRADA"
      },
      {
        "codigo": "R413",
        "valor": "OTRA AMNESIA"
      },
      {
        "codigo": "R418",
        "valor": "OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LA FUNCION COGNOSCITIVA Y LA CONCIENCIA Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R42 - MAREO Y DESVANECIMIENTO",
    "detalle": [
      {
        "codigo": "R42X",
        "valor": "MAREO Y DESVANECIMIENTO"
      }
    ]
  },
  {
    "grupo": "R43 - TRASTORNOS DEL OLFATO Y DEL GUSTO",
    "detalle": [
      {
        "codigo": "R430",
        "valor": "ANOSMIA"
      },
      {
        "codigo": "R431",
        "valor": "PAROSMIA"
      },
      {
        "codigo": "R432",
        "valor": "PARAGEUSIA"
      },
      {
        "codigo": "R438",
        "valor": "OTRAS ALTERACIONES DEL GUSTO Y DEL OLFATO Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R44 - OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LAS SENSACIONES Y PERCEPCIONES",
    "detalle": [
      {
        "codigo": "R440",
        "valor": "ALUCINACIONES AUDITIVAS"
      },
      {
        "codigo": "R441",
        "valor": "ALUCINACIONES VISUALES"
      },
      {
        "codigo": "R442",
        "valor": "OTRAS ALUCINACIONES"
      },
      {
        "codigo": "R443",
        "valor": "ALUCINACIONES, NO ESPECIFICADAS"
      },
      {
        "codigo": "R448",
        "valor": "OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LAS SENSACIONES Y PERCEPCIONES GENERALES Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R45 - SINTOMAS Y SIGNOS QUE INVOLUCRAN EL ESTADO EMOCIONAL",
    "detalle": [
      {
        "codigo": "R450",
        "valor": "NERVIOSISMO"
      },
      {
        "codigo": "R451",
        "valor": "INQUIETUD Y AGITACION"
      },
      {
        "codigo": "R452",
        "valor": "INFELICIDAD"
      },
      {
        "codigo": "R453",
        "valor": "DESMORALIZACION Y APATIA"
      },
      {
        "codigo": "R454",
        "valor": "IRRITABILIDAD Y ENOJO"
      },
      {
        "codigo": "R455",
        "valor": "HOSTILIDAD"
      },
      {
        "codigo": "R456",
        "valor": "VIOLENCIA FISICA"
      },
      {
        "codigo": "R457",
        "valor": "TENSION Y ESTADO DE CHOQUE EMOCIONAL, NO ESPECIFICADO"
      },
      {
        "codigo": "R458",
        "valor": "OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN EL ESTADO EMOCIONAL"
      }
    ]
  },
  {
    "grupo": "R46 - SINTOMAS Y SIGNOS QUE INVOLUCRAN LA APARIENCIA Y EL COMPORTAMIENTO",
    "detalle": [
      {
        "codigo": "R460",
        "valor": "MUY BAJO NIVEL DE HIGIENE PERSONAL"
      },
      {
        "codigo": "R461",
        "valor": "APARIENCIA PERSONAL EXTRAÑA"
      },
      {
        "codigo": "R462",
        "valor": "CONDUCTA EXTRAÑA E INEXPLICABLE"
      },
      {
        "codigo": "R463",
        "valor": "HIPERACTIVIDAD"
      },
      {
        "codigo": "R464",
        "valor": "LENTITUD Y POBRE RESPUESTA"
      },
      {
        "codigo": "R465",
        "valor": "SUSPICACIA Y EVASIVIDAD MARCADAS"
      },
      {
        "codigo": "R466",
        "valor": "PREOCUPACION INDEBIDA POR SUCESOS QUE CAUSAN TENSION"
      },
      {
        "codigo": "R467",
        "valor": "VERBOSIDAD Y DETALLES CIRCUNSTANCIALES QUE OSCURECEN LA RAZON DE LA CONSULTA O EL CONTACTO"
      },
      {
        "codigo": "R468",
        "valor": "OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LA APARIENCIA Y EL COMPORTAMIENTO"
      }
    ]
  },
  {
    "grupo": "R47 - ALTERACIONES DEL HABLA, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "R470",
        "valor": "DISFASIA Y AFASIA"
      },
      {
        "codigo": "R471",
        "valor": "DISARTRIA Y ANARTRIA"
      },
      {
        "codigo": "R478",
        "valor": "OTRAS ALTERACIONES DEL HABLA Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R48 - DISLEXIA Y OTRAS DISFUNCIONES SIMBOLICAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "R480",
        "valor": "DISLEXIA Y ALEXIA"
      },
      {
        "codigo": "R481",
        "valor": "AGNOSIA"
      },
      {
        "codigo": "R482",
        "valor": "APRAXIA"
      },
      {
        "codigo": "R488",
        "valor": "OTRAS DISFUNCIONES SIMBOLICAS Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R49 - ALTERACIONES DE LA VOZ",
    "detalle": [
      {
        "codigo": "R490",
        "valor": "DISFONIA"
      },
      {
        "codigo": "R491",
        "valor": "AFONIA"
      },
      {
        "codigo": "R492",
        "valor": "HIPERNASALIDAD E HIPONASALIDAD"
      },
      {
        "codigo": "R498",
        "valor": "OTRAS ALTERACIONES DE LA VOZ Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R50 - FIEBRE DE ORIGEN DESCONOCIDO",
    "detalle": [
      {
        "codigo": "R500",
        "valor": "FIEBRE CON ESCALOFRIO"
      },
      {
        "codigo": "R501",
        "valor": "FIEBRE PERSISTENTE"
      },
      {
        "codigo": "R502",
        "valor": "FIEBRE INDUCIDA POR DROGAS"
      },
      {
        "codigo": "R508",
        "valor": "OTRAS FIEBRES ESPECIFICADAS"
      },
      {
        "codigo": "R509",
        "valor": "FIEBRE, NO ESPECIFICADA"
      },
      {
        "codigo": "R5091",
        "valor": "FEBRIL SOSPECHOSO DE MALARIA"
      }
    ]
  },
  {
    "grupo": "R51 - CEFALEA",
    "detalle": [
      {
        "codigo": "R51X",
        "valor": "CEFALEA"
      }
    ]
  },
  {
    "grupo": "R52 - DOLOR, NO CLASIFICADO EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "R520",
        "valor": "DOLOR AGUDO"
      },
      {
        "codigo": "R521",
        "valor": "DOLOR CRONICO INTRATABLE"
      },
      {
        "codigo": "R522",
        "valor": "OTRO DOLOR CRONICO"
      },
      {
        "codigo": "R529",
        "valor": "DOLOR, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "R53 - MALESTAR Y FATIGA",
    "detalle": [
      {
        "codigo": "R53X",
        "valor": "MALESTAR Y FATIGA"
      }
    ]
  },
  {
    "grupo": "R54 - SENILIDAD",
    "detalle": [
      {
        "codigo": "R54X",
        "valor": "SENILIDAD"
      }
    ]
  },
  {
    "grupo": "R55 - SINCOPE Y COLAPSO",
    "detalle": [
      {
        "codigo": "R55X",
        "valor": "SINCOPE Y COLAPSO"
      }
    ]
  },
  {
    "grupo": "R56 - CONVULSIONES, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "R560",
        "valor": "CONVULSIONES FEBRILES"
      },
      {
        "codigo": "R568",
        "valor": "OTRAS CONVULSIONES Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R57 - CHOQUE, NO CLASIFICADO EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "R570",
        "valor": "CHOQUE CARDIOGENICO"
      },
      {
        "codigo": "R571",
        "valor": "CHOQUE HIPOVOLEMICO"
      },
      {
        "codigo": "R572",
        "valor": "CHOQUE SEPTICO"
      },
      {
        "codigo": "R578",
        "valor": "OTRAS FORMAS DE CHOQUE"
      },
      {
        "codigo": "R579",
        "valor": "CHOQUE, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "R58 - HEMORRAGIA, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "R58X",
        "valor": "HEMORRAGIA, NO CLASIFICADA EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "R59 - ADENOMEGALIA",
    "detalle": [
      {
        "codigo": "R590",
        "valor": "ADENOMEGALIA LOCALIZADA"
      },
      {
        "codigo": "R591",
        "valor": "ADENOMEGALIA GENERALIZADA"
      },
      {
        "codigo": "R599",
        "valor": "ADENOMEGALIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "R60 - EDEMA, NO CLASIFICADO EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "R600",
        "valor": "EDEMA LOCALIZADO"
      },
      {
        "codigo": "R601",
        "valor": "EDEMA GENERALIZADO"
      },
      {
        "codigo": "R609",
        "valor": "EDEMA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "R61 - HIPERHIDROSIS",
    "detalle": [
      {
        "codigo": "R610",
        "valor": "HIPERHIDROSIS LOCALIZADA"
      },
      {
        "codigo": "R611",
        "valor": "HIPERHIDROSIS GENERALIZADA"
      },
      {
        "codigo": "R619",
        "valor": "HIPERHIDROSIS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "R62 - FALTA DEL DESARROLLO FISIOLOGICO NORMAL ESPERADO",
    "detalle": [
      {
        "codigo": "R620",
        "valor": "RETARDO DEL DESARROLLO"
      },
      {
        "codigo": "R6201",
        "valor": "RIESGO EN EL AREA DEL LENGUAJE"
      },
      {
        "codigo": "R6202",
        "valor": "RIESGO EN EL AREA MOTORA"
      },
      {
        "codigo": "R628",
        "valor": "OTRAS FALTAS DEL DESARROLLO FISIOLOGICO NORMAL ESPERADO"
      },
      {
        "codigo": "R6281",
        "valor": "RIESGO EN EL AREA SOCIAL"
      },
      {
        "codigo": "R6282",
        "valor": "RIESGO EN EL AREA DE COORDINACION"
      },
      {
        "codigo": "R629",
        "valor": "FALTA DEL DESARROLLO FISIOLOGICO NORMAL ESPERADO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "R6291",
        "valor": "RIESGO EN EL DESARROLLO PSICOMOTOR"
      }
    ]
  },
  {
    "grupo": "R63 - SINTOMAS Y SIGNOS CONCERNIENTES A LA ALIMENTACION Y A LA INGESTION DE LIQUIDOS",
    "detalle": [
      {
        "codigo": "R630",
        "valor": "ANOREXIA"
      },
      {
        "codigo": "R631",
        "valor": "POLIDIPSIA"
      },
      {
        "codigo": "R632",
        "valor": "POLIFAGIA"
      },
      {
        "codigo": "R633",
        "valor": "DIFICULTADES Y MALA ADMINISTRACION DE LA ALIMENTACION"
      },
      {
        "codigo": "R634",
        "valor": "PERDIDA ANORMAL DE PESO"
      },
      {
        "codigo": "R635",
        "valor": "AUMENTO ANORMAL DE PESO"
      },
      {
        "codigo": "R636",
        "valor": "INGESTA INSUFICIENTE DE ALIMENTOS Y AGUA DEBIDA A DESCUIDO PERSONAL"
      },
      {
        "codigo": "R638",
        "valor": "OTROS SINTOMAS Y SIGNOS CONCERNIENTES A LA ALIMENTACION Y A LA INGESTION DE LIQUIDOS"
      }
    ]
  },
  {
    "grupo": "R64 - CAQUEXIA",
    "detalle": [
      {
        "codigo": "R64X",
        "valor": "CAQUEXIA"
      }
    ]
  },
  {
    "grupo": "R65 - SINDROME DE RESPUESTA INFLAMATORIA SISTEMICA",
    "detalle": [
      {
        "codigo": "R650",
        "valor": "SINDROME DE RESPUESTA INFLAMATORIA SISTEMICA DE ORIGEN INFECCIOSO, SIN FALLA ORGANICA"
      },
      {
        "codigo": "R651",
        "valor": "SINDROME DE RESPUESTA INFLAMATORIA SISTEMICA DE ORIGEN INFECCIOSO, CON FALLA ORGANICA"
      },
      {
        "codigo": "R652",
        "valor": "SINDROME DE RESPUESTA INFLAMATORIA SISTEMICA DE ORIGEN NO INFECCIOSO, SIN FALLA ORGANICA"
      },
      {
        "codigo": "R653",
        "valor": "SINDROME DE RESPUESTA INFLAMATORIA SISTEMICA DE ORIGEN NO INFECCIOSO, CON FALLA ORGANICA"
      },
      {
        "codigo": "R659",
        "valor": "SINDROME DE RESPUESTA INFLAMATORIA SISTEMICA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "R68 - OTROS SINTOMAS Y SIGNOS GENERALES",
    "detalle": [
      {
        "codigo": "R680",
        "valor": "HIPOTERMIA NO ASOCIADA CON BAJA TEMPERATURA DEL AMBIENTE"
      },
      {
        "codigo": "R681",
        "valor": "SINTOMAS NO ESPECIFICOS PROPIOS DE LA INFANCIA"
      },
      {
        "codigo": "R682",
        "valor": "BOCA SECA, NO ESPECIFICADA"
      },
      {
        "codigo": "R683",
        "valor": "DEDOS DE LA MANO DEFORMES"
      },
      {
        "codigo": "R688",
        "valor": "OTROS SINTOMAS Y SIGNOS GENERALES ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R69 - CAUSAS DE MORBILIDAD DESCONOCIDAS Y NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "R69X",
        "valor": "CAUSAS DE MORBILIDAD DESCONOCIDAS Y NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "R70 - VELOCIDAD DE ERITROSEDIMENTACION ELEVADA Y OTRAS ANORMALIDADES DE LA VISCOSIDAD DEL PLASMA",
    "detalle": [
      {
        "codigo": "R700",
        "valor": "VELOCIDAD DE ERITROSEDIMENTACION ELEVADA"
      },
      {
        "codigo": "R701",
        "valor": "VISCOSIDAD PLASMATICA ANORMAL"
      }
    ]
  },
  {
    "grupo": "R71 - ANORMALIDAD DE LOS ERITROCITOS",
    "detalle": [
      {
        "codigo": "R71X",
        "valor": "ANORMALIDAD DE LOS ERITROCITOS"
      }
    ]
  },
  {
    "grupo": "R72 - ANORMALIDADES DE LOS LEUCOCITOS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "R72X",
        "valor": "ANORMALIDADES DE LOS LEUCOCITOS, NO CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "R73 - NIVEL ELEVADO DE GLUCOSA EN SANGRE",
    "detalle": [
      {
        "codigo": "R730",
        "valor": "ANORMALIDADES EN LA PRUEBA DE TOLERANCIA A LA GLUCOSA"
      },
      {
        "codigo": "R739",
        "valor": "HIPERGLICEMIA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "R74 - NIVEL ANORMAL DE ENZIMAS EN SUERO",
    "detalle": [
      {
        "codigo": "R740",
        "valor": "ELEVACION DE LOS NIVELES DE TRANSAMINASAS O DESHIDROGENASA LACTICA [DHL]"
      },
      {
        "codigo": "R748",
        "valor": "NIVELES ANORMALES DE OTRAS ENZIMAS EN SUERO"
      },
      {
        "codigo": "R749",
        "valor": "NIVEL ANORMAL DE ENZIMAS EN SUERO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "R75 - EVIDENCIAS DE LABORATORIO DEL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]",
    "detalle": [
      {
        "codigo": "R75X",
        "valor": "EVIDENCIAS DE LABORATORIO DEL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]"
      }
    ]
  },
  {
    "grupo": "R76 - OTROS HALLAZGOS INMUNOLOGICOS ANORMALES EN SUERO",
    "detalle": [
      {
        "codigo": "R760",
        "valor": "TITULACION ELEVADA DE ANTICUERPOS"
      },
      {
        "codigo": "R761",
        "valor": "REACCION ANORMAL A LA PRUEBA CON TUBERCULINA"
      },
      {
        "codigo": "R762",
        "valor": "FALSO POSITIVO EN LA PRUEBA SEROLOGICA PARA SIFILIS"
      },
      {
        "codigo": "R768",
        "valor": "OTROS HALLAZGOS INMUNOLOGICOS ANORMALES ESPECIFICADOS EN SUERO"
      },
      {
        "codigo": "R769",
        "valor": "HALLAZGOS INMUNOLOGICOS ANORMALES NO ESPECIFICADOS EN SUERO"
      }
    ]
  },
  {
    "grupo": "R77 - OTRAS ANORMALIDADES DE LAS PROTEINAS PLASMATICAS",
    "detalle": [
      {
        "codigo": "R770",
        "valor": "ANORMALIDAD DE LA ALBUMINA"
      },
      {
        "codigo": "R771",
        "valor": "ANORMALIDAD DE LA GLOBULINA"
      },
      {
        "codigo": "R772",
        "valor": "ANORMALIDAD DE LA ALFAFETOPROTEINA"
      },
      {
        "codigo": "R778",
        "valor": "OTRAS ANORMALIDADES ESPECIFICADAS DE LAS PROTEINAS PLASMATICAS"
      },
      {
        "codigo": "R779",
        "valor": "ANORMALIDADES NO ESPECIFICADAS DE LAS PROTEINAS PLASMATICAS"
      }
    ]
  },
  {
    "grupo": "R78 - HALLAZGO DE DROGAS Y OTRAS SUSTANCIAS QUE NORMALMENTE NO SE ENCUENTRAN EN LA SANGRE",
    "detalle": [
      {
        "codigo": "R780",
        "valor": "HALLAZGO DE ALCOHOL EN LA SANGRE"
      },
      {
        "codigo": "R781",
        "valor": "HALLAZGO DE DROGAS OPIACEAS EN LA SANGRE"
      },
      {
        "codigo": "R782",
        "valor": "HALLAZGO DE COCAINA EN LA SANGRE"
      },
      {
        "codigo": "R783",
        "valor": "HALLAZGO DE ALUCINOGENOS EN LA SANGRE"
      },
      {
        "codigo": "R784",
        "valor": "HALLAZGO DE OTRAS DROGAS POTENCIALMENTE ADICTIVAS EN LA SANGRE"
      },
      {
        "codigo": "R785",
        "valor": "HALLAZGO DE DROGAS PSICOTROPICAS EN LA SANGRE"
      },
      {
        "codigo": "R786",
        "valor": "HALLAZGO DE AGENTES ESTEROIDES EN LA SANGRE"
      },
      {
        "codigo": "R787",
        "valor": "HALLAZGO DE NIVELES ANORMALES DE METALES PESADOS EN LA SANGRE"
      },
      {
        "codigo": "R788",
        "valor": "HALLAZGO DE OTRAS SUSTANCIAS ESPECIFICADAS QUE NORMALMENTE NO SE ENCUENTRAN EN LA SANGRE"
      },
      {
        "codigo": "R789",
        "valor": "HALLAZGO DE SUSTANCIA NO ESPECIFICADA QUE NORMALMENTE NO SE ENCUENTRA EN LA SANGRE"
      }
    ]
  },
  {
    "grupo": "R79 - OTROS HALLAZGOS ANORMALES EN LA QUIMICA SANGUINEA",
    "detalle": [
      {
        "codigo": "R790",
        "valor": "NIVEL ANORMAL DE MINERAL EN LA SANGRE"
      },
      {
        "codigo": "R798",
        "valor": "OTROS HALLAZGOS ANORMALES ESPECIFICADOS EN LA QUIMICA SANGUINEA"
      },
      {
        "codigo": "R799",
        "valor": "HALLAZGO ANORMAL EN LA QUIMICA SANGUINEA, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "R80 - PROTEINURIA AISLADA",
    "detalle": [
      {
        "codigo": "R80X",
        "valor": "PROTEINURIA AISLADA"
      }
    ]
  },
  {
    "grupo": "R81 - GLUCOSURIA",
    "detalle": [
      {
        "codigo": "R81X",
        "valor": "GLUCOSURIA"
      }
    ]
  },
  {
    "grupo": "R82 - OTROS HALLAZGOS ANORMALES EN LA ORINA",
    "detalle": [
      {
        "codigo": "R820",
        "valor": "QUILURIA"
      },
      {
        "codigo": "R821",
        "valor": "MIOGLOBINURIA"
      },
      {
        "codigo": "R822",
        "valor": "BILIURIA"
      },
      {
        "codigo": "R823",
        "valor": "HEMOGLOBINURIA"
      },
      {
        "codigo": "R824",
        "valor": "ACETONURIA"
      },
      {
        "codigo": "R825",
        "valor": "ELEVACION DE LOS NIVELES DE DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS EN LA ORINA"
      },
      {
        "codigo": "R826",
        "valor": "NIVELES ANORMALES EN LA ORINA DE SUSTANCIAS DE ORIGEN PRINCIPALMENTE NO MEDICINAL"
      },
      {
        "codigo": "R827",
        "valor": "HALLAZGOS ANORMALES EN EL EXAMEN MICROBIOLOGICO DE LA ORINA"
      },
      {
        "codigo": "R828",
        "valor": "HALLAZGOS ANORMALES EN EL EXAMEN CITOLOGICO E HISTOLOGICO DE LA ORINA"
      },
      {
        "codigo": "R829",
        "valor": "OTROS HALLAZGOS ANORMALES EN LA ORINA Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R83 - HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO",
    "detalle": [
      {
        "codigo": "R830",
        "valor": "HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO, NIVEL ANORMAL DE ENZIMAS"
      },
      {
        "codigo": "R831",
        "valor": "HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO, NIVEL ANORMAL DE HORMONAS"
      },
      {
        "codigo": "R832",
        "valor": "HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO, NIVEL ANORMAL DE OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS"
      },
      {
        "codigo": "R833",
        "valor": "HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO, NIVEL ANORMAL DE SUSTANCIAS DE ORIGEN FUNDAMENTALMENTE NO MEDICINAL"
      },
      {
        "codigo": "R834",
        "valor": "HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO, HALLAZGOS INMUNOLOGICOS ANORMALES"
      },
      {
        "codigo": "R835",
        "valor": "HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO, HALLAZGOS MICROBIOLOGICOS ANORMALES, HALLAZGOS POSITIVOS EN EL CULTIVO"
      },
      {
        "codigo": "R836",
        "valor": "HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO, HALLAZGOS CITOLOGICOS ANORMALES, FROTIS ANORMAL DE PAPANICOLAOU"
      },
      {
        "codigo": "R837",
        "valor": "HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO, HALLAZGOS HISTOLOGICOS ANORMALES"
      },
      {
        "codigo": "R838",
        "valor": "HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO, OTROS HALLAZGOS ANORMALES, HALLAZGOS CROMOSOMICOS ANORMALES"
      },
      {
        "codigo": "R839",
        "valor": "HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO, HALLAZGOS ANORMALES NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R84 - HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS",
    "detalle": [
      {
        "codigo": "R840",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS, NIVEL ANORMAL DE ENZIMAS"
      },
      {
        "codigo": "R841",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS, NIVEL ANORMAL DE HORMONAS"
      },
      {
        "codigo": "R842",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS,NIVEL ANORMAL DE OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS"
      },
      {
        "codigo": "R843",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS, NIVEL ANORMAL DE SUSTANCIAS DE ORIGEN FUNDAMENTALMENTE NO MEDICINAL"
      },
      {
        "codigo": "R844",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS, HALLAZGOS INMUNOLOGICOS ANORMALES"
      },
      {
        "codigo": "R845",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS, HALLAZGOS MICROBIOLOGICOS ANORMALES, HALLAZGOS POSITIVOS EN EL CULTIVO"
      },
      {
        "codigo": "R846",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS, HALLAZGOS CITOLOGICOS ANORMALES, FROTIS ANORMAL DE PAPANICOLAOU"
      },
      {
        "codigo": "R847",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS, HALLAZGOS HISTOLOGICOS ANORMALES"
      },
      {
        "codigo": "R848",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIAS Y TORACICOS OTROS HALLAZGOS ANORMALES, HALLAZGOS CROMOSOMICOS ANORMALES"
      },
      {
        "codigo": "R849",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS, HALLAZGOS ANORMALES NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R85 - HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CABIDAD ABDOMINAL",
    "detalle": [
      {
        "codigo": "R850",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL, NIVEL ANORMAL DE ENZIMAS"
      },
      {
        "codigo": "R851",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL, NIVEL ANORMAL DE HORMONAS"
      },
      {
        "codigo": "R852",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESIVOS Y DE LA CAVIDAD ABDOMINAL, NIVEL ANORMAL DE OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS"
      },
      {
        "codigo": "R853",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL, NIVEL ANORMAL DE SUSTANCIAS DE ORIGEN FUNDAMENTALMENTE NO MEDICINAL"
      },
      {
        "codigo": "R854",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL, HALLAZGOS INMUNOLOGICOS ANORMALES"
      },
      {
        "codigo": "R855",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL, HALLAZGOS MICROBIOLOGICOS ANORMALES, HALLAZGOS POSITIVOS EN EL CULTIVO"
      },
      {
        "codigo": "R856",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL, HALLAZGOS CITOLOGICOS ANORMALES, FROTIS ANORMAL DE PAPANICOLAOU"
      },
      {
        "codigo": "R857",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL, HALLAZGOS HISTOLOGICOS ANORMALES"
      },
      {
        "codigo": "R858",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL, OTROS HALLAZGOS ANORMALES, HALLAZGOS CROMOSOMICOS ANORMALES"
      },
      {
        "codigo": "R859",
        "valor": "HALLAZGOS ANORMALES EN MUESTRA TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL, HALLAZGOS ANORMALES NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R86 - HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINO",
    "detalle": [
      {
        "codigo": "R860",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS, NIVEL ANORMAL DE ENZIMAS"
      },
      {
        "codigo": "R861",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS, NIVEL ANORMAL DE HORMONAS"
      },
      {
        "codigo": "R862",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS, NIVEL ANORMAL DE OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS"
      },
      {
        "codigo": "R863",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS, NIVEL ANORMAL DE SUSTANCIAS DE ORIGEN FUNDAMENTALMENTE NO MEDICINAL"
      },
      {
        "codigo": "R864",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS, HALLAZGOS INMUNOLOGICOS ANORMALES"
      },
      {
        "codigo": "R865",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS, HALLAZGOS MICROBIOLOGICOS ANORMALES, HALLAZGOS POSITIVOS EN EL CULTIVO"
      },
      {
        "codigo": "R866",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS, HALLAZGOS CITOLOGICOS ANORMALES, FROTIS ANORMAL DE PAPANICOLAOU"
      },
      {
        "codigo": "R867",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS, HALLAZGOS HISTOLOGICOS ANORMALES"
      },
      {
        "codigo": "R868",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS, OTROS HALLAZGOS ANORMALES, HALLAZGOS CROMOSOMICOS ANORMALES"
      },
      {
        "codigo": "R869",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS, HALLAZGOS ANORMALES NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R87 - HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS",
    "detalle": [
      {
        "codigo": "R870",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS, NIVEL ANORMAL DE ENZIMAS"
      },
      {
        "codigo": "R871",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS, NIVEL ANORMAL DE HORMONAS"
      },
      {
        "codigo": "R872",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS, NIVEL ANORMAL DE OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS."
      },
      {
        "codigo": "R873",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS, NIVEL ANORMAL DE SUSTANCIAS DE ORIGEN FUNDAMENTALMENTE NO MEDICINAL"
      },
      {
        "codigo": "R874",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS, HALLAZGOS INMUNOLOGICOS ANORMALES"
      },
      {
        "codigo": "R875",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS, HALLAZGOS MICROBIOLOGICOS ANORMALES, HALLAZGOS POSITIVOS EN EL CULTIVO"
      },
      {
        "codigo": "R876",
        "valor": "HALLAZGOS ANORMALES.EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS, HALLAZGOS CITOLOGICOS ANORMALES, FROTIS ANORMAL DE PAPANICOLAOU"
      },
      {
        "codigo": "R877",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS, HALLAZGOS HISTOLOGICOS ANORMALES"
      },
      {
        "codigo": "R878",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS, OTROS HALLAZGOS ANORMALES, HALLAZGOS CROMOSOMICOS ANORMALES"
      },
      {
        "codigo": "R879",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS, HALLAZGOS ANORMALES, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "R89 - HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS",
    "detalle": [
      {
        "codigo": "R890",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS, NIVEL ANORMAL DE ENZIMAS"
      },
      {
        "codigo": "R891",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS, NIVEL ANORMAL DE HORMONAS"
      },
      {
        "codigo": "R892",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS, NIVEL ANORMAL DE OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS"
      },
      {
        "codigo": "R893",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS, NIVEL ANORMAL DE SUSTANCIAS DE ORIGEN FUNDAMENTALMENTE NO MEDICINAL"
      },
      {
        "codigo": "R894",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS, HALLAZGOS INMUNOLOGICOS ANORMALES"
      },
      {
        "codigo": "R895",
        "valor": "HALLAZGOS ANORMALES EN MUESTRA TOMADAS DE OTROS ORGANOS , SISTEMAS Y TEJIDOS, HALLAZGOS MICROBIOLOGICOS ANORMALES, HALLAZGOS POSITIVOS EN EL CULTIVO"
      },
      {
        "codigo": "R896",
        "valor": "HALLAZGOS ANORMALES EN MUESTRA TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS, HALLAZGOS CITOLOGICOS ANORMALES, FROTIS ANORMAL DE PAPANICOLAOU"
      },
      {
        "codigo": "R897",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS, HALLAZGOS HISTOLOGICOS ANORMALES"
      },
      {
        "codigo": "R898",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS, OTROS HALLAZGOS ANORMALES, HALLAZGOS CROMOSOMICOS ANORMALES"
      },
      {
        "codigo": "R899",
        "valor": "HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS, HALLAZGOS ANORMALES NO ESPECIFICADOS."
      }
    ]
  },
  {
    "grupo": "R90 - HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DEL SISTEMA NERVIOSO CENTRAL",
    "detalle": [
      {
        "codigo": "R900",
        "valor": "LESION QUE OCUPA EL ESPACIO INTRACRANEAL"
      },
      {
        "codigo": "R908",
        "valor": "OTROS HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DEL SISTEMA NERVIOSO CENTRAL"
      }
    ]
  },
  {
    "grupo": "R91 - HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DEL PULMON",
    "detalle": [
      {
        "codigo": "R91X",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DEL PULMON"
      }
    ]
  },
  {
    "grupo": "R92 - HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE LA MAMA",
    "detalle": [
      {
        "codigo": "R92X",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE LA MAMA"
      }
    ]
  },
  {
    "grupo": "R93 - HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE OTRAS ESTRUCTURAS DEL CUERPO",
    "detalle": [
      {
        "codigo": "R930",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DEL CRANEO Y DE LA CABEZA, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "R931",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DEL CORAZON Y DE LA CIRCULACION CORONARIA"
      },
      {
        "codigo": "R932",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DEL HIGADO Y DE LAS VIAS BILIARES"
      },
      {
        "codigo": "R933",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE OTRAS PARTES DE LAS VIAS DIGESTIVAS"
      },
      {
        "codigo": "R934",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE LOS ORGANOS URINARIOS"
      },
      {
        "codigo": "R935",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE OTRAS REGIONES ABDOMINALES, INCLUIDO EL RETROPERITONEO"
      },
      {
        "codigo": "R936",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE LOS MIEMBROS"
      },
      {
        "codigo": "R937",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE OTRAS PARTES DEL SISTEMA OSTEOMUSCULAR"
      },
      {
        "codigo": "R938",
        "valor": "HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE OTRAS ESTRUCTURAS ESPECIFICADAS DEL CUERPO"
      }
    ]
  },
  {
    "grupo": "R94 - RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES",
    "detalle": [
      {
        "codigo": "R940",
        "valor": "RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DEL SISTEMA NERVIOSO CENTRAL"
      },
      {
        "codigo": "R941",
        "valor": "RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DEL SISTEMA NERVIOSO PERIFERICO Y SENTIDOS ESPECIALES"
      },
      {
        "codigo": "R942",
        "valor": "RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DEL PULMON"
      },
      {
        "codigo": "R943",
        "valor": "RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES CARDIOVASCULARES"
      },
      {
        "codigo": "R944",
        "valor": "RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DEL RIÑON"
      },
      {
        "codigo": "R945",
        "valor": "RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DEL HIGADO"
      },
      {
        "codigo": "R946",
        "valor": "RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DE LA TIROIDES"
      },
      {
        "codigo": "R947",
        "valor": "RESULTADOS ANORMALES EN OTROS ESTUDIOS FUNCIONALES ENDOCRINOS"
      },
      {
        "codigo": "R948",
        "valor": "RESULTADOS ANORMALES EN LOS ESTUDIOS FUNCIONALES DE OTROS ORGANOS Y SISTEMAS"
      }
    ]
  },
  {
    "grupo": "R95 - SINDROME DE LA MUERTE SUBITA INFANTIL",
    "detalle": [
      {
        "codigo": "R950",
        "valor": "SINDROME DE LA MUERTE SUBITA INFANTIL, CON MENCION DE AUTOPSIA"
      },
      {
        "codigo": "R959",
        "valor": "SINDROME DE LA MUERTE SUBITA INFANTIL, SIN MENCION DE AUTOPSIA"
      },
      {
        "codigo": "R95X",
        "valor": "SINDROME DE LA MUERTE SUBITA INFANTIL"
      }
    ]
  },
  {
    "grupo": "R96 - OTRAS MUERTES SUBITAS DE CAUSA DESCONOCIDA",
    "detalle": [
      {
        "codigo": "R960",
        "valor": "MUERTE INSTANTANEA"
      },
      {
        "codigo": "R961",
        "valor": "MUERTE QUE OCURRE EN MENOS DE 24 HORAS DEL INICIO DE LOS SINTOMAS, NO EXPLICADA DE OTRA FORMA"
      }
    ]
  },
  {
    "grupo": "R98 - MUERTE SIN ASISTENCIA",
    "detalle": [
      {
        "codigo": "R98X",
        "valor": "MUERTE SIN ASISTENCIA"
      }
    ]
  },
  {
    "grupo": "R99 - OTRAS CAUSAS MAL DEFINIDAS Y LAS NO ESPECIFICADAS DE MORTALIDAD",
    "detalle": [
      {
        "codigo": "R99X",
        "valor": "OTRAS CAUSAS MAL DEFINIDAS Y LAS NO ESPECIFICADAS DE MORTALIDAD"
      }
    ]
  },
  {
    "grupo": "S00 - TRAUMATISMO SUPERFICIAL DE LA CABEZA",
    "detalle": [
      {
        "codigo": "S000",
        "valor": "TRAUMATISMO SUPERFICIAL DEL CUERO CABELLUDO"
      },
      {
        "codigo": "S001",
        "valor": "CONTUSION DE LOS PARPADOS Y DE LA REGION PERIOCULAR"
      },
      {
        "codigo": "S002",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES DEL PARPADO Y DE LA REGION PERIOCULAR"
      },
      {
        "codigo": "S003",
        "valor": "TRAUMATISMO SUPERFICIAL DE LA NARIZ"
      },
      {
        "codigo": "S004",
        "valor": "TRAUMATISMO SUPERFICIAL DEL OIDO"
      },
      {
        "codigo": "S005",
        "valor": "TRAUMATISMO SUPERFICIAL DEL LABIO Y DE LA CAVIDAD BUCAL"
      },
      {
        "codigo": "S007",
        "valor": "TRAUMATISMOS SUPERFICIALES MULTIPLES DE LA CABEZA"
      },
      {
        "codigo": "S008",
        "valor": "TRAUMATISMO SUPERFICIAL DE OTRAS PARTES DE LA CABEZA"
      },
      {
        "codigo": "S009",
        "valor": "TRAUMATISMO SUPERFICIAL DE LA CABEZA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S01 - HERIDA DE LA CABEZA",
    "detalle": [
      {
        "codigo": "S010",
        "valor": "HERIDA DEL CUERO CABELLUDO"
      },
      {
        "codigo": "S011",
        "valor": "HERIDA DEL PARPADO Y DE LA REGION PERIOCULAR"
      },
      {
        "codigo": "S012",
        "valor": "HERIDA DE LA NARIZ"
      },
      {
        "codigo": "S013",
        "valor": "HERIDA DEL OIDO"
      },
      {
        "codigo": "S014",
        "valor": "HERIDA DE LA MEJILLA Y DE LA REGION TEMPOROMANDIBULAR"
      },
      {
        "codigo": "S015",
        "valor": "HERIDA DEL LABIO Y DE LA CAVIDAD BUCAL"
      },
      {
        "codigo": "S017",
        "valor": "HERIDAS MULTIPLES DE LA CABEZA"
      },
      {
        "codigo": "S018",
        "valor": "HERIDA DE OTRAS PARTES DE LA CABEZA"
      },
      {
        "codigo": "S019",
        "valor": "HERIDA DE LA CABEZA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S02 - FRACTURA DE HUESOS DEL CRANEO Y DE LA CARA",
    "detalle": [
      {
        "codigo": "S020",
        "valor": "FRACTURA DE LA BOVEDA DEL CRANEO"
      },
      {
        "codigo": "S021",
        "valor": "FRACTURA DE LA BASE DEL CRANEO"
      },
      {
        "codigo": "S022",
        "valor": "FRACTURA DE LOS HUESOS DE LA NARIZ"
      },
      {
        "codigo": "S023",
        "valor": "FRACTURA DEL SUELO DE LA ORBITA"
      },
      {
        "codigo": "S024",
        "valor": "FRACTURA DEL MALAR Y DEL HUESO MAXILAR SUPERIOR"
      },
      {
        "codigo": "S025",
        "valor": "FRACTURA DE LOS DIENTES"
      },
      {
        "codigo": "S026",
        "valor": "FRACTURA DEL MAXILAR INFERIOR"
      },
      {
        "codigo": "S027",
        "valor": "FRACTURAS MULTIPLES QUE COMPROMETEN EL CRANEO Y LOS HUESOS DE LA CARA"
      },
      {
        "codigo": "S028",
        "valor": "FRACTURA DE OTROS HUESOS DEL CRANEO Y DE LA CARA"
      },
      {
        "codigo": "S029",
        "valor": "FRACTURA DEL CRANEO Y DE LOS HUESOS DE LA CARA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S03 - LUXACION, ESGUINCE Y TORCEDURA DE ARTICULACIONES Y DE LIGAMENTOS DE LA CABEZA",
    "detalle": [
      {
        "codigo": "S030",
        "valor": "LUXACION DEL MAXILAR"
      },
      {
        "codigo": "S031",
        "valor": "LUXACION DEL CARTILAGO SEPTAL DE LA NARIZ"
      },
      {
        "codigo": "S032",
        "valor": "LUXACION DE DIENTE"
      },
      {
        "codigo": "S033",
        "valor": "LUXACION DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CABEZA"
      },
      {
        "codigo": "S034",
        "valor": "ESGUINCES Y TORCEDURAS DEL MAXILAR"
      },
      {
        "codigo": "S035",
        "valor": "ESGUINCES Y TORCEDURAS DE ARTICULACIONES Y LIGAMENTOS DE OTRAS PARTES Y LAS NO ESPECIFICADAS DE LA CABEZA"
      }
    ]
  },
  {
    "grupo": "S04 - TRAUMATISMO DE NERVIOS CRANEALES",
    "detalle": [
      {
        "codigo": "S040",
        "valor": "TRAUMATISMO DEL NERVIO OPTICO [II PAR] Y DE LAS VIAS OPTICAS"
      },
      {
        "codigo": "S041",
        "valor": "TRAUMATISMO DEL NERVIO MOTOR OCULAR COMUN [III PAR]"
      },
      {
        "codigo": "S042",
        "valor": "TRAUMATISMO DEL NERVIO PATETICO [IV PAR]"
      },
      {
        "codigo": "S043",
        "valor": "TRAUMATISMO DEL NERVIO TRIGEMINO [V PAR]"
      },
      {
        "codigo": "S044",
        "valor": "TRAUMATISMO DEL NERVIO MOTOR OCULAR EXTERNO [VI PAR]"
      },
      {
        "codigo": "S045",
        "valor": "TRAUMATISMO DEL NERVIO FACIAL [VII PAR]"
      },
      {
        "codigo": "S046",
        "valor": "TRAUMATISMO DEL NERVIO ACUSTICO [VIII PAR]"
      },
      {
        "codigo": "S047",
        "valor": "TRAUMATISMO DEL NERVIO ESPINAL [XI PAR]"
      },
      {
        "codigo": "S048",
        "valor": "TRAUMATISMO DE OTROS NERVIOS CRANEALES"
      },
      {
        "codigo": "S049",
        "valor": "TRAUMATISMO DE NERVIOS CRANEALES, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S05 - TRAUMATISMO DEL OJO Y DE LA ORBITA",
    "detalle": [
      {
        "codigo": "S050",
        "valor": "TRAUMATISMO DE LA CONJUNTIVA Y ABRASION CORNEAL SIN MENCION DE CUERPO EXTRAÑO"
      },
      {
        "codigo": "S051",
        "valor": "CONTUSION DEL GLOBO OCULAR Y DEL TEJIDO ORBITARIO"
      },
      {
        "codigo": "S052",
        "valor": "LACERACION Y RUPTURA OCULAR CON PROLAPSO O PERDIDA DEL TEJIDO INTRAOCULAR"
      },
      {
        "codigo": "S053",
        "valor": "LACERACION OCULAR SIN PROLAPSO O PERDIDA DEL TEJIDO INTRAOCULAR"
      },
      {
        "codigo": "S054",
        "valor": "HERIDA PENETRANTE DE LA ORBITA CON O SIN CUERPO EXTRAÑO"
      },
      {
        "codigo": "S055",
        "valor": "HERIDA PENETRANTE DEL GLOBO OCULAR CON CUERPO EXTRAÑO"
      },
      {
        "codigo": "S056",
        "valor": "HERIDA PENETRANTE DEL GLOBO OCULAR SIN CUERPO EXTRAÑO"
      },
      {
        "codigo": "S057",
        "valor": "AVULSION DE OJO"
      },
      {
        "codigo": "S058",
        "valor": "OTROS TRAUMATISMOS DEL OJO Y DE LA ORBITA"
      },
      {
        "codigo": "S059",
        "valor": "TRAUMATISMO DEL OJO Y DE LA ORBITA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S06 - TRAUMATISMO INTRACRANEAL",
    "detalle": [
      {
        "codigo": "S060",
        "valor": "CONCUSION"
      },
      {
        "codigo": "S061",
        "valor": "EDEMA CEREBRAL TRAUMATICO"
      },
      {
        "codigo": "S062",
        "valor": "TRAUMATISMO CEREBRAL DIFUSO"
      },
      {
        "codigo": "S063",
        "valor": "TRAUMATISMO CEREBRAL FOCAL"
      },
      {
        "codigo": "S064",
        "valor": "HEMORRAGIA EPIDURAL"
      },
      {
        "codigo": "S065",
        "valor": "HEMORRAGIA SUBDURAL TRAUMATICA"
      },
      {
        "codigo": "S066",
        "valor": "HEMORRAGIA SUBARACNOIDEA TRAUMATICA"
      },
      {
        "codigo": "S067",
        "valor": "TRAUMATISMO INTRACRANEAL CON COMA PROLONGADO"
      },
      {
        "codigo": "S068",
        "valor": "OTROS TRAUMATISMOS INTRACRANEALES"
      },
      {
        "codigo": "S069",
        "valor": "TRAUMATISMO INTRACRANEAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S07 - TRAUMATISMO POR APLASTAMIENTO DE LA CABEZA",
    "detalle": [
      {
        "codigo": "S070",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE LA CARA"
      },
      {
        "codigo": "S071",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DEL CRANEO"
      },
      {
        "codigo": "S078",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES DE LA CABEZA"
      },
      {
        "codigo": "S079",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE LA CABEZA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S08 - AMPUTACION TRAUMATICA DE PARTE DE LA CABEZA",
    "detalle": [
      {
        "codigo": "S080",
        "valor": "AVULSION DEL CUERO CABELLUDO"
      },
      {
        "codigo": "S081",
        "valor": "AMPUTACION TRAUMATICA DE LA OREJA"
      },
      {
        "codigo": "S088",
        "valor": "AMPUTACION TRAUMATICA DE OTRAS PARTES DE LA CABEZA"
      },
      {
        "codigo": "S089",
        "valor": "AMPUTACION TRAUMATICA DE PARTE NO ESPECIFICADA DE LA CABEZA"
      }
    ]
  },
  {
    "grupo": "S09 - OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DE LA CABEZA",
    "detalle": [
      {
        "codigo": "S090",
        "valor": "TRAUMATISMO DE LOS VASOS SANGUINEOS DE LA CABEZA NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "S091",
        "valor": "TRAUMATISMO DE TENDON Y MUSCULOS DE LA CABEZA"
      },
      {
        "codigo": "S092",
        "valor": "RUPTURA TRAUMATICA DEL TIMPANO DEL OIDO"
      },
      {
        "codigo": "S097",
        "valor": "TRAUMATISMOS MULTIPLES DE LA CABEZA"
      },
      {
        "codigo": "S098",
        "valor": "OTROS TRAUMATISMOS DE LA CABEZA, ESPECIFICADOS"
      },
      {
        "codigo": "S099",
        "valor": "TRAUMATISMO DE LA CABEZA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S10 - TRAUMATISMO SUPERFICIAL DEL CUELLO",
    "detalle": [
      {
        "codigo": "S100",
        "valor": "CONTUSION DE LA GARGANTA"
      },
      {
        "codigo": "S101",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES Y LOS NO ESPECIFICADOS DE LA GARGANTA"
      },
      {
        "codigo": "S107",
        "valor": "TRAUMATISMO SUPERFICIAL MULTIPLE DEL CUELLO"
      },
      {
        "codigo": "S108",
        "valor": "TRAUMATISMO SUPERFICIAL DE OTRAS PARTES DEL CUELLO"
      },
      {
        "codigo": "S109",
        "valor": "TRAUMATISMO SUPERFICIAL DEL CUELLO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S11 - HERIDA DEL CUELLO",
    "detalle": [
      {
        "codigo": "S110",
        "valor": "HERIDA QUE COMPROMETE LA LARINGE Y LA TRAQUEA"
      },
      {
        "codigo": "S111",
        "valor": "HERIDA QUE COMPROMETE LA GLANDULA TIROIDES"
      },
      {
        "codigo": "S112",
        "valor": "HERIDA QUE COMPROMETE LA FARINGE Y EL ESOFAGO CERVICAL"
      },
      {
        "codigo": "S117",
        "valor": "HERIDAS MULTIPLES DEL CUELLO"
      },
      {
        "codigo": "S118",
        "valor": "HERIDAS DE OTRAS PARTES DEL CUELLO"
      },
      {
        "codigo": "S119",
        "valor": "HERIDA DE CUELLO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S12 - FRACTURA DEL CUELLO",
    "detalle": [
      {
        "codigo": "S120",
        "valor": "FRACTURA DE LA PRIMERA VERTEBRA CERVICAL"
      },
      {
        "codigo": "S121",
        "valor": "FRACTURA DE LA SEGUNDA VERTEBRA CERVICAL"
      },
      {
        "codigo": "S122",
        "valor": "FRACTURA DE OTRAS VERTEBRAS CERVICALES ESPECIFICADAS"
      },
      {
        "codigo": "S127",
        "valor": "FRACTURAS MULTIPLES DE COLUMNA CERVICAL"
      },
      {
        "codigo": "S128",
        "valor": "FRACTURA DE OTRAS PARTES DEL CUELLO"
      },
      {
        "codigo": "S129",
        "valor": "FRACTURA DEL CUELLO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S13 - LUXACION, ESGUINCE Y TORCEDURA DE ARTICULACIONES Y LIGAMENTOS DEL CUELLO",
    "detalle": [
      {
        "codigo": "S130",
        "valor": "RUPTURA TRAUMATICA DE DISCO CERVICAL INTERVERTEBRAL"
      },
      {
        "codigo": "S131",
        "valor": "LUXACION DE VERTEBRA CERVICAL"
      },
      {
        "codigo": "S132",
        "valor": "LUXACIONES DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL CUELLO"
      },
      {
        "codigo": "S133",
        "valor": "LUXACIONES MULTIPLES DEL CUELLO"
      },
      {
        "codigo": "S134",
        "valor": "ESGUINCES Y TORCEDURAS DE LA COLUMNA CERVICAL"
      },
      {
        "codigo": "S135",
        "valor": "ESGUINCES Y TORCEDURAS DE LA REGION TIROIDEA"
      },
      {
        "codigo": "S136",
        "valor": "ESGUINCES Y TORCEDURAS DE ARTICULACIONES Y LIGAMENTOS DE OTROS SITIOS ESPECIFICADOS Y DE LOS NO ESPECIFICADOS DEL CUELLO"
      }
    ]
  },
  {
    "grupo": "S14 - TRAUMATISMO DE LA MEDULA ESPINAL Y DE NERVIOS A NIVEL DEL CUELLO",
    "detalle": [
      {
        "codigo": "S140",
        "valor": "CONCUSION Y EDEMA DE LA MEDULA ESPINAL CERVICAL"
      },
      {
        "codigo": "S141",
        "valor": "OTROS TRAUMATISMOS DE LA MEDULA ESPINAL CERVICAL Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "S142",
        "valor": "TRAUMATISMO DE RAIZ NERVIOSA DE COLUMNA CERVICAL"
      },
      {
        "codigo": "S143",
        "valor": "TRAUMATISMO DEL PLEXO BRAQUIAL"
      },
      {
        "codigo": "S144",
        "valor": "TRAUMATISMO DE NERVIOS PERIFERICOS DEL CUELLO"
      },
      {
        "codigo": "S145",
        "valor": "TRAUMATISMO DE NERVIOS CERVICALES SIMPATICOS"
      },
      {
        "codigo": "S146",
        "valor": "TRAUMATISMO DE OTROS NERVIOS Y DE LOS NO ESPECIFICADOS DEL CUELLO"
      }
    ]
  },
  {
    "grupo": "S15 - TRAUMATISMO DE VASOS SANGUINEOS A NIVEL DEL CUELLO",
    "detalle": [
      {
        "codigo": "S150",
        "valor": "TRAUMATISMO DE LA ARTERIA CAROTIDA"
      },
      {
        "codigo": "S151",
        "valor": "TRAUMATISMO DE LA ARTERIA VERTEBRAL"
      },
      {
        "codigo": "S152",
        "valor": "TRAUMATISMO DE LA VENA YUGULAR EXTERNA"
      },
      {
        "codigo": "S153",
        "valor": "TRAUMATISMO DE LA VENA YUGULAR INTERNA"
      },
      {
        "codigo": "S157",
        "valor": "TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DEL CUELLO"
      },
      {
        "codigo": "S158",
        "valor": "TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DEL CUELLO"
      },
      {
        "codigo": "S159",
        "valor": "TRAUMATISMO DE VASOS SANGUINEOS NO ESPECIFICADOS A NIVEL DEL CUELLO"
      }
    ]
  },
  {
    "grupo": "S16 - TRAUMATISMO DE TENDON Y MUSCULOS A NIVEL DEL CUELLO",
    "detalle": [
      {
        "codigo": "S16X",
        "valor": "TRAUMATISMO DE TENDON Y MUSCULOS A NIVEL DEL CUELLO"
      }
    ]
  },
  {
    "grupo": "S17 - TRAUMATISMO POR APLASTAMIENTO DEL CUELLO",
    "detalle": [
      {
        "codigo": "S170",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE LA LARINGE Y DE LA TRAQUEA"
      },
      {
        "codigo": "S178",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES DEL CUELLO"
      },
      {
        "codigo": "S179",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DEL CUELLO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S18 - AMPUTACION TRAUMATICA A NIVEL DEL CUELLO",
    "detalle": [
      {
        "codigo": "S18X",
        "valor": "AMPUTACION TRAUMATICA A NIVEL DEL CUELLO"
      }
    ]
  },
  {
    "grupo": "S19 - OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DEL CUELLO",
    "detalle": [
      {
        "codigo": "S197",
        "valor": "TRAUMATISMOS MULTIPLES DEL CUELLO"
      },
      {
        "codigo": "S198",
        "valor": "OTROS TRAUMATISMOS DEL CUELLO, ESPECIFICADOS"
      },
      {
        "codigo": "S199",
        "valor": "TRAUMATISMO DEL CUELLO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S20 - TRAUMATISMO SUPERFICIAL DEL TORAX",
    "detalle": [
      {
        "codigo": "S200",
        "valor": "CONTUSION DE LA MAMA"
      },
      {
        "codigo": "S201",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES Y LOS NO ESPECIFICADOS DE LA MAMA"
      },
      {
        "codigo": "S202",
        "valor": "CONTUSION DEL TORAX"
      },
      {
        "codigo": "S203",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES DE LA PARED ANTERIOR DEL TORAX"
      },
      {
        "codigo": "S204",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES DE LA PARED POSTERIOR DEL TORAX"
      },
      {
        "codigo": "S207",
        "valor": "TRAUMATISMOS SUPERFICIALES MULTIPLES DEL TORAX"
      },
      {
        "codigo": "S208",
        "valor": "TRAUMATISMO SUPERFICIAL DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL TORAX"
      }
    ]
  },
  {
    "grupo": "S21 - HERIDA DEL TORAX",
    "detalle": [
      {
        "codigo": "S210",
        "valor": "HERIDA DE LA MAMA"
      },
      {
        "codigo": "S211",
        "valor": "HERIDA DE LA PARED ANTERIOR DEL TORAX"
      },
      {
        "codigo": "S212",
        "valor": "HERIDA DE LA PARED POSTERIOR DEL TORAX"
      },
      {
        "codigo": "S217",
        "valor": "HERIDA MULTIPLE DE LA PARED TORACICA"
      },
      {
        "codigo": "S218",
        "valor": "HERIDA DE OTRAS PARTES DEL TORAX"
      },
      {
        "codigo": "S219",
        "valor": "HERIDA DEL TORAX, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S22 - FRACTURA DE LAS COSTILLAS, DEL ESTERNON Y DE LA COLUMNA TORACICA [DORSAL]",
    "detalle": [
      {
        "codigo": "S220",
        "valor": "FRACTURA DE VERTEBRA TORACICA"
      },
      {
        "codigo": "S221",
        "valor": "FRACTURAS MULTIPLES DE COLUMNA TORACICA"
      },
      {
        "codigo": "S222",
        "valor": "FRACTURA DEL ESTERNON"
      },
      {
        "codigo": "S223",
        "valor": "FRACTURA DE COSTILLA"
      },
      {
        "codigo": "S224",
        "valor": "FRACTURAS MULTIPLES DE COSTILLAS"
      },
      {
        "codigo": "S225",
        "valor": "TORAX AZOTADO"
      },
      {
        "codigo": "S228",
        "valor": "FRACTURA DE OTRAS PARTES DEL TORAX OSEO"
      },
      {
        "codigo": "S229",
        "valor": "FRACTURA DEL TORAX OSEO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S23 - LUXACION, ESGUINCE Y TORCEDURA DE ARTICULACIONES Y LIGAMENTOS DEL TORAX",
    "detalle": [
      {
        "codigo": "S230",
        "valor": "RUPTURA TRAUMATICA DE DISCO INTERVERTEBRAL TORACICO"
      },
      {
        "codigo": "S231",
        "valor": "LUXACION DE VERTEBRA TORACICA"
      },
      {
        "codigo": "S232",
        "valor": "LUXACION DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL TORAX"
      },
      {
        "codigo": "S233",
        "valor": "ESGUINCES Y TORCEDURAS DE COLUMNA TORACICA"
      },
      {
        "codigo": "S234",
        "valor": "ESGUINCES Y TORCEDURAS DE COSTILLAS Y ESTERNON"
      },
      {
        "codigo": "S235",
        "valor": "ESGUINCES Y TORCEDURAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL TORAX"
      }
    ]
  },
  {
    "grupo": "S24 - TRAUMATISMO DE NERVIOS Y DE LA MEDULA ESPINAL A NIVEL DEL TORAX",
    "detalle": [
      {
        "codigo": "S240",
        "valor": "CONCUSION Y EDEMA DE LA MEDULA ESPINAL TORACICA"
      },
      {
        "codigo": "S241",
        "valor": "OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DE LA MEDULA ESPINAL TORACICA"
      },
      {
        "codigo": "S242",
        "valor": "TRAUMATISMO DE RAICES NERVIOSAS DE LA COLUMNA TORACICA"
      },
      {
        "codigo": "S243",
        "valor": "TRAUMATISMO DE NERVIOS PERIFERICOS DEL TORAX"
      },
      {
        "codigo": "S244",
        "valor": "TRAUMATISMO DE NERVIOS SIMPATICOS TORACICOS"
      },
      {
        "codigo": "S245",
        "valor": "TRAUMATISMO DE OTROS NERVIOS DEL TORAX"
      },
      {
        "codigo": "S246",
        "valor": "TRAUMATISMO DE NERVIO NO ESPECIFICADO DEL TORAX"
      }
    ]
  },
  {
    "grupo": "S25 - TRAUMATISMO DE VASOS SANGUINEOS DEL TORAX",
    "detalle": [
      {
        "codigo": "S250",
        "valor": "TRAUMATISMO DE LA AORTA TORACICA"
      },
      {
        "codigo": "S251",
        "valor": "TRAUMATISMO DE LA ARTERIA INNOMINADA O SUBCLAVIA"
      },
      {
        "codigo": "S252",
        "valor": "TRAUMATISMO DE VENA CAVA SUPERIOR"
      },
      {
        "codigo": "S253",
        "valor": "TRAUMATISMO DE LA VENA INNOMINADA O SUBCLAVIA"
      },
      {
        "codigo": "S254",
        "valor": "TRAUMATISMO DE VASOS SANGUINEOS PULMONARES"
      },
      {
        "codigo": "S255",
        "valor": "TRAUMATISMO DE VASOS SANGUINEOS INTERCOSTALES"
      },
      {
        "codigo": "S257",
        "valor": "TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS DEL TORAX"
      },
      {
        "codigo": "S258",
        "valor": "TRAUMATISMO DE OTROS VASOS SANGUINEOS DEL TORAX"
      },
      {
        "codigo": "S259",
        "valor": "TRAUMATISMO DE VASOS SANGUINEOS NO ESPECIFICADOS DEL TORAX"
      }
    ]
  },
  {
    "grupo": "S26 - TRAUMATISMO DEL CORAZON",
    "detalle": [
      {
        "codigo": "S260",
        "valor": "TRAUMATISMO DEL CORAZON CON HEMOPERICARDIO"
      },
      {
        "codigo": "S268",
        "valor": "OTROS TRAUMATISMOS DEL CORAZON"
      },
      {
        "codigo": "S269",
        "valor": "TRAUMATISMO DEL CORAZON, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S27 - TRAUMATISMO DE OTROS ORGANOS INTRATORACICOS Y DE LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "S270",
        "valor": "NEUMOTORAX TRAUMATICO"
      },
      {
        "codigo": "S271",
        "valor": "HEMOTORAX TRAUMATICO"
      },
      {
        "codigo": "S272",
        "valor": "HEMONEUMOTORAX TRAUMATICO"
      },
      {
        "codigo": "S273",
        "valor": "OTROS TRAUMATISMOS DEL PULMON"
      },
      {
        "codigo": "S274",
        "valor": "TRAUMATISMO DE LOS BRONQUIOS"
      },
      {
        "codigo": "S275",
        "valor": "TRAUMATISMO DE LA TRAQUEA TORACICA"
      },
      {
        "codigo": "S276",
        "valor": "TRAUMATISMO DE LA PLEURA"
      },
      {
        "codigo": "S277",
        "valor": "TRAUMATISMOS MULTIPLES DE ORGANOS INTRATORACICOS"
      },
      {
        "codigo": "S278",
        "valor": "TRAUMATISMO DE OTROS ORGANOS INTRATORACICOS, ESPECIFICADOS"
      },
      {
        "codigo": "S279",
        "valor": "TRAUMATISMO DE ORGANO INTRATORACICO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S28 - TRAUMATISMO POR APLASTAMIENTO DEL TORAX Y AMPUTACION TRAUMATICA DE PARTE DEL TORAX",
    "detalle": [
      {
        "codigo": "S280",
        "valor": "APLASTAMIENTO DEL TORAX"
      },
      {
        "codigo": "S281",
        "valor": "AMPUTACION TRAUMATICA DE PARTE DEL TORAX"
      }
    ]
  },
  {
    "grupo": "S29 - OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DEL TORAX",
    "detalle": [
      {
        "codigo": "S290",
        "valor": "TRAUMATISMO DE TENDON Y MUSCULOS A NIVEL DEL TORAX"
      },
      {
        "codigo": "S297",
        "valor": "TRAUMATISMOS MULTIPLES DEL TORAX"
      },
      {
        "codigo": "S298",
        "valor": "OTROS TRAUMATISMOS DEL TORAX, ESPECIFICADOS"
      },
      {
        "codigo": "S299",
        "valor": "TRAUMATISMO DEL TORAX, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S30 - TRAUMATISMO SUPERFICIAL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "detalle": [
      {
        "codigo": "S300",
        "valor": "CONTUSION DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S301",
        "valor": "CONTUSION DE LA PARED ABDOMINAL"
      },
      {
        "codigo": "S302",
        "valor": "CONTUSION DE ORGANOS GENITALES EXTERNOS"
      },
      {
        "codigo": "S307",
        "valor": "TRAUMATISMOS SUPERFICIALES MULTIPLES DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S308",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S309",
        "valor": "TRAUMATISMO SUPERFICIAL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S31 - HERIDA DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "detalle": [
      {
        "codigo": "S310",
        "valor": "HERIDA DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S311",
        "valor": "HERIDA DE LA PARED ABDOMINAL"
      },
      {
        "codigo": "S312",
        "valor": "HERIDA DEL PENE"
      },
      {
        "codigo": "S313",
        "valor": "HERIDA DEL ESCROTO Y DE LOS TESTICULOS"
      },
      {
        "codigo": "S314",
        "valor": "HERIDA DE LA VAGINA Y DE LA VULVA"
      },
      {
        "codigo": "S315",
        "valor": "HERIDA DE OTROS ORGANOS GENITALES EXTERNOS Y DE LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "S317",
        "valor": "HERIDAS MULTIPLES DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S318",
        "valor": "HERIDAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL ABDOMEN"
      }
    ]
  },
  {
    "grupo": "S32 - FRACTURA DE LA COLUMNA LUMBAR Y DE LA PELVIS",
    "detalle": [
      {
        "codigo": "S320",
        "valor": "FRACTURA DE VERTEBRA LUMBAR"
      },
      {
        "codigo": "S321",
        "valor": "FRACTURA DEL SACRO"
      },
      {
        "codigo": "S322",
        "valor": "FRACTURA DEL COCCIX"
      },
      {
        "codigo": "S323",
        "valor": "FRACTURA DEL HUESO ILIACO"
      },
      {
        "codigo": "S324",
        "valor": "FRACTURA DEL ACETABULO"
      },
      {
        "codigo": "S325",
        "valor": "FRACTURA DEL PUBIS"
      },
      {
        "codigo": "S327",
        "valor": "FRACTURAS MULTIPLES DE LA COLUMNA LUMBAR Y DE LA PELVIS"
      },
      {
        "codigo": "S328",
        "valor": "FRACTURA DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA COLUMNA LUMBAR Y DE LA PELVIS"
      }
    ]
  },
  {
    "grupo": "S33 - LUXACION, ESGUINCE Y TORCEDURA DE ARTICULACIONES Y LIGAMENTOS DE LA COLUMNA LUMBAR Y DE LA PELVIS",
    "detalle": [
      {
        "codigo": "S330",
        "valor": "RUPTURA TRAUMATICA DE DISCO INTERVERTEBRAL LUMBAR"
      },
      {
        "codigo": "S331",
        "valor": "LUXACION DE VERTEBRA LUMBAR"
      },
      {
        "codigo": "S332",
        "valor": "LUXACION DE ARTICULACION SACROCOCCIGEA Y SACROILIACA"
      },
      {
        "codigo": "S333",
        "valor": "LUXACION DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA COLUMNA LUMBAR Y DE LA PELVIS"
      },
      {
        "codigo": "S334",
        "valor": "RUPTURA TRAUMATICA DE LA SINFISIS DEL PUBIS"
      },
      {
        "codigo": "S335",
        "valor": "ESGUINCES Y TORCEDURAS DE LA COLUMNA LUMBAR"
      },
      {
        "codigo": "S336",
        "valor": "ESGUINCES Y TORCEDURAS DE LA ARTICULACION SACROILIACA"
      },
      {
        "codigo": "S337",
        "valor": "ESGUINCES Y TORCEDURAS DE OTRAS PARTES Y DE LA NO ESPECIFICADAS DE LA COLUMNA LUMBAR Y DE LA PELVIS"
      }
    ]
  },
  {
    "grupo": "S34 - TRAUMATISMO DE LOS NERVIOS Y DE LA MEDULA ESPINAL LUMBAR, A NIVEL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "detalle": [
      {
        "codigo": "S340",
        "valor": "CONCUSION Y EDEMA DE LA MEDULA ESPINAL LUMBAR"
      },
      {
        "codigo": "S341",
        "valor": "OTRO TRAUMATISMO DE LA MEDULA ESPINAL LUMBAR"
      },
      {
        "codigo": "S342",
        "valor": "TRAUMATISMO DE RAIZ NERVIOSA DE LA COLUMNA LUMBAR Y SACRA"
      },
      {
        "codigo": "S343",
        "valor": "TRAUMATISMO DE LA COLA DE CABALLO"
      },
      {
        "codigo": "S344",
        "valor": "TRAUMATISMO DEL PLEXO LUMBOSACRO"
      },
      {
        "codigo": "S345",
        "valor": "TRAUMATISMO DE NERVIOS(S) SIMPATICO(S) LUMBAR(ES),SACRO(S) Y PELVICO(S)"
      },
      {
        "codigo": "S346",
        "valor": "TRAUMATISMO DE NERVIO(S) PERIFERICO(S) DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S348",
        "valor": "TRAUMATISMO DE OTROS NERVIOS A NIVEL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS Y DE LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "S35 - TRAUMATISMO DE VASOS SANGUINEOS A NIVEL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "detalle": [
      {
        "codigo": "S350",
        "valor": "TRAUMATISMO DE LA AORTA ABDOMINAL"
      },
      {
        "codigo": "S351",
        "valor": "TRAUMATISMO DE LA VENA CAVA INFERIOR"
      },
      {
        "codigo": "S352",
        "valor": "TRAUMATISMO DE ARTERIAS CELIACAS Y MESENTERICAS"
      },
      {
        "codigo": "S353",
        "valor": "TRAUMATISMO DE VENAS PORTA Y ESPLENICA"
      },
      {
        "codigo": "S354",
        "valor": "TRAUMATISMO DE VASOS SANGUINEOS RENALES"
      },
      {
        "codigo": "S355",
        "valor": "TRAUMATISMO DE VASOS SANGUINEOS ILIACOS"
      },
      {
        "codigo": "S357",
        "valor": "TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S358",
        "valor": "TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S359",
        "valor": "TRAUMATISMO DE VASOS SANGUINEOS NO ESPECIFICADOS A NIVEL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      }
    ]
  },
  {
    "grupo": "S36 - TRAUMATISMO DE ORGANOS INTRAABDOMINALES",
    "detalle": [
      {
        "codigo": "S360",
        "valor": "TRAUMATISMO DEL BAZO"
      },
      {
        "codigo": "S361",
        "valor": "TRAUMATISMO DEL HIGADO Y DE LA VESICULA BILIAR"
      },
      {
        "codigo": "S362",
        "valor": "TRAUMATISMO DEL PANCREAS"
      },
      {
        "codigo": "S363",
        "valor": "TRAUMATISMO DEL ESTOMAGO"
      },
      {
        "codigo": "S364",
        "valor": "TRAUMATISMO DEL INTESTINO DELGADO"
      },
      {
        "codigo": "S365",
        "valor": "TRAUMATISMO DEL COLON"
      },
      {
        "codigo": "S366",
        "valor": "TRAUMATISMO DEL RECTO"
      },
      {
        "codigo": "S367",
        "valor": "TRAUMATISMO DE MULTIPLES ORGANOS INTRAABDOMINALES"
      },
      {
        "codigo": "S368",
        "valor": "TRAUMATISMO DE OTROS ORGANOS INTRAABDOMINALES"
      },
      {
        "codigo": "S369",
        "valor": "TRAUMATISMO DE ORGANO INTRAABDOMINAL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S37 - TRAUMATISMO DE ORGANOS PELVICOS",
    "detalle": [
      {
        "codigo": "S370",
        "valor": "TRAUMATISMO DEL RIÑON"
      },
      {
        "codigo": "S371",
        "valor": "TRAUMATISMO DEL URETER"
      },
      {
        "codigo": "S372",
        "valor": "TRAUMATISMO DE LA VEJIGA"
      },
      {
        "codigo": "S373",
        "valor": "TRAUMATISMO DE LA URETRA"
      },
      {
        "codigo": "S374",
        "valor": "TRAUMATISMO DEL OVARIO"
      },
      {
        "codigo": "S375",
        "valor": "TRAUMATISMO DE LA TROMPA DE FALOPIO"
      },
      {
        "codigo": "S376",
        "valor": "TRAUMATISMO DEL UTERO"
      },
      {
        "codigo": "S377",
        "valor": "TRAUMATISMO DE MULTIPLES ORGANOS PELVICOS"
      },
      {
        "codigo": "S378",
        "valor": "TRAUMATISMO DE OTROS ORGANOS PELVICOS"
      },
      {
        "codigo": "S379",
        "valor": "TRAUMATISMO DE ORGANO PELVICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S38 - TRAUMATISMO POR APLASTAMIENTO Y AMPUTACION TRAUMATICA DE PARTE DEL ABDOMEN DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "detalle": [
      {
        "codigo": "S380",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE ORGANOS GENITALES EXTERNOS"
      },
      {
        "codigo": "S381",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S382",
        "valor": "AMPUTACION TRAUMATICA DE ORGANOS GENITALES EXTERNOS"
      },
      {
        "codigo": "S383",
        "valor": "AMPUTACION TRAUMATICA DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL ABDOMEN, REGION LUMBOSACRA Y PELVIS"
      }
    ]
  },
  {
    "grupo": "S39 - OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "detalle": [
      {
        "codigo": "S390",
        "valor": "TRAUMATISMO DE TENDON Y DE MUSCULOS DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S396",
        "valor": "TRAUMATISMO DE ORGANO(S) INTRAABDOMINAL(ES) CON ORGANO(S) PELVICO(S)"
      },
      {
        "codigo": "S397",
        "valor": "OTROS TRAUMATISMOS MULTIPLES DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S398",
        "valor": "OTROS TRAUMATISMOS ESPECIFICADOS DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "S399",
        "valor": "TRAUMATISMO NO ESPECIFICADO DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      }
    ]
  },
  {
    "grupo": "S40 - TRAUMATISMO SUPERFICIAL DEL HOMBRO Y DEL BRAZO",
    "detalle": [
      {
        "codigo": "S400",
        "valor": "CONTUSION DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S407",
        "valor": "TRAUMATISMOS SUPERFICIALES MULTIPLES DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S408",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S409",
        "valor": "TRAUMATISMO SUPERFICIAL NO ESPECIFICADO DEL HOMBRO Y DEL BRAZO"
      }
    ]
  },
  {
    "grupo": "S41 - HERIDA DEL HOMBRO Y DEL BRAZO",
    "detalle": [
      {
        "codigo": "S410",
        "valor": "HERIDA DEL HOMBRO"
      },
      {
        "codigo": "S411",
        "valor": "HERIDA DEL BRAZO"
      },
      {
        "codigo": "S417",
        "valor": "HERIDAS MULTIPLES DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S418",
        "valor": "HERIDA DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL HOMBRO Y DEL BRAZO"
      }
    ]
  },
  {
    "grupo": "S42 - FRACTURA DEL HOMBRO Y DEL BRAZO",
    "detalle": [
      {
        "codigo": "S420",
        "valor": "FRACTURA DE LA CLAVICULA"
      },
      {
        "codigo": "S421",
        "valor": "FRACTURA DEL OMOPLATO"
      },
      {
        "codigo": "S422",
        "valor": "FRACTURA DE LA EPIFISIS SUPERIOR DEL HUMERO"
      },
      {
        "codigo": "S423",
        "valor": "FRACTURA DE LA DIAFISIS DEL HUMERO"
      },
      {
        "codigo": "S424",
        "valor": "FRACTURA DE LA EPIFISIS INFERIOR DEL HUMERO"
      },
      {
        "codigo": "S427",
        "valor": "FRACTURAS MULTIPLES DE LA CLAVICULA, DEL OMOPLATO Y DEL HUMERO"
      },
      {
        "codigo": "S428",
        "valor": "FRACTURA DE OTRAS PARTES DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S429",
        "valor": "FRACTURA DEL HOMBRO Y DEL BRAZO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S43 - LUXACION, ESGUINCE Y TORCEDURA DE ARTICULACIONES Y LIGAMENTOS DE LA CINTURA ESCAPULAR",
    "detalle": [
      {
        "codigo": "S430",
        "valor": "LUXACION DE LA ARTICULACION DEL HOMBRO"
      },
      {
        "codigo": "S431",
        "valor": "LUXACION DE LA ARTICULACION ACROMIOCLAVICULAR"
      },
      {
        "codigo": "S432",
        "valor": "LUXACION DE LA ARTICULACION ESTERNOCLAVICULAR"
      },
      {
        "codigo": "S433",
        "valor": "LUXACION DE OTRAS PARTES DE LA CINTURA ESCAPULAR Y DE LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "S434",
        "valor": "ESGUINCES Y TORCEDURAS DE LA ARTICULACION DEL HOMBRO"
      },
      {
        "codigo": "S435",
        "valor": "ESGUINCES Y TORCEDURAS DE LA ARTICULACION ACROMIOCLAVICULAR"
      },
      {
        "codigo": "S436",
        "valor": "ESGUINCES Y TORCEDURAS DE LA ARTICULACION ESTERNOCLAVICULAR"
      },
      {
        "codigo": "S437",
        "valor": "ESGUINCES Y TORCEDURAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CINTURA ESCAPULAR"
      }
    ]
  },
  {
    "grupo": "S44 - TRAUMATISMO DE NERVIOS A NIVEL DEL HOMBRO Y DEL BRAZO",
    "detalle": [
      {
        "codigo": "S440",
        "valor": "TRAUMATISMO DEL NERVIO CUBITAL A NIVEL DEL BRAZO"
      },
      {
        "codigo": "S441",
        "valor": "TRAUMATISMO DEL NERVIO MEDIANO A NIVEL DEL BRAZO"
      },
      {
        "codigo": "S442",
        "valor": "TRAUMATISMO DEL NERVIO RADIAL A NIVEL DEL BRAZO"
      },
      {
        "codigo": "S443",
        "valor": "TRAUMATISMO DEL NERVIO AXILAR"
      },
      {
        "codigo": "S444",
        "valor": "TRAUMATISMO DEL NERVIO MUSCULOCUTANEO"
      },
      {
        "codigo": "S445",
        "valor": "TRAUMATISMO DEL NERVIO SENSITIVO CUTANEO A NIVEL DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S447",
        "valor": "TRAUMATISMO DE MULTIPLES NERVIOS A NIVEL DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S448",
        "valor": "TRAUMATISMO DE OTROS NERVIOS A NIVEL DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S449",
        "valor": "TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DEL HOMBRO Y DEL BRAZO"
      }
    ]
  },
  {
    "grupo": "S45 - TRAUMATISMO DE VASOS SANGUINEOS A NIVEL DEL HOMBRO Y DEL BRAZO",
    "detalle": [
      {
        "codigo": "S450",
        "valor": "TRAUMATISMO DE LA ARTERIA AXILAR"
      },
      {
        "codigo": "S451",
        "valor": "TRAUMATISMO DE LA ARTERIA BRAQUIAL"
      },
      {
        "codigo": "S452",
        "valor": "TRAUMATISMO DE LA VENA AXILAR O BRAQUIAL"
      },
      {
        "codigo": "S453",
        "valor": "TRAUMATISMO DE VENA SUPERFICIAL A NIVEL DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S457",
        "valor": "TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S458",
        "valor": "TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S459",
        "valor": "TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DEL HOMBRO Y DEL BRAZO"
      }
    ]
  },
  {
    "grupo": "S46 - TRAUMATISMO DE TENDON Y MUSCULO A NIVEL DEL HOMBRO Y DEL BRAZO",
    "detalle": [
      {
        "codigo": "S460",
        "valor": "TRAUMATISMO DEL MUSCULO(S) Y TENDON(ES) DEL MANGUITO ROTATORIO DEL HOMBRO"
      },
      {
        "codigo": "S461",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO DE LA CABEZA LARGA DEL BICEPS"
      },
      {
        "codigo": "S462",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO DE OTRAS PARTES DEL BICEPS"
      },
      {
        "codigo": "S463",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO DEL TRICEPS"
      },
      {
        "codigo": "S467",
        "valor": "TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS A NIVEL DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S468",
        "valor": "TRAUMATISMO DE OTROS TENDONES Y MUSCULOS A NIVEL DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S469",
        "valor": "TRAUMATISMO DE TENDON Y MUSCULO NO ESPECIFICADO, A NIVEL DEL HOMBRO Y DEL BRAZO"
      }
    ]
  },
  {
    "grupo": "S47 - TRAUMATISMO POR APLASTAMIENTO DEL HOMBRO Y DEL BRAZO",
    "detalle": [
      {
        "codigo": "S47X",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DEL HOMBRO Y DEL BRAZO"
      }
    ]
  },
  {
    "grupo": "S48 - AMPUTACION TRAUMATICA DEL HOMBRO Y DEL BRAZO",
    "detalle": [
      {
        "codigo": "S480",
        "valor": "AMPUTACION TRAUMATICA EN LA ARTICULACION DEL HOMBRO"
      },
      {
        "codigo": "S481",
        "valor": "AMPUTACION TRAUMATICA A NIVEL ENTRE EL HOMBRO Y EL CODO"
      },
      {
        "codigo": "S489",
        "valor": "AMPUTACION TRAUMATICA DEL HOMBRO Y DEL BRAZO, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S49 - OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DEL HOMBRO Y DEL BRAZO",
    "detalle": [
      {
        "codigo": "S497",
        "valor": "TRAUMATISMOS MULTIPLES DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S498",
        "valor": "OTROS TRAUMATISMOS ESPECIFICADOS DEL HOMBRO Y DEL BRAZO"
      },
      {
        "codigo": "S499",
        "valor": "TRAUMATISMOS NO ESPECIFICADOS DEL HOMBRO Y DEL BRAZO"
      }
    ]
  },
  {
    "grupo": "S50 - TRAUMATISMO SUPERFICIAL DEL ANTEBRAZO Y DEL CODO",
    "detalle": [
      {
        "codigo": "S500",
        "valor": "CONTUSION DEL CODO"
      },
      {
        "codigo": "S501",
        "valor": "CONTUSION DE OTRAS PARTES DEL ANTEBRAZO Y DE LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "S507",
        "valor": "TRAUMATISMOS SUPERFICIALES MULTIPLES DEL ANTEBRAZO"
      },
      {
        "codigo": "S508",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES DEL ANTEBRAZO"
      },
      {
        "codigo": "S509",
        "valor": "TRAUMATISMO SUPERFICIAL DEL ANTEBRAZO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S51 - HERIDA DEL ANTEBRAZO Y DEL CODO",
    "detalle": [
      {
        "codigo": "S510",
        "valor": "HERIDA DEL CODO"
      },
      {
        "codigo": "S517",
        "valor": "HERIDAS MULTIPLES DEL ANTEBRAZO"
      },
      {
        "codigo": "S518",
        "valor": "HERIDA DE OTRAS PARTES DEL ANTEBRAZO"
      },
      {
        "codigo": "S519",
        "valor": "HERIDA DEL ANTEBRAZO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S52 - FRACTURA DEL ANTEBRAZO",
    "detalle": [
      {
        "codigo": "S520",
        "valor": "FRACTURA DE LA EPIFISIS SUPERIOR DEL CUBITO"
      },
      {
        "codigo": "S521",
        "valor": "FRACTURA DE LA EPIFISIS SUPERIOR DEL RADIO"
      },
      {
        "codigo": "S522",
        "valor": "FRACTURA DE LA DIAFISIS DEL CUBITO"
      },
      {
        "codigo": "S523",
        "valor": "FRACTURA DE LA DIAFISIS DEL RADIO"
      },
      {
        "codigo": "S524",
        "valor": "FRACTURA DE LA DIAFISIS DEL CUBITO Y DEL RADIO"
      },
      {
        "codigo": "S525",
        "valor": "FRACTURA DE LA EPIFISIS INFERIOR DEL RADIO"
      },
      {
        "codigo": "S526",
        "valor": "FRACTURA DE LA EPIFISIS INFERIOR DEL CUBITO Y DEL RADIO"
      },
      {
        "codigo": "S527",
        "valor": "FRACTURAS MULTIPLES DEL ANTEBRAZO"
      },
      {
        "codigo": "S528",
        "valor": "FRACTURA DE OTRAS PARTES DEL ANTEBRAZO"
      },
      {
        "codigo": "S529",
        "valor": "FRACTURA DEL ANTEBRAZO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S53 - LUXACION, ESGUINCE Y TORCEDURA DE ARTICULACIONES Y LIGAMENTOS DEL CODO",
    "detalle": [
      {
        "codigo": "S530",
        "valor": "LUXACION DE LA CABEZA DEL RADIO"
      },
      {
        "codigo": "S531",
        "valor": "LUXACION DEL CODO, NO ESPECIFICADA"
      },
      {
        "codigo": "S532",
        "valor": "RUPTURA TRAUMATICA DEL LIGAMENTO LATERAL DEL RADIO"
      },
      {
        "codigo": "S533",
        "valor": "RUPTURA TRAUMATICA DEL LIGAMENTO LATERAL DEL CUBITO"
      },
      {
        "codigo": "S534",
        "valor": "ESGUINCES Y TORCEDURAS DEL CODO"
      }
    ]
  },
  {
    "grupo": "S54 - TRAUMATISMO DE NERVIOS A NIVEL DEL ANTEBRAZO",
    "detalle": [
      {
        "codigo": "S540",
        "valor": "TRAUMATISMO DEL NERVIO CUBITAL A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S541",
        "valor": "TRAUMATISMO DEL NERVIO MEDIANO A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S542",
        "valor": "TRAUMATISMO DEL NERVIO RADIAL A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S543",
        "valor": "TRAUMATISMO DEL NERVIO SENSORIAL CUTANEO A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S547",
        "valor": "TRAUMATISMO DE MULTIPLES NERVIOS A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S548",
        "valor": "TRAUMATISMO DE OTROS NERVIOS A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S549",
        "valor": "TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DEL ANTEBRAZO"
      }
    ]
  },
  {
    "grupo": "S55 - TRAUMATISMO DE LOS VASOS SANGUINEOS A NIVEL DEL ANTEBRAZO",
    "detalle": [
      {
        "codigo": "S550",
        "valor": "TRAUMATISMO DE LA ARTERIA CUBITAL A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S551",
        "valor": "TRAUMATISMO DE LA ARTERIA RADIAL A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S552",
        "valor": "TRAUMATISMO DE VENA A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S557",
        "valor": "TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S558",
        "valor": "TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S559",
        "valor": "TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DEL ANTEBRAZO"
      }
    ]
  },
  {
    "grupo": "S56 - TRAUMATISMO DE TENDON Y MUSCULO A NIVEL DEL ANTEBRAZO",
    "detalle": [
      {
        "codigo": "S560",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO FLEXOR DEL PULGAR A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S561",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO FLEXOR DE OTRO(S) DEDO(S) A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S562",
        "valor": "TRAUMATISMO DE OTRO TENDON Y MUSCULO FLEXOR A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S563",
        "valor": "TRAUMATISMO DE TENDONES Y MUSCULOS ABDUCTORES Y EXTENSORES DEL PULGAR A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S564",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO EXTENSOR DE OTRO(S) DEDO(S) A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S565",
        "valor": "TRAUMATISMO DE OTRO TENDON Y MUSCULO EXTENSOR A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S567",
        "valor": "TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS A NIVEL DEL ANTEBRAZO"
      },
      {
        "codigo": "S568",
        "valor": "TRAUMATISMO DE OTROS TENDONES Y MUSCULOS Y DE LOS NO ESPECIFICADOS, A NIVEL DEL ANTEBRAZO"
      }
    ]
  },
  {
    "grupo": "S57 - TRAUMATISMO POR APLASTAMIENTO DEL ANTEBRAZO",
    "detalle": [
      {
        "codigo": "S570",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DEL CODO"
      },
      {
        "codigo": "S578",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES DEL ANTEBRAZO"
      },
      {
        "codigo": "S579",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DEL ANTEBRAZO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S58 - AMPUTACION TRAUMATICA DEL ANTEBRAZO",
    "detalle": [
      {
        "codigo": "S580",
        "valor": "AMPUTACION TRAUMATICA A NIVEL DEL CODO"
      },
      {
        "codigo": "S581",
        "valor": "AMPUTACION TRAUMATICA NIVEL ENTRE EL CODO Y LA MUÑECA"
      },
      {
        "codigo": "S589",
        "valor": "AMPUTACION TRAUMATICA DEL ANTEBRAZO, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S59 - OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DEL ANTEBRAZO",
    "detalle": [
      {
        "codigo": "S597",
        "valor": "OTROS TRAUMATISMOS MULTIPLES DEL ANTEBRAZO"
      },
      {
        "codigo": "S598",
        "valor": "OTROS TRAUMATISMOS ESPECIFICADOS DEL ANTEBRAZO"
      },
      {
        "codigo": "S599",
        "valor": "TRAUMATISMO NO ESPECIFICADO DEL ANTEBRAZO"
      }
    ]
  },
  {
    "grupo": "S60 - TRAUMATISMO SUPERFICIAL DE LA MU?ECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "S600",
        "valor": "CONTUSION DE DEDO(S) DE LA MANO, SIN DAÑO DE LA(S) UÑA(S)"
      },
      {
        "codigo": "S601",
        "valor": "CONTUSION DE DEDO(S) DE LA MANO CON DAÑO DE LA(S) UÑA(S)"
      },
      {
        "codigo": "S602",
        "valor": "CONTUSION DE OTRAS PARTES DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S607",
        "valor": "TRAUMATISMOS SUPERFICIALES MULTIPLES DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S608",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S609",
        "valor": "TRAUMATISMO SUPERFICIAL DE LA MUÑECA Y DE LA MANO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S61 - HERIDA DE LA MU?ECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "S610",
        "valor": "HERIDA DE DEDO(S) DE LA MANO, SIN DAÑO DE LA(S) UÑA(S)"
      },
      {
        "codigo": "S611",
        "valor": "HERIDA DE DEDO(S) DE LA MANO, CON DAÑO DE LA(S) UÑA(S)"
      },
      {
        "codigo": "S617",
        "valor": "HERIDAS MULTIPLES DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S618",
        "valor": "HERIDA DE OTRAS PARTES DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S619",
        "valor": "HERIDA DE LA MUÑECA Y DE LA MANO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S62 - FRACTURA A NIVEL DE LA MU?ECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "S620",
        "valor": "FRACTURA DEL HUESO ESCAFOIDES [NAVICULAR] DE LA MANO"
      },
      {
        "codigo": "S621",
        "valor": "FRACTURA DE OTRO(S) HUESO(S) DEL CARPO"
      },
      {
        "codigo": "S622",
        "valor": "FRACTURA DEL PRIMER METACARPIANO"
      },
      {
        "codigo": "S623",
        "valor": "FRACTURA DE OTROS HUESOS METACARPIANOS"
      },
      {
        "codigo": "S624",
        "valor": "FRACTURAS MULTIPLES DE HUESOS METACARPIANOS"
      },
      {
        "codigo": "S625",
        "valor": "FRACTURA DEL PULGAR"
      },
      {
        "codigo": "S626",
        "valor": "FRACTURA DE OTRO DEDO DE LA MANO"
      },
      {
        "codigo": "S627",
        "valor": "FRACTURAS MULTIPLES DE LOS DEDOS DE LA MANO"
      },
      {
        "codigo": "S628",
        "valor": "FRACTURA DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA MUÑECA Y DE LA MANO"
      }
    ]
  },
  {
    "grupo": "S63 - LUXACION, ESGUINCE Y TORCEDURA DE ARTICULACIONES Y LIGAMENTOS A NIVEL DE LA MUÑECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "S630",
        "valor": "LUXACION DE LA MUÑECA"
      },
      {
        "codigo": "S631",
        "valor": "LUXACION DE DEDOS DE LA MANO"
      },
      {
        "codigo": "S632",
        "valor": "LUXACIONES MULTIPLES DE DEDOS DE LA MANO"
      },
      {
        "codigo": "S633",
        "valor": "RUPTURA TRAUMATICA DE LIGAMENTOS DE LA MUÑECA Y DEL CARPO"
      },
      {
        "codigo": "S634",
        "valor": "RUPTURA TRAUMATICA DE LIGAMENTOS DEL DEDO DE LA MANO EN LA(S) ARTICULACION(ES) METACARPOFALANGICA E INTERFALANGICA"
      },
      {
        "codigo": "S635",
        "valor": "ESGUINCE Y TORCEDURA DE LA MUÑECA"
      },
      {
        "codigo": "S636",
        "valor": "ESGUINCES Y TORCEDURAS DE DEDO(S) DE LA MANO"
      },
      {
        "codigo": "S637",
        "valor": "ESGUINCES Y TORCEDURAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA MUÑECA Y DE LA MANO"
      }
    ]
  },
  {
    "grupo": "S64 - TRAUMATISMO DE NERVIOS A NIVEL DE LA MUÑECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "S640",
        "valor": "TRAUMATISMO DEL NERVIO CUBITAL A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S641",
        "valor": "TRAUMATISMO DEL NERVIO MEDIANO A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S642",
        "valor": "TRAUMATISMO DEL NERVIO RADIAL A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S643",
        "valor": "TRAUMATISMO DEL NERVIO DIGITAL DEL PULGAR"
      },
      {
        "codigo": "S644",
        "valor": "TRAUMATISMO DEL NERVIO DIGITAL DE OTRO DEDO"
      },
      {
        "codigo": "S647",
        "valor": "TRAUMATISMO DE MULTIPLES NERVIOS A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S648",
        "valor": "TRAUMATISMO DE OTROS NERVIOS A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S649",
        "valor": "TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DE LA MUÑECA Y DE LA MANO"
      }
    ]
  },
  {
    "grupo": "S65 - TRAUMATISMO DE VASOS SANGUINEOS A NIVEL DE LA MUÑECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "S650",
        "valor": "TRAUMATISMO DE LA ARTERIA CUBITAL A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S651",
        "valor": "TRAUMATISMO DE LA ARTERIA RADIAL A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S652",
        "valor": "TRAUMATISMO DEL ARCO PALMAR SUPERFICIAL"
      },
      {
        "codigo": "S653",
        "valor": "TRAUMATISMO DEL ARCO PALMAR PROFUNDO"
      },
      {
        "codigo": "S654",
        "valor": "TRAUMATISMO DE VASO(S) SANGUINEO(S) DEL PULGAR"
      },
      {
        "codigo": "S655",
        "valor": "TRAUMATISMO DE VASO(S) SANGUINEO(S) DE OTRO DEDO"
      },
      {
        "codigo": "S657",
        "valor": "TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S658",
        "valor": "TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S659",
        "valor": "TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO, A NIVEL DE LA MUÑECA Y DE LA MANO"
      }
    ]
  },
  {
    "grupo": "S66 - TRAUMATISMO DE TENDON Y MUSCULO A NIVEL DE LA MUÑECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "S660",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO FLEXOR LARGO DEL PULGAR A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S661",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO FLEXOR DE OTRO DEDO A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S662",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO EXTENSOR DEL PULGAR A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S663",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO EXTENSOR DE OTRO(S) DEDO(S) A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S664",
        "valor": "TRAUMATISMO DEL MUSCULO Y TENDON INTRINSECO DEL PULGAR A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S665",
        "valor": "TRAUMATISMO DEL MUSCULO Y TENDON INTRINSECO DE OTRO(S) DEDO(S) A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S666",
        "valor": "TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS FLEXORES A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S667",
        "valor": "TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS EXTENSORES A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S668",
        "valor": "TRAUMATISMO DE OTROS TENDONES Y MUSCULOS A NIVEL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S669",
        "valor": "TRAUMATISMO DE TENDON Y MUSCULO NO ESPECIFICADO, A NIVEL DE LA MUÑECA Y DE LA MANO"
      }
    ]
  },
  {
    "grupo": "S67 - TRAUMATISMO POR APLASTAMIENTO DE LA MUÑECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "S670",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DEL PULGAR Y OTRO(S) DEDO(S)"
      },
      {
        "codigo": "S678",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA MUÑECA Y DE LA MANO"
      }
    ]
  },
  {
    "grupo": "S68 - AMPUTACION TRAUMATICA DE LA MUÑECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "S680",
        "valor": "AMPUTACION TRAUMATICA DEL PULGAR (COMPLETA) (PARCIAL)"
      },
      {
        "codigo": "S681",
        "valor": "AMPUTACION TRAUMATICA DE OTRO DEDO UNICO (COMPLETA) (PARCIAL)"
      },
      {
        "codigo": "S682",
        "valor": "AMPUTACION TRAUMATICA DE DOS O MAS DEDOS SOLAMENTE (COMPLETA) (PARCIAL)"
      },
      {
        "codigo": "S683",
        "valor": "AMPUTACION TRAUMATICA COMBINADA (DE PARTE) DE DEDO(S) CON OTRAS PARTES DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S684",
        "valor": "AMPUTACION TRAUMATICA DE LA MANO A NIVEL DE LA MUÑECA"
      },
      {
        "codigo": "S688",
        "valor": "AMPUTACION TRAUMATICA DE OTRAS PARTES DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S689",
        "valor": "AMPUTACION TRAUMATICA DE LA MUÑECA Y DE LA MANO, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S69 - OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DE LA MUÑECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "S697",
        "valor": "OTROS TRAUMATISMOS MULTIPLES DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S698",
        "valor": "OTROS TRAUMATISMOS ESPECIFICADOS DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "S699",
        "valor": "TRAUMATISMO NO ESPECIFICADO DE LA MUÑECA Y DE LA MANO"
      }
    ]
  },
  {
    "grupo": "S70 - TRAUMATISMO SUPERFICIAL DE LA CADERA Y DEL MUSLO",
    "detalle": [
      {
        "codigo": "S700",
        "valor": "CONTUSION DE LA CADERA"
      },
      {
        "codigo": "S701",
        "valor": "CONTUSION DEL MUSLO"
      },
      {
        "codigo": "S707",
        "valor": "TRAUMATISMOS SUPERFICIALES MULTIPLES DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S708",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S709",
        "valor": "TRAUMATISMO SUPERFICIAL DE LA CADERA Y DEL MUSLO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S71 - HERIDA DE LA CADERA Y DEL MUSLO",
    "detalle": [
      {
        "codigo": "S710",
        "valor": "HERIDA DE LA CADERA"
      },
      {
        "codigo": "S711",
        "valor": "HERIDA DEL MUSLO"
      },
      {
        "codigo": "S717",
        "valor": "HERIDAS MULTIPLES DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S718",
        "valor": "HERIDA DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CINTURA PELVICA"
      }
    ]
  },
  {
    "grupo": "S72 - FRACTURA DEL FEMUR",
    "detalle": [
      {
        "codigo": "S720",
        "valor": "FRACTURA DEL CUELLO DE FEMUR"
      },
      {
        "codigo": "S721",
        "valor": "FRACTURA PERTROCANTERIANA"
      },
      {
        "codigo": "S722",
        "valor": "FRACTURA SUBTROCANTERIANA"
      },
      {
        "codigo": "S723",
        "valor": "FRACTURA DE LA DIAFISIS DEL FEMUR"
      },
      {
        "codigo": "S724",
        "valor": "FRACTURA DE LA EPIFISIS INFERIOR DEL FEMUR"
      },
      {
        "codigo": "S727",
        "valor": "FRACTURAS MULTIPLES DEL FEMUR"
      },
      {
        "codigo": "S728",
        "valor": "FRACTURAS DE OTRAS PARTES DEL FEMUR"
      },
      {
        "codigo": "S729",
        "valor": "FRACTURA DEL FEMUR, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S73 - LUXACION, ESGUINCE Y TORCEDURA DE LA ARTICULACION Y DE LOS LIGAMENTOS",
    "detalle": [
      {
        "codigo": "S730",
        "valor": "LUXACION DE LA CADERA"
      },
      {
        "codigo": "S731",
        "valor": "ESGUINCES Y TORCEDURAS DE LA CADERA"
      }
    ]
  },
  {
    "grupo": "S74 - TRAUMATISMO DE NERVIOS A NIVEL DE LA CADERA Y DEL MUSLO",
    "detalle": [
      {
        "codigo": "S740",
        "valor": "TRAUMATISMO DEL NERVIO CIATICO A NIVEL DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S741",
        "valor": "TRAUMATISMO DEL NERVIO FEMOROCUTANEO A NIVEL DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S742",
        "valor": "TRAUMATISMO DEL NERVIO SENSORIAL CUTANEO A NIVEL DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S747",
        "valor": "TRAUMATISMO DE NERVIOS MULTIPLES A NIVEL DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S748",
        "valor": "TRAUMATISMO DE OTROS NERVIOS A NIVEL DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S749",
        "valor": "TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DE LA CADERA Y DEL MUSLO"
      }
    ]
  },
  {
    "grupo": "S75 - TRAUMATISMO DE VASOS SANGUINEOS A NIVEL DE LA CADERA Y DEL MUSLO",
    "detalle": [
      {
        "codigo": "S750",
        "valor": "TRAUMATISMO DE LA ARTERIA FEMORAL"
      },
      {
        "codigo": "S751",
        "valor": "TRAUMATISMO DE LA VENA FEMORAL A NIVEL DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S752",
        "valor": "TRAUMATISMO DE LA GRAN VENA SAFENA A NIVEL DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S757",
        "valor": "TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S758",
        "valor": "TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S759",
        "valor": "TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DE LA CADERA Y DEL MUSLO"
      }
    ]
  },
  {
    "grupo": "S76 - TRAUMATISMO DE TENDON Y MUSCULO A NIVEL DE LA CADERA Y DEL MUSLO",
    "detalle": [
      {
        "codigo": "S760",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO DE LA CADERA"
      },
      {
        "codigo": "S761",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO CUADRICEPS"
      },
      {
        "codigo": "S762",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO ADUCTOR MAYOR DEL MUSLO"
      },
      {
        "codigo": "S763",
        "valor": "TRAUMATISMO DE TENDON Y MUSCULO DEL GRUPO MUSCULAR POSTERIOR A NIVEL DEL MUSLO"
      },
      {
        "codigo": "S764",
        "valor": "TRAUMATISMO DE OTROS TENDONES Y MUSCULOS Y LOS NO ESPECIFICADOS A NIVEL DEL MUSLO"
      },
      {
        "codigo": "S767",
        "valor": "TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS A NIVEL DE LA CADERA Y DEL MUSLO"
      }
    ]
  },
  {
    "grupo": "S77 - TRAUMATISMO POR APLASTAMIENTO DE LA CADERA Y DEL MUSLO",
    "detalle": [
      {
        "codigo": "S770",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE LA CADERA"
      },
      {
        "codigo": "S771",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DEL MUSLO"
      },
      {
        "codigo": "S772",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE LA CADERA CON EL MUSLO"
      }
    ]
  },
  {
    "grupo": "S78 - AMPUTACION TRAUMATICA DE LA CADERA Y DEL MUSLO",
    "detalle": [
      {
        "codigo": "S780",
        "valor": "AMPUTACION TRAUMATICA DE LA ARTICULACION DE LA CADERA"
      },
      {
        "codigo": "S781",
        "valor": "AMPUTACION TRAUMATICA EN ALGUN NIVEL ENTRE LA CADERA Y LA RODILLA"
      },
      {
        "codigo": "S789",
        "valor": "AMPUTACION TRAUMATICA DE CADERA Y MUSLO, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S79 - OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DE LA CADERA Y DEL MUSLO",
    "detalle": [
      {
        "codigo": "S797",
        "valor": "TRAUMATISMOS MULTIPLES DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S798",
        "valor": "OTROS TRAUMATISMOS ESPECIFICADOS DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "S799",
        "valor": "TRAUMATISMO NO ESPECIFICADO DE LA CADERA Y DEL MUSLO"
      }
    ]
  },
  {
    "grupo": "S80 - TRAUMATISMO SUPERFICIAL DE LA PIERNA",
    "detalle": [
      {
        "codigo": "S800",
        "valor": "CONTUSION DE LA RODILLA"
      },
      {
        "codigo": "S801",
        "valor": "CONTUSION DE OTRAS PARTES Y LAS NO ESPECIFICADAS DE LA PIERNA"
      },
      {
        "codigo": "S807",
        "valor": "TRAUMATISMOS SUPERFICIALES MULTIPLES DE LA PIERNA"
      },
      {
        "codigo": "S808",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES DE LA PIERNA"
      },
      {
        "codigo": "S809",
        "valor": "TRAUMATISMO SUPERFICIAL DE LA PIERNA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S81 - HERIDA DE LA PIERNA",
    "detalle": [
      {
        "codigo": "S810",
        "valor": "HERIDA DE LA RODILLA"
      },
      {
        "codigo": "S817",
        "valor": "HERIDAS MULTIPLES DE LA PIERNA"
      },
      {
        "codigo": "S818",
        "valor": "HERIDA DE OTRAS PARTES DE LA PIERNA"
      },
      {
        "codigo": "S819",
        "valor": "HERIDA DE LA PIERNA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S82 - FRACTURA DE LA PIERNA, INCLUSIVE EL TOBILLO",
    "detalle": [
      {
        "codigo": "S820",
        "valor": "FRACTURA DE LA ROTULA"
      },
      {
        "codigo": "S821",
        "valor": "FRACTURA DE LA EPIFISIS SUPERIOR DE LA TIBIA"
      },
      {
        "codigo": "S822",
        "valor": "FRACTURA DE LA DIAFISIS DE LA TIBIA"
      },
      {
        "codigo": "S823",
        "valor": "FRACTURA DE LA EPIFISIS INFERIOR DE LA TIBIA"
      },
      {
        "codigo": "S824",
        "valor": "FRACTURA DEL PERONE SOLAMENTE"
      },
      {
        "codigo": "S825",
        "valor": "FRACTURA DEL MALEOLO INTERNO"
      },
      {
        "codigo": "S826",
        "valor": "FRACTURA DEL MALEOLO EXTERNO"
      },
      {
        "codigo": "S827",
        "valor": "FRACTURAS MULTIPLES DE LA PIERNA"
      },
      {
        "codigo": "S828",
        "valor": "FRACTURA DE OTRAS PARTES DE LA PIERNA"
      },
      {
        "codigo": "S829",
        "valor": "FRACTURA DE LA PIERNA, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S83 - LUXACION, ESGUINCE Y TORCEDURA DE ARTICULACIONES Y LIGAMENTOS DE LA RODILLA",
    "detalle": [
      {
        "codigo": "S830",
        "valor": "LUXACION DE LA ROTULA"
      },
      {
        "codigo": "S831",
        "valor": "LUXACION DE LA RODILLA"
      },
      {
        "codigo": "S832",
        "valor": "DESGARRO DE MENISCOS, PRESENTE"
      },
      {
        "codigo": "S833",
        "valor": "DESGARRO DEL CARTILAGO ARTICULAR DE LA RODILLA, PRESENTE"
      },
      {
        "codigo": "S834",
        "valor": "ESGUINCES Y TORCEDURAS QUE COMPROMETEN LOS LIGAMENTOS LATERALES (EXTERNO) (INTERNO) DE LA RODILLA"
      },
      {
        "codigo": "S835",
        "valor": "ESGUINCES Y TORCEDURAS QUE COMPROMETEN EL LIGAMENTO CRUZADO (ANTERIOR) (POSTERIOR) DE LA RODILLA"
      },
      {
        "codigo": "S836",
        "valor": "ESGUINCES Y TORCEDURAS DE OTRAS PARTES Y LAS NO ESPECIFICADAS DE LA RODILLA"
      },
      {
        "codigo": "S837",
        "valor": "TRAUMATISMO DE ESTRUCTURAS MULTIPLES DE LA RODILLA"
      }
    ]
  },
  {
    "grupo": "S84 - TRAUMATISMO DE NERVIOS A NIVEL DE LA PIERNA",
    "detalle": [
      {
        "codigo": "S840",
        "valor": "TRAUMATISMO DEL NERVIO TIBIAL A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S841",
        "valor": "TRAUMATISMO DEL NERVIO PERONEO A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S842",
        "valor": "TRAUMATISMO DEL NERVIO SENSORIAL CUTANEO A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S847",
        "valor": "TRAUMATISMO DE NERVIOS MULTIPLES A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S848",
        "valor": "TRAUMATISMO DE OTROS NERVIOS A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S849",
        "valor": "TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DE LA PIERNA"
      }
    ]
  },
  {
    "grupo": "S85 - TRAUMATISMO DE VASOS SANGUINEOS A NIVEL DE LA PIERNA",
    "detalle": [
      {
        "codigo": "S850",
        "valor": "TRAUMATISMO DE LA ARTERIA POPLITEA"
      },
      {
        "codigo": "S851",
        "valor": "TRAUMATISMO DE LA ARTERIA TIBIAL (ANTERIOR) (POSTERIOR)"
      },
      {
        "codigo": "S852",
        "valor": "TRAUMATISMO DE LA ARTERIA PERONEA"
      },
      {
        "codigo": "S853",
        "valor": "TRAUMATISMO DE LA GRAN VENA SAFENA A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S854",
        "valor": "TRAUMATISMO DE LA VENA SAFENA EXTERNA A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S855",
        "valor": "TRAUMATISMO DE LA VENA POPLITEA"
      },
      {
        "codigo": "S857",
        "valor": "TRAUMATISMO DE VASOS SANGUINEOS MULTIPLES A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S858",
        "valor": "TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S859",
        "valor": "TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DE LA PIERNA"
      }
    ]
  },
  {
    "grupo": "S86 - TRAUMATISMO DE TENDON Y MUSCULO A NIVEL DE LA PIERNA",
    "detalle": [
      {
        "codigo": "S860",
        "valor": "TRAUMATISMO DEL TENDON DE AQUILES"
      },
      {
        "codigo": "S861",
        "valor": "TRAUMATISMO DE OTRO(S) TENDON(ES) Y MUSCULO(S) DEL GRUPO MUSCULAR POSTERIOR A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S862",
        "valor": "TRAUMATISMO DE TENDON(ES) Y MUSCULO(S) DEL GRUPO MUSCULAR ANTERIOR A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S863",
        "valor": "TRAUMATISMO DE TENDON(ES) Y MUSCULO(S) DEL GRUPO MUSCULAR PERONEO A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S867",
        "valor": "TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S868",
        "valor": "TRAUMATISMO DE OTROS TENDONES Y MUSCULOS A NIVEL DE LA PIERNA"
      },
      {
        "codigo": "S869",
        "valor": "TRAUMATISMO DE TENDON Y MUSCULO NO ESPECIFICADO A NIVEL DE LA PIERNA"
      }
    ]
  },
  {
    "grupo": "S87 - TRAUMATISMO POR APLASTAMIENTO DE LA PIERNA",
    "detalle": [
      {
        "codigo": "S870",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE LA RODILLA"
      },
      {
        "codigo": "S878",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA PIERNA"
      }
    ]
  },
  {
    "grupo": "S88 - AMPUTACION TRAUMATICA DE LA PIERNA",
    "detalle": [
      {
        "codigo": "S880",
        "valor": "AMPUTACION TRAUMATICA A NIVEL DE LA RODILLA"
      },
      {
        "codigo": "S881",
        "valor": "AMPUTACION TRAUMATICA EN ALGUN NIVEL ENTRE LA RODILLA Y EL TOBILLO"
      },
      {
        "codigo": "S889",
        "valor": "AMPUTACION TRAUMATICA DE LA PIERNA, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S89 - OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DE LA PIERNA",
    "detalle": [
      {
        "codigo": "S897",
        "valor": "TRAUMATISMOS MULTIPLES DE LA PIERNA"
      },
      {
        "codigo": "S898",
        "valor": "OTROS TRAUMATISMOS DE LA PIERNA, ESPECIFICADOS"
      },
      {
        "codigo": "S899",
        "valor": "TRAUMATISMO DE LA PIERNA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S90 - TRAUMATISMO SUPERFICIAL DEL TOBILLO Y DEL PIE",
    "detalle": [
      {
        "codigo": "S900",
        "valor": "CONTUSION DEL TOBILLO"
      },
      {
        "codigo": "S901",
        "valor": "CONTUSION DE DEDO(S) DEL PIE SIN DAÑO DE LA(S) UÑA(S)"
      },
      {
        "codigo": "S902",
        "valor": "CONTUSION DE DEDO(S) DEL PIE CON DAÑO DE LA(S) UÑA(S)"
      },
      {
        "codigo": "S903",
        "valor": "CONTUSION DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL PIE"
      },
      {
        "codigo": "S907",
        "valor": "TRAUMATISMOS SUPERFICIALES MULTIPLES DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S908",
        "valor": "OTROS TRAUMATISMOS SUPERFICIALES DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S909",
        "valor": "TRAUMATISMO SUPERFICIAL DEL PIE Y DEL TOBILLO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S91 - HERIDA DEL TOBILLO Y DEL PIE",
    "detalle": [
      {
        "codigo": "S910",
        "valor": "HERIDA DEL TOBILLO"
      },
      {
        "codigo": "S911",
        "valor": "HERIDA DE DEDO(S) DEL PIE SIN DAÑO(S) DE LA(S) UÑA(S)"
      },
      {
        "codigo": "S912",
        "valor": "HERIDA DE DEDO(S) DEL PIE CON DAÑO(S) DE LA(S) UÑA(S)"
      },
      {
        "codigo": "S913",
        "valor": "HERIDA DE OTRAS PARTES DEL PIE"
      },
      {
        "codigo": "S917",
        "valor": "HERIDAS MULTIPLES DEL TOBILLO Y DEL PIE"
      }
    ]
  },
  {
    "grupo": "S92 - FRACTURA DEL PIE, EXCEPTO DEL TOBILLO",
    "detalle": [
      {
        "codigo": "S920",
        "valor": "FRACTURA DEL CALCANEO"
      },
      {
        "codigo": "S921",
        "valor": "FRACTURA DEL ASTRAGALO"
      },
      {
        "codigo": "S922",
        "valor": "FRACTURA DE OTRO(S) HUESO(S) DEL TARSO"
      },
      {
        "codigo": "S923",
        "valor": "FRACTURA DE HUESO DEL METATARSO"
      },
      {
        "codigo": "S924",
        "valor": "FRACTURA DE LOS HUESOS DEL DEDO GORDO DEL PIE"
      },
      {
        "codigo": "S925",
        "valor": "FRACTURA DE LOS HUESOS DE OTRO(S) DEDO(S) DEL PIE"
      },
      {
        "codigo": "S927",
        "valor": "FRACTURAS MULTIPLES DEL PIE"
      },
      {
        "codigo": "S929",
        "valor": "FRACTURA DEL PIE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "S93 - LUXACION, ESGUINCE Y TORCEDURA DE ARTICULACIONES Y LIGAMENTOS DEL TOBILLO Y DEL PIE",
    "detalle": [
      {
        "codigo": "S930",
        "valor": "LUXACION DE LA ARTICULACION DEL TOBILLO"
      },
      {
        "codigo": "S931",
        "valor": "LUXACION DE DEDO(S) DEL PIE"
      },
      {
        "codigo": "S932",
        "valor": "RUPTURA DE LIGAMENTOS A NIVEL DEL TOBILLO Y DEL PIE"
      },
      {
        "codigo": "S933",
        "valor": "LUXACION DE OTROS SITIOS Y LOS NO ESPECIFICADOS DEL PIE"
      },
      {
        "codigo": "S934",
        "valor": "ESGUINCES Y TORCEDURAS DEL TOBILLO"
      },
      {
        "codigo": "S935",
        "valor": "ESGUINCES Y TORCEDURAS DE DEDO(S) DEL PIE"
      },
      {
        "codigo": "S936",
        "valor": "ESGUINCES Y TORCEDURAS DE OTROS SITIOS Y LOS NO ESPECIFICADOS DEL PIE"
      }
    ]
  },
  {
    "grupo": "S94 - TRAUMATISMO DE NERVIOS A NIVEL DEL PIE Y DEL TOBILLO",
    "detalle": [
      {
        "codigo": "S940",
        "valor": "TRAUMATISMO DEL NERVIO PLANTAR EXTERNO"
      },
      {
        "codigo": "S941",
        "valor": "TRAUMATISMO DEL NERVIO PLANTAR INTERNO"
      },
      {
        "codigo": "S942",
        "valor": "TRAUMATISMO DEL NERVIO PERONEAL PROFUNDO A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S943",
        "valor": "TRAUMATISMO DE NERVIO SENSORIAL CUTANEO A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S947",
        "valor": "TRAUMATISMO DE MULTIPLES NERVIOS A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S948",
        "valor": "TRAUMATISMO DE OTROS NERVIOS A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S949",
        "valor": "TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DEL PIE Y DEL TOBILLO"
      }
    ]
  },
  {
    "grupo": "S95 - TRAUMATISMO DE VASOS SANGUINEOS A NIVEL DEL PIE Y DEL TOBILLO",
    "detalle": [
      {
        "codigo": "S950",
        "valor": "TRAUMATISMO DE LA ARTERIA DORSAL DEL PIE"
      },
      {
        "codigo": "S951",
        "valor": "TRAUMATISMO DE LA ARTERIA PLANTAR DEL PIE"
      },
      {
        "codigo": "S952",
        "valor": "TRAUMATISMO DE LA VENA DORSAL DEL PIE"
      },
      {
        "codigo": "S957",
        "valor": "TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S958",
        "valor": "TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S959",
        "valor": "TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DE PIE Y DEL TOBILLO"
      }
    ]
  },
  {
    "grupo": "S96 - TRAUMATISMO DE TENDON Y MUSCULO A NIVEL DEL PIE Y DEL TOBILLO",
    "detalle": [
      {
        "codigo": "S960",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO DEL FLEXOR LARGO DEL DEDO A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S961",
        "valor": "TRAUMATISMO DEL TENDON Y MUSCULO DEL EXTENSOR LARGO DEL (DE LOS) DEDO(S) A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S962",
        "valor": "TRAUMATISMO DE TENDONES Y MUSCULOS INTRINSECOS A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S967",
        "valor": "TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S968",
        "valor": "TRAUMATISMO DE OTROS TENDONES Y MUSCULOS A NIVEL DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S969",
        "valor": "TRAUMATISMO DE TENDONES Y MUSCULOS NO ESPECIFICADOS A NIVEL DEL PIE Y DEL TOBILLO"
      }
    ]
  },
  {
    "grupo": "S97 - TRAUMATISMO POR APLASTAMIENTO DEL PIE Y DEL TOBILLO",
    "detalle": [
      {
        "codigo": "S970",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DEL TOBILLO"
      },
      {
        "codigo": "S971",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE DEDO(S) DEL PIE"
      },
      {
        "codigo": "S978",
        "valor": "TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES DEL PIE Y DEL TOBILLO"
      }
    ]
  },
  {
    "grupo": "S98 - AMPUTACION TRAUMATICA DEL PIE Y DEL TOBILLO",
    "detalle": [
      {
        "codigo": "S980",
        "valor": "AMPUTACION TRAUMATICA DEL PIE A NIVEL DEL TOBILLO"
      },
      {
        "codigo": "S981",
        "valor": "AMPUTACION TRAUMATICA DE UN DEDO DEL PIE"
      },
      {
        "codigo": "S982",
        "valor": "AMPUTACION TRAUMATICA DE DOS A MAS DEDOS DEL PIE"
      },
      {
        "codigo": "S983",
        "valor": "AMPUTACION TRAUMATICA DE OTRAS PARTES DEL PIE"
      },
      {
        "codigo": "S984",
        "valor": "AMPUTACION DEL PIE, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "S99 - OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DEL PIE Y DEL TOBILLO",
    "detalle": [
      {
        "codigo": "S997",
        "valor": "OTROS TRAUMATISMOS MULTIPLES DEL PIE Y DEL TOBILLO"
      },
      {
        "codigo": "S998",
        "valor": "OTROS TRAUMATISMOS DEL PIE Y DEL TOBILLO, ESPECIFICADOS"
      },
      {
        "codigo": "S999",
        "valor": "TRAUMATISMO DEL PIE Y DEL TOBILLO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T00 - TRAUMATISMOS SUPERFICIALES QUE AFECTAN MULTIPLES REGIONES DEL CUERPO",
    "detalle": [
      {
        "codigo": "T000",
        "valor": "TRAUMATISMOS SUPERFICIALES QUE AFECTAN LA CABEZA CON EL CUELLO"
      },
      {
        "codigo": "T001",
        "valor": "TRAUMATISMOS SUPERFICIALES QUE AFECTAN EL TORAX CON EL ABDOMEN, LA REGION LUMBOSACRA Y LA PELVIS"
      },
      {
        "codigo": "T002",
        "valor": "TRAUMATISMOS SUPERFICIALES QUE AFECTAN MULTIPLES REGIONES DEL(OS) MIEMBRO(S) SUPERIOR(ES)"
      },
      {
        "codigo": "T003",
        "valor": "TRAUMATISMOS SUPERFICIALES QUE AFECTAN MULTIPLES REGIONES DEL(DE LOS) MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "T006",
        "valor": "TRAUMATISMOS SUPERFICIALES QUE AFECTAN MULTIPLES REGIONES DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES) CON MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "T008",
        "valor": "TRAUMATISMOS SUPERFICIALES QUE AFECTAN OTRAS COMBINACIONES DE REGIONES DEL CUERPO"
      },
      {
        "codigo": "T009",
        "valor": "TRAUMATISMOS SUPERFICIALES MULTIPLES, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T01 - HERIDAS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO",
    "detalle": [
      {
        "codigo": "T010",
        "valor": "HERIDAS QUE AFECTAN LA CABEZA CON EL CUELLO"
      },
      {
        "codigo": "T011",
        "valor": "HERIDAS QUE AFECTAN EL TORAX CON EL ABDOMEN, LA REGION LUMBOSACRA Y LA PELVIS"
      },
      {
        "codigo": "T012",
        "valor": "HERIDAS QUE AFECTAN MULTIPLES REGIONES DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES)"
      },
      {
        "codigo": "T013",
        "valor": "HERIDAS QUE AFECTAN MULTIPLES REGIONES DEL (DE LOS) MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "T016",
        "valor": "HERIDAS QUE AFECTAN MULTIPLES REGIONES DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES) CON MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "T018",
        "valor": "HERIDAS QUE AFECTAN OTRAS COMBINACIONES DE LAS REGIONES DEL CUERPO"
      },
      {
        "codigo": "T019",
        "valor": "HERIDAS MULTIPLES, NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "T02 - FRACTURAS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO",
    "detalle": [
      {
        "codigo": "T020",
        "valor": "FRACTURAS QUE AFECTAN LA CABEZA CON EL CUELLO"
      },
      {
        "codigo": "T021",
        "valor": "FRACTURAS QUE AFECTAN EL TORAX CON LA REGION LUMBOSACRA Y LA PELVIS"
      },
      {
        "codigo": "T022",
        "valor": "FRACTURAS QUE AFECTAN MULTIPLES REGIONES DE UN MIEMBRO SUPERIOR"
      },
      {
        "codigo": "T023",
        "valor": "FRACTURAS QUE AFECTAN MULTIPLES REGIONES DE UN MIEMBRO INFERIOR"
      },
      {
        "codigo": "T024",
        "valor": "FRACTURAS QUE AFECTAN MULTIPLES REGIONES DE AMBOS MIEMBROS SUPERIORES"
      },
      {
        "codigo": "T025",
        "valor": "FRACTURAS QUE AFECTAN MULTIPLES REGIONES DE AMBOS MIEMBROS INFERIORES"
      },
      {
        "codigo": "T026",
        "valor": "FRACTURAS QUE AFECTAN MULTIPLES REGIONES DE MIEMBRO(S) SUPERIOR(ES) CON MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "T027",
        "valor": "FRACTURAS QUE AFECTAN EL TORAX CON LA REGION LUMBOSACRA Y LA PELVIS CON MIEMBRO(S)"
      },
      {
        "codigo": "T028",
        "valor": "FRACTURAS QUE AFECTAN OTRAS COMBINACIONES DE LAS REGIONES DEL CUERPO"
      },
      {
        "codigo": "T029",
        "valor": "FRACTURAS MULTIPLES, NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "T03 - LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN MULTIPLES REGIONES DEL CUERPO",
    "detalle": [
      {
        "codigo": "T030",
        "valor": "LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN LA CABEZA CON EL CUELLO"
      },
      {
        "codigo": "T031",
        "valor": "LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN EL TORAX CON LA REGION LUMBOSACRA Y LA PELVIS"
      },
      {
        "codigo": "T032",
        "valor": "LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN MULTIPLES REGIONES DEL (DE LOS) MIEMBROS(S) SUPERIOR(ES)"
      },
      {
        "codigo": "T033",
        "valor": "LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN MULTIPLES REGIONES DEL (DE LOS) MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "T034",
        "valor": "LUXACIONES, TORCEDURAS ESGUINCES QUE AFECTAN MULTIPLES REGIONES DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES) CON MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "T038",
        "valor": "LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN OTRAS COMBINACIONES DE REGIONES DEL CUERPO"
      },
      {
        "codigo": "T039",
        "valor": "LUXACIONES, TORCEDURAS Y ESGUINCES MULTIPLES, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T04 - TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN MULTIPLES REGIONES DEL CUERPO",
    "detalle": [
      {
        "codigo": "T040",
        "valor": "TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN LA CABEZA CON EL CUELLO"
      },
      {
        "codigo": "T041",
        "valor": "TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN EL TORAX CON EL ABDOMEN, LA REGION LUMBOSACRA Y LA PELVIS"
      },
      {
        "codigo": "T042",
        "valor": "TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN MULTIPLES REGIONES DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES)"
      },
      {
        "codigo": "T043",
        "valor": "TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN MULTIPLES REGIONES DEL (DE LOS) MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "T044",
        "valor": "TRAUMATISMOS POR APLASTAMIENTO QUE AFECTA MULTIPLES REGIONES DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES) CON MIEMBRO(S) INFERIOR(ES)"
      },
      {
        "codigo": "T047",
        "valor": "TRAUMATISMOS POR APLASTAMIENTO DEL TORAX, DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS CON MIEMBRO(S)"
      },
      {
        "codigo": "T048",
        "valor": "TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN OTRAS COMBINACIONES DE REGIONES DEL CUERPO"
      },
      {
        "codigo": "T049",
        "valor": "TRAUMATISMOS POR APLASTAMIENTO MULTIPLE, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T05 - AMPUTACIONES TRAUMATICAS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO",
    "detalle": [
      {
        "codigo": "T050",
        "valor": "AMPUTACION TRAUMATICA DE AMBAS MANOS"
      },
      {
        "codigo": "T051",
        "valor": "AMPUTACION TRAUMATICA DE UNA MANO Y EL OTRO BRAZO [CUALQUIER NIVEL, EXCEPTO MANO]"
      },
      {
        "codigo": "T052",
        "valor": "AMPUTACION TRAUMATICA DE AMBOS BRAZOS [CUALQUIER NIVEL]"
      },
      {
        "codigo": "T053",
        "valor": "AMPUTACION TRAUMATICA DE AMBOS PIES"
      },
      {
        "codigo": "T054",
        "valor": "AMPUTACION TRAUMATICA DE UN PIE Y LA OTRA PIERNA [CUALQUIER NIVEL, EXCEPTO PIE]"
      },
      {
        "codigo": "T055",
        "valor": "AMPUTACION TRAUMATICA DE AMBAS PIERNAS [CUALQUIER NIVEL]"
      },
      {
        "codigo": "T056",
        "valor": "AMPUTACION TRAUMATICA DE MIEMBROS SUPERIOR(ES) E INFERIOR(ES), CUALQUIER COMBINACION [CUALQUIER NIVEL]"
      },
      {
        "codigo": "T058",
        "valor": "AMPUTACION TRAUMATICA QUE AFECTA OTRAS COMBINACIONES DE REGIONES DEL CUERPO"
      },
      {
        "codigo": "T059",
        "valor": "AMPUTACIONES TRAUMATICAS MULTIPLES, NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "T06 - OTROS TRAUMATISMOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "T060",
        "valor": "TRAUMATISMOS DEL ENCEFALO Y DE NERVIOS CRANEALES CON TRAUMATISMO DE NERVIOS Y MEDULA ESPINAL A NIVEL DEL CUELLO"
      },
      {
        "codigo": "T061",
        "valor": "TRAUMATISMOS DE NERVIOS Y MEDULA ESPINAL QUE AFECTAN OTRAS MULTIPLES REGIONES DEL CUERPO"
      },
      {
        "codigo": "T062",
        "valor": "TRAUMATISMOS DE NERVIOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO"
      },
      {
        "codigo": "T063",
        "valor": "TRAUMATISMOS DE VASOS SANGUINEOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO"
      },
      {
        "codigo": "T064",
        "valor": "TRAUMATISMOS DE TENDONES Y MUSCULOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO"
      },
      {
        "codigo": "T065",
        "valor": "TRAUMATISMOS DE ORGANOS INTRATORACICOS CON ORGANOS INTRAABDOMINALES Y PELVICOS"
      },
      {
        "codigo": "T068",
        "valor": "OTROS TRAUMATISMOS ESPECIFICADOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO"
      }
    ]
  },
  {
    "grupo": "T07 - TRAUMATISMOS MULTIPLES, NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "T07X",
        "valor": "TRAUMATISMOS MULTIPLES, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T08 - FRACTURA DE LA COLUMNA VERTEBRAL, NIVEL NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "T08X",
        "valor": "FRACTURA DE LA COLUMNA VERTEBRAL, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T09 - OTROS TRAUMATISMOS DE LA COLUMNA VERTEBRAL Y DEL TRONCO, NIVEL NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "T090",
        "valor": "TRAUMATISMO SUPERFICIAL DEL TRONCO, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T091",
        "valor": "HERIDA DEL TRONCO, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T092",
        "valor": "LUXACION, ESGUINCE O TORCEDURA DE ARTICULACION Y LIGAMENTOS DEL TRONCO, NO ESPECIFICADO"
      },
      {
        "codigo": "T093",
        "valor": "TRAUMATISMO DE LA MEDULA ESPINAL, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T094",
        "valor": "TRAUMATISMO DE NERVIOS, RAIZ DE NERVIO ESPINAL Y PLEXOS DEL TRONCO NO ESPECIFICADOS"
      },
      {
        "codigo": "T095",
        "valor": "TRAUMATISMO DE TENDONES Y MUSCULOS DEL TRONCO NO ESPECIFICADOS"
      },
      {
        "codigo": "T096",
        "valor": "AMPUTACION TRAUMATICA DEL TRONCO, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T098",
        "valor": "OTROS TRAUMATISMOS ESPECIFICADOS DEL TRONCO, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T099",
        "valor": "TRAUMATISMO NO ESPECIFICADO DEL TRONCO, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T10 - FRACTURA DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "T10X",
        "valor": "FRACTURA DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T11 - OTROS TRAUMATISMOS DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "T110",
        "valor": "TRAUMATISMO SUPERFICIAL DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T111",
        "valor": "HERIDA DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T112",
        "valor": "LUXACION, ESGUINCE O TORCEDURA DE ARTICULACION O LIGAMENTO NO ESPECIFICADO DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T113",
        "valor": "TRAUMATISMO DE NERVIO NO ESPECIFICADO DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T114",
        "valor": "TRAUMATISMO DE VASOS SANGUINEOS NO ESPECIFICADOS DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T115",
        "valor": "TRAUMATISMO DE TENDON Y MUSCULO NO ESPECIFICADOS DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T116",
        "valor": "AMPUTACION TRAUMATICA DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T118",
        "valor": "OTROS TRAUMATISMOS ESPECIFICADOS DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T119",
        "valor": "TRAUMATISMO NO ESPECIFICADO DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T12 - FRACTURA DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "T12X",
        "valor": "FRACTURA DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T13 - OTROS TRAUMATISMOS DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "T130",
        "valor": "TRAUMATISMO SUPERFICIAL DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO."
      },
      {
        "codigo": "T131",
        "valor": "HERIDA DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T132",
        "valor": "LUXACION, ESGUINCE O TORCEDURA DE ARTICULACION Y LIGAMENTOS NO ESPECIFICADOS DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T133",
        "valor": "TRAUMATISMO DE NERVIOS NO ESPECIFICADOS DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T134",
        "valor": "TRAUMATISMO DE VASOS SANGUINEOS NO ESPECIFICADOS DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T135",
        "valor": "TRAUMATISMO DE TENDONES Y MUSCULOS NO ESPECIFICADOS DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T136",
        "valor": "AMPUTACION TRAUMATICA DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T138",
        "valor": "OTROS TRAUMATISMOS ESPECIFICADOS DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO"
      },
      {
        "codigo": "T139",
        "valor": "TRAUMATISMO NO ESPECIFICADO DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T14 - TRAUMATISMO DE REGIONES NO ESPECIFICADAS DEL CUERPO",
    "detalle": [
      {
        "codigo": "T140",
        "valor": "TRAUMATISMO SUPERFICIAL DE REGION NO ESPECIFICADA DEL CUERPO"
      },
      {
        "codigo": "T141",
        "valor": "HERIDA DE REGION NO ESPECIFICADA DEL CUERPO"
      },
      {
        "codigo": "T142",
        "valor": "FRACTURA DE REGION NO ESPECIFICADA DEL CUERPO"
      },
      {
        "codigo": "T143",
        "valor": "LUXACION, ESGUINCE Y TORCEDURA DE REGION NO ESPECIFICADA DEL CUERPO"
      },
      {
        "codigo": "T144",
        "valor": "TRAUMATISMO DE NERVIO(S) DE REGION NO ESPECIFICADA DEL CUERPO"
      },
      {
        "codigo": "T145",
        "valor": "TRAUMATISMO DE VASO(S) SANGUINEO(S) DE REGION NO ESPECIFICADA DEL CUERPO"
      },
      {
        "codigo": "T146",
        "valor": "TRAUMATISMO DE TENDONES Y MUSCULOS DE REGION NO ESPECIFICADA DEL CUERPO"
      },
      {
        "codigo": "T147",
        "valor": "TRAUMATISMO POR APLASTAMIENTO Y AMPUTACION TRAUMATICA DE REGIONES NO ESPECIFICADAS DEL CUERPO"
      },
      {
        "codigo": "T148",
        "valor": "OTROS TRAUMATISMOS DE REGION NO ESPECIFICADA DEL CUERPO"
      },
      {
        "codigo": "T149",
        "valor": "TRAUMATISMO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T15 - CUERPO EXTRAÑO EN PARTE EXTERNA DEL OJO",
    "detalle": [
      {
        "codigo": "T150",
        "valor": "CUERPO EXTRAÑO EN LA CORNEA"
      },
      {
        "codigo": "T151",
        "valor": "CUERPO EXTRAÑO EN EL SACO CONJUNTIVAL"
      },
      {
        "codigo": "T158",
        "valor": "CUERPO EXTRAÑO EN OTRAS Y EN MULTIPLES PARTES DE LA PARTE EXTERNA DEL OJO"
      },
      {
        "codigo": "T159",
        "valor": "CUERPO EXTRAÑO EN PARTE EXTERNA DEL OJO, SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T16 - CUERPO EXTRAÑO EN EL OIDO",
    "detalle": [
      {
        "codigo": "T16X",
        "valor": "CUERPO EXTRAÑO EN EL OIDO"
      }
    ]
  },
  {
    "grupo": "T17 - CUERPO EXTRAÑO EN LAS VIAS RESPIRATORIAS",
    "detalle": [
      {
        "codigo": "T170",
        "valor": "CUERPO EXTRAÑO EN SENO PARANASAL"
      },
      {
        "codigo": "T171",
        "valor": "CUERPO EXTRAÑO EN EL ORIFICIO NASAL"
      },
      {
        "codigo": "T172",
        "valor": "CUERPO EXTRAÑO EN LA FARINGE"
      },
      {
        "codigo": "T173",
        "valor": "CUERPO EXTRAÑO EN LA LARINGE"
      },
      {
        "codigo": "T174",
        "valor": "CUERPO EXTRAÑO EN LA TRAQUEA"
      },
      {
        "codigo": "T175",
        "valor": "CUERPO EXTRAÑO EN BRONQUIOS"
      },
      {
        "codigo": "T178",
        "valor": "CUERPO EXTRAÑO EN OTRAS Y EN MULTIPLES PARTES DE LAS VIAS RESPIRATORIAS"
      },
      {
        "codigo": "T179",
        "valor": "CUERPO EXTRAÑO EN LAS VIAS RESPIRATORIAS, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T18 - CUERPO EXTRAÑO EN EL TUBO DIGESTIVO",
    "detalle": [
      {
        "codigo": "T180",
        "valor": "CUERPO EXTRAÑO EN LA BOCA"
      },
      {
        "codigo": "T181",
        "valor": "CUERPO EXTRAÑO EN EL ESOFAGO"
      },
      {
        "codigo": "T182",
        "valor": "CUERPO EXTRAÑO EN EL ESTOMAGO"
      },
      {
        "codigo": "T183",
        "valor": "CUERPO EXTRAÑO EN EL INTESTINO DELGADO"
      },
      {
        "codigo": "T184",
        "valor": "CUERPO EXTRAÑO EN EL COLON"
      },
      {
        "codigo": "T185",
        "valor": "CUERPO EXTRAÑO EN EL ANO Y EN EL RECTO"
      },
      {
        "codigo": "T188",
        "valor": "CUERPO EXTRAÑO EN OTRAS Y EN MULTIPLES PARTES DEL TUBO DIGESTIVO"
      },
      {
        "codigo": "T189",
        "valor": "CUERPO EXTRAÑO EN EL TUBO DIGESTIVO, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T19 - CUERPO EXTRAÑO EN LAS VIAS GENITOURINARIAS",
    "detalle": [
      {
        "codigo": "T190",
        "valor": "CUERPO EXTRAÑO EN LA URETRA"
      },
      {
        "codigo": "T191",
        "valor": "CUERPO EXTRAÑO EN LA VEJIGA"
      },
      {
        "codigo": "T192",
        "valor": "CUERPO EXTRAÑO EN LA VULVA Y EN LA VAGINA"
      },
      {
        "codigo": "T193",
        "valor": "CUERPO EXTRAÑO EN EL UTERO [CUALQUIER PARTE]"
      },
      {
        "codigo": "T198",
        "valor": "CUERPO EXTRAÑO EN OTRAS Y EN MULTIPLES PARTES DE LAS VIAS GENITOURINARIAS"
      },
      {
        "codigo": "T199",
        "valor": "CUERPO EXTRAÑO EN LAS VIAS GENITOURINARIAS, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T20 - QUEMADURA Y CORROSION DE LA CABEZA Y DEL CUELLO",
    "detalle": [
      {
        "codigo": "T200",
        "valor": "QUEMADURA DE LA CABEZA Y DEL CUELLO, GRADO NO ESPECIFICADO"
      },
      {
        "codigo": "T201",
        "valor": "QUEMADURA DE LA CABEZA Y DEL CUELLO, DE PRIMER GRADO"
      },
      {
        "codigo": "T202",
        "valor": "QUEMADURA DE LA CABEZA Y DEL CUELLO, DE SEGUNDO GRADO"
      },
      {
        "codigo": "T203",
        "valor": "QUEMADURA DE LA CABEZA Y DEL CUELLO, DE TERCER GRADO"
      },
      {
        "codigo": "T204",
        "valor": "CORROSION DE LA CABEZA Y DEL CUELLO, GRADO NO ESPECIFICADO"
      },
      {
        "codigo": "T205",
        "valor": "CORROSION DE LA CABEZA Y DEL CUELLO, DE PRIMER GRADO"
      },
      {
        "codigo": "T206",
        "valor": "CORROSION DE LA CABEZA Y DEL CUELLO, DE SEGUNDO GRADO"
      },
      {
        "codigo": "T207",
        "valor": "CORROSION DE LA CABEZA Y DEL CUELLO, DE TERCER GRADO"
      }
    ]
  },
  {
    "grupo": "T21 - QUEMADURA Y CORROSION DEL TRONCO",
    "detalle": [
      {
        "codigo": "T210",
        "valor": "QUEMADURA DEL TRONCO, GRADO NO ESPECIFICADO"
      },
      {
        "codigo": "T211",
        "valor": "QUEMADURA DEL TRONCO, DE PRIMER GRADO"
      },
      {
        "codigo": "T212",
        "valor": "QUEMADURA DEL TRONCO, DE SEGUNDO GRADO"
      },
      {
        "codigo": "T213",
        "valor": "QUEMADURA DEL TRONCO, DE TERCER GRADO"
      },
      {
        "codigo": "T214",
        "valor": "CORROSION DEL TRONCO, GRADO NO ESPECIFICADO"
      },
      {
        "codigo": "T215",
        "valor": "CORROSION DEL TRONCO, DE PRIMER GRADO"
      },
      {
        "codigo": "T216",
        "valor": "CORROSION DEL TRONCO, DE SEGUNDO GRADO"
      },
      {
        "codigo": "T217",
        "valor": "CORROSION DEL TRONCO, DE TERCER GRADO"
      }
    ]
  },
  {
    "grupo": "T22 - QUEMADURA Y CORROSION DEL HOMBRO Y MIEMBRO SUPERIOR, EXCEPTO DE LA MUÑECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "T220",
        "valor": "QUEMADURA DEL HOMBRO Y MIEMBRO SUPERIOR, GRADO NO ESPECIFICADO, EXCEPTO DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "T221",
        "valor": "QUEMADURA DEL HOMBRO Y MIEMBRO SUPERIOR, DE PRIMER GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "T222",
        "valor": "QUEMADURA DEL HOMBRO Y MIEMBRO SUPERIOR, DE SEGUNDO GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "T223",
        "valor": "QUEMADURA DEL HOMBRO Y MIEMBRO SUPERIOR, DE TERCER GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "T224",
        "valor": "CORROSION DEL HOMBRO Y MIEMBRO SUPERIOR, GRADO NO ESPECIFICADO, EXCEPTO DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "T225",
        "valor": "CORROSION DEL HOMBRO Y MIEMBRO SUPERIOR, DE PRIMER GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "T226",
        "valor": "CORROSION DEL HOMBRO Y MIEMBRO SUPERIOR, DE SEGUNDO GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "T227",
        "valor": "CORROSION DEL HOMBRO Y MIEMBRO SUPERIOR, DE TERCER GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO"
      }
    ]
  },
  {
    "grupo": "T23 - QUEMADURA Y CORROSION DE LA MUÑECA Y DE LA MANO",
    "detalle": [
      {
        "codigo": "T230",
        "valor": "QUEMADURA DE LA MUÑECA Y DE LA MANO, GRADO NO ESPECIFICADO"
      },
      {
        "codigo": "T231",
        "valor": "QUEMADURA DE LA MUÑECA Y DE LA MANO, DE PRIMER GRADO"
      },
      {
        "codigo": "T232",
        "valor": "QUEMADURA DE LA MUÑECA Y DE LA MANO, DE SEGUNDO GRADO"
      },
      {
        "codigo": "T233",
        "valor": "QUEMADURA DE LA MUÑECA Y DE LA MANO, DE TERCER GRADO"
      },
      {
        "codigo": "T234",
        "valor": "CORROSION DE LA MUÑECA Y DE LA MANO, GRADO NO ESPECIFICADO"
      },
      {
        "codigo": "T235",
        "valor": "CORROSION DE LA MUÑECA Y DE LA MANO, DE PRIMER GRADO"
      },
      {
        "codigo": "T236",
        "valor": "CORROSION DE LA MUÑECA Y DE LA MANO, DE SEGUNDO GRADO"
      },
      {
        "codigo": "T237",
        "valor": "CORROSION DE LA MUÑECA Y DE LA MANO, DE TERCER GRADO"
      }
    ]
  },
  {
    "grupo": "T24 - QUEMADURA Y CORROSION DE LA CADERA Y MIEMBRO INFERIOR, EXCEPTO TOBILLO",
    "detalle": [
      {
        "codigo": "T240",
        "valor": "QUEMADURA DE LA CADERA Y MIEMBRO INFERIOR, GRADO NO ESPECIFICADO, EXCEPTO TOBILLO Y PIE"
      },
      {
        "codigo": "T241",
        "valor": "QUEMADURA DE LA CADERA Y MIEMBRO INFERIOR, DE PRIMER GRADO, EXCEPTO TOBILLO Y PIE"
      },
      {
        "codigo": "T242",
        "valor": "QUEMADURA DE LA CADERA Y MIEMBRO INFERIOR, DE SEGUNDO GRADO , EXCEPTO TOBILLO Y PIE"
      },
      {
        "codigo": "T243",
        "valor": "QUEMADURA DE LA CADERA Y MIEMBRO INFERIOR, DE TERCER GRADO, EXCEPTO TOBILLO Y PIE"
      },
      {
        "codigo": "T244",
        "valor": "CORROSION DE LA CADERA Y MIEMBRO INFERIOR, GRADO NO ESPECIFICADO, EXCEPTO TOBILLO Y PIE"
      },
      {
        "codigo": "T245",
        "valor": "CORROSION DE LA CADERA Y MIEMBRO INFERIOR, DE PRIMER GRADO, EXCEPTO TOBILLO Y PIE"
      },
      {
        "codigo": "T246",
        "valor": "CORROSION DE LA CADERA Y MIEMBRO INFERIOR, DE SEGUNDO GRADO, EXCEPTO TOBILLO Y PIE"
      },
      {
        "codigo": "T247",
        "valor": "CORROSION DE LA CADERA Y MIEMBRO INFERIOR, DE TERCER GRADO, EXCEPTO TOBILLO Y PIE"
      }
    ]
  },
  {
    "grupo": "T25 - QUEMADURA Y CORROSION DEL TOBILLO Y DEL PIE",
    "detalle": [
      {
        "codigo": "T250",
        "valor": "QUEMADURA DEL TOBILLO Y DEL PIE, GRADO NO ESPECIFICADO"
      },
      {
        "codigo": "T251",
        "valor": "QUEMADURA DEL TOBILLO Y DEL PIE, DE PRIMER GRADO"
      },
      {
        "codigo": "T252",
        "valor": "QUEMADURA DEL TOBILLO Y DEL PIE, DE SEGUNDO GRADO"
      },
      {
        "codigo": "T253",
        "valor": "QUEMADURA DEL TOBILLO Y DEL PIE, DE TERCER GRADO"
      },
      {
        "codigo": "T254",
        "valor": "CORROSION DEL TOBILLO Y DEL PIE, GRADO NO ESPECIFICADO"
      },
      {
        "codigo": "T255",
        "valor": "CORROSION DEL TOBILLO Y DEL PIE, DE PRIMER GRADO"
      },
      {
        "codigo": "T256",
        "valor": "CORROSION DEL TOBILLO Y DEL PIE, DE SEGUNDO GRADO"
      },
      {
        "codigo": "T257",
        "valor": "CORROSION DEL TOBILLO Y DEL PIE, DE TERCER GRADO"
      }
    ]
  },
  {
    "grupo": "T26 - QUEMADURA Y CORROSION LIMITADA AL OJO Y SUS ANEXOS",
    "detalle": [
      {
        "codigo": "T260",
        "valor": "QUEMADURA DEL PARPADO Y AREA PERIOCULAR"
      },
      {
        "codigo": "T261",
        "valor": "QUEMADURA DE LA CORNEA Y SACO CONJUNTIVAL"
      },
      {
        "codigo": "T262",
        "valor": "QUEMADURA CON RUPTURA Y DESTRUCCION RESULTANTES DEL GLOBO OCULAR"
      },
      {
        "codigo": "T263",
        "valor": "QUEMADURA DE OTRAS PARTES DEL OJO Y SUS ANEXOS"
      },
      {
        "codigo": "T264",
        "valor": "QUEMADURA DEL OJO Y ANEXOS, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "T265",
        "valor": "CORROSION DEL PARPADO Y AREA PERIOCULAR"
      },
      {
        "codigo": "T266",
        "valor": "CORROSION DE LA CORNEA Y SACO CONJUNTIVAL"
      },
      {
        "codigo": "T267",
        "valor": "CORROSION CON RUPTURA Y DESTRUCCION RESULTANTES DEL GLOBO OCULAR"
      },
      {
        "codigo": "T268",
        "valor": "CORROSION DE OTRAS PARTES DEL OJO Y SUS ANEXOS"
      },
      {
        "codigo": "T269",
        "valor": "CORROSION DEL OJO Y SUS ANEXOS, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T27 - QUEMADURA Y CORROSION DE LAS VIAS RESPIRATORIAS",
    "detalle": [
      {
        "codigo": "T270",
        "valor": "QUEMADURA DE LA LARINGE Y DE LA TRAQUEA"
      },
      {
        "codigo": "T271",
        "valor": "QUEMADURA QUE AFECTA LA LARINGE Y LA TRAQUEA CON EL PULMON"
      },
      {
        "codigo": "T272",
        "valor": "QUEMADURA DE OTRAS PARTES DE LAS VIAS RESPIRATORIAS"
      },
      {
        "codigo": "T273",
        "valor": "QUEMADURA DE LAS VIAS RESPIRATORIAS, PARTE NO ESPECIFICADA"
      },
      {
        "codigo": "T274",
        "valor": "CORROSION DE LA LARINGE Y DE LA TRAQUEA"
      },
      {
        "codigo": "T275",
        "valor": "CORROSION QUE AFECTA LA LARINGE Y LA TRAQUEA CON EL PULMON"
      },
      {
        "codigo": "T276",
        "valor": "CORROSION DE OTRAS PARTES DE LAS VIAS RESPIRATORIAS"
      },
      {
        "codigo": "T277",
        "valor": "CORROSION DE LAS VIAS RESPIRATORIAS, PARTE NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T28 - QUEMADURA Y CORROSION DE OTROS ORGANOS INTERNOS",
    "detalle": [
      {
        "codigo": "T280",
        "valor": "QUEMADURA DE LA BOCA Y DE LA FARINGE"
      },
      {
        "codigo": "T281",
        "valor": "QUEMADURA DEL ESOFAGO"
      },
      {
        "codigo": "T282",
        "valor": "QUEMADURA DE OTRAS PARTES DEL TUBO DIGESTIVO"
      },
      {
        "codigo": "T283",
        "valor": "QUEMADURA DE ORGANOS GENITOURINARIOS INTERNOS"
      },
      {
        "codigo": "T284",
        "valor": "QUEMADURA DE OTROS ORGANOS INTERNOS Y DE LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "T285",
        "valor": "CORROSION DE LA BOCA Y DE LA FARINGE"
      },
      {
        "codigo": "T286",
        "valor": "CORROSION DEL ESOFAGO"
      },
      {
        "codigo": "T287",
        "valor": "CORROSION DE OTRAS PARTES DEL TUBO DIGESTIVO"
      },
      {
        "codigo": "T288",
        "valor": "CORROSION DE ORGANOS GENITOURINARIOS INTERNOS"
      },
      {
        "codigo": "T289",
        "valor": "CORROSION DE OTROS ORGANOS INTERNOS Y DE LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T29 - QUEMADURAS Y CORROSIONES DE MULTIPLES REGIONES DEL CUERPO",
    "detalle": [
      {
        "codigo": "T290",
        "valor": "QUEMADURAS DE MULTIPLES REGIONES, GRADO NO ESPECIFICADO"
      },
      {
        "codigo": "T291",
        "valor": "QUEMADURAS DE MULTIPLES REGIONES, MENCIONADAS COMO DE NO MAS DE PRIMER GRADO"
      },
      {
        "codigo": "T292",
        "valor": "QUEMADURAS DE MULTIPLES REGIONES, MENCIONADAS COMO DE NO MAS DE SEGUNDO GRADO"
      },
      {
        "codigo": "T293",
        "valor": "QUEMADURAS MULTIPLES, CON MENCION AL MENOS DE UNA QUEMADURA DE TERCER GRADO"
      },
      {
        "codigo": "T294",
        "valor": "CORROSIONES DE MULTIPLES REGIONES, GRADO NO ESPECIFICADO"
      },
      {
        "codigo": "T295",
        "valor": "CORROSIONES MULTIPLES, MENCIONADAS COMO DE NO MAS DE PRIMER GRADO"
      },
      {
        "codigo": "T296",
        "valor": "CORROSIONES MULTIPLES, MENCIONADAS COMO DE NO MAS DE SEGUNDO GRADO"
      },
      {
        "codigo": "T297",
        "valor": "CORROSIONES MULTIPLES, CON MENCION AL MENOS DE UNA CORROSION DE TERCER GRADO"
      }
    ]
  },
  {
    "grupo": "T30 - QUEMADURA Y CORROSION, REGION DEL CUERPO NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "T300",
        "valor": "QUEMADURA DE REGION DEL CUERPO Y GRADO NO ESPECIFICADOS"
      },
      {
        "codigo": "T301",
        "valor": "QUEMADURA DE PRIMER GRADO, REGION DEL CUERPO NO ESPECIFICADA"
      },
      {
        "codigo": "T302",
        "valor": "QUEMADURA DE SEGUNDO GRADO, REGION DEL CUERPO NO ESPECIFICADA"
      },
      {
        "codigo": "T303",
        "valor": "QUEMADURA DE TERCER GRADO, REGION DEL CUERPO NO ESPECIFICADA"
      },
      {
        "codigo": "T304",
        "valor": "CORROSION DE REGION DEL CUERPO Y GRADO NO ESPECIFICADOS"
      },
      {
        "codigo": "T305",
        "valor": "CORROSION DE PRIMER GRADO, REGION DEL CUERPO NO ESPECIFICADA"
      },
      {
        "codigo": "T306",
        "valor": "CORROSION DE SEGUNDO GRADO, REGION DEL CUERPO NO ESPECIFICADA"
      },
      {
        "codigo": "T307",
        "valor": "CORROSION DE TERCER GRADO, REGION DEL CUERPO NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T31 - QUEMADURAS CLASIFICADAS SEGUN LA EXTENSION DE LA SUPERFICIE DEL CUERPO",
    "detalle": [
      {
        "codigo": "T310",
        "valor": "QUEMADURAS QUE AFECTAN MENOS DEL 10% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T311",
        "valor": "QUEMADURAS QUE AFECTAN DEL 10 AL 19% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T312",
        "valor": "QUEMADURAS QUE AFECTAN DEL 20 AL 29% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T313",
        "valor": "QUEMADURAS QUE AFECTAN DEL 30 AL 39% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T314",
        "valor": "QUEMADURAS QUE AFECTAN DEL 40 AL 49% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T315",
        "valor": "QUEMADURAS QUE AFECTAN DEL 50 AL 59% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T316",
        "valor": "QUEMADURAS QUE AFECTAN DEL 60 AL 69% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T317",
        "valor": "QUEMADURAS QUE AFECTAN DEL 70 AL 79% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T318",
        "valor": "QUEMADURAS QUE AFECTAN DEL 80 AL 89% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T319",
        "valor": "QUEMADURAS QUE AFECTAN EL 90% O MAS DE LA SUPERFICIE DEL CUERPO"
      }
    ]
  },
  {
    "grupo": "T32 - CORROSIONES CLASIFICADAS SEGUN LA EXTENSION DE LA SUPERFICIE DEL CUERPO",
    "detalle": [
      {
        "codigo": "T320",
        "valor": "CORROSIONES QUE AFECTAN MENOS DEL 10% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T321",
        "valor": "CORROSIONES QUE AFECTAN DEL 10 AL 19% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T322",
        "valor": "CORROSIONES QUE AFECTAN DEL 20 AL 29% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T323",
        "valor": "CORROSIONES QUE AFECTAN DEL 30 AL 39% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T324",
        "valor": "CORROSIONES QUE AFECTAN DEL 40 AL 49% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T325",
        "valor": "CORROSIONES QUE AFECTAN DEL 50 AL 59% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T326",
        "valor": "CORROSIONES QUE AFECTAN DEL 60 AL 69% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T327",
        "valor": "CORROSIONES QUE AFECTAN DEL 70 AL 79% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T328",
        "valor": "CORROSIONES QUE AFECTAN DEL 80 AL 89% DE LA SUPERFICIE DEL CUERPO"
      },
      {
        "codigo": "T329",
        "valor": "CORROSIONES QUE AFECTAN EL 90% O MAS DE LA SUPERFICIE DEL CUERPO"
      }
    ]
  },
  {
    "grupo": "T33 - CONGELAMIENTO SUPERFICIAL",
    "detalle": [
      {
        "codigo": "T330",
        "valor": "CONGELAMIENTO SUPERFICIAL DE LA CABEZA"
      },
      {
        "codigo": "T331",
        "valor": "CONGELAMIENTO SUPERFICIAL DEL CUELLO"
      },
      {
        "codigo": "T332",
        "valor": "CONGELAMIENTO SUPERFICIAL DEL TORAX"
      },
      {
        "codigo": "T333",
        "valor": "CONGELAMIENTO SUPERFICIAL DE LA PARED ABDOMINAL, REGION LUMBOSACRA Y PELVIS"
      },
      {
        "codigo": "T334",
        "valor": "CONGELAMIENTO SUPERFICIAL DEL BRAZO"
      },
      {
        "codigo": "T335",
        "valor": "CONGELAMIENTO SUPERFICIAL DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "T336",
        "valor": "CONGELAMIENTO SUPERFICIAL DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "T337",
        "valor": "CONGELAMIENTO SUPERFICIAL DE LA RODILLA Y DE LA PIERNA"
      },
      {
        "codigo": "T338",
        "valor": "CONGELAMIENTO SUPERFICIAL DEL TOBILLO Y DEL PIE"
      },
      {
        "codigo": "T339",
        "valor": "CONGELAMIENTO SUPERFICIAL DE OTROS SITIOS Y DE LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T34 - CONGELAMIENTO CON NECROSIS TISULAR",
    "detalle": [
      {
        "codigo": "T340",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR DE LA CABEZA"
      },
      {
        "codigo": "T341",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR DEL CUELLO"
      },
      {
        "codigo": "T342",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR DEL TORAX"
      },
      {
        "codigo": "T343",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR DE LA PARED ABDOMINAL, REGION LUMBOSACRA Y PELVIS"
      },
      {
        "codigo": "T344",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR DEL BRAZO"
      },
      {
        "codigo": "T345",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "T346",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR DE LA CADERA Y DEL MUSLO"
      },
      {
        "codigo": "T347",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR DE LA RODILLA Y DE LA PIERNA"
      },
      {
        "codigo": "T348",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR DEL TOBILLO Y DEL PIE"
      },
      {
        "codigo": "T349",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR DE OTROS SITIOS Y DE LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T35 - CONGELAMIENTO QUE AFECTA MULTIPLES REGIONES DEL CUERPO Y CONGELAMIENTO",
    "detalle": [
      {
        "codigo": "T350",
        "valor": "CONGELAMIENTO SUPERFICIAL QUE AFECTA MULTIPLES REGIONES DEL CUERPO"
      },
      {
        "codigo": "T351",
        "valor": "CONGELAMIENTO CON NECROSIS TISULAR QUE AFECTA MULTIPLES REGIONES DEL CUERPO"
      },
      {
        "codigo": "T352",
        "valor": "CONGELAMIENTO NO ESPECIFICADO DE LA CABEZA Y DEL CUELLO"
      },
      {
        "codigo": "T353",
        "valor": "CONGELAMIENTO NO ESPECIFICADO DEL TORAX, DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS"
      },
      {
        "codigo": "T354",
        "valor": "CONGELAMIENTO NO ESPECIFICADO DEL MIEMBRO SUPERIOR"
      },
      {
        "codigo": "T355",
        "valor": "CONGELAMIENTO NO ESPECIFICADO DEL MIEMBRO INFERIOR"
      },
      {
        "codigo": "T356",
        "valor": "CONGELAMIENTO NO ESPECIFICADO QUE AFECTA MULTIPLES REGIONES DEL CUERPO"
      },
      {
        "codigo": "T357",
        "valor": "CONGELAMIENTO NO ESPECIFICADO, DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T36 - ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS",
    "detalle": [
      {
        "codigo": "T360",
        "valor": "ENVENENAMIENTO POR PENICILINAS"
      },
      {
        "codigo": "T361",
        "valor": "ENVENENAMIENTO POR CEFALOSPORINAS Y OTROS ANTIBIOTICOS BETA-LACTAMICOS"
      },
      {
        "codigo": "T362",
        "valor": "ENVENENAMIENTO POR ANTIBIOTICOS DEL GRUPO DEL CLORAMFENICOL"
      },
      {
        "codigo": "T363",
        "valor": "ENVENENAMIENTO POR MACROLIDOS"
      },
      {
        "codigo": "T364",
        "valor": "ENVENENAMIENTO POR TETRACICLINAS"
      },
      {
        "codigo": "T365",
        "valor": "ENVENENAMIENTO POR AMINOGLUCOSIDOS"
      },
      {
        "codigo": "T366",
        "valor": "ENVENENAMIENTO POR RIFAMICINAS"
      },
      {
        "codigo": "T367",
        "valor": "ENVENENAMIENTO POR ANTIBIOTICOS ANTIMICOTICOS USADOS SISTEMICAMENTE"
      },
      {
        "codigo": "T368",
        "valor": "ENVENENAMIENTO POR OTROS ANTIBIOTICOS SISTEMICOS"
      },
      {
        "codigo": "T369",
        "valor": "ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T37 - ENVENENAMIENTO POR OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS",
    "detalle": [
      {
        "codigo": "T370",
        "valor": "ENVENENAMIENTO POR SULFONAMIDAS"
      },
      {
        "codigo": "T371",
        "valor": "ENVENENAMIENTO POR DROGAS ANTIMICOBACTERIANAS"
      },
      {
        "codigo": "T372",
        "valor": "ENVENENAMIENTO POR ANTIPALUDICOS Y DROGAS DE ACCION CONTRA OTROS PROTOZOARIOS SANGUINEOS"
      },
      {
        "codigo": "T373",
        "valor": "ENVENENAMIENTO POR OTRAS DROGAS ANTIPROTOZOARIAS"
      },
      {
        "codigo": "T374",
        "valor": "ENVENENAMIENTO POR ANTIHELMINTICOS"
      },
      {
        "codigo": "T375",
        "valor": "ENVENENAMIENTO POR DROGAS ANTIVIRALES"
      },
      {
        "codigo": "T378",
        "valor": "ENVENENAMIENTO POR OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS ESPECIFICADOS"
      },
      {
        "codigo": "T379",
        "valor": "ENVENENAMIENTO POR ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T38 - ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS",
    "detalle": [
      {
        "codigo": "T380",
        "valor": "ENVENENAMIENTO POR GLUCOCORTICOIDES Y ANALOGOS SINTETICOS"
      },
      {
        "codigo": "T381",
        "valor": "ENVENENAMIENTO POR HORMONAS TIROIDEAS Y SUSTITUTOS"
      },
      {
        "codigo": "T382",
        "valor": "ENVENENAMIENTO POR DROGAS ANTITIROIDEAS"
      },
      {
        "codigo": "T383",
        "valor": "ENVENENAMIENTO POR INSULINA Y DROGAS HIPOGLUCEMIANTES ORALES [ANTIDIABETICAS]"
      },
      {
        "codigo": "T384",
        "valor": "ENVENENAMIENTO POR ANTICONCEPTIVOS ORALES"
      },
      {
        "codigo": "T385",
        "valor": "ENVENENAMIENTO POR OTROS ESTROGENOS Y PROGESTOGENOS"
      },
      {
        "codigo": "T386",
        "valor": "ENVENENAMIENTO POR ANTIGONADOTROFINAS, ANTIESTROGENOS Y ANTIANDROGENOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T387",
        "valor": "ENVENENAMIENTO POR ANDROGENOS Y SUS CONGENERES ANABOLICOS"
      },
      {
        "codigo": "T388",
        "valor": "ENVENENAMIENTO POR OTRAS HORMONAS Y SUSTITUTOS SINTETICOS Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "T389",
        "valor": "ENVENENAMIENTO POR OTROS ANTAGONISTAS DE LAS HORMONAS Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T39 - ENVENENAMIENTO POR ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS",
    "detalle": [
      {
        "codigo": "T390",
        "valor": "ENVENENAMIENTO POR SALICILATOS"
      },
      {
        "codigo": "T391",
        "valor": "ENVENENAMIENTO POR DERIVADOS DEL PARAAMINOFENOL"
      },
      {
        "codigo": "T392",
        "valor": "ENVENENAMIENTO POR DERIVADOS DE LA PIRAZOLONA"
      },
      {
        "codigo": "T393",
        "valor": "ENVENENAMIENTO POR OTRAS DROGAS ANTIIFLAMATORIAS NO ESTEROIDEAS [DAINE]"
      },
      {
        "codigo": "T394",
        "valor": "ENVENENAMIENTO POR ANTIRREUMATICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T398",
        "valor": "ENVENENAMIENTO POR OTROS ANALGESICOS NO NARCOTICOS Y ANTIPIRETICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T399",
        "valor": "ENVENENAMIENTO POR ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T40 - ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]",
    "detalle": [
      {
        "codigo": "T400",
        "valor": "ENVENENAMIENTO POR OPIO"
      },
      {
        "codigo": "T401",
        "valor": "ENVENENAMIENTO POR HEROINA"
      },
      {
        "codigo": "T402",
        "valor": "ENVENENAMIENTO POR OTROS OPIACEOS"
      },
      {
        "codigo": "T403",
        "valor": "ENVENENAMIENTO POR METADONA"
      },
      {
        "codigo": "T404",
        "valor": "ENVENENAMIENTO POR OTROS NARCOTICOS SINTETICOS"
      },
      {
        "codigo": "T405",
        "valor": "ENVENENAMIENTO POR COCAINA"
      },
      {
        "codigo": "T406",
        "valor": "ENVENENAMIENTO POR OTROS NARCOTICOS Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "T407",
        "valor": "ENVENENAMIENTO POR CANNABIS (DERIVADOS)"
      },
      {
        "codigo": "T408",
        "valor": "ENVENENAMIENTO POR ACIDO LISERGICO [LSD]"
      },
      {
        "codigo": "T409",
        "valor": "ENVENENAMIENTO POR OTROS PSICODISLEPTICOS Y LOS NO ESPECIFICADOS [ALUCINOGENOS]"
      }
    ]
  },
  {
    "grupo": "T41 - ENVENENAMIENTO POR ANESTESICOS Y GASES TERAPEUTICOS",
    "detalle": [
      {
        "codigo": "T410",
        "valor": "ENVENENAMIENTO POR ANESTESICOS POR INHALACION"
      },
      {
        "codigo": "T411",
        "valor": "ENVENENAMIENTO POR ANESTESICOS INTRAVENOSOS"
      },
      {
        "codigo": "T412",
        "valor": "ENVENENAMIENTO POR OTROS ANESTESICOS GENERALES Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "T413",
        "valor": "ENVENENAMIENTO POR ANESTESICOS LOCALES"
      },
      {
        "codigo": "T414",
        "valor": "ENVENENAMIENTO POR ANESTESICOS, NO ESPECIFICADOS"
      },
      {
        "codigo": "T415",
        "valor": "ENVENENAMIENTO POR GASES TERAPEUTICOS"
      }
    ]
  },
  {
    "grupo": "T42 - ENVENENAMIENTO POR ANTIEPILEPTICOS, HIPNOTICOS-SEDANTES Y DROGAS ANTIPARKINSONONIANAS",
    "detalle": [
      {
        "codigo": "T420",
        "valor": "ENVENENAMIENTO POR DERIVADOS DE LA HIDANTOINA"
      },
      {
        "codigo": "T421",
        "valor": "ENVENENAMIENTO POR IMINOSTILBENOS"
      },
      {
        "codigo": "T422",
        "valor": "ENVENENAMIENTO POR SUCCINAMIDAS Y DERIVADOS DE LA OXAZOLIDINA"
      },
      {
        "codigo": "T423",
        "valor": "ENVENENAMIENTO POR BARBITURICOS"
      },
      {
        "codigo": "T424",
        "valor": "ENVENENAMIENTO POR BENZODIAZEPINAS"
      },
      {
        "codigo": "T425",
        "valor": "ENVENENAMIENTO POR ANTIEPILEPTICOS MIXTOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T426",
        "valor": "ENVENENAMIENTO POR OTROS ANTIEPILEPTICOS Y DROGAS HIPNOTICO-SEDANTES"
      },
      {
        "codigo": "T427",
        "valor": "ENVENENAMIENTO POR ANTIEPILEPTICOS Y DROGAS HIPNOTICO-SEDANTES, NO ESPECIFICADOS"
      },
      {
        "codigo": "T428",
        "valor": "ENVENENAMIENTO POR DROGAS ANTIPARKINSONIANAS Y OTROS DEPRESORES DEL TONO MUSCULAR CENTRAL"
      }
    ]
  },
  {
    "grupo": "T43 - ENVENENAMIENTO POR PSICOTROPICOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "T430",
        "valor": "ENVENENAMIENTO POR ANTIDEPRESIVOS TRICICLICOS Y TETRACICLICOS"
      },
      {
        "codigo": "T431",
        "valor": "ENVENENAMIENTO POR ANTIDEPRESIVOS INHIBIDORES DE LA MONOAMINOXIDASA"
      },
      {
        "codigo": "T432",
        "valor": "ENVENENAMIENTO POR OTROS ANTIDEPRESIVOS Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "T433",
        "valor": "ENVENENAMIENTO POR ANTIPSICOTICOS Y NEUROLEPTICOS FENOTIACINICOS"
      },
      {
        "codigo": "T434",
        "valor": "ENVENENAMIENTO POR BUTIROFENONA Y NEUROLEPTICOS TIOXANTENICOS"
      },
      {
        "codigo": "T435",
        "valor": "ENVENENAMIENTO POR OTROS ANTIPSICOTICOS Y NEUROLEPTICOS Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "T436",
        "valor": "ENVENENAMIENTO POR PSICOESTIMULANTES CON ABUSO POTENCIAL"
      },
      {
        "codigo": "T438",
        "valor": "ENVENENAMIENTO POR OTRAS DROGAS PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T439",
        "valor": "ENVENENAMIENTO POR DROGA PSICOTROPICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T44 - ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO",
    "detalle": [
      {
        "codigo": "T440",
        "valor": "ENVENENAMIENTO POR AGENTES ANTICOLINESTERASA"
      },
      {
        "codigo": "T441",
        "valor": "ENVENENAMIENTO POR OTROS PARASIMPATICOMIMETICOS [COLINERGICOS]"
      },
      {
        "codigo": "T442",
        "valor": "ENVENENAMIENTO POR DROGAS BLOQUEADORAS GANGLIONARES, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T443",
        "valor": "ENVENENAMIENTO POR OTROS PARASIMPATICOLITICOS [ANTICOLINERGICOS Y ANTIMUSCARINICOS] Y ESPASMOLITICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T444",
        "valor": "ENVENENAMIENTO POR AGONISTAS, PREDOMINANTEMENTE ALFA-ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T445",
        "valor": "ENVENENAMIENTO POR AGONISTAS, PREDOMINANTEMENTE BETA-ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T446",
        "valor": "ENVENENAMIENTO POR ANTAGONISTAS ALFA-ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T447",
        "valor": "ENVENENAMIENTO POR ANTAGONISTAS BETA-ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T448",
        "valor": "ENVENENAMIENTO POR AGENTES DE ACCION CENTRAL Y BLOQUEADORES NEURONALES ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T449",
        "valor": "ENVENENAMIENTO POR OTRAS DROGAS Y LAS NO ESPECIFICADAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO"
      }
    ]
  },
  {
    "grupo": "T45 - ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "T450",
        "valor": "ENVENENAMIENTO POR DROGAS ANTIALERGICAS Y ANTIEMETICAS"
      },
      {
        "codigo": "T451",
        "valor": "ENVENENAMIENTO POR DROGAS ANTINEOPLASICAS E INMUNOSUPRESORAS"
      },
      {
        "codigo": "T452",
        "valor": "ENVENENAMIENTO POR VITAMINAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T453",
        "valor": "ENVENENAMIENTO POR ENZIMAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T454",
        "valor": "ENVENENAMIENTO POR HIERRO Y SUS COMPUESTOS"
      },
      {
        "codigo": "T455",
        "valor": "ENVENENAMIENTO POR ANTICOAGULANTES"
      },
      {
        "codigo": "T456",
        "valor": "ENVENENAMIENTO POR DROGAS QUE AFECTAN LA FIBRINOLISIS"
      },
      {
        "codigo": "T457",
        "valor": "ENVENENAMIENTO POR ANTAGONISTAS DE ANTICOAGULANTES, VITAMINA K Y OTROS COAGULANTES"
      },
      {
        "codigo": "T458",
        "valor": "ENVENENAMIENTO POR OTROS AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS"
      },
      {
        "codigo": "T459",
        "valor": "ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T46 - ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR",
    "detalle": [
      {
        "codigo": "T460",
        "valor": "ENVENENAMIENTO POR GLUCOSIDOS CARDIOTONICOS Y MEDICAMENTOS DE ACCION SIMILAR"
      },
      {
        "codigo": "T461",
        "valor": "ENVENENAMIENTO POR BLOQUEADORES DEL CANAL DEL CALCIO"
      },
      {
        "codigo": "T462",
        "valor": "ENVENENAMIENTO POR OTRAS DROGAS ANTIARRITMICAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T463",
        "valor": "ENVENENAMIENTO POR VASODILATADORES CORONARIOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T464",
        "valor": "ENVENENAMIENTO POR INHIBIDORES DE LA ENZIMA CONVERTIDORA DE LA ANGIOTENSINA"
      },
      {
        "codigo": "T465",
        "valor": "ENVENENAMIENTO POR OTRAS DROGAS ANTIHIPERTENSIVAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T466",
        "valor": "ENVENENAMIENTO POR DROGAS ANTILIPEMICAS Y ANTIARTERIOSCLEROTICAS"
      },
      {
        "codigo": "T467",
        "valor": "ENVENENAMIENTO POR VASODILATADORES PERIFERICOS"
      },
      {
        "codigo": "T468",
        "valor": "ENVENENAMIENTO POR DROGAS ANTIVARICOSAS, INCLUSIVE AGENTES ESCLEROSANTES"
      },
      {
        "codigo": "T469",
        "valor": "ENVENENAMIENTO POR OTROS AGENTES Y LOS NO ESPECIFICADOS QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR"
      }
    ]
  },
  {
    "grupo": "T47 - ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL",
    "detalle": [
      {
        "codigo": "T470",
        "valor": "ENVENENAMIENTO POR ANTAGONISTAS DEL RECEPTOR H2 DE HISTAMINA"
      },
      {
        "codigo": "T471",
        "valor": "ENVENENAMIENTO POR OTRAS DROGAS ANTIACIDAS Y QUE INHIBEN LA SECRECION GASTRICA"
      },
      {
        "codigo": "T472",
        "valor": "ENVENENAMIENTO POR LAXANTES ESTIMULANTES"
      },
      {
        "codigo": "T473",
        "valor": "ENVENENAMIENTO POR LAXANTES SALINOS Y OSMOTICOS"
      },
      {
        "codigo": "T474",
        "valor": "ENVENENAMIENTO POR OTROS LAXANTES"
      },
      {
        "codigo": "T475",
        "valor": "ENVENENAMIENTO POR DIGESTIVOS"
      },
      {
        "codigo": "T476",
        "valor": "ENVENENAMIENTO POR DROGAS ANTIDIARREICAS"
      },
      {
        "codigo": "T477",
        "valor": "ENVENENAMIENTO POR EMETICOS"
      },
      {
        "codigo": "T478",
        "valor": "ENVENENAMIENTO POR OTROS AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL"
      },
      {
        "codigo": "T479",
        "valor": "ENVENENAMIENTO POR AGENTES NO ESPECIFICADOS QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL"
      }
    ]
  },
  {
    "grupo": "T48 - ENVENENAMIENTO POR AGENTES CON ACCION PRINCIPAL SOBRE LOS MUSCULOS LISOS Y ESQUELITICOS Y SOBRE EL SISTEMA RESPIRATORIO",
    "detalle": [
      {
        "codigo": "T480",
        "valor": "ENVENENAMIENTO POR DROGAS OXITOCICAS"
      },
      {
        "codigo": "T481",
        "valor": "ENVENENAMIENTO POR RELAJANTES MUSCULOESQUELETICOS [AGENTES BLOQUEADORES NEUROMUSCULARES]"
      },
      {
        "codigo": "T482",
        "valor": "ENVENENAMIENTO POR OTROS MEDICAMENTOS Y LOS NO ESPECIFICADOS DE ACCION PRINCIPAL SOBRE LOS MUSCULOS"
      },
      {
        "codigo": "T483",
        "valor": "ENVENENAMIENTO POR ANTITUSIGENOS"
      },
      {
        "codigo": "T484",
        "valor": "ENVENENAMIENTO POR EXPECTORANTES"
      },
      {
        "codigo": "T485",
        "valor": "ENVENENAMIENTO POR DROGAS CONTRA EL CATARRO COMUN"
      },
      {
        "codigo": "T486",
        "valor": "ENVENENAMIENTO POR ANTIASMATICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T487",
        "valor": "ENVENENAMIENTO POR OTROS AGENTES Y LOS NO ESPECIFICADOS DE ACCION PRINCIPAL SOBRE EL SISTEMA RESPIRATORIO"
      }
    ]
  },
  {
    "grupo": "T49 - ENVENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LA MEMBRANAS MUCOSAS Y POR DROGAS OFTALMOLOGICAS, OTORRINOLARINGOLOGICAS Y DENTALES",
    "detalle": [
      {
        "codigo": "T490",
        "valor": "ENVENENAMIENTO POR DROGAS LOCALES ANTIMICOTICAS, ANTIINFECCIOSAS Y ANTIINFLAMATORIAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T491",
        "valor": "ENVENENAMIENTO POR ANTIPRURITICOS"
      },
      {
        "codigo": "T492",
        "valor": "ENVENENAMIENTO POR ASTRINGENTES Y DETERGENTES LOCALES"
      },
      {
        "codigo": "T493",
        "valor": "ENVENENAMIENTO POR EMOLIENTES, DEMULCENTES Y PROTECTORES"
      },
      {
        "codigo": "T494",
        "valor": "ENVENENAMIENTO POR QUERATOLITICOS, QUERATOPLASTICOS, DROGAS Y OTRAS PREPARACIONES PARA EL TRATAMIENTO DEL CABELLO"
      },
      {
        "codigo": "T495",
        "valor": "ENVENENAMIENTO POR DROGAS Y PREPARACIONES OFTALMOLOGICAS"
      },
      {
        "codigo": "T496",
        "valor": "ENVENENAMIENTO POR DROGAS Y PREPARACIONES OTORRINOLARINGOLOGICAS"
      },
      {
        "codigo": "T497",
        "valor": "ENVENENAMIENTO POR DROGAS DENTALES, APLICADAS TOPICAMENTE"
      },
      {
        "codigo": "T498",
        "valor": "ENVENENAMIENTO POR OTROS AGENTES TOPICOS"
      },
      {
        "codigo": "T499",
        "valor": "ENVENENAMIENTO POR AGENTES TOPICOS, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T50 - ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "T500",
        "valor": "ENVENENAMIENTO POR MINERALOCORTICOIDES Y SUS ANTAGONISTAS"
      },
      {
        "codigo": "T501",
        "valor": "ENVENENAMIENTO POR DIURETICOS DEL ASA [DINTEL ALTO]"
      },
      {
        "codigo": "T502",
        "valor": "ENVENENAMIENTO POR INHIBIDORES DE LA ANHIDRASA DEL ACIDO CARBONICO, BENZOTIAZIDAS Y OTROS DIURETICOS"
      },
      {
        "codigo": "T503",
        "valor": "ENVENENAMIENTO POR AGENTES DEL EQUILIBRIO HIDROLITICO, ELECTROLITICO Y CALORICO"
      },
      {
        "codigo": "T504",
        "valor": "ENVENENAMIENTO POR DROGAS QUE AFECTAN EL METABOLISMO DEL ACIDO URICO"
      },
      {
        "codigo": "T505",
        "valor": "ENVENENAMIENTO POR DEPRESORES DEL APETITO"
      },
      {
        "codigo": "T506",
        "valor": "ENVENENAMIENTO POR ANTIDOTOS Y AGENTES QUELANTES, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T507",
        "valor": "ENVENENAMIENTO POR ANALEPTICOS Y ANTAGONISTAS DEL OPIO"
      },
      {
        "codigo": "T508",
        "valor": "ENVENENAMIENTO POR AGENTES DIAGNOSTICOS"
      },
      {
        "codigo": "T509",
        "valor": "ENVENENAMIENTO POR OTRAS DROGAS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "T51 - EFECTO TOXICO DEL ALCOHOL",
    "detalle": [
      {
        "codigo": "T510",
        "valor": "EFECTO TOXICO DEL ETANOL"
      },
      {
        "codigo": "T511",
        "valor": "EFECTO TOXICO DEL METANOL"
      },
      {
        "codigo": "T512",
        "valor": "EFECTO TOXICO DEL PROPANOL-2"
      },
      {
        "codigo": "T513",
        "valor": "EFECTO TOXICO DEL LICOR DE ALCOHOL INSUFICIENTEMENTE DESTILADO"
      },
      {
        "codigo": "T518",
        "valor": "EFECTO TOXICO DE OTROS ALCOHOLES"
      },
      {
        "codigo": "T519",
        "valor": "EFECTO TOXICO DEL ALCOHOL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T52 - EFECTO TOXICO DE DISOLVENTES ORGANICOS",
    "detalle": [
      {
        "codigo": "T520",
        "valor": "EFECTO TOXICO DE PRODUCTOS DEL PETROLEO"
      },
      {
        "codigo": "T521",
        "valor": "EFECTO TOXICO DEL BENCENO"
      },
      {
        "codigo": "T522",
        "valor": "EFECTO TOXICO DE HOMOLOGOS DEL BENCENO"
      },
      {
        "codigo": "T523",
        "valor": "EFECTO TOXICO DE GLICOLES"
      },
      {
        "codigo": "T524",
        "valor": "EFECTO TOXICO DE CETONAS"
      },
      {
        "codigo": "T528",
        "valor": "EFECTO TOXICO DE OTROS DISOLVENTES ORGANICOS"
      },
      {
        "codigo": "T529",
        "valor": "EFECTO TOXICO DE DISOLVENTES ORGANICOS, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T53 - EFECTO TOXICO DE LOS DERIVADOS HALOGENADOS DE LOS HIDROCARBUROS ALIFATICOS Y AROMATICOS",
    "detalle": [
      {
        "codigo": "T530",
        "valor": "EFECTO TOXICO DEL TETRACLORURO DE CARBONO"
      },
      {
        "codigo": "T531",
        "valor": "EFECTO TOXICO DEL CLOROFORMO"
      },
      {
        "codigo": "T532",
        "valor": "EFECTO TOXICO DEL TRICLOROETILENO"
      },
      {
        "codigo": "T533",
        "valor": "EFECTO TOXICO DEL TETRACLOROETILENO"
      },
      {
        "codigo": "T534",
        "valor": "EFECTO TOXICO DEL DICLOROETANO"
      },
      {
        "codigo": "T535",
        "valor": "EFECTO TOXICO DE CLOROFLUOROCARBUROS"
      },
      {
        "codigo": "T536",
        "valor": "EFECTO TOXICO DE OTROS DERIVADOS HALOGENADOS DE HIDROCARBUROS ALIFATICOS"
      },
      {
        "codigo": "T537",
        "valor": "EFECTO TOXICO DE OTROS DERIVADOS HALOGENADOS DE HIDROCARBUROS AROMATICOS"
      },
      {
        "codigo": "T539",
        "valor": "EFECTO TOXICO DE DERIVADOS HALOGENADOS DE HIDROCARBUROS ALIFATICOS Y AROMATICOS, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T54 - EFECTO TOXICO DE SUSTANCIAS CORROSIVAS",
    "detalle": [
      {
        "codigo": "T540",
        "valor": "EFECTO TOXICO DE FENOL Y HOMOLOGOS DEL FENOL"
      },
      {
        "codigo": "T541",
        "valor": "EFECTO TOXICO DE OTROS COMPUESTOS ORGANICOS CORROSIVOS"
      },
      {
        "codigo": "T542",
        "valor": "EFECTO TOXICO DE ACIDOS CORROSIVOS Y SUSTANCIAS ACIDAS SIMILARES"
      },
      {
        "codigo": "T543",
        "valor": "EFECTO TOXICO DE ALCALIS CAUSTICOS Y SUSTANCIAS ALCALINAS SIMILARES"
      },
      {
        "codigo": "T549",
        "valor": "EFECTO TOXICO DE SUSTANCIA CORROSIVA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T55 - EFECTO TOXICO DE DETERGENTES Y JABONES",
    "detalle": [
      {
        "codigo": "T55X",
        "valor": "EFECTO TOXICO DE DETERGENTES Y JABONES"
      }
    ]
  },
  {
    "grupo": "T56 - EFECTO TOXICO DE METALES",
    "detalle": [
      {
        "codigo": "T560",
        "valor": "EFECTO TOXICO DEL PLOMO Y SUS COMPUESTOS"
      },
      {
        "codigo": "T561",
        "valor": "EFECTO TOXICO DEL MERCURIO Y SUS COMPUESTOS"
      },
      {
        "codigo": "T562",
        "valor": "EFECTO TOXICO DEL CROMO Y SUS COMPUESTOS"
      },
      {
        "codigo": "T563",
        "valor": "EFECTO TOXICO DEL CADMIO Y SUS COMPUESTOS"
      },
      {
        "codigo": "T564",
        "valor": "EFECTO TOXICO DEL COBRE Y SUS COMPUESTOS"
      },
      {
        "codigo": "T565",
        "valor": "EFECTO TOXICO DEL ZINC Y SUS COMPUESTOS"
      },
      {
        "codigo": "T566",
        "valor": "EFECTO TOXICO DEL ESTAÑO Y SUS COMPUESTOS"
      },
      {
        "codigo": "T567",
        "valor": "EFECTO TOXICO DEL BERILIO Y SUS COMPUESTOS"
      },
      {
        "codigo": "T568",
        "valor": "EFECTO TOXICO DE OTROS METALES"
      },
      {
        "codigo": "T569",
        "valor": "EFECTO TOXICO DE METAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T57 - EFECTO TOXICO DE OTRAS SUSTANCIAS INORGANICAS",
    "detalle": [
      {
        "codigo": "T570",
        "valor": "EFECTO TOXICO DEL ARSENICO Y SUS COMPUESTOS"
      },
      {
        "codigo": "T571",
        "valor": "EFECTO TOXICO DEL FOSFORO Y SUS COMPUESTOS"
      },
      {
        "codigo": "T572",
        "valor": "EFECTO TOXICO DEL MANGANESO Y SUS COMPUESTOS"
      },
      {
        "codigo": "T573",
        "valor": "EFECTO TOXICO DEL ACIDO CIANHIDRICO"
      },
      {
        "codigo": "T578",
        "valor": "EFECTO TOXICO DE OTRAS SUSTANCIAS INORGANICAS, ESPECIFICADAS"
      },
      {
        "codigo": "T579",
        "valor": "EFECTO TOXICO DE SUSTANCIA INORGANICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T58 - EFECTO TOXICO DEL MONOXIDO DE CARBONO",
    "detalle": [
      {
        "codigo": "T58X",
        "valor": "EFECTO TOXICO DEL MONOXIDO DE CARBONO"
      }
    ]
  },
  {
    "grupo": "T59 - EFECTO TOXICO DE OTROS GASES, HUMOS Y VAPORES",
    "detalle": [
      {
        "codigo": "T590",
        "valor": "EFECTO TOXICO DE OXIDOS DE NITROGENO"
      },
      {
        "codigo": "T591",
        "valor": "EFECTO TOXICO DEL DIOXIDO DE SULFURO"
      },
      {
        "codigo": "T592",
        "valor": "EFECTO TOXICO DEL FORMALDEHIDO"
      },
      {
        "codigo": "T593",
        "valor": "EFECTO TOXICO DEL GAS LACRIMOGENO"
      },
      {
        "codigo": "T594",
        "valor": "EFECTO TOXICO DEL CLORO GASEOSO"
      },
      {
        "codigo": "T595",
        "valor": "EFECTO TOXICO DEL GAS DE FLUOR Y FLUORURO DE HIDROGENO"
      },
      {
        "codigo": "T596",
        "valor": "EFECTO TOXICO DEL SULFURO DE HIDROGENO"
      },
      {
        "codigo": "T597",
        "valor": "EFECTO TOXICO DEL DIOXIDO DE CARBONO"
      },
      {
        "codigo": "T598",
        "valor": "EFECTO TOXICO DE OTROS GASES, HUMOS Y VAPORES ESPECIFICADOS"
      },
      {
        "codigo": "T599",
        "valor": "EFECTO TOXICO DE GASES, HUMOS Y VAPORES NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T60 - EFECTO TOXICO DE PLAGUICIDAS [PESTICIDAS]",
    "detalle": [
      {
        "codigo": "T600",
        "valor": "EFECTO TOXICO DE INSECTICIDAS ORGANOFOSFORADOS Y CARBAMATOS"
      },
      {
        "codigo": "T601",
        "valor": "EFECTO TOXICO DE INSECTICIDAS HALOGENADOS"
      },
      {
        "codigo": "T602",
        "valor": "EFECTO TOXICO DE OTROS INSECTICIDAS"
      },
      {
        "codigo": "T603",
        "valor": "EFECTO TOXICO DE HERBICIDAS Y FUNGICIDAS"
      },
      {
        "codigo": "T604",
        "valor": "EFECTO TOXICO DE RODENTICIDAS"
      },
      {
        "codigo": "T608",
        "valor": "EFECTO TOXICO DE OTROS PLAGUICIDAS"
      },
      {
        "codigo": "T609",
        "valor": "EFECTO TOXICO DE PLAGUICIDA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T61 - EFECTO TOXICO DE SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTOS MARINOS",
    "detalle": [
      {
        "codigo": "T610",
        "valor": "ENVENENAMIENTO CIGUATERO POR PESCADO"
      },
      {
        "codigo": "T611",
        "valor": "ENVENENAMIENTO ESCOMBROIDEO POR PESCADO"
      },
      {
        "codigo": "T612",
        "valor": "OTROS ENVENENAMIENTOS POR PESCADOS Y MARISCOS"
      },
      {
        "codigo": "T618",
        "valor": "EFECTO TOXICO DE OTROS ALIMENTOS MARINOS"
      },
      {
        "codigo": "T619",
        "valor": "EFECTO TOXICO DE ALIMENTOS MARINOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T62 - EFECTO TOXICO DE OTRAS SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTO",
    "detalle": [
      {
        "codigo": "T620",
        "valor": "EFECTO TOXICO DE HONGOS INGERIDOS"
      },
      {
        "codigo": "T621",
        "valor": "EFECTO TOXICO DE BAYAS INGERIDAS"
      },
      {
        "codigo": "T622",
        "valor": "EFECTO TOXICO DE OTRA(S) (PARTES DE) PLANTA(S) INGERIDA(S)"
      },
      {
        "codigo": "T628",
        "valor": "EFECTO TOXICO DE OTRAS SUSTANCIAS NOCIVAS ESPECIFICADAS INGERIDAS COMO ALIMENTO"
      },
      {
        "codigo": "T629",
        "valor": "EFECTO TOXICO DE SUSTANCIA NOCIVA INGERIDA COMO ALIMENTO, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T63 - EFECTO TOXICO DEL CONTACTO CON ANIMALES VENENOSOS",
    "detalle": [
      {
        "codigo": "T630",
        "valor": "EFECTO TOXICO DEL VENENO DE SERPIENTE"
      },
      {
        "codigo": "T631",
        "valor": "EFECTO TOXICO DEL VENENO DE OTROS REPTILES"
      },
      {
        "codigo": "T632",
        "valor": "EFECTO TOXICO DEL VENENO DE ESCORPION"
      },
      {
        "codigo": "T633",
        "valor": "EFECTO TOXICO DEL VENENO DE ARAÑAS"
      },
      {
        "codigo": "T634",
        "valor": "EFECTO TOXICO DEL VENENO DE OTROS ARTROPODOS"
      },
      {
        "codigo": "T635",
        "valor": "EFECTO TOXICO DEL CONTACTO CON PECES"
      },
      {
        "codigo": "T636",
        "valor": "EFECTO TOXICO DEL CONTACTO CON OTROS ANIMALES MARINOS"
      },
      {
        "codigo": "T638",
        "valor": "EFECTOS TOXICOS DEL CONTACTO CON OTROS ANIMALES VENENOSOS"
      },
      {
        "codigo": "T639",
        "valor": "EFECTO TOXICO DEL CONTACTO CON ANIMAL VENENOSO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T64 - EFECTO TOXICO DE AFLATOXINA Y OTRAS MICOTOXINAS CONTAMINANTES DE ALIMENTOS",
    "detalle": [
      {
        "codigo": "T64X",
        "valor": "EFECTO TOXICO DE AFLATOXINA Y OTRAS MICOTOXINAS CONTAMINANTES DE ALIMENTOS"
      }
    ]
  },
  {
    "grupo": "T65 - EFECTO TOXICO DE OTRAS SUSTANCIAS Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "T650",
        "valor": "EFECTO TOXICO DEL CIANURO"
      },
      {
        "codigo": "T651",
        "valor": "EFECTO TOXICO DE LA ESTRICNINA Y SUS SALES"
      },
      {
        "codigo": "T652",
        "valor": "EFECTO TOXICO DEL TABACO Y LA NICOTINA"
      },
      {
        "codigo": "T653",
        "valor": "EFECTO TOXICO DE NITRODERIVADOS Y AMINODERIVADOS DEL BENCENO Y SUS HOMOLOGOS"
      },
      {
        "codigo": "T654",
        "valor": "EFECTO TOXICO DEL BISULFURO DE CARBONO"
      },
      {
        "codigo": "T655",
        "valor": "EFECTO TOXICO DE NITROGLICERINA Y OTROS ACIDOS Y ESTERES NITRICOS"
      },
      {
        "codigo": "T656",
        "valor": "EFECTO TOXICO DE PINTURAS Y COLORANTES, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T658",
        "valor": "EFECTO TOXICO DE OTRAS SUSTANCIAS ESPECIFICADAS"
      },
      {
        "codigo": "T659",
        "valor": "EFECTO TOXICO DE SUSTANCIA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T66 - EFECTOS NO ESPECIFICADOS DE LA RADIACION",
    "detalle": [
      {
        "codigo": "T66X",
        "valor": "EFECTOS NO ESPECIFICADOS DE LA RADIACION"
      }
    ]
  },
  {
    "grupo": "T67 - EFECTOS DEL CALOR Y DE LA LUZ",
    "detalle": [
      {
        "codigo": "T670",
        "valor": "GOLPE DE CALOR E INSOLACION"
      },
      {
        "codigo": "T671",
        "valor": "SINCOPE POR CALOR"
      },
      {
        "codigo": "T672",
        "valor": "CALAMBRE POR CALOR"
      },
      {
        "codigo": "T673",
        "valor": "AGOTAMIENTO POR CALOR, ANHIDROTICO"
      },
      {
        "codigo": "T674",
        "valor": "AGOTAMIENTO POR CALOR DEBIDA A DEPLECION DE SAL"
      },
      {
        "codigo": "T675",
        "valor": "AGOTAMIENTO POR CALOR NO ESPECIFICADO"
      },
      {
        "codigo": "T676",
        "valor": "FATIGA POR CALOR, TRANSITORIA"
      },
      {
        "codigo": "T677",
        "valor": "EDEMA POR CALOR"
      },
      {
        "codigo": "T678",
        "valor": "OTROS EFECTOS DEL CALOR Y DE LA LUZ"
      },
      {
        "codigo": "T679",
        "valor": "EFECTO DEL CALOR Y DE LA LUZ, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T68 - HIPOTERMIA",
    "detalle": [
      {
        "codigo": "T68X",
        "valor": "HIPOTERMIA"
      }
    ]
  },
  {
    "grupo": "T69 - OTROS EFECTOS DE LA REDUCCION DE LA TEMPERATURA",
    "detalle": [
      {
        "codigo": "T690",
        "valor": "MANO Y PIE DE INMERSION"
      },
      {
        "codigo": "T691",
        "valor": "SABAÑON(ES)"
      },
      {
        "codigo": "T698",
        "valor": "OTROS EFECTOS ESPECIFICADOS DE LA REDUCCION DE LA TEMPERATURA"
      },
      {
        "codigo": "T699",
        "valor": "EFECTO DE LA REDUCCION DE LA TEMPERATURA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T70 - EFECTOS DE LA PRESION DEL AIRE Y DE LA PRESION DEL AGUA",
    "detalle": [
      {
        "codigo": "T700",
        "valor": "BAROTRAUMA OTITICO"
      },
      {
        "codigo": "T701",
        "valor": "BAROTRAUMA SINUSAL"
      },
      {
        "codigo": "T702",
        "valor": "OTROS EFECTOS Y LOS NO ESPECIFICADOS DE LA GRAN ALTITUD"
      },
      {
        "codigo": "T703",
        "valor": "ENFERMEDAD POR DESCOMPRESION [DE LOS CAJONES SUMERGIDOS]"
      },
      {
        "codigo": "T704",
        "valor": "EFECTOS DE LIQUIDOS CON ALTA PRESION"
      },
      {
        "codigo": "T708",
        "valor": "OTROS EFECTOS DE LA PRESION DEL AIRE Y DEL AGUA"
      },
      {
        "codigo": "T709",
        "valor": "EFECTO DE LA PRESION DEL AIRE Y DEL AGUA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T71 - ASFIXIA",
    "detalle": [
      {
        "codigo": "T71X",
        "valor": "ASFIXIA"
      }
    ]
  },
  {
    "grupo": "T73 - EFECTOS DE OTRAS PRIVACIONES",
    "detalle": [
      {
        "codigo": "T730",
        "valor": "EFECTOS DEL HAMBRE"
      },
      {
        "codigo": "T731",
        "valor": "EFECTOS DE LA SED"
      },
      {
        "codigo": "T732",
        "valor": "AGOTAMIENTO DEBIDO A EXPOSICION A LA INTEMPERIE"
      },
      {
        "codigo": "T733",
        "valor": "AGOTAMIENTO DEBIDO A ESFUERZO EXCESIVO"
      },
      {
        "codigo": "T738",
        "valor": "OTROS EFECTOS DE PRIVACION"
      },
      {
        "codigo": "T739",
        "valor": "EFECTOS DE PRIVACION, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T74 - SINDROMES DEL MALTRATO",
    "detalle": [
      {
        "codigo": "T740",
        "valor": "NEGLIGENCIA O ABANDONO"
      },
      {
        "codigo": "T741",
        "valor": "ABUSO FISICO"
      },
      {
        "codigo": "T7411",
        "valor": "ABUSO FISICO A ESPOSA (O)"
      },
      {
        "codigo": "T7412",
        "valor": "ABUSO FISICO A NIÑO O BEBE"
      },
      {
        "codigo": "T742",
        "valor": "ABUSO SEXUAL"
      },
      {
        "codigo": "T743",
        "valor": "ABUSO PSICOLOGICO"
      },
      {
        "codigo": "T748",
        "valor": "OTROS SINDROMES DEL MALTRATO"
      },
      {
        "codigo": "T7480",
        "valor": "RIESGO DE ABUSO FISICO Y/O EMOCIONAL Y/O SEXUAL"
      },
      {
        "codigo": "T749",
        "valor": "SINDROME DEL MALTRATO, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T75 - EFECTOS DE OTRAS CAUSAS EXTERNAS",
    "detalle": [
      {
        "codigo": "T750",
        "valor": "EFECTOS DEL RAYO"
      },
      {
        "codigo": "T751",
        "valor": "AHOGAMIENTO Y SUMERSION NO MORTAL"
      },
      {
        "codigo": "T752",
        "valor": "EFECTOS DE LA VIBRACION"
      },
      {
        "codigo": "T753",
        "valor": "MAL DEL MOVIMIENTO"
      },
      {
        "codigo": "T754",
        "valor": "EFECTOS DE LA CORRIENTE ELECTRICA"
      },
      {
        "codigo": "T758",
        "valor": "OTROS EFECTOS ESPECIFICADOS DE CAUSAS EXTERNAS"
      }
    ]
  },
  {
    "grupo": "T78 - EFECTOS ADVERSOS, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "T780",
        "valor": "CHOQUE ANAFILACTICO DEBIDO A REACCION ADVERSA A ALIMENTOS"
      },
      {
        "codigo": "T781",
        "valor": "OTRA REACCION ADVERSA A ALIMENTOS, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "T782",
        "valor": "CHOQUE ANAFILACTICO, NO ESPECIFICADO"
      },
      {
        "codigo": "T783",
        "valor": "EDEMA ANGIONEUROTICO"
      },
      {
        "codigo": "T784",
        "valor": "ALERGIA NO ESPECIFICADA"
      },
      {
        "codigo": "T788",
        "valor": "OTROS EFECTOS ADVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T789",
        "valor": "EFECTO ADVERSO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T79 - ALGUNAS COMPLICACIONES PRECOCES DE TRAUMATISMOS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "T790",
        "valor": "EMBOLIA GASEOSA (TRAUMATICA)"
      },
      {
        "codigo": "T791",
        "valor": "EMBOLIA GRASA (TRAUMATICA)"
      },
      {
        "codigo": "T792",
        "valor": "HEMORRAGIA TRAUMATICA SECUNDARIA Y RECURRENTE"
      },
      {
        "codigo": "T793",
        "valor": "INFECCION POSTRAUMATICA DE HERIDA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "T794",
        "valor": "CHOQUE TRAUMATICO"
      },
      {
        "codigo": "T795",
        "valor": "ANURIA TRAUMATICA"
      },
      {
        "codigo": "T796",
        "valor": "ISQUEMIA TRAUMATICA DE MUSCULO"
      },
      {
        "codigo": "T797",
        "valor": "ENFISEMA SUBCUTANEO TRAUMATICO"
      },
      {
        "codigo": "T798",
        "valor": "OTRAS COMPLICACIONES PRECOCES DE LOS TRAUMATISMOS"
      },
      {
        "codigo": "T799",
        "valor": "COMPLICACIONES PRECOCES NO ESPECIFICADAS DE LOS TRAUMATISMOS"
      }
    ]
  },
  {
    "grupo": "T80 - COMPLICACIONES CONSECUTIVAS A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA",
    "detalle": [
      {
        "codigo": "T800",
        "valor": "EMBOLIA GASEOSA CONSECUTIVA A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA"
      },
      {
        "codigo": "T801",
        "valor": "COMPLICACIONES VASCULARES CONSECUTIVAS A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA"
      },
      {
        "codigo": "T802",
        "valor": "INFECCIONES CONSECUTIVAS A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA"
      },
      {
        "codigo": "T803",
        "valor": "REACCION DE INCOMPATIBILIDAD AL GRUPO ABO"
      },
      {
        "codigo": "T804",
        "valor": "REACCION DE INCOMPATIBILIDAD A RH"
      },
      {
        "codigo": "T805",
        "valor": "CHOQUE ANAFILACTICO DEBIDO A SUERO"
      },
      {
        "codigo": "T806",
        "valor": "OTRAS REACCIONES AL SUERO"
      },
      {
        "codigo": "T808",
        "valor": "OTRAS COMPLICACIONES CONSECUTIVAS A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA"
      },
      {
        "codigo": "T809",
        "valor": "COMPLICACIONES NO ESPECIFICADAS CONSECUTIVAS A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA"
      }
    ]
  },
  {
    "grupo": "T81 - COMPLICACIONES DE PROCEDIMIENTOS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "T810",
        "valor": "HEMORRAGIA Y HEMATOMA QUE COMPLICAN UN PROCEDIMIENTO, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "T811",
        "valor": "CHOQUE DURANTE O RESULTANTE DE UN PROCEDIMIENTO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "T812",
        "valor": "PUNCION O LACERACION ACCIDENTAL DURANTE UN PROCEDIMIENTO, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T813",
        "valor": "DESGARRO DE HERIDA OPERATORIA, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "T814",
        "valor": "INFECCION CONSECUTIVA A PROCEDIMIENTO, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "T815",
        "valor": "CUERPO EXTRAÑO DEJADO ACCIDENTALMENTE EN CAVIDAD CORPORAL O EN HERIDA OPERATORIA CONSECUTIVA A PROCEDIMIENTO"
      },
      {
        "codigo": "T816",
        "valor": "REACCION AGUDA A SUSTANCIA EXTRAÑA DEJADA ACCIDENTALMENTE DURANTE UN PROCEDIMIENTO"
      },
      {
        "codigo": "T817",
        "valor": "COMPLICACIONES VASCULARES CONSECUTIVAS A PROCEDIMIENTO, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T818",
        "valor": "OTRAS COMPLICACIONES DE PROCEDIMIENTOS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T819",
        "valor": "COMPLICACION DE PROCEDIMIENTOS, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "T82 - COMPLICACIONES DE DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS CARDIOVASCULARES",
    "detalle": [
      {
        "codigo": "T820",
        "valor": "COMPLICACION MECANICA DE PROTESIS DE VALVULA CARDIACA"
      },
      {
        "codigo": "T821",
        "valor": "COMPLICACION MECANICA DE DISPOSITIVO ELECTRONICO CARDIACO"
      },
      {
        "codigo": "T822",
        "valor": "COMPLICACION MECANICA DE DERIVACION DE ARTERIA CORONARIA E INJERTO VALVULAR"
      },
      {
        "codigo": "T823",
        "valor": "COMPLICACION MECANICA DE OTROS INJERTOS VASCULARES"
      },
      {
        "codigo": "T824",
        "valor": "COMPLICACION MECANICA DE CATETER PARA DIALISIS VASCULAR"
      },
      {
        "codigo": "T825",
        "valor": "COMPLICACION MECANICA DE OTROS DISPOSITIVOS E IMPLANTES CARDIOVASCULARES"
      },
      {
        "codigo": "T826",
        "valor": "INFECCION Y REACCION INFLAMATORIA DEBIDAS A PROTESIS DE VALVULA CARDIACA"
      },
      {
        "codigo": "T827",
        "valor": "INFECCION Y REACCION INFLAMATORIA DEBIDAS A OTROS DISPOSITIVOS, IMPLANTES E INJERTOS CARDIOVASCULARES"
      },
      {
        "codigo": "T828",
        "valor": "OTRAS COMPLICACIONES ESPECIFICADAS DE DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS CARDIOVASCULARES"
      },
      {
        "codigo": "T829",
        "valor": "COMPLICACION NO ESPECIFICADA DE DISPOSITIVO PROTESICO, IMPLANTE E INJERTO CARDIOVASCULAR"
      }
    ]
  },
  {
    "grupo": "T83 - COMPLICACIONES DE DISPOSITIVOS, IMPLANTES E INJERTOS GENITOURINARIOS",
    "detalle": [
      {
        "codigo": "T830",
        "valor": "COMPLICACION MECANICA DE CATETER URINARIO (FIJO)"
      },
      {
        "codigo": "T831",
        "valor": "COMPLICACION MECANICA DE OTROS DISPOSITIVOS E IMPLANTES URINARIOS"
      },
      {
        "codigo": "T832",
        "valor": "COMPLICACION MECANICA DE INJERTO EN ORGANO URINARIO"
      },
      {
        "codigo": "T833",
        "valor": "COMPLICACION MECANICA DE DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
      },
      {
        "codigo": "T8331",
        "valor": "EXPULSION DE DIU"
      },
      {
        "codigo": "T8332",
        "valor": "SANGRADO ANORMAL ASOCIADO A DIU"
      },
      {
        "codigo": "T8333",
        "valor": "DIU EN CAVIDAD ABDOMINAL"
      },
      {
        "codigo": "T8334",
        "valor": "DIU ENCARCELADO"
      },
      {
        "codigo": "T8335",
        "valor": "COMPLICACION DE DIU CON PERFORACION UTERINA"
      },
      {
        "codigo": "T8336",
        "valor": "DOLOR PELVICO ASOCIADO CON DIU"
      },
      {
        "codigo": "T834",
        "valor": "COMPLICACION MECANICA DE OTROS DISPOSITIVOS, IMPLANTES E INJERTOS EN EL TRACTO GENITAL"
      },
      {
        "codigo": "T835",
        "valor": "INFECCION Y REACCION INFLAMATORIA DEBIDAS A DISPOSITIVO PROTESICO, IMPLANTE E INJERTO EN EL SISTEMA URINARIO"
      },
      {
        "codigo": "T836",
        "valor": "INFECCION Y REACCION INFLAMATORIA DEBIDAS A DISPOSITIVO PROTESICO, IMPLANTE E INJERTO EN EL TRACTO GENITAL"
      },
      {
        "codigo": "T838",
        "valor": "OTRAS COMPLICACIONES DE DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS GENITOURINARIOS"
      },
      {
        "codigo": "T839",
        "valor": "COMPLICACION NO ESPECIFICADA DE DISPOSITIVO PROTESICO, IMPLANTE E INJERTO GENITOURINARIO"
      }
    ]
  },
  {
    "grupo": "T84 - COMPLICACIONES DE DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS ORTOPEDICOS INTERNOS",
    "detalle": [
      {
        "codigo": "T840",
        "valor": "COMPLICACION MECANICA DE PROTESIS ARTICULAR INTERNA"
      },
      {
        "codigo": "T841",
        "valor": "COMPLICACION MECANICA DE DISPOSITIVO DE FIJACION INTERNA DE HUESOS DE UN MIEMBRO"
      },
      {
        "codigo": "T842",
        "valor": "COMPLICACION MECANICA DE DISPOSITIVO DE FIJACION INTERNA DE OTROS HUESOS"
      },
      {
        "codigo": "T843",
        "valor": "COMPLICACION MECANICA DE OTROS DISPOSITIVOS OSEOS, IMPLANTES E INJERTOS"
      },
      {
        "codigo": "T844",
        "valor": "COMPLICACION MECANICA DE OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS ORTOPEDICOS INTERNOS"
      },
      {
        "codigo": "T845",
        "valor": "INFECCION Y REACCION INFLAMATORIA DEBIDAS A PROTESIS ARTICULAR INTERNA"
      },
      {
        "codigo": "T846",
        "valor": "INFECCION Y REACCION INFLAMATORIA DEBIDAS A DISPOSITIVO DE FIJACION INTERNA [CUALQUIER SITIO]"
      },
      {
        "codigo": "T847",
        "valor": "INFECCION Y REACCION INFLAMATORIA DEBIDAS A OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS ORTOPEDICOS INTERNOS"
      },
      {
        "codigo": "T848",
        "valor": "OTRAS COMPLICACIONES DE DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS ORTOPEDICOS INTERNOS"
      },
      {
        "codigo": "T849",
        "valor": "COMPLICACIONES NO ESPECIFICADAS DE DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS ORTOPEDICOS INTERNOS"
      }
    ]
  },
  {
    "grupo": "T85 - COMPLICACIONES DE OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS",
    "detalle": [
      {
        "codigo": "T850",
        "valor": "COMPLICACION MECANICA DE DERIVACION (ANASTOMOTICA) VENTRICULAR INTRACRANEAL"
      },
      {
        "codigo": "T851",
        "valor": "COMPLICACION MECANICA DE IMPLANTE DE ESTIMULADOR ELECTRONICO DEL SISTEMA NERVIOSO"
      },
      {
        "codigo": "T852",
        "valor": "COMPLICACION MECANICA DE LENTES INTRAOCULARES"
      },
      {
        "codigo": "T853",
        "valor": "COMPLICACION MECANICA DE OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS OCULARES"
      },
      {
        "codigo": "T854",
        "valor": "COMPLICACION MECANICA DE PROTESIS E IMPLANTE DE MAMA"
      },
      {
        "codigo": "T855",
        "valor": "COMPLICACION MECANICA DE DISPOSITIVO PROTESICO, IMPLANTE E INJERTO GASTROINTESTINAL"
      },
      {
        "codigo": "T856",
        "valor": "COMPLICACION MECANICA DE OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS INTERNOS ESPECIFICADOS"
      },
      {
        "codigo": "T857",
        "valor": "INFECCION Y REACCION INFLAMATORIA DEBIDAS A OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS INTERNOS"
      },
      {
        "codigo": "T858",
        "valor": "OTRAS COMPLICACIONES DE DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS INTERNOS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T859",
        "valor": "COMPLICACION NO ESPECIFICADA DE DISPOSITIVO PROTESICO, IMPLANTE E INJERTO INTERNO"
      }
    ]
  },
  {
    "grupo": "T86 - FALLA Y RECHAZO DEL TRASPLANTE DE ORGANOS Y TEJIDOS",
    "detalle": [
      {
        "codigo": "T860",
        "valor": "RECHAZO DE TRASPLANTE DE MEDULA OSEA"
      },
      {
        "codigo": "T861",
        "valor": "FALLA Y RECHAZO DE TRASPLANTE DE RIÑON"
      },
      {
        "codigo": "T862",
        "valor": "FALLA Y RECHAZO DE TRASPLANTE DE CORAZON"
      },
      {
        "codigo": "T863",
        "valor": "FALLA Y RECHAZO DE TRASPLANTE DE PULMON-CORAZON"
      },
      {
        "codigo": "T864",
        "valor": "FALLA Y RECHAZO DE TRASPLANTE DE HIGADO"
      },
      {
        "codigo": "T868",
        "valor": "FALLA Y RECHAZO DE OTROS ORGANOS Y TEJIDOS TRASPLANTADOS"
      },
      {
        "codigo": "T869",
        "valor": "FALLA Y RECHAZO DE TRASPLANTE DE ORGANO Y TEJIDO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "T87 - COMPLICACIONES PECULIARES DE LA REINSERCION Y AMPUTACION",
    "detalle": [
      {
        "codigo": "T870",
        "valor": "COMPLICACIONES DE LA REINSERCION (DE PARTE) DE EXTREMIDAD SUPERIOR"
      },
      {
        "codigo": "T871",
        "valor": "COMPLICACIONES DE LA REINSERCION (DE PARTE) DE EXTREMIDAD INFERIOR"
      },
      {
        "codigo": "T872",
        "valor": "COMPLICACIONES DE OTRAS PARTES DEL CUERPO REINSERTADAS"
      },
      {
        "codigo": "T873",
        "valor": "NEUROMA DE MUÑON DE AMPUTACION"
      },
      {
        "codigo": "T874",
        "valor": "INFECCION DE MUÑON DE AMPUTACION"
      },
      {
        "codigo": "T875",
        "valor": "NECROSIS DE MUÑON DE AMPUTACION"
      },
      {
        "codigo": "T876",
        "valor": "OTRAS COMPLICACIONES Y LAS NO ESPECIFICADAS DE MUÑON DE AMPUTACION"
      }
    ]
  },
  {
    "grupo": "T88 - OTRAS COMPLICACIONES DE LA ATENCION MEDICA Y QUIRURGICA, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "T880",
        "valor": "INFECCION CONSECUTIVA A INMUNIZACION"
      },
      {
        "codigo": "T881",
        "valor": "OTRAS COMPLICACIONES CONSECUTIVAS A INMUNIZACION, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T882",
        "valor": "CHOQUE DEBIDO A LA ANESTESIA"
      },
      {
        "codigo": "T883",
        "valor": "HIPERTERMIA MALIGNA DEBIDA A LA ANESTESIA"
      },
      {
        "codigo": "T884",
        "valor": "FALLA O DIFICULTAD DE LA INTUBACION"
      },
      {
        "codigo": "T885",
        "valor": "OTRAS COMPLICACIONES DE LA ANESTESIA"
      },
      {
        "codigo": "T886",
        "valor": "CHOQUE ANAFILACTICO DEBIDO A EFECTO ADVERSO DE DROGA O MEDICAMENTO CORRECTO ADMINISTRADO APROPIADAMENTE"
      },
      {
        "codigo": "T887",
        "valor": "EFECTO ADVERSO NO ESPECIFICADO DE DROGA O MEDICAMENTO"
      },
      {
        "codigo": "T888",
        "valor": "OTRAS COMPLICACIONES ESPECIFICADAS DE LA ATENCION MEDICA Y QUIRURGICA, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "T889",
        "valor": "COMPLICACIONES NO ESPECIFICADAS DE LA ATENCION MEDICA Y QUIRURGICA"
      }
    ]
  },
  {
    "grupo": "T90 - SECUELAS DE TRAUMATISMOS DE LA CABEZA",
    "detalle": [
      {
        "codigo": "T900",
        "valor": "SECUELAS DE TRAUMATISMO SUPERFICIAL DE LA CABEZA"
      },
      {
        "codigo": "T901",
        "valor": "SECUELAS DE HERIDA DE LA CABEZA"
      },
      {
        "codigo": "T902",
        "valor": "SECUELAS DE FRACTURA DEL CRANEO Y DE HUESOS FACIALES"
      },
      {
        "codigo": "T903",
        "valor": "SECUELAS DE TRAUMATISMO DE NERVIOS CRANEALES"
      },
      {
        "codigo": "T904",
        "valor": "SECUELAS DE TRAUMATISMO DEL OJO Y DE LA ORBITA"
      },
      {
        "codigo": "T905",
        "valor": "SECUELAS DE TRAUMATISMO INTRACRANEAL"
      },
      {
        "codigo": "T908",
        "valor": "SECUELAS DE OTROS TRAUMATISMOS ESPECIFICADOS DE LA CABEZA"
      },
      {
        "codigo": "T909",
        "valor": "SECUELAS DE TRAUMATISMO NO ESPECIFICADO DE LA CABEZA"
      }
    ]
  },
  {
    "grupo": "T91 - SECUELAS DE TRAUMATISMOS DEL CUELLO Y DEL TRONCO",
    "detalle": [
      {
        "codigo": "T910",
        "valor": "SECUELAS DE TRAUMATISMO SUPERFICIAL Y DE HERIDAS DEL CUELLO Y DEL TRONCO"
      },
      {
        "codigo": "T911",
        "valor": "SECUELAS DE FRACTURA DE LA COLUMNA VERTEBRAL"
      },
      {
        "codigo": "T912",
        "valor": "SECUELAS DE OTRA FRACTURA DEL TORAX Y DE LA PELVIS"
      },
      {
        "codigo": "T913",
        "valor": "SECUELAS DE TRAUMATISMO DE LA MEDULA ESPINAL"
      },
      {
        "codigo": "T914",
        "valor": "SECUELAS DE TRAUMATISMO DE ORGANOS INTRATORACICOS"
      },
      {
        "codigo": "T915",
        "valor": "SECUELAS DE TRAUMATISMO DE ORGANOS INTRAABDOMINALES Y PELVICOS"
      },
      {
        "codigo": "T918",
        "valor": "SECUELAS DE OTROS TRAUMATISMOS ESPECIFICADOS DEL CUELLO Y DEL TRONCO"
      },
      {
        "codigo": "T919",
        "valor": "SECUELAS DE TRAUMATISMO NO ESPECIFICADO DEL CUELLO Y DEL TRONCO"
      }
    ]
  },
  {
    "grupo": "T92 - SECUELAS DE TRAUMATISMOS DE MIEMBRO SUPERIOR",
    "detalle": [
      {
        "codigo": "T920",
        "valor": "SECUELAS DE HERIDA DE MIEMBRO SUPERIOR"
      },
      {
        "codigo": "T921",
        "valor": "SECUELAS DE FRACTURA DEL BRAZO"
      },
      {
        "codigo": "T922",
        "valor": "SECUELAS DE FRACTURA DE LA MUÑECA Y DE LA MANO"
      },
      {
        "codigo": "T923",
        "valor": "SECUELAS DE LUXACION, TORCEDURA Y ESQUINCE DE MIEMBRO SUPERIOR"
      },
      {
        "codigo": "T924",
        "valor": "SECUELAS DE TRAUMATISMO DE NERVIO DE MIEMBRO SUPERIOR"
      },
      {
        "codigo": "T925",
        "valor": "SECUELAS DE TRAUMATISMO DE TENDON Y MUSCULO DE MIEMBRO SUPERIOR"
      },
      {
        "codigo": "T926",
        "valor": "SECUELAS DE APLASTAMIENTO Y AMPUTACION TRAUMATICAS DE MIEMBRO SUPERIOR"
      },
      {
        "codigo": "T928",
        "valor": "SECUELAS DE OTROS TRAUMATISMOS ESPECIFICADOS DE MIEMBRO SUPERIOR"
      },
      {
        "codigo": "T929",
        "valor": "SECUELAS DE TRAUMATISMO NO ESPECIFICADO DE MIEMBRO SUPERIOR"
      }
    ]
  },
  {
    "grupo": "T93 - SECUELAS DE TRAUMATISMOS DE MIEMBRO INFERIOR",
    "detalle": [
      {
        "codigo": "T930",
        "valor": "SECUELAS DE HERIDA DE MIEMBRO INFERIOR"
      },
      {
        "codigo": "T931",
        "valor": "SECUELAS DE FRACTURA DEL FEMUR"
      },
      {
        "codigo": "T932",
        "valor": "SECUELAS DE OTRAS FRACTURAS DE MIEMBRO INFERIOR"
      },
      {
        "codigo": "T933",
        "valor": "SECUELAS DE LUXACION, TORCEDURA Y ESGUINCE DE MIEMBRO INFERIOR"
      },
      {
        "codigo": "T934",
        "valor": "SECUELAS DE TRAUMATISMO DE NERVIO DE MIEMBRO INFERIOR"
      },
      {
        "codigo": "T935",
        "valor": "SECUELAS DE TRAUMATISMO DE TENDON Y MUSCULO DE MIEMBRO INFERIOR"
      },
      {
        "codigo": "T936",
        "valor": "SECUELAS DE APLASTAMIENTO Y AMPUTACION TRAUMATICAS DE MIEMBRO INFERIOR"
      },
      {
        "codigo": "T938",
        "valor": "SECUELAS DE OTROS TRAUMATISMOS ESPECIFICADOS DE MIEMBRO INFERIOR"
      },
      {
        "codigo": "T939",
        "valor": "SECUELAS DE TRAUMATISMO NO ESPECIFICADO DE MIEMBRO INFERIOR"
      }
    ]
  },
  {
    "grupo": "T94 - SECUELAS DE TRAUMATISMOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "T940",
        "valor": "SECUELAS DE TRAUMATISMOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO"
      },
      {
        "codigo": "T941",
        "valor": "SECUELAS DE TRAUMATISMOS DE REGIONES NO ESPECIFICADAS DEL CUERPO"
      }
    ]
  },
  {
    "grupo": "T95 - SECUELAS DE QUEMADURAS, CORROSIONES Y CONGELAMIENTOS",
    "detalle": [
      {
        "codigo": "T950",
        "valor": "SECUELAS DE QUEMADURA, CORROSION Y CONGELAMIENTO DE LA CABEZA Y DEL CUELLO"
      },
      {
        "codigo": "T951",
        "valor": "SECUELAS DE QUEMADURA, CORROSION Y CONGELAMIENTO DEL TRONCO"
      },
      {
        "codigo": "T952",
        "valor": "SECUELAS DE QUEMADURA, CORROSION Y CONGELAMIENTO DE MIEMBRO SUPERIOR"
      },
      {
        "codigo": "T953",
        "valor": "SECUELAS DE QUEMADURA, CORROSION Y CONGELAMIENTO DE MIEMBRO INFERIOR"
      },
      {
        "codigo": "T954",
        "valor": "SECUELAS DE QUEMADURA Y CORROSION CLASIFICABLES SOLO DE ACUERDO CON LA EXTENSION DE LA SUPERFICIE DEL CUERPO AFECTADA"
      },
      {
        "codigo": "T958",
        "valor": "SECUELAS DE OTRAS QUEMADURAS, CORROSIONES Y CONGELAMIENTOS ESPECIFICADOS"
      },
      {
        "codigo": "T959",
        "valor": "SECUELAS DE QUEMADURA, CORROSION Y CONGELAMIENTO NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "T96 - SECUELAS DE ENVENENAMIENTOS POR DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS",
    "detalle": [
      {
        "codigo": "T96X",
        "valor": "SECUELAS DE ENVENENAMIENTOS POR DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS"
      }
    ]
  },
  {
    "grupo": "T97 - SECUELAS DE EFECTOS TOXICOS DE SUSTANCIAS DE PROCEDENCIA PRINCIPALMENTE NO MEDICINAL",
    "detalle": [
      {
        "codigo": "T97X",
        "valor": "SECUELAS DE EFECTOS TOXICOS DE SUSTANCIAS DE PROCEDENCIA PRINCIPALMENTE NO MEDI"
      }
    ]
  },
  {
    "grupo": "T98 - SECUELAS DE OTROS EFECTOS Y LOS NO ESPECIFICADOS DE CAUSAS EXTERNAS",
    "detalle": [
      {
        "codigo": "T980",
        "valor": "SECUELAS DE EFECTOS DE CUERPOS EXTRAÑOS QUE PENETRAN EN ORIFICIOS NATURALES"
      },
      {
        "codigo": "T981",
        "valor": "SECUELAS DE OTROS EFECTOS Y LOS NO ESPECIFICADOS DE CAUSAS EXTERNAS"
      },
      {
        "codigo": "T982",
        "valor": "SECUELAS DE CIERTAS COMPLICACIONES PRECOCES DE LOS TRAUMATISMOS"
      },
      {
        "codigo": "T983",
        "valor": "SECUELAS DE COMPLICACIONES DE LA ATENCION MEDICA Y QUIRURGICA, NO CLASIFICADAS EN OTRAS PARTE"
      }
    ]
  },
  {
    "grupo": "V01 - PEATON LESIONADO POR COLISION CON VEHICULO DE PEDAL",
    "detalle": [
      {
        "codigo": "V010",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE PEDAL, ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V011",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE PEDAL, ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V012",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE PEDAL EN ACCIDENTE NO ESPECIFICADO COMO DE"
      },
      {
        "codigo": "V019",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE PEDAL, ACCIDENTE NO ESPECIFICADO COMO DE TRANSITO O NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V02 - PEATON LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS",
    "detalle": [
      {
        "codigo": "V020",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V021",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V022",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS EN ACCIDENTE NO"
      },
      {
        "codigo": "V029",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, ACCIDENTE NO ESPECIFICADO COMO DE TRANSITO O NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V03 - PEATON LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA",
    "detalle": [
      {
        "codigo": "V030",
        "valor": "PEATON LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V031",
        "valor": "PEATON LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V032",
        "valor": "PEATON LESIONADO POR COLISION CON AUTOMOVIL CAMIONETA O FURGONETA EN ACCIDENTE NO ESPECI"
      },
      {
        "codigo": "V039",
        "valor": "PEATON LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, ACCIDENTE NO ESPECIFICADO COMO DE TRANSITO O NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V04 - PEATON LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "detalle": [
      {
        "codigo": "V040",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V041",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V042",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS EN ACCIDENTE N"
      },
      {
        "codigo": "V049",
        "valor": "PEATON LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, ACCIDENTE NO ESPECIFICADO COMO DE TRANSITO O NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V05 - PEATON LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES",
    "detalle": [
      {
        "codigo": "V050",
        "valor": "PEATON LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V051",
        "valor": "PEATON LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V052",
        "valor": "PEATON LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES EN ACCIDENTE NO ESPECIFICADO"
      },
      {
        "codigo": "V059",
        "valor": "PEATON LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, ACCIDENTE NO ESPECIFICADO COMO DE TRANSITO O NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V06 - PEATON LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR",
    "detalle": [
      {
        "codigo": "V060",
        "valor": "PEATON LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V061",
        "valor": "PEATON LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V062",
        "valor": "PEATON LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR EN ACCIDENTE NO ESPECIFICADO"
      },
      {
        "codigo": "V069",
        "valor": "PEATON LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, ACCIDENTE NO ESPECIFICADO COMO DE TRANSITO O NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V09 - PEATON LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE, Y EN LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V090",
        "valor": "PEATON LESIONADO EN ACCIDENTE NO DE TRANSITO QUE INVOLUCRA OTROS VEHICULOS DE MOTOR, Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "V091",
        "valor": "PEATON LESIONADO EN ACCIDENTE NO DE TRANSITO NO ESPECIFICADO"
      },
      {
        "codigo": "V092",
        "valor": "PEATON LESIONADO EN ACCIDENTE DE TRANSITO QUE INVOLUCRA OTROS VEHICULOS DE MOTOR, Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "V093",
        "valor": "PEATON LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO"
      },
      {
        "codigo": "V099",
        "valor": "PEATON LESIONADO EN ACCIDENTE DE TRANSPORTE NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V10 - CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL",
    "detalle": [
      {
        "codigo": "V100",
        "valor": "CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V101",
        "valor": "CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V102",
        "valor": "CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V103",
        "valor": "CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V104",
        "valor": "CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V105",
        "valor": "CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V109",
        "valor": "CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V11 - CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA",
    "detalle": [
      {
        "codigo": "V110",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V111",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V112",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V113",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V114",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V115",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V119",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V12 - CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS",
    "detalle": [
      {
        "codigo": "V120",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V121",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTES NO DE TRANSITO"
      },
      {
        "codigo": "V122",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V123",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V124",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V125",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V129",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V13 - CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA",
    "detalle": [
      {
        "codigo": "V130",
        "valor": "CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V131",
        "valor": "CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V132",
        "valor": "CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CICLISTA NO ESPECIFICADO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V133",
        "valor": "CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V134",
        "valor": "CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V135",
        "valor": "CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V139",
        "valor": "CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V14 - CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "detalle": [
      {
        "codigo": "V140",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V141",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V142",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V143",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V144",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V145",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V149",
        "valor": "CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V15 - CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES",
    "detalle": [
      {
        "codigo": "V150",
        "valor": "CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V151",
        "valor": "CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V152",
        "valor": "CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V153",
        "valor": "CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V154",
        "valor": "CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V155",
        "valor": "CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V159",
        "valor": "CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V16 - CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR",
    "detalle": [
      {
        "codigo": "V160",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V161",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V162",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V163",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V164",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V165",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V169",
        "valor": "CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V17 - CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO",
    "detalle": [
      {
        "codigo": "V170",
        "valor": "CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V171",
        "valor": "CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V172",
        "valor": "CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V173",
        "valor": "CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V174",
        "valor": "CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V175",
        "valor": "CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V179",
        "valor": "CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V18 - CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION",
    "detalle": [
      {
        "codigo": "V180",
        "valor": "CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V181",
        "valor": "CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V182",
        "valor": "CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V183",
        "valor": "CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V184",
        "valor": "CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V185",
        "valor": "CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V189",
        "valor": "CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V19 - CICLISTA LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE, Y EN LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V190",
        "valor": "CONDUCTOR DE VEHICULO DE PEDAL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V191",
        "valor": "PASAJERO DE VEHICULO DE PEDAL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V192",
        "valor": "CICLISTA NO ESPECIFICADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V193",
        "valor": "CICLISTA (CUALQUIERA) LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICADO"
      },
      {
        "codigo": "V194",
        "valor": "CONDUCTOR DE VEHICULO DE PEDAL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V195",
        "valor": "PASAJERO DE VEHICULO DE PEDAL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V196",
        "valor": "CICLISTA NO ESPECIFICADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADO, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V198",
        "valor": "CICLISTA [CUALQUIERA] LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS"
      },
      {
        "codigo": "V199",
        "valor": "CICLISTA [CUALQUIERA] LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V20 - MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL",
    "detalle": [
      {
        "codigo": "V200",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V201",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V202",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V203",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V204",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V205",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V209",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V21 - MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL",
    "detalle": [
      {
        "codigo": "V210",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V211",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V212",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V213",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V214",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V215",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V219",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V22 - MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES",
    "detalle": [
      {
        "codigo": "V220",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V221",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V222",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V223",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V224",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V225",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V229",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V23 - MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA",
    "detalle": [
      {
        "codigo": "V230",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V231",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V232",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, MOTOCICLISTA NO ESPECIFICADO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V233",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V234",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V235",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V239",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, MOTOCICLISTA NO ESPECIFICADO, LESION EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V24 - MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO",
    "detalle": [
      {
        "codigo": "V240",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V241",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V242",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V243",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V244",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V245",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V249",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V25 - MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES",
    "detalle": [
      {
        "codigo": "V250",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V251",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V252",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V253",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V254",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V255",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V259",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V26 - MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR",
    "detalle": [
      {
        "codigo": "V260",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V261",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V262",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V263",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V264",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V265",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V269",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V27 - MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO",
    "detalle": [
      {
        "codigo": "V270",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V271",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V272",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V273",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V274",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V275",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V279",
        "valor": "MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V28 - MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION",
    "detalle": [
      {
        "codigo": "V280",
        "valor": "MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V281",
        "valor": "MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V282",
        "valor": "MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V283",
        "valor": "MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V284",
        "valor": "MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V285",
        "valor": "MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V289",
        "valor": "MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V29 - MOTOCICLISTA LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE, Y EN LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V290",
        "valor": "CONDUCTOR DE MOTOCICLETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V291",
        "valor": "PASAJERO DE MOTOCICLETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V292",
        "valor": "MOTOCICLISTA NO ESPECIFICADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V293",
        "valor": "MOTOCICLISTA [CUALQUIERA] LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICADO"
      },
      {
        "codigo": "V294",
        "valor": "CONDUCTOR DE MOTOCICLETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V295",
        "valor": "PASAJERO DE MOTOCICLETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V296",
        "valor": "MOTOCICLISTA NO ESPECIFICADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V298",
        "valor": "MOTOCICLISTA [CUALQUIERA] LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS"
      },
      {
        "codigo": "V299",
        "valor": "MOTOCICLISTA [CUALQUIERA] LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V30 - OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION COLISION CON PEATON O ANIMAL",
    "detalle": [
      {
        "codigo": "V300",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V301",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V302",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V303",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V304",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V305",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V306",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V307",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V309",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V31 - OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL",
    "detalle": [
      {
        "codigo": "V310",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V311",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V312",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V313",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V314",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V315",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V316",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V317",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V319",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V32 - OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DOS O TRES RUEDAS",
    "detalle": [
      {
        "codigo": "V320",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V321",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V322",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V323",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DOS O TRES RUEDAS, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V324",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V325",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V326",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V327",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V329",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DOS O TRES RUEDAS, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V33 - OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL CAMIONETA O FURGONETA",
    "detalle": [
      {
        "codigo": "V330",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V331",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V332",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V333",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V334",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V335",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V336",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V337",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V339",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V34 - OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "detalle": [
      {
        "codigo": "V340",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V341",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V342",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V343",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V344",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V345",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V346",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V347",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V349",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V35 - OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULOS DE RIELES",
    "detalle": [
      {
        "codigo": "V350",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V351",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V352",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V353",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V354",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V355",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V356",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V357",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V359",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V36 - OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR",
    "detalle": [
      {
        "codigo": "V360",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V361",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V362",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V363",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V364",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V365",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V366",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V367",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V369",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V37 - OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBEJETO FIJO O ESTACIONADO",
    "detalle": [
      {
        "codigo": "V370",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V371",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V372",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V373",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V374",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V375",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V376",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V377",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V379",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V38 - OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION",
    "detalle": [
      {
        "codigo": "V380",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V381",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V382",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V383",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V384",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V385",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V386",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V387",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V389",
        "valor": "OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V39 - OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE Y EN LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V390",
        "valor": "CONDUCTOR DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V391",
        "valor": "PASAJERO DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V392",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V393",
        "valor": "OCUPANTE [CUALQUIERA] DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICADO"
      },
      {
        "codigo": "V394",
        "valor": "CONDUCTOR DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V395",
        "valor": "PASAJERO DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V396",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V398",
        "valor": "OCUPANTE [CUALQUIERA] DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS"
      },
      {
        "codigo": "V399",
        "valor": "OCUPANTE [CUALQUIERA] DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V40 - OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON PEATON O ANIMAL",
    "detalle": [
      {
        "codigo": "V400",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V401",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V402",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V403",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON PEATON O ANIMAL, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V404",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V405",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V406",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V407",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V409",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON PEATON O ANIMAL, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V41 - OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL",
    "detalle": [
      {
        "codigo": "V410",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V411",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V412",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V413",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V414",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V415",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V416",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V417",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V419",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V42 - OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS",
    "detalle": [
      {
        "codigo": "V420",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V421",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V422",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V423",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V424",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V425",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V426",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V427",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V429",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V43 - OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA",
    "detalle": [
      {
        "codigo": "V430",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V431",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V432",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V433",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V434",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V435",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V436",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V437",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V439",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V44 - OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "detalle": [
      {
        "codigo": "V440",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V441",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V442",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V443",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS , OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V444",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS , PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V445",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS , CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V446",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS , PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V447",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V449",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS , OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V45 - OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES",
    "detalle": [
      {
        "codigo": "V450",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V451",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V452",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V453",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V454",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V455",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V456",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V457",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V459",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V46 - OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR",
    "detalle": [
      {
        "codigo": "V460",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V461",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V462",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V463",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V464",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V465",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V466",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V467",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V469",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V47 - OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO",
    "detalle": [
      {
        "codigo": "V470",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V471",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V472",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V473",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V474",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V475",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V476",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V477",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V479",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V48 - OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION",
    "detalle": [
      {
        "codigo": "V480",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V481",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V482",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V483",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V484",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V485",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V486",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V487",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V489",
        "valor": "OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, OCUPANTE NO ESPECIFICADO DE AUTOMOVIL, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V49 - OCUPANTE DE AUTOMOVIL LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE, Y EN LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V490",
        "valor": "CONDUCTOR DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V491",
        "valor": "PASAJERO DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V492",
        "valor": "OCUPANTE NO ESPECIFICADO DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V493",
        "valor": "OCUPANTE (CUALQUIERA) DE AUTOMOVIL LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICADO"
      },
      {
        "codigo": "V494",
        "valor": "CONDUCTOR DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V495",
        "valor": "PASAJERO DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V496",
        "valor": "OCUPANTE NO ESPECIFICADO DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V498",
        "valor": "OCUPANTE (CUALQUIERA) DE AUTOMOVIL LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS"
      },
      {
        "codigo": "V499",
        "valor": "OCUPANTE (CUALQUIERA) DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V50 - OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL",
    "detalle": [
      {
        "codigo": "V500",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V501",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V502",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V503",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V504",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V505",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V506",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V507",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V509",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V51 - OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL",
    "detalle": [
      {
        "codigo": "V510",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V511",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V512",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V513",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V514",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V515",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V516",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V517",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V519",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V52 - OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS",
    "detalle": [
      {
        "codigo": "V520",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V521",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V522",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V523",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V524",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V525",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V526",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V527",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V529",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V53 - OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA",
    "detalle": [
      {
        "codigo": "V530",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V531",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V532",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V533",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V534",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V535",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V536",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V537",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V539",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V54 - OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "detalle": [
      {
        "codigo": "V540",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V541",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V542",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V543",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V544",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V545",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V546",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V547",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V549",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V55 - OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULOS DE RIELES",
    "detalle": [
      {
        "codigo": "V550",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V551",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V552",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V553",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V554",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V555",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V556",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V557",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V559",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V56 - OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR",
    "detalle": [
      {
        "codigo": "V560",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V561",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V562",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V563",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V564",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V565",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V566",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V567",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V569",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V57 - OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO",
    "detalle": [
      {
        "codigo": "V570",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V571",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V572",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V573",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONANDO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V574",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V575",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V576",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V577",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V579",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V58 - OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION",
    "detalle": [
      {
        "codigo": "V580",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V581",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V582",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V583",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, OCUPANTE NO ESPECIFICADO CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V584",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V585",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V586",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V587",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V589",
        "valor": "OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V59 - OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE Y EN LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V590",
        "valor": "CONDUCTOR DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V591",
        "valor": "PASAJERO DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V592",
        "valor": "OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V593",
        "valor": "OCUPANTE [CUALQUIERA] DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICADO"
      },
      {
        "codigo": "V594",
        "valor": "CONDUCTOR DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V595",
        "valor": "PASAJERO DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V596",
        "valor": "OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V598",
        "valor": "OCUPANTE [CUALQUIERA] DE CAMIONETA O FURGONETA LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS"
      },
      {
        "codigo": "V599",
        "valor": "OCUPANTE [CUALQUIERA] DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V60 - OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL",
    "detalle": [
      {
        "codigo": "V600",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V601",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V602",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V603",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V604",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V605",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V606",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V607",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V609",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V61 - OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL",
    "detalle": [
      {
        "codigo": "V610",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V611",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V612",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V613",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V614",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V615",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V616",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V617",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V619",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V62 - OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VIHICULO DE MOTOR DE DOS O TRES RUEDAS",
    "detalle": [
      {
        "codigo": "V620",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V621",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V622",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V623",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V624",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V625",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V626",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V627",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V629",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V63 - OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA",
    "detalle": [
      {
        "codigo": "V630",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V631",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V632",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V633",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V634",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V635",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V636",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V637",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V639",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V64 - OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "detalle": [
      {
        "codigo": "V640",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V641",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V642",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V643",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PESADO O AUTOBUS, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V644",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V645",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V646",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V647",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V649",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PESADO O AUTOBUS, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V65 - OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES",
    "detalle": [
      {
        "codigo": "V650",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V651",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V652",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V653",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V654",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V655",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V656",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V657",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V659",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V66 - OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR",
    "detalle": [
      {
        "codigo": "V660",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V661",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V662",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V663",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, OCUPANTE NO ESPECIFICADO, DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V664",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V665",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V666",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V667",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V669",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V67 - OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO",
    "detalle": [
      {
        "codigo": "V670",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V671",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V672",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V673",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V674",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V675",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V676",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V677",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V679",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V68 - OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION",
    "detalle": [
      {
        "codigo": "V680",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V681",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V682",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V683",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V684",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V685",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V686",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V687",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V689",
        "valor": "OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V69 - OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE Y EN LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V690",
        "valor": "CONDUCTOR DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V691",
        "valor": "PASAJERO DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V692",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V693",
        "valor": "OCUPANTE [CUALQUIERA] DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICADO"
      },
      {
        "codigo": "V694",
        "valor": "CONDUCTOR DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V695",
        "valor": "PASAJERO DE VEHICULO TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V696",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V698",
        "valor": "OCUPANTE [CUALQUIERA] DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS"
      },
      {
        "codigo": "V699",
        "valor": "OCUPANTE [CUALQUIERA] DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V70 - OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON O ANIMAL",
    "detalle": [
      {
        "codigo": "V700",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V701",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V702",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V703",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON O ANIMAL, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V704",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V705",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON O ANIMAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V706",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON O ANIMAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V707",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON O ANIMAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V709",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON O ANIMAL, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V71 - OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL",
    "detalle": [
      {
        "codigo": "V710",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V711",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V712",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V713",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V714",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V715",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V716",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V717",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V719",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V72 - OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS",
    "detalle": [
      {
        "codigo": "V720",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V721",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V722",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO TRANSITO"
      },
      {
        "codigo": "V723",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V724",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V725",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V726",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V727",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V729",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V73 - OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA",
    "detalle": [
      {
        "codigo": "V730",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V731",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V732",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA QUE VIAJA FUERA DEL VEHICULO LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V733",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V734",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V735",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V736",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V737",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V739",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V74 - OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "detalle": [
      {
        "codigo": "V740",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V741",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V742",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V743",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V744",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V745",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V746",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V747",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, PERSONA QUE VIAJA FUERA DEL VEHICULO LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V749",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V75 - OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES",
    "detalle": [
      {
        "codigo": "V750",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V751",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V752",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V753",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V754",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V755",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V756",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V757",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V759",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V76 - OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR",
    "detalle": [
      {
        "codigo": "V760",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V761",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V762",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA QUE VIAJA FUERA DEL VEHICULO LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V763",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V764",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V765",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V766",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V767",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, PERSONA QUE VIAJA FUERA DEL VEHICULO LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V769",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V77 - OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO",
    "detalle": [
      {
        "codigo": "V770",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V771",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V772",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA QUE VIAJA FUERA DEL VEHICULO LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V773",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V774",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V775",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V776",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V777",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, PERSONA QUE VIAJA FUERA DEL VEHICULO, LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V779",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V78 - OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION",
    "detalle": [
      {
        "codigo": "V780",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V781",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE O SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V782",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA QUE VIAJA FUERA DEL VEHICULO LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V783",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V784",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO"
      },
      {
        "codigo": "V785",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V786",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V787",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, PERSONA QUE VIAJA FUERA DEL VEHICULO LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V789",
        "valor": "OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION, OCUPANTE NO ESPECIFICADO DE AUTOBUS, LESIONADO EN ACCIDENTE DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V79 - OCUPANTE DE AUTOBUS LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE, Y EN LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V790",
        "valor": "CONDUCTOR DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V791",
        "valor": "PASAJERO DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V792",
        "valor": "OCUPANTE NO ESPECIFICADO DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V793",
        "valor": "OCUPANTE [CUALQUIERA] DE AUTOBUS LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICADO"
      },
      {
        "codigo": "V794",
        "valor": "CONDUCTOR DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V795",
        "valor": "PASAJERO DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V796",
        "valor": "OCUPANTE NO ESPECIFICADO DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V798",
        "valor": "OCUPANTE [CUALQUIERA] DE AUTOBUS LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS"
      },
      {
        "codigo": "V799",
        "valor": "OCUPANTE [CUALQUIERA] DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V80 - JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO EN ACCIDENTE DE TRANSPORTE",
    "detalle": [
      {
        "codigo": "V800",
        "valor": "JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR CAIDA (O POR SER DESPEDIDO) DEL ANIMAL O DEL VEHICULO DE TRACCION ANIMAL, EN ACCIDENTE SIN COLISION"
      },
      {
        "codigo": "V801",
        "valor": "JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON PEATON O ANIMAL"
      },
      {
        "codigo": "V802",
        "valor": "JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON VEHICULO DE PEDAL"
      },
      {
        "codigo": "V803",
        "valor": "JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS"
      },
      {
        "codigo": "V804",
        "valor": "JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA, VEHICULO DE TRANSPORTE PESADO, O AUTOBUS"
      },
      {
        "codigo": "V805",
        "valor": "JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR ESPECIFICADOS"
      },
      {
        "codigo": "V806",
        "valor": "JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES"
      },
      {
        "codigo": "V807",
        "valor": "JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR"
      },
      {
        "codigo": "V808",
        "valor": "JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO"
      },
      {
        "codigo": "V809",
        "valor": "JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE, Y EN LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "V81 - OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO EN ACCIDENTE DE TRANSPORTE",
    "detalle": [
      {
        "codigo": "V810",
        "valor": "OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR COLISION CON VEHICULO DE MOTOR, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V811",
        "valor": "OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR COLISION CON VEHICULO DE MOTOR, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V812",
        "valor": "OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR COLISION CON, O GOLPEADO POR VAGON"
      },
      {
        "codigo": "V813",
        "valor": "OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR COLISION CON OTROS OBJETOS"
      },
      {
        "codigo": "V814",
        "valor": "PERSONA LESIONADA AL SUBIR O BAJAR DEL TREN O VEHICULO DE RIELES"
      },
      {
        "codigo": "V815",
        "valor": "OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR CAIDA DENTRO DEL TREN O VEHICULO DE RIELES"
      },
      {
        "codigo": "V816",
        "valor": "OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR CAIDA DESDE EL TREN O VEHICULO DE RIELES"
      },
      {
        "codigo": "V817",
        "valor": "OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO EN DESCARRILAMIENTO SIN COLISION ANTERIOR"
      },
      {
        "codigo": "V818",
        "valor": "OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO EN OTROS ACCIDENTES FERROVIARIOS ESPECIFICADOS"
      },
      {
        "codigo": "V819",
        "valor": "OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO EN ACCIDENTE FERROVIARIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V82 - OCUPANTE DE TRANVIA LESIONADO EN ACCIDENTE DE TRANSPORTE",
    "detalle": [
      {
        "codigo": "V820",
        "valor": "OCUPANTE DE TRANVIA LESIONADO POR COLISION CON VEHICULO DE MOTOR, EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V821",
        "valor": "OCUPANTE DE TRANVIA LESIONADO POR COLISION CON VEHICULO DE MOTOR, EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V822",
        "valor": "OCUPANTE DE TRANVIA LESIONADO POR COLISION CON, O GOLPEADO POR VAGON"
      },
      {
        "codigo": "V823",
        "valor": "OCUPANTE DE TRANVIA LESIONADO POR COLISION CON OTROS OBJETOS"
      },
      {
        "codigo": "V824",
        "valor": "PERSONA LESIONADA AL SUBIR O BAJAR DEL TRANVIA"
      },
      {
        "codigo": "V825",
        "valor": "OCUPANTE DE TRANVIA LESIONADO POR CAIDA DENTRO DEL TRANVIA"
      },
      {
        "codigo": "V826",
        "valor": "OCUPANTE DE TRANVIA LESIONADO POR CAIDA DESDE EL TRANVIA"
      },
      {
        "codigo": "V827",
        "valor": "OCUPANTE DE TRANVIA LESIONADO POR DESCARRILAMIENTO, SIN COLISION ANTERIOR"
      },
      {
        "codigo": "V828",
        "valor": "OCUPANTE DE TRANVIA LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE, ESPECIFICADOS"
      },
      {
        "codigo": "V829",
        "valor": "OCUPANTE DE TRANVIA LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V83 - OCUPANTE DE VEHICULO ESPECIAL (DE MOTOR) PARA USO PRINCIPALMENTE EN PLANTAS INDUSTRIALES LESIONADO EN ACCIDENTE DE TRANSPORTE",
    "detalle": [
      {
        "codigo": "V830",
        "valor": "CONDUCTOR DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V831",
        "valor": "PASAJERO DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V832",
        "valor": "PERSONA QUE VIAJA FUERA DE VEHICULO INDUSTRIAL ESPECIAL LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V833",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V834",
        "valor": "PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO INDUSTRIAL ESPECIAL"
      },
      {
        "codigo": "V835",
        "valor": "CONDUCTOR DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V836",
        "valor": "PASAJERO DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V837",
        "valor": "PERSONA QUE VIAJA FUERA DEL VEHICULO INDUSTRIAL ESPECIAL LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V839",
        "valor": "OCUPANTE NO ESPECIFICADO DEL VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V84 - OCUPANTE DE VEHICULO ESPECIAL (DE MOTOR) PARA USO PRINCIPALMENTE EN AGRICULTURA LESIONADO EN ACCIDENTE DE TRANSPORTE",
    "detalle": [
      {
        "codigo": "V840",
        "valor": "CONDUCTOR DE VEHICULO AGRICOLA ESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V841",
        "valor": "PASAJERO DE VEHICULO AGRICOLA ESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V842",
        "valor": "PERSONA QUE VIAJA FUERA DEL VEHICULO AGRICOLA ESPECIAL LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V843",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO AGRICOLA ESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V844",
        "valor": "PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO AGRICOLA ESPECIAL"
      },
      {
        "codigo": "V845",
        "valor": "CONDUCTOR DE VEHICULO AGRICOLA ESPECIAL LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V846",
        "valor": "PASAJERO DE VEHICULO AGRICOLA ESPECIAL LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V847",
        "valor": "PERSONA QUE VIAJA FUERA DEL VEHICULO AGRICOLA ESPECIAL LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V849",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO AGRICOLA ESPECIAL LESIONADO EN ACCIDENTE NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V85 - OCUPANTE DE VEHICULO ESPECIAL (DE MOTOR) PARA CONSTRUCCION LESIONADO EN ACCIDENTE DE TRANSPORTE",
    "detalle": [
      {
        "codigo": "V850",
        "valor": "CONDUCTOR DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V851",
        "valor": "PASAJERO DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V852",
        "valor": "PERSONA QUE VIAJA FUERA DEL VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V853",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V854",
        "valor": "PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO ESPECIAL PARA CONSTRUCCION"
      },
      {
        "codigo": "V855",
        "valor": "CONDUCTOR DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V856",
        "valor": "PASAJERO DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V857",
        "valor": "PERSONA QUE VIAJA FUERA DEL VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V859",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V86 - OCUPANTE DE VEHICULO ESPECIAL PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE LA CARRETERA LESIONADO EN ACCIDENTE DE TRANSPORTE",
    "detalle": [
      {
        "codigo": "V860",
        "valor": "CONDUCTOR DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE LA CARRETERA LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V861",
        "valor": "PASAJERO DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE LA CARRETERA LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V862",
        "valor": "PERSONA QUE VIAJA FUERA DEL VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE LA CARRETERA LESIONADA EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V863",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE LA CARRETERA LESIONADO EN ACCIDENTE DE TRANSITO"
      },
      {
        "codigo": "V864",
        "valor": "PERSONA LESIONADA EN ACCIDENTE DE TRANSITO AL SUBIR O BAJAR DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE CARRETERA"
      },
      {
        "codigo": "V865",
        "valor": "CONDUCTOR DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE LA CARRETERA LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V866",
        "valor": "PASAJERO DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE LA CARRETERA LESIONADO EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V867",
        "valor": "PERSONA QUE VIAJA FUERA DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO MOTOR PARA USO FUERA DE CARRETERA LESIONADA EN ACCIDENTE NO DE TRANSITO"
      },
      {
        "codigo": "V869",
        "valor": "OCUPANTE NO ESPECIFICADO DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE LA CARRETERA LESIONADO EN ACCIDENTE NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V87 - ACCIDENTE DE TRANSITO DE TIPO ESPECIFICADO, PERO DONDE SE DESCONOCE EL MODO DE TRANSPORTE DE LA VICTIMA",
    "detalle": [
      {
        "codigo": "V870",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y VEHICULO DE MOTOR DE DOS O TRES RUEDAS (TRANSITO)"
      },
      {
        "codigo": "V871",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE OTROS VEHICULOS DE MOTOR Y UN VEHICULO DE MOTOR DE DOS O TRES RUEDAS (TRANSITO)"
      },
      {
        "codigo": "V872",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y CAMIONETA O FURGONETA (TRANSITO)"
      },
      {
        "codigo": "V873",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y AUTOBUS (TRANSITO)"
      },
      {
        "codigo": "V874",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y VEHICULO DE TRANSPORTE PESADO (TRANSITO)"
      },
      {
        "codigo": "V875",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE VEHICULO DE TRANSPORTE PESADO Y AUTOBUS (TRANSITO)"
      },
      {
        "codigo": "V876",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE TREN O VEHICULO DE RIELES Y AUTOMOVIL (TRANSITO)"
      },
      {
        "codigo": "V877",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE OTROS VEHICULOS DE MOTOR ESPECIFICADOS (TRANSITO)"
      },
      {
        "codigo": "V878",
        "valor": "PERSONA LESIONADA EN OTROS ACCIDENTES ESPECIFICADOS DE TRANSPORTE DE VEHICULO DE MOTOR SIN COLISION (TRANSITO)"
      },
      {
        "codigo": "V879",
        "valor": "PERSONA LESIONADA EN OTROS ACCIDENTES ESPECIFICADOS DE TRANSPORTE DE VEHICULO SIN MOTOR (CON COLISION)(SIN COLISION)(TRANSITO)"
      }
    ]
  },
  {
    "grupo": "V88 - ACCIDENTE NO DE TRANSITO DE TIPO ESPECIFICADO, PERO DONDE SE DESCONOCE EL MODO DE TRANSPORTE DE LA VICTIMA",
    "detalle": [
      {
        "codigo": "V880",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y VEHICULO DE MOTOR DE DOS O TRES RUEDAS, NO DE TRANSITO"
      },
      {
        "codigo": "V881",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE OTROS VEHICULOS DE MOTOR Y UN VEHICULO DE MOTOR DE DOS O TRES RUEDAS, NO DE TRANSITO"
      },
      {
        "codigo": "V882",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y CAMIONETA O FURGONETA, NO DE TRANSITO"
      },
      {
        "codigo": "V883",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y AUTOBUS, NO DE TRANSITO"
      },
      {
        "codigo": "V884",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y VEHICULO DE TRANSPORTE PESADO, NO DE TRANSITO"
      },
      {
        "codigo": "V885",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE VEHICULO DE TRANSPORTE PESADO Y AUTOBUS, NO DE TRANSITO"
      },
      {
        "codigo": "V886",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE TREN O VEHICULO DE RIELES Y AUTOMOVIL, NO DE TRANSITO"
      },
      {
        "codigo": "V887",
        "valor": "PERSONA LESIONADA POR COLISION ENTRE OTROS VEHICULOS DE MOTOR ESPECIFICADOS, NO DE TRANSITO"
      },
      {
        "codigo": "V888",
        "valor": "PERSONA LESIONADA EN OTROS ACCIDENTES ESPECIFICADOS DE TRANSPORTE DE VEHICULO DE MOTOR SIN COLISION, NO DE TRANSITO"
      },
      {
        "codigo": "V889",
        "valor": "PERSONA LESIONADA EN OTROS ACCIDENTES ESPECIFICADOS DE TRANSPORTE DE VEHICULO SIN MOTOR (CON COLISION)(SIN COLISION), NO DE TRANSITO"
      }
    ]
  },
  {
    "grupo": "V89 - ACCIDENTE DE VEHICULO DE MOTOR O SIN MOTOR, TIPO DE VEHICULO NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "V890",
        "valor": "PERSONA LESIONADA EN ACCIDENTE NO DE TRANSITO, DE VEHICULO DE MOTOR NO ESPECIFICADO"
      },
      {
        "codigo": "V891",
        "valor": "PERSONA LESIONADA EN ACCIDENTE NO DE TRANSITO, DE VEHICULO SIN MOTOR NO ESPECIFICADO"
      },
      {
        "codigo": "V892",
        "valor": "PERSONA LESIONADA EN ACCIDENTE DE TRANSITO, DE VEHICULO DE MOTOR NO ESPECIFICADO"
      },
      {
        "codigo": "V893",
        "valor": "PERSONA LESIONADA EN ACCIDENTE DE TRANSITO, DE VEHICULO SIN MOTOR NO ESPECIFICADO"
      },
      {
        "codigo": "V899",
        "valor": "PERSONA LESIONADA EN ACCIDENTE DE VEHICULO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V90 - ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION",
    "detalle": [
      {
        "codigo": "V900",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION, BARCO MERCANTE"
      },
      {
        "codigo": "V901",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION, BARCO DE PASAJEROS"
      },
      {
        "codigo": "V902",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION, BOTE DE PESCA"
      },
      {
        "codigo": "V903",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION, OTRO VEHICULO ACUATICO CON MOTOR"
      },
      {
        "codigo": "V904",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION, VELERO"
      },
      {
        "codigo": "V905",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION, CANOA O KAYAC"
      },
      {
        "codigo": "V906",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION, BALSA INFLABLE (SIN MOTOR)"
      },
      {
        "codigo": "V907",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION, ESQUI ACUATICO"
      },
      {
        "codigo": "V908",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION, OTRO VEHICULO ACUATICO SIN MOTOR"
      },
      {
        "codigo": "V909",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION, VEHICULO ACUATICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V91 - ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO",
    "detalle": [
      {
        "codigo": "V910",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO, BARCO MERCANTE"
      },
      {
        "codigo": "V911",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO, BARCO DE PASAJEROS"
      },
      {
        "codigo": "V912",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO, BOTE DE PESCA"
      },
      {
        "codigo": "V913",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO, OTRO VEHICULO ACUATICO CON MOTOR"
      },
      {
        "codigo": "V914",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO, VELERO"
      },
      {
        "codigo": "V915",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO, CANOA O KAYAK"
      },
      {
        "codigo": "V916",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO, BALSA INFLABLE (SIN MOTOR)"
      },
      {
        "codigo": "V917",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO, ESQUI ACUATICO"
      },
      {
        "codigo": "V918",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO, OTRO VEHICULO ACUATICO SIN MOTOR"
      },
      {
        "codigo": "V919",
        "valor": "ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO, VEHICULO ACUATICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V92 - AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION",
    "detalle": [
      {
        "codigo": "V920",
        "valor": "AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION, BARCO MERCANTE"
      },
      {
        "codigo": "V921",
        "valor": "AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION, BARCO DE PASAJEROS"
      },
      {
        "codigo": "V922",
        "valor": "AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION, BOTE DE PESCA"
      },
      {
        "codigo": "V923",
        "valor": "AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION, OTRO VEHICULO ACUATICO CON MOTOR"
      },
      {
        "codigo": "V924",
        "valor": "AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION, VELERO"
      },
      {
        "codigo": "V925",
        "valor": "AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION, CANOA O KAYAK"
      },
      {
        "codigo": "V926",
        "valor": "AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION, BALSA INFLABLE (SIN MOTOR)"
      },
      {
        "codigo": "V927",
        "valor": "AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION, ESQUI ACUATICO"
      },
      {
        "codigo": "V928",
        "valor": "AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION, OTRO VEHICULO ACUATICO SIN MOTOR"
      },
      {
        "codigo": "V929",
        "valor": "AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION, VEHICULO ACUATICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V93 - ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION",
    "detalle": [
      {
        "codigo": "V930",
        "valor": "ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION, BARCO MERCANTE"
      },
      {
        "codigo": "V931",
        "valor": "ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION, BARCO DE PASAJEROS"
      },
      {
        "codigo": "V932",
        "valor": "ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION, BOTE DE PESCA"
      },
      {
        "codigo": "V933",
        "valor": "ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION, OTRO VEHICULO ACUATICO CON MOTOR"
      },
      {
        "codigo": "V934",
        "valor": "ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION, VELERO"
      },
      {
        "codigo": "V935",
        "valor": "ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION, CANOA O KAYAK"
      },
      {
        "codigo": "V936",
        "valor": "ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION, BALSA INFLABLE (SIN MOTOR)"
      },
      {
        "codigo": "V937",
        "valor": "ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION, ESQUI ACUATICO"
      },
      {
        "codigo": "V938",
        "valor": "ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION, OTRO VEHICULO ACUATICO SIN MOTOR"
      },
      {
        "codigo": "V939",
        "valor": "ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE A LA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION, VEHICULO ACUATICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V94 - OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V940",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS, BARCO MERCANTE"
      },
      {
        "codigo": "V941",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS, BARCO DE PASAJEROS"
      },
      {
        "codigo": "V942",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS, BOTE DE PESCA"
      },
      {
        "codigo": "V943",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS, OTRO VEHICULO ACUATICO CON MOTOR"
      },
      {
        "codigo": "V944",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS, VELERO"
      },
      {
        "codigo": "V945",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS, CANOA O KAYAK"
      },
      {
        "codigo": "V946",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS, BALSA INFLABLE (SIN MOTOR)"
      },
      {
        "codigo": "V947",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS, ESQUI ACUATICO"
      },
      {
        "codigo": "V948",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS, OTRO VEHICULO ACUATICO SIN MOTOR"
      },
      {
        "codigo": "V949",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS, VEHICULO ACUATICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "V95 - ACCIDENTE DE AERONAVE DE MOTOR, CON OCUPANTE LESIONADO",
    "detalle": [
      {
        "codigo": "V950",
        "valor": "ACCIDENTE DE HELICOPTERO CON OCUPANTE LESIONADO"
      },
      {
        "codigo": "V951",
        "valor": "ACCIDENTE DE PLANEADOR ULTRA LIVIANO, MICRO LIVIANO O MOTORIZADO, CON OCUPANTE LESIONADO"
      },
      {
        "codigo": "V952",
        "valor": "ACCIDENTE DE OTROS VEHICULOS AEREOS DE ALAS FIJAS, PRIVADOS, CON OCUPANTE LESIONADO"
      },
      {
        "codigo": "V953",
        "valor": "ACCIDENTE DE VEHICULO AEREO DE ALAS FIJAS, COMERCIAL, CON OCUPANTE LESIONADO"
      },
      {
        "codigo": "V954",
        "valor": "ACCIDENTE DE NAVE ESPACIAL, CON OCUPANTE LESIONADO"
      },
      {
        "codigo": "V958",
        "valor": "ACCIDENTE DE OTRAS AERONAVES, CON OCUPANTE LESIONADO"
      },
      {
        "codigo": "V959",
        "valor": "ACCIDENTE DE AERONAVE NO ESPECIFICADA, CON OCUPANTE LESIONADO"
      }
    ]
  },
  {
    "grupo": "V96 - ACCIDENTE DE AERONAVE SIN MOTOR, CON OCUPANTE LESIONADO",
    "detalle": [
      {
        "codigo": "V960",
        "valor": "ACCIDENTE DE GLOBO AEROSTATICO, CON OCUPANTE LESIONADO"
      },
      {
        "codigo": "V961",
        "valor": "ACCIDENTE DE ALA DELTA, CON OCUPANTE LESIONADO"
      },
      {
        "codigo": "V962",
        "valor": "ACCIDENTE DE PLANEADOR (SIN MOTOR), CON OCUPANTE LESIONADO"
      },
      {
        "codigo": "V968",
        "valor": "ACCIDENTE DE OTRAS AERONAVES SIN MOTOR, CON OCUPANTE LESIONADO"
      },
      {
        "codigo": "V969",
        "valor": "ACCIDENTE DE AERONAVE SIN MOTOR NO ESPECIFICADA, CON OCUPANTE LESIONADO"
      }
    ]
  },
  {
    "grupo": "V97 - OTROS ACCIDENTES DE TRANSPORTE AEREO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V970",
        "valor": "OCUPANTE DE AERONAVE LESIONADO EN OTROS ACCIDENTES ESPECIFICADOS DE TRANSPORTE AEREO"
      },
      {
        "codigo": "V971",
        "valor": "PERSONA LESIONADA AL SUBIR O BAJAR DE UNA AERONAVE"
      },
      {
        "codigo": "V972",
        "valor": "PARACAIDISTA LESIONADO EN ACCIDENTE DE TRANSPORTE AEREO"
      },
      {
        "codigo": "V973",
        "valor": "PERSONA EN TIERRA LESIONADA POR ACCIDENTE DE TRANSPORTE AEREO"
      },
      {
        "codigo": "V978",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE AEREO, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "V98 - OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "V98X",
        "valor": "OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "V99 - ACCIDENTE DE TRANSPORTE NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "V99X",
        "valor": "ACCIDENTE DE TRANSPORTE NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W00 - CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE",
    "detalle": [
      {
        "codigo": "W000",
        "valor": "CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE, VIVIENDA"
      },
      {
        "codigo": "W001",
        "valor": "CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W002",
        "valor": "CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W003",
        "valor": "CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W004",
        "valor": "CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W005",
        "valor": "CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W006",
        "valor": "CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W007",
        "valor": "CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE, GRANJA"
      },
      {
        "codigo": "W008",
        "valor": "CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W009",
        "valor": "CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W01 - CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE",
    "detalle": [
      {
        "codigo": "W010",
        "valor": "CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE, VIVIENDA"
      },
      {
        "codigo": "W011",
        "valor": "CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W012",
        "valor": "CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W013",
        "valor": "CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W014",
        "valor": "CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W015",
        "valor": "CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W016",
        "valor": "CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W017",
        "valor": "CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE, GRANJA"
      },
      {
        "codigo": "W018",
        "valor": "CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W019",
        "valor": "CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W02 - CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA",
    "detalle": [
      {
        "codigo": "W020",
        "valor": "CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA, VIVIENDA"
      },
      {
        "codigo": "W021",
        "valor": "CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W022",
        "valor": "CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W023",
        "valor": "CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W024",
        "valor": "CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W025",
        "valor": "CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W026",
        "valor": "CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W027",
        "valor": "CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA, GRANJA"
      },
      {
        "codigo": "W028",
        "valor": "CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W029",
        "valor": "CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W03 - OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA",
    "detalle": [
      {
        "codigo": "W030",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA, VIVIENDA"
      },
      {
        "codigo": "W031",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W032",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W033",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W034",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W035",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W036",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W037",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA, GRANJA"
      },
      {
        "codigo": "W038",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W039",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W04 - CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS",
    "detalle": [
      {
        "codigo": "W040",
        "valor": "CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS, VIVIENDA"
      },
      {
        "codigo": "W041",
        "valor": "CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W042",
        "valor": "CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W043",
        "valor": "CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W044",
        "valor": "CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W045",
        "valor": "CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W046",
        "valor": "CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W047",
        "valor": "CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS, GRANJA"
      },
      {
        "codigo": "W048",
        "valor": "CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W049",
        "valor": "CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W05 - CAIDA QUE IMPLICA SILLA DE RUEDAS",
    "detalle": [
      {
        "codigo": "W050",
        "valor": "CAIDA QUE IMPLICA SILLA DE RUEDAS, VIVIENDA"
      },
      {
        "codigo": "W051",
        "valor": "CAIDA QUE IMPLICA SILLA DE RUEDAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W052",
        "valor": "CAIDA QUE IMPLICA SILLA DE RUEDAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W053",
        "valor": "CAIDA QUE IMPLICA SILLA DE RUEDAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W054",
        "valor": "CAIDA QUE IMPLICA SILLA DE RUEDAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W055",
        "valor": "CAIDA QUE IMPLICA SILLA DE RUEDAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W056",
        "valor": "CAIDA QUE IMPLICA SILLA DE RUEDAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W057",
        "valor": "CAIDA QUE IMPLICA SILLA DE RUEDAS, GRANJA"
      },
      {
        "codigo": "W058",
        "valor": "CAIDA QUE IMPLICA SILLA DE RUEDAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W059",
        "valor": "CAIDA QUE IMPLICA SILLA DE RUEDAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W06 - CAIDA QUE IMPLICA CAMA",
    "detalle": [
      {
        "codigo": "W060",
        "valor": "CAIDA QUE IMPLICA CAMA, VIVIENDA"
      },
      {
        "codigo": "W061",
        "valor": "CAIDA QUE IMPLICA CAMA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W062",
        "valor": "CAIDA QUE IMPLICA CAMA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W063",
        "valor": "CAIDA QUE IMPLICA CAMA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W064",
        "valor": "CAIDA QUE IMPLICA CAMA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W065",
        "valor": "CAIDA QUE IMPLICA CAMA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W066",
        "valor": "CAIDA QUE IMPLICA CAMA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W067",
        "valor": "CAIDA QUE IMPLICA CAMA, GRANJA"
      },
      {
        "codigo": "W068",
        "valor": "CAIDA QUE IMPLICA CAMA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W069",
        "valor": "CAIDA QUE IMPLICA CAMA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W07 - CAIDA QUE IMPLICA SILLA",
    "detalle": [
      {
        "codigo": "W070",
        "valor": "CAIDA QUE IMPLICA SILLA, VIVIENDA"
      },
      {
        "codigo": "W071",
        "valor": "CAIDA QUE IMPLICA SILLA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W072",
        "valor": "CAIDA QUE IMPLICA SILLA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W073",
        "valor": "CAIDA QUE IMPLICA SILLA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W074",
        "valor": "CAIDA QUE IMPLICA SILLA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W075",
        "valor": "CAIDA QUE IMPLICA SILLA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W076",
        "valor": "CAIDA QUE IMPLICA SILLA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W077",
        "valor": "CAIDA QUE IMPLICA SILLA, GRANJA"
      },
      {
        "codigo": "W078",
        "valor": "CAIDA QUE IMPLICA SILLA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W079",
        "valor": "CAIDA QUE IMPLICA SILLA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W08 - CAIDA QUE IMPLICA OTRO MUEBLE",
    "detalle": [
      {
        "codigo": "W080",
        "valor": "CAIDA QUE IMPLICA OTRO MUEBLE, VIVIENDA"
      },
      {
        "codigo": "W081",
        "valor": "CAIDA QUE IMPLICA OTRO MUEBLE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W082",
        "valor": "CAIDA QUE IMPLICA OTRO MUEBLE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W083",
        "valor": "CAIDA QUE IMPLICA OTRO MUEBLE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W084",
        "valor": "CAIDA QUE IMPLICA OTRO MUEBLE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W085",
        "valor": "CAIDA QUE IMPLICA OTRO MUEBLE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W086",
        "valor": "CAIDA QUE IMPLICA OTRO MUEBLE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W087",
        "valor": "CAIDA QUE IMPLICA OTRO MUEBLE, GRANJA"
      },
      {
        "codigo": "W088",
        "valor": "CAIDA QUE IMPLICA OTRO MUEBLE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W089",
        "valor": "CAIDA QUE IMPLICA OTRO MUEBLE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W09 - CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES",
    "detalle": [
      {
        "codigo": "W090",
        "valor": "CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES, VIVIENDA"
      },
      {
        "codigo": "W091",
        "valor": "CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W092",
        "valor": "CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W093",
        "valor": "CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W094",
        "valor": "CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W095",
        "valor": "CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W096",
        "valor": "CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W097",
        "valor": "CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES, GRANJA"
      },
      {
        "codigo": "W098",
        "valor": "CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W099",
        "valor": "CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W10 - CAIDA EN O DESDE ESCALERA Y ESCALONES",
    "detalle": [
      {
        "codigo": "W100",
        "valor": "CAIDA EN O DESDE ESCALERA Y ESCALONES, VIVIENDA"
      },
      {
        "codigo": "W101",
        "valor": "CAIDA EN O DESDE ESCALERA Y ESCALONES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W102",
        "valor": "CAIDA EN O DESDE ESCALERA Y ESCALONES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W103",
        "valor": "CAIDA EN O DESDE ESCALERA Y ESCALONES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W104",
        "valor": "CAIDA EN O DESDE ESCALERA Y ESCALONES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W105",
        "valor": "CAIDA EN O DESDE ESCALERA Y ESCALONES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W106",
        "valor": "CAIDA EN O DESDE ESCALERA Y ESCALONES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W107",
        "valor": "CAIDA EN O DESDE ESCALERA Y ESCALONES, GRANJA"
      },
      {
        "codigo": "W108",
        "valor": "CAIDA EN O DESDE ESCALERA Y ESCALONES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W109",
        "valor": "CAIDA EN O DESDE ESCALERA Y ESCALONES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W11 - CAIDA EN O DESDE ESCALERAS MANUALES",
    "detalle": [
      {
        "codigo": "W110",
        "valor": "CAIDA EN O DESDE ESCALERAS MANUALES, VIVIENDA"
      },
      {
        "codigo": "W111",
        "valor": "CAIDA EN O DESDE ESCALERAS MANUALES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W112",
        "valor": "CAIDA EN O DESDE ESCALERAS MANUALES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W113",
        "valor": "CAIDA EN O DESDE ESCALERAS MANUALES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W114",
        "valor": "CAIDA EN O DESDE ESCALERAS MANUALES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W115",
        "valor": "CAIDA EN O DESDE ESCALERAS MANUALES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W116",
        "valor": "CAIDA EN O DESDE ESCALERAS MANUALES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W117",
        "valor": "CAIDA EN O DESDE ESCALERAS MANUALES, GRANJA"
      },
      {
        "codigo": "W118",
        "valor": "CAIDA EN O DESDE ESCALERAS MANUALES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W119",
        "valor": "CAIDA EN O DESDE ESCALERAS MANUALES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W12 - CAIDA EN O DESDE ANDAMIO",
    "detalle": [
      {
        "codigo": "W120",
        "valor": "CAIDA EN O DESDE ANDAMIO, VIVIENDA"
      },
      {
        "codigo": "W121",
        "valor": "CAIDA EN O DESDE ANDAMIO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W122",
        "valor": "CAIDA EN O DESDE ANDAMIO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W123",
        "valor": "CAIDA EN O DESDE ANDAMIO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W124",
        "valor": "CAIDA EN O DESDE ANDAMIO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W125",
        "valor": "CAIDA EN O DESDE ANDAMIO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W126",
        "valor": "CAIDA EN O DESDE ANDAMIO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W127",
        "valor": "CAIDA EN O DESDE ANDAMIO, GRANJA"
      },
      {
        "codigo": "W128",
        "valor": "CAIDA EN O DESDE ANDAMIO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W129",
        "valor": "CAIDA EN O DESDE ANDAMIO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W13 - CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION",
    "detalle": [
      {
        "codigo": "W130",
        "valor": "CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION, VIVIENDA"
      },
      {
        "codigo": "W131",
        "valor": "CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W132",
        "valor": "CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W133",
        "valor": "CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W134",
        "valor": "CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W135",
        "valor": "CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W136",
        "valor": "CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W137",
        "valor": "CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION, GRANJA"
      },
      {
        "codigo": "W138",
        "valor": "CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W139",
        "valor": "CAIDA DESDE, FUERA O A TRAVES DE UN EDIFICIO U OTRA CONSTRUCCION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W14 - CAIDA DESDE UN ARBOL",
    "detalle": [
      {
        "codigo": "W140",
        "valor": "CAIDA DESDE UN ARBOL, VIVIENDA"
      },
      {
        "codigo": "W141",
        "valor": "CAIDA DESDE UN ARBOL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W142",
        "valor": "CAIDA DESDE UN ARBOL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W143",
        "valor": "CAIDA DESDE UN ARBOL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W144",
        "valor": "CAIDA DESDE UN ARBOL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W145",
        "valor": "CAIDA DESDE UN ARBOL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W146",
        "valor": "CAIDA DESDE UN ARBOL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W147",
        "valor": "CAIDA DESDE UN ARBOL, GRANJA"
      },
      {
        "codigo": "W148",
        "valor": "CAIDA DESDE UN ARBOL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W149",
        "valor": "CAIDA DESDE UN ARBOL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W15 - CAIDA DESDE PE?ASCO",
    "detalle": [
      {
        "codigo": "W150",
        "valor": "CAIDA DESDE PEÑASCO, VIVIENDA"
      },
      {
        "codigo": "W151",
        "valor": "CAIDA DESDE PEÑASCO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W152",
        "valor": "CAIDA DESDE PEÑASCO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W153",
        "valor": "CAIDA DESDE PEÑASCO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W154",
        "valor": "CAIDA DESDE PEÑASCO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W155",
        "valor": "CAIDA DESDE PEÑASCO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W156",
        "valor": "CAIDA DESDE PEÑASCO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W157",
        "valor": "CAIDA DESDE PEÑASCO, GRANJA"
      },
      {
        "codigo": "W158",
        "valor": "CAIDA DESDE PEÑASCO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W159",
        "valor": "CAIDA DESDE PEÑASCO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W16 - SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO",
    "detalle": [
      {
        "codigo": "W160",
        "valor": "SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO, VIVIENDA"
      },
      {
        "codigo": "W161",
        "valor": "SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W162",
        "valor": "SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W163",
        "valor": "SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W164",
        "valor": "SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W165",
        "valor": "SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W166",
        "valor": "SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W167",
        "valor": "SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO, GRANJA"
      },
      {
        "codigo": "W168",
        "valor": "SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W169",
        "valor": "SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W17 - OTRAS CAIDAS DE UN NIVEL A OTRO",
    "detalle": [
      {
        "codigo": "W170",
        "valor": "OTRAS CAIDAS DE UN NIVEL A OTRO, VIVIENDA"
      },
      {
        "codigo": "W171",
        "valor": "OTRAS CAIDAS DE UN NIVEL A OTRO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W172",
        "valor": "OTRAS CAIDAS DE UN NIVEL A OTRO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W173",
        "valor": "OTRAS CAIDAS DE UN NIVEL A OTRO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W174",
        "valor": "OTRAS CAIDAS DE UN NIVEL A OTRO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W175",
        "valor": "OTRAS CAIDAS DE UN NIVEL A OTRO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W176",
        "valor": "OTRAS CAIDAS DE UN NIVEL A OTRO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W177",
        "valor": "OTRAS CAIDAS DE UN NIVEL A OTRO, GRANJA"
      },
      {
        "codigo": "W178",
        "valor": "OTRAS CAIDAS DE UN NIVEL A OTRO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W179",
        "valor": "OTRAS CAIDAS DE UN NIVEL A OTRO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W18 - OTRAS CAIDAS EN EL MISMO NIVEL",
    "detalle": [
      {
        "codigo": "W180",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL, VIVIENDA"
      },
      {
        "codigo": "W181",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W182",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W183",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W184",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W185",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W186",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W187",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL, GRANJA"
      },
      {
        "codigo": "W188",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W189",
        "valor": "OTRAS CAIDAS EN EL MISMO NIVEL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W19 - CAIDA NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "W190",
        "valor": "CAIDA NO ESPECIFICADA, VIVIENDA"
      },
      {
        "codigo": "W191",
        "valor": "CAIDA NO ESPECIFICADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W192",
        "valor": "CAIDA NO ESPECIFICADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W193",
        "valor": "CAIDA NO ESPECIFICADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W194",
        "valor": "CAIDA NO ESPECIFICADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W195",
        "valor": "CAIDA NO ESPECIFICADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W196",
        "valor": "CAIDA NO ESPECIFICADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W197",
        "valor": "CAIDA NO ESPECIFICADA, GRANJA"
      },
      {
        "codigo": "W198",
        "valor": "CAIDA NO ESPECIFICADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W199",
        "valor": "CAIDA NO ESPECIFICADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W20 - GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE",
    "detalle": [
      {
        "codigo": "W200",
        "valor": "GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE, VIVIENDA"
      },
      {
        "codigo": "W201",
        "valor": "GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W202",
        "valor": "GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W203",
        "valor": "GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W204",
        "valor": "GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W205",
        "valor": "GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W206",
        "valor": "GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W207",
        "valor": "GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE, GRANJA"
      },
      {
        "codigo": "W208",
        "valor": "GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W209",
        "valor": "GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W21 - GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES",
    "detalle": [
      {
        "codigo": "W210",
        "valor": "GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES, VIVIENDA"
      },
      {
        "codigo": "W211",
        "valor": "GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W212",
        "valor": "GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W213",
        "valor": "GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W214",
        "valor": "GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W215",
        "valor": "GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W216",
        "valor": "GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W217",
        "valor": "GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES, GRANJA"
      },
      {
        "codigo": "W218",
        "valor": "GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W219",
        "valor": "GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W22 - GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS",
    "detalle": [
      {
        "codigo": "W220",
        "valor": "GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS, VIVIENDA"
      },
      {
        "codigo": "W221",
        "valor": "GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W222",
        "valor": "GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W223",
        "valor": "GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W224",
        "valor": "GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W225",
        "valor": "GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W226",
        "valor": "GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W227",
        "valor": "GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS, GRANJA"
      },
      {
        "codigo": "W228",
        "valor": "GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W229",
        "valor": "GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W23 - ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS",
    "detalle": [
      {
        "codigo": "W230",
        "valor": "ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS, VIVIENDA"
      },
      {
        "codigo": "W231",
        "valor": "ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W232",
        "valor": "ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W233",
        "valor": "ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W234",
        "valor": "ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W235",
        "valor": "ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W236",
        "valor": "ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W237",
        "valor": "ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS, GRANJA"
      },
      {
        "codigo": "W238",
        "valor": "ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W239",
        "valor": "ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W24 - CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "W240",
        "valor": "CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE, VIVIENDA"
      },
      {
        "codigo": "W241",
        "valor": "CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W242",
        "valor": "CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W243",
        "valor": "CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W244",
        "valor": "CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W245",
        "valor": "CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W246",
        "valor": "CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W247",
        "valor": "CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE, GRANJA"
      },
      {
        "codigo": "W248",
        "valor": "CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W249",
        "valor": "CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION Y TRANSMISION, NO CLASIFICADOS EN OTRA PARTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W25 - CONTACTO TRAUMATICO CON VIDRIO CORTANTE",
    "detalle": [
      {
        "codigo": "W250",
        "valor": "CONTACTO TRAUMATICO CON VIDRIO CORTANTE, VIVIENDA"
      },
      {
        "codigo": "W251",
        "valor": "CONTACTO TRAUMATICO CON VIDRIO CORTANTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W252",
        "valor": "CONTACTO TRAUMATICO CON VIDRIO CORTANTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W253",
        "valor": "CONTACTO TRAUMATICO CON VIDRIO CORTANTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W254",
        "valor": "CONTACTO TRAUMATICO CON VIDRIO CORTANTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W255",
        "valor": "CONTACTO TRAUMATICO CON VIDRIO CORTANTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W256",
        "valor": "CONTACTO TRAUMATICO CON VIDRIO CORTANTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W257",
        "valor": "CONTACTO TRAUMATICO CON VIDRIO CORTANTE, GRANJA"
      },
      {
        "codigo": "W258",
        "valor": "CONTACTO TRAUMATICO CON VIDRIO CORTANTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W259",
        "valor": "CONTACTO TRAUMATICO CON VIDRIO CORTANTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W26 - CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL",
    "detalle": [
      {
        "codigo": "W260",
        "valor": "CONTACTO TRAUMATICO CON CUCHILLO, ESPADA O DAGA"
      },
      {
        "codigo": "W261",
        "valor": "CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W262",
        "valor": "CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W263",
        "valor": "CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W264",
        "valor": "CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W265",
        "valor": "CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W266",
        "valor": "CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W267",
        "valor": "CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL, GRANJA"
      },
      {
        "codigo": "W268",
        "valor": "CONTACTO TRAUMATICO CON OTRO(S) OBJETOS(S) AFILADO(S) EN OTRA PARTE"
      },
      {
        "codigo": "W269",
        "valor": "CONTACTO TRAUMATICO CON OTROS OBJETOS PUNTIAGUDOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "W27 - CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR",
    "detalle": [
      {
        "codigo": "W270",
        "valor": "CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR, VIVIENDA"
      },
      {
        "codigo": "W271",
        "valor": "CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W272",
        "valor": "CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W273",
        "valor": "CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W274",
        "valor": "CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W275",
        "valor": "CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W276",
        "valor": "CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W277",
        "valor": "CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR, GRANJA"
      },
      {
        "codigo": "W278",
        "valor": "CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W279",
        "valor": "CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W28 - CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR",
    "detalle": [
      {
        "codigo": "W280",
        "valor": "CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR, VIVIENDA"
      },
      {
        "codigo": "W281",
        "valor": "CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W282",
        "valor": "CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W283",
        "valor": "CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W284",
        "valor": "CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W285",
        "valor": "CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W286",
        "valor": "CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W287",
        "valor": "CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR, GRANJA"
      },
      {
        "codigo": "W288",
        "valor": "CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W289",
        "valor": "CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W29 - CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR CON MOTOR",
    "detalle": [
      {
        "codigo": "W290",
        "valor": "CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR, VIVIENDA"
      },
      {
        "codigo": "W291",
        "valor": "CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W292",
        "valor": "CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W293",
        "valor": "CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W294",
        "valor": "CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W295",
        "valor": "CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W296",
        "valor": "CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W297",
        "valor": "CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR, GRANJA"
      },
      {
        "codigo": "W298",
        "valor": "CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W299",
        "valor": "CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W30 - CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA",
    "detalle": [
      {
        "codigo": "W300",
        "valor": "CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA, VIVIENDA"
      },
      {
        "codigo": "W301",
        "valor": "CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W302",
        "valor": "CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W303",
        "valor": "CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W304",
        "valor": "CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W305",
        "valor": "CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W306",
        "valor": "CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W307",
        "valor": "CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA, GRANJA"
      },
      {
        "codigo": "W308",
        "valor": "CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W309",
        "valor": "CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W31 - CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "W310",
        "valor": "CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "W311",
        "valor": "CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W312",
        "valor": "CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W313",
        "valor": "CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W314",
        "valor": "CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W315",
        "valor": "CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W316",
        "valor": "CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W317",
        "valor": "CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "W318",
        "valor": "CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W319",
        "valor": "CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS, Y LAS NO ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W32 - DISPARO DE ARMA CORTA",
    "detalle": [
      {
        "codigo": "W320",
        "valor": "DISPARO DE ARMA CORTA, VIVIENDA"
      },
      {
        "codigo": "W321",
        "valor": "DISPARO DE ARMA CORTA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W322",
        "valor": "DISPARO DE ARMA CORTA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W323",
        "valor": "DISPARO DE ARMA CORTA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W324",
        "valor": "DISPARO DE ARMA CORTA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W325",
        "valor": "DISPARO DE ARMA CORTA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W326",
        "valor": "DISPARO DE ARMA CORTA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W327",
        "valor": "DISPARO DE ARMA CORTA, GRANJA"
      },
      {
        "codigo": "W328",
        "valor": "DISPARO DE ARMA CORTA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W329",
        "valor": "DISPARO DE ARMA CORTA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W33 - DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA",
    "detalle": [
      {
        "codigo": "W330",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, VIVIENDA"
      },
      {
        "codigo": "W331",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W332",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W333",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W334",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W335",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W336",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W337",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, GRANJA"
      },
      {
        "codigo": "W338",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W339",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W34 - DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "W340",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "W341",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W342",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W343",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W344",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W345",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W346",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W347",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "W348",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W349",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W35 - EXPLOSION Y ROTURA DE CALDERA",
    "detalle": [
      {
        "codigo": "W350",
        "valor": "EXPLOSION Y ROTURA DE CALDERA, VIVIENDA"
      },
      {
        "codigo": "W351",
        "valor": "EXPLOSION Y ROTURA DE CALDERA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W352",
        "valor": "EXPLOSION Y ROTURA DE CALDERA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W353",
        "valor": "EXPLOSION Y ROTURA DE CALDERA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W354",
        "valor": "EXPLOSION Y ROTURA DE CALDERA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W355",
        "valor": "EXPLOSION Y ROTURA DE CALDERA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W356",
        "valor": "EXPLOSION Y ROTURA DE CALDERA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W357",
        "valor": "EXPLOSION Y ROTURA DE CALDERA, GRANJA"
      },
      {
        "codigo": "W358",
        "valor": "EXPLOSION Y ROTURA DE CALDERA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W359",
        "valor": "EXPLOSION Y ROTURA DE CALDERA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W36 - EXPLOSION Y ROTURA DE CILINDRO CON GAS",
    "detalle": [
      {
        "codigo": "W360",
        "valor": "EXPLOSION Y ROTURA DE CILINDRO CON GAS, VIVIENDA"
      },
      {
        "codigo": "W361",
        "valor": "EXPLOSION Y ROTURA DE CILINDRO CON GAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W362",
        "valor": "EXPLOSION Y ROTURA DE CILINDRO CON GAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W363",
        "valor": "EXPLOSION Y ROTURA DE CILINDRO CON GAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W364",
        "valor": "EXPLOSION Y ROTURA DE CILINDRO CON GAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W365",
        "valor": "EXPLOSION Y ROTURA DE CILINDRO CON GAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W366",
        "valor": "EXPLOSION Y ROTURA DE CILINDRO CON GAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W367",
        "valor": "EXPLOSION Y ROTURA DE CILINDRO CON GAS, GRANJA"
      },
      {
        "codigo": "W368",
        "valor": "EXPLOSION Y ROTURA DE CILINDRO CON GAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W369",
        "valor": "EXPLOSION Y ROTURA DE CILINDRO CON GAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W37 - EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA",
    "detalle": [
      {
        "codigo": "W370",
        "valor": "EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA, VIVIENDA"
      },
      {
        "codigo": "W371",
        "valor": "EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W372",
        "valor": "EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W373",
        "valor": "EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W374",
        "valor": "EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W375",
        "valor": "EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W376",
        "valor": "EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W377",
        "valor": "EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA, GRANJA"
      },
      {
        "codigo": "W378",
        "valor": "EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W379",
        "valor": "EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W38 - EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "W380",
        "valor": "EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "W381",
        "valor": "EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W382",
        "valor": "EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W383",
        "valor": "EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W384",
        "valor": "EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W385",
        "valor": "EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W386",
        "valor": "EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W387",
        "valor": "EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "W388",
        "valor": "EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W389",
        "valor": "EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W39 - EXPLOSION DE FUEGOS ARTIFICIALES",
    "detalle": [
      {
        "codigo": "W390",
        "valor": "EXPLOSION DE FUEGOS ARTIFICIALES, VIVIENDA"
      },
      {
        "codigo": "W391",
        "valor": "EXPLOSION DE FUEGOS ARTIFICIALES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W392",
        "valor": "EXPLOSION DE FUEGOS ARTIFICIALES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W393",
        "valor": "EXPLOSION DE FUEGOS ARTIFICIALES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W394",
        "valor": "EXPLOSION DE FUEGOS ARTIFICIALES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W395",
        "valor": "EXPLOSION DE FUEGOS ARTIFICIALES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W396",
        "valor": "EXPLOSION DE FUEGOS ARTIFICIALES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W397",
        "valor": "EXPLOSION DE FUEGOS ARTIFICIALES, GRANJA"
      },
      {
        "codigo": "W398",
        "valor": "EXPLOSION DE FUEGOS ARTIFICIALES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W399",
        "valor": "EXPLOSION DE FUEGOS ARTIFICIALES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W40 - EXPLOSION DE OTROS MATERIALES",
    "detalle": [
      {
        "codigo": "W400",
        "valor": "EXPLOSION DE OTROS MATERIALES, VIVIENDA"
      },
      {
        "codigo": "W401",
        "valor": "EXPLOSION DE OTROS MATERIALES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W402",
        "valor": "EXPLOSION DE OTROS MATERIALES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W403",
        "valor": "EXPLOSION DE OTROS MATERIALES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W404",
        "valor": "EXPLOSION DE OTROS MATERIALES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W405",
        "valor": "EXPLOSION DE OTROS MATERIALES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W406",
        "valor": "EXPLOSION DE OTROS MATERIALES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W407",
        "valor": "EXPLOSION DE OTROS MATERIALES, GRANJA"
      },
      {
        "codigo": "W408",
        "valor": "EXPLOSION DE OTROS MATERIALES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W409",
        "valor": "EXPLOSION DE OTROS MATERIALES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W41 - EXPOSICION A CHORRO DE ALTA PRESION",
    "detalle": [
      {
        "codigo": "W410",
        "valor": "EXPOSICION A CHORRO DE ALTA PRESION, VIVIENDA"
      },
      {
        "codigo": "W411",
        "valor": "EXPOSICION A CHORRO DE ALTA PRESION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W412",
        "valor": "EXPOSICION A CHORRO DE ALTA PRESION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W413",
        "valor": "EXPOSICION A CHORRO DE ALTA PRESION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W414",
        "valor": "EXPOSICION A CHORRO DE ALTA PRESION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W415",
        "valor": "EXPOSICION A CHORRO DE ALTA PRESION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W416",
        "valor": "EXPOSICION A CHORRO DE ALTA PRESION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W417",
        "valor": "EXPOSICION A CHORRO DE ALTA PRESION, GRANJA"
      },
      {
        "codigo": "W418",
        "valor": "EXPOSICION A CHORRO DE ALTA PRESION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W419",
        "valor": "EXPOSICION A CHORRO DE ALTA PRESION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W42 - EXPOSICION AL RUIDO",
    "detalle": [
      {
        "codigo": "W420",
        "valor": "EXPOSICION AL RUIDO, VIVIENDA"
      },
      {
        "codigo": "W421",
        "valor": "EXPOSICION AL RUIDO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W422",
        "valor": "EXPOSICION AL RUIDO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W423",
        "valor": "EXPOSICION AL RUIDO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W424",
        "valor": "EXPOSICION AL RUIDO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W425",
        "valor": "EXPOSICION AL RUIDO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W426",
        "valor": "EXPOSICION AL RUIDO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W427",
        "valor": "EXPOSICION AL RUIDO, GRANJA"
      },
      {
        "codigo": "W428",
        "valor": "EXPOSICION AL RUIDO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W429",
        "valor": "EXPOSICION AL RUIDO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W43 - EXPOSICION A VIBRACIONES",
    "detalle": [
      {
        "codigo": "W430",
        "valor": "EXPOSICION A VIBRACIONES, VIVIENDA"
      },
      {
        "codigo": "W431",
        "valor": "EXPOSICION A VIBRACIONES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W432",
        "valor": "EXPOSICION A VIBRACIONES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W433",
        "valor": "EXPOSICION A VIBRACIONES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W434",
        "valor": "EXPOSICION A VIBRACIONES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W435",
        "valor": "EXPOSICION A VIBRACIONES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W436",
        "valor": "EXPOSICION A VIBRACIONES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W437",
        "valor": "EXPOSICION A VIBRACIONES, GRANJA"
      },
      {
        "codigo": "W438",
        "valor": "EXPOSICION A VIBRACIONES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W439",
        "valor": "EXPOSICION A VIBRACIONES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W44 - CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL",
    "detalle": [
      {
        "codigo": "W440",
        "valor": "CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL, VIVIENDA"
      },
      {
        "codigo": "W441",
        "valor": "CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W442",
        "valor": "CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W443",
        "valor": "CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W444",
        "valor": "CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W445",
        "valor": "CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W446",
        "valor": "CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W447",
        "valor": "CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL, GRANJA"
      },
      {
        "codigo": "W448",
        "valor": "CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W449",
        "valor": "CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W45 - CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL",
    "detalle": [
      {
        "codigo": "W450",
        "valor": "CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL, VIVIENDA"
      },
      {
        "codigo": "W451",
        "valor": "CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W452",
        "valor": "CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W453",
        "valor": "CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W454",
        "valor": "CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W455",
        "valor": "CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W456",
        "valor": "CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W457",
        "valor": "CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL, GRANJA"
      },
      {
        "codigo": "W458",
        "valor": "CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W459",
        "valor": "CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W46 - CONTACTO TRAUMATICO CON AGUJA HIPODERMICA",
    "detalle": [
      {
        "codigo": "W460",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA, VIVIENDA"
      },
      {
        "codigo": "W461",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W462",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W463",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W464",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W465",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W466",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W467",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA, GRANJA"
      },
      {
        "codigo": "W468",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W469",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA, LUGAR NO ESPECIFICADO"
      },
      {
        "codigo": "W46X",
        "valor": "CONTACTO TRAUMATICO CON AGUJA HIPODERMICA"
      }
    ]
  },
  {
    "grupo": "W49 - EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "W490",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "W491",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W492",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W493",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W494",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W495",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W496",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W497",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "W498",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W499",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W50 - APORREO, GOLPE, MORDEDURA, PATADA, RASGU?O O TORCEDURA INFLIGIDOS POR OTRA PERSONA",
    "detalle": [
      {
        "codigo": "W500",
        "valor": "APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA, VIVIENDA"
      },
      {
        "codigo": "W501",
        "valor": "APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W502",
        "valor": "APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W503",
        "valor": "APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W504",
        "valor": "APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W505",
        "valor": "APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W506",
        "valor": "APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W507",
        "valor": "APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA, GRANJA"
      },
      {
        "codigo": "W508",
        "valor": "APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W509",
        "valor": "APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W51 - CHOQUE O EMPELLON CONTRA OTRA PERSONA",
    "detalle": [
      {
        "codigo": "W510",
        "valor": "CHOQUE O EMPELLON CONTRA OTRA PERSONA, VIVIENDA"
      },
      {
        "codigo": "W511",
        "valor": "CHOQUE O EMPELLON CONTRA OTRA PERSONA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W512",
        "valor": "CHOQUE O EMPELLON CONTRA OTRA PERSONA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W513",
        "valor": "CHOQUE O EMPELLON CONTRA OTRA PERSONA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W514",
        "valor": "CHOQUE O EMPELLON CONTRA OTRA PERSONA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W515",
        "valor": "CHOQUE O EMPELLON CONTRA OTRA PERSONA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W516",
        "valor": "CHOQUE O EMPELLON CONTRA OTRA PERSONA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W517",
        "valor": "CHOQUE O EMPELLON CONTRA OTRA PERSONA, GRANJA"
      },
      {
        "codigo": "W518",
        "valor": "CHOQUE O EMPELLON CONTRA OTRA PERSONA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W519",
        "valor": "CHOQUE O EMPELLON CONTRA OTRA PERSONA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W52 - PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA",
    "detalle": [
      {
        "codigo": "W520",
        "valor": "PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA, VIVIENDA"
      },
      {
        "codigo": "W521",
        "valor": "PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W522",
        "valor": "PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W523",
        "valor": "PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W524",
        "valor": "PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W525",
        "valor": "PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W526",
        "valor": "PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W527",
        "valor": "PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA, GRANJA"
      },
      {
        "codigo": "W528",
        "valor": "PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W529",
        "valor": "PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W53 - MORDEDURA DE RATA",
    "detalle": [
      {
        "codigo": "W530",
        "valor": "MORDEDURA DE RATA, VIVIENDA"
      },
      {
        "codigo": "W531",
        "valor": "MORDEDURA DE RATA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W532",
        "valor": "MORDEDURA DE RATA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W533",
        "valor": "MORDEDURA DE RATA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W534",
        "valor": "MORDEDURA DE RATA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W535",
        "valor": "MORDEDURA DE RATA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W536",
        "valor": "MORDEDURA DE RATA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W537",
        "valor": "MORDEDURA DE RATA, GRANJA"
      },
      {
        "codigo": "W538",
        "valor": "MORDEDURA DE RATA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W539",
        "valor": "MORDEDURA DE RATA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W54 - MORDEDURA O ATAQUE DE PERRO",
    "detalle": [
      {
        "codigo": "W540",
        "valor": "MORDEDURA O ATAQUE DE PERRO, VIVIENDA"
      },
      {
        "codigo": "W541",
        "valor": "MORDEDURA O ATAQUE DE PERRO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W542",
        "valor": "MORDEDURA O ATAQUE DE PERRO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W543",
        "valor": "MORDEDURA O ATAQUE DE PERRO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W544",
        "valor": "MORDEDURA O ATAQUE DE PERRO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W545",
        "valor": "MORDEDURA O ATAQUE DE PERRO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W546",
        "valor": "MORDEDURA O ATAQUE DE PERRO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W547",
        "valor": "MORDEDURA O ATAQUE DE PERRO, GRANJA"
      },
      {
        "codigo": "W548",
        "valor": "MORDEDURA O ATAQUE DE PERRO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W549",
        "valor": "MORDEDURA O ATAQUE DE PERRO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W55 - MORDEDURA O ATAQUE DE OTROS MAMIFEROS",
    "detalle": [
      {
        "codigo": "W550",
        "valor": "MORDEDURA O ATAQUE DE OTROS MAMIFEROS, VIVIENDA"
      },
      {
        "codigo": "W551",
        "valor": "MORDEDURA O ATAQUE DE OTROS MAMIFEROS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W552",
        "valor": "MORDEDURA O ATAQUE DE OTROS MAMIFEROS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W553",
        "valor": "MORDEDURA O ATAQUE DE OTROS MAMIFEROS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W554",
        "valor": "MORDEDURA O ATAQUE DE OTROS MAMIFEROS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W555",
        "valor": "MORDEDURA O ATAQUE DE OTROS MAMIFEROS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W556",
        "valor": "MORDEDURA O ATAQUE DE OTROS MAMIFEROS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W557",
        "valor": "MORDEDURA O ATAQUE DE OTROS MAMIFEROS, GRANJA"
      },
      {
        "codigo": "W558",
        "valor": "MORDEDURA O ATAQUE DE OTROS MAMIFEROS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W559",
        "valor": "MORDEDURA O ATAQUE DE OTROS MAMIFEROS, LUGAR NO ESPECIFICADO"
      },
      {
        "codigo": "W5591",
        "valor": "PERSONA MORDIDA POR MURCIELAGO EN LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W56 - CONTACTO TRAUMATICO CON ANIMALES MARINOS",
    "detalle": [
      {
        "codigo": "W560",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES MARINOS, VIVIENDA"
      },
      {
        "codigo": "W561",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES MARINOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W562",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES MARINOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W563",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES MARINOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W564",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES MARINOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W565",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES MARINOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W566",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES MARINOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W567",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES MARINOS, GRANJA"
      },
      {
        "codigo": "W568",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES MARINOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W569",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES MARINOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W57 - MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS",
    "detalle": [
      {
        "codigo": "W570",
        "valor": "MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS, VIVIENDA"
      },
      {
        "codigo": "W571",
        "valor": "MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W572",
        "valor": "MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W573",
        "valor": "MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W574",
        "valor": "MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W575",
        "valor": "MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W576",
        "valor": "MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W577",
        "valor": "MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS, GRANJA"
      },
      {
        "codigo": "W578",
        "valor": "MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W579",
        "valor": "MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W58 - MORDEDURA O ATAQUE DE COCODRILO O CAIMAN",
    "detalle": [
      {
        "codigo": "W580",
        "valor": "MORDEDURA O ATAQUE DE COCODRILO O CAIMAN, VIVIENDA"
      },
      {
        "codigo": "W581",
        "valor": "MORDEDURA O ATAQUE DE COCODRILO O CAIMAN, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W582",
        "valor": "MORDEDURA O ATAQUE DE COCODRILO O CAIMAN, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W583",
        "valor": "MORDEDURA O ATAQUE DE COCODRILO O CAIMAN, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W584",
        "valor": "MORDEDURA O ATAQUE DE COCODRILO O CAIMAN, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W585",
        "valor": "MORDEDURA O ATAQUE DE COCODRILO O CAIMAN, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W586",
        "valor": "MORDEDURA O ATAQUE DE COCODRILO O CAIMAN, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W587",
        "valor": "MORDEDURA O ATAQUE DE COCODRILO O CAIMAN, GRANJA"
      },
      {
        "codigo": "W588",
        "valor": "MORDEDURA O ATAQUE DE COCODRILO O CAIMAN, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W589",
        "valor": "MORDEDURA O ATAQUE DE COCODRILO O CAIMAN, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W59 - MORDEDURA O APLASTAMIENTO POR OTROS REPTILES",
    "detalle": [
      {
        "codigo": "W590",
        "valor": "MORDEDURA O APLASTAMIENTO POR OTROS REPTILES, VIVIENDA"
      },
      {
        "codigo": "W591",
        "valor": "MORDEDURA O APLASTAMIENTO POR OTROS REPTILES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W592",
        "valor": "MORDEDURA O APLASTAMIENTO POR OTROS REPTILES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W593",
        "valor": "MORDEDURA O APLASTAMIENTO POR OTROS REPTILES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W594",
        "valor": "MORDEDURA O APLASTAMIENTO POR OTROS REPTILES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W595",
        "valor": "MORDEDURA O APLASTAMIENTO POR OTROS REPTILES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W596",
        "valor": "MORDEDURA O APLASTAMIENTO POR OTROS REPTILES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W597",
        "valor": "MORDEDURA O APLASTAMIENTO POR OTROS REPTILES, GRANJA"
      },
      {
        "codigo": "W598",
        "valor": "MORDEDURA O APLASTAMIENTO POR OTROS REPTILES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W599",
        "valor": "MORDEDURA O APLASTAMIENTO POR OTROS REPTILES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W60 - CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTA",
    "detalle": [
      {
        "codigo": "W600",
        "valor": "CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS, VIVIENDA"
      },
      {
        "codigo": "W601",
        "valor": "CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W602",
        "valor": "CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W603",
        "valor": "CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W604",
        "valor": "CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W605",
        "valor": "CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W606",
        "valor": "CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W607",
        "valor": "CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS, GRANJA"
      },
      {
        "codigo": "W608",
        "valor": "CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W609",
        "valor": "CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W64 - EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "W640",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "W641",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W642",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W643",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W644",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W645",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W646",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W647",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "W648",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W649",
        "valor": "EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W65 - AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA",
    "detalle": [
      {
        "codigo": "W650",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA, VIVIENDA"
      },
      {
        "codigo": "W651",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W652",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W653",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W654",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W655",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W656",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W657",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA, GRANJA"
      },
      {
        "codigo": "W658",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W659",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W66 - AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA",
    "detalle": [
      {
        "codigo": "W660",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA, VIVIENDA"
      },
      {
        "codigo": "W661",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W662",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W663",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W664",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W665",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W666",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W667",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA, GRANJA"
      },
      {
        "codigo": "W668",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W669",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W67 - AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA",
    "detalle": [
      {
        "codigo": "W670",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA, VIVIENDA"
      },
      {
        "codigo": "W671",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W672",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W673",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W674",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W675",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W676",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W677",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA, GRANJA"
      },
      {
        "codigo": "W678",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W679",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W68 - AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA",
    "detalle": [
      {
        "codigo": "W680",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA, VIVIENDA"
      },
      {
        "codigo": "W681",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W682",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W683",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W684",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W685",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W686",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W687",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA, GRANJA"
      },
      {
        "codigo": "W688",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W689",
        "valor": "AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W69 - AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES",
    "detalle": [
      {
        "codigo": "W690",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES, VIVIENDA"
      },
      {
        "codigo": "W691",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W692",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W693",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W694",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W695",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W696",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W697",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES, GRANJA"
      },
      {
        "codigo": "W698",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W699",
        "valor": "AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W70 - AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES",
    "detalle": [
      {
        "codigo": "W700",
        "valor": "AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES, VIVIENDA"
      },
      {
        "codigo": "W701",
        "valor": "AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W702",
        "valor": "AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W703",
        "valor": "AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W704",
        "valor": "AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W705",
        "valor": "AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W706",
        "valor": "AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W707",
        "valor": "AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES, GRANJA"
      },
      {
        "codigo": "W708",
        "valor": "AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W709",
        "valor": "AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W73 - OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "W730",
        "valor": "OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "W731",
        "valor": "OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W732",
        "valor": "OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W733",
        "valor": "OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W734",
        "valor": "OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W735",
        "valor": "OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W736",
        "valor": "OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W737",
        "valor": "OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "W738",
        "valor": "OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W739",
        "valor": "OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W74 - AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "W740",
        "valor": "AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "W741",
        "valor": "AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W742",
        "valor": "AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W743",
        "valor": "AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W744",
        "valor": "AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W745",
        "valor": "AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W746",
        "valor": "AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W747",
        "valor": "AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "W748",
        "valor": "AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W749",
        "valor": "AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W75 - SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA",
    "detalle": [
      {
        "codigo": "W750",
        "valor": "SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA, VIVIENDA"
      },
      {
        "codigo": "W751",
        "valor": "SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W752",
        "valor": "SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W753",
        "valor": "SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W754",
        "valor": "SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W755",
        "valor": "SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W756",
        "valor": "SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W757",
        "valor": "SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA, GRANJA"
      },
      {
        "codigo": "W758",
        "valor": "SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W759",
        "valor": "SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W76 - OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES",
    "detalle": [
      {
        "codigo": "W760",
        "valor": "OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES, VIVIENDA"
      },
      {
        "codigo": "W761",
        "valor": "OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W762",
        "valor": "OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W763",
        "valor": "OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W764",
        "valor": "OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W765",
        "valor": "OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W766",
        "valor": "OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W767",
        "valor": "OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES, GRANJA"
      },
      {
        "codigo": "W768",
        "valor": "OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W769",
        "valor": "OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W77 - OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS",
    "detalle": [
      {
        "codigo": "W770",
        "valor": "OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS, VIVIENDA"
      },
      {
        "codigo": "W771",
        "valor": "OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W772",
        "valor": "OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W773",
        "valor": "OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W774",
        "valor": "OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W775",
        "valor": "OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W776",
        "valor": "OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W777",
        "valor": "OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS, GRANJA"
      },
      {
        "codigo": "W778",
        "valor": "OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W779",
        "valor": "OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W78 - INHALACION DE CONTENIDOS GASTRICOS",
    "detalle": [
      {
        "codigo": "W780",
        "valor": "INHALACION DE CONTENIDOS GASTRICOS, VIVIENDA"
      },
      {
        "codigo": "W781",
        "valor": "INHALACION DE CONTENIDOS GASTRICOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W782",
        "valor": "INHALACION DE CONTENIDOS GASTRICOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W783",
        "valor": "INHALACION DE CONTENIDOS GASTRICOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W784",
        "valor": "INHALACION DE CONTENIDOS GASTRICOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W785",
        "valor": "INHALACION DE CONTENIDOS GASTRICOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W786",
        "valor": "INHALACION DE CONTENIDOS GASTRICOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W787",
        "valor": "INHALACION DE CONTENIDOS GASTRICOS, GRANJA"
      },
      {
        "codigo": "W788",
        "valor": "INHALACION DE CONTENIDOS GASTRICOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W789",
        "valor": "INHALACION DE CONTENIDOS GASTRICOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W79 - INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS",
    "detalle": [
      {
        "codigo": "W790",
        "valor": "INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS, VIVIENDA"
      },
      {
        "codigo": "W791",
        "valor": "INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W792",
        "valor": "INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W793",
        "valor": "INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W794",
        "valor": "INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W795",
        "valor": "INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W796",
        "valor": "INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W797",
        "valor": "INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS, GRANJA"
      },
      {
        "codigo": "W798",
        "valor": "INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W799",
        "valor": "INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W80 - INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS",
    "detalle": [
      {
        "codigo": "W800",
        "valor": "INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS, VIVIENDA"
      },
      {
        "codigo": "W801",
        "valor": "INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W802",
        "valor": "INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS, ESCUELAS, OTRAS INSTITUCION Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W803",
        "valor": "INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W804",
        "valor": "INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W805",
        "valor": "INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W806",
        "valor": "INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W807",
        "valor": "INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS, GRANJA"
      },
      {
        "codigo": "W808",
        "valor": "INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W809",
        "valor": "INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W81 - CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO",
    "detalle": [
      {
        "codigo": "W810",
        "valor": "CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO, VIVIENDA"
      },
      {
        "codigo": "W811",
        "valor": "CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W812",
        "valor": "CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W813",
        "valor": "CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W814",
        "valor": "CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W815",
        "valor": "CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W816",
        "valor": "CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W817",
        "valor": "CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO, GRANJA"
      },
      {
        "codigo": "W818",
        "valor": "CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W819",
        "valor": "CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W83 - OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION",
    "detalle": [
      {
        "codigo": "W830",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION, VIVIENDA"
      },
      {
        "codigo": "W831",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W832",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W833",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W834",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W835",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W836",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W837",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION, GRANJA"
      },
      {
        "codigo": "W838",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W839",
        "valor": "OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W84 - OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION",
    "detalle": [
      {
        "codigo": "W840",
        "valor": "OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION, VIVIENDA"
      },
      {
        "codigo": "W841",
        "valor": "OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W842",
        "valor": "OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W843",
        "valor": "OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W844",
        "valor": "OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W845",
        "valor": "OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W846",
        "valor": "OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W847",
        "valor": "OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION, GRANJA"
      },
      {
        "codigo": "W848",
        "valor": "OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W849",
        "valor": "OBSTRUCCION NO ESPECIFICADA DE LA RESPIRACION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W85 - EXPOSICION A LINEAS DE TRANSMISION ELECTRICA",
    "detalle": [
      {
        "codigo": "W850",
        "valor": "EXPOSICION A LINEAS DE TRANSMISION ELECTRICA, VIVIENDA"
      },
      {
        "codigo": "W851",
        "valor": "EXPOSICION A LINEAS DE TRANSMISION ELECTRICA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W852",
        "valor": "EXPOSICION A LINEAS DE TRANSMISION ELECTRICA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W853",
        "valor": "EXPOSICION A LINEAS DE TRANSMISION ELECTRICA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W854",
        "valor": "EXPOSICION A LINEAS DE TRANSMISION ELECTRICA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W855",
        "valor": "EXPOSICION A LINEAS DE TRANSMISION ELECTRICA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W856",
        "valor": "EXPOSICION A LINEAS DE TRANSMISION ELECTRICA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W857",
        "valor": "EXPOSICION A LINEAS DE TRANSMISION ELECTRICA, GRANJA"
      },
      {
        "codigo": "W858",
        "valor": "EXPOSICION A LINEAS DE TRANSMISION ELECTRICA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W859",
        "valor": "EXPOSICION A LINEAS DE TRANSMISION ELECTRICA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W86 - EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "W860",
        "valor": "EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "W861",
        "valor": "EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W862",
        "valor": "EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W863",
        "valor": "EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W864",
        "valor": "EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W865",
        "valor": "EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W866",
        "valor": "EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W867",
        "valor": "EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "W868",
        "valor": "EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W869",
        "valor": "EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W87 - EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "W870",
        "valor": "EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA, VIVIENDA"
      },
      {
        "codigo": "W871",
        "valor": "EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W872",
        "valor": "EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W873",
        "valor": "EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W874",
        "valor": "EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W875",
        "valor": "EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W876",
        "valor": "EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W877",
        "valor": "EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA, GRANJA"
      },
      {
        "codigo": "W878",
        "valor": "EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W879",
        "valor": "EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W88 - EXPOSICION A RADIACION IONIZANTE",
    "detalle": [
      {
        "codigo": "W880",
        "valor": "EXPOSICION A RADIACION IONIZANTE, VIVIENDA"
      },
      {
        "codigo": "W881",
        "valor": "EXPOSICION A RADIACION IONIZANTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W882",
        "valor": "EXPOSICION A RADIACION IONIZANTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W883",
        "valor": "EXPOSICION A RADIACION IONIZANTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W884",
        "valor": "EXPOSICION A RADIACION IONIZANTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W885",
        "valor": "EXPOSICION A RADIACION IONIZANTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W886",
        "valor": "EXPOSICION A RADIACION IONIZANTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W887",
        "valor": "EXPOSICION A RADIACION IONIZANTE, GRANJA"
      },
      {
        "codigo": "W888",
        "valor": "EXPOSICION A RADIACION IONIZANTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W889",
        "valor": "EXPOSICION A RADIACION IONIZANTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W89 - EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL",
    "detalle": [
      {
        "codigo": "W890",
        "valor": "EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL, VIVIENDA"
      },
      {
        "codigo": "W891",
        "valor": "EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W892",
        "valor": "EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W893",
        "valor": "EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W894",
        "valor": "EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W895",
        "valor": "EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W896",
        "valor": "EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W897",
        "valor": "EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL, GRANJA"
      },
      {
        "codigo": "W898",
        "valor": "EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W899",
        "valor": "EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W90 - EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE",
    "detalle": [
      {
        "codigo": "W900",
        "valor": "EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE, VIVIENDA"
      },
      {
        "codigo": "W901",
        "valor": "EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W902",
        "valor": "EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W903",
        "valor": "EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W904",
        "valor": "EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W905",
        "valor": "EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W906",
        "valor": "EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W907",
        "valor": "EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE, GRANJA"
      },
      {
        "codigo": "W908",
        "valor": "EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W909",
        "valor": "EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W91 - EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO",
    "detalle": [
      {
        "codigo": "W910",
        "valor": "EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO, VIVIENDA"
      },
      {
        "codigo": "W911",
        "valor": "EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W912",
        "valor": "EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W913",
        "valor": "EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W914",
        "valor": "EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W915",
        "valor": "EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W916",
        "valor": "EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W917",
        "valor": "EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO, GRANJA"
      },
      {
        "codigo": "W918",
        "valor": "EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W919",
        "valor": "EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W92 - EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL",
    "detalle": [
      {
        "codigo": "W920",
        "valor": "EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL, VIVIENDA"
      },
      {
        "codigo": "W921",
        "valor": "EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W922",
        "valor": "EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W923",
        "valor": "EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W924",
        "valor": "EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W925",
        "valor": "EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W926",
        "valor": "EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W927",
        "valor": "EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL, GRANJA"
      },
      {
        "codigo": "W928",
        "valor": "EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W929",
        "valor": "EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W93 - EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL",
    "detalle": [
      {
        "codigo": "W930",
        "valor": "EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL, VIVIENDA"
      },
      {
        "codigo": "W931",
        "valor": "EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W932",
        "valor": "EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W933",
        "valor": "EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W934",
        "valor": "EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W935",
        "valor": "EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W936",
        "valor": "EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W937",
        "valor": "EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL, GRANJA"
      },
      {
        "codigo": "W938",
        "valor": "EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W939",
        "valor": "EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W94 - EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE",
    "detalle": [
      {
        "codigo": "W940",
        "valor": "EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE, VIVIENDA"
      },
      {
        "codigo": "W941",
        "valor": "EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W942",
        "valor": "EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W943",
        "valor": "EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W944",
        "valor": "EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W945",
        "valor": "EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W946",
        "valor": "EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W947",
        "valor": "EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE, GRANJA"
      },
      {
        "codigo": "W948",
        "valor": "EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W949",
        "valor": "EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "W99 - EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL",
    "detalle": [
      {
        "codigo": "W990",
        "valor": "EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL, VIVIENDA"
      },
      {
        "codigo": "W991",
        "valor": "EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "W992",
        "valor": "EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "W993",
        "valor": "EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "W994",
        "valor": "EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "W995",
        "valor": "EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "W996",
        "valor": "EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "W997",
        "valor": "EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL, GRANJA"
      },
      {
        "codigo": "W998",
        "valor": "EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "W999",
        "valor": "EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X00 - EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION",
    "detalle": [
      {
        "codigo": "X000",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, VIVIENDA"
      },
      {
        "codigo": "X001",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X002",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X003",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X004",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X005",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X006",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X007",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, GRANJA"
      },
      {
        "codigo": "X008",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X009",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X01 - EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION",
    "detalle": [
      {
        "codigo": "X010",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, VIVIENDA"
      },
      {
        "codigo": "X011",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X012",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X013",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X014",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X015",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X016",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X017",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, GRANJA"
      },
      {
        "codigo": "X018",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X019",
        "valor": "EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X02 - EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION",
    "detalle": [
      {
        "codigo": "X020",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, VIVIENDA"
      },
      {
        "codigo": "X021",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X022",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X023",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X024",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X025",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X026",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X027",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, GRANJA"
      },
      {
        "codigo": "X028",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X029",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X03 - EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION",
    "detalle": [
      {
        "codigo": "X030",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, VIVIENDA"
      },
      {
        "codigo": "X031",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X032",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X033",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X034",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X035",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X036",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X037",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, GRANJA"
      },
      {
        "codigo": "X038",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X039",
        "valor": "EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X04 - EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE",
    "detalle": [
      {
        "codigo": "X040",
        "valor": "EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE, VIVIENDA"
      },
      {
        "codigo": "X041",
        "valor": "EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X042",
        "valor": "EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X043",
        "valor": "EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X044",
        "valor": "EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X045",
        "valor": "EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X046",
        "valor": "EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X047",
        "valor": "EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE, GRANJA"
      },
      {
        "codigo": "X048",
        "valor": "EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X049",
        "valor": "EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X05 - EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR",
    "detalle": [
      {
        "codigo": "X050",
        "valor": "EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR, VIVIENDA"
      },
      {
        "codigo": "X051",
        "valor": "EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X052",
        "valor": "EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X053",
        "valor": "EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X054",
        "valor": "EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X055",
        "valor": "EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X056",
        "valor": "EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X057",
        "valor": "EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR, GRANJA"
      },
      {
        "codigo": "X058",
        "valor": "EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X059",
        "valor": "EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X06 - EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS",
    "detalle": [
      {
        "codigo": "X060",
        "valor": "EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS, VIVIENDA"
      },
      {
        "codigo": "X061",
        "valor": "EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X062",
        "valor": "EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X063",
        "valor": "EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X064",
        "valor": "EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X065",
        "valor": "EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X066",
        "valor": "EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X067",
        "valor": "EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS, GRANJA"
      },
      {
        "codigo": "X068",
        "valor": "EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X069",
        "valor": "EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X08 - EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X080",
        "valor": "EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X081",
        "valor": "EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X082",
        "valor": "EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X083",
        "valor": "EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X084",
        "valor": "EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X085",
        "valor": "EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X086",
        "valor": "EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X087",
        "valor": "EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X088",
        "valor": "EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X089",
        "valor": "EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X09 - EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X090",
        "valor": "EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X091",
        "valor": "EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X092",
        "valor": "EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X093",
        "valor": "EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X094",
        "valor": "EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X095",
        "valor": "EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X096",
        "valor": "EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X097",
        "valor": "EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X098",
        "valor": "EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X099",
        "valor": "EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X10 - CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES",
    "detalle": [
      {
        "codigo": "X100",
        "valor": "CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES, VIVIENDA"
      },
      {
        "codigo": "X101",
        "valor": "CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X102",
        "valor": "CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X103",
        "valor": "CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X104",
        "valor": "CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X105",
        "valor": "CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X106",
        "valor": "CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X107",
        "valor": "CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES, GRANJA"
      },
      {
        "codigo": "X108",
        "valor": "CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X109",
        "valor": "CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X11 - CONTACTO CON AGUA CALIENTE CORRIENTE",
    "detalle": [
      {
        "codigo": "X110",
        "valor": "CONTACTO CON AGUA CALIENTE CORRIENTE, VIVIENDA"
      },
      {
        "codigo": "X111",
        "valor": "CONTACTO CON AGUA CALIENTE CORRIENTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X112",
        "valor": "CONTACTO CON AGUA CALIENTE CORRIENTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X113",
        "valor": "CONTACTO CON AGUA CALIENTE CORRIENTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X114",
        "valor": "CONTACTO CON AGUA CALIENTE CORRIENTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X115",
        "valor": "CONTACTO CON AGUA CALIENTE CORRIENTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X116",
        "valor": "CONTACTO CON AGUA CALIENTE CORRIENTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X117",
        "valor": "CONTACTO CON AGUA CALIENTE CORRIENTE, GRANJA"
      },
      {
        "codigo": "X118",
        "valor": "CONTACTO CON AGUA CALIENTE CORRIENTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X119",
        "valor": "CONTACTO CON AGUA CALIENTE CORRIENTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X12 - CONTACTO CON OTROS LIQUIDOS CALIENTES",
    "detalle": [
      {
        "codigo": "X120",
        "valor": "CONTACTO CON OTROS LIQUIDOS CALIENTES, VIVIENDA"
      },
      {
        "codigo": "X121",
        "valor": "CONTACTO CON OTROS LIQUIDOS CALIENTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X122",
        "valor": "CONTACTO CON OTROS LIQUIDOS CALIENTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X123",
        "valor": "CONTACTO CON OTROS LIQUIDOS CALIENTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X124",
        "valor": "CONTACTO CON OTROS LIQUIDOS CALIENTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X125",
        "valor": "CONTACTO CON OTROS LIQUIDOS CALIENTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X126",
        "valor": "CONTACTO CON OTROS LIQUIDOS CALIENTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X127",
        "valor": "CONTACTO CON OTROS LIQUIDOS CALIENTES, GRANJA"
      },
      {
        "codigo": "X128",
        "valor": "CONTACTO CON OTROS LIQUIDOS CALIENTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X129",
        "valor": "CONTACTO CON OTROS LIQUIDOS CALIENTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X13 - CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES",
    "detalle": [
      {
        "codigo": "X130",
        "valor": "CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES, VIVIENDA"
      },
      {
        "codigo": "X131",
        "valor": "CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X132",
        "valor": "CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X133",
        "valor": "CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X134",
        "valor": "CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X135",
        "valor": "CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X136",
        "valor": "CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X137",
        "valor": "CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES, GRANJA"
      },
      {
        "codigo": "X138",
        "valor": "CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X139",
        "valor": "CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X14 - CONTACTO CON AIRE Y GASES CALIENTES",
    "detalle": [
      {
        "codigo": "X140",
        "valor": "CONTACTO CON AIRE Y GASES CALIENTES, VIVIENDA"
      },
      {
        "codigo": "X141",
        "valor": "CONTACTO CON AIRE Y GASES CALIENTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X142",
        "valor": "CONTACTO CON AIRE Y GASES CALIENTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X143",
        "valor": "CONTACTO CON AIRE Y GASES CALIENTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X144",
        "valor": "CONTACTO CON AIRE Y GASES CALIENTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X145",
        "valor": "CONTACTO CON AIRE Y GASES CALIENTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X146",
        "valor": "CONTACTO CON AIRE Y GASES CALIENTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X147",
        "valor": "CONTACTO CON AIRE Y GASES CALIENTES, GRANJA"
      },
      {
        "codigo": "X148",
        "valor": "CONTACTO CON AIRE Y GASES CALIENTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X149",
        "valor": "CONTACTO CON AIRE Y GASES CALIENTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X15 - CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES",
    "detalle": [
      {
        "codigo": "X150",
        "valor": "CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES, VIVIENDA"
      },
      {
        "codigo": "X151",
        "valor": "CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X152",
        "valor": "CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X153",
        "valor": "CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X154",
        "valor": "CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X155",
        "valor": "CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X156",
        "valor": "CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X157",
        "valor": "CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES, GRANJA"
      },
      {
        "codigo": "X158",
        "valor": "CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X159",
        "valor": "CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X16 - CONTACTO CON RADIADORES, CA?ERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES",
    "detalle": [
      {
        "codigo": "X160",
        "valor": "CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES, VIVIENDA"
      },
      {
        "codigo": "X161",
        "valor": "CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X162",
        "valor": "CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X163",
        "valor": "CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X164",
        "valor": "CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X165",
        "valor": "CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X166",
        "valor": "CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X167",
        "valor": "CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES, GRANJA"
      },
      {
        "codigo": "X168",
        "valor": "CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X169",
        "valor": "CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X17 - CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES",
    "detalle": [
      {
        "codigo": "X170",
        "valor": "CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES, VIVIENDA"
      },
      {
        "codigo": "X171",
        "valor": "CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X172",
        "valor": "CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X173",
        "valor": "CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X174",
        "valor": "CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X175",
        "valor": "CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X176",
        "valor": "CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X177",
        "valor": "CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES, GRANJA"
      },
      {
        "codigo": "X178",
        "valor": "CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X179",
        "valor": "CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X18 - CONTACTO CON OTROS METALES CALIENTES",
    "detalle": [
      {
        "codigo": "X180",
        "valor": "CONTACTO CON OTROS METALES CALIENTES, VIVIENDA"
      },
      {
        "codigo": "X181",
        "valor": "CONTACTO CON OTROS METALES CALIENTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X182",
        "valor": "CONTACTO CON OTROS METALES CALIENTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X183",
        "valor": "CONTACTO CON OTROS METALES CALIENTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X184",
        "valor": "CONTACTO CON OTROS METALES CALIENTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X185",
        "valor": "CONTACTO CON OTROS METALES CALIENTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X186",
        "valor": "CONTACTO CON OTROS METALES CALIENTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X187",
        "valor": "CONTACTO CON OTROS METALES CALIENTES, GRANJA"
      },
      {
        "codigo": "X188",
        "valor": "CONTACTO CON OTROS METALES CALIENTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X189",
        "valor": "CONTACTO CON OTROS METALES CALIENTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X19 - CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "X190",
        "valor": "CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "X191",
        "valor": "CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X192",
        "valor": "CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X193",
        "valor": "CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X194",
        "valor": "CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X195",
        "valor": "CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X196",
        "valor": "CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X197",
        "valor": "CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "X198",
        "valor": "CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X199",
        "valor": "CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X20 - CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS",
    "detalle": [
      {
        "codigo": "X200",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS, VIVIENDA"
      },
      {
        "codigo": "X201",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X202",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X203",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X204",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X205",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X206",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X207",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS, GRANJA"
      },
      {
        "codigo": "X208",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X209",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS, LUGAR NO ESPECIFICADO"
      },
      {
        "codigo": "X2091",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS EN PERSONA MORDIDA POR BOTHROOPS"
      },
      {
        "codigo": "X2092",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS EN PERSONA MORDIDA POR LACHESIS"
      },
      {
        "codigo": "X2093",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS EN PERSONA MORDIDA POR CROTALUS"
      },
      {
        "codigo": "X2094",
        "valor": "CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS EN PERSONA MORDIDA POR OTRAS ESPECIES"
      },
      {
        "codigo": "X2095",
        "valor": "CONTACTO TRAUMATICO POR MICRURUS"
      }
    ]
  },
  {
    "grupo": "X21 - CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS",
    "detalle": [
      {
        "codigo": "X210",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS, VIVIENDA"
      },
      {
        "codigo": "X211",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X212",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X213",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X214",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X215",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X216",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X217",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS, GRANJA"
      },
      {
        "codigo": "X218",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X219",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS, LUGAR NO ESPECIFICADO"
      },
      {
        "codigo": "X2191",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS EN PERSONA MORDIDA POR LOXOSCELES (ARAÑA CASERA)"
      },
      {
        "codigo": "X2192",
        "valor": "CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS EN PERSONA MORDIDA POR LACRODECTUS (ARAÑA SILVESTRE)"
      },
      {
        "codigo": "X2193",
        "valor": "CONTACTO TRAUMATICO CON ARANAS VENENOSAS EN PERSONA MORDIDA POR OTROS ARACNIDOS O NO DEFINIDOS"
      }
    ]
  },
  {
    "grupo": "X22 - CONTACTO TRAUMATICO CON ESCORPION",
    "detalle": [
      {
        "codigo": "X220",
        "valor": "CONTACTO TRAUMATICO CON ESCORPION, VIVIENDA"
      },
      {
        "codigo": "X221",
        "valor": "CONTACTO TRAUMATICO CON ESCORPION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X222",
        "valor": "CONTACTO TRAUMATICO CON ESCORPION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X223",
        "valor": "CONTACTO TRAUMATICO CON ESCORPION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X224",
        "valor": "CONTACTO TRAUMATICO CON ESCORPION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X225",
        "valor": "CONTACTO TRAUMATICO CON ESCORPION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X226",
        "valor": "CONTACTO TRAUMATICO CON ESCORPION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X227",
        "valor": "CONTACTO TRAUMATICO CON ESCORPION, GRANJA"
      },
      {
        "codigo": "X228",
        "valor": "CONTACTO TRAUMATICO CON ESCORPION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X229",
        "valor": "CONTACTO TRAUMATICO CON ESCORPION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X23 - CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS",
    "detalle": [
      {
        "codigo": "X230",
        "valor": "CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS, VIVIENDA"
      },
      {
        "codigo": "X231",
        "valor": "CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X232",
        "valor": "CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X233",
        "valor": "CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X234",
        "valor": "CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X235",
        "valor": "CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X236",
        "valor": "CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X237",
        "valor": "CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS, GRANJA"
      },
      {
        "codigo": "X238",
        "valor": "CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X239",
        "valor": "CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X24 - CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES)",
    "detalle": [
      {
        "codigo": "X240",
        "valor": "CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES), VIVIENDA"
      },
      {
        "codigo": "X241",
        "valor": "CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES), INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X242",
        "valor": "CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES), ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X243",
        "valor": "CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES), AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X244",
        "valor": "CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES), CALLES Y CARRETERAS"
      },
      {
        "codigo": "X245",
        "valor": "CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES), COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X246",
        "valor": "CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES), AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X247",
        "valor": "CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES), GRANJA"
      },
      {
        "codigo": "X248",
        "valor": "CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES), OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X249",
        "valor": "CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES), LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X25 - CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X250",
        "valor": "CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS, VIVIENDA"
      },
      {
        "codigo": "X251",
        "valor": "CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X252",
        "valor": "CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X253",
        "valor": "CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X254",
        "valor": "CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X255",
        "valor": "CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X256",
        "valor": "CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X257",
        "valor": "CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS, GRANJA"
      },
      {
        "codigo": "X258",
        "valor": "CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X259",
        "valor": "CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X26 - CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS",
    "detalle": [
      {
        "codigo": "X260",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS, VIVIENDA"
      },
      {
        "codigo": "X261",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X262",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X263",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X264",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X265",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X266",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X267",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS, GRANJA"
      },
      {
        "codigo": "X268",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X269",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X27 - CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X270",
        "valor": "CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X271",
        "valor": "CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X272",
        "valor": "CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X273",
        "valor": "CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X274",
        "valor": "CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X275",
        "valor": "CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X276",
        "valor": "CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X277",
        "valor": "CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X278",
        "valor": "CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X279",
        "valor": "CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X28 - CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "X280",
        "valor": "CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "X281",
        "valor": "CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X282",
        "valor": "CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X283",
        "valor": "CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X284",
        "valor": "CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X285",
        "valor": "CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X286",
        "valor": "CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X287",
        "valor": "CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "X288",
        "valor": "CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X289",
        "valor": "CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X29 - CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X290",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X291",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X292",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X293",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X294",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X295",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X296",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X297",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X298",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X299",
        "valor": "CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X30 - EXPOSICION AL CALOR NATURAL EXCESIVO",
    "detalle": [
      {
        "codigo": "X300",
        "valor": "EXPOSICION AL CALOR NATURAL EXCESIVO, VIVIENDA"
      },
      {
        "codigo": "X301",
        "valor": "EXPOSICION AL CALOR NATURAL EXCESIVO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X302",
        "valor": "EXPOSICION AL CALOR NATURAL EXCESIVO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X303",
        "valor": "EXPOSICION AL CALOR NATURAL EXCESIVO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X304",
        "valor": "EXPOSICION AL CALOR NATURAL EXCESIVO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X305",
        "valor": "EXPOSICION AL CALOR NATURAL EXCESIVO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X306",
        "valor": "EXPOSICION AL CALOR NATURAL EXCESIVO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X307",
        "valor": "EXPOSICION AL CALOR NATURAL EXCESIVO, GRANJA"
      },
      {
        "codigo": "X308",
        "valor": "EXPOSICION AL CALOR NATURAL EXCESIVO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X309",
        "valor": "EXPOSICION AL CALOR NATURAL EXCESIVO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X31 - EXPOSICION AL FRIO NATURAL EXCESIVO",
    "detalle": [
      {
        "codigo": "X310",
        "valor": "EXPOSICION AL FRIO NATURAL EXCESIVO, VIVIENDA"
      },
      {
        "codigo": "X311",
        "valor": "EXPOSICION AL FRIO NATURAL EXCESIVO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X312",
        "valor": "EXPOSICION AL FRIO NATURAL EXCESIVO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X313",
        "valor": "EXPOSICION AL FRIO NATURAL EXCESIVO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X314",
        "valor": "EXPOSICION AL FRIO NATURAL EXCESIVO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X315",
        "valor": "EXPOSICION AL FRIO NATURAL EXCESIVO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X316",
        "valor": "EXPOSICION AL FRIO NATURAL EXCESIVO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X317",
        "valor": "EXPOSICION AL FRIO NATURAL EXCESIVO, GRANJA"
      },
      {
        "codigo": "X318",
        "valor": "EXPOSICION AL FRIO NATURAL EXCESIVO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X319",
        "valor": "EXPOSICION AL FRIO NATURAL EXCESIVO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X32 - EXPOSICION A RAYOS SOLARES",
    "detalle": [
      {
        "codigo": "X320",
        "valor": "EXPOSICION A RAYOS SOLARES, VIVIENDA"
      },
      {
        "codigo": "X321",
        "valor": "EXPOSICION A RAYOS SOLARES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X322",
        "valor": "EXPOSICION A RAYOS SOLARES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X323",
        "valor": "EXPOSICION A RAYOS SOLARES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X324",
        "valor": "EXPOSICION A RAYOS SOLARES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X325",
        "valor": "EXPOSICION A RAYOS SOLARES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X326",
        "valor": "EXPOSICION A RAYOS SOLARES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X327",
        "valor": "EXPOSICION A RAYOS SOLARES, GRANJA"
      },
      {
        "codigo": "X328",
        "valor": "EXPOSICION A RAYOS SOLARES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X329",
        "valor": "EXPOSICION A RAYOS SOLARES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X33 - VICTIMA DE RAYO",
    "detalle": [
      {
        "codigo": "X330",
        "valor": "VICTIMA DE RAYO, VIVIENDA"
      },
      {
        "codigo": "X331",
        "valor": "VICTIMA DE RAYO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X332",
        "valor": "VICTIMA DE RAYO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X333",
        "valor": "VICTIMA DE RAYO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X334",
        "valor": "VICTIMA DE RAYO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X335",
        "valor": "VICTIMA DE RAYO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X336",
        "valor": "VICTIMA DE RAYO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X337",
        "valor": "VICTIMA DE RAYO, GRANJA"
      },
      {
        "codigo": "X338",
        "valor": "VICTIMA DE RAYO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X339",
        "valor": "VICTIMA DE RAYO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X34 - VICTIMA DE TERREMOTO",
    "detalle": [
      {
        "codigo": "X340",
        "valor": "VICTIMA DE MOVIMIENTOS CATACLISMICOS DE LA TIERRA CAUSADOS POR TERREMOTO"
      },
      {
        "codigo": "X341",
        "valor": "VICTIMA DE TSUNAMI"
      },
      {
        "codigo": "X342",
        "valor": "VICTIMA DE TERREMOTO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X343",
        "valor": "VICTIMA DE TERREMOTO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X344",
        "valor": "VICTIMA DE TERREMOTO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X345",
        "valor": "VICTIMA DE TERREMOTO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X346",
        "valor": "VICTIMA DE TERREMOTO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X347",
        "valor": "VICTIMA DE TERREMOTO, GRANJA"
      },
      {
        "codigo": "X348",
        "valor": "VICTIMA DE OTROS EFECTOS DE TERREMOTO ESPECIFICADOS"
      },
      {
        "codigo": "X349",
        "valor": "VICTIMA DE EFECTOS DE TERREMOTO NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "X35 - VICTIMA DE ERUPCION VOLCANICA",
    "detalle": [
      {
        "codigo": "X350",
        "valor": "VICTIMA DE ERUPCION VOLCANICA, VIVIENDA"
      },
      {
        "codigo": "X351",
        "valor": "VICTIMA DE ERUPCION VOLCANICA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X352",
        "valor": "VICTIMA DE ERUPCION VOLCANICA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X353",
        "valor": "VICTIMA DE ERUPCION VOLCANICA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X354",
        "valor": "VICTIMA DE ERUPCION VOLCANICA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X355",
        "valor": "VICTIMA DE ERUPCION VOLCANICA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X356",
        "valor": "VICTIMA DE ERUPCION VOLCANICA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X357",
        "valor": "VICTIMA DE ERUPCION VOLCANICA, GRANJA"
      },
      {
        "codigo": "X358",
        "valor": "VICTIMA DE ERUPCION VOLCANICA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X359",
        "valor": "VICTIMA DE ERUPCION VOLCANICA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X36 - VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA",
    "detalle": [
      {
        "codigo": "X360",
        "valor": "VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA, VIVIENDA"
      },
      {
        "codigo": "X361",
        "valor": "VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X362",
        "valor": "VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X363",
        "valor": "VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X364",
        "valor": "VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X365",
        "valor": "VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA, COMERCIO Y AREAS DE SERVICIO"
      },
      {
        "codigo": "X366",
        "valor": "VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X367",
        "valor": "VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA, GRANJA"
      },
      {
        "codigo": "X368",
        "valor": "VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X369",
        "valor": "VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X37 - VICTIMA DE TORMENTA CATACLISMICA",
    "detalle": [
      {
        "codigo": "X370",
        "valor": "VICTIMA DE TORMENTA CATACLISMICA, VIVIENDA"
      },
      {
        "codigo": "X371",
        "valor": "VICTIMA DE TORMENTA CATACLISMICA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X372",
        "valor": "VICTIMA DE TORMENTA CATACLISMICA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X373",
        "valor": "VICTIMA DE TORMENTA CATACLISMICA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X374",
        "valor": "VICTIMA DE TORMENTA CATACLISMICA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X375",
        "valor": "VICTIMA DE TORMENTA CATACLISMICA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X376",
        "valor": "VICTIMA DE TORMENTA CATACLISMICA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X377",
        "valor": "VICTIMA DE TORMENTA CATACLISMICA, GRANJA"
      },
      {
        "codigo": "X378",
        "valor": "VICTIMA DE TORMENTA CATACLISMICA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X379",
        "valor": "VICTIMA DE TORMENTA CATACLISMICA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X38 - VICTIMA DE INUNDACION",
    "detalle": [
      {
        "codigo": "X380",
        "valor": "VICTIMA DE INUNDACION, VIVIENDA"
      },
      {
        "codigo": "X381",
        "valor": "VICTIMA DE INUNDACION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X382",
        "valor": "VICTIMA DE INUNDACION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X383",
        "valor": "VICTIMA DE INUNDACION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X384",
        "valor": "VICTIMA DE INUNDACION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X385",
        "valor": "VICTIMA DE INUNDACION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X386",
        "valor": "VICTIMA DE INUNDACION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X387",
        "valor": "VICTIMA DE INUNDACION, GRANJA"
      },
      {
        "codigo": "X388",
        "valor": "VICTIMA DE INUNDACION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X389",
        "valor": "VICTIMA DE INUNDACION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X39 - EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "X390",
        "valor": "EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "X391",
        "valor": "EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X392",
        "valor": "EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X393",
        "valor": "EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X394",
        "valor": "EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X395",
        "valor": "EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X396",
        "valor": "EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X397",
        "valor": "EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "X398",
        "valor": "EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X399",
        "valor": "EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X40 - ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICO",
    "detalle": [
      {
        "codigo": "X400",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, VIVIENDA"
      },
      {
        "codigo": "X401",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X402",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X403",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X404",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X405",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X406",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X407",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, GRANJA"
      },
      {
        "codigo": "X408",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X409",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X41 - ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS,",
    "detalle": [
      {
        "codigo": "X410",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, VIVIENDA"
      },
      {
        "codigo": "X411",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X412",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X413",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X414",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X415",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X416",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X417",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, GRANJA"
      },
      {
        "codigo": "X418",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X419",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X42 - ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO ESPECIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "X420",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, VIVIENDA"
      },
      {
        "codigo": "X421",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X422",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X423",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X424",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X425",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X426",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X427",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, GRANJA"
      },
      {
        "codigo": "X428",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X429",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X43 - ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO",
    "detalle": [
      {
        "codigo": "X430",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, VIVIENDA"
      },
      {
        "codigo": "X431",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X432",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X433",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X434",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X435",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X436",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X437",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, GRANJA"
      },
      {
        "codigo": "X438",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X439",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X44 - ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS Y LAS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X440",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X441",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X442",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X443",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X444",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X445",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X446",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X447",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X448",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X449",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X45 - ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL",
    "detalle": [
      {
        "codigo": "X450",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL, VIVIENDA"
      },
      {
        "codigo": "X451",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X452",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X453",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X454",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X455",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X456",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X457",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL, GRANJA"
      },
      {
        "codigo": "X458",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X459",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X46 - ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES",
    "detalle": [
      {
        "codigo": "X460",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, VIVIENDA"
      },
      {
        "codigo": "X461",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X462",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X463",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X464",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X465",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X466",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X467",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, GRANJA"
      },
      {
        "codigo": "X468",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X469",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X47 - ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES",
    "detalle": [
      {
        "codigo": "X470",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES, VIVIENDA"
      },
      {
        "codigo": "X471",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X472",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X473",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X474",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X475",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X476",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X477",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES, GRANJA"
      },
      {
        "codigo": "X478",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X479",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X48 - ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS",
    "detalle": [
      {
        "codigo": "X480",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS, VIVIENDA"
      },
      {
        "codigo": "X481",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X482",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X483",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X484",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X485",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X486",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X487",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS, GRANJA"
      },
      {
        "codigo": "X488",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X489",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X49 - ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS",
    "detalle": [
      {
        "codigo": "X490",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X491",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X492",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X493",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X494",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X495",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X496",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X497",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X498",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X499",
        "valor": "ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X50 - EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS",
    "detalle": [
      {
        "codigo": "X500",
        "valor": "EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS, VIVIENDA"
      },
      {
        "codigo": "X501",
        "valor": "EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X502",
        "valor": "EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X503",
        "valor": "EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X504",
        "valor": "EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X505",
        "valor": "EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X506",
        "valor": "EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X507",
        "valor": "EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS, GRANJA"
      },
      {
        "codigo": "X508",
        "valor": "EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X509",
        "valor": "EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X51 - VIAJES Y DESPLAZAMIENTOS",
    "detalle": [
      {
        "codigo": "X510",
        "valor": "VIAJES Y DESPLAZAMIENTOS, VIVIENDA"
      },
      {
        "codigo": "X511",
        "valor": "VIAJES Y DESPLAZAMIENTOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X512",
        "valor": "VIAJES Y DESPLAZAMIENTOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X513",
        "valor": "VIAJES Y DESPLAZAMIENTOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X514",
        "valor": "VIAJES Y DESPLAZAMIENTOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X515",
        "valor": "VIAJES Y DESPLAZAMIENTOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X516",
        "valor": "VIAJES Y DESPLAZAMIENTOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X517",
        "valor": "VIAJES Y DESPLAZAMIENTOS, GRANJA"
      },
      {
        "codigo": "X518",
        "valor": "VIAJES Y DESPLAZAMIENTOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X519",
        "valor": "VIAJES Y DESPLAZAMIENTOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X52 - PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD",
    "detalle": [
      {
        "codigo": "X520",
        "valor": "PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD, VIVIENDA"
      },
      {
        "codigo": "X521",
        "valor": "PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X522",
        "valor": "PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X523",
        "valor": "PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X524",
        "valor": "PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X525",
        "valor": "PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X526",
        "valor": "PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X527",
        "valor": "PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD, GRANJA"
      },
      {
        "codigo": "X528",
        "valor": "PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X529",
        "valor": "PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X53 - PRIVACION DE ALIMENTOS",
    "detalle": [
      {
        "codigo": "X530",
        "valor": "PRIVACION DE ALIMENTOS, VIVIENDA"
      },
      {
        "codigo": "X531",
        "valor": "PRIVACION DE ALIMENTOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X532",
        "valor": "PRIVACION DE ALIMENTOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X533",
        "valor": "PRIVACION DE ALIMENTOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X534",
        "valor": "PRIVACION DE ALIMENTOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X535",
        "valor": "PRIVACION DE ALIMENTOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X536",
        "valor": "PRIVACION DE ALIMENTOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X537",
        "valor": "PRIVACION DE ALIMENTOS, GRANJA"
      },
      {
        "codigo": "X538",
        "valor": "PRIVACION DE ALIMENTOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X539",
        "valor": "PRIVACION DE ALIMENTOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X54 - PRIVACION DE AGUA",
    "detalle": [
      {
        "codigo": "X540",
        "valor": "PRIVACION DE AGUA, VIVIENDA"
      },
      {
        "codigo": "X541",
        "valor": "PRIVACION DE AGUA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X542",
        "valor": "PRIVACION DE AGUA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X543",
        "valor": "PRIVACION DE AGUA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X544",
        "valor": "PRIVACION DE AGUA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X545",
        "valor": "PRIVACION DE AGUA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X546",
        "valor": "PRIVACION DE AGUA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X547",
        "valor": "PRIVACION DE AGUA, GRANJA"
      },
      {
        "codigo": "X548",
        "valor": "PRIVACION DE AGUA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X549",
        "valor": "PRIVACION DE AGUA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X57 - PRIVACION NO ESPECIFICADA",
    "detalle": [
      {
        "codigo": "X570",
        "valor": "PRIVACION NO ESPECIFICADA, VIVIENDA"
      },
      {
        "codigo": "X571",
        "valor": "PRIVACION NO ESPECIFICADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X572",
        "valor": "PRIVACION NO ESPECIFICADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X573",
        "valor": "PRIVACION NO ESPECIFICADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X574",
        "valor": "PRIVACION NO ESPECIFICADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X575",
        "valor": "PRIVACION NO ESPECIFICADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X576",
        "valor": "PRIVACION NO ESPECIFICADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X577",
        "valor": "PRIVACION NO ESPECIFICADA, GRANJA"
      },
      {
        "codigo": "X578",
        "valor": "PRIVACION NO ESPECIFICADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X579",
        "valor": "PRIVACION NO ESPECIFICADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X58 - EXPOSICION A OTROS FACTORES ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X580",
        "valor": "EXPOSICION A OTROS FACTORES ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X581",
        "valor": "EXPOSICION A OTROS FACTORES ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X582",
        "valor": "EXPOSICION A OTROS FACTORES ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X583",
        "valor": "EXPOSICION A OTROS FACTORES ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X584",
        "valor": "EXPOSICION A OTROS FACTORES ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X585",
        "valor": "EXPOSICION A OTROS FACTORES ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X586",
        "valor": "EXPOSICION A OTROS FACTORES ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X587",
        "valor": "EXPOSICION A OTROS FACTORES ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X588",
        "valor": "EXPOSICION A OTROS FACTORES ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X589",
        "valor": "EXPOSICION A OTROS FACTORES ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X59 - EXPOSICION A FACTORES NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X590",
        "valor": "EXPOSICION A FACTORES NO ESPECIFICADOS, QUE CAUSAN FRACTURA"
      },
      {
        "codigo": "X591",
        "valor": "EXPOSICION A FACTORES NO ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X592",
        "valor": "EXPOSICION A FACTORES NO ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X593",
        "valor": "EXPOSICION A FACTORES NO ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X594",
        "valor": "EXPOSICION A FACTORES NO ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X595",
        "valor": "EXPOSICION A FACTORES NO ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X596",
        "valor": "EXPOSICION A FACTORES NO ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X597",
        "valor": "EXPOSICION A FACTORES NO ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X598",
        "valor": "EXPOSICION A FACTORES NO ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X599",
        "valor": "EXPOSICION A FACTORES NO ESPECIFICADOS QUE CAUSAN OTRAS LESIONES Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "X60 - ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRECTICOS Y ANTIRREUMATICOS",
    "detalle": [
      {
        "codigo": "X600",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, VIVIENDA"
      },
      {
        "codigo": "X601",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X602",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X603",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X604",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X605",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X606",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X607",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, GRANJA"
      },
      {
        "codigo": "X608",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X609",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X61 - ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "X610",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, VIVIENDA"
      },
      {
        "codigo": "X611",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X612",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X613",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X614",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X615",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X616",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X617",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, GRANJA"
      },
      {
        "codigo": "X618",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X619",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X62 - ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICOLODISPLEPTICOS [ALUCINOGENOS] NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "X620",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, VIVIENDA"
      },
      {
        "codigo": "X621",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X622",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X623",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X624",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X625",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X626",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X627",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, GRANJA"
      },
      {
        "codigo": "X628",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X629",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X63 - ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO",
    "detalle": [
      {
        "codigo": "X630",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, VIVIENDA"
      },
      {
        "codigo": "X631",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X632",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X633",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X634",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X635",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X636",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X637",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, GRANJA"
      },
      {
        "codigo": "X638",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X639",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X64 - ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRA",
    "detalle": [
      {
        "codigo": "X640",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X641",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X642",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X643",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X644",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X645",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X646",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X647",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X648",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X649",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LOS NO ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X65 - ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL",
    "detalle": [
      {
        "codigo": "X650",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL, VIVIENDA"
      },
      {
        "codigo": "X651",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X652",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X653",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X654",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X655",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X656",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X657",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL, GRANJA"
      },
      {
        "codigo": "X658",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X659",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X66 - ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES",
    "detalle": [
      {
        "codigo": "X660",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, VIVIENDA"
      },
      {
        "codigo": "X661",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X662",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X663",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X664",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X665",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X666",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X667",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, GRANJA"
      },
      {
        "codigo": "X668",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X669",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X67 - ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES",
    "detalle": [
      {
        "codigo": "X670",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES, VIVIENDA"
      },
      {
        "codigo": "X671",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X672",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X673",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X674",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X675",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X676",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X677",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES, GRANJA"
      },
      {
        "codigo": "X678",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X679",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X68 - ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS",
    "detalle": [
      {
        "codigo": "X680",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS, VIVIENDA"
      },
      {
        "codigo": "X681",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X682",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X683",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X684",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X685",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X686",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X687",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS, GRANJA"
      },
      {
        "codigo": "X688",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X689",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X69 - ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS Y LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X690",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X691",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X692",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X693",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X694",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X695",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X696",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X697",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X698",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X699",
        "valor": "ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X70 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION",
    "detalle": [
      {
        "codigo": "X700",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION VIVIENDA"
      },
      {
        "codigo": "X701",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X702",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X703",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X704",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X705",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X706",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X707",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION, GRANJA"
      },
      {
        "codigo": "X708",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X709",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X71 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION",
    "detalle": [
      {
        "codigo": "X710",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO, Y SUMERSION, VIVIENDA"
      },
      {
        "codigo": "X711",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO, Y SUMERSION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X712",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO, Y SUMERSION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X713",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO, Y SUMERSION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X714",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO, Y SUMERSION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X715",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO, Y SUMERSION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X716",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X717",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION, GRANJA"
      },
      {
        "codigo": "X718",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X719",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X72 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA",
    "detalle": [
      {
        "codigo": "X720",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA, VIVIENDA"
      },
      {
        "codigo": "X721",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X722",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X723",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X724",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X725",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X726",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X727",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA, GRANJA"
      },
      {
        "codigo": "X728",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X729",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X73 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA",
    "detalle": [
      {
        "codigo": "X730",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, VIVIENDA"
      },
      {
        "codigo": "X731",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X732",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X733",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X734",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X735",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X736",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X737",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, GRANJA"
      },
      {
        "codigo": "X738",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X739",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X74 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "X740",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "X741",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X742",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X743",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X744",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X745",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X746",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X747",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "X748",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X749",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X75 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO",
    "detalle": [
      {
        "codigo": "X750",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO, VIVIENDA"
      },
      {
        "codigo": "X751",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X752",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X753",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X754",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X755",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X756",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X757",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO, GRANJA"
      },
      {
        "codigo": "X758",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X759",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X76 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS",
    "detalle": [
      {
        "codigo": "X760",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS, VIVIENDA"
      },
      {
        "codigo": "X761",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X762",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X763",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X764",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X765",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X766",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X767",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS, GRANJA"
      },
      {
        "codigo": "X768",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X769",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X77 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES",
    "detalle": [
      {
        "codigo": "X770",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, VIVIENDA"
      },
      {
        "codigo": "X771",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X772",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X773",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X774",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X775",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X776",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X777",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, GRANJA"
      },
      {
        "codigo": "X778",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X779",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X78 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE",
    "detalle": [
      {
        "codigo": "X780",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE, VIVIENDA"
      },
      {
        "codigo": "X781",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X782",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X783",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X784",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X785",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X786",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X787",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE, GRANJA"
      },
      {
        "codigo": "X788",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X789",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X79 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO",
    "detalle": [
      {
        "codigo": "X790",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO, VIVIENDA"
      },
      {
        "codigo": "X791",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X792",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X793",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X794",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X795",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X796",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X797",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO, GRANJA"
      },
      {
        "codigo": "X798",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X799",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X80 - LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO",
    "detalle": [
      {
        "codigo": "X800",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO, VIVIENDA"
      },
      {
        "codigo": "X801",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X802",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X803",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X804",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X805",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X806",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X807",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO, GRANJA"
      },
      {
        "codigo": "X808",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X809",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X81 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO",
    "detalle": [
      {
        "codigo": "X810",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO, VIVIENDA"
      },
      {
        "codigo": "X811",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X812",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X813",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X814",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X815",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X816",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X817",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO, GRANJA"
      },
      {
        "codigo": "X818",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X819",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X82 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR",
    "detalle": [
      {
        "codigo": "X820",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR, VIVIENDA"
      },
      {
        "codigo": "X821",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X822",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X823",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X824",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X825",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X826",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X827",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR, GRANJA"
      },
      {
        "codigo": "X828",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X829",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X83 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X830",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X831",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X832",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X833",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X834",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X835",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X836",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X837",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X838",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X839",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X84 - LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "X840",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "X841",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X842",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X843",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X844",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X845",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X846",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X847",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "X848",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X849",
        "valor": "LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X85 - AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS",
    "detalle": [
      {
        "codigo": "X850",
        "valor": "AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, VIVIENDA"
      },
      {
        "codigo": "X851",
        "valor": "AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X852",
        "valor": "AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X853",
        "valor": "AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X854",
        "valor": "AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X855",
        "valor": "AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X856",
        "valor": "AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X857",
        "valor": "AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, GRANJA"
      },
      {
        "codigo": "X858",
        "valor": "AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X859",
        "valor": "AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X86 - AGRESION CON SUSTANCIA CORROSIVA",
    "detalle": [
      {
        "codigo": "X860",
        "valor": "AGRESION CON SUSTANCIA CORROSIVA, VIVIENDA"
      },
      {
        "codigo": "X861",
        "valor": "AGRESION CON SUSTANCIA CORROSIVA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X862",
        "valor": "AGRESION CON SUSTANCIA CORROSIVA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X863",
        "valor": "AGRESION CON SUSTANCIA CORROSIVA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X864",
        "valor": "AGRESION CON SUSTANCIA CORROSIVA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X865",
        "valor": "AGRESION CON SUSTANCIA CORROSIVA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X866",
        "valor": "AGRESION CON SUSTANCIA CORROSIVA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X867",
        "valor": "AGRESION CON SUSTANCIA CORROSIVA, GRANJA"
      },
      {
        "codigo": "X868",
        "valor": "AGRESION CON SUSTANCIA CORROSIVA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X869",
        "valor": "AGRESION CON SUSTANCIA CORROSIVA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X87 - AGRESION CON PLAGUICIDAS",
    "detalle": [
      {
        "codigo": "X870",
        "valor": "AGRESION CON PLAGUICIDAS, VIVIENDA"
      },
      {
        "codigo": "X871",
        "valor": "AGRESION CON PLAGUICIDAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X872",
        "valor": "AGRESION CON PLAGUICIDAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X873",
        "valor": "AGRESION CON PLAGUICIDAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X874",
        "valor": "AGRESION CON PLAGUICIDAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X875",
        "valor": "AGRESION CON PLAGUICIDAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X876",
        "valor": "AGRESION CON PLAGUICIDAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X877",
        "valor": "AGRESION CON PLAGUICIDAS, GRANJA"
      },
      {
        "codigo": "X878",
        "valor": "AGRESION CON PLAGUICIDAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X879",
        "valor": "AGRESION CON PLAGUICIDAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X88 - AGRESION CON GASES Y VAPORES",
    "detalle": [
      {
        "codigo": "X880",
        "valor": "AGRESION CON GASES Y VAPORES, VIVIENDA"
      },
      {
        "codigo": "X881",
        "valor": "AGRESION CON GASES Y VAPORES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X882",
        "valor": "AGRESION CON GASES Y VAPORES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X883",
        "valor": "AGRESION CON GASES Y VAPORES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X884",
        "valor": "AGRESION CON GASES Y VAPORES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X885",
        "valor": "AGRESION CON GASES Y VAPORES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X886",
        "valor": "AGRESION CON GASES Y VAPORES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X887",
        "valor": "AGRESION CON GASES Y VAPORES, GRANJA"
      },
      {
        "codigo": "X888",
        "valor": "AGRESION CON GASES Y VAPORES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X889",
        "valor": "AGRESION CON GASES Y VAPORES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X89 - AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "X890",
        "valor": "AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "X891",
        "valor": "AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X892",
        "valor": "AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X893",
        "valor": "AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X894",
        "valor": "AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X895",
        "valor": "AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X896",
        "valor": "AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X897",
        "valor": "AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "X898",
        "valor": "AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X899",
        "valor": "AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X90 - AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "X900",
        "valor": "AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "X901",
        "valor": "AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X902",
        "valor": "AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X903",
        "valor": "AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X904",
        "valor": "AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X905",
        "valor": "AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X906",
        "valor": "AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X907",
        "valor": "AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "X908",
        "valor": "AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X909",
        "valor": "AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X91 - AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION",
    "detalle": [
      {
        "codigo": "X910",
        "valor": "AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, VIVIENDA"
      },
      {
        "codigo": "X911",
        "valor": "AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X912",
        "valor": "AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X913",
        "valor": "AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X914",
        "valor": "AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X915",
        "valor": "AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X916",
        "valor": "AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X917",
        "valor": "AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, GRANJA"
      },
      {
        "codigo": "X918",
        "valor": "AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X919",
        "valor": "AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X92 - AGRESION POR AHOGAMIENTO Y SUMERSION",
    "detalle": [
      {
        "codigo": "X920",
        "valor": "AGRESION POR AHOGAMIENTO Y SUMERSION, VIVIENDA"
      },
      {
        "codigo": "X921",
        "valor": "AGRESION POR AHOGAMIENTO Y SUMERSION, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X922",
        "valor": "AGRESION POR AHOGAMIENTO Y SUMERSION, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X923",
        "valor": "AGRESION POR AHOGAMIENTO Y SUMERSION, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X924",
        "valor": "AGRESION POR AHOGAMIENTO Y SUMERSION, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X925",
        "valor": "AGRESION POR AHOGAMIENTO Y SUMERSION, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X926",
        "valor": "AGRESION POR AHOGAMIENTO Y SUMERSION, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X927",
        "valor": "AGRESION POR AHOGAMIENTO Y SUMERSION, GRANJA"
      },
      {
        "codigo": "X928",
        "valor": "AGRESION POR AHOGAMIENTO Y SUMERSION, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X929",
        "valor": "AGRESION POR AHOGAMIENTO Y SUMERSION, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X93 - AGRESION CON DISPARO DE ARMA CORTA",
    "detalle": [
      {
        "codigo": "X930",
        "valor": "AGRESION CON DISPARO DE ARMA CORTA, VIVIENDA"
      },
      {
        "codigo": "X931",
        "valor": "AGRESION CON DISPARO DE ARMA CORTA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X932",
        "valor": "AGRESION CON DISPARO DE ARMA CORTA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X933",
        "valor": "AGRESION CON DISPARO DE ARMA CORTA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X934",
        "valor": "AGRESION CON DISPARO DE ARMA CORTA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X935",
        "valor": "AGRESION CON DISPARO DE ARMA CORTA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X936",
        "valor": "AGRESION CON DISPARO DE ARMA CORTA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X937",
        "valor": "AGRESION CON DISPARO DE ARMA CORTA, GRANJA"
      },
      {
        "codigo": "X938",
        "valor": "AGRESION CON DISPARO DE ARMA CORTA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X939",
        "valor": "AGRESION CON DISPARO DE ARMA CORTA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X94 - AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA",
    "detalle": [
      {
        "codigo": "X940",
        "valor": "AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, VIVIENDA"
      },
      {
        "codigo": "X941",
        "valor": "AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X942",
        "valor": "AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X943",
        "valor": "AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X944",
        "valor": "AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X945",
        "valor": "AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X946",
        "valor": "AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X947",
        "valor": "AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, GRANJA"
      },
      {
        "codigo": "X948",
        "valor": "AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X949",
        "valor": "AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X95 - AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "X950",
        "valor": "AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, VIVIENDA"
      },
      {
        "codigo": "X951",
        "valor": "AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X952",
        "valor": "AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X953",
        "valor": "AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X954",
        "valor": "AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X955",
        "valor": "AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X956",
        "valor": "AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X957",
        "valor": "AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, GRANJA"
      },
      {
        "codigo": "X958",
        "valor": "AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X959",
        "valor": "AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X96 - AGRESION CON MATERIAL EXPLOSIVO",
    "detalle": [
      {
        "codigo": "X960",
        "valor": "AGRESION CON MATERIAL EXPLOSIVO, VIVIENDA"
      },
      {
        "codigo": "X961",
        "valor": "AGRESION CON MATERIAL EXPLOSIVO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X962",
        "valor": "AGRESION CON MATERIAL EXPLOSIVO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X963",
        "valor": "AGRESION CON MATERIAL EXPLOSIVO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X964",
        "valor": "AGRESION CON MATERIAL EXPLOSIVO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X965",
        "valor": "AGRESION CON MATERIAL EXPLOSIVO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X966",
        "valor": "AGRESION CON MATERIAL EXPLOSIVO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X967",
        "valor": "AGRESION CON MATERIAL EXPLOSIVO, GRANJA"
      },
      {
        "codigo": "X968",
        "valor": "AGRESION CON MATERIAL EXPLOSIVO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X969",
        "valor": "AGRESION CON MATERIAL EXPLOSIVO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X97 - AGRESION CON HUMO, FUEGO Y LLAMAS",
    "detalle": [
      {
        "codigo": "X970",
        "valor": "AGRESION CON HUMO, FUEGO Y LLAMAS, VIVIENDA"
      },
      {
        "codigo": "X971",
        "valor": "AGRESION CON HUMO, FUEGO Y LLAMAS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X972",
        "valor": "AGRESION CON HUMO, FUEGO Y LLAMAS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X973",
        "valor": "AGRESION CON HUMO, FUEGO Y LLAMAS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X974",
        "valor": "AGRESION CON HUMO, FUEGO Y LLAMAS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X975",
        "valor": "AGRESION CON HUMO, FUEGO Y LLAMAS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X976",
        "valor": "AGRESION CON HUMO, FUEGO Y LLAMAS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X977",
        "valor": "AGRESION CON HUMO, FUEGO Y LLAMAS, GRANJA"
      },
      {
        "codigo": "X978",
        "valor": "AGRESION CON HUMO, FUEGO Y LLAMAS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X979",
        "valor": "AGRESION CON HUMO, FUEGO Y LLAMAS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X98 - AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES",
    "detalle": [
      {
        "codigo": "X980",
        "valor": "AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, VIVIENDA"
      },
      {
        "codigo": "X981",
        "valor": "AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X982",
        "valor": "AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X983",
        "valor": "AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X984",
        "valor": "AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X985",
        "valor": "AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X986",
        "valor": "AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X987",
        "valor": "AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, GRANJA"
      },
      {
        "codigo": "X988",
        "valor": "AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X989",
        "valor": "AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "X99 - AGRESION CON OBJETO CORTANTE",
    "detalle": [
      {
        "codigo": "X990",
        "valor": "AGRESION CON OBJETO CORTANTE, VIVIENDA"
      },
      {
        "codigo": "X991",
        "valor": "AGRESION CON OBJETO CORTANTE, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "X992",
        "valor": "AGRESION CON OBJETO CORTANTE, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "X993",
        "valor": "AGRESION CON OBJETO CORTANTE, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "X994",
        "valor": "AGRESION CON OBJETO CORTANTE, CALLES Y CARRETERAS"
      },
      {
        "codigo": "X995",
        "valor": "AGRESION CON OBJETO CORTANTE, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "X996",
        "valor": "AGRESION CON OBJETO CORTANTE, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "X997",
        "valor": "AGRESION CON OBJETO CORTANTE, GRANJA"
      },
      {
        "codigo": "X998",
        "valor": "AGRESION CON OBJETO CORTANTE, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "X999",
        "valor": "AGRESION CON OBJETO CORTANTE, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y00 - AGRESION CON OBJETO ROMO O SIN FILO",
    "detalle": [
      {
        "codigo": "Y000",
        "valor": "AGRESION CON OBJETO ROMO O SIN FILO, VIVIENDA"
      },
      {
        "codigo": "Y001",
        "valor": "AGRESION CON OBJETO ROMO O SIN FILO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y002",
        "valor": "AGRESION CON OBJETO ROMO O SIN FILO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y003",
        "valor": "AGRESION CON OBJETO ROMO O SIN FILO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y004",
        "valor": "AGRESION CON OBJETO ROMO O SIN FILO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y005",
        "valor": "AGRESION CON OBJETO ROMO O SIN FILO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y006",
        "valor": "AGRESION CON OBJETO ROMO O SIN FILO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y007",
        "valor": "AGRESION CON OBJETO ROMO O SIN FILO, GRANJA"
      },
      {
        "codigo": "Y008",
        "valor": "AGRESION CON OBJETO ROMO O SIN FILO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y009",
        "valor": "AGRESION CON OBJETO ROMO O SIN FILO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y01 - AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO",
    "detalle": [
      {
        "codigo": "Y010",
        "valor": "AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO, VIVIENDA"
      },
      {
        "codigo": "Y011",
        "valor": "AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y012",
        "valor": "AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y013",
        "valor": "AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y014",
        "valor": "AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y015",
        "valor": "AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y016",
        "valor": "AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y017",
        "valor": "AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO, GRANJA"
      },
      {
        "codigo": "Y018",
        "valor": "AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y019",
        "valor": "AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y02 - AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO",
    "detalle": [
      {
        "codigo": "Y020",
        "valor": "AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO, VIVIENDA"
      },
      {
        "codigo": "Y021",
        "valor": "AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y022",
        "valor": "AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y023",
        "valor": "AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y024",
        "valor": "AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y025",
        "valor": "AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y026",
        "valor": "AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y027",
        "valor": "AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO, GRANJA"
      },
      {
        "codigo": "Y028",
        "valor": "AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y029",
        "valor": "AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y03 - AGRESION POR COLISION DE VEHICULO DE MOTOR",
    "detalle": [
      {
        "codigo": "Y030",
        "valor": "AGRESION POR COLISION DE VEHICULO DE MOTOR, VIVIENDA"
      },
      {
        "codigo": "Y031",
        "valor": "AGRESION POR COLISION DE VEHICULO DE MOTOR, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y032",
        "valor": "AGRESION POR COLISION DE VEHICULO DE MOTOR, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y033",
        "valor": "AGRESION POR COLISION DE VEHICULO DE MOTOR, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y034",
        "valor": "AGRESION POR COLISION DE VEHICULO DE MOTOR, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y035",
        "valor": "AGRESION POR COLISION DE VEHICULO DE MOTOR, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y036",
        "valor": "AGRESION POR COLISION DE VEHICULO DE MOTOR, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y037",
        "valor": "AGRESION POR COLISION DE VEHICULO DE MOTOR, GRANJA"
      },
      {
        "codigo": "Y038",
        "valor": "AGRESION POR COLISION DE VEHICULO DE MOTOR, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y039",
        "valor": "AGRESION POR COLISION DE VEHICULO DE MOTOR, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y04 - AGRESION CON FUERZA CORPORAL",
    "detalle": [
      {
        "codigo": "Y040",
        "valor": "AGRESION CON FUERZA CORPORAL, VIVIENDA"
      },
      {
        "codigo": "Y041",
        "valor": "AGRESION CON FUERZA CORPORAL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y042",
        "valor": "AGRESION CON FUERZA CORPORAL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y043",
        "valor": "AGRESION CON FUERZA CORPORAL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y044",
        "valor": "AGRESION CON FUERZA CORPORAL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y045",
        "valor": "AGRESION CON FUERZA CORPORAL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y046",
        "valor": "AGRESION CON FUERZA CORPORAL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y047",
        "valor": "AGRESION CON FUERZA CORPORAL, GRANJA"
      },
      {
        "codigo": "Y048",
        "valor": "AGRESION CON FUERZA CORPORAL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y049",
        "valor": "AGRESION CON FUERZA CORPORAL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y05 - AGRESION SEXUAL CON FUERZA CORPORAL",
    "detalle": [
      {
        "codigo": "Y050",
        "valor": "AGRESION SEXUAL CON FUERZA CORPORAL, VIVIENDA"
      },
      {
        "codigo": "Y051",
        "valor": "AGRESION SEXUAL CON FUERZA CORPORAL, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y052",
        "valor": "AGRESION SEXUAL CON FUERZA CORPORAL, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y053",
        "valor": "AGRESION SEXUAL CON FUERZA CORPORAL, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y054",
        "valor": "AGRESION SEXUAL CON FUERZA CORPORAL, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y055",
        "valor": "AGRESION SEXUAL CON FUERZA CORPORAL, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y056",
        "valor": "AGRESION SEXUAL CON FUERZA CORPORAL, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y057",
        "valor": "AGRESION SEXUAL CON FUERZA CORPORAL, GRANJA"
      },
      {
        "codigo": "Y058",
        "valor": "AGRESION SEXUAL CON FUERZA CORPORAL, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y059",
        "valor": "AGRESION SEXUAL CON FUERZA CORPORAL, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y06 - NEGLIGENCIA Y ABANDONO",
    "detalle": [
      {
        "codigo": "Y060",
        "valor": "NEGLIGENCIA Y ABANDONO POR ESPOSO O PAREJA"
      },
      {
        "codigo": "Y061",
        "valor": "NEGLIGENCIA Y ABANDONO POR PADRE O MADRE"
      },
      {
        "codigo": "Y062",
        "valor": "NEGLIGENCIA Y ABANDONO POR CONOCIDO O AMIGO"
      },
      {
        "codigo": "Y068",
        "valor": "NEGLIGENCIA Y ABANDONO POR OTRA PERSONA ESPECIFICADA"
      },
      {
        "codigo": "Y069",
        "valor": "NEGLIGENCIA Y ABANDONO POR PERSONA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Y07 - OTROS MALTRATOS",
    "detalle": [
      {
        "codigo": "Y070",
        "valor": "OTROS MALTRATOS POR ESPOSO O PAREJA"
      },
      {
        "codigo": "Y071",
        "valor": "OTROS MALTRATOS POR PADRE O MADRE"
      },
      {
        "codigo": "Y072",
        "valor": "OTROS MALTRATOS POR CONOCIDO O AMIGO"
      },
      {
        "codigo": "Y073",
        "valor": "OTROS MALTRATOS POR AUTORIDADES OFICIALES"
      },
      {
        "codigo": "Y078",
        "valor": "OTROS MALTRATOS POR OTRA PERSONA ESPECIFICADA"
      },
      {
        "codigo": "Y079",
        "valor": "OTROS MALTRATOS POR PERSONA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Y08 - AGRESION POR OTROS MEDIOS ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "Y080",
        "valor": "AGRESION POR OTROS MEDIOS ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "Y081",
        "valor": "AGRESION POR OTROS MEDIOS ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y082",
        "valor": "AGRESION POR OTROS MEDIOS ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y083",
        "valor": "AGRESION POR OTROS MEDIOS ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y084",
        "valor": "AGRESION POR OTROS MEDIOS ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y085",
        "valor": "AGRESION POR OTROS MEDIOS ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y086",
        "valor": "AGRESION POR OTROS MEDIOS ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y087",
        "valor": "AGRESION POR OTROS MEDIOS ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "Y088",
        "valor": "AGRESION POR OTROS MEDIOS ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y089",
        "valor": "AGRESION POR OTROS MEDIOS ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y09 - AGRESION POR MEDIOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "Y090",
        "valor": "AGRESION POR MEDIOS NO ESPECIFICADOS, VIVIENDA"
      },
      {
        "codigo": "Y091",
        "valor": "AGRESION POR MEDIOS NO ESPECIFICADOS, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y092",
        "valor": "AGRESION POR MEDIOS NO ESPECIFICADOS, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y093",
        "valor": "AGRESION POR MEDIOS NO ESPECIFICADOS, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y094",
        "valor": "AGRESION POR MEDIOS NO ESPECIFICADOS, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y095",
        "valor": "AGRESION POR MEDIOS NO ESPECIFICADOS, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y096",
        "valor": "AGRESION POR MEDIOS NO ESPECIFICADOS, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y097",
        "valor": "AGRESION POR MEDIOS NO ESPECIFICADOS, GRANJA"
      },
      {
        "codigo": "Y098",
        "valor": "AGRESION POR MEDIOS NO ESPECIFICADOS, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y099",
        "valor": "AGRESION POR MEDIOS NO ESPECIFICADOS, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y10 - ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRECTICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y100",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y101",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y102",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y103",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y104",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y105",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y106",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y107",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y108",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y109",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y11 - ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HINOPTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y110",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y111",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y112",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y113",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y114",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y115",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y116",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y117",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y118",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y119",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS Y PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y12 - ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS] NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y120",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y121",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y122",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y123",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y124",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y125",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y126",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y127",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y128",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y129",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADOS EN OTRA PARTE, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y13 - ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y130",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y131",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y132",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y133",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y134",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y135",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y136",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y137",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y138",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y139",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y14 - ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS Y LAS NO ESPECIFICADAS DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y140",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y141",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y142",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y143",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y144",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y145",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y146",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y147",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y148",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y149",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y15 - ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y150",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y151",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y152",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y153",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y154",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y155",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y156",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y157",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y158",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y159",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y16 - ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y160",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y161",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y162",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y163",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y164",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y165",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y166",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y167",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y168",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y169",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y17 - ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y170",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y171",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y172",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y173",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y174",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y175",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y176",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y177",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y178",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y179",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y18 - ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y180",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y181",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y182",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y183",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y184",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y185",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y186",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y187",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y188",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y189",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y19 - ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y190",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y191",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y192",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y193",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y194",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y195",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y196",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y197",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y198",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y199",
        "valor": "ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFICADOS, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y20 - AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y200",
        "valor": "AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y201",
        "valor": "AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y202",
        "valor": "AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y203",
        "valor": "AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y204",
        "valor": "AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y205",
        "valor": "AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y206",
        "valor": "AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y207",
        "valor": "AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y208",
        "valor": "AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y209",
        "valor": "AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y21 - AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y210",
        "valor": "AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y211",
        "valor": "AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y212",
        "valor": "AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y213",
        "valor": "AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y214",
        "valor": "AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y215",
        "valor": "AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y216",
        "valor": "AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y217",
        "valor": "AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y218",
        "valor": "AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y219",
        "valor": "AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y22 - DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y220",
        "valor": "DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y221",
        "valor": "DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y222",
        "valor": "DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y223",
        "valor": "DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y224",
        "valor": "DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y225",
        "valor": "DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y226",
        "valor": "DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y227",
        "valor": "DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y228",
        "valor": "DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y229",
        "valor": "DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y23 - DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y230",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y231",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y232",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y233",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y234",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y235",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y236",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y237",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y238",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y239",
        "valor": "DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y24 - DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION",
    "detalle": [
      {
        "codigo": "Y240",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y241",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y242",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y243",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y244",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y245",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y246",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y247",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y248",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y249",
        "valor": "DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y25 - CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y250",
        "valor": "CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y251",
        "valor": "CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y252",
        "valor": "CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y253",
        "valor": "CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y254",
        "valor": "CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y255",
        "valor": "CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y256",
        "valor": "CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y257",
        "valor": "CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y258",
        "valor": "CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y259",
        "valor": "CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y26 - EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y260",
        "valor": "EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y261",
        "valor": "EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y262",
        "valor": "EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y263",
        "valor": "EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y264",
        "valor": "EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y265",
        "valor": "EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y266",
        "valor": "EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y267",
        "valor": "EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y268",
        "valor": "EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y269",
        "valor": "EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y27 - CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y270",
        "valor": "CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y271",
        "valor": "CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y272",
        "valor": "CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y273",
        "valor": "CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y274",
        "valor": "CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y275",
        "valor": "CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y276",
        "valor": "CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y277",
        "valor": "CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y278",
        "valor": "CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y279",
        "valor": "CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y28 - CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y280",
        "valor": "CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y281",
        "valor": "CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y282",
        "valor": "CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y283",
        "valor": "CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y284",
        "valor": "CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y285",
        "valor": "CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y286",
        "valor": "CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y287",
        "valor": "CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y288",
        "valor": "CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y289",
        "valor": "CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y29 - CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y290",
        "valor": "CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y291",
        "valor": "CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y292",
        "valor": "CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y293",
        "valor": "CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y294",
        "valor": "CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y295",
        "valor": "CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y296",
        "valor": "CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y297",
        "valor": "CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y298",
        "valor": "CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y299",
        "valor": "CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y30 - CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y300",
        "valor": "CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y301",
        "valor": "CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y302",
        "valor": "CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y303",
        "valor": "CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y304",
        "valor": "CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y305",
        "valor": "CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y306",
        "valor": "CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y307",
        "valor": "CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y308",
        "valor": "CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y309",
        "valor": "CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y31 - CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y310",
        "valor": "CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y311",
        "valor": "CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y312",
        "valor": "CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y313",
        "valor": "CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y314",
        "valor": "CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y315",
        "valor": "CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y316",
        "valor": "CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y317",
        "valor": "CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y318",
        "valor": "CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y319",
        "valor": "CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y32 - COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y320",
        "valor": "COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y321",
        "valor": "COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y322",
        "valor": "COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y323",
        "valor": "COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y324",
        "valor": "COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y325",
        "valor": "COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y326",
        "valor": "COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y327",
        "valor": "COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y328",
        "valor": "COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y329",
        "valor": "COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y33 - OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y330",
        "valor": "OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y331",
        "valor": "OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y332",
        "valor": "OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y333",
        "valor": "OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y334",
        "valor": "OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y335",
        "valor": "OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y336",
        "valor": "OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y337",
        "valor": "OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y338",
        "valor": "OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y339",
        "valor": "OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y34 - EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y340",
        "valor": "EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA, VIVIENDA"
      },
      {
        "codigo": "Y341",
        "valor": "EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA, INSTITUCION RESIDENCIAL"
      },
      {
        "codigo": "Y342",
        "valor": "EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA, ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS"
      },
      {
        "codigo": "Y343",
        "valor": "EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA, AREAS DE DEPORTE Y ATLETISMO"
      },
      {
        "codigo": "Y344",
        "valor": "EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA, CALLES Y CARRETERAS"
      },
      {
        "codigo": "Y345",
        "valor": "EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA, COMERCIO Y AREA DE SERVICIOS"
      },
      {
        "codigo": "Y346",
        "valor": "EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA, AREA INDUSTRIAL Y DE LA CONSTRUCCION"
      },
      {
        "codigo": "Y347",
        "valor": "EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA, GRANJA"
      },
      {
        "codigo": "Y348",
        "valor": "EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA, OTRO LUGAR ESPECIFICADO"
      },
      {
        "codigo": "Y349",
        "valor": "EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA, LUGAR NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y35 - INTERVENCION LEGAL",
    "detalle": [
      {
        "codigo": "Y350",
        "valor": "INTERVENCION LEGAL CON DISPARO DE ARMA DE FUEGO"
      },
      {
        "codigo": "Y351",
        "valor": "INTERVENCION LEGAL CON EXPLOSIVOS"
      },
      {
        "codigo": "Y352",
        "valor": "INTERVENCION LEGAL CON GAS"
      },
      {
        "codigo": "Y353",
        "valor": "INTERVENCION LEGAL CON OBJETOS ROMOS O SIN FILO"
      },
      {
        "codigo": "Y354",
        "valor": "INTERVENCION LEGAL CON OBJETOS CORTANTES"
      },
      {
        "codigo": "Y355",
        "valor": "EJECUCION LEGAL"
      },
      {
        "codigo": "Y356",
        "valor": "INTERVENCION LEGAL CON OTROS MEDIOS ESPECIFICADOS"
      },
      {
        "codigo": "Y357",
        "valor": "INTERVENCION LEGAL, MEDIOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Y36 - OPERACIONES DE GUERRA",
    "detalle": [
      {
        "codigo": "Y360",
        "valor": "OPERACIONES DE GUERRA CON EXPLOSION DE ARMAMENTO NAVAL"
      },
      {
        "codigo": "Y361",
        "valor": "OPERACIONES DE GUERRA CON DESTRUCCION DE AERONAVE"
      },
      {
        "codigo": "Y362",
        "valor": "OPERACIONES DE GUERRA CON OTRAS EXPLOSIONES Y ESQUIRLAS"
      },
      {
        "codigo": "Y363",
        "valor": "OPERACIONES DE GUERRA CON FUEGO Y SUSTANCIAS INCENDIARIAS Y CALIENTES"
      },
      {
        "codigo": "Y364",
        "valor": "OPERACIONES DE GUERRA CON DISPARO DE ARMA DE FUEGO Y OTRAS FORMAS DE GUERRA CONVENCIONAL"
      },
      {
        "codigo": "Y365",
        "valor": "OPERACIONES DE GUERRA CON ARMAS NUCLEARES"
      },
      {
        "codigo": "Y366",
        "valor": "OPERACIONES DE GUERRA CON ARMAS BIOLOGICAS"
      },
      {
        "codigo": "Y367",
        "valor": "OPERACIONES DE GUERRA CON ARMAS QUIMICAS Y OTRAS FORMAS DE GUERRA NO CONVENCIONAL"
      },
      {
        "codigo": "Y368",
        "valor": "OPERACIONES DE GUERRA QUE OCURREN DESPUES DEL CESE DE HOSTILIDADES"
      },
      {
        "codigo": "Y369",
        "valor": "OPERACION DE GUERRA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Y40 - EFECTOS ADVERSOS DE ANTIBIOTICOS SISTEMICOS",
    "detalle": [
      {
        "codigo": "Y400",
        "valor": "EFECTOS ADVERSOS DE PENICILINAS"
      },
      {
        "codigo": "Y401",
        "valor": "EFECTOS ADVERSOS DE CEFALOSPORINAS Y OTROS ANTIBIOTICOS BETA-LACTAMICOS"
      },
      {
        "codigo": "Y402",
        "valor": "EFECTOS ADVERSOS DEL GRUPO DE CLORAMFENICOL"
      },
      {
        "codigo": "Y403",
        "valor": "EFECTOS ADVERSOS DE LOS MACROLIDOS"
      },
      {
        "codigo": "Y404",
        "valor": "EFECTOS ADVERSOS DE TETRACICLINAS"
      },
      {
        "codigo": "Y405",
        "valor": "EFECTOS ADVERSOS DE AMINOGLUCOSIDOS"
      },
      {
        "codigo": "Y406",
        "valor": "EFECTOS ADVERSOS DE RIFAMICINAS"
      },
      {
        "codigo": "Y407",
        "valor": "EFECTOS ADVERSOS DE ANTIBIOTICOS ANTIMICOTICOS USADOS SISTEMICAMENTE"
      },
      {
        "codigo": "Y408",
        "valor": "EFECTOS ADVERSOS DE OTROS ANTIBIOTICOS SISTEMICOS"
      },
      {
        "codigo": "Y409",
        "valor": "EFECTOS ADVERSOS DE ANTIBIOTICO SISTEMICO NO ESPECIFICADO"
      },
      {
        "codigo": "Y4091",
        "valor": "REACCION ADVERSA LEVE / NO SERIO"
      },
      {
        "codigo": "Y4092",
        "valor": "REACCION ADVERSA MODERADA / SERIO"
      },
      {
        "codigo": "Y4093",
        "valor": "REACCION ADVERSA GRAVE"
      }
    ]
  },
  {
    "grupo": "Y41 - EFECTOS ADVERSOS DE OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICO",
    "detalle": [
      {
        "codigo": "Y410",
        "valor": "EFECTOS ADVERSOS DE SULFONAMIDAS"
      },
      {
        "codigo": "Y411",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTIMICOBACTERIANAS"
      },
      {
        "codigo": "Y4111",
        "valor": "EFECTOS ADVERSOS LEVES A MEDICAMENTOS ANTITUBERCULOSOS"
      },
      {
        "codigo": "Y4112",
        "valor": "EFECTOS ADVERSOS MODERADOS A MEDICAMENTOS ANTITUBERCULOSOS"
      },
      {
        "codigo": "Y4113",
        "valor": "EFECTOS ADVERSOS GRAVES A MEDICAMENTOS ANTITUBERCULOSOS"
      },
      {
        "codigo": "Y412",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTIPALUDICAS Y AGENTES QUE ACTUAN SOBRE OTROS PROTOZOARIOS DE LA SANGRE"
      },
      {
        "codigo": "Y413",
        "valor": "EFECTOS ADVERSOS DE OTRAS DROGAS ANTIPROTOZOARIAS"
      },
      {
        "codigo": "Y414",
        "valor": "EFECTOS ADVERSOS DE ANTIHELMINTICOS"
      },
      {
        "codigo": "Y415",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTIVIRALES"
      },
      {
        "codigo": "Y418",
        "valor": "EFECTOS ADVERSOS DE OTROS ANTIINFECCIOSOS Y ANTIPARASTARIOS SISTEMICOS ESPECIFICADOS"
      },
      {
        "codigo": "Y4181",
        "valor": "REACCION ADVERSA A MEDICAMENTOS ANTICHAGASICOS"
      },
      {
        "codigo": "Y4182",
        "valor": "REACCION ADVERSA A MEDICAMENTOS ANT ILEISHMANIASIS"
      },
      {
        "codigo": "Y4183",
        "valor": "REACCION ADVERSA AL MEDICAMENTO ANTI BARTONELOSIS"
      },
      {
        "codigo": "Y4184",
        "valor": "REACCION ADVERSA A MEDICAMENTOS ANTI FIEBRE AMARILLA"
      },
      {
        "codigo": "Y4185",
        "valor": "REACCION ADVERSA A MEDICAMENTOS ANTI DENGUE"
      },
      {
        "codigo": "Y419",
        "valor": "EFECTOS ADVERSOS DE ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Y42 - EFECTOS ADVERSOS DE HORMONAS Y SUS SUSTITUTOS SINTETICOS Y ANTAGONISTA",
    "detalle": [
      {
        "codigo": "Y420",
        "valor": "EFECTOS ADVERSOS DE GLUCOCORTICOIDES Y ANALOGOS SINTETICOS"
      },
      {
        "codigo": "Y421",
        "valor": "EFECTOS ADVERSOS DE HORMONAS TIROIDEAS Y SUSTITUTOS"
      },
      {
        "codigo": "Y422",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTITIROIDEAS"
      },
      {
        "codigo": "Y423",
        "valor": "EFECTOS ADVERSOS DE DROGAS HIPOGLUCEMIANTES ORALES E INSULINA [ANTIDIABETICAS]"
      },
      {
        "codigo": "Y424",
        "valor": "EFECTOS ADVERSOS DE ANTICONCEPTIVOS ORALES"
      },
      {
        "codigo": "Y4241",
        "valor": "EFECTOS SECUNDARIOS ANTICONCEPTIVOS ORALES COMBINADO"
      },
      {
        "codigo": "Y4242",
        "valor": "EFECTOS SECUNDARIOS ANTICONCEPTIVOS ORALES PROGESTAGENO"
      },
      {
        "codigo": "Y4253",
        "valor": "EFECTOS SECUNDARIOS DEL IMPLANTE"
      },
      {
        "codigo": "Y425",
        "valor": "EFECTOS ADVERSOS DE OTROS ESTROGENOS Y PROGESTAGENOS"
      },
      {
        "codigo": "Y4251",
        "valor": "EFECTOS SECUNDARIOS DE INYECTABLES MENSUAL"
      },
      {
        "codigo": "Y4252",
        "valor": "EFECTOS SECUNDARIOS DE INYECTABLES TRIMESTRAL"
      },
      {
        "codigo": "Y426",
        "valor": "EFECTOS ADVERSOS DE ANTIGONADOTROPINAS, ANTIESTROGENOS Y ANTIANDROGENOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y427",
        "valor": "EFECTOS ADVERSOS DE ANDROGENOS Y CONGENERES ANABOLICOS"
      },
      {
        "codigo": "Y428",
        "valor": "EFECTOS ADVERSOS DE OTRAS HORMONAS Y SUS SUSTITUTOS SINTETICOS Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "Y429",
        "valor": "EFECTOS ADVERSOS DE OTRAS HORMONAS ANTAGONISTAS Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Y43 - EFECTOS ADVERSOS DE AGENTES SISTEMICOS PRIMARIOS",
    "detalle": [
      {
        "codigo": "Y430",
        "valor": "EFECTOS ADVERSOS DE ANTIALERGICOS Y ANTIEMETICOS"
      },
      {
        "codigo": "Y431",
        "valor": "EFECTOS ADVERSOS DE ANTIMETABOLITOS ANTINEOPLASICOS"
      },
      {
        "codigo": "Y432",
        "valor": "EFECTOS ADVERSOS DE PRODUCTOS NATURALES ANTINEOPLASICOS"
      },
      {
        "codigo": "Y433",
        "valor": "EFECTOS ADVERSOS DE OTRAS DROGAS ANTINEOPLASICAS"
      },
      {
        "codigo": "Y434",
        "valor": "EFECTOS ADVERSOS DE AGENTES INMUNOSUPRESORES"
      },
      {
        "codigo": "Y435",
        "valor": "EFECTOS ADVERSOS DE AGENTES ACIDIFICANTES Y ALCALINIZANTES"
      },
      {
        "codigo": "Y436",
        "valor": "EFECTOS ADVERSOS DE ENZIMAS NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Y438",
        "valor": "EFECTOS ADVERSOS DE OTROS AGENTES SISTEMICOS PRIMARIOS NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y439",
        "valor": "EFECTOS ADVERSOS DE AGENTE SISTEMICO PRIMARIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y44 - EFECTOS ADVERSOS DE AGENTES QUE AFECTAN PRIMARIAMENTE LOS CONSTITUYENTES DE LA SANGRE",
    "detalle": [
      {
        "codigo": "Y440",
        "valor": "EFECTOS ADVERSOS DE PREPARACIONES CON HIERRO Y OTROS PREPARADOS CONTRA LA ANEMIA HIPOCROMICA"
      },
      {
        "codigo": "Y441",
        "valor": "EFECTOS ADVERSOS DE VITAMINA B12, ACIDO FOLICO Y OTROS PREPARADOS CONTRA LA ANEMIA MEGALOBLASTICA"
      },
      {
        "codigo": "Y442",
        "valor": "EFECTOS ADVERSOS DE ANTICOAGULANTES"
      },
      {
        "codigo": "Y443",
        "valor": "EFECTOS ADVERSOS DE ANTAGONISTAS DE ANTICOAGULANTES, VITAMINA K Y OTROS COAGULANTES"
      },
      {
        "codigo": "Y444",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTITROMBOTICAS [INHIBIDORAS DE LA AGREGACION PLAQUETARIA]"
      },
      {
        "codigo": "Y445",
        "valor": "EFECTOS ADVERSOS DE DROGAS TROMBOLITICAS"
      },
      {
        "codigo": "Y446",
        "valor": "EFECTOS ADVERSOS DE SANGRE NATURAL Y PRODUCTOS SANGUINEOS"
      },
      {
        "codigo": "Y447",
        "valor": "EFECTOS ADVERSOS DE LOS SUSTITUTOS DEL PLASMA"
      },
      {
        "codigo": "Y449",
        "valor": "EFECTOS ADVERSOS DE OTROS AGENTES QUE AFECTAN LOS CONSTITUYENTES DE LA SANGRE, Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Y45 - EFECTOS ADVERSOS DE DROGAS ANALGESICAS, ANTIPIRETICAS Y ANTIINFLAMATORIAS",
    "detalle": [
      {
        "codigo": "Y450",
        "valor": "EFECTOS ADVERSOS DE OPIACEOS Y ANALGESICOS RELACIONADOS"
      },
      {
        "codigo": "Y451",
        "valor": "EFECTOS ADVERSOS DE SALICILATOS"
      },
      {
        "codigo": "Y452",
        "valor": "EFECTOS ADVERSOS DE DERIVADOS DEL ACIDO PROPIONICO"
      },
      {
        "codigo": "Y453",
        "valor": "EFECTOS ADVERSOS DE OTRAS DROGAS ANTIINFLAMATORIAS NO ESTEROIDES [DAINE]"
      },
      {
        "codigo": "Y454",
        "valor": "EFECTOS ADVERSOS DE LOS ANTIRREUMATICOS"
      },
      {
        "codigo": "Y455",
        "valor": "EFECTOS ADVERSOS DE LOS DERIVADOS DEL 4-AMINOFENOL"
      },
      {
        "codigo": "Y458",
        "valor": "EFECTOS ADVERSOS DE OTROS ANALGESICOS Y ANTIPIRETICOS"
      },
      {
        "codigo": "Y459",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANALGESICAS, ANTIPIRETICAS Y ANTIINFLAMATORIAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Y46 - EFECTOS ADVERSOS DE DROGAS ANTIEPILEPTICAS Y ANTIPARKINSONIANAS",
    "detalle": [
      {
        "codigo": "Y460",
        "valor": "EFECTOS ADVERSOS DE SUCCINAMIDAS"
      },
      {
        "codigo": "Y461",
        "valor": "EFECTOS ADVERSOS DE OXAZOLIDINADIONAS"
      },
      {
        "codigo": "Y462",
        "valor": "EFECTOS ADVERSOS DE DERIVADOS DE LA HIDANTOINA"
      },
      {
        "codigo": "Y463",
        "valor": "EFECTOS ADVERSOS DE DESOXIBARBITURICOS"
      },
      {
        "codigo": "Y464",
        "valor": "EFECTOS ADVERSOS DE IMINOESTILBENOS"
      },
      {
        "codigo": "Y465",
        "valor": "EFECTOS ADVERSOS DEL ACIDO VALPROICO"
      },
      {
        "codigo": "Y466",
        "valor": "EFECTOS ADVERSOS DE OTROS ANTIEPILEPTICOS, Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "Y467",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTIPARKINSONIANAS"
      },
      {
        "codigo": "Y468",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTIESPASTICAS"
      }
    ]
  },
  {
    "grupo": "Y47 - EFECTOS ADVERSOS DE DROGAS SEDANTES, HIPNOTICAS Y ANSIOLITICAS",
    "detalle": [
      {
        "codigo": "Y470",
        "valor": "EFECTOS ADVERSOS DE BARBITURICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y471",
        "valor": "EFECTOS ADVERSOS DE BENZODIAZEPINAS"
      },
      {
        "codigo": "Y472",
        "valor": "EFECTOS ADVERSOS DE DERIVADOS CLORALES"
      },
      {
        "codigo": "Y473",
        "valor": "EFECTOS ADVERSOS DE PARALDEHIDO"
      },
      {
        "codigo": "Y474",
        "valor": "EFECTOS ADVERSOS DE COMPUESTOS DEL BROMO"
      },
      {
        "codigo": "Y475",
        "valor": "EFECTOS ADVERSOS DE MEZCLAS SEDANTES E HIPNOTICAS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y478",
        "valor": "EFECTOS ADVERSOS DE OTRAS DROGAS SEDANTES, HIPNOTICAS Y ANSIOLITICAS"
      },
      {
        "codigo": "Y479",
        "valor": "EFECTOS ADVERSOS DE DROGAS SEDANTES, HIPNOTICAS Y ANSIOLITICAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Y48 - EFECTOS ADVERSOS DE GASES ANESTESICOS Y TERAPEUTICOS",
    "detalle": [
      {
        "codigo": "Y480",
        "valor": "EFECTOS ADVERSOS DE GASES ANESTESICOS POR INHALACION"
      },
      {
        "codigo": "Y481",
        "valor": "EFECTOS ADVERSOS DE GASES ANESTESICOS PARENTERALES"
      },
      {
        "codigo": "Y482",
        "valor": "EFECTOS ADVERSOS DE OTROS GASES ANESTESICOS GENERALES, Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "Y483",
        "valor": "EFECTOS ADVERSOS DE GASES ANESTESICOS LOCALES"
      },
      {
        "codigo": "Y484",
        "valor": "EFECTOS ADVERSOS DE ANESTESICOS NO ESPECIFICADOS"
      },
      {
        "codigo": "Y485",
        "valor": "EFECTOS ADVERSOS DE GASES TERAPEUTICOS"
      }
    ]
  },
  {
    "grupo": "Y49 - EFECTOS ADVERSOS DE DROGAS PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Y490",
        "valor": "EFECTOS ADVERSOS DE ANTIDEPRESIVOS TRICICLICOS Y TETRACICLICOS"
      },
      {
        "codigo": "Y491",
        "valor": "EFECTOS ADVERSOS DE ANTIDEPRESIVOS INHIBIDORES DE LA MONOAMINOOXIDASA"
      },
      {
        "codigo": "Y492",
        "valor": "EFECTOS ADVERSOS DE OTROS ANTIDEPRESIVOS, Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "Y493",
        "valor": "EFECTOS ADVERSOS DE ANTIPSICOTICOS Y NEUROLEPTICOS FENOTIAZINICOS"
      },
      {
        "codigo": "Y494",
        "valor": "EFECTOS ADVERSOS DE NEUROLEPTICOS DE LA BUTIROFENONA Y TIOXANTINA"
      },
      {
        "codigo": "Y495",
        "valor": "EFECTOS ADVERSOS DE OTROS ANTIPSICOTICOS Y NEUROLEPTICOS"
      },
      {
        "codigo": "Y496",
        "valor": "EFECTOS ADVERSOS DE PSICODISLEPTICOS [ALUCINOGENOS]"
      },
      {
        "codigo": "Y497",
        "valor": "EFECTOS ADVERSOS DE PSICOESTIMULANTES CON ABUSO POTENCIAL"
      },
      {
        "codigo": "Y498",
        "valor": "EFECTOS ADVERSOS DE OTRAS DROGAS PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Y499",
        "valor": "EFECTOS ADVERSOS DE DROGAS PSICOTROPICAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Y50 - EFECTOS ADVERSOS DE ESTIMULANTES DEL SISTEMA NERVIOSO CENTRAL, NO CLASIFICADOS EN OTRAS PARTE",
    "detalle": [
      {
        "codigo": "Y500",
        "valor": "EFECTOS ADVERSOS DE ANALEPTICOS"
      },
      {
        "codigo": "Y501",
        "valor": "EFECTOS ADVERSOS DE ANTAGONISTAS DE OPIACEOS"
      },
      {
        "codigo": "Y502",
        "valor": "EFECTOS ADVERSOS DE METILXANTINAS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y508",
        "valor": "EFECTOS ADVERSOS DE OTROS ESTIMULANTES DEL SISTEMA NERVIOSO CENTRAL"
      },
      {
        "codigo": "Y509",
        "valor": "EFECTOS ADVERSOS DE ESTIMULANTE NO ESPECIFICADO DEL SISTEMA NERVIOSO CENTRAL"
      }
    ]
  },
  {
    "grupo": "Y51 - EFECTOS ADVERSOS DE DROGAS QUE AFECTAN PRIMARIAMENTE EL SISTEMA NERVIOSO",
    "detalle": [
      {
        "codigo": "Y510",
        "valor": "EFECTOS ADVERSOS DE AGENTES ANTICOLINESTERASA"
      },
      {
        "codigo": "Y511",
        "valor": "EFECTOS ADVERSOS DE OTROS PARASIMPATICOMIMETICOS [COLINERGICOS]"
      },
      {
        "codigo": "Y512",
        "valor": "EFECTOS ADVERSOS DE DROGAS BLOQUEADORAS GANGLIONARES, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Y513",
        "valor": "EFECTOS ADVERSOS DE PARASIMPATICOLITICOS [ANTICOLINERGICOS Y ANTIMUSCARINICOS] Y ESPASMOLITICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y514",
        "valor": "EFECTOS ADVERSOS DE AGONISTAS [ESTIMULANTES] PREDOMINANTEMENTE ALFA-ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y515",
        "valor": "EFECTOS ADVERSOS DE AGONISTAS [ESTIMULANTES] PREDOMINANTEMENTE BETA-ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y516",
        "valor": "EFECTOS ADVERSOS DE ANTAGONISTAS [BLOQUEADORES] ALFA-ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y517",
        "valor": "EFECTOS ADVERSOS DE ANTAGONISTAS [BLOQUEADORES] BETA-ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y518",
        "valor": "EFECTOS ADVERSOS DE AGENTES BLOQUEADORES NEURO-ADRENERGICOS QUE ACTUAN CENTRALMENTE, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y519",
        "valor": "EFECTOS ADVERSOS OTRAS DROGAS QUE AFECTAN PRIMARIAMENTE EL SISTEMA NERVIOSO AUTONOMO, Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Y52 - EFECTOS ADVERSOS DE AGENTES QUE AFECTAN PRIMARIAMENTE EL SISTEMA CARDIOVACULAR",
    "detalle": [
      {
        "codigo": "Y520",
        "valor": "EFECTOS ADVERSOS DE GLUCOSIDOS CARDIOTONICOS Y DROGAS DE ACCION SIMILAR"
      },
      {
        "codigo": "Y521",
        "valor": "EFECTOS ADVERSOS DE BLOQUEADORES DEL CANAL DEL CALCIO"
      },
      {
        "codigo": "Y522",
        "valor": "EFECTOS ADVERSOS DE OTRAS DROGAS ANTIARRITMICAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Y523",
        "valor": "EFECTOS ADVERSOS DE VASODILATADORES CORONARIOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y524",
        "valor": "EFECTOS ADVERSOS DE INHIBIDORES DE ENZIMA CONVERTIDORA ANGIOTENSINA"
      },
      {
        "codigo": "Y525",
        "valor": "EFECTOS ADVERSOS DE OTRAS DROGAS ANTIHIPERTENCIVAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Y526",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTIHIPERLIPIDEMICAS Y ANTIARTERIOSCLEROTICAS"
      },
      {
        "codigo": "Y527",
        "valor": "EFECTOS ADVERSOS DE VASODILATADORES PERIFERICOS"
      },
      {
        "codigo": "Y528",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTIVARICOSAS, INCLUSIVE AGENTES ESCLEROSANTES"
      },
      {
        "codigo": "Y529",
        "valor": "EFECTOS ADVERSOS OTROS AGENTES QUE AFECTAN PRIMARIAMENTE EL SISTEMA CARDIOVASCULAR, Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Y53 - EFECTOS ADVERSOS DE AGENTES QUE AFECTAN PRIMARIAMENTE EL SISTEMA GASTROINTESTINAL",
    "detalle": [
      {
        "codigo": "Y530",
        "valor": "EFECTOS ADVERSOS DE BLOQUEADORES DE LOS RECEPTORES H2 DE HISTAMINA"
      },
      {
        "codigo": "Y531",
        "valor": "EFECTOS ADVERSOS OTRAS DROGAS ANTIACIDAS E INHIBIDORAS DE LA SECRECION GASTRICA"
      },
      {
        "codigo": "Y532",
        "valor": "EFECTOS ADVERSOS DE LAXANTES ESTIMULANTES"
      },
      {
        "codigo": "Y533",
        "valor": "EFECTOS ADVERSOS DE LAXANTES SALINOS Y OSMOTICOS"
      },
      {
        "codigo": "Y534",
        "valor": "EFECTOS ADVERSOS DE OTROS LAXANTES"
      },
      {
        "codigo": "Y535",
        "valor": "EFECTOS ADVERSOS DE DIGESTIVOS"
      },
      {
        "codigo": "Y536",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTIDIARREICAS"
      },
      {
        "codigo": "Y537",
        "valor": "EFECTOS ADVERSOS DE EMETICOS"
      },
      {
        "codigo": "Y538",
        "valor": "EFECTOS ADVERSOS DE OTROS AGENTES QUE AFECTAN PRIMARIAMENTE AL SISTEMA GASTROINTESTINAL"
      },
      {
        "codigo": "Y539",
        "valor": "EFECTOS ADVERSOS DE OTROS AGENTES QUE AFECTAN EL SISTEMA GASTROINTESTINAL, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Y54 - EFECTOS ADVERSOS DE AGENTES QUE AFECTAN PRIMARIAMENTE EL EQUILIBRIO HIDRICO Y METABILISMO MINERAL Y DEL ACIDO URICO",
    "detalle": [
      {
        "codigo": "Y540",
        "valor": "EFECTOS ADVERSOS DE MINERALOCORTICOIDES"
      },
      {
        "codigo": "Y541",
        "valor": "EFECTOS ADVERSOS DE LOS BLOQUEADORES DE MINERALOCORTICOIDES [ANTAGONISTAS DE LA ALDOSTERONA]"
      },
      {
        "codigo": "Y542",
        "valor": "EFECTOS ADVERSOS DE LOS INHIBIDORES DE LA ANHIDRASA CARBONICA"
      },
      {
        "codigo": "Y543",
        "valor": "EFECTOS ADVERSOS DE LOS DERIVADOS DE LA BENZOTIADIAZINA"
      },
      {
        "codigo": "Y544",
        "valor": "EFECTOS ADVERSOS DE DIURETICOS DE ASA [HIGH-CEILING]"
      },
      {
        "codigo": "Y545",
        "valor": "EFECTOS ADVERSOS DE OTROS DIURETICOS"
      },
      {
        "codigo": "Y546",
        "valor": "EFECTOS ADVERSOS DE AGENTES ELECTROLITICOS, CALORICOS Y DEL EQUILIBRIO HIDRICO"
      },
      {
        "codigo": "Y547",
        "valor": "EFECTOS ADVERSOS DE AGENTES QUE AFECTAN LA CALCIFICACION"
      },
      {
        "codigo": "Y548",
        "valor": "EFECTOS ADVERSOS DE AGENTES QUE AFECTAN EL METABOLISMO DEL ACIDO URICO"
      },
      {
        "codigo": "Y549",
        "valor": "EFECTOS ADVERSOS DE SALES MINERALES, NO CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y55 - EFECTOS ADVERSOS DE AGENTES QUE ACTUAN PRIMARIAMENTE SOBRE LOS MUSCULO LISOS Y ESTRIADOS Y SOBRE EL SISTEMA RESPIRATORIO",
    "detalle": [
      {
        "codigo": "Y550",
        "valor": "EFECTOS ADVERSOS DE DROGAS OXITOCICAS"
      },
      {
        "codigo": "Y551",
        "valor": "EFECTOS ADVERSOS DE RELAJANTES DE LOS MUSCULOS ESTRIADOS [AGENTES BLOQUEADORES NEUROMUSCULARES]"
      },
      {
        "codigo": "Y552",
        "valor": "EFECTOS ADVERSOS DE OTROS AGENTES QUE ACTUAN PRIMARIAMENTE SOBRE LOS MUSCULOS, Y LOS NO ESPECIFICADOS"
      },
      {
        "codigo": "Y553",
        "valor": "EFECTOS ADVERSOS DE ANTITUSIGENOS"
      },
      {
        "codigo": "Y554",
        "valor": "EFECTOS ADVERSOS DE EXPECTORANTES"
      },
      {
        "codigo": "Y555",
        "valor": "EFECTOS ADVERSOS DE DROGAS CONTRA EL RESFRIADO COMUN"
      },
      {
        "codigo": "Y556",
        "valor": "EFECTOS ADVERSOS DE ANTIASMATICOS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y557",
        "valor": "EFECTOS ADVERSOS DE OTROS AGENTES QUE ACTUAN PRIMARIAMENTE SOBRE EL SISTEMA RESPIRATORIO, Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Y56 - EFECTOS ADVERSOS DE AGENTES TOPICOS QUE AFECTAN PRIMARIAMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS, Y DROGAS OFTALMOLOGICAS, OTORRINOLARINGOLOGICAS Y DENTALES",
    "detalle": [
      {
        "codigo": "Y560",
        "valor": "EFECTOS ADVERSOS DE DROGAS ANTIMICOTICAS, ANTIINFECCIOSAS, Y ANTIINFLAMATORIAS DE USO LOCAL, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Y561",
        "valor": "EFECTOS ADVERSOS DE ANTIPRURIGINOSOS"
      },
      {
        "codigo": "Y562",
        "valor": "EFECTOS ADVERSOS DE ASTRINGENTES Y DETERGENTES LOCALES"
      },
      {
        "codigo": "Y563",
        "valor": "EFECTOS ADVERSOS DE EMOLIENTES, DEMULCENTES Y PROTECTORES"
      },
      {
        "codigo": "Y564",
        "valor": "EFECTOS ADVERSOS DE DROGAS Y PREPARADOS QUERATOLITICOS, QUERATOPLASTICOS Y OTROS PARA EL TRATAMIENTO DEL CABELLO"
      },
      {
        "codigo": "Y565",
        "valor": "EFECTOS ADVERSOS DE DROGAS Y PREPARADOS OFTALMOLOGICOS"
      },
      {
        "codigo": "Y566",
        "valor": "EFECTOS ADVERSOS DE DROGAS Y PREPARADOS OTORRINOLARINGOLOGICOS"
      },
      {
        "codigo": "Y567",
        "valor": "EFECTOS ADVERSOS DE DROGAS DENTALES, DE APLICACION TOPICA"
      },
      {
        "codigo": "Y568",
        "valor": "EFECTOS ADVERSOS DE OTROS AGENTES TOPICOS"
      },
      {
        "codigo": "Y569",
        "valor": "EFECTOS ADVERSOS DE OTROS AGENTES TOPICOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Y57 - EFECTOS ADVERSOS DE OTRAS DROGAS Y MEDICAMENTOS, Y LOS NO ESPECIFICADOS",
    "detalle": [
      {
        "codigo": "Y570",
        "valor": "EFECTOS ADVERSOS DE DEPRESORES DEL APETITO [ANOREXICOS]"
      },
      {
        "codigo": "Y571",
        "valor": "EFECTOS ADVERSOS DE DROGAS LIPOTROPICAS"
      },
      {
        "codigo": "Y572",
        "valor": "EFECTOS ADVERSOS DE ANTIDOTOS Y AGENTES QUELANTES, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Y573",
        "valor": "EFECTOS ADVERSOS DE DISUASIVOS DEL ALCOHOL"
      },
      {
        "codigo": "Y574",
        "valor": "EFECTOS ADVERSOS DE EXCIPIENTES FARMACEUTICOS"
      },
      {
        "codigo": "Y575",
        "valor": "EFECTOS ADVERSOS DE MEDIOS DE CONTRASTE PARA RAYOS X"
      },
      {
        "codigo": "Y576",
        "valor": "EFECTOS ADVERSOS DE OTROS AGENTES DIAGNOSTICOS"
      },
      {
        "codigo": "Y577",
        "valor": "EFECTOS ADVERSOS DE VITAMINAS, NO CLASIFICADAS EN OTRA PARTE"
      },
      {
        "codigo": "Y578",
        "valor": "EFECTOS ADVERSOS DE OTRAS DROGAS Y MEDICAMENTOS"
      },
      {
        "codigo": "Y579",
        "valor": "EFECTOS ADVERSOS DE DROGAS O MEDICAMENTOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Y58 - EFECTOS ADVERSOS DE VACUNAS BACTERIANAS",
    "detalle": [
      {
        "codigo": "Y580",
        "valor": "EFECTOS ADVERSOS DE LA VACUNA BCG"
      },
      {
        "codigo": "Y581",
        "valor": "EFECTOS ADVERSOS DE LA VACUNA TIFOIDEA Y PARATIFOIDEA"
      },
      {
        "codigo": "Y582",
        "valor": "EFECTOS ADVERSOS DE LA VACUNA CONTRA EL COLERA"
      },
      {
        "codigo": "Y583",
        "valor": "EFECTOS ADVERSOS DE LA VACUNA CONTRA LA PESTE"
      },
      {
        "codigo": "Y584",
        "valor": "EFECTOS ADVERSOS DE LA VACUNA CONTRA EL TETANOS"
      },
      {
        "codigo": "Y585",
        "valor": "EFECTOS ADVERSOS DE LA VACUNA CONTRA LA DIFTERIA"
      },
      {
        "codigo": "Y586",
        "valor": "EFECTOS ADVERSOS DE LA VACUNA CONTRA TOS FERINA, INCLUSIVE COMBINACIONES CON COMPONENTE PERTUSIS"
      },
      {
        "codigo": "Y588",
        "valor": "EFECTOS ADVERSOS DE VACUNAS BACTERIANAS MIXTAS, EXCEPTO COMBINACIONES CON UN COMPONENTE PERTUSIS"
      },
      {
        "codigo": "Y589",
        "valor": "EFECTOS ADVERSOS DE OTRAS VACUNAS BACTERIANAS, Y LAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Y59 - EFECTOS ADVERSOS DE OTRAS VACUNAS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPECIFICADAS",
    "detalle": [
      {
        "codigo": "Y590",
        "valor": "EFECTOS ADVERSOS DE VACUNAS VIRALES"
      },
      {
        "codigo": "Y5901",
        "valor": "EFECTOS ADVERSOS A LA VACUNA ANTIPOLIOMIELITICA"
      },
      {
        "codigo": "Y5902",
        "valor": "EFECTOS ADVERSOS A LA VACUNA ANTISARAMPIONOSA"
      },
      {
        "codigo": "Y5903",
        "valor": "EFECTOS ADVERSOS A LA VACUNA ANTIEPATITIS VIRAL B"
      },
      {
        "codigo": "Y5904",
        "valor": "EFECTOS ADVERSOS DE VACUNA ANTIRRABICA"
      },
      {
        "codigo": "Y5905",
        "valor": "EFECTOS ADVERSOS A LA VACUNA ANTIAMARILICA"
      },
      {
        "codigo": "Y5906",
        "valor": "EFECTOS ADVERSOS A LA VACUNA DIFTERIA, TETANO"
      },
      {
        "codigo": "Y5907",
        "valor": "EFECTOS ADVERSOS DE VACUNA SARAMPION RUBEOLA"
      },
      {
        "codigo": "Y5908",
        "valor": "EFECTOS ADVERSOS DE VACUNA SARAMPION PAPERA RUBEOLA"
      },
      {
        "codigo": "Y591",
        "valor": "EFECTOS ADVERSOS DE VACUNAS CONTRA RICKETTSSIAS"
      },
      {
        "codigo": "Y592",
        "valor": "EFECTOS ADVERSOS DE VACUNAS ANTIPROTOZOARIAS"
      },
      {
        "codigo": "Y593",
        "valor": "EFECTOS ADVERSOS DE LA INMUNOGLOBULINA"
      },
      {
        "codigo": "Y598",
        "valor": "EFECTOS ADVERSOS DE OTRAS VACUNAS Y SUSTANCIAS BIOLOGICAS ESPECIFICADAS"
      },
      {
        "codigo": "Y599",
        "valor": "EFECTOS ADVERSOS DE VACUNAS O SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Y60 - CORTE, PUNCION, PERFORACION O HEMORRAGIA NO INTENCIONAL DURANTE LA ATENCION MEDICA Y QUIRURGICA",
    "detalle": [
      {
        "codigo": "Y600",
        "valor": "INCIDENTE DURANTE OPERACION QUIRURGICA"
      },
      {
        "codigo": "Y601",
        "valor": "INCIDENTE DURANTE INFUSION O TRANSFUSION"
      },
      {
        "codigo": "Y602",
        "valor": "INCIDENTE DURANTE DIALISIS RENAL U OTRA PERFUCION"
      },
      {
        "codigo": "Y603",
        "valor": "INCIDENTE DURANTE INYECCION O INMUNIZACION"
      },
      {
        "codigo": "Y604",
        "valor": "INCIDENTE DURANTE EXAMEN ENDOSCOPICO"
      },
      {
        "codigo": "Y605",
        "valor": "INCIDENTE DURANTE CATETERIZACION CARDIACA"
      },
      {
        "codigo": "Y606",
        "valor": "INCIDENTE DURANTE ASPIRACION, PUNCION Y OTRA CATETERIZACION"
      },
      {
        "codigo": "Y607",
        "valor": "INCIDENTE DURANTE ADMINISTRACION DE ENEMA"
      },
      {
        "codigo": "Y608",
        "valor": "INCIDENTE DURANTE OTRAS ATENCIONES MEDICAS Y QUIRURGICAS"
      },
      {
        "codigo": "Y609",
        "valor": "INCIDENTE DURANTE ATENCION MEDICA Y QUIRURGICA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Y61 - OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE LA ATENCION MEDICA Y QUIRURGICA",
    "detalle": [
      {
        "codigo": "Y610",
        "valor": "OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE OPERACION QUIRURGICA"
      },
      {
        "codigo": "Y611",
        "valor": "OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE INFUSION O TRANSFUSION"
      },
      {
        "codigo": "Y612",
        "valor": "OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE DIALISIS RENAL U OTRA PERFUSION"
      },
      {
        "codigo": "Y613",
        "valor": "OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE INYECCION O INMUNIZACION"
      },
      {
        "codigo": "Y614",
        "valor": "OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE EXAMEN ENDOSCOPICO"
      },
      {
        "codigo": "Y615",
        "valor": "OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE CATETERIZACION CARDIACA"
      },
      {
        "codigo": "Y616",
        "valor": "OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE ASPIRACION, PUNCION Y OTRA CATETERIZACION"
      },
      {
        "codigo": "Y617",
        "valor": "OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE REMOCION DE CATETER O TAPONAMIENTO"
      },
      {
        "codigo": "Y618",
        "valor": "OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE OTRAS ATENCIONES MEDICAS Y QUIRURGICAS"
      },
      {
        "codigo": "Y619",
        "valor": "OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE ATENCION MEDICA Y QUIRURGICA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Y62 - FALLAS EN LA ESTERILIZACION DURANTE LA ATENCION MEDICA Y QUIRURGICA",
    "detalle": [
      {
        "codigo": "Y620",
        "valor": "FALLAS EN LA ESTERILIZACION DURANTE OPERACION QUIRURGICA"
      },
      {
        "codigo": "Y621",
        "valor": "FALLAS EN LA ESTERILIZACION DURANTE INFUSION O TRANSFUSION"
      },
      {
        "codigo": "Y622",
        "valor": "FALLAS EN LA ESTERILIZACION DURANTE DIALISIS RENAL U OTRA PERFUSION"
      },
      {
        "codigo": "Y623",
        "valor": "FALLAS EN LA ESTERILIZACION DURANTE INYECCION O INMUNIZACION"
      },
      {
        "codigo": "Y624",
        "valor": "FALLAS EN LA ESTERILIZACION DURANTE EXAMEN ENDOSCOPICO"
      },
      {
        "codigo": "Y625",
        "valor": "FALLAS EN LA ESTERILIZACION DURANTE CATETERIZACION CARDIACA"
      },
      {
        "codigo": "Y626",
        "valor": "FALLAS EN LA ESTERILIZACION DURANTE ASPIRACION, PUNCION Y OTRA CATETERIZACION"
      },
      {
        "codigo": "Y628",
        "valor": "FALLAS EN LA ESTERILIZACION DURANTE OTRAS ATENCIONES MEDICAS Y QUIRURGICAS"
      },
      {
        "codigo": "Y629",
        "valor": "FALLAS EN LA ESTERILIZACION DURANTE ATENCION MEDICA Y QUIRURGICA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Y63 - FALLA EN LA DOSIFICACION DURANTE LA ATENCION MEDICA Y QUIRURGICA",
    "detalle": [
      {
        "codigo": "Y630",
        "valor": "EXCESIVA CANTIDAD DE SANGRE U OTRO LIQUIDO ADMINISTRADO DURANTE UNA INFUSION O TRANSFUSION"
      },
      {
        "codigo": "Y631",
        "valor": "DILUCION INCORRECTA DE LIQUIDO DURANTE UNA INFUSION"
      },
      {
        "codigo": "Y632",
        "valor": "SOBREDOSIS DE RADIACION ADMINISTRADA DURANTE TERAPIA"
      },
      {
        "codigo": "Y633",
        "valor": "EXPOSICION INADVERTIDA DEL PACIENTE A RADIACION DURANTE ATENCION MEDICA"
      },
      {
        "codigo": "Y634",
        "valor": "FALLA EN LA DOSIFICACION EN ELECTROCHOQUE O EN CHOQUE INSULINICO"
      },
      {
        "codigo": "Y635",
        "valor": "FALLA EN EL CONTROL DE TEMPERATURA, EN TAPONAMIENTOS Y APLICACIONES LOCALES"
      },
      {
        "codigo": "Y636",
        "valor": "NO ADMINISTRACION DE DROGAS, MEDICAMENTOS O SUSTANCIAS BIOLOGICAS NECESARIAS"
      },
      {
        "codigo": "Y638",
        "valor": "FALLA EN LA DOSIFICACION DURANTE OTRAS ATENCIONES MEDICAS Y QUIRURGICAS"
      },
      {
        "codigo": "Y639",
        "valor": "FALLA EN LA DOSIFICACION DURANTE ATENCION MEDICA Y QUIRURGICA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Y64 - MEDICAMENTOS O SUSTANCIAS BIOLOGICAS CONTAMINADOS",
    "detalle": [
      {
        "codigo": "Y640",
        "valor": "MEDICAMENTO O SUSTANCIA BIOLOGICA CONTAMINADO EN INFUSION O TRANSFUSION"
      },
      {
        "codigo": "Y641",
        "valor": "MEDICAMENTO O SUSTANCIA BIOLOGICA CONTAMINADO, INYECTADO O USADO PARA INMUNIZACION"
      },
      {
        "codigo": "Y648",
        "valor": "MEDICAMENTO O SUSTANCIA BIOLOGICA CONTAMINADO, ADMINISTRADO POR OTROS MEDIOS"
      },
      {
        "codigo": "Y649",
        "valor": "MEDICAMENTO O SUSTANCIA BIOLOGICA CONTAMINADO, ADMINISTRADO POR MEDIOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Y65 - OTROS INCIDENTES DURANTE LA ATENCION MEDICA Y QUIRURGICA",
    "detalle": [
      {
        "codigo": "Y650",
        "valor": "SANGRE INCOMPATIBLE USADA EN TRANSFUSION"
      },
      {
        "codigo": "Y651",
        "valor": "LIQUIDO ERRONEO USADO EN INFUSION"
      },
      {
        "codigo": "Y652",
        "valor": "FALLA EN LA SUTURA O LIGADURA DURANTE OPERACION QUIRURGICA"
      },
      {
        "codigo": "Y653",
        "valor": "TUBO ENDOTRAQUEAL COLOCADO ERRONEAMENTE DURANTE PROCEDIMIENTO ANESTESICO"
      },
      {
        "codigo": "Y654",
        "valor": "FALLA EN LA INTRODUCCION O REMOCION DE OTRO TUBO O INSTRUMENTO"
      },
      {
        "codigo": "Y655",
        "valor": "REALIZACION DE UNA OPERACION INADECUADA"
      },
      {
        "codigo": "Y658",
        "valor": "OTROS INCIDENTES ESPECIFICADOS DURANTE LA ATENCION MEDICA Y QUIRURGICA"
      }
    ]
  },
  {
    "grupo": "Y66 - NO ADMINISTRACION DE LA ATENCION MEDICA Y QUIRURGICA",
    "detalle": [
      {
        "codigo": "Y66X",
        "valor": "NO ADMINISTRACION DE LA ATENCION MEDICA Y QUIRURGICA"
      }
    ]
  },
  {
    "grupo": "Y69 - INCIDENTES NO ESPECIFICADOS DURANTE LA ATENCION MEDICA Y QUIRURGICA",
    "detalle": [
      {
        "codigo": "Y69X",
        "valor": "INCIDENTES NO ESPECIFICADOS DURANTE LA ATENCION MEDICA Y QUIRURGICA"
      }
    ]
  },
  {
    "grupo": "Y70 - DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y700",
        "valor": "DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y701",
        "valor": "DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y702",
        "valor": "DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y703",
        "valor": "DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y708",
        "valor": "DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y71 - DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y710",
        "valor": "DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y711",
        "valor": "DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y712",
        "valor": "DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y713",
        "valor": "DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y718",
        "valor": "DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y72 - DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y720",
        "valor": "DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y721",
        "valor": "DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y722",
        "valor": "DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y723",
        "valor": "DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y728",
        "valor": "DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y73 - DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES",
    "detalle": [
      {
        "codigo": "Y730",
        "valor": "DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y731",
        "valor": "DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y732",
        "valor": "DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y733",
        "valor": "DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y738",
        "valor": "DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y74 - DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y740",
        "valor": "DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y741",
        "valor": "DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y742",
        "valor": "DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y743",
        "valor": "DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y748",
        "valor": "DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y75 - DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y750",
        "valor": "DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y751",
        "valor": "DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y752",
        "valor": "DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y753",
        "valor": "DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y758",
        "valor": "DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y76 - DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y760",
        "valor": "DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y761",
        "valor": "DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y762",
        "valor": "DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y763",
        "valor": "DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y768",
        "valor": "DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y77 - DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y770",
        "valor": "DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y771",
        "valor": "DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y772",
        "valor": "DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y773",
        "valor": "DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y778",
        "valor": "DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y78 - APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y780",
        "valor": "APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y781",
        "valor": "APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y782",
        "valor": "APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y783",
        "valor": "APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y788",
        "valor": "APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y79 - DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y790",
        "valor": "DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y791",
        "valor": "DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y792",
        "valor": "DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y793",
        "valor": "DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y798",
        "valor": "DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y80 - APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y800",
        "valor": "APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y801",
        "valor": "APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y802",
        "valor": "APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y803",
        "valor": "APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y808",
        "valor": "APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y81 - DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y810",
        "valor": "DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y811",
        "valor": "DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y812",
        "valor": "DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y813",
        "valor": "DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y818",
        "valor": "DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y82 - OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS",
    "detalle": [
      {
        "codigo": "Y820",
        "valor": "OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO"
      },
      {
        "codigo": "Y821",
        "valor": "OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) Y DE REHABILITACION"
      },
      {
        "codigo": "Y822",
        "valor": "OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, MATERIALES Y ACCESORIOS"
      },
      {
        "codigo": "Y823",
        "valor": "OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS, INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MATERIALES (INCLUSIVE SUTURAS)"
      },
      {
        "codigo": "Y828",
        "valor": "OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS, DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Y83 - CIRUGIA Y OTROS PROCEDIMIENTOS QUIRURGICOS COMO LA CAUSA DE REACCION ANORMAL DEL PACIENTE O DE COMPLICACION POSTERIOR, SIN MENCION DE INCIDENTE EN EL MOMENTO DE EFECTUAR EL PROCEDIMIENTO",
    "detalle": [
      {
        "codigo": "Y830",
        "valor": "OPERACION QUIRURGICA CON TRASPLANTE DE UN ORGANO COMPLETO"
      },
      {
        "codigo": "Y831",
        "valor": "OPERACION QUIRURGICA CON IMPLANTE DE UN DISPOSITIVO ARTIFICIAL INTERNO"
      },
      {
        "codigo": "Y832",
        "valor": "OPERACION QUIRURGICA CON ANASTOMOSIS, DERIVACION O INJERTO"
      },
      {
        "codigo": "Y833",
        "valor": "OPERACION QUIRURGICA CON FORMACION DE ESTOMA EXTERNO"
      },
      {
        "codigo": "Y834",
        "valor": "OTRA CIRUGIA RECONSTRUCTIVA"
      },
      {
        "codigo": "Y835",
        "valor": "AMPUTACION DE MIEMBRO(S)"
      },
      {
        "codigo": "Y836",
        "valor": "REMOCION DE OTRO ORGANO (PARCIAL) (TOTAL)"
      },
      {
        "codigo": "Y838",
        "valor": "OTROS PROCEDIMIENTOS QUIRURGICOS"
      },
      {
        "codigo": "Y839",
        "valor": "PROCEDIMIENTO QUIRURGICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y84 - OTROS PROCEDIMIENTOS MEDICOS COMO LA CAUSA DE REACCION ANORMAL DEL PACIENTE O DE COMPLICACION POSTERIOR, SIN MEDICION DE INCIDENTE EN EL MOMENTO DE EFECTUAR EL PROCEDIMIENTO",
    "detalle": [
      {
        "codigo": "Y840",
        "valor": "CATETERIZACION CARDIACA"
      },
      {
        "codigo": "Y841",
        "valor": "DIALISIS RENAL"
      },
      {
        "codigo": "Y842",
        "valor": "PROCEDIMIENTO RADIOLOGICO Y RADIOTERAPIA"
      },
      {
        "codigo": "Y843",
        "valor": "TERAPIA POR CHOQUE"
      },
      {
        "codigo": "Y844",
        "valor": "ASPIRACION DE LIQUIDOS"
      },
      {
        "codigo": "Y845",
        "valor": "INSERCION DE SONDA GASTRICA O DUODENAL"
      },
      {
        "codigo": "Y846",
        "valor": "CATETERIZACION URINARIA"
      },
      {
        "codigo": "Y847",
        "valor": "MUESTRA DE SANGRE"
      },
      {
        "codigo": "Y848",
        "valor": "OTROS PROCEDIMIENTOS MEDICOS"
      },
      {
        "codigo": "Y849",
        "valor": "PROCEDIMIENTO MEDICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y85 - SECUELAS DE ACCIDENTES DE TRANSPORTE",
    "detalle": [
      {
        "codigo": "Y850",
        "valor": "SECUELAS DE ACCIDENTE DE VEHICULO DE MOTOR"
      },
      {
        "codigo": "Y859",
        "valor": "SECUELAS DE OTROS ACCIDENTES DE TRANSPORTE, Y LOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Y86 - SECUELAS DE OTROS ACCIDENTES",
    "detalle": [
      {
        "codigo": "Y86X",
        "valor": "SECUELAS DE OTROS ACCIDENTES"
      }
    ]
  },
  {
    "grupo": "Y87 - SECUELAS DE LESIONES AUTOINFLIGIDAS INTENCIONALMENTE, AGRESIONES Y EVENTOS DE INTENCION NO DETERMINADA",
    "detalle": [
      {
        "codigo": "Y870",
        "valor": "SECUELAS DE LESIONES AUTOINFLIGIDAS"
      },
      {
        "codigo": "Y871",
        "valor": "SECUELAS DE AGRESIONES"
      },
      {
        "codigo": "Y872",
        "valor": "SECUELAS DE EVENTOS DE INTENCION NO DETERMINADA"
      }
    ]
  },
  {
    "grupo": "Y88 - SECUELAS CON ATENCION MEDICA Y QUIRURGICA COMO CAUSA EXTERNA",
    "detalle": [
      {
        "codigo": "Y880",
        "valor": "SECUELAS DE EFECTOS ADVERSOS CAUSADOS POR DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS EN SU USO TERAPEUTICO"
      },
      {
        "codigo": "Y881",
        "valor": "SECUELAS DE INCIDENTES OCURRIDOS AL PACIENTE DURANTE PROCEDIMIENTOS MEDICOS Y QUIRURGICOS"
      },
      {
        "codigo": "Y882",
        "valor": "SECUELAS DE INCIDENTES ADVERSOS ASOCIADOS CON DISPOSITIVOS MEDICOS EN USO DIAGNOSTICO Y TERAPEUTICO"
      },
      {
        "codigo": "Y883",
        "valor": "SECUELAS DE PROCEDIMIENTOS MEDICOS Y QUIRURGICOS COMO LA CAUSA DE REACCION ANORMAL DEL PACIENTE O DE COMPLICACION POSTERIOR, SIN MENCION DE INCIDENTE EN EL MOMENTO DE EFECTUAR EL PROCEDIMIENTO"
      },
      {
        "codigo": "Y8831",
        "valor": "COMPLICACIONES DE LIGADURA DE TROMPAS"
      },
      {
        "codigo": "Y8832",
        "valor": "COMPLICACIONES DE VASECTOMIA"
      }
    ]
  },
  {
    "grupo": "Y89 - SECUELAS DE OTRAS CAUSAS EXTERNAS",
    "detalle": [
      {
        "codigo": "Y890",
        "valor": "SECUELAS DE INTERVENCION LEGAL"
      },
      {
        "codigo": "Y891",
        "valor": "SECUELAS DE OPERACIONES DE GUERRA"
      },
      {
        "codigo": "Y899",
        "valor": "SECUELAS DE CAUSA EXTERNA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Y90 - EVIDENCIA DE ALCOHOLISMO DETERMINADA POR EL NIVEL DE ALCOHOL EN LA SANGRE",
    "detalle": [
      {
        "codigo": "Y900",
        "valor": "NIVEL DE ALCOHOL EN LA SANGRE MENOR DE 20 MG/100 ML"
      },
      {
        "codigo": "Y901",
        "valor": "NIVEL DE ALCOHOL EN LA SANGRE DE 20 A 39 MG/100 ML"
      },
      {
        "codigo": "Y902",
        "valor": "NIVEL DE ALCOHOL EN LA SANGRE DE 40 A 59 MG/100 ML"
      },
      {
        "codigo": "Y903",
        "valor": "NIVEL DE ALCOHOL EN LA SANGRE DE 60 A 79 MG/100 ML"
      },
      {
        "codigo": "Y904",
        "valor": "NIVEL DE ALCOHOL EN LA SANGRE DE 80 A 99 MG/100 ML"
      },
      {
        "codigo": "Y905",
        "valor": "NIVEL DE ALCOHOL EN LA SANGRE DE 100 A 119 MG/100 ML"
      },
      {
        "codigo": "Y906",
        "valor": "NIVEL DE ALCOHOL EN LA SANGRE DE 120 A 199 MG/100 ML"
      },
      {
        "codigo": "Y907",
        "valor": "NIVEL DE ALCOHOL EN LA SANGRE DE 200 A 239 MG/100 ML"
      },
      {
        "codigo": "Y908",
        "valor": "NIVEL DE ALCOHOL EN LA SANGRE DE 240 MG/100 ML O MAS"
      },
      {
        "codigo": "Y909",
        "valor": "PRESENCIA DE ALCOHOL EN LA SANGRE, NIVEL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y91 - EVIDENCIA DE ALCOHOLISMO DETERMINADA POR EL NIVEL DE INTOXICACION",
    "detalle": [
      {
        "codigo": "Y910",
        "valor": "INTOXICACION ALCOHOLICA LEVE"
      },
      {
        "codigo": "Y911",
        "valor": "INTOXICACION ALCOHOLICA MODERADA"
      },
      {
        "codigo": "Y912",
        "valor": "INTOXICACION ALCOHOLICA SEVERA"
      },
      {
        "codigo": "Y913",
        "valor": "INTOXICACION ALCOHOLICA MUY SEVERA"
      },
      {
        "codigo": "Y919",
        "valor": "ALCOHOLISMO, NIVEL DE INTOXICACION NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Y95 - AFECCION NOSOCOMIAL",
    "detalle": [
      {
        "codigo": "Y95X",
        "valor": "AFECCION NOSOCOMIAL"
      }
    ]
  },
  {
    "grupo": "Y96 - AFECCION RELACIONADA CON EL TRABAJO",
    "detalle": [
      {
        "codigo": "Y96X",
        "valor": "AFECCION RELACIONADA CON EL TRABAJO"
      }
    ]
  },
  {
    "grupo": "Y97 - AFECCION RELACIONADA CON LA CONTAMINACION AMBIENTAL",
    "detalle": [
      {
        "codigo": "Y97X",
        "valor": "AFECCION RELACIONADA CON LA CONTAMINACION AMBIENTAL"
      }
    ]
  },
  {
    "grupo": "Y98 - AFECCION RELACIONADA CON EL ESTILO DE VIDA",
    "detalle": [
      {
        "codigo": "Y98X",
        "valor": "AFECCION RELACIONADA CON EL ESTILO DE VIDA"
      }
    ]
  },
  {
    "grupo": "Z00 - EXAMEN GENERAL E INVESTIGACION DE PERSONAS SIN QUEJAS O SIN DIAGNOSTICO INFORMADO",
    "detalle": [
      {
        "codigo": "Z000",
        "valor": "EXAMEN MEDICO GENERAL"
      },
      {
        "codigo": "Z001",
        "valor": "CONTROL DE SALUD DE RUTINA DEL NIÑO"
      },
      {
        "codigo": "Z0010",
        "valor": "CONTROL DEL RECIEN NACIDO ENFERMO"
      },
      {
        "codigo": "Z0011",
        "valor": "CONTROL DEL RECIEN NACIDO SANO"
      },
      {
        "codigo": "Z0012",
        "valor": "TEST PAUTA BREVE (PB) / CONTROL CRECIMIENTO Y DESARROLLO"
      },
      {
        "codigo": "Z0013",
        "valor": "TEST CON EEDP"
      },
      {
        "codigo": "Z0014",
        "valor": "TEST CON TEPSI"
      },
      {
        "codigo": "Z0015",
        "valor": "NIÑO CON LACTANCIA MATERNA EXCLUSIVA"
      },
      {
        "codigo": "Z0016",
        "valor": "NIÑO CON LACTANCIA MATERNA CONTINUADA"
      },
      {
        "codigo": "Z0017",
        "valor": "NIÑO CON ALIMENTACION COMPLEMENTARIA ADECUADA"
      },
      {
        "codigo": "Z0018",
        "valor": "SESION DE ESTIMULACION TEMPRANA"
      },
      {
        "codigo": "Z002",
        "valor": "EXAMEN DURANTE EL PERIODO DE CRECIMIENTO RAPIDO EN LA INFANCIA"
      },
      {
        "codigo": "Z003",
        "valor": "EXAMEN DEL ESTADO DE DESARROLLO DEL ADOLESCENTE"
      },
      {
        "codigo": "Z004",
        "valor": "EXAMEN PSIQUIATRICO GENERAL, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "Z005",
        "valor": "EXAMEN DE DONANTE POTENCIAL DE ORGANO O TEJIDO"
      },
      {
        "codigo": "Z006",
        "valor": "EXAMEN PARA COMPARACION Y CONTROL NORMALES EN PROGRAMA DE INVESTIGACION CLINICA"
      },
      {
        "codigo": "Z008",
        "valor": "OTROS EXAMENES GENERALES"
      }
    ]
  },
  {
    "grupo": "Z01 - OTROS EXAMENES ESPECIALES E INVESTIGACIONES EN PERSONAS SIN QUEJAS O SIN DIAGNOSTICO INFORMADO",
    "detalle": [
      {
        "codigo": "Z010",
        "valor": "EXAMEN DE OJOS Y DE LA VISION"
      },
      {
        "codigo": "Z011",
        "valor": "EXAMEN DE OIDOS Y DE LA AUDICION"
      },
      {
        "codigo": "Z012",
        "valor": "EXAMEN ODONTOLOGICO"
      },
      {
        "codigo": "Z013",
        "valor": "EXAMEN DE LA PRESION SANGUINEA"
      },
      {
        "codigo": "Z014",
        "valor": "EXAMEN GINECOLOGICO (GENERAL) (DE RUTINA)"
      },
      {
        "codigo": "Z0140",
        "valor": "EXAMEN GINECOLOGICO DESCARTE DE ETS"
      },
      {
        "codigo": "Z0141",
        "valor": "TOMA DE MUESTRA DE PAP"
      },
      {
        "codigo": "Z0142",
        "valor": "EXAMEN PELVICO"
      },
      {
        "codigo": "Z0143",
        "valor": "EXAMEN DE MAMA"
      },
      {
        "codigo": "Z015",
        "valor": "PRUEBAS DE SENSIBILIZACION Y DIAGNOSTICO CUTANEO"
      },
      {
        "codigo": "Z016",
        "valor": "EXAMEN RADIOLOGICO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "Z0160",
        "valor": "MAMOGRAFIA"
      },
      {
        "codigo": "Z0161",
        "valor": "RADIOGRAFIA PERIAPICAL"
      },
      {
        "codigo": "Z0162",
        "valor": "RADIOGRAFIA OCLUSAL"
      },
      {
        "codigo": "Z0163",
        "valor": "RADIOGRAFIA PANORAMICA"
      },
      {
        "codigo": "Z0164",
        "valor": "RADIOGRAFIA DE PERFIL ESTRICTO"
      },
      {
        "codigo": "Z0165",
        "valor": "RADIOGRAFIA DE MORDIDA (BITE WING)"
      },
      {
        "codigo": "Z017",
        "valor": "EXAMEN DE LABORATORIO"
      },
      {
        "codigo": "Z0170",
        "valor": "HEMOGRAMA"
      },
      {
        "codigo": "Z0171",
        "valor": "HEMOGLOBINA / HEMATOCRITO"
      },
      {
        "codigo": "Z0172",
        "valor": "GRUPO SANGUINEO RH"
      },
      {
        "codigo": "Z0173",
        "valor": "EXAMEN DE ORINA"
      },
      {
        "codigo": "Z0174",
        "valor": "RPR O VDRL"
      },
      {
        "codigo": "Z0175",
        "valor": "PRUEBA DE ELISA (VIH)"
      },
      {
        "codigo": "Z0176",
        "valor": "GLICEMIA"
      },
      {
        "codigo": "Z0177",
        "valor": "BATERIA DE LABORATORIO DE LA GESTANTE"
      },
      {
        "codigo": "Z0178",
        "valor": "EXAMEN DE GRUPO SANGRE"
      },
      {
        "codigo": "Z0179",
        "valor": "PRUEBA RAPIDA DE ELISA (VIH)"
      },
      {
        "codigo": "Z018",
        "valor": "OTROS EXAMENES ESPECIALES ESPECIFICADOS"
      },
      {
        "codigo": "Z0181",
        "valor": "OTROS DIAGNOSTICOS POR IMAGENES A GESTANTE"
      },
      {
        "codigo": "Z0182",
        "valor": "INSPECCION VISUAL CON ACIDO ACETICO (IVAA)"
      },
      {
        "codigo": "Z0183",
        "valor": "INSPECCION VISUAL CON ACIDO ACETICO MAGNIFICADA (IVAAM)"
      },
      {
        "codigo": "Z019",
        "valor": "EXAMEN ESPECIAL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z02 - EXAMENES Y CONTACTOS PARA FINES ADMINISTRATIVOS",
    "detalle": [
      {
        "codigo": "Z020",
        "valor": "EXAMEN PARA ADMISION A INSTITUCIONES EDUCATIVAS"
      },
      {
        "codigo": "Z021",
        "valor": "EXAMEN PREEMPLEO"
      },
      {
        "codigo": "Z022",
        "valor": "EXAMEN PARA ADMISION A INSTITUCIONES RESIDENCIALES"
      },
      {
        "codigo": "Z023",
        "valor": "EXAMEN PARA RECLUTAMIENTO EN LAS FUERZAS ARMADAS"
      },
      {
        "codigo": "Z024",
        "valor": "EXAMEN PARA OBTENCION DE LICENCIA DE CONDUCIR"
      },
      {
        "codigo": "Z025",
        "valor": "EXAMEN PARA PARTICIPACION EN COMPETENCIAS DEPORTIVAS"
      },
      {
        "codigo": "Z026",
        "valor": "EXAMEN PARA FINES DE SEGUROS"
      },
      {
        "codigo": "Z027",
        "valor": "EXTENSION DE CERTIFICADO MEDICO"
      },
      {
        "codigo": "Z0271",
        "valor": "EXPEDICION DE CERTIFICADO MEDICO"
      },
      {
        "codigo": "Z0272",
        "valor": "EXPEDICION DE CERTIFICADO DE DEFUNCION"
      },
      {
        "codigo": "Z0273",
        "valor": "EXPEDICION DE CERTIFICADO DE NACIMIENTO"
      },
      {
        "codigo": "Z0274",
        "valor": "EXPEDICION DE CERTIFICADO POR DISCAPACIDAD"
      },
      {
        "codigo": "Z0275",
        "valor": "EXPEDICION DE CERTIFICADO POR INCAPACIDAD"
      },
      {
        "codigo": "Z028",
        "valor": "OTROS EXAMENES PARA FINES ADMINISTRATIVOS"
      },
      {
        "codigo": "Z0281",
        "valor": "VISACION DE CERTIFICADO"
      },
      {
        "codigo": "Z029",
        "valor": "EXAMEN PARA FINES ADMINISTRATIVOS, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z03 - OBSERVACION Y EVALUACION MEDICAS POR SOSPECHA DE ENFERMEDADES Y AFECCIONES, DESCARTADAS",
    "detalle": [
      {
        "codigo": "Z030",
        "valor": "OBSERVACION POR SOSPECHA DE TUBERCULOSIS"
      },
      {
        "codigo": "Z031",
        "valor": "OBSERVACION POR SOSPECHA DE TUMOR MALIGNO"
      },
      {
        "codigo": "Z032",
        "valor": "OBSERVACION POR SOSPECHA DE TRASTORNO MENTAL Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "Z033",
        "valor": "OBSERVACION POR SOSPECHA DE TRASTORNO DEL SISTEMA NERVIOSO"
      },
      {
        "codigo": "Z034",
        "valor": "OBSERVACION POR SOSPECHA DE INFARTO DE MIOCARDIO"
      },
      {
        "codigo": "Z035",
        "valor": "OBSERVACION POR SOSPECHA DE OTRAS ENFERMEDADES CARDIOVASCULARES"
      },
      {
        "codigo": "Z036",
        "valor": "OBSERVACION POR SOSPECHA DE EFECTOS TOXICOS DE SUSTANCIAS INGERIDAS"
      },
      {
        "codigo": "Z038",
        "valor": "OBSERVACION POR SOSPECHA DE OTRAS ENFERMEDADES Y AFECCIONES"
      },
      {
        "codigo": "Z039",
        "valor": "OBSERVACION POR SOSPECHA DE ENFERMEDAD O AFECCION NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z04 - EXAMEN Y OBSERVACION POR OTRAS RAZONES",
    "detalle": [
      {
        "codigo": "Z040",
        "valor": "PRUEBA DE ALCOHOL O DROGAS EN LA SANGRE"
      },
      {
        "codigo": "Z041",
        "valor": "EXAMEN Y OBSERVACION CONSECUTIVOS A ACCIDENTE DE TRANSPORTE"
      },
      {
        "codigo": "Z042",
        "valor": "EXAMEN Y OBSERVACION CONSECUTIVOS A ACCIDENTE DE TRABAJO"
      },
      {
        "codigo": "Z043",
        "valor": "EXAMEN Y OBSERVACION CONSECUTIVOS A OTRO ACCIDENTE"
      },
      {
        "codigo": "Z044",
        "valor": "EXAMEN Y OBSERVACION CONSECUTIVOS A DENUNCIA DE VIOLACION Y SEDUCCION"
      },
      {
        "codigo": "Z045",
        "valor": "EXAMEN Y OBSERVACION CONSECUTIVOS A OTRA LESION INFLIGIDA"
      },
      {
        "codigo": "Z046",
        "valor": "EXAMEN PSIQUIATRICO GENERAL, SOLICITADO POR UNA AUTORIDAD"
      },
      {
        "codigo": "Z048",
        "valor": "EXAMEN Y OBSERVACION POR OTRAS RAZONES ESPECIFICADAS"
      },
      {
        "codigo": "Z049",
        "valor": "EXAMEN Y OBSERVACION POR RAZONES NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Z08 - EXAMEN DE SEGUIMIENTO CONSECUTIVO AL TRATAMIENTO POR TUMOR MALIGNO",
    "detalle": [
      {
        "codigo": "Z080",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A CIRUGIA POR TUMOR MALIGNO"
      },
      {
        "codigo": "Z081",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A RADIOTERAPIA POR TUMOR MALIGNO"
      },
      {
        "codigo": "Z082",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A QUIMIOTERAPIA POR TUMOR MALIGNO"
      },
      {
        "codigo": "Z087",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A TRATAMIENTO COMBINADO POR TUMOR MALIGNO"
      },
      {
        "codigo": "Z088",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A OTRO TRATAMIENTO POR TUMOR MALIGNO"
      },
      {
        "codigo": "Z089",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A TRATAMIENTO NO ESPECIFICADO POR TUMOR MALIGNO"
      }
    ]
  },
  {
    "grupo": "Z09 - EXAMEN DE SEGUIMIENTO CONSECUTIVO A TRATAMIENTO POR OTRAS AFECCIONES DIFERENTES A TUMORES MALIGNOS",
    "detalle": [
      {
        "codigo": "Z090",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A CIRUGIA POR OTRAS AFECCIONES"
      },
      {
        "codigo": "Z091",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A RADIOTERAPIA POR OTRAS AFECCIONES"
      },
      {
        "codigo": "Z092",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A QUIMIOTERAPIA POR OTRAS AFECCIONES"
      },
      {
        "codigo": "Z093",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A PSICOTERAPIA"
      },
      {
        "codigo": "Z094",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A TRATAMIENTO DE FRACTURA"
      },
      {
        "codigo": "Z097",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A TRATAMIENTO COMBINADO POR OTRAS AFECCIONES"
      },
      {
        "codigo": "Z098",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A OTRO TRATAMIENTO POR OTRAS AFECCIONES"
      },
      {
        "codigo": "Z099",
        "valor": "EXAMEN DE SEGUIMIENTO CONSECUTIVO A TRATAMIENTO NO ESPECIFICADO POR OTRAS AFECCIONES"
      }
    ]
  },
  {
    "grupo": "Z10 - CONTROL GENERAL DE SALUD DE RUTINA DE SUBPOBLACIONES DEFINIDAS",
    "detalle": [
      {
        "codigo": "Z100",
        "valor": "EXAMEN DE SALUD OCUPACIONAL"
      },
      {
        "codigo": "Z101",
        "valor": "CONTROL GENERAL DE SALUD DE RUTINA DE RESIDENTES DE INSTITUCIONES"
      },
      {
        "codigo": "Z102",
        "valor": "CONTROL GENERAL DE SALUD DE RUTINA A MIEMBROS DE LAS FUERZAS ARMADAS"
      },
      {
        "codigo": "Z103",
        "valor": "CONTROL GENERAL DE SALUD DE RUTINA A INTEGRANTES DE EQUIPOS DEPORTIVOS"
      },
      {
        "codigo": "Z108",
        "valor": "OTROS CONTROLES GENERALES DE SALUD DE RUTINA DE OTRAS SUBPOBLACIONES DEFINIDAS"
      }
    ]
  },
  {
    "grupo": "Z11 - EXAMEN DE PESQUISA ESPECIAL PARA ENFERMEDADES INFECCIOSAS Y PARASITARIAS",
    "detalle": [
      {
        "codigo": "Z110",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA ENFERMEDADES INFECCIOSAS INTESTINALES"
      },
      {
        "codigo": "Z111",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TUBERCULOSIS RESPIRATORIA"
      },
      {
        "codigo": "Z112",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES BACTERIANAS"
      },
      {
        "codigo": "Z113",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA INFECCIONES DE TRANSMISION PREDOMINANTEMENTE SEXUAL"
      },
      {
        "codigo": "Z114",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA EL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]"
      },
      {
        "codigo": "Z115",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES VIRALES"
      },
      {
        "codigo": "Z116",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES DEBIDAS A PROTOZOARIOS Y HELMINTOS"
      },
      {
        "codigo": "Z118",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS ESPECIFICADAS"
      },
      {
        "codigo": "Z119",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA ENFERMEDADES INFECCIOSAS Y PARASITARIAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Z12 - EXAMEN DE PESQUISA ESPECIAL PARA TUMORES",
    "detalle": [
      {
        "codigo": "Z120",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE ESTOMAGO"
      },
      {
        "codigo": "Z121",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DEL INTESTINO"
      },
      {
        "codigo": "Z122",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TUMORES DE ORGANOS RESPIRATORIOS"
      },
      {
        "codigo": "Z123",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE LA MAMA"
      },
      {
        "codigo": "Z124",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DEL CUELLO UTERINO"
      },
      {
        "codigo": "Z125",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE LA PROSTATA"
      },
      {
        "codigo": "Z126",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE LA VEJIGA"
      },
      {
        "codigo": "Z128",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TUMORES DE OTROS SITIOS"
      },
      {
        "codigo": "Z129",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z13 - EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES Y TRASTORNOS",
    "detalle": [
      {
        "codigo": "Z130",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA ENFERMEDADES DE LA SANGRE Y ORGANOS HEMATOPOYETICOS Y CIERTOS TRASTORNOS DEL MECANISMO DE LA INMUNIDAD"
      },
      {
        "codigo": "Z131",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA DIABETES MELLITUS"
      },
      {
        "codigo": "Z132",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TRASTORNOS DE LA NUTRICION"
      },
      {
        "codigo": "Z133",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      },
      {
        "codigo": "Z134",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA CIERTOS TRASTORNOS DEL DESARROLLO EN EL NIÑO"
      },
      {
        "codigo": "Z135",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TRASTORNOS DEL OJO Y DEL OIDO"
      },
      {
        "codigo": "Z136",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA TRASTORNOS CARDIOVASCULARES"
      },
      {
        "codigo": "Z137",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA MALFORMACIONES CONGENITAS, DEFORMIDADES Y ANOMALIAS CROMOSOMICAS"
      },
      {
        "codigo": "Z138",
        "valor": "EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES Y TRASTORNOS ESPECIFICADOS"
      },
      {
        "codigo": "Z139",
        "valor": "EXAMEN DE PESQUISA ESPECIAL, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z20 - CONTACTO CON Y EXPOSICION A ENFERMEDADES TRANSMISIBLES",
    "detalle": [
      {
        "codigo": "Z200",
        "valor": "CONTACTO CON Y EXPOSICION A ENFERMEDADES INFECCIOSAS INTESTINALES"
      },
      {
        "codigo": "Z201",
        "valor": "CONTACTO CON Y EXPOSICION A TUBERCULOSIS"
      },
      {
        "codigo": "Z202",
        "valor": "CONTACTO CON Y EXPOSICION A ENFERMEDADES INFECCIOSAS CON UN MODO DE TRANSMISION PREDOMINANTEMENTE SEXUAL"
      },
      {
        "codigo": "Z203",
        "valor": "CONTACTO CON Y EXPOSICION A RABIA"
      },
      {
        "codigo": "Z204",
        "valor": "CONTACTO CON Y EXPOSICION A RUBEOLA"
      },
      {
        "codigo": "Z205",
        "valor": "CONTACTO CON Y EXPOSICION A HEPATITIS VIRAL"
      },
      {
        "codigo": "Z206",
        "valor": "CONTACTO CON Y EXPOSICION AL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]"
      },
      {
        "codigo": "Z2061",
        "valor": "HIJO DE MADRE INFECTADA VIH"
      },
      {
        "codigo": "Z207",
        "valor": "CONTACTO CON Y EXPOSICION A PEDICULOSIS, ACARIASIS Y OTRAS INFESTACIONES"
      },
      {
        "codigo": "Z208",
        "valor": "CONTACTO CON Y EXPOSICION A OTRAS ENFERMEDADES TRANSMISIBLES"
      },
      {
        "codigo": "Z209",
        "valor": "CONTACTO CON Y EXPOSICION A ENFERMEDADES TRANSMISIBLES NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Z21 - ESTADO DE INFECCION ASINTOMATICA POR EL VIRUS DE LA INMUNODEFICIENCIA",
    "detalle": [
      {
        "codigo": "Z21X",
        "valor": "ESTADO DE INFECCION ASINTOMATICA POR EL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]"
      }
    ]
  },
  {
    "grupo": "Z22 - PORTADOR DE AGENTE DE ENFERMEDAD INFECCIOSA",
    "detalle": [
      {
        "codigo": "Z220",
        "valor": "PORTADOR DEL AGENTE DE LA FIEBRE TIFOIDEA"
      },
      {
        "codigo": "Z221",
        "valor": "PORTADOR DE AGENTES DE OTRAS ENFERMEDADES INFECCIOSAS INTESTINALES"
      },
      {
        "codigo": "Z222",
        "valor": "PORTADOR DEL AGENTE DE LA DIFTERIA"
      },
      {
        "codigo": "Z223",
        "valor": "PORTADOR DE AGENTES DE OTRAS ENFERMEDADES BACTERIANAS ESPECIFICADAS"
      },
      {
        "codigo": "Z224",
        "valor": "PORTADOR DE AGENTES DE ENFERMEDADES INFECCIOSAS CON UN MODO DE TRANSMISION PREDOMINANTEMENTE SEXUAL"
      },
      {
        "codigo": "Z225",
        "valor": "PORTADOR DE AGENTES DE HEPATITIS VIRAL"
      },
      {
        "codigo": "Z226",
        "valor": "PORTADOR DEL VIRUS HUMANO T-LINFOTROPICO TIPO 1 [VHTL-1]"
      },
      {
        "codigo": "Z228",
        "valor": "PORTADOR DE AGENTES DE OTRAS ENFERMEDADES INFECCIOSAS"
      },
      {
        "codigo": "Z229",
        "valor": "PORTADOR DE AGENTE DE ENFERMEDAD INFECCIOSA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z23 - NECESIDAD DE INMUNIZACION CONTRA ENFERMEDAD BACTERIANA UNICA",
    "detalle": [
      {
        "codigo": "Z230",
        "valor": "NECESIDAD DE INMUNIZACION SOLO CONTRA EL COLERA"
      },
      {
        "codigo": "Z231",
        "valor": "NECESIDAD DE INMUNIZACION SOLO CONTRA LA TIFOIDEA-PARATIFOIDEA [TAB]"
      },
      {
        "codigo": "Z232",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA LA TUBERCULOSIS [BCG]"
      },
      {
        "codigo": "Z233",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA LA PESTE"
      },
      {
        "codigo": "Z234",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA LA TULAREMIA"
      },
      {
        "codigo": "Z235",
        "valor": "NECESIDAD DE INMUNIZACION SOLO CONTRA EL TETANOS"
      },
      {
        "codigo": "Z236",
        "valor": "NECESIDAD DE INMUNIZACION SOLO CONTRA LA DIFTERIA"
      },
      {
        "codigo": "Z237",
        "valor": "NECESIDAD DE INMUNIZACION SOLO CONTRA LA TOS FERINA"
      },
      {
        "codigo": "Z238",
        "valor": "NECESIDAD DE INMUNIZACION SOLO CONTRA OTRA ENFERMEDAD BACTERIANA"
      }
    ]
  },
  {
    "grupo": "Z24 - NECESIDAD DE INMUNIZACION CONTRA CIERTAS ENFERMEDADES VIRALES",
    "detalle": [
      {
        "codigo": "Z240",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA LA POLIOMIELITIS"
      },
      {
        "codigo": "Z241",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA LA ENCEFALITIS VIRAL TRANSMITIDA POR ARTROPODOS"
      },
      {
        "codigo": "Z242",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA LA RABIA"
      },
      {
        "codigo": "Z2421",
        "valor": "VACUNACION ANTIRRABICA HUMANA POR MORDEDURA DE ANIMAL ESQUEMA REDUCIDO"
      },
      {
        "codigo": "Z2422",
        "valor": "VACUNACION ANTIRRABICA HUMANA POR MORDEDURA DE ANIMAL ESQUEMA CLASICO"
      },
      {
        "codigo": "Z2423",
        "valor": "VACUNACION ANTIRRABICA HUMANA POR MORDEDURA DE MURCIELAGO (RABIA SILVESTRE) ESQUEMA REDUCIDO"
      },
      {
        "codigo": "Z2424",
        "valor": "VACUNACION ANTIRRABICA HUMANA POR MORDEDURA DE MURCIELAGO (RABIA SILVESTRE) ESQUEMA CLASICO"
      },
      {
        "codigo": "Z243",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA LA FIEBRE AMARILLA"
      },
      {
        "codigo": "Z244",
        "valor": "NECESIDAD DE INMUNIZACION SOLO CONTRA EL SARAMPION"
      },
      {
        "codigo": "Z245",
        "valor": "NECESIDAD DE INMUNIZACION SOLO CONTRA LA RUBEOLA"
      },
      {
        "codigo": "Z246",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA LA HEPATITIS VIRAL"
      }
    ]
  },
  {
    "grupo": "Z25 - NECESIDAD DE INMUNIZACION CONTRA OTRAS ENFERMEDADES VIRALES UNICAS",
    "detalle": [
      {
        "codigo": "Z250",
        "valor": "NECESIDAD DE INMUNIZACION SOLO CONTRA LA PAROTIDITIS"
      },
      {
        "codigo": "Z251",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA LA INFLUENZA [GRIPE]"
      },
      {
        "codigo": "Z2511",
        "valor": "VACUNACION CONTRA INFLUENZA"
      },
      {
        "codigo": "Z258",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA OTRAS ENFERMEDADES VIRALES UNICAS ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Z26 - NECESIDAD DE INMUNIZACION CONTRA OTRAS ENFERMEDADES INFECCIOSAS UNICAS",
    "detalle": [
      {
        "codigo": "Z260",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA LA LEISHMANIASIS"
      },
      {
        "codigo": "Z268",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA OTRAS ENFERMEDADES INFECCIOSAS UNICAS ESPECIFICADAS"
      },
      {
        "codigo": "Z269",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA ENFERMEDAD INFECCIOSA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z27 - NECESIDAD DE INMUNIZACION CONTRA COMBINACIONES DE ENFERMEDADES INFECCIOSAS",
    "detalle": [
      {
        "codigo": "Z270",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA EL COLERA Y LA TIFOIDEA-PARATIFOIDEA [COLERA + TAB]"
      },
      {
        "codigo": "Z271",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA DIFTERIA-PERTUSSIS-TETANOS COMBINADOS [DPT]"
      },
      {
        "codigo": "Z272",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA DIFTERIA-PERTUSSIS-TETANOS Y TIFOIDEA-PARATIFOIDEA [DPT + TAB]"
      },
      {
        "codigo": "Z273",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA DIFTERIA-PERTUSSIS-TETANOS Y POLIOMIELITIS [DPT + POLIO]"
      },
      {
        "codigo": "Z274",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA SARAMPION-PAROTIDITIS-RUBEOLA- [SPR] [MMR]"
      },
      {
        "codigo": "Z275",
        "valor": "VACUNACION ANTISARAMPION-RUBEOLA"
      },
      {
        "codigo": "Z276",
        "valor": "VACUNACION CONTRA DPT - HEP. B - HEMOF. INFLUENZA"
      },
      {
        "codigo": "Z278",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA OTRAS COMBINACIONES DE ENFERMEDADES INFECCIOSAS"
      },
      {
        "codigo": "Z2781",
        "valor": "VACUNACION DT (DIFTERIA TETANOS)"
      },
      {
        "codigo": "Z279",
        "valor": "NECESIDAD DE INMUNIZACION CONTRA COMBINACIONES NO ESPECIFICADAS DE ENFERMEDADES INFECCIOSAS"
      }
    ]
  },
  {
    "grupo": "Z28 - INMUNIZACION NO REALIZADA",
    "detalle": [
      {
        "codigo": "Z280",
        "valor": "INMUNIZACION NO REALIZADA POR CONTRAINDICACION"
      },
      {
        "codigo": "Z281",
        "valor": "INMUNIZACION NO REALIZADA POR DECISION DEL PACIENTE, POR MOTIVOS DE CREENCIA O PRESION DE GRUPO"
      },
      {
        "codigo": "Z282",
        "valor": "INMUNIZACION NO REALIZADA POR DECISION DEL PACIENTE, POR OTRAS RAZONES Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "Z288",
        "valor": "INMUNIZACION NO REALIZADA POR OTRAS RAZONES"
      },
      {
        "codigo": "Z289",
        "valor": "INMUNIZACION NO REALIZADA POR RAZON NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z29 - NECESIDAD DE OTRAS MEDIDAS PROFILACTICAS",
    "detalle": [
      {
        "codigo": "Z290",
        "valor": "AISLAMIENTO"
      },
      {
        "codigo": "Z291",
        "valor": "INMUNOTERAPIA PROFILACTICA"
      },
      {
        "codigo": "Z292",
        "valor": "OTRA QUIMIOTERAPIA PROFILACTICA"
      },
      {
        "codigo": "Z298",
        "valor": "OTRAS MEDIDAS PROFILACTICAS ESPECIFICADAS"
      },
      {
        "codigo": "Z2981",
        "valor": "ADMINISTRACION DE VITAMINA A"
      },
      {
        "codigo": "Z2982",
        "valor": "ADMINISTRACION DE SULFATO FERROSO"
      },
      {
        "codigo": "Z2983",
        "valor": "ADMINISTRACION ACIDO FOLICO"
      },
      {
        "codigo": "Z2984",
        "valor": "PROFILAXIS OCULAR"
      },
      {
        "codigo": "Z2985",
        "valor": "ADMINISTRACION DE VITAMINA K"
      },
      {
        "codigo": "Z299",
        "valor": "MEDIDA PROFILACTICA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z30 - ATENCION PARA LA ANTICONCEPCION",
    "detalle": [
      {
        "codigo": "Z300",
        "valor": "CONSEJO Y ASESORAMIENTO GENERAL SOBRE LA ANTICONCEPCION"
      },
      {
        "codigo": "Z3001",
        "valor": "CONSEJERIA Y ORIENTACION GENERAL PARA PLANIFICACION FAMILIAR"
      },
      {
        "codigo": "Z3002",
        "valor": "CONSEJERIA Y ORIENTACION AQV"
      },
      {
        "codigo": "Z3003",
        "valor": "PRESCRIPCION INICIAL DE METODO ORAL COMBINADO"
      },
      {
        "codigo": "Z3004",
        "valor": "PRESCRIPCION INICIAL DE METODO ORAL PROGESTAGENO"
      },
      {
        "codigo": "Z3006",
        "valor": "PRESCRIPCION INICIAL DE METODO IMPLANTE"
      },
      {
        "codigo": "Z3007",
        "valor": "PRESCRIPCION INICIAL DE METODO TABLETA VAGINAL U OTRO ESPERMICIDA"
      },
      {
        "codigo": "Z3008",
        "valor": "PRESCRIPCION INICIAL DE METODO PRESERVATIVO MASCULINO"
      },
      {
        "codigo": "Z3009",
        "valor": "PRESCRIPCION INICIAL DE METODO PRESERVATIVO FEMENINO"
      },
      {
        "codigo": "Z301",
        "valor": "INSERCION DE DISPOSITIVO ANTICONCEPTIVO (INTRAUTERINO)"
      },
      {
        "codigo": "Z302",
        "valor": "ESTERILIZACION"
      },
      {
        "codigo": "Z303",
        "valor": "EXTRACCION MENSTRUAL"
      },
      {
        "codigo": "Z3031",
        "valor": "ATENCION DE ABORTO"
      },
      {
        "codigo": "Z304",
        "valor": "SUPERVISION DEL USO DE DROGAS ANTICONCEPTIVAS"
      },
      {
        "codigo": "Z3043",
        "valor": "REPETICION DE PRESCRIPCION DE METODO ORAL COMBINADO"
      },
      {
        "codigo": "Z3044",
        "valor": "REPETICION DE PRESCRIPCION DE METODO ORAL PROGESTAGENO"
      },
      {
        "codigo": "Z3046",
        "valor": "REPETICION DE PRESCRIPCION DE METODO DE IMPLANTE"
      },
      {
        "codigo": "Z3047",
        "valor": "REPETICION DE PRESCRIPCION DE METODO TABLETA VAGINAL U OTRO ESPERMICIDA"
      },
      {
        "codigo": "Z3048",
        "valor": "REPETICION DE PRESCRIPCION DE METODO DE PRESERVATIVO MASCULINO"
      },
      {
        "codigo": "Z3049",
        "valor": "REPETICION DE PRESCRIPCION DE METODO DE PRESERVATIVO FEMENINO"
      },
      {
        "codigo": "Z305",
        "valor": "SUPERVISION DEL USO DE DISPOSITIVO ANTICONCEPTIVO (INTRAUTERINO)"
      },
      {
        "codigo": "Z3051",
        "valor": "RETIRO DE DIU"
      },
      {
        "codigo": "Z306",
        "valor": "CONTROL O REINSERCION DE IMPLANTE"
      },
      {
        "codigo": "Z308",
        "valor": "OTRAS ATENCIONES ESPECIFICADAS PARA LA ANTICONCEPCION"
      },
      {
        "codigo": "Z309",
        "valor": "ASISTENCIA PARA LA ANTICONCEPCION, NO ESPECIFICADA"
      },
      {
        "codigo": "Z3091",
        "valor": "ANTICONCEPCION ORAL DE EMERGENCIA COMBINADO"
      },
      {
        "codigo": "Z3092",
        "valor": "ANTICONCEPCION ORAL DE EMERGENCIA PROGESTAGENO"
      }
    ]
  },
  {
    "grupo": "Z31 - ATENCION PARA LA PROCREACION",
    "detalle": [
      {
        "codigo": "Z310",
        "valor": "TUBOPLASTIA O VASOPLASTIA POSTERIOR A ESTERILIZACION"
      },
      {
        "codigo": "Z311",
        "valor": "INSEMINACION ARTIFICIAL"
      },
      {
        "codigo": "Z312",
        "valor": "FECUNDACION IN VITRO"
      },
      {
        "codigo": "Z313",
        "valor": "OTROS METODOS DE ATENCION PARA LA FECUNDACION"
      },
      {
        "codigo": "Z314",
        "valor": "INVESTIGACION Y PRUEBA PARA LA PROCREACION"
      },
      {
        "codigo": "Z315",
        "valor": "ASESORAMIENTO GENETICO"
      },
      {
        "codigo": "Z316",
        "valor": "CONSEJO Y ASESORAMIENTO GENERAL SOBRE LA PROCREACION"
      },
      {
        "codigo": "Z318",
        "valor": "OTRA ATENCION ESPECIFICADA PARA LA PROCREACION"
      },
      {
        "codigo": "Z3181",
        "valor": "SESION DE PSICOPROFILAXIS GENERAL (REGISTRO GRUPAL)"
      },
      {
        "codigo": "Z3182",
        "valor": "SESION DE PSICOPROFILAXIS ESPECIFICO (REGISTRO INDIVIDUAL)"
      },
      {
        "codigo": "Z3183",
        "valor": "PREPARACION PARA LACTANCIA MATERNA"
      },
      {
        "codigo": "Z319",
        "valor": "ATENCION NO ESPECIFICADA RELACIONADA CON LA PROCREACION"
      }
    ]
  },
  {
    "grupo": "Z32 - EXAMEN Y PRUEBA DEL EMBARAZO",
    "detalle": [
      {
        "codigo": "Z320",
        "valor": "EMBARAZO (AUN) NO CONFIRMADO"
      },
      {
        "codigo": "Z321",
        "valor": "EMBARAZO CONFIRMADO"
      }
    ]
  },
  {
    "grupo": "Z33 - ESTADO DE EMBARAZO, INCIDENTAL",
    "detalle": [
      {
        "codigo": "Z33X",
        "valor": "ESTADO DE EMBARAZO, INCIDENTAL"
      }
    ]
  },
  {
    "grupo": "Z34 - SUPERVISION DE EMBARAZO NORMAL",
    "detalle": [
      {
        "codigo": "Z340",
        "valor": "SUPERVISION DE PRIMER EMBARAZO NORMAL"
      },
      {
        "codigo": "Z348",
        "valor": "SUPERVISION DE OTROS EMBARAZOS NORMALES"
      },
      {
        "codigo": "Z349",
        "valor": "SUPERVISION DE EMBARAZO NORMAL NO ESPECIFICADO"
      },
      {
        "codigo": "Z3490",
        "valor": "GESTANTE CAPTADA"
      },
      {
        "codigo": "Z3491",
        "valor": "GESTANTE NORMAL CONTROL 1ER. TRIMESTRE (12 SEMANAS)"
      },
      {
        "codigo": "Z3492",
        "valor": "GESTANTE NORMAL CONTROL 2DO. TRIMESTRE (24 SEMANAS)"
      },
      {
        "codigo": "Z3493",
        "valor": "GESTANTE NORMAL CONTROL 3ER. TRIMESTRE (36 SEMANAS)"
      }
    ]
  },
  {
    "grupo": "Z35 - SUPERVISION DE EMBARAZO DE ALTO RIESGO",
    "detalle": [
      {
        "codigo": "Z350",
        "valor": "SUPERVISION DE EMBARAZO CON HISTORIA DE ESTERILIDAD"
      },
      {
        "codigo": "Z351",
        "valor": "SUPERVISION DE EMBARAZO CON HISTORIA DE ABORTO"
      },
      {
        "codigo": "Z352",
        "valor": "SUPERVISION DE EMBARAZO CON OTRO RIESGO EN LA HISTORIA OBSTETRICA O REPRODUCTIVA"
      },
      {
        "codigo": "Z353",
        "valor": "SUPERVISION DE EMBARAZO CON HISTORIA DE INSUFICIENTE ATENCION PRENATAL"
      },
      {
        "codigo": "Z354",
        "valor": "SUPERVISION DE EMBARAZO CON GRAN MULTIPARIDAD"
      },
      {
        "codigo": "Z355",
        "valor": "SUPERVISION DE PRIMIGESTA AÑOSA"
      },
      {
        "codigo": "Z356",
        "valor": "SUPERVISION DE PRIMIGESTA MUY JOVEN"
      },
      {
        "codigo": "Z357",
        "valor": "SUPERVISION DE EMBARAZO DE ALTO RIESGO DEBIDO A PROBLEMAS SOCIALES"
      },
      {
        "codigo": "Z358",
        "valor": "SUPERVISION DE OTROS EMBARAZOS DE ALTO RIESGO"
      },
      {
        "codigo": "Z359",
        "valor": "SUPERVISION DE EMBARAZO DE ALTO RIESGO, SIN OTRA ESPECIFICACION"
      },
      {
        "codigo": "Z3591",
        "valor": "GESTANTE CON FACTOR DE RIESGO CONTROL 1ER. TRIMESTRE (12 SEMANAS)"
      },
      {
        "codigo": "Z3592",
        "valor": "GESTANTE CON FACTOR DE RIESGO CONTROL 2DO. TRIMESTRE (24 SEMANAS)"
      },
      {
        "codigo": "Z3593",
        "valor": "GESTANTE CON FACTOR DE RIESGO CONTROL 3ER. TRIMESTRE (36 SEMANAS)"
      }
    ]
  },
  {
    "grupo": "Z36 - PESQUISAS PRENATALES",
    "detalle": [
      {
        "codigo": "Z360",
        "valor": "PESQUISA PRENATAL PARA ANOMALIAS CROMOSOMICAS"
      },
      {
        "codigo": "Z361",
        "valor": "PESQUISA PRENATAL PARA MEDIR NIVELES ELEVADOS DE ALFAFETOPROTEINAS"
      },
      {
        "codigo": "Z362",
        "valor": "OTRAS PESQUISAS PRENATALES BASADAS EN AMNIOCENTESIS"
      },
      {
        "codigo": "Z363",
        "valor": "PESQUISA PRENATAL DE MALFORMACIONES USANDO ULTRASONIDO Y OTROS METODOS FISICOS"
      },
      {
        "codigo": "Z364",
        "valor": "PESQUISA PRENATAL DEL RETARDO DEL CRECIMIENTO FETAL USANDO ULTRASONIDO Y OTROS METODOS FISICOS"
      },
      {
        "codigo": "Z365",
        "valor": "PESQUISA PRENATAL PARA ISOINMUNIZACION"
      },
      {
        "codigo": "Z368",
        "valor": "OTRAS PESQUISAS PRENATALES ESPECIFICAS"
      },
      {
        "codigo": "Z369",
        "valor": "PESQUISA PRENATAL, SIN OTRA ESPECIFICACION"
      }
    ]
  },
  {
    "grupo": "Z37 - PRODUCTO DEL PARTO",
    "detalle": [
      {
        "codigo": "Z370",
        "valor": "NACIDO VIVO, UNICO"
      },
      {
        "codigo": "Z371",
        "valor": "NACIDO MUERTO, UNICO"
      },
      {
        "codigo": "Z372",
        "valor": "GEMELOS, AMBOS NACIDOS VIVOS"
      },
      {
        "codigo": "Z373",
        "valor": "GEMELOS, UN NACIDO VIVO Y UN NACIDO MUERTO"
      },
      {
        "codigo": "Z374",
        "valor": "GEMELOS, AMBOS NACIDOS MUERTOS"
      },
      {
        "codigo": "Z375",
        "valor": "OTROS NACIMIENTOS MULTIPLES, TODOS NACIDOS VIVOS"
      },
      {
        "codigo": "Z376",
        "valor": "OTROS NACIMIENTOS MULTIPLES, ALGUNOS NACIDOS VIVOS"
      },
      {
        "codigo": "Z377",
        "valor": "OTROS NACIMIENTOS MULTIPLES, TODOS NACIDOS MUERTOS"
      },
      {
        "codigo": "Z379",
        "valor": "PRODUCTO DEL PARTO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z38 - NACIDOS VIVOS SEGUN LUGAR DE NACIMIENTO",
    "detalle": [
      {
        "codigo": "Z380",
        "valor": "PRODUCTO UNICO, NACIDO EN HOSPITAL"
      },
      {
        "codigo": "Z381",
        "valor": "PRODUCTO UNICO, NACIDO FUERA DE HOSPITAL"
      },
      {
        "codigo": "Z382",
        "valor": "PRODUCTO UNICO, LUGAR DE NACIMIENTO NO ESPECIFICADO"
      },
      {
        "codigo": "Z383",
        "valor": "GEMELOS, NACIDOS EN HOSPITAL"
      },
      {
        "codigo": "Z384",
        "valor": "GEMELOS, NACIDOS FUERA DE HOSPITAL"
      },
      {
        "codigo": "Z385",
        "valor": "GEMELOS, LUGAR DE NACIMIENTO NO ESPECIFICADO"
      },
      {
        "codigo": "Z386",
        "valor": "OTROS NACIMIENTOS MULTIPLES, EN HOSPITAL"
      },
      {
        "codigo": "Z387",
        "valor": "OTROS NACIMIENTOS MULTIPLES, FUERA DEL HOSPITAL"
      },
      {
        "codigo": "Z388",
        "valor": "OTROS NACIMIENTOS MULTIPLES, LUGAR DE NACIMIENTO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z39 - EXAMEN Y ATENCION DEL POSTPARTO",
    "detalle": [
      {
        "codigo": "Z390",
        "valor": "ATENCION Y EXAMEN INMEDIATAMENTE DESPUES DEL PARTO"
      },
      {
        "codigo": "Z391",
        "valor": "ATENCION Y EXAMEN DE MADRE EN PERIODO DE LACTANCIA"
      },
      {
        "codigo": "Z392",
        "valor": "SEGUIMIENTO POSTPARTO, DE RUTINA"
      },
      {
        "codigo": "Z3921",
        "valor": "PUERPERA"
      }
    ]
  },
  {
    "grupo": "Z40 - CIRUGIA PROFILACTICA",
    "detalle": [
      {
        "codigo": "Z400",
        "valor": "CIRUGIA PROFILACTICA POR FACTORES DE RIESGO RELACIONADOS CON TUMORES MALIGNOS"
      },
      {
        "codigo": "Z408",
        "valor": "OTRA CIRUGIA PROFILACTICA"
      },
      {
        "codigo": "Z409",
        "valor": "CIRUGIA PROFILACTICA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z41 - PROCEDIMIENTOS PARA OTROS PROPOSITOS QUE NO SEAN LOS DE MEJORAR EL ESTADO DE SALUD",
    "detalle": [
      {
        "codigo": "Z410",
        "valor": "TRASPLANTE DE PELO"
      },
      {
        "codigo": "Z411",
        "valor": "OTRAS CIRUGIAS PLASTICAS POR RAZONES ESTETICAS"
      },
      {
        "codigo": "Z412",
        "valor": "CIRCUNCISION RITUAL O DE RUTINA"
      },
      {
        "codigo": "Z413",
        "valor": "PERFORACION DE LA OREJA"
      },
      {
        "codigo": "Z418",
        "valor": "OTROS PROCEDIMIENTOS PARA OTROS PROPOSITOS QUE NO SEAN LOS DE MEJORAR EL ESTADO DE SALUD"
      },
      {
        "codigo": "Z419",
        "valor": "PROCEDIMIENTO NO ESPECIFICADO PARA OTROS PROPOSITOS QUE NO SEAN LOS DE MEJORAR EL ESTADO DE SALUD"
      }
    ]
  },
  {
    "grupo": "Z42 - CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA",
    "detalle": [
      {
        "codigo": "Z420",
        "valor": "CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE LA CABEZA Y DEL CUELLO"
      },
      {
        "codigo": "Z421",
        "valor": "CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE LA MAMA"
      },
      {
        "codigo": "Z422",
        "valor": "CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE OTRAS PARTES ESPECIFICADAS DEL TRONCO"
      },
      {
        "codigo": "Z423",
        "valor": "CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE LAS EXTREMIDADES SUPERIORES"
      },
      {
        "codigo": "Z424",
        "valor": "CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE LAS EXTREMIDADES INFERIORES"
      },
      {
        "codigo": "Z428",
        "valor": "CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE OTRAS PARTES ESPECIFICADAS DEL CUERPO"
      },
      {
        "codigo": "Z429",
        "valor": "CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z43 - ATENCION DE ORIFICIOS ARTIFICIALES",
    "detalle": [
      {
        "codigo": "Z430",
        "valor": "ATENCION DE TRAQUEOSTOMIA"
      },
      {
        "codigo": "Z431",
        "valor": "ATENCION DE GASTROSTOMIA"
      },
      {
        "codigo": "Z432",
        "valor": "ATENCION DE ILEOSTOMIA"
      },
      {
        "codigo": "Z433",
        "valor": "ATENCION DE COLOSTOMIA"
      },
      {
        "codigo": "Z434",
        "valor": "ATENCION DE OTROS ORIFICIOS ARTIFICIALES DE LAS VIAS DIGESTIVAS"
      },
      {
        "codigo": "Z435",
        "valor": "ATENCION DE CISTOSTOMIA"
      },
      {
        "codigo": "Z436",
        "valor": "ATENCION DE OTROS ORIFICIOS ARTIFICIALES DE LAS VIAS URINARIAS"
      },
      {
        "codigo": "Z437",
        "valor": "ATENCION DE VAGINA ARTIFICIAL"
      },
      {
        "codigo": "Z438",
        "valor": "ATENCION DE OTROS ORIFICIOS ARTIFICIALES"
      },
      {
        "codigo": "Z439",
        "valor": "ATENCION DE ORIFICIO ARTIFICIAL NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z44 - PRUEBA Y AJUSTE DE DISPOSITIVOS PROTESICOS EXTERNOS",
    "detalle": [
      {
        "codigo": "Z440",
        "valor": "PRUEBA Y AJUSTE DE BRAZO ARTIFICIAL (COMPLETO) (PARCIAL)"
      },
      {
        "codigo": "Z441",
        "valor": "PRUEBA Y AJUSTE DE PIERNA ARTIFICIAL (COMPLETA) (PARCIAL)"
      },
      {
        "codigo": "Z442",
        "valor": "PRUEBA Y AJUSTE DE OJO ARTIFICIAL"
      },
      {
        "codigo": "Z443",
        "valor": "PRUEBA Y AJUSTE DE PROTESIS MAMARIA EXTERNA"
      },
      {
        "codigo": "Z448",
        "valor": "PRUEBA Y AJUSTE DE OTROS DISPOSITIVOS PROTESICOS EXTERNOS"
      },
      {
        "codigo": "Z449",
        "valor": "PRUEBA Y AJUSTE DE DISPOSITIVO PROTESICO EXTERNO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z45 - ASISTENCIA Y AJUSTE DE DISPOSITIVOS IMPLANTADOS",
    "detalle": [
      {
        "codigo": "Z450",
        "valor": "ASISTENCIA Y AJUSTE DE DISPOSITIVOS CARDIACOS"
      },
      {
        "codigo": "Z451",
        "valor": "ASISTENCIA Y AJUSTE DE BOMBA DE INFUSION"
      },
      {
        "codigo": "Z452",
        "valor": "ASISTENCIA Y AJUSTE DE DISPOSITIVOS DE ACCESO VASCULAR"
      },
      {
        "codigo": "Z453",
        "valor": "ASISTENCIA Y AJUSTE DE DISPOSITIVO AUDITIVO IMPLANTADO"
      },
      {
        "codigo": "Z458",
        "valor": "ASISTENCIA Y AJUSTE DE OTROS DISPOSITIVOS IMPLANTADOS"
      },
      {
        "codigo": "Z459",
        "valor": "ASISTENCIA Y AJUSTE DE DISPOSITIVO IMPLANTADO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z46 - PRUEBA Y AJUSTE DE OTROS DISPOSITIVOS",
    "detalle": [
      {
        "codigo": "Z460",
        "valor": "PRUEBA Y AJUSTE DE ANTEOJOS Y LENTES DE CONTACTO"
      },
      {
        "codigo": "Z461",
        "valor": "PRUEBA Y AJUSTE DE AUDIFONOS"
      },
      {
        "codigo": "Z462",
        "valor": "PRUEBA Y AJUSTE DE OTROS DISPOSITIVOS RELACIONADOS CON EL SISTEMA NERVIOSO Y LOS SENTIDOS ESPECIALES"
      },
      {
        "codigo": "Z463",
        "valor": "PRUEBA Y AJUSTE DE PROTESIS DENTAL"
      },
      {
        "codigo": "Z4631",
        "valor": "PROTESIS FIJA"
      },
      {
        "codigo": "Z4632",
        "valor": "PROTESIS REMOVIBLE"
      },
      {
        "codigo": "Z4633",
        "valor": "PROTESIS TOTAL"
      },
      {
        "codigo": "Z4634",
        "valor": "INCRUSTRACION"
      },
      {
        "codigo": "Z464",
        "valor": "PRUEBA Y AJUSTE DE DISPOSITIVO ORTODONCICO"
      },
      {
        "codigo": "Z465",
        "valor": "PRUEBA Y AJUSTE DE ILEOSTOMIA U OTRO DISPOSITIVO INTESTINAL"
      },
      {
        "codigo": "Z466",
        "valor": "PRUEBA Y AJUSTE DE DISPOSITIVO URINARIO"
      },
      {
        "codigo": "Z467",
        "valor": "PRUEBA Y AJUSTE DE DISPOSITIVO ORTOPEDICO"
      },
      {
        "codigo": "Z468",
        "valor": "PRUEBA Y AJUSTE DE OTROS DISPOSITIVOS ESPECIFICADOS"
      },
      {
        "codigo": "Z469",
        "valor": "PRUEBA Y AJUSTE DE DISPOSITIVO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z47 - OTROS CUIDADOS POSTERIORES A LA ORTOPEDIA",
    "detalle": [
      {
        "codigo": "Z470",
        "valor": "CUIDADOS POSTERIORES A LA EXTRACCION DE PLACA U OTRO DISPOSITIVO DE FIJACION INTERNA EN FRACTURA"
      },
      {
        "codigo": "Z478",
        "valor": "OTROS CUIDADOS ESPECIFICADOS POSTERIORES A LA ORTOPEDIA"
      },
      {
        "codigo": "Z479",
        "valor": "CUIDADO POSTERIOR A LA ORTOPEDIA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z48 - OTROS CUIDADOS POSTERIORES A LA CIRUGIA",
    "detalle": [
      {
        "codigo": "Z480",
        "valor": "ATENCION DE LOS APOSITOS Y SUTURAS"
      },
      {
        "codigo": "Z488",
        "valor": "OTROS CUIDADOS ESPECIFICADOS POSTERIORES A LA CIRUGIA"
      },
      {
        "codigo": "Z489",
        "valor": "CUIDADO POSTERIOR A LA CIRUGIA, NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z49 - CUIDADOS RELATIVOS AL PROCEDIMIENTO DE DIALISIS",
    "detalle": [
      {
        "codigo": "Z490",
        "valor": "CUIDADOS PREPARATORIOS PARA DIALISIS"
      },
      {
        "codigo": "Z491",
        "valor": "DIALISIS EXTRAÑORPOREA"
      },
      {
        "codigo": "Z492",
        "valor": "OTRAS DIALISIS"
      }
    ]
  },
  {
    "grupo": "Z50 - ATENCION POR EL USO DE PROCEDIMIENTOS DE REHABILITACION",
    "detalle": [
      {
        "codigo": "Z500",
        "valor": "REHABILITACION CARDIACA"
      },
      {
        "codigo": "Z501",
        "valor": "OTRAS TERAPIAS FISICAS"
      },
      {
        "codigo": "Z502",
        "valor": "REHABILITACION DEL ALCOHOLICO"
      },
      {
        "codigo": "Z503",
        "valor": "REHABILITACION DEL DROGADICTO"
      },
      {
        "codigo": "Z504",
        "valor": "PSICOTERAPIA, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "Z505",
        "valor": "TERAPIA DEL LENGUAJE"
      },
      {
        "codigo": "Z506",
        "valor": "ADIESTRAMIENTO ORTOPTICO"
      },
      {
        "codigo": "Z507",
        "valor": "TERAPIA OCUPACIONAL Y REHABILITACION VOCACIONAL, NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "Z508",
        "valor": "ATENCION POR OTROS PROCEDIMIENTOS DE REHABILITACION"
      },
      {
        "codigo": "Z509",
        "valor": "ATENCION POR PROCEDIMIENTO DE REHABILITACION, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z51 - OTRA ATENCION MEDICA",
    "detalle": [
      {
        "codigo": "Z510",
        "valor": "SESION DE RADIOTERAPIA"
      },
      {
        "codigo": "Z5101",
        "valor": "RADIOTERAPIA"
      },
      {
        "codigo": "Z5102",
        "valor": "LASER TERAPIA"
      },
      {
        "codigo": "Z5103",
        "valor": "RADIUM INTRACAVITARIO"
      },
      {
        "codigo": "Z511",
        "valor": "SESION DE QUIMIOTERAPIA POR TUMOR"
      },
      {
        "codigo": "Z512",
        "valor": "OTRA QUIMIOTERAPIA"
      },
      {
        "codigo": "Z513",
        "valor": "TRANSFUSION DE SANGRE SIN DIAGNOSTICO INFORMADO"
      },
      {
        "codigo": "Z514",
        "valor": "ATENCION PREPARATORIA PARA TRATAMIENTO SUBSECUENTE, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "Z515",
        "valor": "ATENCION PALIATIVA"
      },
      {
        "codigo": "Z516",
        "valor": "DESENSIBILIZACION A ALERGENOS"
      },
      {
        "codigo": "Z518",
        "valor": "OTRAS ATENCIONES MEDICAS ESPECIFICADAS"
      },
      {
        "codigo": "Z5181",
        "valor": "QUIMIOPROFILAXIS COTRIMOXAZOL"
      },
      {
        "codigo": "Z5182",
        "valor": "QUIMIOPROFILAXIS CON ISONIAZIDA"
      },
      {
        "codigo": "Z5183",
        "valor": "TRATAMIENTO ANTIVIRAL PARA VIH"
      },
      {
        "codigo": "Z5184",
        "valor": "LACTANCIA ARTIFICIAL RECIEN NACIDO DE MADRE VIH (+)"
      },
      {
        "codigo": "Z5185",
        "valor": "TRATAMIENTO ANTIRRETROVIRAL PARA LA MADRE VIH (+)"
      },
      {
        "codigo": "Z5186",
        "valor": "TRATAMIENTO ANTIRRETROVIRAL RECIEN NACIDO MADRE VIH (+)"
      },
      {
        "codigo": "Z5187",
        "valor": "TRATAMIENTO PROFILACTICO ANTIRETROVIRAL CON ZIDOVUDINA"
      },
      {
        "codigo": "Z5188",
        "valor": "TRATAMIENTO PROFILACTICO ANTIRETROVIRAL CON NEVIRAPINA"
      },
      {
        "codigo": "Z5189",
        "valor": "TRATAMIENTO PROFILACTICO PARA VIH POR EXPOSICION"
      },
      {
        "codigo": "Z519",
        "valor": "ATENCION MEDICA, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z52 - DONANTES DE ORGANOS Y TEJIDOS",
    "detalle": [
      {
        "codigo": "Z520",
        "valor": "DONANTE DE SANGRE"
      },
      {
        "codigo": "Z521",
        "valor": "DONANTE DE PIEL"
      },
      {
        "codigo": "Z522",
        "valor": "DONANTE DE HUESO"
      },
      {
        "codigo": "Z523",
        "valor": "DONANTE DE MEDULA OSEA"
      },
      {
        "codigo": "Z524",
        "valor": "DONANTE DE RIÑON"
      },
      {
        "codigo": "Z525",
        "valor": "DONANTE DE CORNEA"
      },
      {
        "codigo": "Z526",
        "valor": "DONANTE DE HIGADO"
      },
      {
        "codigo": "Z527",
        "valor": "DONANTE DE CORAZON"
      },
      {
        "codigo": "Z528",
        "valor": "DONANTE DE OTROS ORGANOS O TEJIDOS"
      },
      {
        "codigo": "Z529",
        "valor": "DONANTE DE ORGANO O TEJIDO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z53 - PERSONA EN CONTACTO CON LOS SERVICIOS DE SALUD PARA PROCEDIMIENTOS ESPECIFICOS NO REALIZADOS",
    "detalle": [
      {
        "codigo": "Z530",
        "valor": "PROCEDIMIENTO NO REALIZADO POR CONTRAINDICACION"
      },
      {
        "codigo": "Z531",
        "valor": "PROCEDIMIENTO NO REALIZADO POR DECISION DEL PACIENTE, POR RAZONES DE CREENCIA O PRESION DE GRUPO"
      },
      {
        "codigo": "Z532",
        "valor": "PROCEDIMIENTO NO REALIZADO POR DECISION DEL PACIENTE, POR OTRAS RAZONES Y LAS NO ESPECIFICADAS"
      },
      {
        "codigo": "Z538",
        "valor": "PROCEDIMIENTO NO REALIZADO POR OTRAS RAZONES"
      },
      {
        "codigo": "Z539",
        "valor": "PROCEDIMIENTO NO REALIZADO POR RAZON NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z54 - CONVALECENCIA",
    "detalle": [
      {
        "codigo": "Z540",
        "valor": "CONVALECENCIA CONSECUTIVA A CIRUGIA"
      },
      {
        "codigo": "Z541",
        "valor": "CONVALECENCIA CONSECUTIVA A RADIOTERAPIA"
      },
      {
        "codigo": "Z542",
        "valor": "CONVALECENCIA CONSECUTIVA A QUIMIOTERAPIA"
      },
      {
        "codigo": "Z543",
        "valor": "CONVALECENCIA CONSECUTIVA A PSICOTERAPIA"
      },
      {
        "codigo": "Z544",
        "valor": "CONVALECENCIA CONSECUTIVA A TRATAMIENTO DE FRACTURA"
      },
      {
        "codigo": "Z547",
        "valor": "CONVALECENCIA CONSECUTIVA A TRATAMIENTO COMBINADO"
      },
      {
        "codigo": "Z548",
        "valor": "CONVALECENCIA CONSECUTIVA A OTROS TRATAMIENTOS"
      },
      {
        "codigo": "Z549",
        "valor": "CONVALECENCIA CONSECUTIVA A TRATAMIENTO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z55 - PROBLEMAS RELACIONADOS CON LA EDUCACION Y LA ALFABETIZACION",
    "detalle": [
      {
        "codigo": "Z550",
        "valor": "PROBLEMAS RELACIONADOS CON EL ANALFABETISMO O BAJO NIVEL DE INSTRUCCION"
      },
      {
        "codigo": "Z551",
        "valor": "PROBLEMAS RELACIONADOS CON LA EDUCACION NO DISPONIBLE O INACCESIBLE"
      },
      {
        "codigo": "Z552",
        "valor": "PROBLEMAS RELACIONADOS CON LA FALLA EN LOS EXAMENES"
      },
      {
        "codigo": "Z553",
        "valor": "PROBLEMAS RELACIONADOS CON EL BAJO RENDIMIENTO ESCOLAR"
      },
      {
        "codigo": "Z554",
        "valor": "PROBLEMAS RELACIONADOS CON LA INADAPTACION EDUCACIONAL Y DESAVENENCIAS CON MAESTROS Y COMPAÑEROS"
      },
      {
        "codigo": "Z558",
        "valor": "OTROS PROBLEMAS RELACIONADOS CON LA EDUCACION Y LA ALFABETIZACION"
      },
      {
        "codigo": "Z559",
        "valor": "PROBLEMA NO ESPECIFICADO RELACIONADO CON LA EDUCACION Y LA ALFABETIZACION"
      }
    ]
  },
  {
    "grupo": "Z56 - PROBLEMAS RELACIONADOS CON EL EMPLEO Y EL DESEMPLEO",
    "detalle": [
      {
        "codigo": "Z560",
        "valor": "PROBLEMAS RELACIONADOS CON EL DESEMPLEO, NO ESPECIFICADOS"
      },
      {
        "codigo": "Z561",
        "valor": "PROBLEMAS RELACIONADOS CON EL CAMBIO DE EMPLEO"
      },
      {
        "codigo": "Z562",
        "valor": "PROBLEMAS RELACIONADOS CON AMENAZA DE PERDIDA DEL EMPLEO"
      },
      {
        "codigo": "Z563",
        "valor": "PROBLEMAS RELACIONADOS CON HORARIO ESTRESANTE DE TRABAJO"
      },
      {
        "codigo": "Z564",
        "valor": "PROBLEMAS RELACIONADOS CON DESAVENENCIAS CON EL JEFE Y LOS COMPAÑEROS DE TRABAJO"
      },
      {
        "codigo": "Z565",
        "valor": "PROBLEMAS RELACIONADOS CON EL TRABAJO INCOMPATIBLE"
      },
      {
        "codigo": "Z566",
        "valor": "OTROS PROBLEMAS DE TENSION FISICA O MENTAL RELACIONADAS CON EL TRABAJO"
      },
      {
        "codigo": "Z567",
        "valor": "OTROS PROBLEMAS Y LOS NO ESPECIFICADOS RELACIONADOS CON EL EMPLEO"
      }
    ]
  },
  {
    "grupo": "Z57 - EXPOSICION A FACTORES DE RIESGO OCUPACIONAL",
    "detalle": [
      {
        "codigo": "Z570",
        "valor": "EXPOSICION OCUPACIONAL AL RUIDO"
      },
      {
        "codigo": "Z571",
        "valor": "EXPOSICION OCUPACIONAL A LA RADIACION"
      },
      {
        "codigo": "Z572",
        "valor": "EXPOSICION OCUPACIONAL AL POLVO"
      },
      {
        "codigo": "Z573",
        "valor": "EXPOSICION OCUPACIONAL A OTRO CONTAMINANTE DEL AIRE"
      },
      {
        "codigo": "Z574",
        "valor": "EXPOSICION OCUPACIONAL A AGENTES TOXICOS EN AGRICULTURA"
      },
      {
        "codigo": "Z575",
        "valor": "EXPOSICION OCUPACIONAL A AGENTES TOXICOS EN OTRAS INDUSTRIAS"
      },
      {
        "codigo": "Z5751",
        "valor": "EXPOSICION OCUPACIONAL A METALES PESADOS (HIERRO, PLOMO, CADMIO, ARSENICO, MERCURIO)"
      },
      {
        "codigo": "Z576",
        "valor": "EXPOSICION OCUPACIONAL A TEMPERATURA EXTREMA"
      },
      {
        "codigo": "Z577",
        "valor": "EXPOSICION OCUPACIONAL A LA VIBRACION"
      },
      {
        "codigo": "Z578",
        "valor": "EXPOSICION OCUPACIONAL A OTROS FACTORES DE RIESGO"
      },
      {
        "codigo": "Z5781",
        "valor": "EXPOSICION OCUPACIONAL A AGENTES BIOLOGICOS"
      },
      {
        "codigo": "Z5782",
        "valor": "EXPOSICION OCUPACIONAL A FACTORES PSICOSOCIALES"
      },
      {
        "codigo": "Z5783",
        "valor": "EXPOSICION OCUPACIONAL A FACTORES ERGONOMICOS"
      },
      {
        "codigo": "Z579",
        "valor": "EXPOSICION OCUPACIONAL A FACTOR DE RIESGO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z58 - PROBLEMAS RELACIONADOS CON EL AMBIENTE FISICO",
    "detalle": [
      {
        "codigo": "Z580",
        "valor": "EXPOSICION AL RUIDO"
      },
      {
        "codigo": "Z581",
        "valor": "EXPOSICION AL AIRE CONTAMINADO"
      },
      {
        "codigo": "Z582",
        "valor": "EXPOSICION AL AGUA CONTAMINADA"
      },
      {
        "codigo": "Z583",
        "valor": "EXPOSICION AL SUELO CONTAMINADO"
      },
      {
        "codigo": "Z584",
        "valor": "EXPOSICION A LA RADIACION"
      },
      {
        "codigo": "Z585",
        "valor": "EXPOSICION A OTRAS CONTAMINACIONES DEL AMBIENTE FISICO"
      },
      {
        "codigo": "Z586",
        "valor": "SUMINISTRO INADECUADO DE AGUA POTABLE"
      },
      {
        "codigo": "Z587",
        "valor": "EXPOSICION AL HUMO DEL TABACO"
      },
      {
        "codigo": "Z588",
        "valor": "OTROS PROBLEMAS RELACIONADOS CON EL AMBIENTE FISICO"
      },
      {
        "codigo": "Z589",
        "valor": "PROBLEMA NO ESPECIFICADO RELACIONADO CON EL AMBIENTE FISICO"
      }
    ]
  },
  {
    "grupo": "Z59 - PROBLEMAS RELACIONADOS CON LA VIVIENDA Y LAS CIRCUNSTANCIAS ECONOMICAS",
    "detalle": [
      {
        "codigo": "Z590",
        "valor": "PROBLEMAS RELACIONADOS CON LA FALTA DE VIVIENDA"
      },
      {
        "codigo": "Z591",
        "valor": "PROBLEMAS RELACIONADOS CON VIVIENDA INADECUADA"
      },
      {
        "codigo": "Z592",
        "valor": "PROBLEMAS CASEROS Y CON VECINOS E INQUILINOS"
      },
      {
        "codigo": "Z593",
        "valor": "PROBLEMAS RELACIONADOS CON PERSONA QUE RESIDE EN UNA INSTITUCION"
      },
      {
        "codigo": "Z594",
        "valor": "PROBLEMAS RELACIONADOS CON LA FALTA DE ALIMENTOS ADECUADOS"
      },
      {
        "codigo": "Z595",
        "valor": "PROBLEMAS RELACIONADOS CON POBREZA EXTREMA"
      },
      {
        "codigo": "Z596",
        "valor": "PROBLEMAS RELACIONADOS CON BAJOS INGRESOS"
      },
      {
        "codigo": "Z5961",
        "valor": "POBREZA RECIENTE"
      },
      {
        "codigo": "Z5962",
        "valor": "POBREZA CRONICA"
      },
      {
        "codigo": "Z597",
        "valor": "PROBLEMAS RELACIONADOS CON SEGURIDAD SOCIAL Y SOSTENIMIENTO INSUFICIENTES PARA EL BIENESTAR"
      },
      {
        "codigo": "Z598",
        "valor": "OTROS PROBLEMAS RELACIONADOS CON LA VIVIENDA Y LAS CIRCUNSTANCIAS ECONOMICAS"
      },
      {
        "codigo": "Z599",
        "valor": "PROBLEMAS NO ESPECIFICADOS RELACIONADOS CON LA VIVIENDA Y LAS CIRCUNSTANCIAS ECONOMICAS"
      }
    ]
  },
  {
    "grupo": "Z60 - PROBLEMAS RELACIONADOS CON EL AMBIENTE SOCIAL",
    "detalle": [
      {
        "codigo": "Z600",
        "valor": "PROBLEMAS RELACIONADOS CON EL AJUSTE A LAS TRANSICIONES DEL CICLO VITAL"
      },
      {
        "codigo": "Z601",
        "valor": "PROBLEMAS RELACIONADOS CON SITUACION FAMILIAR ATIPICA"
      },
      {
        "codigo": "Z602",
        "valor": "PROBLEMAS RELACIONADOS CON PERSONA QUE VIVE SOLA"
      },
      {
        "codigo": "Z603",
        "valor": "PROBLEMAS RELACIONADOS CON LA ADAPTACION CULTURAL"
      },
      {
        "codigo": "Z604",
        "valor": "PROBLEMAS RELACIONADOS CON EXCLUSION Y RECHAZO SOCIAL"
      },
      {
        "codigo": "Z6041",
        "valor": "PACIENTE ABANDONADO"
      },
      {
        "codigo": "Z605",
        "valor": "PROBLEMAS RELACIONADOS CON LA DISCRIMINACION Y PERSECUCION PERCIBIDAS"
      },
      {
        "codigo": "Z608",
        "valor": "OTROS PROBLEMAS RELACIONADOS CON EL AMBIENTE SOCIAL"
      },
      {
        "codigo": "Z6081",
        "valor": "PERSONA EN ABANDONO SOCIAL"
      },
      {
        "codigo": "Z609",
        "valor": "PROBLEMA NO ESPECIFICADO RELACIONADO CON EL AMBIENTE SOCIAL"
      }
    ]
  },
  {
    "grupo": "Z61 - PROBLEMAS RELACIONADOS CON HECHOS NEGATIVOS EN LA NIÑEZ",
    "detalle": [
      {
        "codigo": "Z610",
        "valor": "PROBLEMAS RELACIONADOS CON LA PERDIDA DE RELACION AFECTIVA EN LA INFANCIA"
      },
      {
        "codigo": "Z611",
        "valor": "PROBLEMAS RELACIONADOS CON EL ALEJAMIENTO DEL HOGAR EN LA INFANCIA"
      },
      {
        "codigo": "Z6111",
        "valor": "NIÑO EN ABANDONO SOCIAL SIN SOPORTE FAMILIAR O SOCIAL INSTITUCIONAL."
      },
      {
        "codigo": "Z612",
        "valor": "PROBLEMAS RELACIONADOS CON ALTERACION EN EL PATRON DE LA RELACION FAMILIAR EN LA INFANCIA"
      },
      {
        "codigo": "Z613",
        "valor": "PROBLEMAS RELACIONADOS CON EVENTOS QUE LLEVARON A LA PERDIDA DE LA AUTOESTIMA EN LA INFANCIA"
      },
      {
        "codigo": "Z614",
        "valor": "PROBLEMAS RELACIONADOS CON EL ABUSO SEXUAL DEL NIÑO POR PERSONA DENTRO DEL GRUPO DE APOYO PRIMARIO"
      },
      {
        "codigo": "Z615",
        "valor": "PROBLEMAS RELACIONADOS CON EL ABUSO SEXUAL DEL NIÑO POR PERSONA AJENA AL GRUPO DE APOYO PRIMARIO"
      },
      {
        "codigo": "Z616",
        "valor": "PROBLEMAS RELACIONADOS CON ABUSO FISICO DEL NIÑO"
      },
      {
        "codigo": "Z617",
        "valor": "PROBLEMAS RELACIONADOS CON EXPERIENCIAS PERSONALES ATEMORIZANTES EN LA INFANCIA"
      },
      {
        "codigo": "Z618",
        "valor": "PROBLEMAS RELACIONADOS CON OTRAS EXPERIENCIAS NEGATIVAS EN LA INFANCIA"
      },
      {
        "codigo": "Z619",
        "valor": "PROBLEMAS RELACIONADOS CON EXPERIENCIA NEGATIVA NO ESPECIFICADA EN LA INFANCIA"
      }
    ]
  },
  {
    "grupo": "Z62 - OTROS PROBLEMAS RELACIONADOS CON LA CRIANZA DEL NIÑO",
    "detalle": [
      {
        "codigo": "Z620",
        "valor": "PROBLEMAS RELACIONADOS CON LA SUPERVISION O EL CONTROL INADECUADOS DE LOS PADRES"
      },
      {
        "codigo": "Z621",
        "valor": "PROBLEMAS RELACIONADOS CON LA SOBREPROTECCION DE LOS PADRES"
      },
      {
        "codigo": "Z622",
        "valor": "PROBLEMAS RELACIONADOS CON LA CRIANZA EN INSTITUCION"
      },
      {
        "codigo": "Z623",
        "valor": "PROBLEMAS RELACIONADOS CON HOSTILIDAD Y REPROBACION AL NIÑO"
      },
      {
        "codigo": "Z624",
        "valor": "PROBLEMAS RELACIONADOS CON EL ABANDONO EMOCIONAL DEL NIÑO"
      },
      {
        "codigo": "Z625",
        "valor": "OTROS PROBLEMAS RELACIONADOS CON NEGLIGENCIA EN LA CRIANZA DEL NIÑO"
      },
      {
        "codigo": "Z626",
        "valor": "PROBLEMAS RELACIONADOS CON PRESIONES INAPROPIADAS DE LOS PADRES Y OTRAS ANORMALIDADES EN LA CALIDAD DE LA CRIANZA"
      },
      {
        "codigo": "Z628",
        "valor": "OTROS PROBLEMAS ESPECIFICADOS Y RELACIONADOS CON LA CRIANZA DEL NIÑO"
      },
      {
        "codigo": "Z629",
        "valor": "PROBLEMA NO ESPECIFICADO RELACIONADO CON LA CRIANZA DEL NIÑO"
      }
    ]
  },
  {
    "grupo": "Z63 - OTROS PROBLEMAS RELACIONADOS CON EL GRUPO PRIMARIO DE APOYO, INCLUSIVE CIRCUNSTANCIAS FAMILIARES",
    "detalle": [
      {
        "codigo": "Z630",
        "valor": "PROBLEMAS EN LA RELACION ENTRE ESPOSOS O PAREJA"
      },
      {
        "codigo": "Z631",
        "valor": "PROBLEMAS EN LA RELACION CON LOS PADRES Y LOS FAMILIARES POLITICOS"
      },
      {
        "codigo": "Z632",
        "valor": "PROBLEMAS RELACIONADOS CON EL APOYO FAMILIAR INADECUADO"
      },
      {
        "codigo": "Z633",
        "valor": "PROBLEMAS RELACIONADOS CON LA AUSENCIA DE UN MIEMBRO DE LA FAMILIA"
      },
      {
        "codigo": "Z6331",
        "valor": "PROBLEMAS RELACIONADOS CON LA AUSENCIA DEL JEFE DEL HOGAR"
      },
      {
        "codigo": "Z634",
        "valor": "PROBLEMAS RELACIONADOS CON LA DESAPARICION O MUERTE DE UN MIEMBRO DE LA FAMILIA"
      },
      {
        "codigo": "Z635",
        "valor": "PROBLEMAS RELACIONADOS CON LA RUPTURA FAMILIAR POR SEPARACION O DIVORCIO"
      },
      {
        "codigo": "Z636",
        "valor": "PROBLEMAS RELACIONADOS CON FAMILIAR DEPENDIENTE, NECESITADO DE CUIDADO EN LA CASA"
      },
      {
        "codigo": "Z6361",
        "valor": "PERSONA ADULTA MAYOR INDEPENDIENTE"
      },
      {
        "codigo": "Z6362",
        "valor": "PERSONA ADULTA MAYOR DEPENDIENTE PARCIAL"
      },
      {
        "codigo": "Z6363",
        "valor": "PERSONA ADULTA MAYOR DEPENDIENTE TOTAL"
      },
      {
        "codigo": "Z637",
        "valor": "PROBLEMAS RELACIONADOS CON OTROS HECHOS ESTRESANTES QUE AFECTAN A LA FAMILIA Y AL HOGAR"
      },
      {
        "codigo": "Z638",
        "valor": "OTROS PROBLEMAS ESPECIFICADOS RELACIONADOS CON EL GRUPO PRIMARIO DE APOYO"
      },
      {
        "codigo": "Z6381",
        "valor": "PROBLEMAS SOCIALES RELACIONADOS CON LA VIOLENCIA FAMILIAR"
      },
      {
        "codigo": "Z639",
        "valor": "PROBLEMA NO ESPECIFICADO RELACIONADO CON EL GRUPO PRIMARIO DE APOYO"
      }
    ]
  },
  {
    "grupo": "Z64 - PROBLEMAS RELACIONADOS CON CIERTAS CIRCUNSTANCIAS PSICOSOCIALES",
    "detalle": [
      {
        "codigo": "Z640",
        "valor": "PROBLEMAS RELACIONADOS CON EMBARAZO NO DESEADO"
      },
      {
        "codigo": "Z641",
        "valor": "PROBLEMAS RELACIONADOS CON LA MULTIPARIDAD"
      },
      {
        "codigo": "Z642",
        "valor": "PROBLEMAS RELACIONADOS CON LA SOLICITUD O ACEPTACION DE INTERVENCIONES FISICAS, NUTRICIONALES Y QUIMICAS, CONOCIENDO SU RIESGO Y PELIGRO"
      },
      {
        "codigo": "Z643",
        "valor": "PROBLEMAS RELACIONADOS CON LA SOLICITUD O ACEPTACION DE INTERVENCIONES PSICOLOGICAS O DE LA CONDUCTA, CONOCIENDO SU RIESGO Y PELIGRO"
      },
      {
        "codigo": "Z644",
        "valor": "PROBLEMAS RELACIONADOS CON EL DESACUERDO CON CONSEJEROS"
      }
    ]
  },
  {
    "grupo": "Z65 - PROBLEMAS RELACIONADOS CON OTRAS CIRCUNSTANCIAS PSICOSOCIALES",
    "detalle": [
      {
        "codigo": "Z650",
        "valor": "PROBLEMAS RELACIONADOS CON CULPABILIDAD EN PROCEDIMIENTOS CIVILES O CRIMINALES SIN PRISION"
      },
      {
        "codigo": "Z651",
        "valor": "PROBLEMAS RELACIONADOS CON PRISION Y OTRO ENCARCELAMIENTO"
      },
      {
        "codigo": "Z652",
        "valor": "PROBLEMAS RELACIONADOS CON LA LIBERACION DE LA PRISION"
      },
      {
        "codigo": "Z653",
        "valor": "PROBLEMAS RELACIONADOS CON OTRAS CIRCUNSTANCIAS LEGALES"
      },
      {
        "codigo": "Z654",
        "valor": "PROBLEMAS RELACIONADOS CON VICTIMA DE CRIMEN O TERRORISMO"
      },
      {
        "codigo": "Z655",
        "valor": "PROBLEMAS RELACIONADOS CON LA EXPOSICION A DESASTRE, GUERRA U OTRAS HOSTILIDADES"
      },
      {
        "codigo": "Z658",
        "valor": "OTROS PROBLEMAS ESPECIFICADOS RELACIONADOS CON CIRCUNSTANCIANCIAS PSICOSOCIALES"
      },
      {
        "codigo": "Z659",
        "valor": "PROBLEMAS RELACIONADOS CON CIRCUNSTANCIAS PSICOSOCIALES NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Z70 - CONSULTA RELACIONADA CON ACTITUD, CONDUCTA U ORIENTACION SEXUAL",
    "detalle": [
      {
        "codigo": "Z700",
        "valor": "CONSULTA RELACIONADA CON LA ACTITUD SEXUAL"
      },
      {
        "codigo": "Z701",
        "valor": "CONSULTA RELACIONADA CON LA ORIENTACION Y CONDUCTA SEXUAL DEL PACIENTE"
      },
      {
        "codigo": "Z702",
        "valor": "CONSULTA RELACIONADA CON LA ORIENTACION Y CONDUCTA SEXUAL DE UNA TERCERA PERSONA"
      },
      {
        "codigo": "Z703",
        "valor": "CONSULTA RELACIONADA CON PREOCUPACIONES COMBINADAS SOBRE LA ACTITUD, LA CONDUCTA Y LA ORIENTACION SEXUALES"
      },
      {
        "codigo": "Z704",
        "valor": "CONTROL DE TRABAJADORES SEXUALES"
      },
      {
        "codigo": "Z708",
        "valor": "OTRAS CONSULTAS SEXUALES ESPECIFICAS"
      },
      {
        "codigo": "Z709",
        "valor": "CONSULTA SEXUAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z71 - PERSONAS EN CONTACTO CON LOS SERVICIOS DE SALUD POR OTRAS CONSULTAS Y CONSEJOS MEDICOS NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Z710",
        "valor": "PERSONA QUE CONSULTA EN NOMBRE DE OTRA PERSONA"
      },
      {
        "codigo": "Z711",
        "valor": "PERSONA QUE TEME ESTAR ENFERMA, A QUIEN NO SE HACE DIAGNOSTICO"
      },
      {
        "codigo": "Z712",
        "valor": "PERSONA QUE CONSULTA PARA LA EXPLICACION DE HALLAZGOS DE INVESTIGACION"
      },
      {
        "codigo": "Z713",
        "valor": "CONSULTA PARA INSTRUCCION Y VIGILANCIA DE LA DIETA"
      },
      {
        "codigo": "Z714",
        "valor": "CONSULTA PARA ASESORIA Y VIGILANCIA POR ABUSO DE ALCOHOL"
      },
      {
        "codigo": "Z715",
        "valor": "CONSULTA PARA ASESORIA Y VIGILANCIA POR ABUSO DE DROGAS"
      },
      {
        "codigo": "Z716",
        "valor": "CONSULTA PARA ASESORIA POR ABUSO DE TABACO"
      },
      {
        "codigo": "Z717",
        "valor": "CONSULTA PARA ASESORIA SOBRE EL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]"
      },
      {
        "codigo": "Z7171",
        "valor": "CONSEJERIA PRE-TEST PARA VIH"
      },
      {
        "codigo": "Z7172",
        "valor": "CONSEJERIA POST-TEST POSITIVO PARA VIH"
      },
      {
        "codigo": "Z7173",
        "valor": "CONSEJERIA POST-TEST NEGATIVO PARA VIH"
      },
      {
        "codigo": "Z7174",
        "valor": "CONSEJERIA A PERSONAS QUE VIVEN CON VIH/SIDA"
      },
      {
        "codigo": "Z718",
        "valor": "OTRAS CONSULTAS ESPECIFICADAS"
      },
      {
        "codigo": "Z719",
        "valor": "CONSULTA, NO ESPECIFICADA"
      },
      {
        "codigo": "Z7191",
        "valor": "CONSULTA ODONTOESTOMATOLOGICA"
      }
    ]
  },
  {
    "grupo": "Z72 - PROBLEMAS RELACIONADOS CON EL ESTILO DE VIDA",
    "detalle": [
      {
        "codigo": "Z720",
        "valor": "PROBLEMAS RELACIONADOS CON EL USO DEL TABACO"
      },
      {
        "codigo": "Z721",
        "valor": "PROBLEMAS RELACIONADOS CON EL USO DEL ALCOHOL"
      },
      {
        "codigo": "Z722",
        "valor": "PROBLEMAS RELACIONADOS CON EL USO DE DROGAS"
      },
      {
        "codigo": "Z723",
        "valor": "PROBLEMAS RELACIONADOS CON FALTA DE EJERCICIO FISICO"
      },
      {
        "codigo": "Z724",
        "valor": "PROBLEMAS RELACIONADOS CON LA DIETA Y HABITOS ALIMENTARIOS INAPROPIADOS"
      },
      {
        "codigo": "Z7241",
        "valor": "RIESGO DE DESNUTRICION"
      },
      {
        "codigo": "Z725",
        "valor": "PROBLEMAS RELACIONADOS CON LA CONDUCTA SEXUAL DE ALTO RIESGO"
      },
      {
        "codigo": "Z7251",
        "valor": "RIESGO DE EMBARAZO POR LA CONDUCTA SEXUAL DE ALTO RIESGO"
      },
      {
        "codigo": "Z7252",
        "valor": "RIESGO DE ETS POR LA CONDUCTA SEXUAL DE ALTO RIESGO"
      },
      {
        "codigo": "Z7253",
        "valor": "RIESGO DE SIDA POR LA CONDUCTA SEXUAL DE ALTO RIESGO"
      },
      {
        "codigo": "Z7254",
        "valor": "RIESGO DE SIDA POR LA CONDUCTA NO SEXUAL"
      },
      {
        "codigo": "Z726",
        "valor": "PROBLEMAS RELACIONADOS CON EL JUEGO Y LAS APUESTAS"
      },
      {
        "codigo": "Z728",
        "valor": "OTROS PROBLEMAS RELACIONADOS CON EL ESTILO DE VIDA"
      },
      {
        "codigo": "Z7281",
        "valor": "RIESGO DE LESIONES Y ACCIDENTES"
      },
      {
        "codigo": "Z729",
        "valor": "PROBLEMA NO ESPECIFICADO RELACIONADO CON EL ESTILO DE VIDA"
      }
    ]
  },
  {
    "grupo": "Z73 - PROBLEMAS RELACIONADOS CON DIFICULTADES CON EL MODO DE VIDA",
    "detalle": [
      {
        "codigo": "Z730",
        "valor": "PROBLEMAS RELACIONADOS CON LA ENFERMEDAD CONSUNTIVA"
      },
      {
        "codigo": "Z731",
        "valor": "PROBLEMAS RELACIONADOS CON LA ACENTUACION DE RASGOS DE LA PERSONALIDAD"
      },
      {
        "codigo": "Z732",
        "valor": "PROBLEMAS RELACIONADOS CON LA FALTA DE RELAJACION Y DESCANSO"
      },
      {
        "codigo": "Z733",
        "valor": "PROBLEMAS RELACIONADOS CON EL ESTRES, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Z734",
        "valor": "PROBLEMAS RELACIONADOS CON HABILIDADES SOCIALES INADECUADAS, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Z735",
        "valor": "PROBLEMAS RELACIONADOS CON EL CONFLICTO DEL ROL SOCIAL, NO CLASIFICADOS EN OTRA PARTE"
      },
      {
        "codigo": "Z736",
        "valor": "PROBLEMAS RELACIONADOS CON LA LIMITACION DE LAS ACTIVIDADES DEBIDO A DISCAPACIDAD"
      },
      {
        "codigo": "Z738",
        "valor": "OTROS PROBLEMAS RELACIONADOS CON DIFICULTADES CON EL MODO DE VIDA"
      },
      {
        "codigo": "Z739",
        "valor": "PROBLEMAS NO ESPECIFICADOS RELACIONADOS CON DIFICULTADES CON EL MODO DE VIDA"
      }
    ]
  },
  {
    "grupo": "Z74 - PROBLEMAS RELACIONADOS CON DEPENDENCIA DEL PRESTADOR DE SERVICIOS",
    "detalle": [
      {
        "codigo": "Z740",
        "valor": "NECESIDAD DE ASISTENCIA DEBIDA A MOVILIDAD REDUCIDA"
      },
      {
        "codigo": "Z741",
        "valor": "PROBLEMAS RELACIONADOS CON LA NECESIDAD DE AYUDA PARA EL CUIDADO PERSONAL"
      },
      {
        "codigo": "Z742",
        "valor": "PROBLEMAS RELACIONADOS CON LA NECESIDAD DE ASISTENCIA DOMICILIARIA Y QUE NINGUN OTRO MIEMBRO DEL HOGAR PUEDE PROPORCIONAR"
      },
      {
        "codigo": "Z743",
        "valor": "PROBLEMAS RELACIONADOS CON LA NECESIDAD DE SUPERVISION CONTINUA"
      },
      {
        "codigo": "Z748",
        "valor": "OTROS PROBLEMAS RELACIONADOS CON DEPENDENCIA DEL PRESTADOR DE SERVICIOS"
      },
      {
        "codigo": "Z749",
        "valor": "PROBLEMA NO ESPECIFICADO RELACIONADO CON DEPENDENCIA DEL PRESTADOR DE SERVICIOS"
      }
    ]
  },
  {
    "grupo": "Z75 - PROBLEMAS RELACIONADOS CON FACILIDADES DE ATENCION MEDICA U OTROS SERVICIOS DE SALUD",
    "detalle": [
      {
        "codigo": "Z750",
        "valor": "PROBLEMAS RELACIONADOS CON SERVICIO MEDICO NO DISPONIBLE EN EL DOMICILIO"
      },
      {
        "codigo": "Z751",
        "valor": "PROBLEMAS RELACIONADOS CON PERSONA ESPERANDO ADMISION EN UNA INSTITUCION APROPIADA EN OTRO LUGAR"
      },
      {
        "codigo": "Z752",
        "valor": "PROBLEMAS RELACIONADOS CON PERSONA EN OTRO PERIODO DE ESPERA PARA INVESTIGACION Y TRATAMIENTO"
      },
      {
        "codigo": "Z753",
        "valor": "PROBLEMAS RELACIONADOS CON ATENCION DE SALUD NO DISPONIBLE O INACCESIBLE"
      },
      {
        "codigo": "Z754",
        "valor": "PROBLEMAS RELACIONADOS CON OTROS SERVICIOS ASISTENCIALES NO DISPONIBLES O INACCESIBLES"
      },
      {
        "codigo": "Z755",
        "valor": "PROBLEMAS RELACIONADOS CON LA ATENCION DURANTE VACACIONES DE LA FAMILIA"
      },
      {
        "codigo": "Z758",
        "valor": "OTROS PROBLEMAS RELACIONADOS CON SERVICIOS MEDICOS Y DE SALUD"
      },
      {
        "codigo": "Z759",
        "valor": "PROBLEMA NO ESPECIFICADO RELACIONADO CON SERVICIOS MEDICOS Y DE SALUD"
      }
    ]
  },
  {
    "grupo": "Z76 - PERSONAS EN CONTACTO CON LOS SERVICIOS DE SALUD POR OTRAS CIRCUNSTANCIAS",
    "detalle": [
      {
        "codigo": "Z760",
        "valor": "CONSULTA PARA REPETICION DE RECETA"
      },
      {
        "codigo": "Z761",
        "valor": "CONSULTA PARA ATENCION Y SUPERVISION DE LA SALUD DEL NIÑO ABANDONADO"
      },
      {
        "codigo": "Z762",
        "valor": "CONSULTA PARA ATENCION Y SUPERVISION DE LA SALUD DE OTROS NIÑOS O LACTANTES SANOS"
      },
      {
        "codigo": "Z763",
        "valor": "PERSONA SANA QUE ACOMPAÑA AL ENFERMO"
      },
      {
        "codigo": "Z764",
        "valor": "OTRO HUESPED EN SERVICIOS DE SALUD"
      },
      {
        "codigo": "Z765",
        "valor": "PERSONA QUE CONSULTA CON SIMULACION CONSCIENTE [SIMULADOR]"
      },
      {
        "codigo": "Z768",
        "valor": "PERSONA EN CONTACTO CON LOS SERVICIOS DE SALUD EN OTRAS CIRCUNSTANCIAS ESPECIFICADAS"
      },
      {
        "codigo": "Z769",
        "valor": "PERSONA EN CONTACTO CON LOS SERVICIOS DE SALUD EN CIRCUNSTANCIAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Z77 - DISCORDANCIA DE IDENTIDAD DE GENERO",
    "detalle": [
      {
        "codigo": "Z770",
        "valor": "DISCORDANCIA DE GENERO EN LA ADOLESCENCIA O ADULTEZ"
      },
      {
        "codigo": "Z771",
        "valor": "DISCORDANCIA DE GENERO EN LA INFANCIA"
      },
      {
        "codigo": "Z772",
        "valor": "DISCORDANCIA DE GENERO SIN ESPECIFICACION"
      },
      {
        "codigo": "Z773",
        "valor": "ASESORAMIENTO RELACIONADO CON EL COMPORTAMIENTO Y LA ORIENTACION SEXUAL O LAS RELACIONES SEXUALES DE LA PERSONA"
      }
    ]
  },
  {
    "grupo": "Z80 - HISTORIA FAMILIAR DE TUMOR MALIGNO",
    "detalle": [
      {
        "codigo": "Z800",
        "valor": "HISTORIA FAMILIAR DE TUMOR MALIGNO DE ORGANOS DIGESTIVOS"
      },
      {
        "codigo": "Z801",
        "valor": "HISTORIA FAMILIAR DE TUMOR MALIGNO DE TRAQUEA, BRONQUIOS Y PULMON"
      },
      {
        "codigo": "Z802",
        "valor": "HISTORIA FAMILIAR DE TUMOR MALIGNO DE OTROS ORGANOS RESPIRATORIOS E INTRATORACICOS"
      },
      {
        "codigo": "Z803",
        "valor": "HISTORIA FAMILIAR DE TUMOR MALIGNO DE MAMA"
      },
      {
        "codigo": "Z804",
        "valor": "HISTORIA FAMILIAR DE TUMOR MALIGNO DE ORGANOS GENITALES"
      },
      {
        "codigo": "Z805",
        "valor": "HISTORIA FAMILIAR DE TUMOR MALIGNO DE VIAS URINARIAS"
      },
      {
        "codigo": "Z806",
        "valor": "HISTORIA FAMILIAR DE LEUCEMIA"
      },
      {
        "codigo": "Z807",
        "valor": "HISTORIA FAMILIAR DE OTROS TUMORES MALIGNOS DEL TEJIDO LINFOIDE, HEMATOPOYETICO Y TEJIDOS RELACIONADOS"
      },
      {
        "codigo": "Z808",
        "valor": "HISTORIA FAMILIAR DE TUMOR MALIGNO DE OTROS ORGANOS O SISTEMAS ESPECIFICADOS"
      },
      {
        "codigo": "Z809",
        "valor": "HISTORIA FAMILIAR DE TUMOR MALIGNO, DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z81 - HISTORIA FAMILIAR DE TRASTORNOS MENTALES Y DEL COMPORTAMIENTO",
    "detalle": [
      {
        "codigo": "Z810",
        "valor": "HISTORIA FAMILIAR DE RETARDO MENTAL"
      },
      {
        "codigo": "Z811",
        "valor": "HISTORIA FAMILIAR DE ABUSO DE ALCOHOL"
      },
      {
        "codigo": "Z812",
        "valor": "HISTORIA FAMILIAR DE ABUSO DEL TABACO"
      },
      {
        "codigo": "Z813",
        "valor": "HISTORIA FAMILIAR DE ABUSO DE OTRAS SUSTANCIAS PSICOACTIVAS"
      },
      {
        "codigo": "Z814",
        "valor": "HISTORIA FAMILIAR DE ABUSO DE OTRAS SUSTANCIAS"
      },
      {
        "codigo": "Z818",
        "valor": "HISTORIA FAMILIAR DE OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO"
      }
    ]
  },
  {
    "grupo": "Z82 - HISTORIA FAMILIAR DE CIERTAS DISCAPACIDADES Y ENFERMEDADES CRONICAS INCAPACITANTES",
    "detalle": [
      {
        "codigo": "Z820",
        "valor": "HISTORIA FAMILIAR DE EPILEPSIA Y OTRAS ENFERMEDADES DEL SISTEMA NERVIOSO"
      },
      {
        "codigo": "Z821",
        "valor": "HISTORIA FAMILIAR DE CEGUERA O PERDIDA DE LA VISION"
      },
      {
        "codigo": "Z822",
        "valor": "HISTORIA FAMILIAR DE SORDERA O PERDIDA DE LA AUDICION"
      },
      {
        "codigo": "Z823",
        "valor": "HISTORIA FAMILIAR DE APOPLEJIA"
      },
      {
        "codigo": "Z824",
        "valor": "HISTORIA FAMILIAR DE ENFERMEDAD ISQUEMICA DEL CORAZON Y OTRAS ENFERMEDADES DEL SISTEMA CIRCULATORIO"
      },
      {
        "codigo": "Z825",
        "valor": "HISTORIA FAMILIAR DE ASMA Y DE OTRAS ENFERMEDADES CRONICAS DE LAS VIAS RESPIRATORIAS INFERIORES"
      },
      {
        "codigo": "Z826",
        "valor": "HISTORIA FAMILIAR DE ARTRITIS Y OTRAS ENFERMEDADES DEL SISTEMA OSTEOMUSCULAR Y TEJIDO CONJUNTIVO"
      },
      {
        "codigo": "Z827",
        "valor": "HISTORIA FAMILIAR DE MALFORMACIONES CONGENITAS, DEFORMIDADES Y OTRAS ANOMALIAS CROMOSOMICAS"
      },
      {
        "codigo": "Z828",
        "valor": "HISTORIA FAMILIAR DE OTRAS DISCAPACIDADES Y ENFERMEDADES CRONICAS INCAPACITANTES NO CLASIFICADAS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Z83 - HISTORIA FAMILIAR DE OTROS TRASTORNOS ESPECIFICOS",
    "detalle": [
      {
        "codigo": "Z830",
        "valor": "HISTORIA FAMILIAR DE INFECCION POR EL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]"
      },
      {
        "codigo": "Z831",
        "valor": "HISTORIA FAMILIAR DE OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS"
      },
      {
        "codigo": "Z832",
        "valor": "HISTORIA FAMILIAR DE ENFERMEDADES DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS Y DE CIERTOS TRASTORNOS DEL MECANISMO INMUNOLOGICO"
      },
      {
        "codigo": "Z833",
        "valor": "HISTORIA FAMILIAR DE DIABETES MELLITUS"
      },
      {
        "codigo": "Z834",
        "valor": "HISTORIA FAMILIAR DE OTRAS ENFERMEDADES ENDOCRINAS, NUTRICIONALES Y METABOLICAS"
      },
      {
        "codigo": "Z835",
        "valor": "HISTORIA FAMILIAR DE TRASTORNOS DE LOS OJOS Y DE LOS OIDOS"
      },
      {
        "codigo": "Z836",
        "valor": "HISTORIA FAMILIAR DE ENFERMEDADES DEL SISTEMA RESPIRATORIO"
      },
      {
        "codigo": "Z837",
        "valor": "HISTORIA FAMILIAR DE ENFERMEDADES DEL SISTEMA DIGESTIVO"
      }
    ]
  },
  {
    "grupo": "Z84 - HISTORIA FAMILIAR DE OTRAS AFECCIONES",
    "detalle": [
      {
        "codigo": "Z840",
        "valor": "HISTORIA FAMILIAR DE ENFERMEDADES DE LA PIEL Y DEL TEJIDO SUBCUTANEO"
      },
      {
        "codigo": "Z841",
        "valor": "HISTORIA FAMILIAR DE TRASTORNOS DEL RIÑON Y DEL URETER"
      },
      {
        "codigo": "Z842",
        "valor": "HISTORIA FAMILIAR DE OTRAS ENFERMEDADES DEL SISTEMA GENITOURINARIO"
      },
      {
        "codigo": "Z843",
        "valor": "HISTORIA FAMILIAR DE CONSANGUINIDAD"
      },
      {
        "codigo": "Z848",
        "valor": "HISTORIA FAMILIAR DE OTRAS AFECCIONES ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Z85 - HISTORIA PERSONAL DE TUMOR MALIGNO",
    "detalle": [
      {
        "codigo": "Z850",
        "valor": "HISTORIA PERSONAL DE TUMOR MALIGNO DE ORGANOS DIGESTIVOS"
      },
      {
        "codigo": "Z851",
        "valor": "HISTORIA PERSONAL DE TUMOR MALIGNO DE TRAQUEA, BRONQUIOS Y PULMON"
      },
      {
        "codigo": "Z852",
        "valor": "HISTORIA PERSONAL DE TUMOR MALIGNO DE OTROS ORGANOS RESPIRATORIOS E INTRATORACICOS"
      },
      {
        "codigo": "Z853",
        "valor": "HISTORIA PERSONAL DE TUMOR MALIGNO DE MAMA"
      },
      {
        "codigo": "Z854",
        "valor": "HISTORIA PERSONAL DE TUMOR MALIGNO DE ORGANOS GENITALES"
      },
      {
        "codigo": "Z855",
        "valor": "HISTORIA PERSONAL DE TUMOR MALIGNO DE VIAS URINARIAS"
      },
      {
        "codigo": "Z856",
        "valor": "HISTORIA PERSONAL DE LEUCEMIA"
      },
      {
        "codigo": "Z857",
        "valor": "HISTORIA PERSONAL DE OTROS TUMORES MALIGNOS DEL TEJIDO LINFOIDE, HEMATOPOYETICO Y TEJIDOS RELACIONADOS"
      },
      {
        "codigo": "Z858",
        "valor": "HISTORIA PERSONAL DE TUMOR MALIGNO DE OTROS ORGANOS Y SISTEMAS"
      },
      {
        "codigo": "Z859",
        "valor": "HISTORIA PERSONAL DE TUMOR MALIGNO, DE SITIO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z86 - HISTORIA PERSONAL DE ALGUNAS OTRAS ENFERMEDADES",
    "detalle": [
      {
        "codigo": "Z860",
        "valor": "HISTORIA PERSONAL DE OTROS TUMORES"
      },
      {
        "codigo": "Z861",
        "valor": "HISTORIA PERSONAL DE ENFERMEDADES INFECCIOSAS Y PARASITARIAS"
      },
      {
        "codigo": "Z862",
        "valor": "HISTORIA PERSONAL DE ENFERMEDADES DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS Y DE CIERTOS TRASTORNOS DEL MECANISMO INMUNOLOGICO"
      },
      {
        "codigo": "Z863",
        "valor": "HISTORIA PERSONAL DE ENFERMEDADES ENDOCRINAS, NUTRICIONALES Y METABOLICAS"
      },
      {
        "codigo": "Z864",
        "valor": "HISTORIA PERSONAL DE ABUSO DE SUSTANCIAS PSICOACTIVAS"
      },
      {
        "codigo": "Z865",
        "valor": "HISTORIA PERSONAL DE OTROS TRASTORNOS MENTALES O DEL COMPORTAMIENTO"
      },
      {
        "codigo": "Z866",
        "valor": "HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA NERVIOSO Y DE LOS ORGANOS DE LOS SENTIDOS"
      },
      {
        "codigo": "Z867",
        "valor": "HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA CIRCULATORIO"
      }
    ]
  },
  {
    "grupo": "Z87 - HISTORIA PERSONAL DE OTRAS ENFERMEDADES Y AFECCIONES",
    "detalle": [
      {
        "codigo": "Z870",
        "valor": "HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA RESPIRATORIO"
      },
      {
        "codigo": "Z871",
        "valor": "HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA DIGESTIVO"
      },
      {
        "codigo": "Z872",
        "valor": "HISTORIA PERSONAL DE ENFERMEDADES DE LA PIEL Y DEL TEJIDO SUBCUTANEO"
      },
      {
        "codigo": "Z873",
        "valor": "HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA OSTEOMUSCULAR Y DEL TEJIDO CONJUNTIVO"
      },
      {
        "codigo": "Z874",
        "valor": "HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA GENITOURINARIO"
      },
      {
        "codigo": "Z875",
        "valor": "HISTORIA PERSONAL DE COMPLICACIONES DEL EMBARAZO, DEL PARTO Y DEL PUERPERIO"
      },
      {
        "codigo": "Z876",
        "valor": "HISTORIA PERSONAL DE CIERTAS AFECCIONES ORIGINADAS EN EL PERIODO PERINATAL"
      },
      {
        "codigo": "Z877",
        "valor": "HISTORIA PERSONAL DE MALFORMACIONES CONGENITAS, DEFORMIDADES Y ANOMALIAS CROMOSOMICAS"
      },
      {
        "codigo": "Z878",
        "valor": "HISTORIA PERSONAL DE OTRAS AFECCIONES ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Z88 - HISTORIA PERSONAL DE ALERGIA A DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS",
    "detalle": [
      {
        "codigo": "Z880",
        "valor": "HISTORIA PERSONAL DE ALERGIA A PENICILINA"
      },
      {
        "codigo": "Z881",
        "valor": "HISTORIA PERSONAL DE ALERGIA A OTROS AGENTES ANTIBIOTICOS"
      },
      {
        "codigo": "Z882",
        "valor": "HISTORIA PERSONAL DE ALERGIA A SULFONAMIDAS"
      },
      {
        "codigo": "Z883",
        "valor": "HISTORIA PERSONAL DE ALERGIA A OTROS AGENTES ANTIINFECCIOSOS"
      },
      {
        "codigo": "Z884",
        "valor": "HISTORIA PERSONAL DE ALERGIA A AGENTE ANESTESICO"
      },
      {
        "codigo": "Z885",
        "valor": "HISTORIA PERSONAL DE ALERGIA A AGENTE NARCOTICO"
      },
      {
        "codigo": "Z886",
        "valor": "HISTORIA PERSONAL DE ALERGIA A AGENTE ANALGESICO"
      },
      {
        "codigo": "Z887",
        "valor": "HISTORIA PERSONAL DE ALERGIA A SUERO O VACUNA"
      },
      {
        "codigo": "Z888",
        "valor": "HISTORIA PERSONAL DE ALERGIA A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS"
      },
      {
        "codigo": "Z889",
        "valor": "HISTORIA PERSONAL DE ALERGIA A DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "Z89 - AUSENCIA ADQUIRIDA DE MIEMBROS",
    "detalle": [
      {
        "codigo": "Z890",
        "valor": "AUSENCIA ADQUIRIDA DE DEDO(S), [INCLUIDO EL PULGAR], UNILATERAL"
      },
      {
        "codigo": "Z891",
        "valor": "AUSENCIA ADQUIRIDA DE MANO Y MUÑECA"
      },
      {
        "codigo": "Z892",
        "valor": "AUSENCIA ADQUIRIDA DE MIEMBRO SUPERIOR POR ARRIBA DE LA MUÑECA"
      },
      {
        "codigo": "Z893",
        "valor": "AUSENCIA ADQUIRIDA DE AMBOS MIEMBROS SUPERIORES [CUALQUIER NIVEL]"
      },
      {
        "codigo": "Z894",
        "valor": "AUSENCIA ADQUIRIDA DE PIE Y TOBILLO"
      },
      {
        "codigo": "Z895",
        "valor": "AUSENCIA ADQUIRIDA DE PIERNA A NIVEL DE O DEBAJO DE LA RODILLA"
      },
      {
        "codigo": "Z896",
        "valor": "AUSENCIA ADQUIRIDA DE PIERNA POR ARRIBA DE LA RODILLA"
      },
      {
        "codigo": "Z897",
        "valor": "AUSENCIA ADQUIRIDA DE AMBOS MIEMBROS INFERIORES [CUALQUIER NIVEL, EXCEPTO DEDOS DEL PIE SOLAMENTE]"
      },
      {
        "codigo": "Z898",
        "valor": "AUSENCIA ADQUIRIDA DE MIEMBROS SUPERIORES E INFERIORES [CUALQUIER NIVEL]"
      },
      {
        "codigo": "Z899",
        "valor": "AUSENCIA ADQUIRIDA DE MIEMBROS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Z90 - AUSENCIA ADQUIRIDA DE ORGANOS, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Z900",
        "valor": "AUSENCIA ADQUIRIDA DE PARTE DE LA CABEZA Y DEL CUELLO"
      },
      {
        "codigo": "Z901",
        "valor": "AUSENCIA ADQUIRIDA DE MAMA(S)"
      },
      {
        "codigo": "Z902",
        "valor": "AUSENCIA ADQUIRIDA (DE PARTE) DEL PULMON"
      },
      {
        "codigo": "Z903",
        "valor": "AUSENCIA ADQUIRIDA DE PARTE DEL ESTOMAGO"
      },
      {
        "codigo": "Z904",
        "valor": "AUSENCIA ADQUIRIDA DE OTRAS PARTES DEL TUBO DIGESTIVO"
      },
      {
        "codigo": "Z905",
        "valor": "AUSENCIA ADQUIRIDA DE RIÑON"
      },
      {
        "codigo": "Z906",
        "valor": "AUSENCIA ADQUIRIDA DE OTRAS PARTES DE LAS VIAS URINARIAS"
      },
      {
        "codigo": "Z907",
        "valor": "AUSENCIA ADQUIRIDA DE ORGANO(S) GENITAL(ES)"
      },
      {
        "codigo": "Z908",
        "valor": "AUSENCIA ADQUIRIDA DE OTROS ORGANOS"
      }
    ]
  },
  {
    "grupo": "Z91 - HISTORIA PERSONAL DE FACTORES DE RIESGO, NO CLASIFICADOS EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Z910",
        "valor": "HISTORIA PERSONAL DE ALERGIA, NO DEBIDA A DROGAS NI A SUSTANCIAS BIOLOGICAS"
      },
      {
        "codigo": "Z911",
        "valor": "HISTORIA PERSONAL DE INCUMPLIMIENTO DEL REGIMEN O TRATAMIENTO MEDICO"
      },
      {
        "codigo": "Z912",
        "valor": "HISTORIA PERSONAL DE HIGIENE PERSONAL DEFICIENTE"
      },
      {
        "codigo": "Z913",
        "valor": "HISTORIA PERSONAL DE CICLO SUEÑO-VIGILIA NO SALUDABLE"
      },
      {
        "codigo": "Z914",
        "valor": "HISTORIA PERSONAL DE TRAUMA PSICOLOGICO, NO CLASIFICADO EN OTRA PARTE"
      },
      {
        "codigo": "Z915",
        "valor": "HISTORIA PERSONAL DE LESION AUTOINFLIGIDA INTENCIONALMENTE"
      },
      {
        "codigo": "Z916",
        "valor": "HISTORIA PERSONAL DE OTRO TRAUMA FISICO"
      },
      {
        "codigo": "Z918",
        "valor": "HISTORIA PERSONAL DE OTROS FACTORES DE RIESGO, NO CLASIFICADOS EN OTRA PARTE"
      }
    ]
  },
  {
    "grupo": "Z92 - HISTORIA PERSONAL DE TRATAMIENTO MEDICO",
    "detalle": [
      {
        "codigo": "Z920",
        "valor": "HISTORIA PERSONAL DE ANTICONCEPCION"
      },
      {
        "codigo": "Z921",
        "valor": "HISTORIA PERSONAL DE USO (PRESENTE) DE ANTICOAGULANTES POR LARGO TIEMPO"
      },
      {
        "codigo": "Z922",
        "valor": "HISTORIA PERSONAL DE USO (PRESENTE) DE OTROS MEDICAMENTOS POR LARGO TIEMPO"
      },
      {
        "codigo": "Z923",
        "valor": "HISTORIA PERSONAL DE IRRADIACION"
      },
      {
        "codigo": "Z924",
        "valor": "HISTORIA PERSONAL DE CIRUGIA MAYOR NO CLASIFICADA EN OTRA PARTE"
      },
      {
        "codigo": "Z925",
        "valor": "HISTORIA PERSONAL DE MEDIDAS DE REHABILITACION"
      },
      {
        "codigo": "Z926",
        "valor": "HISTORIA PERSONAL DE QUIMIOTERAPIA POR ENFERMEDAD NEOPLASICA"
      },
      {
        "codigo": "Z928",
        "valor": "HISTORIA PERSONAL DE OTROS TRATAMIENTOS MEDICOS"
      },
      {
        "codigo": "Z929",
        "valor": "HISTORIA PERSONAL DE TRATAMIENTO MEDICO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z93 - ABERTURAS ARTIFICIALES",
    "detalle": [
      {
        "codigo": "Z930",
        "valor": "TRAQUEOSTOMIA"
      },
      {
        "codigo": "Z931",
        "valor": "GASTROSTOMIA"
      },
      {
        "codigo": "Z932",
        "valor": "ILEOSTOMIA"
      },
      {
        "codigo": "Z933",
        "valor": "COLOSTOMIA"
      },
      {
        "codigo": "Z934",
        "valor": "OTROS ORIFICIOS ARTIFICIALES DEL TUBO GASTROINTESTINAL"
      },
      {
        "codigo": "Z935",
        "valor": "CISTOSTOMIA"
      },
      {
        "codigo": "Z936",
        "valor": "OTROS ORIFICIOS ARTIFICIALES DE LAS VIAS URINARIAS"
      },
      {
        "codigo": "Z938",
        "valor": "OTRAS ABERTURAS ARTIFICIALES"
      },
      {
        "codigo": "Z939",
        "valor": "ABERTURA ARTIFICIAL, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "Z94 - ORGANOS Y TEJIDOS TRASPLANTADOS",
    "detalle": [
      {
        "codigo": "Z940",
        "valor": "TRASPLANTE DE RIÑON"
      },
      {
        "codigo": "Z941",
        "valor": "TRASPLANTE DE CORAZON"
      },
      {
        "codigo": "Z942",
        "valor": "TRASPLANTE DE PULMON"
      },
      {
        "codigo": "Z943",
        "valor": "TRASPLANTE DE CORAZON Y PULMONES"
      },
      {
        "codigo": "Z944",
        "valor": "TRASPLANTE DE HIGADO"
      },
      {
        "codigo": "Z945",
        "valor": "TRASPLANTE DE PIEL"
      },
      {
        "codigo": "Z946",
        "valor": "TRASPLANTE DE HUESO"
      },
      {
        "codigo": "Z947",
        "valor": "TRASPLANTE DE CORNEA"
      },
      {
        "codigo": "Z948",
        "valor": "OTROS ORGANOS Y TEJIDOS TRASPLANTADOS"
      },
      {
        "codigo": "Z949",
        "valor": "ORGANO O TEJIDO TRASPLANTADO NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "Z95 - PRESENCIA DE IMPLANTES E INJERTOS CARDIOVASCULARES",
    "detalle": [
      {
        "codigo": "Z950",
        "valor": "PRESENCIA DE DISPOSITIVOS CARDIACOS ELECTRONICOS"
      },
      {
        "codigo": "Z951",
        "valor": "PRESENCIA DE DERIVACION AORTOCORONARIA"
      },
      {
        "codigo": "Z952",
        "valor": "PRESENCIA DE VALVULA CARDIACA PROTESICA"
      },
      {
        "codigo": "Z953",
        "valor": "PRESENCIA DE VALVULA CARDIACA XENOGENICA"
      },
      {
        "codigo": "Z954",
        "valor": "PRESENCIA DE OTROS REEMPLAZOS DE VALVULA CARDIACA"
      },
      {
        "codigo": "Z955",
        "valor": "PRESENCIA DE ANGIOPLASTIA, INJERTOS Y PROTESIS CORONARIAS"
      },
      {
        "codigo": "Z958",
        "valor": "PRESENCIA DE OTROS INJERTOS Y PROTESIS CARDIOVASCULARES"
      },
      {
        "codigo": "Z959",
        "valor": "PRESENCIA DE INJERTOS E IMPLANTES CARDIOVASCULARES NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Z96 - PRESENCIA DE OTROS IMPLANTES FUNCIONALES",
    "detalle": [
      {
        "codigo": "Z960",
        "valor": "PRESENCIA DE IMPLANTE UROGENITAL"
      },
      {
        "codigo": "Z961",
        "valor": "PRESENCIA DE LENTES INTRAOCULARES"
      },
      {
        "codigo": "Z962",
        "valor": "PRESENCIA DE IMPLANTES OTICOS Y AUDITIVOS"
      },
      {
        "codigo": "Z963",
        "valor": "PRESENCIA DE LARINGE ARTIFICIAL"
      },
      {
        "codigo": "Z964",
        "valor": "PRESENCIA DE IMPLANTES ENDOCRINOS"
      },
      {
        "codigo": "Z965",
        "valor": "PRESENCIA DE IMPLANTES DE RAIZ DE DIENTE Y DE MANDIBULA"
      },
      {
        "codigo": "Z966",
        "valor": "PRESENCIA DE IMPLANTE ORTOPEDICO ARTICULAR"
      },
      {
        "codigo": "Z967",
        "valor": "PRESENCIA DE OTROS IMPLANTES DE TENDONES Y HUESOS"
      },
      {
        "codigo": "Z968",
        "valor": "PRESENCIA DE OTROS IMPLANTES FUNCIONALES ESPECIFICADOS"
      },
      {
        "codigo": "Z969",
        "valor": "PRESENCIA DE IMPLANTES FUNCIONALES NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Z97 - PRESENCIA DE OTROS DISPOSITIVOS",
    "detalle": [
      {
        "codigo": "Z970",
        "valor": "PRESENCIA DE OJO ARTIFICIAL"
      },
      {
        "codigo": "Z971",
        "valor": "PRESENCIA DE MIEMBRO ARTIFICIAL (COMPLETO) (PARCIAL)"
      },
      {
        "codigo": "Z972",
        "valor": "PRESENCIA DE DISPOSITIVO PROTESICO DENTAL (COMPLETO) (PARCIAL)"
      },
      {
        "codigo": "Z973",
        "valor": "PRESENCIA DE ANTEOJOS Y LENTES DE CONTACTO"
      },
      {
        "codigo": "Z974",
        "valor": "PRESENCIA DE AUDIFONO EXTERNO"
      },
      {
        "codigo": "Z975",
        "valor": "PRESENCIA DE DISPOSITIVO ANTICONCEPTIVO (INTRAUTERINO)"
      },
      {
        "codigo": "Z978",
        "valor": "PRESENCIA DE OTROS DISPOSITIVOS ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Z98 - OTROS ESTADOS POSTQUIRURGICOS",
    "detalle": [
      {
        "codigo": "Z980",
        "valor": "ESTADO DE DERIVACION INTESTINAL O ANASTOMOSIS"
      },
      {
        "codigo": "Z981",
        "valor": "ESTADO DE ARTRODESIS"
      },
      {
        "codigo": "Z982",
        "valor": "PRESENCIA DE DISPOSITIVO PARA DRENAJE DE LIQUIDO CEFALORRAQUIDEO"
      },
      {
        "codigo": "Z988",
        "valor": "OTROS ESTADOS POSTQUIRURGICOS ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "Z99 - DEPENDENCIA DE MAQUINAS Y DISPOSITIVOS CAPACITANTES, NO CLASIFICADA EN OTRA PARTE",
    "detalle": [
      {
        "codigo": "Z990",
        "valor": "DEPENDENCIA DE ASPIRADOR"
      },
      {
        "codigo": "Z991",
        "valor": "DEPENDENCIA DE RESPIRADOR"
      },
      {
        "codigo": "Z992",
        "valor": "DEPENDENCIA DE DIALISIS RENAL"
      },
      {
        "codigo": "Z993",
        "valor": "DEPENDENCIA DE SILLA DE RUEDAS"
      },
      {
        "codigo": "Z994",
        "valor": "DEPENDENCIA DE CORAZON ARTIFICIAL"
      },
      {
        "codigo": "Z998",
        "valor": "DEPENDENCIA DE OTRAS MAQUINAS Y DISPOSITIVOS CAPACITANTES"
      },
      {
        "codigo": "Z999",
        "valor": "DEPENDENCIA DE MAQUINA Y DISPOSITIVO CAPACITANTE, NO ESPECIFICADA"
      }
    ]
  },
  {
    "grupo": "U04 - SINDROME RESPIRATORIO AGUDO GRAVE [SRAG]",
    "detalle": [
      {
        "codigo": "U049",
        "valor": "SINDROME RESPIRATORIO AGUDO GRAVE [SRAG], NO ESPECIFICADO"
      }
    ]
  },
  {
    "grupo": "U06 - USO EMERGENTE",
    "detalle": [
      {
        "codigo": "U060",
        "valor": "USO EMERGENTE DE U06.0"
      },
      {
        "codigo": "U061",
        "valor": "USO EMERGENTE DE U06.1"
      },
      {
        "codigo": "U062",
        "valor": "USO EMERGENTE DE U06.2"
      },
      {
        "codigo": "U063",
        "valor": "USO EMERGENTE DE U06.3"
      },
      {
        "codigo": "U064",
        "valor": "USO EMERGENTE DE U06.4"
      },
      {
        "codigo": "U065",
        "valor": "USO EMERGENTE DE U06.5"
      },
      {
        "codigo": "U066",
        "valor": "USO EMERGENTE DE U06.6"
      },
      {
        "codigo": "U067",
        "valor": "USO EMERGENTE DE U06.7"
      },
      {
        "codigo": "U068",
        "valor": "USO EMERGENTE DE U06.8"
      }
    ]
  },
  {
    "grupo": "U07 - USO EMERGENTE",
    "detalle": [
      {
        "codigo": "U070",
        "valor": "USO EMERGENTE DE U07.0"
      },
      {
        "codigo": "U071",
        "valor": "COVID-19, VIRUS IDENTIFICADO"
      },
      {
        "codigo": "U072",
        "valor": "COVID-19, VIRUS NO IDENTIFICADO"
      },
      {
        "codigo": "U073",
        "valor": "USO EMERGENTE DE U07.3"
      },
      {
        "codigo": "U074",
        "valor": "USO EMERGENTE DE U07.4"
      },
      {
        "codigo": "U075",
        "valor": "USO EMERGENTE DE U07.5"
      },
      {
        "codigo": "U076",
        "valor": "USO EMERGENTE DE U07.6"
      },
      {
        "codigo": "U077",
        "valor": "USO EMERGENTE DE U07.7"
      },
      {
        "codigo": "U078",
        "valor": "USO EMERGENTE DE U07.8"
      },
      {
        "codigo": "U079",
        "valor": "USO EMERGENTE DE U07.9"
      }
    ]
  },
  {
    "grupo": "U20 - DETECCION DE ENFERMEDADES",
    "detalle": [
      {
        "codigo": "U200",
        "valor": "SINTOMATICO RESPIRATORIO"
      },
      {
        "codigo": "U201",
        "valor": "TBC CRONICA"
      },
      {
        "codigo": "U202",
        "valor": "TUBERCULOSIS MULTIDROGORESISTENTE (TB MDR)"
      },
      {
        "codigo": "U203",
        "valor": "TUBERCULOSIS MONORRESISTENTE"
      },
      {
        "codigo": "U204",
        "valor": "TUBERCULOSIS POLIRRESISTENTE"
      },
      {
        "codigo": "U205",
        "valor": "TUBERCULOSIS EXTENSAMENTE RESISTENTE (TB XDR)"
      },
      {
        "codigo": "U206",
        "valor": "OTRAS TUBERCULOSIS DROGORESISTENTES"
      }
    ]
  },
  {
    "grupo": "U32 - RESULTADOS DEL TRATAMIENTO DE ENFERMEDADES",
    "detalle": [
      {
        "codigo": "U320",
        "valor": "LEISHMANIASIS CON FALTA DE RESPUESTA A ANTIMONIALES PENTAVALENTES"
      }
    ]
  },
  {
    "grupo": "U82 - RESISTENCIA A ANTIBIOTICOS",
    "detalle": [
      {
        "codigo": "U820",
        "valor": "RESISTENCIA A PENICILINA"
      },
      {
        "codigo": "U821",
        "valor": "RESISTENCIA A METICILINA"
      },
      {
        "codigo": "U822",
        "valor": "RESISTENCIA A BETALACTAMASA DE ESPECTRO EXTENDIDO (BLEE)"
      },
      {
        "codigo": "U828",
        "valor": "RESISTENCIA A OTROS ANTIBIOTICOS BETALACTAMICOS"
      },
      {
        "codigo": "U829",
        "valor": "RESISTENCIA A ANTIBIOTICOS BETALACTAMICOS, NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "U83 - RESISTENCIA A OTROS ANTIBIOTICOS",
    "detalle": [
      {
        "codigo": "U830",
        "valor": "RESISTENCIA A VANCOMICINA"
      },
      {
        "codigo": "U831",
        "valor": "RESISTENCIA A OTROS ANTIBIOTICOS SIMILARES A VANCOMICINA"
      },
      {
        "codigo": "U832",
        "valor": "RESISTENCIA A QUINOLONAS"
      },
      {
        "codigo": "U837",
        "valor": "RESISTENCIA A MULTIPLES ANTIBIOTICOS"
      },
      {
        "codigo": "U838",
        "valor": "RESISTENCIA A OTROS ANTIBIOTICOS UNICOS ESPECIFICADOS"
      },
      {
        "codigo": "U839",
        "valor": "RESISTENCIA A ANTIBIOTICOS NO ESPECIFICADOS"
      }
    ]
  },
  {
    "grupo": "U84 - RESISTENCIA A OTRAS DROGAS",
    "detalle": [
      {
        "codigo": "U840",
        "valor": "RESISTENCIA A DROGAS ANTIPARASITARIAS"
      },
      {
        "codigo": "U841",
        "valor": "RESISTENCIA A DROGAS ANTIMICOTICAS"
      },
      {
        "codigo": "U842",
        "valor": "RESISTENCIA A DROGAS ANTIVIRALES"
      },
      {
        "codigo": "U843",
        "valor": "RESISTENCIA A DROGAS ANTITUBERCULOSAS"
      },
      {
        "codigo": "U847",
        "valor": "RESISTENCIA A MULTIPLES DROGAS ANTIMICROBIANAS"
      },
      {
        "codigo": "U848",
        "valor": "RESISTENCIA A OTRAS DROGAS ANTIMICROBIANAS ESPECIFICADAS"
      },
      {
        "codigo": "U849",
        "valor": "RESISTENCIA A DROGAS ANTIMICROBIANAS NO ESPECIFICADAS"
      }
    ]
  },
  {
    "grupo": "U85 - RESISTENCIA A ANTINEOPLASICAS",
    "detalle": [
      {
        "codigo": "U85X",
        "valor": "RESISTENCIA A DROGAS ANTINEOPLASICAS"
      }
    ]
  }
];

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (value: string) => void; // solo un string
  // children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, onSelect }) => {
  const [search, setSearch] = useState('');
const inputRef = useRef<HTMLInputElement>(null);

useEffect(() => {
    if (!isOpen) {
      setSearch('');
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    }
  }, [isOpen]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
       const value = inputRef.current?.value ?? '';
      // setSearch(searchInput);
        setSearch(value);
    }
  };

  // ✅ useMemo para evitar recalcular innecesariamente
  const filteredData = useMemo(() => {
    if (search.trim() === '') return data;

    return data
      .map((grupo) => ({
        ...grupo,
        detalle: grupo.detalle.filter((item) =>
          `${item.codigo} ${item.valor}`.toLowerCase().includes(search.toLowerCase())
        ),
      }))
      .filter((grupo) => grupo.detalle.length > 0);
  }, [search, data]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full relative">
           {/* Encabezado con título y botón cerrar */}
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-lg font-semibold text-gray-800">Listado de CIE10</h2>
      <button
        onClick={onClose}
        className="text-gray-500 hover:text-gray-800 text-xl"
        aria-label="Cerrar"
      >
        ✕
      </button>
    </div>
    
        {/* Input con ícono */}
        <div className="relative mb-4">
          <span className="absolute left-3 top-2.5 text-gray-400">🔍</span>
          <input
            ref={inputRef}
            type="text"
            placeholder="Buscar por código o valor..."
            onKeyDown={handleKeyDown}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <table className="w-full text-sm text-left border border-gray-200 block max-h-[400px] overflow-y-auto w-full"

          style={{ display: "block", maxHeight: "400px", overflowY: "auto" }}>
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="border px-2 py-1">Código</th>
              <th className="border px-2 py-1">Descripción</th>
                <th className="border px-2 py-1"></th>
            </tr>
          </thead>
          <tbody
          >
            {filteredData.map((grupo, i) => (
              <React.Fragment key={i}>
                <tr className="bg-blue-100">
                  <td colSpan={3} className="font-semibold px-2 py-2 text-blue-800">
                    {grupo.grupo}
                  </td>
                </tr>
                {grupo.detalle.map((item, j) => (
                  <tr key={j} className="hover:bg-gray-50">
                    <td className="border px-2 py-1">{item.codigo}</td>
                    <td className="border px-2 py-1">{item.valor}</td>
                    <td className="border px-2 py-1">              
                      <button type="button"
                        onClick={() => {
                        onSelect(item.codigo+" - "+item.valor); // envías solo un string
                        onClose();
                        }}
                      >
                      <PaperAirplaneIcon className="ml-2 h-4 w-4 rotate-90" />
                      </button>
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {/* {children} */}
      </div>
    </div>
  );
};

export default Modal;